// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// Onyomi, kunyomi, and common word examples for the 2,136 jōyō kanji, derived
// from KANJIDIC2 (readings) and JMdict (examples), both via the jmdict-simplified
// project (https://github.com/scriptin/jmdict-simplified), itself built from the
// Electronic Dictionary Research and Development Group's (EDRDG) data, used under
// the Creative Commons Attribution-ShareAlike 4.0 licence.
export const kanjiDetails = {
    "亜": {
        onyomi: ["ア"],
        kunyomi: ["つ.ぐ"],
        examples: [
        { word: "亜鉛", reading: "あえん", meaning: "zinc (Zn)" },
        { word: "東亜", reading: "とうあ", meaning: "East Asia, the Orient" },
        { word: "亜熱帯", reading: "あねったい", meaning: "subtropics" }
    ],
    },
    "哀": {
        onyomi: ["アイ"],
        kunyomi: ["あわ.れ", "あわ.れむ", "かな.しい"],
        examples: [
        { word: "哀れ", reading: "あわれ", meaning: "pity, sorrow, grief" },
        { word: "哀愁", reading: "あいしゅう", meaning: "pathos, sorrow, grief" },
        { word: "哀悼", reading: "あいとう", meaning: "condolence, regret, tribute" },
        { word: "悲哀", reading: "ひあい", meaning: "sorrow, grief, sadness" }
    ],
    },
    "挨": {
        onyomi: ["アイ"],
        kunyomi: ["ひら.く"],
        examples: [
        { word: "挨拶", reading: "あいさつ", meaning: "greeting, greetings, salutation" }
    ],
    },
    "愛": {
        onyomi: ["アイ"],
        kunyomi: ["いと.しい", "かな.しい", "め.でる", "お.しむ", "まな"],
        examples: [
        { word: "愛嬌", reading: "あいきょう", meaning: "charm, attractiveness, amiability" },
        { word: "愛犬", reading: "あいけん", meaning: "pet dog, beloved dog" },
        { word: "愛護", reading: "あいご", meaning: "protection, tender care" },
        { word: "愛好", reading: "あいこう", meaning: "love, adoration, being fond of" }
    ],
    },
    "曖": {
        onyomi: ["アイ"],
        kunyomi: ["くら.い"],
        examples: [
        { word: "曖昧", reading: "あいまい", meaning: "vague, ambiguous, unclear" }
    ],
    },
    "悪": {
        onyomi: ["アク", "オ"],
        kunyomi: ["わる.い", "わる-", "あ.し", "にく.い", "-にく.い", "ああ", "いずくに", "いずくんぞ", "にく.む"],
        examples: [
        { word: "悪い", reading: "わるい", meaning: "bad, poor, undesirable" },
        { word: "悪さ", reading: "わるさ", meaning: "badness, mean mischief" },
        { word: "悪意", reading: "あくい", meaning: "ill will, spite, evil intention" },
        { word: "悪化", reading: "あっか", meaning: "deterioration, getting worse, worsening" }
    ],
    },
    "握": {
        onyomi: ["アク"],
        kunyomi: ["にぎ.る"],
        examples: [
        { word: "握り", reading: "にぎり", meaning: "grasping, gripping, grasp" },
        { word: "握る", reading: "にぎる", meaning: "to clasp, to grasp, to grip" },
        { word: "握手", reading: "あくしゅ", meaning: "handshake" },
        { word: "握力", reading: "あくりょく", meaning: "grip (of hand), grip strength" }
    ],
    },
    "圧": {
        onyomi: ["アツ", "エン", "オウ"],
        kunyomi: ["お.す", "へ.す", "おさ.える", "お.さえる"],
        examples: [
        { word: "圧巻", reading: "あっかん", meaning: "highlight, best part" },
        { word: "圧縮", reading: "あっしゅく", meaning: "compression" },
        { word: "圧勝", reading: "あっしょう", meaning: "overwhelming victory, crushing victory, sweeping victory" },
        { word: "圧倒", reading: "あっとう", meaning: "to overwhelm (e.g. an opponent), to overpower, to crush" }
    ],
    },
    "扱": {
        onyomi: ["ソウ", "キュウ"],
        kunyomi: ["あつか.い", "あつか.う", "あつか.る", "こ.く"],
        examples: [
        { word: "扱い", reading: "あつかい", meaning: "treatment, service, dealing (with)" },
        { word: "扱う", reading: "あつかう", meaning: "to deal with (a person), to treat, to handle" },
        { word: "取扱", reading: "とりあつかい", meaning: "treatment, service, handling" },
        { word: "取扱い", reading: "とりあつかい", meaning: "treatment, service, handling" }
    ],
    },
    "宛": {
        onyomi: ["エン"],
        kunyomi: ["あ.てる", "-あて", "-づつ", "あたか.も"],
        examples: [
        { word: "宛先", reading: "あてさき", meaning: "address, destination" },
        { word: "宛名", reading: "あてな", meaning: "name and address (on an envelope, etc.), (addressee's) name, addressee" },
        { word: "宛", reading: "あて", meaning: "aim, object, purpose" }
    ],
    },
    "嵐": {
        onyomi: ["ラン"],
        kunyomi: ["あらし"],
        examples: [
        { word: "嵐", reading: "あらし", meaning: "storm, tempest" }
    ],
    },
    "安": {
        onyomi: ["アン"],
        kunyomi: ["やす.い", "やす.まる", "やす", "やす.らか"],
        examples: [
        { word: "安い", reading: "やすい", meaning: "cheap, inexpensive" },
        { word: "安易", reading: "あんい", meaning: "easy, simple" },
        { word: "安価", reading: "あんか", meaning: "low-priced, cheap, inexpensive" },
        { word: "安住", reading: "あんじゅう", meaning: "living in peace, living a quiet life" }
    ],
    },
    "案": {
        onyomi: ["アン"],
        kunyomi: ["つくえ"],
        examples: [
        { word: "案外", reading: "あんがい", meaning: "unexpectedly, surprisingly" },
        { word: "案件", reading: "あんけん", meaning: "matter (to discuss), item (on the agenda), issue" },
        { word: "案内", reading: "あんない", meaning: "guidance, leading (the way), showing around" },
        { word: "議案", reading: "ぎあん", meaning: "legislative bill, measure" }
    ],
    },
    "暗": {
        onyomi: ["アン"],
        kunyomi: ["くら.い", "くら.む", "くれ.る"],
        examples: [
        { word: "暗い", reading: "くらい", meaning: "dark, gloomy, murky" },
        { word: "暗に", reading: "あんに", meaning: "implicitly, indirectly, tacitly" },
        { word: "暗闇", reading: "くらやみ", meaning: "darkness, the dark" },
        { word: "暗雲", reading: "あんうん", meaning: "dark clouds" }
    ],
    },
    "以": {
        onyomi: ["イ"],
        kunyomi: ["もっ.て"],
        examples: [
        { word: "以て", reading: "もって", meaning: "with, by, by means of" },
        { word: "以下", reading: "いか", meaning: "not exceeding ..., not more than ..., ... and under" },
        { word: "以外", reading: "いがい", meaning: "excluding, except (for), apart from" },
        { word: "以後", reading: "いご", meaning: "after this, from now on, hereafter" }
    ],
    },
    "衣": {
        onyomi: ["イ", "エ"],
        kunyomi: ["ころも", "きぬ", "-ぎ"],
        examples: [
        { word: "衣装", reading: "いしょう", meaning: "clothing, costume, outfit" },
        { word: "衣服", reading: "いふく", meaning: "clothes" },
        { word: "衣料", reading: "いりょう", meaning: "clothing" },
        { word: "羽衣", reading: "はごろも", meaning: "angel's raiment, robe of feathers" }
    ],
    },
    "位": {
        onyomi: ["イ"],
        kunyomi: ["くらい", "ぐらい"],
        examples: [
        { word: "一位", reading: "いちい", meaning: "first place, first rank" },
        { word: "王位", reading: "おうい", meaning: "the throne, the crown" },
        { word: "下位", reading: "かい", meaning: "low rank, lower position, subordinate position" },
        { word: "各位", reading: "かくい", meaning: "everyone, each and every one (of you), ladies and gentlemen" }
    ],
    },
    "囲": {
        onyomi: ["イ"],
        kunyomi: ["かこ.む", "かこ.う", "かこ.い"],
        examples: [
        { word: "囲い", reading: "かこい", meaning: "enclosure, fence, wall" },
        { word: "囲う", reading: "かこう", meaning: "to enclose, to surround, to encircle" },
        { word: "囲む", reading: "かこむ", meaning: "to surround, to encircle, to enclose" },
        { word: "囲碁", reading: "いご", meaning: "go (board game)" }
    ],
    },
    "医": {
        onyomi: ["イ"],
        kunyomi: ["い.やす", "い.する", "くすし"],
        examples: [
        { word: "医院", reading: "いいん", meaning: "doctor's office, doctor's surgery, clinic" },
        { word: "医科", reading: "いか", meaning: "medical science, medical department" },
        { word: "医学", reading: "いがく", meaning: "medicine, medical science" },
        { word: "医局", reading: "いきょく", meaning: "medical office (esp. in a hospital), doctor's office" }
    ],
    },
    "依": {
        onyomi: ["イ", "エ"],
        kunyomi: ["よ.る"],
        examples: [
        { word: "依然", reading: "いぜん", meaning: "still, as yet, as it has been" },
        { word: "依頼", reading: "いらい", meaning: "request, commission, entrusting (with a matter)" },
        { word: "帰依", reading: "きえ", meaning: "becoming a devout believer, (religious) conversion" },
        { word: "依存", reading: "いぞん", meaning: "dependence, reliance" }
    ],
    },
    "委": {
        onyomi: ["イ"],
        kunyomi: ["ゆだ.ねる"],
        examples: [
        { word: "委員", reading: "いいん", meaning: "committee member" },
        { word: "委託", reading: "いたく", meaning: "entrusting (something to a person), consignment (of goods), putting in someone's charge" },
        { word: "委任", reading: "いにん", meaning: "entrusting, charge, delegation" },
        { word: "委嘱", reading: "いしょく", meaning: "commissioning, entrusting (with), request" }
    ],
    },
    "威": {
        onyomi: ["イ"],
        kunyomi: ["おど.す", "おど.し", "おど.かす"],
        examples: [
        { word: "威嚇", reading: "いかく", meaning: "threat, intimidation, menace" },
        { word: "威厳", reading: "いげん", meaning: "dignity, majesty, solemnity" },
        { word: "威信", reading: "いしん", meaning: "prestige, dignity" },
        { word: "威勢", reading: "いせい", meaning: "power, might, authority" }
    ],
    },
    "為": {
        onyomi: ["イ"],
        kunyomi: ["ため", "な.る", "な.す", "す.る", "たり", "つく.る", "なり"],
        examples: [
        { word: "為に", reading: "ために", meaning: "for, for the sake of, to one's advantage" },
        { word: "為替", reading: "かわせ", meaning: "money order, draft" },
        { word: "行為", reading: "こうい", meaning: "act, deed, conduct" },
        { word: "人為", reading: "じんい", meaning: "human work, human agency, art" }
    ],
    },
    "畏": {
        onyomi: ["イ"],
        kunyomi: ["おそ.れる", "かしこま.る", "かしこ", "かしこ.し"],
        examples: [
        { word: "畏まりました", reading: "かしこまりました", meaning: "certainly!, very well, with pleasure" }
    ],
    },
    "胃": {
        onyomi: ["イ"],
        kunyomi: [],
        examples: [
        { word: "胃袋", reading: "いぶくろ", meaning: "stomach" },
        { word: "胃腸", reading: "いちょう", meaning: "stomach and intestines, gastrointestinal tract, digestive organs" },
        { word: "胃", reading: "い", meaning: "stomach" }
    ],
    },
    "尉": {
        onyomi: ["イ", "ジョウ"],
        kunyomi: [],
        examples: [
        { word: "少尉", reading: "しょうい", meaning: "second lieutenant, sublieutenant, ensign" },
        { word: "大尉", reading: "たいい", meaning: "captain (Army, US Marine Corps, USAF), lieutenant (Navy), flight lieutenant (RAF, RAAF, RNZAF, etc.)" },
        { word: "中尉", reading: "ちゅうい", meaning: "first lieutenant, lieutenant junior grade" }
    ],
    },
    "異": {
        onyomi: ["イ"],
        kunyomi: ["こと", "こと.なる", "け"],
        examples: [
        { word: "異議", reading: "いぎ", meaning: "objection, dissent, protest" },
        { word: "異国", reading: "いこく", meaning: "foreign country" },
        { word: "異質", reading: "いしつ", meaning: "different (quality, nature), heterogeneous" },
        { word: "異常", reading: "いじょう", meaning: "abnormal, unusual, extraordinary" }
    ],
    },
    "移": {
        onyomi: ["イ"],
        kunyomi: ["うつ.る", "うつ.す"],
        examples: [
        { word: "移す", reading: "うつす", meaning: "to transfer (to a different place, group, etc.), to change, to move (something)" },
        { word: "移る", reading: "うつる", meaning: "to move (to another place or state), to change (e.g. of state, affiliation, scenery, etc.), to be transferred" },
        { word: "移管", reading: "いかん", meaning: "transfer of control" },
        { word: "移行", reading: "いこう", meaning: "transition, changeover, switchover" }
    ],
    },
    "萎": {
        onyomi: ["イ"],
        kunyomi: ["な", "しお.れる", "しな.びる", "しぼ.む", "な.える"],
        examples: [
        { word: "萎む", reading: "しぼむ", meaning: "to wither (of flowers, dreams, etc.), to wilt, to droop" },
        { word: "萎縮", reading: "いしゅく", meaning: "withering, shrivelling, shrinking" },
        { word: "萎える", reading: "なえる", meaning: "to lose strength, to become weak, to disappear (of energy, drive, etc.)" },
        { word: "萎れる", reading: "しおれる", meaning: "to wither, to wilt, to droop" }
    ],
    },
    "偉": {
        onyomi: ["イ"],
        kunyomi: ["えら.い"],
        examples: [
        { word: "偉い", reading: "えらい", meaning: "great, excellent, admirable" },
        { word: "偉業", reading: "いぎょう", meaning: "great achievement, great feat, great work" },
        { word: "偉人", reading: "いじん", meaning: "great person, eminent figure" },
        { word: "偉大", reading: "いだい", meaning: "great, grand, magnificent" }
    ],
    },
    "椅": {
        onyomi: ["イ"],
        kunyomi: [],
        examples: [
        { word: "椅子", reading: "いす", meaning: "chair, seat, stool" },
        { word: "車椅子", reading: "くるまいす", meaning: "wheelchair" }
    ],
    },
    "彙": {
        onyomi: ["イ"],
        kunyomi: ["はりねずみ"],
        examples: [
        { word: "語彙", reading: "ごい", meaning: "vocabulary, lexicon, lexis" }
    ],
    },
    "意": {
        onyomi: ["イ"],
        kunyomi: [],
        examples: [
        { word: "悪意", reading: "あくい", meaning: "ill will, spite, evil intention" },
        { word: "意外", reading: "いがい", meaning: "unexpected, surprising, unanticipated" },
        { word: "意気", reading: "いき", meaning: "spirit, heart, disposition" },
        { word: "意義", reading: "いぎ", meaning: "meaning, significance" }
    ],
    },
    "違": {
        onyomi: ["イ"],
        kunyomi: ["ちが.う", "ちが.い", "ちが.える", "-ちが.える", "たが.う", "たが.える"],
        examples: [
        { word: "違い", reading: "ちがい", meaning: "difference, distinction, discrepancy" },
        { word: "違う", reading: "ちがう", meaning: "to differ (from), to be different, to be distinct" },
        { word: "違憲", reading: "いけん", meaning: "unconstitutionality" },
        { word: "違反", reading: "いはん", meaning: "violation, offense, offence" }
    ],
    },
    "維": {
        onyomi: ["イ"],
        kunyomi: [],
        examples: [
        { word: "維持", reading: "いじ", meaning: "maintenance, preservation, improvement" },
        { word: "維新", reading: "いしん", meaning: "reformation, revolution, renewal" },
        { word: "繊維", reading: "せんい", meaning: "fibre, fiber" },
        { word: "合成繊維", reading: "ごうせいせんい", meaning: "synthetic fibre, synthetic fiber" }
    ],
    },
    "慰": {
        onyomi: ["イ"],
        kunyomi: ["なぐさ.める", "なぐさ.む"],
        examples: [
        { word: "慰安", reading: "いあん", meaning: "solace, relaxation" },
        { word: "慰問", reading: "いもん", meaning: "visit to console someone, giving comfort (to the sick, injured, etc.), expressing condolences (sympathy, concern, etc.)" },
        { word: "慰謝", reading: "いしゃ", meaning: "consolation" },
        { word: "慰霊", reading: "いれい", meaning: "consoling the spirits of the dead" }
    ],
    },
    "遺": {
        onyomi: ["イ", "ユイ"],
        kunyomi: ["のこ.す"],
        examples: [
        { word: "遺影", reading: "いえい", meaning: "portrait of a deceased person" },
        { word: "遺憾", reading: "いかん", meaning: "regrettable, unsatisfactory, deplorable" },
        { word: "遺言", reading: "ゆいごん", meaning: "will, testament, one's dying wish" },
        { word: "遺構", reading: "いこう", meaning: "(archaeological) remains, remnants (of ancient structures), ancient foundation" }
    ],
    },
    "緯": {
        onyomi: ["イ"],
        kunyomi: ["よこいと", "ぬき"],
        examples: [
        { word: "緯度", reading: "いど", meaning: "latitude" },
        { word: "経緯", reading: "けいい", meaning: "details, particulars, sequence of events" },
        { word: "南緯", reading: "なんい", meaning: "southern latitude" },
        { word: "北緯", reading: "ほくい", meaning: "north latitude" }
    ],
    },
    "域": {
        onyomi: ["イキ"],
        kunyomi: [],
        examples: [
        { word: "域外", reading: "いきがい", meaning: "outside the area" },
        { word: "域内", reading: "いきない", meaning: "inside the area" },
        { word: "海域", reading: "かいいき", meaning: "area of sea, waters" },
        { word: "区域", reading: "くいき", meaning: "area, zone, district" }
    ],
    },
    "育": {
        onyomi: ["イク"],
        kunyomi: ["そだ.つ", "そだ.ち", "そだ.てる", "はぐく.む"],
        examples: [
        { word: "育ち", reading: "そだち", meaning: "growth, breeding" },
        { word: "育つ", reading: "そだつ", meaning: "to be raised (e.g. child), to be brought up, to grow (up)" },
        { word: "育英", reading: "いくえい", meaning: "education of gifted young people, providing financial support to gifted students" },
        { word: "育児", reading: "いくじ", meaning: "childcare, child-rearing, nursing" }
    ],
    },
    "一": {
        onyomi: ["イチ", "イツ"],
        kunyomi: ["ひと-", "ひと.つ"],
        examples: [
        { word: "一つ", reading: "ひとつ", meaning: "one" },
        { word: "一位", reading: "いちい", meaning: "first place, first rank" },
        { word: "一員", reading: "いちいん", meaning: "one person, one member" },
        { word: "一因", reading: "いちいん", meaning: "one cause, one reason, one factor" }
    ],
    },
    "壱": {
        onyomi: ["イチ", "イツ"],
        kunyomi: ["ひとつ"],
        examples: [
        { word: "拾壱", reading: "じゅういち", meaning: "eleven, 11" },
        { word: "壱越", reading: "いちこつ", meaning: "fundamental tone in the traditional Japanese 12-tone scale (approx. D)" },
        { word: "壱岐", reading: "いき", meaning: "Iki (former province located on Iki Island in present-day Nagasaki Prefecture)" },
        { word: "壱拾萬", reading: "じゅうまん", meaning: "100,000, hundred thousand" }
    ],
    },
    "逸": {
        onyomi: ["イツ"],
        kunyomi: ["そ.れる", "そ.らす", "はぐ.れる"],
        examples: [
        { word: "逸脱", reading: "いつだつ", meaning: "deviation, departure" },
        { word: "逸品", reading: "いっぴん", meaning: "excellent article, fine item, rare beauty" },
        { word: "逸話", reading: "いつわ", meaning: "anecdote, story, episode" },
        { word: "秀逸", reading: "しゅういつ", meaning: "excellent, superb, first-rate" }
    ],
    },
    "茨": {
        onyomi: ["シ", "ジ"],
        kunyomi: ["いばら", "かや", "くさぶき"],
        examples: [
        { word: "茨垣", reading: "いばらがき", meaning: "thorn hedge" },
        { word: "茨姫", reading: "いばらひめ", meaning: "Sleeping Beauty, Thorn Princess, Briar Rose" },
        { word: "野茨", reading: "のいばら", meaning: "multiflora rose (Rosa multiflora), baby rose, Japanese rose" },
        { word: "茨藻", reading: "いばらも", meaning: "spiny water nymph (Najas marina), spiny naiad, holly-leaved naiad" }
    ],
    },
    "芋": {
        onyomi: ["ウ"],
        kunyomi: ["いも"],
        examples: [
        { word: "焼芋", reading: "やきいも", meaning: "roasted sweet potato, baked sweet potato" },
        { word: "薩摩芋", reading: "さつまいも", meaning: "sweet potato (Ipomoea batatas)" },
        { word: "焼き芋", reading: "やきいも", meaning: "roasted sweet potato, baked sweet potato" },
        { word: "じゃが芋", reading: "じゃがいも", meaning: "potato (Solanum tuberosum)" }
    ],
    },
    "引": {
        onyomi: ["イン"],
        kunyomi: ["ひ.く", "ひ.ける"],
        examples: [
        { word: "引く", reading: "ひく", meaning: "to pull, to tug, to lead (e.g. a horse)" },
        { word: "引責", reading: "いんせき", meaning: "taking responsibility" },
        { word: "引退", reading: "いんたい", meaning: "retirement" },
        { word: "引用", reading: "いんよう", meaning: "quotation, citation, reference" }
    ],
    },
    "印": {
        onyomi: ["イン"],
        kunyomi: ["しるし", "-じるし", "しる.す"],
        examples: [
        { word: "印鑑", reading: "いんかん", meaning: "stamp, seal" },
        { word: "印刷", reading: "いんさつ", meaning: "printing" },
        { word: "印紙", reading: "いんし", meaning: "(revenue) stamp" },
        { word: "印象", reading: "いんしょう", meaning: "impression" }
    ],
    },
    "因": {
        onyomi: ["イン"],
        kunyomi: ["よ.る", "ちな.む"],
        examples: [
        { word: "一因", reading: "いちいん", meaning: "one cause, one reason, one factor" },
        { word: "因縁", reading: "いんねん", meaning: "fate, destiny" },
        { word: "因果", reading: "いんが", meaning: "cause and effect, causality" },
        { word: "因子", reading: "いんし", meaning: "factor" }
    ],
    },
    "咽": {
        onyomi: ["イン", "エン", "エツ"],
        kunyomi: ["むせ.ぶ", "むせ.る", "のど", "の.む"],
        examples: [
        { word: "咽喉", reading: "いんこう", meaning: "throat" },
        { word: "咽頭", reading: "いんとう", meaning: "pharynx" },
        { word: "嗚咽", reading: "おえつ", meaning: "sobbing, weeping, fit of crying" },
        { word: "鳴咽", reading: "おえつ", meaning: "sobbing, weeping, fit of crying" }
    ],
    },
    "姻": {
        onyomi: ["イン"],
        kunyomi: [],
        examples: [
        { word: "婚姻", reading: "こんいん", meaning: "marriage, matrimony" }
    ],
    },
    "員": {
        onyomi: ["イン"],
        kunyomi: [],
        examples: [
        { word: "委員", reading: "いいん", meaning: "committee member" },
        { word: "一員", reading: "いちいん", meaning: "one person, one member" },
        { word: "員数", reading: "いんずう", meaning: "(total) number (of people or things), count, quota" },
        { word: "駅員", reading: "えきいん", meaning: "(train) station attendant, station employee, station staff" }
    ],
    },
    "院": {
        onyomi: ["イン"],
        kunyomi: [],
        examples: [
        { word: "医院", reading: "いいん", meaning: "doctor's office, doctor's surgery, clinic" },
        { word: "院長", reading: "いんちょう", meaning: "director (of a hospital, institution, academy, etc.), superintendent, rector" },
        { word: "下院", reading: "かいん", meaning: "lower house, lower legislative chamber" },
        { word: "学院", reading: "がくいん", meaning: "institute, academy" }
    ],
    },
    "淫": {
        onyomi: ["イン"],
        kunyomi: ["ひた.す", "ほしいまま", "みだ.ら", "みだ.れる", "みだり"],
        examples: [
        { word: "淫ら", reading: "みだら", meaning: "obscene, indecent, lewd" },
        { word: "淫行", reading: "いんこう", meaning: "obscenity, harlotry" },
        { word: "淫事", reading: "いんじ", meaning: "lascivious act" },
        { word: "淫心", reading: "いんしん", meaning: "sexual passion" }
    ],
    },
    "陰": {
        onyomi: ["イン"],
        kunyomi: ["かげ", "かげ.る"],
        examples: [
        { word: "陰気", reading: "いんき", meaning: "gloomy, dismal, miserable" },
        { word: "陰口", reading: "かげぐち", meaning: "malicious gossip, backbiting, speaking ill behind someone's back" },
        { word: "陰性", reading: "いんせい", meaning: "negative (result)" },
        { word: "陰謀", reading: "いんぼう", meaning: "plot, intrigue, scheme" }
    ],
    },
    "飲": {
        onyomi: ["イン", "オン"],
        kunyomi: ["の.む", "-の.み"],
        examples: [
        { word: "飲む", reading: "のむ", meaning: "to drink, to swallow, to take (medicine)" },
        { word: "飲酒", reading: "いんしゅ", meaning: "drinking alcohol" },
        { word: "飲食", reading: "いんしょく", meaning: "food and drink, eating and drinking" },
        { word: "飲料", reading: "いんりょう", meaning: "beverage, drink" }
    ],
    },
    "隠": {
        onyomi: ["イン", "オン"],
        kunyomi: ["かく.す", "かく.し", "かく.れる", "よ.る"],
        examples: [
        { word: "隠す", reading: "かくす", meaning: "to hide, to conceal" },
        { word: "隠居", reading: "いんきょ", meaning: "retirement (from work), leading a quiet life (after retirement)" },
        { word: "隠語", reading: "いんご", meaning: "secret language, jargon, cant" },
        { word: "隠匿", reading: "いんとく", meaning: "concealment (esp. of wrongdoings or criminals), sheltering, harboring" }
    ],
    },
    "韻": {
        onyomi: ["イン"],
        kunyomi: [],
        examples: [
        { word: "韻律", reading: "いんりつ", meaning: "metre (of a poem), meter, rhythm" },
        { word: "余韻", reading: "よいん", meaning: "reverberation, swelling (of a hymn), trailing note" },
        { word: "韻", reading: "いん", meaning: "rhyme" }
    ],
    },
    "右": {
        onyomi: ["ウ", "ユウ"],
        kunyomi: ["みぎ"],
        examples: [
        { word: "右下", reading: "みぎした", meaning: "lower right" },
        { word: "右手", reading: "みぎて", meaning: "right hand" },
        { word: "右上", reading: "みぎうえ", meaning: "upper right" },
        { word: "右折", reading: "うせつ", meaning: "turning to the right, right turn" }
    ],
    },
    "宇": {
        onyomi: ["ウ"],
        kunyomi: [],
        examples: [
        { word: "宇宙", reading: "うちゅう", meaning: "universe, cosmos, space" },
        { word: "大宇宙", reading: "だいうちゅう", meaning: "macrocosmos, macrocosm, the universe" },
        { word: "宇宙空間", reading: "うちゅうくうかん", meaning: "(outer) space" },
        { word: "宇宙開発", reading: "うちゅうかいはつ", meaning: "space development, space exploration" }
    ],
    },
    "羽": {
        onyomi: ["ウ"],
        kunyomi: ["は", "わ", "はね"],
        examples: [
        { word: "羽根", reading: "はね", meaning: "feather, plume, down" },
        { word: "羽衣", reading: "はごろも", meaning: "angel's raiment, robe of feathers" },
        { word: "羽織", reading: "はおり", meaning: "haori (Japanese formal coat)" },
        { word: "羽毛", reading: "うもう", meaning: "feather, plume, plumage" }
    ],
    },
    "雨": {
        onyomi: ["ウ"],
        kunyomi: ["あめ", "あま-", "-さめ"],
        examples: [
        { word: "雨雲", reading: "あまぐも", meaning: "rain cloud" },
        { word: "雨具", reading: "あまぐ", meaning: "rain gear" },
        { word: "雨戸", reading: "あまど", meaning: "sliding storm shutter" },
        { word: "雨天", reading: "うてん", meaning: "rainy weather" }
    ],
    },
    "唄": {
        onyomi: ["バイ"],
        kunyomi: ["うた", "うた.う"],
        examples: [
        { word: "長唄", reading: "ながうた", meaning: "long epic song with shamisen accompaniment (developed in Edo in the early 17th century)" },
        { word: "唄", reading: "うた", meaning: "song, singing" }
    ],
    },
    "鬱": {
        onyomi: ["ウツ"],
        kunyomi: ["うっ.する", "ふさ.ぐ", "しげ.る"],
        examples: [
        { word: "憂鬱", reading: "ゆううつ", meaning: "depression, melancholy, dejection" },
        { word: "鬱陶しい", reading: "うっとうしい", meaning: "gloomy (e.g. mood), depressing" },
        { word: "鬱", reading: "うつ", meaning: "depression, low spirits" }
    ],
    },
    "畝": {
        onyomi: ["ボウ", "ホ", "モ", "ム"],
        kunyomi: ["せ", "うね"],
        examples: [
        { word: "畝", reading: "うね", meaning: "ridge (in field), row of raised earth when planting crops" }
    ],
    },
    "浦": {
        onyomi: ["ホ"],
        kunyomi: ["うら"],
        examples: [
        { word: "浦", reading: "うら", meaning: "inlet" }
    ],
    },
    "運": {
        onyomi: ["ウン"],
        kunyomi: ["はこ.ぶ"],
        examples: [
        { word: "運ぶ", reading: "はこぶ", meaning: "to carry, to transport, to move" },
        { word: "運営", reading: "うんえい", meaning: "management, administration, operation" },
        { word: "運河", reading: "うんが", meaning: "(navigable) canal, waterway" },
        { word: "運休", reading: "うんきゅう", meaning: "suspension (of a transportation service), cancellation, stoppage" }
    ],
    },
    "雲": {
        onyomi: ["ウン"],
        kunyomi: ["くも", "-ぐも"],
        examples: [
        { word: "暗雲", reading: "あんうん", meaning: "dark clouds" },
        { word: "雨雲", reading: "あまぐも", meaning: "rain cloud" },
        { word: "風雲", reading: "ふううん", meaning: "winds and clouds, nature, the elements" },
        { word: "雲雀", reading: "ひばり", meaning: "skylark (Alauda arvensis)" }
    ],
    },
    "永": {
        onyomi: ["エイ"],
        kunyomi: ["なが.い"],
        examples: [
        { word: "永遠", reading: "えいえん", meaning: "eternity, perpetuity, permanence" },
        { word: "永住", reading: "えいじゅう", meaning: "permanent residence" },
        { word: "永続", reading: "えいぞく", meaning: "permanence, continuation" },
        { word: "永代", reading: "えいたい", meaning: "permanence, eternity" }
    ],
    },
    "泳": {
        onyomi: ["エイ"],
        kunyomi: ["およ.ぐ"],
        examples: [
        { word: "泳ぐ", reading: "およぐ", meaning: "to swim" },
        { word: "遠泳", reading: "えんえい", meaning: "long-distance swimming" },
        { word: "競泳", reading: "きょうえい", meaning: "competitive swimming, swimming race" },
        { word: "水泳", reading: "すいえい", meaning: "swimming" }
    ],
    },
    "英": {
        onyomi: ["エイ"],
        kunyomi: ["はなぶさ"],
        examples: [
        { word: "育英", reading: "いくえい", meaning: "education of gifted young people, providing financial support to gifted students" },
        { word: "英気", reading: "えいき", meaning: "great wisdom, excellent disposition" },
        { word: "英語", reading: "えいご", meaning: "English (language)" },
        { word: "英国", reading: "えいこく", meaning: "United Kingdom, Britain, Great Britain" }
    ],
    },
    "映": {
        onyomi: ["エイ"],
        kunyomi: ["うつ.る", "うつ.す", "は.える", "-ば.え"],
        examples: [
        { word: "映る", reading: "うつる", meaning: "to be reflected, to harmonize with (harmonise), to come out (photo)" },
        { word: "映画", reading: "えいが", meaning: "movie, film, motion picture" },
        { word: "映像", reading: "えいぞう", meaning: "image (on a screen), picture (e.g. on a TV)" },
        { word: "上映", reading: "じょうえい", meaning: "screening (a movie), showing" }
    ],
    },
    "栄": {
        onyomi: ["エイ", "ヨウ"],
        kunyomi: ["さか.える", "は.え", "-ば.え", "は.える", "え"],
        examples: [
        { word: "栄冠", reading: "えいかん", meaning: "crown of victory, laurels" },
        { word: "栄枯", reading: "えいこ", meaning: "vicissitudes, ups and downs" },
        { word: "栄光", reading: "えいこう", meaning: "glory" },
        { word: "栄誉", reading: "えいよ", meaning: "honour, honor" }
    ],
    },
    "営": {
        onyomi: ["エイ"],
        kunyomi: ["いとな.む", "いとな.み"],
        examples: [
        { word: "運営", reading: "うんえい", meaning: "management, administration, operation" },
        { word: "営み", reading: "いとなみ", meaning: "activity, action, performance" },
        { word: "営む", reading: "いとなむ", meaning: "to run (a business), to operate, to conduct" },
        { word: "営業", reading: "えいぎょう", meaning: "business, trade, operations" }
    ],
    },
    "詠": {
        onyomi: ["エイ"],
        kunyomi: ["よ.む", "うた.う"],
        examples: [
        { word: "詠む", reading: "よむ", meaning: "to compose (a Japanese poem), to write, to use as the theme of a poem" },
        { word: "朗詠", reading: "ろうえい", meaning: "recitation (of Japanese or Chinese poem)" }
    ],
    },
    "影": {
        onyomi: ["エイ"],
        kunyomi: ["かげ"],
        examples: [
        { word: "遺影", reading: "いえい", meaning: "portrait of a deceased person" },
        { word: "影絵", reading: "かげえ", meaning: "shadow picture, silhouette, shadowgraph" },
        { word: "影響", reading: "えいきょう", meaning: "influence, effect, impact" },
        { word: "幻影", reading: "げんえい", meaning: "phantom, vision, illusion" }
    ],
    },
    "鋭": {
        onyomi: ["エイ"],
        kunyomi: ["するど.い"],
        examples: [
        { word: "鋭い", reading: "するどい", meaning: "sharp (knife, claws, etc.), pointed" },
        { word: "鋭角", reading: "えいかく", meaning: "acute angle" },
        { word: "鋭敏", reading: "えいびん", meaning: "sharp (eyes, ears, etc.), keen, acute" },
        { word: "鋭利", reading: "えいり", meaning: "sharp, keen, acute" }
    ],
    },
    "衛": {
        onyomi: ["エイ", "エ"],
        kunyomi: [],
        examples: [
        { word: "衛星", reading: "えいせい", meaning: "(natural) satellite, moon" },
        { word: "衛生", reading: "えいせい", meaning: "hygiene, sanitation, cleanliness" },
        { word: "護衛", reading: "ごえい", meaning: "guard, convoy, escort" },
        { word: "自衛", reading: "じえい", meaning: "self-defense, self-defence" }
    ],
    },
    "易": {
        onyomi: ["エキ", "イ"],
        kunyomi: ["やさ.しい", "やす.い"],
        examples: [
        { word: "安易", reading: "あんい", meaning: "easy, simple" },
        { word: "易い", reading: "やすい", meaning: "easy" },
        { word: "簡易", reading: "かんい", meaning: "simple, simplified" },
        { word: "交易", reading: "こうえき", meaning: "trade, commerce" }
    ],
    },
    "疫": {
        onyomi: ["エキ", "ヤク"],
        kunyomi: [],
        examples: [
        { word: "検疫", reading: "けんえき", meaning: "quarantine, medical inspection" },
        { word: "防疫", reading: "ぼうえき", meaning: "communicable disease control (e.g. by quarantine, disinfection, etc.), prevention of epidemics" },
        { word: "免疫", reading: "めんえき", meaning: "immunity, immunization, immunisation" },
        { word: "疫病", reading: "えきびょう", meaning: "epidemic, plague, pestilence" }
    ],
    },
    "益": {
        onyomi: ["エキ", "ヤク"],
        kunyomi: ["ま.す"],
        examples: [
        { word: "権益", reading: "けんえき", meaning: "rights and interests (esp. those a country holds abroad)" },
        { word: "公益", reading: "こうえき", meaning: "public interest, public benefit, public good" },
        { word: "国益", reading: "こくえき", meaning: "national interest" },
        { word: "差益", reading: "さえき", meaning: "marginal profits" }
    ],
    },
    "液": {
        onyomi: ["エキ"],
        kunyomi: [],
        examples: [
        { word: "液化", reading: "えきか", meaning: "liquefaction" },
        { word: "液晶", reading: "えきしょう", meaning: "liquid crystal" },
        { word: "液体", reading: "えきたい", meaning: "liquid" },
        { word: "血液", reading: "けつえき", meaning: "blood" }
    ],
    },
    "駅": {
        onyomi: ["エキ"],
        kunyomi: [],
        examples: [
        { word: "駅員", reading: "えきいん", meaning: "(train) station attendant, station employee, station staff" },
        { word: "駅前", reading: "えきまえ", meaning: "in front of a station" },
        { word: "駅長", reading: "えきちょう", meaning: "station master" },
        { word: "駅伝", reading: "えきでん", meaning: "long-distance relay race" }
    ],
    },
    "悦": {
        onyomi: ["エツ"],
        kunyomi: ["よろこ.ぶ", "よろこ.ばす"],
        examples: [
        { word: "満悦", reading: "まんえつ", meaning: "great delight, great satisfaction, rapture" }
    ],
    },
    "越": {
        onyomi: ["エツ", "オツ"],
        kunyomi: ["こ.す", "-こ.す", "-ご.し", "こ.える", "-ご.え"],
        examples: [
        { word: "越す", reading: "こす", meaning: "to cross over (e.g. mountain), to go across" },
        { word: "越境", reading: "えっきょう", meaning: "crossing a border (illegally), border violation, border transgression" },
        { word: "越権", reading: "えっけん", meaning: "going beyond authority, unauthorized, unauthorised" },
        { word: "越冬", reading: "えっとう", meaning: "passing the winter, hibernation" }
    ],
    },
    "謁": {
        onyomi: ["エツ"],
        kunyomi: [],
        examples: [
        { word: "謁見", reading: "えっけん", meaning: "audience (with a superior, e.g. nobility)" },
        { word: "内謁", reading: "ないえつ", meaning: "private audience" },
        { word: "拝謁", reading: "はいえつ", meaning: "audience with someone of high rank (e.g. the emperor)" },
        { word: "請謁", reading: "せいえつ", meaning: "beseeching, requesting (an audience)" }
    ],
    },
    "閲": {
        onyomi: ["エツ"],
        kunyomi: ["けみ.する"],
        examples: [
        { word: "閲覧", reading: "えつらん", meaning: "inspection, reading, perusal" },
        { word: "検閲", reading: "けんえつ", meaning: "censorship" },
        { word: "校閲", reading: "こうえつ", meaning: "revision, proofreading" }
    ],
    },
    "円": {
        onyomi: ["エン"],
        kunyomi: ["まる.い", "まる", "まど", "まど.か", "まろ.やか"],
        examples: [
        { word: "一円", reading: "いちえん", meaning: "one yen" },
        { word: "円安", reading: "えんやす", meaning: "depreciation of the yen, weak yen" },
        { word: "円弧", reading: "えんこ", meaning: "arc" },
        { word: "円高", reading: "えんだか", meaning: "appreciation of the yen, strong yen" }
    ],
    },
    "延": {
        onyomi: ["エン"],
        kunyomi: ["の.びる", "の.べる", "の.べ", "の.ばす"],
        examples: [
        { word: "延べ", reading: "のべ", meaning: "futures" },
        { word: "延期", reading: "えんき", meaning: "postponement, deferment, adjournment" },
        { word: "延滞", reading: "えんたい", meaning: "arrears, (being) overdue, delay (e.g. in payment)" },
        { word: "延長", reading: "えんちょう", meaning: "extension, elongation, prolongation" }
    ],
    },
    "沿": {
        onyomi: ["エン"],
        kunyomi: ["そ.う", "-ぞ.い"],
        examples: [
        { word: "沿う", reading: "そう", meaning: "to run along, to run beside, to stick to (a line)" },
        { word: "沿海", reading: "えんかい", meaning: "sea along the coast, coastal waters, inshore waters" },
        { word: "沿革", reading: "えんかく", meaning: "history, development" },
        { word: "沿岸", reading: "えんがん", meaning: "coast, shore" }
    ],
    },
    "炎": {
        onyomi: ["エン"],
        kunyomi: ["ほのお"],
        examples: [
        { word: "炎症", reading: "えんしょう", meaning: "inflammation, irritation" },
        { word: "炎上", reading: "えんじょう", meaning: "going up in flames, destruction by fire (esp. of a large building)" },
        { word: "炎天", reading: "えんてん", meaning: "blazing heat, scorching sun" },
        { word: "肝炎", reading: "かんえん", meaning: "hepatitis" }
    ],
    },
    "怨": {
        onyomi: ["エン", "オン", "ウン"],
        kunyomi: ["うら.む", "うらみ", "うら.めしい"],
        examples: [
        { word: "怨恨", reading: "えんこん", meaning: "enmity, grudge" },
        { word: "怨声", reading: "えんせい", meaning: "complaint, murmur" },
        { word: "怨敵", reading: "おんてき", meaning: "sworn enemy" },
        { word: "怨念", reading: "おんねん", meaning: "deep-seated grudge, hatred" }
    ],
    },
    "宴": {
        onyomi: ["エン"],
        kunyomi: ["うたげ"],
        examples: [
        { word: "宴会", reading: "えんかい", meaning: "party, banquet, reception" },
        { word: "宴席", reading: "えんせき", meaning: "banquet, dinner party" },
        { word: "饗宴", reading: "きょうえん", meaning: "feast, banquet" },
        { word: "披露宴", reading: "ひろうえん", meaning: "reception (e.g. wedding), banquet, celebration" }
    ],
    },
    "媛": {
        onyomi: ["エン"],
        kunyomi: ["ひめ"],
        examples: [
        { word: "才媛", reading: "さいえん", meaning: "literary woman, talented woman" },
        { word: "愛媛", reading: "えひめ", meaning: "Ehime (prefecture)" },
        { word: "愛媛県", reading: "えひめけん", meaning: "Ehime Prefecture (Shikoku)" },
        { word: "愛媛縣", reading: "えひめけん", meaning: "Ehime Prefecture (Shikoku)" }
    ],
    },
    "援": {
        onyomi: ["エン"],
        kunyomi: [],
        examples: [
        { word: "援軍", reading: "えんぐん", meaning: "reinforcement" },
        { word: "援助", reading: "えんじょ", meaning: "assistance, aid, support" },
        { word: "応援", reading: "おうえん", meaning: "aid, assistance, help" },
        { word: "救援", reading: "きゅうえん", meaning: "relief, rescue" }
    ],
    },
    "園": {
        onyomi: ["エン"],
        kunyomi: ["その"],
        examples: [
        { word: "園芸", reading: "えんげい", meaning: "horticulture, gardening" },
        { word: "園児", reading: "えんじ", meaning: "kindergarten pupil, kindergartener, preschooler" },
        { word: "園長", reading: "えんちょう", meaning: "head of a garden, kindergarten principal, nursery school principal" },
        { word: "学園", reading: "がくえん", meaning: "educational institution, school, academy" }
    ],
    },
    "煙": {
        onyomi: ["エン"],
        kunyomi: ["けむ.る", "けむり", "けむ.い"],
        examples: [
        { word: "煙い", reading: "けむい", meaning: "smoky" },
        { word: "煙る", reading: "けむる", meaning: "to smoke (e.g. fire), to billow smoke, to smoulder" },
        { word: "煙突", reading: "えんとつ", meaning: "chimney, smokestack, funnel (of a ship)" },
        { word: "喫煙", reading: "きつえん", meaning: "smoking (tobacco)" }
    ],
    },
    "猿": {
        onyomi: ["エン"],
        kunyomi: ["さる"],
        examples: [
        { word: "類人猿", reading: "るいじんえん", meaning: "anthropoid ape, anthropoid, ape" },
        { word: "犬猿の仲", reading: "けんえんのなか", meaning: "like cats and dogs, (on) very bad terms, relationship of dogs and monkeys" },
        { word: "猿", reading: "さる", meaning: "monkey (esp. the Japanese macaque, Macaca fuscata), ape, non-human primate" }
    ],
    },
    "遠": {
        onyomi: ["エン", "オン"],
        kunyomi: ["とお.い"],
        examples: [
        { word: "永遠", reading: "えいえん", meaning: "eternity, perpetuity, permanence" },
        { word: "遠い", reading: "とおい", meaning: "far, distant, far away" },
        { word: "遠く", reading: "とおく", meaning: "far away, distant place, a (great) distance" },
        { word: "遠泳", reading: "えんえい", meaning: "long-distance swimming" }
    ],
    },
    "鉛": {
        onyomi: ["エン"],
        kunyomi: ["なまり"],
        examples: [
        { word: "亜鉛", reading: "あえん", meaning: "zinc (Zn)" },
        { word: "鉛筆", reading: "えんぴつ", meaning: "(wooden) pencil" },
        { word: "黒鉛", reading: "こくえん", meaning: "graphite" },
        { word: "鉛", reading: "なまり", meaning: "lead (Pb)" }
    ],
    },
    "塩": {
        onyomi: ["エン"],
        kunyomi: ["しお"],
        examples: [
        { word: "塩化", reading: "えんか", meaning: "chloridation, salification" },
        { word: "塩基", reading: "えんき", meaning: "base" },
        { word: "塩酸", reading: "えんさん", meaning: "hydrochloric acid" },
        { word: "塩素", reading: "えんそ", meaning: "chlorine (Cl)" }
    ],
    },
    "演": {
        onyomi: ["エン"],
        kunyomi: [],
        examples: [
        { word: "演歌", reading: "えんか", meaning: "enka, traditional-style Japanese popular ballad" },
        { word: "演技", reading: "えんぎ", meaning: "acting, performance" },
        { word: "演芸", reading: "えんげい", meaning: "entertainment, performance" },
        { word: "演劇", reading: "えんげき", meaning: "drama, theatre, theater" }
    ],
    },
    "縁": {
        onyomi: ["エン", "-ネン"],
        kunyomi: ["ふち", "ふち.どる", "ゆかり", "よすが", "へり", "えにし"],
        examples: [
        { word: "因縁", reading: "いんねん", meaning: "fate, destiny" },
        { word: "縁起", reading: "えんぎ", meaning: "omen, sign of luck" },
        { word: "縁側", reading: "えんがわ", meaning: "engawa, external corridor on the outer side of traditional Japanese houses" },
        { word: "縁談", reading: "えんだん", meaning: "marriage proposal, marriage talks" }
    ],
    },
    "艶": {
        onyomi: ["エン"],
        kunyomi: ["つや", "なま.めかしい", "あで.やか", "つや.めく", "なま.めく"],
        examples: [
        { word: "艶々", reading: "つやつや", meaning: "glossy, bright, slick" },
        { word: "艶", reading: "つや", meaning: "gloss, luster, lustre" }
    ],
    },
    "汚": {
        onyomi: ["オ"],
        kunyomi: ["けが.す", "けが.れる", "けが.らわしい", "よご.す", "よご.れる", "きたな.い"],
        examples: [
        { word: "汚い", reading: "きたない", meaning: "dirty, filthy, foul" },
        { word: "汚す", reading: "よごす", meaning: "to pollute, to contaminate, to soil" },
        { word: "汚職", reading: "おしょく", meaning: "corruption (esp. by a government employee), bribery, graft" },
        { word: "汚水", reading: "おすい", meaning: "filthy water, sewage" }
    ],
    },
    "王": {
        onyomi: ["オウ", "-ノウ"],
        kunyomi: [],
        examples: [
        { word: "王位", reading: "おうい", meaning: "the throne, the crown" },
        { word: "王冠", reading: "おうかん", meaning: "crown, diadem" },
        { word: "王宮", reading: "おうきゅう", meaning: "royal palace" },
        { word: "王国", reading: "おうこく", meaning: "kingdom, monarchy" }
    ],
    },
    "凹": {
        onyomi: ["オウ"],
        kunyomi: ["くぼ.む", "へこ.む", "ぼこ"],
        examples: [
        { word: "凹む", reading: "へこむ", meaning: "to be dented, to be indented, to yield" },
        { word: "凹凸", reading: "おうとつ", meaning: "unevenness, bumpiness, roughness" },
        { word: "凹み", reading: "くぼみ", meaning: "hollow, cavity, dent" },
        { word: "凸凹", reading: "でこぼこ", meaning: "unevenness, roughness, ruggedness" }
    ],
    },
    "央": {
        onyomi: ["オウ"],
        kunyomi: [],
        examples: [
        { word: "中央", reading: "ちゅうおう", meaning: "centre, center, middle" },
        { word: "中央集権", reading: "ちゅうおうしゅうけん", meaning: "centralized authoritarian rule, centralised authoritarian rule" }
    ],
    },
    "応": {
        onyomi: ["オウ", "ヨウ", "-ノウ"],
        kunyomi: ["あた.る", "まさに", "こた.える"],
        examples: [
        { word: "一応", reading: "いちおう", meaning: "more or less, though not quite satisfactorily, after a fashion" },
        { word: "応援", reading: "おうえん", meaning: "aid, assistance, help" },
        { word: "応急", reading: "おうきゅう", meaning: "emergency fix, tentative measure, temporary solution" },
        { word: "応酬", reading: "おうしゅう", meaning: "exchange (of words, views, punches, cups, etc.), give-and-take" }
    ],
    },
    "往": {
        onyomi: ["オウ"],
        kunyomi: ["い.く", "いにしえ", "さき.に", "ゆ.く"],
        examples: [
        { word: "往診", reading: "おうしん", meaning: "doctor's visit, house call" },
        { word: "往生", reading: "おうじょう", meaning: "passing on to the next life" },
        { word: "往年", reading: "おうねん", meaning: "years gone by, earlier years, former years" },
        { word: "往復", reading: "おうふく", meaning: "making a round trip, going and returning, coming and going" }
    ],
    },
    "押": {
        onyomi: ["オウ"],
        kunyomi: ["お.す", "お.し-", "お.っ-", "お.さえる", "おさ.える"],
        examples: [
        { word: "押し", reading: "おし", meaning: "push, pushing" },
        { word: "押す", reading: "おす", meaning: "to push, to thrust, to shove" },
        { word: "押収", reading: "おうしゅう", meaning: "seizure, confiscation" },
        { word: "押入", reading: "おしいれ", meaning: "closet (built into the wall, usu. with sliding doors), (built-in) wardrobe" }
    ],
    },
    "旺": {
        onyomi: ["オウ"],
        kunyomi: ["さかん"],
        examples: [
        { word: "旺盛", reading: "おうせい", meaning: "lively, vigorous, energetic" }
    ],
    },
    "欧": {
        onyomi: ["オウ"],
        kunyomi: ["うた.う", "は.く"],
        examples: [
        { word: "欧州", reading: "おうしゅう", meaning: "Europe" },
        { word: "西欧", reading: "せいおう", meaning: "Western Europe" },
        { word: "中欧", reading: "ちゅうおう", meaning: "Central Europe" },
        { word: "東欧", reading: "とうおう", meaning: "Eastern Europe" }
    ],
    },
    "殴": {
        onyomi: ["オウ"],
        kunyomi: ["なぐ.る"],
        examples: [
        { word: "殴る", reading: "なぐる", meaning: "to strike, to hit, to beat" },
        { word: "殴打", reading: "おうだ", meaning: "hit, strike, blow" },
        { word: "殴り込み", reading: "なぐりこみ", meaning: "raid, attack, assault" }
    ],
    },
    "桜": {
        onyomi: ["オウ", "ヨウ"],
        kunyomi: ["さくら"],
        examples: [
        { word: "桜花", reading: "おうか", meaning: "cherry blossom" },
        { word: "八重桜", reading: "やえざくら", meaning: "double-flowered cherry tree, double cherry blossoms" },
        { word: "桜", reading: "さくら", meaning: "cherry tree, cherry blossom, sakura" }
    ],
    },
    "翁": {
        onyomi: ["オウ"],
        kunyomi: ["おきな"],
        examples: [
        { word: "翁", reading: "おきな", meaning: "old man, venerable gentleman" }
    ],
    },
    "奥": {
        onyomi: ["オウ"],
        kunyomi: ["おく", "おく.まる", "くま"],
        examples: [
        { word: "奥行", reading: "おくゆき", meaning: "depth, length" },
        { word: "奥山", reading: "おくやま", meaning: "remote mountain, mountain recesses" },
        { word: "奥様", reading: "おくさま", meaning: "wife, your wife, his wife" },
        { word: "山奥", reading: "やまおく", meaning: "deep in the mountains, mountain recesses" }
    ],
    },
    "横": {
        onyomi: ["オウ"],
        kunyomi: ["よこ"],
        examples: [
        { word: "横顔", reading: "よこがお", meaning: "profile, face in profile, face seen from the side" },
        { word: "横綱", reading: "よこづな", meaning: "yokozuna (highest rank in sumo), grand champion" },
        { word: "横行", reading: "おうこう", meaning: "being rampant, being widespread, being prevalent" },
        { word: "横線", reading: "おうせん", meaning: "horizontal line" }
    ],
    },
    "岡": {
        onyomi: ["コウ"],
        kunyomi: ["おか"],
        examples: [
        { word: "福岡", reading: "ふくおか", meaning: "Fukuoka (city, prefecture)" },
        { word: "静岡", reading: "しずおか", meaning: "Shizuoka (city, prefecture)" }
    ],
    },
    "屋": {
        onyomi: ["オク"],
        kunyomi: ["や"],
        examples: [
        { word: "屋外", reading: "おくがい", meaning: "outdoors, outside" },
        { word: "屋根", reading: "やね", meaning: "roof" },
        { word: "屋上", reading: "おくじょう", meaning: "rooftop" },
        { word: "屋台", reading: "やたい", meaning: "cart (esp. a food cart), stall, stand" }
    ],
    },
    "億": {
        onyomi: ["オク"],
        kunyomi: [],
        examples: [
        { word: "一億", reading: "いちおく", meaning: "100,000,000, one hundred million, 10^8" },
        { word: "十億", reading: "じゅうおく", meaning: "1,000,000,000, billion" },
        { word: "百億", reading: "ひゃくおく", meaning: "10,000,000,000, ten billion" },
        { word: "数億年", reading: "すうおくねん", meaning: "several hundred million years" }
    ],
    },
    "憶": {
        onyomi: ["オク"],
        kunyomi: [],
        examples: [
        { word: "記憶", reading: "きおく", meaning: "memory, recollection, remembrance" },
        { word: "憶測", reading: "おくそく", meaning: "guess, speculation, supposition" }
    ],
    },
    "臆": {
        onyomi: ["オク", "ヨク"],
        kunyomi: ["むね", "おくする"],
        examples: [
        { word: "臆病", reading: "おくびょう", meaning: "cowardly, timid, easily frightened" },
        { word: "臆病者", reading: "おくびょうもの", meaning: "coward, wimp" }
    ],
    },
    "虞": {
        onyomi: ["グ"],
        kunyomi: ["おそれ", "おもんぱか.る", "はか.る", "うれ.える", "あざむ.く", "あやま.る", "のぞ.む", "たの.しむ"],
        examples: [
        { word: "虞れ", reading: "おそれ", meaning: "fear, horror, anxiety" },
        { word: "不虞", reading: "ふぐ", meaning: "unforeseen (occurrence), unexpected (event), accident" },
        { word: "危虞", reading: "きぐ", meaning: "apprehension, misgivings, uneasiness" },
        { word: "憂虞", reading: "ゆうぐ", meaning: "anxiety, fear" }
    ],
    },
    "乙": {
        onyomi: ["オツ", "イツ"],
        kunyomi: ["おと-", "きのと"],
        examples: [
        { word: "甲乙", reading: "こうおつ", meaning: "first and second, A and B" },
        { word: "早乙女", reading: "さおとめ", meaning: "young female rice planter, young girl" },
        { word: "乙", reading: "おつ", meaning: "(the) second (party, rank, etc.), B (grade), the latter" }
    ],
    },
    "俺": {
        onyomi: ["エン"],
        kunyomi: ["おれ", "われ"],
        examples: [
        { word: "俺", reading: "おれ", meaning: "I, me" }
    ],
    },
    "卸": {
        onyomi: ["シャ"],
        kunyomi: ["おろ.す", "おろし", "おろ.し"],
        examples: [
        { word: "卸す", reading: "おろす", meaning: "to sell wholesale" },
        { word: "卸売", reading: "おろしうり", meaning: "wholesale, wholesaling" },
        { word: "卸値", reading: "おろしね", meaning: "wholesale price" },
        { word: "卸売り", reading: "おろしうり", meaning: "wholesale, wholesaling" }
    ],
    },
    "音": {
        onyomi: ["オン", "イン", "-ノン"],
        kunyomi: ["おと", "ね"],
        examples: [
        { word: "音階", reading: "おんかい", meaning: "scale" },
        { word: "音楽", reading: "おんがく", meaning: "music" },
        { word: "音響", reading: "おんきょう", meaning: "sound, noise, audio" },
        { word: "音訓", reading: "おんくん", meaning: "kanji readings" }
    ],
    },
    "恩": {
        onyomi: ["オン"],
        kunyomi: [],
        examples: [
        { word: "恩給", reading: "おんきゅう", meaning: "pension (esp. public servant's)" },
        { word: "恩恵", reading: "おんけい", meaning: "grace, favor, favour" },
        { word: "恩師", reading: "おんし", meaning: "teacher (to whom one owes a debt of gratitude), mentor, one's former teacher" },
        { word: "恩賜", reading: "おんし", meaning: "Imperial gift" }
    ],
    },
    "温": {
        onyomi: ["オン"],
        kunyomi: ["あたた.か", "あたた.かい", "あたた.まる", "あたた.める", "ぬく"],
        examples: [
        { word: "温い", reading: "ぬるい", meaning: "lukewarm, tepid" },
        { word: "温厚", reading: "おんこう", meaning: "gentle, mild-mannered" },
        { word: "温室", reading: "おんしつ", meaning: "greenhouse, hothouse, conservatory" },
        { word: "温床", reading: "おんしょう", meaning: "hotbed, breeding ground" }
    ],
    },
    "穏": {
        onyomi: ["オン"],
        kunyomi: ["おだ.やか"],
        examples: [
        { word: "穏健", reading: "おんけん", meaning: "moderate (view, politics, etc.), temperate, sensible" },
        { word: "穏当", reading: "おんとう", meaning: "proper, reasonable, right" },
        { word: "穏便", reading: "おんびん", meaning: "gentle, peaceable, amicable" },
        { word: "不穏", reading: "ふおん", meaning: "disquieting, threatening, turbulent" }
    ],
    },
    "下": {
        onyomi: ["カ", "ゲ"],
        kunyomi: ["した", "しも", "もと", "さ.げる", "さ.がる", "くだ.る", "くだ.り", "くだ.す", "-くだ.す", "くだ.さる", "お.ろす", "お.りる"],
        examples: [
        { word: "以下", reading: "いか", meaning: "not exceeding ..., not more than ..., ... and under" },
        { word: "右下", reading: "みぎした", meaning: "lower right" },
        { word: "下す", reading: "くだす", meaning: "to make a decision, to draw a conclusion" },
        { word: "下り", reading: "くだり", meaning: "down-train, train heading toward the ending point of its route" }
    ],
    },
    "化": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["ば.ける", "ば.かす", "ふ.ける", "け.する"],
        examples: [
        { word: "悪化", reading: "あっか", meaning: "deterioration, getting worse, worsening" },
        { word: "液化", reading: "えきか", meaning: "liquefaction" },
        { word: "塩化", reading: "えんか", meaning: "chloridation, salification" },
        { word: "化学", reading: "かがく", meaning: "chemistry" }
    ],
    },
    "火": {
        onyomi: ["カ"],
        kunyomi: ["ひ", "-び", "ほ-"],
        examples: [
        { word: "下火", reading: "したび", meaning: "dying down (of a fire), waning" },
        { word: "火花", reading: "ひばな", meaning: "spark" },
        { word: "火器", reading: "かき", meaning: "firearms, guns" },
        { word: "火災", reading: "かさい", meaning: "conflagration, fire" }
    ],
    },
    "加": {
        onyomi: ["カ"],
        kunyomi: ["くわ.える", "くわ.わる"],
        examples: [
        { word: "加圧", reading: "かあつ", meaning: "pressurization, applying pressure (to)" },
        { word: "加減", reading: "かげん", meaning: "degree, extent, amount" },
        { word: "加工", reading: "かこう", meaning: "manufacturing, processing, treatment" },
        { word: "加算", reading: "かさん", meaning: "addition, adding, supplement" }
    ],
    },
    "可": {
        onyomi: ["カ", "コク"],
        kunyomi: ["-べ.き", "-べ.し"],
        examples: [
        { word: "可決", reading: "かけつ", meaning: "approval, adoption (of a motion, bill, etc.), passage" },
        { word: "可能", reading: "かのう", meaning: "possible, potential, practicable" },
        { word: "可否", reading: "かひ", meaning: "propriety, right and wrong, advisability" },
        { word: "可憐", reading: "かれん", meaning: "sweet (e.g. young girls, flowers blooming), touchingly lovely, cute" }
    ],
    },
    "仮": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["かり", "かり-"],
        examples: [
        { word: "仮に", reading: "かりに", meaning: "supposing, even if, granting that" },
        { word: "仮称", reading: "かしょう", meaning: "temporary name, provisional name" },
        { word: "仮想", reading: "かそう", meaning: "imagination, supposition, virtual" },
        { word: "仮装", reading: "かそう", meaning: "costume, fancy dress, masquerade" }
    ],
    },
    "何": {
        onyomi: ["カ"],
        kunyomi: ["なに", "なん", "なに-", "なん-"],
        examples: [
        { word: "何か", reading: "なにか", meaning: "something, some, any" },
        { word: "何て", reading: "なんて", meaning: "how ...!, what ...!" },
        { word: "何と", reading: "なんと", meaning: "what, how" },
        { word: "何も", reading: "なにも", meaning: "(not) anything, (nothing) at all, (not) any" }
    ],
    },
    "花": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["はな"],
        examples: [
        { word: "火花", reading: "ひばな", meaning: "spark" },
        { word: "花弁", reading: "はなびら", meaning: "petal" },
        { word: "花屋", reading: "はなや", meaning: "florist, flower shop" },
        { word: "花嫁", reading: "はなよめ", meaning: "bride" }
    ],
    },
    "佳": {
        onyomi: ["カ"],
        kunyomi: [],
        examples: [
        { word: "佳境", reading: "かきょう", meaning: "most interesting part (of a story), climax, good part" },
        { word: "佳作", reading: "かさく", meaning: "fine (piece of) work, excellent work" }
    ],
    },
    "価": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["あたい"],
        examples: [
        { word: "安価", reading: "あんか", meaning: "low-priced, cheap, inexpensive" },
        { word: "価格", reading: "かかく", meaning: "price, value, cost" },
        { word: "価値", reading: "かち", meaning: "value, worth, merit" },
        { word: "株価", reading: "かぶか", meaning: "stock prices" }
    ],
    },
    "果": {
        onyomi: ["カ"],
        kunyomi: ["は.たす", "はた.す", "-は.たす", "は.てる", "-は.てる", "は.て"],
        examples: [
        { word: "因果", reading: "いんが", meaning: "cause and effect, causality" },
        { word: "果て", reading: "はて", meaning: "end, extremity, limit" },
        { word: "果敢", reading: "かかん", meaning: "resolute, determined, bold" },
        { word: "果実", reading: "かじつ", meaning: "fruit, nut, berry" }
    ],
    },
    "河": {
        onyomi: ["カ"],
        kunyomi: ["かわ"],
        examples: [
        { word: "運河", reading: "うんが", meaning: "(navigable) canal, waterway" },
        { word: "河川", reading: "かせん", meaning: "rivers" },
        { word: "河畔", reading: "かはん", meaning: "riverside" },
        { word: "銀河", reading: "ぎんが", meaning: "Milky Way" }
    ],
    },
    "苛": {
        onyomi: ["カ"],
        kunyomi: ["いじ.める", "さいな.む", "いらだ.つ", "からい", "こまかい"],
        examples: [
        { word: "苛々", reading: "いらいら", meaning: "to get irritated, to get annoyed, to be on the edge" },
        { word: "苛め", reading: "いじめ", meaning: "bullying, teasing" },
        { word: "苛める", reading: "いじめる", meaning: "to ill-treat, to bully, to torment" }
    ],
    },
    "科": {
        onyomi: ["カ"],
        kunyomi: [],
        examples: [
        { word: "医科", reading: "いか", meaning: "medical science, medical department" },
        { word: "科学", reading: "かがく", meaning: "science" },
        { word: "外科", reading: "げか", meaning: "surgery (branch of medicine)" },
        { word: "学科", reading: "がっか", meaning: "subject (of study), course of study" }
    ],
    },
    "架": {
        onyomi: ["カ"],
        kunyomi: ["か.ける", "か.かる"],
        examples: [
        { word: "架空", reading: "かくう", meaning: "fictitious, imaginary, fanciful" },
        { word: "架設", reading: "かせつ", meaning: "construction, building" },
        { word: "高架", reading: "こうか", meaning: "elevated (structure), overhead" },
        { word: "書架", reading: "しょか", meaning: "bookshelf, bookcase" }
    ],
    },
    "夏": {
        onyomi: ["カ", "ガ", "ゲ"],
        kunyomi: ["なつ"],
        examples: [
        { word: "夏至", reading: "げし", meaning: "summer solstice" },
        { word: "夏場", reading: "なつば", meaning: "summertime, summer season" },
        { word: "夏物", reading: "なつもの", meaning: "summer clothing, summer wear" },
        { word: "今夏", reading: "こんか", meaning: "this summer, next summer, last summer" }
    ],
    },
    "家": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["いえ", "や", "うち"],
        examples: [
        { word: "家屋", reading: "かおく", meaning: "house, building" },
        { word: "家業", reading: "かぎょう", meaning: "family business, family trade" },
        { word: "家具", reading: "かぐ", meaning: "furniture" },
        { word: "家系", reading: "かけい", meaning: "family lineage" }
    ],
    },
    "荷": {
        onyomi: ["カ"],
        kunyomi: ["に"],
        examples: [
        { word: "荷札", reading: "にふだ", meaning: "label, tag" },
        { word: "荷台", reading: "にだい", meaning: "(truck) load-carrying tray, (bicycle) luggage carrier, roof rack" },
        { word: "荷物", reading: "にもつ", meaning: "luggage, baggage, package" },
        { word: "集荷", reading: "しゅうか", meaning: "collection of cargo (esp. produce, etc.), cargo booking" }
    ],
    },
    "華": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["はな"],
        examples: [
        { word: "華僑", reading: "かきょう", meaning: "overseas Chinese" },
        { word: "華美", reading: "かび", meaning: "splendor, splendour, gorgeousness" },
        { word: "華麗", reading: "かれい", meaning: "splendid, magnificent, gorgeous" },
        { word: "豪華", reading: "ごうか", meaning: "extravagant, lavish, opulent" }
    ],
    },
    "菓": {
        onyomi: ["カ"],
        kunyomi: [],
        examples: [
        { word: "菓子", reading: "かし", meaning: "confectionery, sweets, candy" },
        { word: "お菓子", reading: "おかし", meaning: "confections, sweets, candy" },
        { word: "菓子屋", reading: "かしや", meaning: "confectionery shop, candy store, sweet shop" },
        { word: "駄菓子", reading: "だがし", meaning: "penny candy, cheap individually wrapped sweets" }
    ],
    },
    "貨": {
        onyomi: ["カ"],
        kunyomi: ["たから"],
        examples: [
        { word: "貨車", reading: "かしゃ", meaning: "freight car, van" },
        { word: "貨物", reading: "かもつ", meaning: "cargo, freight" },
        { word: "貨幣", reading: "かへい", meaning: "money, currency, coin" },
        { word: "外貨", reading: "がいか", meaning: "foreign currency, foreign money, foreign exchange" }
    ],
    },
    "渦": {
        onyomi: ["カ"],
        kunyomi: ["うず"],
        examples: [
        { word: "渦中", reading: "かちゅう", meaning: "vortex, maelstrom, whirlpool" },
        { word: "渦巻き", reading: "うずまき", meaning: "whirlpool, maelstrom, vortex" },
        { word: "渦", reading: "うず", meaning: "whirlpool, swirl, eddy" }
    ],
    },
    "過": {
        onyomi: ["カ"],
        kunyomi: ["す.ぎる", "す.ごす", "あやま.ち", "あやま.つ", "よぎ.る", "よ.ぎる"],
        examples: [
        { word: "一過", reading: "いっか", meaning: "passing (e.g. of a typhoon), going past" },
        { word: "過ぎ", reading: "すぎ", meaning: "past, after" },
        { word: "過ち", reading: "あやまち", meaning: "fault, error, indiscretion" },
        { word: "過去", reading: "かこ", meaning: "the past, bygone days" }
    ],
    },
    "嫁": {
        onyomi: ["カ"],
        kunyomi: ["よめ", "とつ.ぐ", "い.く", "ゆ.く"],
        examples: [
        { word: "嫁ぐ", reading: "とつぐ", meaning: "to marry (of a woman), to become a bride, to marry into (a family)" },
        { word: "花嫁", reading: "はなよめ", meaning: "bride" },
        { word: "転嫁", reading: "てんか", meaning: "imputation, shifting (blame, responsibility, etc.), passing the buck" },
        { word: "嫁入り", reading: "よめいり", meaning: "marriage (of a woman), marrying into a husband's family, becoming a bride" }
    ],
    },
    "暇": {
        onyomi: ["カ"],
        kunyomi: ["ひま", "いとま"],
        examples: [
        { word: "休暇", reading: "きゅうか", meaning: "holiday, vacation, day off" },
        { word: "寸暇", reading: "すんか", meaning: "moment's leisure, free minute" },
        { word: "余暇", reading: "よか", meaning: "leisure, leisure time, spare time" },
        { word: "暇潰し", reading: "ひまつぶし", meaning: "killing time, keeping oneself occupied, time killer" }
    ],
    },
    "禍": {
        onyomi: ["カ"],
        kunyomi: ["わざわい"],
        examples: [
        { word: "禍根", reading: "かこん", meaning: "root of an evil, source of a problem, source of trouble" },
        { word: "戦禍", reading: "せんか", meaning: "war damage, ravages of war, horrors of war" },
        { word: "コロナ禍", reading: "コロナか", meaning: "COVID-19 pandemic, coronavirus crisis, COVID-19 crisis" }
    ],
    },
    "靴": {
        onyomi: ["カ"],
        kunyomi: ["くつ"],
        examples: [
        { word: "革靴", reading: "かわぐつ", meaning: "leather shoes, leather boots" },
        { word: "靴屋", reading: "くつや", meaning: "shoe store, shoe shop, shoemaker" },
        { word: "靴下", reading: "くつした", meaning: "socks, sock, stockings" },
        { word: "靴", reading: "くつ", meaning: "shoe, shoes, boots" }
    ],
    },
    "寡": {
        onyomi: ["カ"],
        kunyomi: [],
        examples: [
        { word: "寡占", reading: "かせん", meaning: "oligopoly, control of a market" },
        { word: "寡黙", reading: "かもく", meaning: "untalkative, quiet, taciturn" },
        { word: "多寡", reading: "たか", meaning: "degree (of something), greatness or smallness (of something), quantity" },
        { word: "寡婦", reading: "かふ", meaning: "widow, divorced woman not remarried, unmarried woman" }
    ],
    },
    "歌": {
        onyomi: ["カ"],
        kunyomi: ["うた", "うた.う"],
        examples: [
        { word: "演歌", reading: "えんか", meaning: "enka, traditional-style Japanese popular ballad" },
        { word: "歌曲", reading: "かきょく", meaning: "melody, tune, song" },
        { word: "歌劇", reading: "かげき", meaning: "opera" },
        { word: "歌詞", reading: "かし", meaning: "song lyrics, words of a song, libretto" }
    ],
    },
    "箇": {
        onyomi: ["カ", "コ"],
        kunyomi: [],
        examples: [
        { word: "箇所", reading: "かしょ", meaning: "place, point, part" }
    ],
    },
    "稼": {
        onyomi: ["カ"],
        kunyomi: ["かせ.ぐ"],
        examples: [
        { word: "稼ぎ", reading: "かせぎ", meaning: "earnings" },
        { word: "稼ぐ", reading: "かせぐ", meaning: "to earn (income), to make (money)" },
        { word: "稼業", reading: "かぎょう", meaning: "trade, business, occupation" },
        { word: "稼働", reading: "かどう", meaning: "operation (of a machine), running" }
    ],
    },
    "課": {
        onyomi: ["カ"],
        kunyomi: [],
        examples: [
        { word: "課員", reading: "かいん", meaning: "section staff" },
        { word: "課税", reading: "かぜい", meaning: "taxation" },
        { word: "課題", reading: "かだい", meaning: "subject, theme, issue" },
        { word: "課長", reading: "かちょう", meaning: "section manager, section chief" }
    ],
    },
    "蚊": {
        onyomi: ["ブン"],
        kunyomi: ["か"],
        examples: [
        { word: "蚊帳", reading: "かや", meaning: "mosquito net" },
        { word: "蚊", reading: "か", meaning: "mosquito" }
    ],
    },
    "牙": {
        onyomi: ["ガ", "ゲ"],
        kunyomi: ["きば", "は"],
        examples: [
        { word: "象牙", reading: "ぞうげ", meaning: "ivory" }
    ],
    },
    "瓦": {
        onyomi: ["ガ"],
        kunyomi: ["かわら", "ぐらむ"],
        examples: [
        { word: "瓦礫", reading: "がれき", meaning: "rubble, debris, wreckage" },
        { word: "煉瓦", reading: "れんが", meaning: "brick" },
        { word: "瓦", reading: "かわら", meaning: "tile (e.g. roof)" }
    ],
    },
    "我": {
        onyomi: ["ガ"],
        kunyomi: ["われ", "わ", "わ.が-", "わが-"],
        examples: [
        { word: "我慢", reading: "がまん", meaning: "endurance, patience, perseverance" },
        { word: "我儘", reading: "わがまま", meaning: "selfish, egoist" },
        { word: "怪我", reading: "けが", meaning: "injury, wound" },
        { word: "自我", reading: "じが", meaning: "ego" }
    ],
    },
    "画": {
        onyomi: ["ガ", "カク", "エ", "カイ"],
        kunyomi: ["えが.く", "かく.する", "かぎ.る", "はかりごと", "はか.る"],
        examples: [
        { word: "映画", reading: "えいが", meaning: "movie, film, motion picture" },
        { word: "画家", reading: "がか", meaning: "painter, artist" },
        { word: "画商", reading: "がしょう", meaning: "picture dealer, commercial art gallery" },
        { word: "画数", reading: "かくすう", meaning: "stroke count (of a kanji)" }
    ],
    },
    "芽": {
        onyomi: ["ガ"],
        kunyomi: ["め"],
        examples: [
        { word: "新芽", reading: "しんめ", meaning: "sprout, bud, shoot" },
        { word: "麦芽", reading: "ばくが", meaning: "malt" },
        { word: "発芽", reading: "はつが", meaning: "germination, sprouting, budding" },
        { word: "萌芽", reading: "ほうが", meaning: "germination, germ, sprout" }
    ],
    },
    "賀": {
        onyomi: ["ガ"],
        kunyomi: [],
        examples: [
        { word: "賀状", reading: "がじょう", meaning: "New Year's card" },
        { word: "賀正", reading: "がしょう", meaning: "A Happy New Year!" },
        { word: "祝賀", reading: "しゅくが", meaning: "celebration, congratulations" },
        { word: "年賀", reading: "ねんが", meaning: "New Year's greetings, New Year's call, New Year's gift" }
    ],
    },
    "雅": {
        onyomi: ["ガ"],
        kunyomi: ["みや.び"],
        examples: [
        { word: "雅楽", reading: "ががく", meaning: "gagaku, ceremonial Japanese court music" },
        { word: "雅致", reading: "がち", meaning: "artistry, good taste, elegance" },
        { word: "優雅", reading: "ゆうが", meaning: "elegant, graceful, refined" }
    ],
    },
    "餓": {
        onyomi: ["ガ"],
        kunyomi: ["う.える"],
        examples: [
        { word: "飢餓", reading: "きが", meaning: "starvation, famine, hunger" },
        { word: "餓死", reading: "がし", meaning: "(death from) starvation, starving to death" }
    ],
    },
    "介": {
        onyomi: ["カイ"],
        kunyomi: [],
        examples: [
        { word: "介護", reading: "かいご", meaning: "nursing, care, caregiving" },
        { word: "介在", reading: "かいざい", meaning: "existing (between), interposition, intervention" },
        { word: "介入", reading: "かいにゅう", meaning: "intervention" },
        { word: "魚介", reading: "ぎょかい", meaning: "marine products, seafood, fish and shellfish" }
    ],
    },
    "回": {
        onyomi: ["カイ", "エ"],
        kunyomi: ["まわ.る", "-まわ.る", "-まわ.り", "まわ.す", "-まわ.す", "まわ.し-", "-まわ.し", "もとお.る", "か.える"],
        examples: [
        { word: "一回", reading: "いっかい", meaning: "once, one time, one round" },
        { word: "何回", reading: "なんかい", meaning: "how many times" },
        { word: "回し", reading: "まわし", meaning: "mawashi, belt, loincloth" },
        { word: "回す", reading: "まわす", meaning: "to turn, to rotate, to spin" }
    ],
    },
    "灰": {
        onyomi: ["カイ"],
        kunyomi: ["はい"],
        examples: [
        { word: "灰皿", reading: "はいざら", meaning: "ashtray" },
        { word: "灰色", reading: "はいいろ", meaning: "grey, gray, ashen" },
        { word: "石灰", reading: "せっかい", meaning: "lime, quicklime, caustic lime" },
        { word: "火山灰", reading: "かざんばい", meaning: "volcanic ash" }
    ],
    },
    "会": {
        onyomi: ["カイ", "エ"],
        kunyomi: ["あ.う", "あ.わせる", "あつ.まる"],
        examples: [
        { word: "宴会", reading: "えんかい", meaning: "party, banquet, reception" },
        { word: "会う", reading: "あう", meaning: "to meet, to encounter, to see" },
        { word: "会員", reading: "かいいん", meaning: "member, the membership" },
        { word: "会期", reading: "かいき", meaning: "session (of a legislature)" }
    ],
    },
    "快": {
        onyomi: ["カイ"],
        kunyomi: ["こころよ.い"],
        examples: [
        { word: "快い", reading: "こころよい", meaning: "pleasant, agreeable, comfortable" },
        { word: "快楽", reading: "かいらく", meaning: "pleasure" },
        { word: "快活", reading: "かいかつ", meaning: "cheerful, lively, lighthearted" },
        { word: "快感", reading: "かいかん", meaning: "pleasant feeling, pleasant sensation, pleasure" }
    ],
    },
    "戒": {
        onyomi: ["カイ"],
        kunyomi: ["いまし.める"],
        examples: [
        { word: "戒告", reading: "かいこく", meaning: "admonition, warning, caution" },
        { word: "戒律", reading: "かいりつ", meaning: "(religious) precept, discipline, commandment" },
        { word: "訓戒", reading: "くんかい", meaning: "warning, admonition, lesson or a phrase that teaches you not to do something" },
        { word: "警戒", reading: "けいかい", meaning: "vigilance, caution, alertness" }
    ],
    },
    "改": {
        onyomi: ["カイ"],
        kunyomi: ["あらた.める", "あらた.まる"],
        examples: [
        { word: "改革", reading: "かいかく", meaning: "reform, reformation, reorganization" },
        { word: "改憲", reading: "かいけん", meaning: "constitutional change, revising the constitution" },
        { word: "改札", reading: "かいさつ", meaning: "examination of tickets" },
        { word: "改宗", reading: "かいしゅう", meaning: "religious conversion" }
    ],
    },
    "怪": {
        onyomi: ["カイ", "ケ"],
        kunyomi: ["あや.しい", "あや.しむ"],
        examples: [
        { word: "怪我", reading: "けが", meaning: "injury, wound" },
        { word: "怪奇", reading: "かいき", meaning: "bizarre, strange, weird" },
        { word: "怪獣", reading: "かいじゅう", meaning: "monster" },
        { word: "怪談", reading: "かいだん", meaning: "ghost story, tale of the supernatural" }
    ],
    },
    "拐": {
        onyomi: ["カイ"],
        kunyomi: [],
        examples: [
        { word: "誘拐", reading: "ゆうかい", meaning: "abduction, kidnapping, kidnaping" }
    ],
    },
    "悔": {
        onyomi: ["カイ"],
        kunyomi: ["く.いる", "く.やむ", "くや.しい"],
        examples: [
        { word: "悔い", reading: "くい", meaning: "regret, repentance" },
        { word: "後悔", reading: "こうかい", meaning: "regret, repentance, remorse" },
        { word: "悔いる", reading: "くいる", meaning: "to regret" },
        { word: "悔やむ", reading: "くやむ", meaning: "to mourn, to lament" }
    ],
    },
    "海": {
        onyomi: ["カイ"],
        kunyomi: ["うみ"],
        examples: [
        { word: "沿海", reading: "えんかい", meaning: "sea along the coast, coastal waters, inshore waters" },
        { word: "海域", reading: "かいいき", meaning: "area of sea, waters" },
        { word: "海運", reading: "かいうん", meaning: "maritime transport, shipping" },
        { word: "海外", reading: "かいがい", meaning: "foreign, abroad, overseas" }
    ],
    },
    "界": {
        onyomi: ["カイ"],
        kunyomi: [],
        examples: [
        { word: "下界", reading: "げかい", meaning: "the earth below, the ground below" },
        { word: "界隈", reading: "かいわい", meaning: "neighborhood, neighbourhood, vicinity" },
        { word: "学界", reading: "がっかい", meaning: "academic world, academia, academic circles" },
        { word: "官界", reading: "かんかい", meaning: "bureaucratic world, government circles" }
    ],
    },
    "皆": {
        onyomi: ["カイ"],
        kunyomi: ["みな", "みんな"],
        examples: [
        { word: "皆無", reading: "かいむ", meaning: "nonexistent, nil, none" },
        { word: "皆目", reading: "かいもく", meaning: "entirely, (not) at all" },
        { word: "皆様", reading: "みなさま", meaning: "everyone" },
        { word: "皆さん", reading: "みなさん", meaning: "all, everyone, everybody" }
    ],
    },
    "械": {
        onyomi: ["カイ"],
        kunyomi: ["かせ"],
        examples: [
        { word: "機械", reading: "きかい", meaning: "machine, mechanism" },
        { word: "器械", reading: "きかい", meaning: "machine, mechanism" },
        { word: "機械化", reading: "きかいか", meaning: "mechanization, mechanisation" },
        { word: "工作機械", reading: "こうさくきかい", meaning: "machine tool" }
    ],
    },
    "絵": {
        onyomi: ["カイ", "エ"],
        kunyomi: [],
        examples: [
        { word: "影絵", reading: "かげえ", meaning: "shadow picture, silhouette, shadowgraph" },
        { word: "絵画", reading: "かいが", meaning: "painting, picture" },
        { word: "絵巻", reading: "えまき", meaning: "picture scroll" },
        { word: "絵本", reading: "えほん", meaning: "picture book" }
    ],
    },
    "開": {
        onyomi: ["カイ"],
        kunyomi: ["ひら.く", "ひら.き", "-びら.き", "ひら.ける", "あ.く", "あ.ける"],
        examples: [
        { word: "開く", reading: "ひらく", meaning: "to open, to undo, to unseal" },
        { word: "開演", reading: "かいえん", meaning: "curtain raising, starting (e.g. play, concert)" },
        { word: "開花", reading: "かいか", meaning: "flowering, blooming, blossoming" },
        { word: "開会", reading: "かいかい", meaning: "opening of a meeting" }
    ],
    },
    "階": {
        onyomi: ["カイ"],
        kunyomi: ["きざはし"],
        examples: [
        { word: "一階", reading: "いっかい", meaning: "first floor, ground floor" },
        { word: "１階", reading: "いっかい", meaning: "first floor, ground floor" },
        { word: "音階", reading: "おんかい", meaning: "scale" },
        { word: "階級", reading: "かいきゅう", meaning: "(social) class" }
    ],
    },
    "塊": {
        onyomi: ["カイ", "ケ"],
        kunyomi: ["かたまり", "つちくれ"],
        examples: [
        { word: "金塊", reading: "きんかい", meaning: "gold nugget, gold bullion, gold bar" },
        { word: "団塊", reading: "だんかい", meaning: "mass, lump, clod" },
        { word: "塊", reading: "かたまり", meaning: "lump, mass, bundle" }
    ],
    },
    "楷": {
        onyomi: ["カイ"],
        kunyomi: [],
        examples: [
        { word: "楷書", reading: "かいしょ", meaning: "printed style (of writing Chinese characters), square style, block style" }
    ],
    },
    "解": {
        onyomi: ["カイ", "ゲ"],
        kunyomi: ["と.く", "と.かす", "と.ける", "ほど.く", "ほぐ.す", "わか.る", "さと.る"],
        examples: [
        { word: "解く", reading: "とく", meaning: "to untie, to unfasten, to unwrap" },
        { word: "解禁", reading: "かいきん", meaning: "lifting a ban, raising an embargo, opening a season (hunting, fishing, etc.)" },
        { word: "解決", reading: "かいけつ", meaning: "settlement, solution, resolution" },
        { word: "解雇", reading: "かいこ", meaning: "dismissal (of an employee), discharge, firing" }
    ],
    },
    "潰": {
        onyomi: ["カイ", "エ"],
        kunyomi: ["つぶ.す", "つぶ.れる", "つい.える"],
        examples: [
        { word: "潰す", reading: "つぶす", meaning: "to smash, to crush, to flatten" },
        { word: "暇潰し", reading: "ひまつぶし", meaning: "killing time, keeping oneself occupied, time killer" },
        { word: "潰れる", reading: "つぶれる", meaning: "to be crushed, to be squashed, to be smashed" },
        { word: "顔を潰す", reading: "かおをつぶす", meaning: "to make someone lose face, to embarrass someone, to make someone look foolish" }
    ],
    },
    "壊": {
        onyomi: ["カイ", "エ"],
        kunyomi: ["こわ.す", "こわ.れる", "やぶ.る"],
        examples: [
        { word: "壊す", reading: "こわす", meaning: "to break, to destroy, to demolish" },
        { word: "壊滅", reading: "かいめつ", meaning: "(complete) destruction, annihilation, devastation" },
        { word: "破壊", reading: "はかい", meaning: "destruction, disruption" },
        { word: "崩壊", reading: "ほうかい", meaning: "collapse, crumbling, breaking down" }
    ],
    },
    "懐": {
        onyomi: ["カイ", "エ"],
        kunyomi: ["ふところ", "なつ.かしい", "なつ.かしむ", "なつ.く", "なつ.ける", "なず.ける", "いだ.く", "おも.う"],
        examples: [
        { word: "懐疑", reading: "かいぎ", meaning: "doubt, skepticism, scepticism" },
        { word: "懐柔", reading: "かいじゅう", meaning: "winning over, placation, gentle persuasion" },
        { word: "述懐", reading: "じゅっかい", meaning: "speaking about (one's thoughts, memories, etc.), relating (one's feelings, reminiscences, etc.), recollection" },
        { word: "懐かしい", reading: "なつかしい", meaning: "dear (old), fondly remembered, beloved" }
    ],
    },
    "諧": {
        onyomi: ["カイ"],
        kunyomi: ["かな.う", "やわ.らぐ"],
        examples: [
        { word: "俳諧", reading: "はいかい", meaning: "haikai (collective name for haiku, haibun, haiga, senryū, etc.)" },
        { word: "誹諧", reading: "はいかい", meaning: "haikai (collective name for haiku, haibun, haiga, senryū, etc.)" },
        { word: "諧声", reading: "かいせい", meaning: "vocal harmony, harmonious voice, harmonious voices" },
        { word: "諧調", reading: "かいちょう", meaning: "harmonious melody, harmony, unity" }
    ],
    },
    "貝": {
        onyomi: ["バイ"],
        kunyomi: ["かい"],
        examples: [
        { word: "貝殻", reading: "かいがら", meaning: "seashell, shell" },
        { word: "貝", reading: "かい", meaning: "shellfish" }
    ],
    },
    "外": {
        onyomi: ["ガイ", "ゲ"],
        kunyomi: ["そと", "ほか", "はず.す", "はず.れる", "と-"],
        examples: [
        { word: "案外", reading: "あんがい", meaning: "unexpectedly, surprisingly" },
        { word: "以外", reading: "いがい", meaning: "excluding, except (for), apart from" },
        { word: "意外", reading: "いがい", meaning: "unexpected, surprising, unanticipated" },
        { word: "域外", reading: "いきがい", meaning: "outside the area" }
    ],
    },
    "劾": {
        onyomi: ["ガイ"],
        kunyomi: [],
        examples: [
        { word: "弾劾", reading: "だんがい", meaning: "impeachment" }
    ],
    },
    "害": {
        onyomi: ["ガイ"],
        kunyomi: [],
        examples: [
        { word: "害虫", reading: "がいちゅう", meaning: "harmful insect, noxious insect, pest" },
        { word: "危害", reading: "きがい", meaning: "injury, harm, danger" },
        { word: "公害", reading: "こうがい", meaning: "pollution, public nuisance, contamination" },
        { word: "災害", reading: "さいがい", meaning: "calamity, disaster, misfortune" }
    ],
    },
    "崖": {
        onyomi: ["ガイ", "ゲ", "ギ"],
        kunyomi: ["がけ", "きし", "はて"],
        examples: [
        { word: "崖", reading: "がけ", meaning: "cliff, precipice" }
    ],
    },
    "涯": {
        onyomi: ["ガイ"],
        kunyomi: ["はて"],
        examples: [
        { word: "生涯", reading: "しょうがい", meaning: "life, lifetime, career" },
        { word: "生涯教育", reading: "しょうがいきょういく", meaning: "lifelong education, continuing education, further education" }
    ],
    },
    "街": {
        onyomi: ["ガイ", "カイ"],
        kunyomi: ["まち"],
        examples: [
        { word: "街角", reading: "まちかど", meaning: "street corner" },
        { word: "街灯", reading: "がいとう", meaning: "street light, streetlamp" },
        { word: "街頭", reading: "がいとう", meaning: "(on the) street" },
        { word: "街道", reading: "かいどう", meaning: "highway (esp. one existing from the Edo period), main road" }
    ],
    },
    "慨": {
        onyomi: ["ガイ"],
        kunyomi: ["なげ.く"],
        examples: [
        { word: "感慨", reading: "かんがい", meaning: "deep emotion, strong feelings" },
        { word: "憤慨", reading: "ふんがい", meaning: "indignation, resentment" },
        { word: "感慨無量", reading: "かんがいむりょう", meaning: "deep emotion, being filled with emotion" }
    ],
    },
    "蓋": {
        onyomi: ["ガイ", "カイ", "コウ"],
        kunyomi: ["ふた", "けだ.し", "おお.う", "かさ", "かこう"],
        examples: [
        { word: "蓋", reading: "ふた", meaning: "cover, lid, cap" }
    ],
    },
    "該": {
        onyomi: ["ガイ"],
        kunyomi: [],
        examples: [
        { word: "該当", reading: "がいとう", meaning: "corresponding to, being applicable to, being relevant to" }
    ],
    },
    "概": {
        onyomi: ["ガイ"],
        kunyomi: ["おおむ.ね"],
        examples: [
        { word: "概況", reading: "がいきょう", meaning: "outlook, general situation" },
        { word: "概算", reading: "がいさん", meaning: "approximation, rough estimate, ballpark figure" },
        { word: "概念", reading: "がいねん", meaning: "general idea, concept, notion" },
        { word: "概要", reading: "がいよう", meaning: "outline, summary, overview" }
    ],
    },
    "骸": {
        onyomi: ["ガイ", "カイ"],
        kunyomi: ["むくろ"],
        examples: [
        { word: "骸骨", reading: "がいこつ", meaning: "skeleton" },
        { word: "亡骸", reading: "なきがら", meaning: "remains, corpse, (dead) body" }
    ],
    },
    "垣": {
        onyomi: ["エン"],
        kunyomi: ["かき"],
        examples: [
        { word: "垣根", reading: "かきね", meaning: "hedge, fence" },
        { word: "石垣", reading: "いしがき", meaning: "stone wall" },
        { word: "生垣", reading: "いけがき", meaning: "hedge" },
        { word: "垣間見る", reading: "かいまみる", meaning: "to take a peep at, to catch a glimpse of" }
    ],
    },
    "柿": {
        onyomi: ["シ"],
        kunyomi: ["かき"],
        examples: [
        { word: "柿", reading: "かき", meaning: "kaki, Japanese persimmon (Diospyros kaki)" }
    ],
    },
    "各": {
        onyomi: ["カク"],
        kunyomi: ["おのおの"],
        examples: [
        { word: "各位", reading: "かくい", meaning: "everyone, each and every one (of you), ladies and gentlemen" },
        { word: "各国", reading: "かっこく", meaning: "each country, every country, various countries" },
        { word: "各自", reading: "かくじ", meaning: "each (person), everyone, individual" },
        { word: "各種", reading: "かくしゅ", meaning: "every kind, all sorts" }
    ],
    },
    "角": {
        onyomi: ["カク"],
        kunyomi: ["かど", "つの"],
        examples: [
        { word: "一角", reading: "いっかく", meaning: "corner, section, point" },
        { word: "鋭角", reading: "えいかく", meaning: "acute angle" },
        { word: "外角", reading: "がいかく", meaning: "external angle, exterior angle" },
        { word: "街角", reading: "まちかど", meaning: "street corner" }
    ],
    },
    "拡": {
        onyomi: ["カク", "コウ"],
        kunyomi: ["ひろ.がる", "ひろ.げる", "ひろ.める"],
        examples: [
        { word: "拡散", reading: "かくさん", meaning: "spreading, disseminating, scattering" },
        { word: "拡充", reading: "かくじゅう", meaning: "expansion" },
        { word: "拡大", reading: "かくだい", meaning: "expansion, extension" },
        { word: "拡張", reading: "かくちょう", meaning: "expansion, extension, enlargement" }
    ],
    },
    "革": {
        onyomi: ["カク"],
        kunyomi: ["かわ"],
        examples: [
        { word: "沿革", reading: "えんかく", meaning: "history, development" },
        { word: "改革", reading: "かいかく", meaning: "reform, reformation, reorganization" },
        { word: "革靴", reading: "かわぐつ", meaning: "leather shoes, leather boots" },
        { word: "革新", reading: "かくしん", meaning: "reform, innovation" }
    ],
    },
    "格": {
        onyomi: ["カク", "コウ", "キャク", "ゴウ"],
        kunyomi: [],
        examples: [
        { word: "価格", reading: "かかく", meaning: "price, value, cost" },
        { word: "格安", reading: "かくやす", meaning: "(very) cheap, (very) inexpensive, cut-price" },
        { word: "格差", reading: "かくさ", meaning: "qualitative difference, disparity, gap" },
        { word: "格子", reading: "こうし", meaning: "lattice, latticework, window bars" }
    ],
    },
    "核": {
        onyomi: ["カク"],
        kunyomi: [],
        examples: [
        { word: "核酸", reading: "かくさん", meaning: "nucleic acid" },
        { word: "核心", reading: "かくしん", meaning: "core, heart (of the matter), point" },
        { word: "結核", reading: "けっかく", meaning: "tuberculosis, TB" },
        { word: "中核", reading: "ちゅうかく", meaning: "kernel, core, nucleus" }
    ],
    },
    "殻": {
        onyomi: ["カク", "コク", "バイ"],
        kunyomi: ["から", "がら"],
        examples: [
        { word: "貝殻", reading: "かいがら", meaning: "seashell, shell" },
        { word: "地殻", reading: "ちかく", meaning: "(Earth's) crust" },
        { word: "吸い殻", reading: "すいがら", meaning: "cigarette end, cigarette butt" },
        { word: "地殻変動", reading: "ちかくへんどう", meaning: "diastrophism (movement and deformation of the earth's crust)" }
    ],
    },
    "郭": {
        onyomi: ["カク"],
        kunyomi: ["くるわ"],
        examples: [
        { word: "外郭", reading: "がいかく", meaning: "outer fence, outer enclosure, outer block" },
        { word: "城郭", reading: "じょうかく", meaning: "castle, citadel, fortress" },
        { word: "輪郭", reading: "りんかく", meaning: "contour, outline, silhouette" },
        { word: "外郭団体", reading: "がいかくだんたい", meaning: "auxiliary organization (organisation), extra-departmental body, fringe organization" }
    ],
    },
    "覚": {
        onyomi: ["カク"],
        kunyomi: ["おぼ.える", "さ.ます", "さ.める", "さと.る"],
        examples: [
        { word: "覚え", reading: "おぼえ", meaning: "memory, sense, experience" },
        { word: "覚悟", reading: "かくご", meaning: "readiness, (mental) preparedness" },
        { word: "感覚", reading: "かんかく", meaning: "sense, sensation, feeling" },
        { word: "幻覚", reading: "げんかく", meaning: "hallucination, illusion" }
    ],
    },
    "較": {
        onyomi: ["カク", "コウ"],
        kunyomi: ["くら.べる"],
        examples: [
        { word: "比較", reading: "ひかく", meaning: "comparison" },
        { word: "比較的", reading: "ひかくてき", meaning: "comparatively, relatively" }
    ],
    },
    "隔": {
        onyomi: ["カク"],
        kunyomi: ["へだ.てる", "へだ.たる"],
        examples: [
        { word: "遠隔", reading: "えんかく", meaning: "distant, remote, isolated" },
        { word: "隔て", reading: "へだて", meaning: "partition, division, barrier" },
        { word: "隔月", reading: "かくげつ", meaning: "every second month, every other month" },
        { word: "隔離", reading: "かくり", meaning: "isolation, segregation, separation" }
    ],
    },
    "閣": {
        onyomi: ["カク"],
        kunyomi: [],
        examples: [
        { word: "閣下", reading: "かっか", meaning: "your Excellency, his Excellency, her Excellency" },
        { word: "閣議", reading: "かくぎ", meaning: "cabinet meeting" },
        { word: "閣僚", reading: "かくりょう", meaning: "cabinet ministers" },
        { word: "組閣", reading: "そかく", meaning: "formation of a cabinet" }
    ],
    },
    "確": {
        onyomi: ["カク", "コウ"],
        kunyomi: ["たし.か", "たし.かめる"],
        examples: [
        { word: "確固", reading: "かっこ", meaning: "firm, unshakeable, resolute" },
        { word: "確執", reading: "かくしつ", meaning: "discord, antagonism" },
        { word: "確実", reading: "かくじつ", meaning: "certain, sure, definite" },
        { word: "確信", reading: "かくしん", meaning: "conviction, belief, confidence" }
    ],
    },
    "獲": {
        onyomi: ["カク"],
        kunyomi: ["え.る"],
        examples: [
        { word: "獲得", reading: "かくとく", meaning: "acquisition, possession" },
        { word: "獲物", reading: "えもの", meaning: "prey, catch, kill" },
        { word: "漁獲", reading: "ぎょかく", meaning: "fishery, fishing, catch" },
        { word: "捕獲", reading: "ほかく", meaning: "capture, seizure" }
    ],
    },
    "嚇": {
        onyomi: ["カク"],
        kunyomi: ["おど.す"],
        examples: [
        { word: "威嚇", reading: "いかく", meaning: "threat, intimidation, menace" }
    ],
    },
    "穫": {
        onyomi: ["カク"],
        kunyomi: [],
        examples: [
        { word: "収穫", reading: "しゅうかく", meaning: "harvest, crop, ingathering" }
    ],
    },
    "学": {
        onyomi: ["ガク"],
        kunyomi: ["まな.ぶ"],
        examples: [
        { word: "医学", reading: "いがく", meaning: "medicine, medical science" },
        { word: "化学", reading: "かがく", meaning: "chemistry" },
        { word: "科学", reading: "かがく", meaning: "science" },
        { word: "学ぶ", reading: "まなぶ", meaning: "to learn, to study, to take lessons in" }
    ],
    },
    "岳": {
        onyomi: ["ガク"],
        kunyomi: ["たけ"],
        examples: [
        { word: "山岳", reading: "さんがく", meaning: "mountain chain, mountains" },
        { word: "岳", reading: "たけ", meaning: "(high) mountain, Mount, Mt." }
    ],
    },
    "楽": {
        onyomi: ["ガク", "ラク", "ゴウ"],
        kunyomi: ["たの.しい", "たの.しむ", "この.む"],
        examples: [
        { word: "音楽", reading: "おんがく", meaning: "music" },
        { word: "雅楽", reading: "ががく", meaning: "gagaku, ceremonial Japanese court music" },
        { word: "快楽", reading: "かいらく", meaning: "pleasure" },
        { word: "楽園", reading: "らくえん", meaning: "paradise, Eden" }
    ],
    },
    "額": {
        onyomi: ["ガク"],
        kunyomi: ["ひたい"],
        examples: [
        { word: "額縁", reading: "がくぶち", meaning: "(picture) frame" },
        { word: "額面", reading: "がくめん", meaning: "face value, par" },
        { word: "巨額", reading: "きょがく", meaning: "huge sum (esp. of money), enormous sum, massive amount" },
        { word: "金額", reading: "きんがく", meaning: "amount of money, sum" }
    ],
    },
    "顎": {
        onyomi: ["ガク"],
        kunyomi: ["あご", "あぎと"],
        examples: [
        { word: "顎", reading: "あご", meaning: "jaw, chin" }
    ],
    },
    "掛": {
        onyomi: ["カイ", "ケイ"],
        kunyomi: ["か.ける", "-か.ける", "か.け", "-か.け", "-が.け", "か.かる", "-か.かる", "-が.かる", "か.かり", "-が.かり", "かかり", "-がかり"],
        examples: [
        { word: "掛け", reading: "かけ", meaning: "credit" },
        { word: "腰掛", reading: "こしかけ", meaning: "seat, bench" },
        { word: "掛軸", reading: "かけじく", meaning: "hanging scroll" },
        { word: "掛かる", reading: "かかる", meaning: "to take (a resource, e.g. time or money)" }
    ],
    },
    "潟": {
        onyomi: ["セキ"],
        kunyomi: ["かた", "-がた"],
        examples: [
        { word: "干潟", reading: "ひがた", meaning: "tidal flat, tideland" },
        { word: "新潟", reading: "にいがた", meaning: "Niigata (city, prefecture)" },
        { word: "潟", reading: "かた", meaning: "lagoon" }
    ],
    },
    "括": {
        onyomi: ["カツ"],
        kunyomi: ["くく.る"],
        examples: [
        { word: "一括", reading: "いっかつ", meaning: "lumping together, summing up, bundle" },
        { word: "括る", reading: "くくる", meaning: "to tie up, to tie together, to bind" },
        { word: "括弧", reading: "かっこ", meaning: "brackets, parentheses" },
        { word: "総括", reading: "そうかつ", meaning: "summarization, summary, generalization" }
    ],
    },
    "活": {
        onyomi: ["カツ"],
        kunyomi: ["い.きる", "い.かす", "い.ける"],
        examples: [
        { word: "快活", reading: "かいかつ", meaning: "cheerful, lively, lighthearted" },
        { word: "活気", reading: "かっき", meaning: "energy, vigour, vigor" },
        { word: "活況", reading: "かっきょう", meaning: "activity, briskness, prosperity" },
        { word: "活字", reading: "かつじ", meaning: "(piece of) type, movable type, moveable type" }
    ],
    },
    "喝": {
        onyomi: ["カツ"],
        kunyomi: [],
        examples: [
        { word: "喝破", reading: "かっぱ", meaning: "arguing (someone) down, loudly scolding, rebuking" },
        { word: "恐喝", reading: "きょうかつ", meaning: "blackmail, extortion, threat (to extort money)" }
    ],
    },
    "渇": {
        onyomi: ["カツ"],
        kunyomi: ["かわ.く"],
        examples: [
        { word: "渇き", reading: "かわき", meaning: "thirst" },
        { word: "渇く", reading: "かわく", meaning: "to be thirsty, to feel thirsty" },
        { word: "渇水", reading: "かっすい", meaning: "water shortage" },
        { word: "渇望", reading: "かつぼう", meaning: "craving, longing, thirsting" }
    ],
    },
    "割": {
        onyomi: ["カツ"],
        kunyomi: ["わ.る", "わり", "わ.り", "わ.れる", "さ.く"],
        examples: [
        { word: "１割", reading: "いちわり", meaning: "ten percent" },
        { word: "学割", reading: "がくわり", meaning: "student discount" },
        { word: "割く", reading: "さく", meaning: "to tear, to rip up" },
        { word: "割る", reading: "わる", meaning: "to divide" }
    ],
    },
    "葛": {
        onyomi: ["カツ", "カチ"],
        kunyomi: ["つづら", "くず"],
        examples: [
        { word: "葛藤", reading: "かっとう", meaning: "conflict, complication, troubles" },
        { word: "葛", reading: "くず", meaning: "kudzu (Pueraria montana), Japanese arrowroot" }
    ],
    },
    "滑": {
        onyomi: ["カツ", "コツ"],
        kunyomi: ["すべ.る", "なめ.らか"],
        examples: [
        { word: "滑る", reading: "すべる", meaning: "to slide, to glide, to skate" },
        { word: "滑稽", reading: "こっけい", meaning: "funny, comical, humorous" },
        { word: "滑降", reading: "かっこう", meaning: "descent (esp. in skiing), sliding down, skiing down" },
        { word: "滑走", reading: "かっそう", meaning: "gliding, sliding, skating (on ice)" }
    ],
    },
    "褐": {
        onyomi: ["カツ"],
        kunyomi: [],
        examples: [
        { word: "褐色", reading: "かっしょく", meaning: "dark brown, colour of tanned skin" },
        { word: "茶褐色", reading: "ちゃかっしょく", meaning: "dark reddish-brown, liver color" }
    ],
    },
    "轄": {
        onyomi: ["カツ"],
        kunyomi: ["くさび"],
        examples: [
        { word: "管轄", reading: "かんかつ", meaning: "jurisdiction, control" },
        { word: "所轄", reading: "しょかつ", meaning: "jurisdiction" },
        { word: "直轄", reading: "ちょっかつ", meaning: "direct control, direct supervision" }
    ],
    },
    "且": {
        onyomi: ["ショ", "ソ", "ショウ"],
        kunyomi: ["か.つ"],
        examples: [
        { word: "且つ", reading: "かつ", meaning: "and, moreover, besides" },
        { word: "尚且つ", reading: "なおかつ", meaning: "besides, furthermore, on top of that" }
    ],
    },
    "株": {
        onyomi: ["シュ"],
        kunyomi: ["かぶ"],
        examples: [
        { word: "株価", reading: "かぶか", meaning: "stock prices" },
        { word: "株券", reading: "かぶけん", meaning: "stock certificate" },
        { word: "株式", reading: "かぶしき", meaning: "share (in a company), stock" },
        { word: "株主", reading: "かぶぬし", meaning: "shareholder, stockholder" }
    ],
    },
    "釜": {
        onyomi: ["フ"],
        kunyomi: ["かま"],
        examples: [
        { word: "釜", reading: "かま", meaning: "iron pot, kettle" }
    ],
    },
    "鎌": {
        onyomi: ["レン", "ケン"],
        kunyomi: ["かま"],
        examples: [
        { word: "鎌倉", reading: "かまくら", meaning: "Kamakura (city)" },
        { word: "鎌", reading: "かま", meaning: "sickle" }
    ],
    },
    "刈": {
        onyomi: ["ガイ", "カイ"],
        kunyomi: ["か.る"],
        examples: [
        { word: "刈る", reading: "かる", meaning: "to cut (grass, hair, etc.), to mow, to clip" },
        { word: "稲刈り", reading: "いねかり", meaning: "rice reaping, rice harvesting" },
        { word: "丸刈り", reading: "まるがり", meaning: "buzz cut, close crop" },
        { word: "草刈り", reading: "くさかり", meaning: "mowing, mower" }
    ],
    },
    "干": {
        onyomi: ["カン"],
        kunyomi: ["ほ.す", "ほ.し-", "-ぼ.し", "ひ.る"],
        examples: [
        { word: "干る", reading: "ひる", meaning: "to dry (up), to become parched" },
        { word: "干潟", reading: "ひがた", meaning: "tidal flat, tideland" },
        { word: "干渉", reading: "かんしょう", meaning: "interference, intervention, meddling" },
        { word: "干拓", reading: "かんたく", meaning: "land reclamation (from sea)" }
    ],
    },
    "刊": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "刊行", reading: "かんこう", meaning: "publication, issue" },
        { word: "季刊", reading: "きかん", meaning: "quarterly publication" },
        { word: "休刊", reading: "きゅうかん", meaning: "suspension of publication" },
        { word: "月刊", reading: "げっかん", meaning: "monthly publication, monthly issue" }
    ],
    },
    "甘": {
        onyomi: ["カン"],
        kunyomi: ["あま.い", "あま.える", "あま.やかす", "うま.い"],
        examples: [
        { word: "甘い", reading: "あまい", meaning: "sweet-tasting, sweet, sugary" },
        { word: "甘え", reading: "あまえ", meaning: "overdependence (on others; usu. one's fosterers or seniors), lack of self-reliance, presumed acceptance (of one's behaviour)" },
        { word: "甘言", reading: "かんげん", meaning: "sweet words, smooth talk, cajolery" },
        { word: "甘酢", reading: "あまず", meaning: "sweet vinegar" }
    ],
    },
    "汗": {
        onyomi: ["カン"],
        kunyomi: ["あせ"],
        examples: [
        { word: "発汗", reading: "はっかん", meaning: "sweating, perspiration, sudation" },
        { word: "冷汗", reading: "ひやあせ", meaning: "cold sweat" },
        { word: "冷や汗", reading: "ひやあせ", meaning: "cold sweat" },
        { word: "汗", reading: "あせ", meaning: "sweat, perspiration" }
    ],
    },
    "缶": {
        onyomi: ["カン"],
        kunyomi: ["かま"],
        examples: [
        { word: "缶詰", reading: "かんづめ", meaning: "canned food, tinned food" },
        { word: "空き缶", reading: "あきかん", meaning: "empty can" },
        { word: "ドラム缶", reading: "ドラムかん", meaning: "drum (e.g. oil, gasoline), metal barrel" },
        { word: "缶", reading: "かん", meaning: "can, tin" }
    ],
    },
    "完": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "完結", reading: "かんけつ", meaning: "conclusion, completion" },
        { word: "完遂", reading: "かんすい", meaning: "successful execution, accomplishment, completion" },
        { word: "完成", reading: "かんせい", meaning: "completion, perfection, accomplishment" },
        { word: "完全", reading: "かんぜん", meaning: "perfect, complete" }
    ],
    },
    "肝": {
        onyomi: ["カン"],
        kunyomi: ["きも"],
        examples: [
        { word: "肝炎", reading: "かんえん", meaning: "hepatitis" },
        { word: "肝臓", reading: "かんぞう", meaning: "liver" },
        { word: "肝要", reading: "かんよう", meaning: "extremely important, essential, vital" },
        { word: "肝心", reading: "かんじん", meaning: "essential, important, crucial" }
    ],
    },
    "官": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "官界", reading: "かんかい", meaning: "bureaucratic world, government circles" },
        { word: "官憲", reading: "かんけん", meaning: "officials, authorities" },
        { word: "官庁", reading: "かんちょう", meaning: "government office, government agency, authorities" },
        { word: "官邸", reading: "かんてい", meaning: "official residence (e.g. of the prime minister)" }
    ],
    },
    "冠": {
        onyomi: ["カン"],
        kunyomi: ["かんむり"],
        examples: [
        { word: "栄冠", reading: "えいかん", meaning: "crown of victory, laurels" },
        { word: "王冠", reading: "おうかん", meaning: "crown, diadem" },
        { word: "弱冠", reading: "じゃっかん", meaning: "twenty years of age" },
        { word: "三冠馬", reading: "さんかんば", meaning: "winner of Japan's three main horse races" }
    ],
    },
    "巻": {
        onyomi: ["カン", "ケン"],
        kunyomi: ["ま.く", "まき", "ま.き"],
        examples: [
        { word: "圧巻", reading: "あっかん", meaning: "highlight, best part" },
        { word: "絵巻", reading: "えまき", meaning: "picture scroll" },
        { word: "巻く", reading: "まく", meaning: "to wind, to coil, to roll" },
        { word: "巻末", reading: "かんまつ", meaning: "end of a book" }
    ],
    },
    "看": {
        onyomi: ["カン"],
        kunyomi: ["み.る"],
        examples: [
        { word: "看る", reading: "みる", meaning: "to look after (often medically), to take care of" },
        { word: "看過", reading: "かんか", meaning: "overlooking, turning a blind eye" },
        { word: "看護", reading: "かんご", meaning: "nursing, (army) nurse" },
        { word: "看守", reading: "かんしゅ", meaning: "prison guard, warder, jailer" }
    ],
    },
    "陥": {
        onyomi: ["カン"],
        kunyomi: ["おちい.る", "おとしい.れる"],
        examples: [
        { word: "陥る", reading: "おちいる", meaning: "to fall into (e.g. a hole)" },
        { word: "陥没", reading: "かんぼつ", meaning: "cave-in, collapse, sinking" },
        { word: "陥落", reading: "かんらく", meaning: "subsidence, sinking, cave-in" },
        { word: "欠陥", reading: "けっかん", meaning: "defect, fault, flaw" }
    ],
    },
    "乾": {
        onyomi: ["カン", "ケン"],
        kunyomi: ["かわ.く", "かわ.かす", "ほ.す", "ひ.る", "いぬい"],
        examples: [
        { word: "乾く", reading: "かわく", meaning: "to get dry" },
        { word: "乾燥", reading: "かんそう", meaning: "dryness, aridity, drying (e.g. clothes)" },
        { word: "乾物", reading: "かんぶつ", meaning: "dry provisions, dried food, dried goods" },
        { word: "乾季", reading: "かんき", meaning: "dry season" }
    ],
    },
    "勘": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "勘定", reading: "かんじょう", meaning: "calculation, computation, counting" },
        { word: "勘弁", reading: "かんべん", meaning: "pardon, forgiveness, forbearance" },
        { word: "勘案", reading: "かんあん", meaning: "taking into consideration, giving consideration (to)" },
        { word: "勘違い", reading: "かんちがい", meaning: "misunderstanding, mistaken idea, wrong guess" }
    ],
    },
    "患": {
        onyomi: ["カン"],
        kunyomi: ["わずら.う"],
        examples: [
        { word: "患う", reading: "わずらう", meaning: "to be ill, to suffer from" },
        { word: "患者", reading: "かんじゃ", meaning: "patient" },
        { word: "患部", reading: "かんぶ", meaning: "affected part, diseased part, wound" },
        { word: "急患", reading: "きゅうかん", meaning: "emergency case" }
    ],
    },
    "貫": {
        onyomi: ["カン"],
        kunyomi: ["つらぬ.く", "ぬ.く", "ぬき"],
        examples: [
        { word: "一貫", reading: "いっかん", meaning: "consistency, coherence, integration" },
        { word: "貫く", reading: "つらぬく", meaning: "to go through, to pierce, to penetrate" },
        { word: "貫通", reading: "かんつう", meaning: "passing through (of a tunnel, bullet, etc.), going (right) through, penetrating" },
        { word: "貫徹", reading: "かんてつ", meaning: "accomplishment, realization, attainment" }
    ],
    },
    "寒": {
        onyomi: ["カン"],
        kunyomi: ["さむ.い"],
        examples: [
        { word: "悪寒", reading: "おかん", meaning: "chill, shakes, ague" },
        { word: "寒い", reading: "さむい", meaning: "cold (e.g. weather)" },
        { word: "寒さ", reading: "さむさ", meaning: "coldness" },
        { word: "寒気", reading: "さむけ", meaning: "chill, the shivers, shivering fit" }
    ],
    },
    "喚": {
        onyomi: ["カン"],
        kunyomi: ["わめ.く"],
        examples: [
        { word: "喚く", reading: "わめく", meaning: "to shout, to cry (out), to yell" },
        { word: "喚起", reading: "かんき", meaning: "arousal, excitation, awakening" },
        { word: "喚問", reading: "かんもん", meaning: "summons" },
        { word: "召喚", reading: "しょうかん", meaning: "summons, subpoena, citation" }
    ],
    },
    "堪": {
        onyomi: ["カン", "タン"],
        kunyomi: ["た.える", "たま.る", "こら.える", "こた.える"],
        examples: [
        { word: "堪能", reading: "たんのう", meaning: "proficient, skilled, skillful" },
        { word: "堪える", reading: "たえる", meaning: "to bear, to stand, to endure" },
        { word: "堪らない", reading: "たまらない", meaning: "intolerable, unbearable, unendurable" }
    ],
    },
    "換": {
        onyomi: ["カン"],
        kunyomi: ["か.える", "-か.える", "か.わる"],
        examples: [
        { word: "換気", reading: "かんき", meaning: "ventilation" },
        { word: "換金", reading: "かんきん", meaning: "realization (of goods into money), conversion (into money), liquidation" },
        { word: "換算", reading: "かんさん", meaning: "conversion (e.g. yen to dollars), change, exchange" },
        { word: "互換", reading: "ごかん", meaning: "interchange" }
    ],
    },
    "敢": {
        onyomi: ["カン"],
        kunyomi: ["あ.えて", "あ.えない", "あ.えず"],
        examples: [
        { word: "果敢", reading: "かかん", meaning: "resolute, determined, bold" },
        { word: "敢行", reading: "かんこう", meaning: "decisive action, going through with, daring to do" },
        { word: "敢然", reading: "かんぜん", meaning: "boldly, bravely, resolutely" },
        { word: "敢闘", reading: "かんとう", meaning: "fighting bravely" }
    ],
    },
    "棺": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "石棺", reading: "せっかん", meaning: "sarcophagus, stone coffin" },
        { word: "棺", reading: "かん", meaning: "coffin, casket" }
    ],
    },
    "款": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "借款", reading: "しゃっかん", meaning: "loan (esp. between governments)" },
        { word: "定款", reading: "ていかん", meaning: "articles of incorporation, company statute" },
        { word: "約款", reading: "やっかん", meaning: "agreement, stipulation, article" }
    ],
    },
    "間": {
        onyomi: ["カン", "ケン"],
        kunyomi: ["あいだ", "ま", "あい"],
        examples: [
        { word: "間隔", reading: "かんかく", meaning: "space, interval" },
        { word: "間近", reading: "まぢか", meaning: "near, close (to), nearby" },
        { word: "間口", reading: "まぐち", meaning: "frontage, width (of a building, plot of land, etc.)" },
        { word: "間際", reading: "まぎわ", meaning: "the point just before ..., the point of (doing), the verge (of)" }
    ],
    },
    "閑": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "等閑", reading: "なおざり", meaning: "neglect, negligence, disregard" },
        { word: "閑散", reading: "かんさん", meaning: "deserted (esp. store, market, town, streets), quiet, still" },
        { word: "閑静", reading: "かんせい", meaning: "quiet (e.g. neighbourhood), peaceful, tranquil" },
        { word: "長閑", reading: "のどか", meaning: "tranquil, calm, quiet" }
    ],
    },
    "勧": {
        onyomi: ["カン", "ケン"],
        kunyomi: ["すす.める"],
        examples: [
        { word: "勧め", reading: "すすめ", meaning: "recommendation, advice, suggestion" },
        { word: "勧業", reading: "かんぎょう", meaning: "(encouragement of) industry" },
        { word: "勧告", reading: "かんこく", meaning: "advice, counsel, remonstrance" },
        { word: "勧奨", reading: "かんしょう", meaning: "encouragement, stimulation" }
    ],
    },
    "寛": {
        onyomi: ["カン"],
        kunyomi: ["くつろ.ぐ", "ひろ.い", "ゆる.やか"],
        examples: [
        { word: "寛ぐ", reading: "くつろぐ", meaning: "to relax, to feel at home" },
        { word: "寛大", reading: "かんだい", meaning: "tolerant, generous, lenient" },
        { word: "寛容", reading: "かんよう", meaning: "tolerance, open-mindedness, forbearance" }
    ],
    },
    "幹": {
        onyomi: ["カン"],
        kunyomi: ["みき"],
        examples: [
        { word: "幹事", reading: "かんじ", meaning: "executive secretary, coordinator, organizer" },
        { word: "幹線", reading: "かんせん", meaning: "main line, trunk line" },
        { word: "幹部", reading: "かんぶ", meaning: "management, (executive) staff, leaders" },
        { word: "基幹", reading: "きかん", meaning: "mainstay, nucleus, key" }
    ],
    },
    "感": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "快感", reading: "かいかん", meaning: "pleasant feeling, pleasant sensation, pleasure" },
        { word: "感じ", reading: "かんじ", meaning: "feeling, sense, impression" },
        { word: "感化", reading: "かんか", meaning: "influence (on someone), inspiration" },
        { word: "感慨", reading: "かんがい", meaning: "deep emotion, strong feelings" }
    ],
    },
    "漢": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "漢語", reading: "かんご", meaning: "Japanese word of Chinese origin, Sino-Japanese word" },
        { word: "漢詩", reading: "かんし", meaning: "Chinese poem, Chinese poetry" },
        { word: "漢字", reading: "かんじ", meaning: "kanji, Chinese character" },
        { word: "漢文", reading: "かんぶん", meaning: "Chinese classical writing, Chinese classics" }
    ],
    },
    "慣": {
        onyomi: ["カン"],
        kunyomi: ["な.れる", "な.らす"],
        examples: [
        { word: "慣れ", reading: "なれ", meaning: "practice, experience, habituation" },
        { word: "慣行", reading: "かんこう", meaning: "customary practice, habit, traditional event" },
        { word: "慣習", reading: "かんしゅう", meaning: "custom, convention, common practice" },
        { word: "慣例", reading: "かんれい", meaning: "custom, practice, convention" }
    ],
    },
    "管": {
        onyomi: ["カン"],
        kunyomi: ["くだ"],
        examples: [
        { word: "移管", reading: "いかん", meaning: "transfer of control" },
        { word: "管轄", reading: "かんかつ", meaning: "jurisdiction, control" },
        { word: "管区", reading: "かんく", meaning: "jurisdiction" },
        { word: "管制", reading: "かんせい", meaning: "control (by the state), controlling, coordination" }
    ],
    },
    "関": {
        onyomi: ["カン"],
        kunyomi: ["せき", "-ぜき", "かか.わる", "からくり", "かんぬき"],
        examples: [
        { word: "関係", reading: "かんけい", meaning: "relation, relationship, connection" },
        { word: "関心", reading: "かんしん", meaning: "concern, interest" },
        { word: "関西", reading: "かんさい", meaning: "Kansai (region comprising Kyoto, Osaka, Kobe and surrounding prefectures)" },
        { word: "関税", reading: "かんぜい", meaning: "customs (duties), duty, tariff" }
    ],
    },
    "歓": {
        onyomi: ["カン"],
        kunyomi: ["よろこ.ぶ"],
        examples: [
        { word: "歓喜", reading: "かんき", meaning: "delight, great joy" },
        { word: "歓迎", reading: "かんげい", meaning: "welcome, (warm) reception" },
        { word: "歓声", reading: "かんせい", meaning: "cheer, shout of joy" },
        { word: "歓待", reading: "かんたい", meaning: "warm welcome, friendly reception, hospitality" }
    ],
    },
    "監": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "監禁", reading: "かんきん", meaning: "confinement, imprisonment, incarceration" },
        { word: "監獄", reading: "かんごく", meaning: "prison" },
        { word: "監察", reading: "かんさつ", meaning: "inspection, inspector" },
        { word: "監視", reading: "かんし", meaning: "monitoring, watching, observation" }
    ],
    },
    "緩": {
        onyomi: ["カン"],
        kunyomi: ["ゆる.い", "ゆる.やか", "ゆる.む", "ゆる.める"],
        examples: [
        { word: "緩い", reading: "ゆるい", meaning: "loose" },
        { word: "緩む", reading: "ゆるむ", meaning: "to become loose, to slacken (e.g. rope)" },
        { word: "緩急", reading: "かんきゅう", meaning: "high and low speed, fast and slow, pace" },
        { word: "緩慢", reading: "かんまん", meaning: "slow, sluggish, dull" }
    ],
    },
    "憾": {
        onyomi: ["カン"],
        kunyomi: ["うら.む"],
        examples: [
        { word: "遺憾", reading: "いかん", meaning: "regrettable, unsatisfactory, deplorable" }
    ],
    },
    "還": {
        onyomi: ["カン"],
        kunyomi: ["かえ.る"],
        examples: [
        { word: "還元", reading: "かんげん", meaning: "restoration, return" },
        { word: "還流", reading: "かんりゅう", meaning: "return current, reflux, back flow" },
        { word: "還暦", reading: "かんれき", meaning: "kanreki, one's 60th birthday (or 61st in the traditional age reckoning system) when one has lived through a full sexagenary cycle" },
        { word: "帰還", reading: "きかん", meaning: "return (home), repatriation" }
    ],
    },
    "館": {
        onyomi: ["カン"],
        kunyomi: ["やかた", "たて"],
        examples: [
        { word: "開館", reading: "かいかん", meaning: "opening (for that day's business; of a library, museum, cinema, etc.)" },
        { word: "館長", reading: "かんちょう", meaning: "superintendent, director, curator" },
        { word: "公館", reading: "こうかん", meaning: "official residence" },
        { word: "別館", reading: "べっかん", meaning: "annex (to a building), annexe, extension" }
    ],
    },
    "環": {
        onyomi: ["カン"],
        kunyomi: ["わ"],
        examples: [
        { word: "一環", reading: "いっかん", meaning: "link (e.g. in a chain of events), part (of a plan, campaign, activities, etc.)" },
        { word: "環境", reading: "かんきょう", meaning: "environment, surroundings, circumstances" },
        { word: "環礁", reading: "かんしょう", meaning: "atoll, circular coral reef" },
        { word: "環状", reading: "かんじょう", meaning: "annulation, ring shape, loop shape" }
    ],
    },
    "簡": {
        onyomi: ["カン", "ケン"],
        kunyomi: ["えら.ぶ", "ふだ"],
        examples: [
        { word: "簡易", reading: "かんい", meaning: "simple, simplified" },
        { word: "簡潔", reading: "かんけつ", meaning: "concise, brief, succinct" },
        { word: "簡素", reading: "かんそ", meaning: "simple, plain, modest" },
        { word: "簡単", reading: "かんたん", meaning: "simple, easy, uncomplicated" }
    ],
    },
    "観": {
        onyomi: ["カン"],
        kunyomi: ["み.る", "しめ.す"],
        examples: [
        { word: "外観", reading: "がいかん", meaning: "outward appearance, exterior appearance, outward show" },
        { word: "楽観", reading: "らっかん", meaning: "optimism, taking an optimistic view" },
        { word: "観客", reading: "かんきゃく", meaning: "spectator, audience" },
        { word: "観劇", reading: "かんげき", meaning: "theatre-going, theater-going" }
    ],
    },
    "韓": {
        onyomi: ["カン"],
        kunyomi: ["から", "いげた"],
        examples: [
        { word: "韓国", reading: "かんこく", meaning: "South Korea, Republic of Korea" },
        { word: "日韓", reading: "にっかん", meaning: "Japan and South Korea, Japanese-Korean" },
        { word: "韓国語", reading: "かんこくご", meaning: "Korean (language; esp. as spoken in South Korea)" }
    ],
    },
    "艦": {
        onyomi: ["カン"],
        kunyomi: [],
        examples: [
        { word: "艦船", reading: "かんせん", meaning: "warships and other vessels" },
        { word: "艦隊", reading: "かんたい", meaning: "(naval) fleet, armada" },
        { word: "艦艇", reading: "かんてい", meaning: "naval vessels, warships" },
        { word: "軍艦", reading: "ぐんかん", meaning: "warship, battleship" }
    ],
    },
    "鑑": {
        onyomi: ["カン"],
        kunyomi: ["かんが.みる", "かがみ"],
        examples: [
        { word: "印鑑", reading: "いんかん", meaning: "stamp, seal" },
        { word: "鑑賞", reading: "かんしょう", meaning: "appreciation (of art, music, poetry, etc.)" },
        { word: "鑑定", reading: "かんてい", meaning: "judgement, judgment, expert opinion" },
        { word: "鑑別", reading: "かんべつ", meaning: "discrimination, judgement, judgment" }
    ],
    },
    "丸": {
        onyomi: ["ガン"],
        kunyomi: ["まる", "まる.める", "まる.い"],
        examples: [
        { word: "一丸", reading: "いちがん", meaning: "one lump, one body, one group" },
        { word: "丸み", reading: "まるみ", meaning: "roundness, rotundity" },
        { word: "丸太", reading: "まるた", meaning: "log" },
        { word: "弾丸", reading: "だんがん", meaning: "bullet, shot, shell" }
    ],
    },
    "含": {
        onyomi: ["ガン"],
        kunyomi: ["ふく.む", "ふく.める"],
        examples: [
        { word: "含み", reading: "ふくみ", meaning: "implication, hidden meaning, latitude" },
        { word: "含む", reading: "ふくむ", meaning: "to contain, to comprise, to have" },
        { word: "含蓄", reading: "がんちく", meaning: "implication, significance, connotation" },
        { word: "含有", reading: "がんゆう", meaning: "containing (an ingredient, mineral, etc.)" }
    ],
    },
    "岸": {
        onyomi: ["ガン"],
        kunyomi: ["きし"],
        examples: [
        { word: "沿岸", reading: "えんがん", meaning: "coast, shore" },
        { word: "海岸", reading: "かいがん", meaning: "seashore, coast, seaside" },
        { word: "岸壁", reading: "がんぺき", meaning: "quay, wharf, jetty" },
        { word: "岸辺", reading: "きしべ", meaning: "shore, bank (of a body of water)" }
    ],
    },
    "岩": {
        onyomi: ["ガン"],
        kunyomi: ["いわ"],
        examples: [
        { word: "岩塩", reading: "がんえん", meaning: "halite, rock salt" },
        { word: "岩屋", reading: "いわや", meaning: "cave, cavern, grotto" },
        { word: "岩間", reading: "いわま", meaning: "among rocks" },
        { word: "岩山", reading: "いわやま", meaning: "rocky mountain" }
    ],
    },
    "玩": {
        onyomi: ["ガン"],
        kunyomi: ["もちあそ.ぶ", "もてあそ.ぶ"],
        examples: [
        { word: "玩具", reading: "おもちゃ", meaning: "toy" }
    ],
    },
    "眼": {
        onyomi: ["ガン", "ゲン"],
        kunyomi: ["まなこ", "め"],
        examples: [
        { word: "眼科", reading: "がんか", meaning: "ophthalmology" },
        { word: "近眼", reading: "きんがん", meaning: "nearsightedness, shortsightedness, myopia" },
        { word: "主眼", reading: "しゅがん", meaning: "main purpose, chief aim, focus" },
        { word: "肉眼", reading: "にくがん", meaning: "naked eye" }
    ],
    },
    "頑": {
        onyomi: ["ガン"],
        kunyomi: ["かたく.な"],
        examples: [
        { word: "頑な", reading: "かたくな", meaning: "obstinate, stubborn, mulish" },
        { word: "頑強", reading: "がんきょう", meaning: "stubborn, dogged, persistent" },
        { word: "頑固", reading: "がんこ", meaning: "stubborn, obstinate, pigheaded" },
        { word: "頑丈", reading: "がんじょう", meaning: "solid, firm, stout" }
    ],
    },
    "顔": {
        onyomi: ["ガン"],
        kunyomi: ["かお"],
        examples: [
        { word: "横顔", reading: "よこがお", meaning: "profile, face in profile, face seen from the side" },
        { word: "顔色", reading: "かおいろ", meaning: "complexion, skin tone, skin colour" },
        { word: "顔面", reading: "がんめん", meaning: "face (of person)" },
        { word: "似顔", reading: "にがお", meaning: "portrait, likeness" }
    ],
    },
    "願": {
        onyomi: ["ガン"],
        kunyomi: ["ねが.う", "-ねがい"],
        examples: [
        { word: "願い", reading: "ねがい", meaning: "desire, wish, hope" },
        { word: "願う", reading: "ねがう", meaning: "to desire, to wish, to hope" },
        { word: "願書", reading: "がんしょ", meaning: "(written) application, written request, petition" },
        { word: "祈願", reading: "きがん", meaning: "prayer (for something), supplication" }
    ],
    },
    "企": {
        onyomi: ["キ"],
        kunyomi: ["くわだ.てる", "たくら.む"],
        examples: [
        { word: "企み", reading: "たくらみ", meaning: "plot, scheme, trick" },
        { word: "企む", reading: "たくらむ", meaning: "to scheme, to plan, to play a trick" },
        { word: "企画", reading: "きかく", meaning: "planning, plan, project" },
        { word: "企業", reading: "きぎょう", meaning: "enterprise, business, company" }
    ],
    },
    "伎": {
        onyomi: ["ギ", "キ"],
        kunyomi: ["わざ", "わざおぎ"],
        examples: [
        { word: "歌舞伎", reading: "かぶき", meaning: "kabuki, traditional form of drama and music performed by male actors wearing makeup mainly in white and red" }
    ],
    },
    "危": {
        onyomi: ["キ"],
        kunyomi: ["あぶ.ない", "あや.うい", "あや.ぶむ"],
        examples: [
        { word: "危害", reading: "きがい", meaning: "injury, harm, danger" },
        { word: "危機", reading: "きき", meaning: "crisis, critical situation, emergency" },
        { word: "危急", reading: "ききゅう", meaning: "emergency, crisis, imminent danger" },
        { word: "危険", reading: "きけん", meaning: "danger, peril, hazard" }
    ],
    },
    "机": {
        onyomi: ["キ"],
        kunyomi: ["つくえ"],
        examples: [
        { word: "机上", reading: "きじょう", meaning: "on the desk" },
        { word: "机", reading: "つくえ", meaning: "desk" }
    ],
    },
    "気": {
        onyomi: ["キ", "ケ"],
        kunyomi: ["いき", "き"],
        examples: [
        { word: "悪気", reading: "わるぎ", meaning: "ill will, malice, evil intent" },
        { word: "意気", reading: "いき", meaning: "spirit, heart, disposition" },
        { word: "一気", reading: "いっき", meaning: "one breath" },
        { word: "陰気", reading: "いんき", meaning: "gloomy, dismal, miserable" }
    ],
    },
    "岐": {
        onyomi: ["キ", "ギ"],
        kunyomi: [],
        examples: [
        { word: "岐路", reading: "きろ", meaning: "forked road, crossroads" },
        { word: "多岐", reading: "たき", meaning: "diverse, various, wide-ranging" },
        { word: "分岐", reading: "ぶんき", meaning: "divergence, ramification, bifurcation" },
        { word: "岐阜", reading: "ぎふ", meaning: "Gifu (city, prefecture)" }
    ],
    },
    "希": {
        onyomi: ["キ", "ケ"],
        kunyomi: ["まれ", "こいねが.う"],
        examples: [
        { word: "希望", reading: "きぼう", meaning: "hope, wish, aspiration" },
        { word: "希少", reading: "きしょう", meaning: "scarce, rare" },
        { word: "希薄", reading: "きはく", meaning: "thin (air), weak (liquid), dilute" }
    ],
    },
    "忌": {
        onyomi: ["キ"],
        kunyomi: ["い.む", "い.み", "い.まわしい"],
        examples: [
        { word: "回忌", reading: "かいき", meaning: "death anniversary, anniversary of a person's death" },
        { word: "忌避", reading: "きひ", meaning: "evasion, avoidance, shirking" },
        { word: "忌まわしい", reading: "いまわしい", meaning: "abhorrent, abominable, detestable" }
    ],
    },
    "汽": {
        onyomi: ["キ"],
        kunyomi: [],
        examples: [
        { word: "汽車", reading: "きしゃ", meaning: "steam locomotive, steam train" },
        { word: "汽船", reading: "きせん", meaning: "steamship, steamboat, steamer" },
        { word: "汽笛", reading: "きてき", meaning: "steam whistle" }
    ],
    },
    "奇": {
        onyomi: ["キ"],
        kunyomi: ["く.しき", "あや.しい", "くし", "めずら.しい"],
        examples: [
        { word: "怪奇", reading: "かいき", meaning: "bizarre, strange, weird" },
        { word: "奇異", reading: "きい", meaning: "odd, strange, queer" },
        { word: "奇怪", reading: "きかい", meaning: "strange, wonderful, weird" },
        { word: "奇襲", reading: "きしゅう", meaning: "surprise attack" }
    ],
    },
    "祈": {
        onyomi: ["キ"],
        kunyomi: ["いの.る"],
        examples: [
        { word: "祈り", reading: "いのり", meaning: "prayer, supplication" },
        { word: "祈る", reading: "いのる", meaning: "to pray, to say a prayer, to say grace" },
        { word: "祈願", reading: "きがん", meaning: "prayer (for something), supplication" },
        { word: "祈念", reading: "きねん", meaning: "prayer" }
    ],
    },
    "季": {
        onyomi: ["キ"],
        kunyomi: [],
        examples: [
        { word: "季刊", reading: "きかん", meaning: "quarterly publication" },
        { word: "季語", reading: "きご", meaning: "seasonal word (in haiku)" },
        { word: "季節", reading: "きせつ", meaning: "season, time of year" },
        { word: "四季", reading: "しき", meaning: "the four seasons" }
    ],
    },
    "紀": {
        onyomi: ["キ"],
        kunyomi: [],
        examples: [
        { word: "紀元", reading: "きげん", meaning: "era" },
        { word: "紀行", reading: "きこう", meaning: "traveller's journal, traveler's journal, travelogue" },
        { word: "綱紀", reading: "こうき", meaning: "law and order, (official) discipline" },
        { word: "世紀", reading: "せいき", meaning: "century" }
    ],
    },
    "軌": {
        onyomi: ["キ"],
        kunyomi: [],
        examples: [
        { word: "軌跡", reading: "きせき", meaning: "tire track" },
        { word: "軌道", reading: "きどう", meaning: "orbit, trajectory" },
        { word: "常軌", reading: "じょうき", meaning: "normal course (of action), proper course, regular way" }
    ],
    },
    "既": {
        onyomi: ["キ"],
        kunyomi: ["すで.に"],
        examples: [
        { word: "既に", reading: "すでに", meaning: "already" },
        { word: "既婚", reading: "きこん", meaning: "married" },
        { word: "既成", reading: "きせい", meaning: "established, existing, accomplished" },
        { word: "既製", reading: "きせい", meaning: "ready-made, off the shelf" }
    ],
    },
    "記": {
        onyomi: ["キ"],
        kunyomi: ["しる.す"],
        examples: [
        { word: "下記", reading: "かき", meaning: "the following" },
        { word: "記す", reading: "しるす", meaning: "to write down, to note down, to jot down" },
        { word: "記憶", reading: "きおく", meaning: "memory, recollection, remembrance" },
        { word: "記号", reading: "きごう", meaning: "sign, symbol, mark" }
    ],
    },
    "起": {
        onyomi: ["キ"],
        kunyomi: ["お.きる", "お.こる", "お.こす", "おこ.す", "た.つ"],
        examples: [
        { word: "縁起", reading: "えんぎ", meaning: "omen, sign of luck" },
        { word: "喚起", reading: "かんき", meaning: "arousal, excitation, awakening" },
        { word: "起因", reading: "きいん", meaning: "to be caused by, to result from, to arise from" },
        { word: "起工", reading: "きこう", meaning: "setting to work" }
    ],
    },
    "飢": {
        onyomi: ["キ"],
        kunyomi: ["う.える"],
        examples: [
        { word: "飢え", reading: "うえ", meaning: "hunger, starvation" },
        { word: "飢餓", reading: "きが", meaning: "starvation, famine, hunger" },
        { word: "飢饉", reading: "ききん", meaning: "famine, crop failure" },
        { word: "飢える", reading: "うえる", meaning: "to starve, to be famished, to be hungry" }
    ],
    },
    "鬼": {
        onyomi: ["キ"],
        kunyomi: ["おに", "おに-"],
        examples: [
        { word: "鬼才", reading: "きさい", meaning: "wizard, genius, remarkable talent" },
        { word: "鬼神", reading: "きしん", meaning: "fierce god" },
        { word: "吸血鬼", reading: "きゅうけつき", meaning: "vampire, bloodsucker" },
        { word: "鬼ごっこ", reading: "おにごっこ", meaning: "tag (children's game), tig" }
    ],
    },
    "帰": {
        onyomi: ["キ"],
        kunyomi: ["かえ.る", "かえ.す", "おく.る", "とつ.ぐ"],
        examples: [
        { word: "回帰", reading: "かいき", meaning: "return (to), revolution, recurrence" },
        { word: "帰す", reading: "かえす", meaning: "to send (someone) back, to send (someone) home" },
        { word: "帰り", reading: "かえり", meaning: "return, coming back" },
        { word: "帰る", reading: "かえる", meaning: "to return, to come home, to go home" }
    ],
    },
    "基": {
        onyomi: ["キ"],
        kunyomi: ["もと", "もとい"],
        examples: [
        { word: "塩基", reading: "えんき", meaning: "base" },
        { word: "基幹", reading: "きかん", meaning: "mainstay, nucleus, key" },
        { word: "基金", reading: "ききん", meaning: "fund, foundation" },
        { word: "基礎", reading: "きそ", meaning: "foundation, basis" }
    ],
    },
    "寄": {
        onyomi: ["キ"],
        kunyomi: ["よ.る", "-よ.り", "よ.せる"],
        examples: [
        { word: "寄せ", reading: "よせ", meaning: "yose, end game, last stage of a game" },
        { word: "寄る", reading: "よる", meaning: "to approach, to draw near, to come near" },
        { word: "寄金", reading: "ききん", meaning: "contribution, donation" },
        { word: "寄港", reading: "きこう", meaning: "calling at a port" }
    ],
    },
    "規": {
        onyomi: ["キ"],
        kunyomi: [],
        examples: [
        { word: "規格", reading: "きかく", meaning: "standard, norm" },
        { word: "規制", reading: "きせい", meaning: "regulation, (traffic) policing, control" },
        { word: "規則", reading: "きそく", meaning: "rule, regulation" },
        { word: "規定", reading: "きてい", meaning: "stipulation, prescription, provision" }
    ],
    },
    "亀": {
        onyomi: ["キ", "キュウ", "キン"],
        kunyomi: ["かめ"],
        examples: [
        { word: "亀裂", reading: "きれつ", meaning: "crack, crevice, fissure" },
        { word: "亀", reading: "かめ", meaning: "tortoise, turtle" }
    ],
    },
    "喜": {
        onyomi: ["キ"],
        kunyomi: ["よろこ.ぶ", "よろこ.ばす"],
        examples: [
        { word: "歓喜", reading: "かんき", meaning: "delight, great joy" },
        { word: "喜ぶ", reading: "よろこぶ", meaning: "to be delighted, to be glad, to be pleased" },
        { word: "喜劇", reading: "きげき", meaning: "comedy" },
        { word: "喜寿", reading: "きじゅ", meaning: "77th birthday" }
    ],
    },
    "幾": {
        onyomi: ["キ"],
        kunyomi: ["いく-", "いく.つ", "いく.ら"],
        examples: [
        { word: "幾つ", reading: "いくつ", meaning: "how many" },
        { word: "幾ら", reading: "いくら", meaning: "how much" },
        { word: "幾何", reading: "きか", meaning: "geometry" },
        { word: "幾日", reading: "いくにち", meaning: "(for) how many days" }
    ],
    },
    "揮": {
        onyomi: ["キ"],
        kunyomi: ["ふる.う"],
        examples: [
        { word: "揮発", reading: "きはつ", meaning: "volatilization, volatilisation" },
        { word: "指揮", reading: "しき", meaning: "command, direction, supervision" },
        { word: "発揮", reading: "はっき", meaning: "show (of power, ability, etc.), exhibition, demonstration" },
        { word: "指揮者", reading: "しきしゃ", meaning: "(musical) conductor" }
    ],
    },
    "期": {
        onyomi: ["キ", "ゴ"],
        kunyomi: [],
        examples: [
        { word: "一期", reading: "いちご", meaning: "one's whole life, one's lifetime" },
        { word: "延期", reading: "えんき", meaning: "postponement, deferment, adjournment" },
        { word: "下期", reading: "しもき", meaning: "second half of the (fiscal) year" },
        { word: "会期", reading: "かいき", meaning: "session (of a legislature)" }
    ],
    },
    "棋": {
        onyomi: ["キ"],
        kunyomi: ["ご"],
        examples: [
        { word: "棋士", reading: "きし", meaning: "professional shogi player, professional go player" },
        { word: "棋譜", reading: "きふ", meaning: "record of a game of go, shogi, chess, etc." },
        { word: "将棋", reading: "しょうぎ", meaning: "shogi, Japanese chess" },
        { word: "棋院", reading: "きいん", meaning: "go institution, go club, go hall" }
    ],
    },
    "貴": {
        onyomi: ["キ"],
        kunyomi: ["たっと.い", "とうと.い", "たっと.ぶ", "とうと.ぶ"],
        examples: [
        { word: "貴社", reading: "きしゃ", meaning: "your company" },
        { word: "貴重", reading: "きちょう", meaning: "precious, valuable" },
        { word: "貴族", reading: "きぞく", meaning: "nobility, aristocracy, peerage" },
        { word: "貴賓", reading: "きひん", meaning: "noble visitor" }
    ],
    },
    "棄": {
        onyomi: ["キ"],
        kunyomi: ["す.てる"],
        examples: [
        { word: "棄却", reading: "ききゃく", meaning: "rejection, dismissal, turning down" },
        { word: "棄権", reading: "きけん", meaning: "abstention (from voting), renunciation (of a right), withdrawal (from a contest)" },
        { word: "自棄", reading: "やけ", meaning: "desperation, despair, self-abandonment" },
        { word: "破棄", reading: "はき", meaning: "tearing up and discarding (e.g. documents), destruction" }
    ],
    },
    "毀": {
        onyomi: ["キ"],
        kunyomi: ["こぼ.つ", "こわ.す", "こぼ.れる", "こわ.れる", "そし.る", "やぶ.る"],
        examples: [
        { word: "毀損", reading: "きそん", meaning: "damage, injury, defamation" }
    ],
    },
    "旗": {
        onyomi: ["キ"],
        kunyomi: ["はた"],
        examples: [
        { word: "旗手", reading: "きしゅ", meaning: "standard-bearer, flag-bearer" },
        { word: "旗色", reading: "はたいろ", meaning: "situation, outlook" },
        { word: "校旗", reading: "こうき", meaning: "school flag" },
        { word: "国旗", reading: "こっき", meaning: "national flag" }
    ],
    },
    "器": {
        onyomi: ["キ"],
        kunyomi: ["うつわ"],
        examples: [
        { word: "火器", reading: "かき", meaning: "firearms, guns" },
        { word: "楽器", reading: "がっき", meaning: "musical instrument" },
        { word: "器楽", reading: "きがく", meaning: "instrumental music" },
        { word: "器官", reading: "きかん", meaning: "organ" }
    ],
    },
    "畿": {
        onyomi: ["キ"],
        kunyomi: ["みやこ"],
        examples: [
        { word: "近畿", reading: "きんき", meaning: "Kinki (region around Osaka, Kyoto, Nara)" }
    ],
    },
    "輝": {
        onyomi: ["キ"],
        kunyomi: ["かがや.く"],
        examples: [
        { word: "輝き", reading: "かがやき", meaning: "brightness, brilliance, brilliancy" },
        { word: "輝く", reading: "かがやく", meaning: "to shine, to sparkle, to twinkle" },
        { word: "輝度", reading: "きど", meaning: "brightness, luminance" },
        { word: "光輝", reading: "こうき", meaning: "brightness, splendour, splendor" }
    ],
    },
    "機": {
        onyomi: ["キ"],
        kunyomi: ["はた"],
        examples: [
        { word: "危機", reading: "きき", meaning: "crisis, critical situation, emergency" },
        { word: "機運", reading: "きうん", meaning: "opportunity, chance, good time (to do)" },
        { word: "機会", reading: "きかい", meaning: "chance, opportunity, occasion" },
        { word: "機械", reading: "きかい", meaning: "machine, mechanism" }
    ],
    },
    "騎": {
        onyomi: ["キ"],
        kunyomi: [],
        examples: [
        { word: "騎士", reading: "きし", meaning: "(medieval) knight" },
        { word: "騎手", reading: "きしゅ", meaning: "horseman, rider, jockey" },
        { word: "騎馬", reading: "きば", meaning: "horse riding, horseback riding, horseback rider" },
        { word: "騎兵", reading: "きへい", meaning: "cavalry, cavalryman, trooper" }
    ],
    },
    "技": {
        onyomi: ["ギ"],
        kunyomi: ["わざ"],
        examples: [
        { word: "演技", reading: "えんぎ", meaning: "acting, performance" },
        { word: "技巧", reading: "ぎこう", meaning: "technique, finesse" },
        { word: "技師", reading: "ぎし", meaning: "engineer, technical officer" },
        { word: "技術", reading: "ぎじゅつ", meaning: "technology, engineering" }
    ],
    },
    "宜": {
        onyomi: ["ギ"],
        kunyomi: ["よろ.しい", "よろ.しく"],
        examples: [
        { word: "時宜", reading: "じぎ", meaning: "right time, appropriate time, season's greetings" },
        { word: "適宜", reading: "てきぎ", meaning: "suitable, appropriate, fitting" },
        { word: "便宜", reading: "べんぎ", meaning: "convenience, accommodation, advantage" },
        { word: "宜しい", reading: "よろしい", meaning: "good, OK, all right" }
    ],
    },
    "偽": {
        onyomi: ["ギ", "カ"],
        kunyomi: ["いつわ.る", "にせ", "いつわ.り"],
        examples: [
        { word: "偽る", reading: "いつわる", meaning: "to lie, to pretend, to feign" },
        { word: "偽証", reading: "ぎしょう", meaning: "false evidence, perjury, false testimony" },
        { word: "偽造", reading: "ぎぞう", meaning: "forgery, counterfeiting, fabrication" },
        { word: "虚偽", reading: "きょぎ", meaning: "falsehood, untruth, lie" }
    ],
    },
    "欺": {
        onyomi: ["ギ"],
        kunyomi: ["あざむ.く"],
        examples: [
        { word: "欺く", reading: "あざむく", meaning: "to deceive, to delude, to trick" },
        { word: "詐欺", reading: "さぎ", meaning: "fraud, swindle, graft" },
        { word: "詐欺師", reading: "さぎし", meaning: "swindler, fraudster, trickster" }
    ],
    },
    "義": {
        onyomi: ["ギ"],
        kunyomi: [],
        examples: [
        { word: "意義", reading: "いぎ", meaning: "meaning, significance" },
        { word: "一義", reading: "いちぎ", meaning: "one meaning" },
        { word: "疑義", reading: "ぎぎ", meaning: "doubt" },
        { word: "義兄", reading: "ぎけい", meaning: "brother-in-law (spouse's older brother or older sister's husband)" }
    ],
    },
    "疑": {
        onyomi: ["ギ"],
        kunyomi: ["うたが.う"],
        examples: [
        { word: "懐疑", reading: "かいぎ", meaning: "doubt, skepticism, scepticism" },
        { word: "疑い", reading: "うたがい", meaning: "doubt, question, uncertainty" },
        { word: "疑う", reading: "うたがう", meaning: "to doubt, to distrust, to be suspicious of" },
        { word: "疑義", reading: "ぎぎ", meaning: "doubt" }
    ],
    },
    "儀": {
        onyomi: ["ギ"],
        kunyomi: [],
        examples: [
        { word: "儀式", reading: "ぎしき", meaning: "ceremony, rite, ritual" },
        { word: "儀礼", reading: "ぎれい", meaning: "courtesy, etiquette, formality" },
        { word: "行儀", reading: "ぎょうぎ", meaning: "manners, behavior, behaviour" },
        { word: "祝儀", reading: "しゅうぎ", meaning: "celebration, celebratory event, wedding ceremony" }
    ],
    },
    "戯": {
        onyomi: ["ギ", "ゲ"],
        kunyomi: ["たわむ.れる", "ざ.れる", "じゃ.れる"],
        examples: [
        { word: "悪戯", reading: "いたずら", meaning: "mischief, prank, trick" },
        { word: "戯れ", reading: "たわむれ", meaning: "play, sport, fun" },
        { word: "戯画", reading: "ぎが", meaning: "caricature, cartoon, comics" },
        { word: "戯曲", reading: "ぎきょく", meaning: "drama, play" }
    ],
    },
    "擬": {
        onyomi: ["ギ"],
        kunyomi: ["まが.い", "もど.き"],
        examples: [
        { word: "模擬", reading: "もぎ", meaning: "imitation" },
        { word: "模擬試験", reading: "もぎしけん", meaning: "mock exam, practice exam, practice test" }
    ],
    },
    "犠": {
        onyomi: ["ギ", "キ"],
        kunyomi: ["いけにえ"],
        examples: [
        { word: "犠牲", reading: "ぎせい", meaning: "sacrifice" },
        { word: "犠打", reading: "ぎだ", meaning: "sacrifice (bunt or fly)" },
        { word: "犠飛", reading: "ぎひ", meaning: "sacrifice fly" },
        { word: "犠牲者", reading: "ぎせいしゃ", meaning: "victim (esp. someone killed), casualty" }
    ],
    },
    "議": {
        onyomi: ["ギ"],
        kunyomi: [],
        examples: [
        { word: "異議", reading: "いぎ", meaning: "objection, dissent, protest" },
        { word: "会議", reading: "かいぎ", meaning: "meeting, conference, session" },
        { word: "閣議", reading: "かくぎ", meaning: "cabinet meeting" },
        { word: "議案", reading: "ぎあん", meaning: "legislative bill, measure" }
    ],
    },
    "菊": {
        onyomi: ["キク"],
        kunyomi: [],
        examples: [
        { word: "白菊", reading: "しらぎく", meaning: "white chrysanthemum" },
        { word: "菊", reading: "きく", meaning: "chrysanthemum (Chrysanthemum morifolium)" }
    ],
    },
    "吉": {
        onyomi: ["キチ", "キツ"],
        kunyomi: ["よし"],
        examples: [
        { word: "吉兆", reading: "きっちょう", meaning: "lucky omen, good omen" },
        { word: "吉報", reading: "きっぽう", meaning: "good news" },
        { word: "不吉", reading: "ふきつ", meaning: "ominous, sinister, unlucky" }
    ],
    },
    "喫": {
        onyomi: ["キツ"],
        kunyomi: ["の.む"],
        examples: [
        { word: "喫煙", reading: "きつえん", meaning: "smoking (tobacco)" },
        { word: "喫茶", reading: "きっさ", meaning: "tea drinking" },
        { word: "満喫", reading: "まんきつ", meaning: "having one's fill (of food or drink), eating (drinking) to one's heart's content" },
        { word: "喫する", reading: "きっする", meaning: "to eat, to drink, to smoke" }
    ],
    },
    "詰": {
        onyomi: ["キツ", "キチ"],
        kunyomi: ["つ.める", "つ.め", "-づ.め", "つ.まる", "つ.む"],
        examples: [
        { word: "缶詰", reading: "かんづめ", meaning: "canned food, tinned food" },
        { word: "詰む", reading: "つむ", meaning: "to become fine (of fabric)" },
        { word: "詰問", reading: "きつもん", meaning: "cross-examination, close questioning, demanding an explanation" },
        { word: "瓶詰", reading: "びんづめ", meaning: "bottling" }
    ],
    },
    "却": {
        onyomi: ["キャク"],
        kunyomi: ["かえ.って", "しりぞ.く", "しりぞ.ける"],
        examples: [
        { word: "棄却", reading: "ききゃく", meaning: "rejection, dismissal, turning down" },
        { word: "却下", reading: "きゃっか", meaning: "rejection, dismissal" },
        { word: "償却", reading: "しょうきゃく", meaning: "repayment, redemption" },
        { word: "焼却", reading: "しょうきゃく", meaning: "incineration, destruction by fire" }
    ],
    },
    "客": {
        onyomi: ["キャク", "カク"],
        kunyomi: [],
        examples: [
        { word: "観客", reading: "かんきゃく", meaning: "spectator, audience" },
        { word: "客員", reading: "きゃくいん", meaning: "guest member, associate member, honorary member" },
        { word: "客観", reading: "きゃっかん", meaning: "objectivity, objective, object (philosophical)" },
        { word: "客間", reading: "きゃくま", meaning: "drawing room, parlor, parlour" }
    ],
    },
    "脚": {
        onyomi: ["キャク", "キャ", "カク"],
        kunyomi: ["あし"],
        examples: [
        { word: "脚色", reading: "きゃくしょく", meaning: "dramatization (e.g. of a novel), dramatisation, adaptation (for the stage or screen)" },
        { word: "脚本", reading: "きゃくほん", meaning: "script, screenplay, scenario" },
        { word: "橋脚", reading: "きょうきゃく", meaning: "bridge pier, pontoon bridge" },
        { word: "行脚", reading: "あんぎゃ", meaning: "pilgrimage" }
    ],
    },
    "逆": {
        onyomi: ["ギャク", "ゲキ"],
        kunyomi: ["さか", "さか.さ", "さか.らう"],
        examples: [
        { word: "逆さ", reading: "さかさ", meaning: "inverted, upside down, reversed" },
        { word: "逆境", reading: "ぎゃっきょう", meaning: "adverse circumstances, unfortunate situation, adversity" },
        { word: "逆襲", reading: "ぎゃくしゅう", meaning: "counterattack" },
        { word: "逆説", reading: "ぎゃくせつ", meaning: "paradox" }
    ],
    },
    "虐": {
        onyomi: ["ギャク"],
        kunyomi: ["しいた.げる"],
        examples: [
        { word: "虐殺", reading: "ぎゃくさつ", meaning: "slaughter, massacre" },
        { word: "虐待", reading: "ぎゃくたい", meaning: "abuse, ill-treatment, maltreatment" },
        { word: "残虐", reading: "ざんぎゃく", meaning: "cruel, brutal, savage" },
        { word: "暴虐", reading: "ぼうぎゃく", meaning: "tyranny, atrocity" }
    ],
    },
    "九": {
        onyomi: ["キュウ", "ク"],
        kunyomi: ["ここの", "ここの.つ"],
        examples: [
        { word: "九つ", reading: "ここのつ", meaning: "nine" },
        { word: "九九", reading: "くく", meaning: "multiplication table, times table" },
        { word: "九月", reading: "くがつ", meaning: "September" },
        { word: "九州", reading: "きゅうしゅう", meaning: "Kyūshū (southernmost of the four main islands of Japan)" }
    ],
    },
    "久": {
        onyomi: ["キュウ", "ク"],
        kunyomi: ["ひさ.しい"],
        examples: [
        { word: "恒久", reading: "こうきゅう", meaning: "permanence, perpetuity" },
        { word: "持久", reading: "じきゅう", meaning: "endurance, persistence" },
        { word: "耐久", reading: "たいきゅう", meaning: "endurance, persistence" },
        { word: "長久", reading: "ちょうきゅう", meaning: "permanence, perpetuity" }
    ],
    },
    "及": {
        onyomi: ["キュウ"],
        kunyomi: ["およ.ぶ", "およ.び", "および", "およ.ぼす"],
        examples: [
        { word: "及び", reading: "および", meaning: "and, as well as" },
        { word: "及ぶ", reading: "およぶ", meaning: "to reach, to amount to, to befall" },
        { word: "言及", reading: "げんきゅう", meaning: "reference, allusion" },
        { word: "追及", reading: "ついきゅう", meaning: "investigation (e.g. into someone's guilt), questioning, pressing" }
    ],
    },
    "弓": {
        onyomi: ["キュウ"],
        kunyomi: ["ゆみ"],
        examples: [
        { word: "弓道", reading: "きゅうどう", meaning: "kyūdō, kyudo, Japanese archery" },
        { word: "弓矢", reading: "ゆみや", meaning: "bow and arrow" },
        { word: "弓", reading: "ゆみ", meaning: "bow (weapon)" }
    ],
    },
    "丘": {
        onyomi: ["キュウ"],
        kunyomi: ["おか"],
        examples: [
        { word: "丘陵", reading: "きゅうりょう", meaning: "hill, hillock" },
        { word: "砂丘", reading: "さきゅう", meaning: "sand dune, sand hill" },
        { word: "丘", reading: "おか", meaning: "hill, height, knoll" }
    ],
    },
    "旧": {
        onyomi: ["キュウ"],
        kunyomi: ["ふる.い", "もと"],
        examples: [
        { word: "旧式", reading: "きゅうしき", meaning: "old type, old style" },
        { word: "旧制", reading: "きゅうせい", meaning: "old system, old order" },
        { word: "旧姓", reading: "きゅうせい", meaning: "one's original family name, maiden name" },
        { word: "旧態", reading: "きゅうたい", meaning: "old state of affairs" }
    ],
    },
    "休": {
        onyomi: ["キュウ"],
        kunyomi: ["やす.む", "やす.まる", "やす.める"],
        examples: [
        { word: "運休", reading: "うんきゅう", meaning: "suspension (of a transportation service), cancellation, stoppage" },
        { word: "休み", reading: "やすみ", meaning: "rest, recess, respite" },
        { word: "休む", reading: "やすむ", meaning: "to be absent, to take a day off" },
        { word: "休暇", reading: "きゅうか", meaning: "holiday, vacation, day off" }
    ],
    },
    "吸": {
        onyomi: ["キュウ"],
        kunyomi: ["す.う"],
        examples: [
        { word: "吸う", reading: "すう", meaning: "to breathe in, to inhale, to smoke (a cigarette, etc.)" },
        { word: "吸引", reading: "きゅういん", meaning: "absorption, suction, aspiration" },
        { word: "吸収", reading: "きゅうしゅう", meaning: "absorption, suction, attraction" },
        { word: "吸入", reading: "きゅうにゅう", meaning: "inhalation" }
    ],
    },
    "朽": {
        onyomi: ["キュウ"],
        kunyomi: ["く.ちる"],
        examples: [
        { word: "不朽", reading: "ふきゅう", meaning: "everlasting, immortal, eternal" },
        { word: "老朽", reading: "ろうきゅう", meaning: "infirmity (due to old age), decrepitude, senility" }
    ],
    },
    "臼": {
        onyomi: ["キュウ", "グ"],
        kunyomi: ["うす", "うすづ.く"],
        examples: [
        { word: "臼歯", reading: "きゅうし", meaning: "molar (tooth), grinder, premolar" },
        { word: "臼砲", reading: "きゅうほう", meaning: "mortar" },
        { word: "厚臼", reading: "あつうす", meaning: "stone hand mill" },
        { word: "上臼", reading: "うわうす", meaning: "upper millstone" }
    ],
    },
    "求": {
        onyomi: ["キュウ", "グ"],
        kunyomi: ["もと.める"],
        examples: [
        { word: "求刑", reading: "きゅうけい", meaning: "recommended sentence, prosecution's demand for punishment" },
        { word: "求職", reading: "きゅうしょく", meaning: "job hunting, seeking employment" },
        { word: "求人", reading: "きゅうじん", meaning: "recruiting, job offer, job vacancy" },
        { word: "請求", reading: "せいきゅう", meaning: "claim, demand, charge" }
    ],
    },
    "究": {
        onyomi: ["キュウ", "ク"],
        kunyomi: ["きわ.める"],
        examples: [
        { word: "学究", reading: "がっきゅう", meaning: "scholar, student" },
        { word: "究極", reading: "きゅうきょく", meaning: "ultimate, final, last" },
        { word: "究明", reading: "きゅうめい", meaning: "investigation (esp. in academic and scientific contexts), finding out the facts, bringing (a matter) to light" },
        { word: "研究", reading: "けんきゅう", meaning: "research, study, investigation" }
    ],
    },
    "泣": {
        onyomi: ["キュウ"],
        kunyomi: ["な.く"],
        examples: [
        { word: "泣き", reading: "なき", meaning: "weeping, lamenting" },
        { word: "泣く", reading: "なく", meaning: "to cry, to shed tears, to weep" },
        { word: "号泣", reading: "ごうきゅう", meaning: "crying loudly, bawling, wailing" },
        { word: "泣き声", reading: "なきごえ", meaning: "cry (e.g. of a baby), sob, whine" }
    ],
    },
    "急": {
        onyomi: ["キュウ"],
        kunyomi: ["いそ.ぐ", "いそ.ぎ", "せ.く"],
        examples: [
        { word: "応急", reading: "おうきゅう", meaning: "emergency fix, tentative measure, temporary solution" },
        { word: "緩急", reading: "かんきゅう", meaning: "high and low speed, fast and slow, pace" },
        { word: "危急", reading: "ききゅう", meaning: "emergency, crisis, imminent danger" },
        { word: "急ぎ", reading: "いそぎ", meaning: "haste, hurry, urgency" }
    ],
    },
    "級": {
        onyomi: ["キュウ"],
        kunyomi: [],
        examples: [
        { word: "一級", reading: "いっきゅう", meaning: "one grade, first-class, primary" },
        { word: "下級", reading: "かきゅう", meaning: "lower grade, low class, junior (officer)" },
        { word: "階級", reading: "かいきゅう", meaning: "(social) class" },
        { word: "学級", reading: "がっきゅう", meaning: "(school) class" }
    ],
    },
    "糾": {
        onyomi: ["キュウ"],
        kunyomi: ["ただ.す"],
        examples: [
        { word: "糾合", reading: "きゅうごう", meaning: "rally, muster" },
        { word: "糾弾", reading: "きゅうだん", meaning: "censure, denunciation, (verbal) attack" },
        { word: "紛糾", reading: "ふんきゅう", meaning: "complication, confusion, disorder" }
    ],
    },
    "宮": {
        onyomi: ["キュウ", "グウ", "ク", "クウ"],
        kunyomi: ["みや"],
        examples: [
        { word: "王宮", reading: "おうきゅう", meaning: "royal palace" },
        { word: "宮中", reading: "きゅうちゅう", meaning: "imperial court" },
        { word: "宮廷", reading: "きゅうてい", meaning: "imperial court, royal court" },
        { word: "宮殿", reading: "きゅうでん", meaning: "palace" }
    ],
    },
    "救": {
        onyomi: ["キュウ"],
        kunyomi: ["すく.う"],
        examples: [
        { word: "救い", reading: "すくい", meaning: "help, rescue, aid" },
        { word: "救う", reading: "すくう", meaning: "to rescue (someone), to save, to help (out of a difficulty)" },
        { word: "救援", reading: "きゅうえん", meaning: "relief, rescue" },
        { word: "救急", reading: "きゅうきゅう", meaning: "first-aid, emergency (aid)" }
    ],
    },
    "球": {
        onyomi: ["キュウ"],
        kunyomi: ["たま"],
        examples: [
        { word: "気球", reading: "ききゅう", meaning: "balloon (hot-air, weather, etc.), blimp" },
        { word: "球技", reading: "きゅうぎ", meaning: "ball game (e.g. baseball, tennis, soccer)" },
        { word: "球菌", reading: "きゅうきん", meaning: "coccus" },
        { word: "球場", reading: "きゅうじょう", meaning: "baseball stadium, ballpark" }
    ],
    },
    "給": {
        onyomi: ["キュウ"],
        kunyomi: ["たま.う", "たも.う", "-たま.え"],
        examples: [
        { word: "恩給", reading: "おんきゅう", meaning: "pension (esp. public servant's)" },
        { word: "給食", reading: "きゅうしょく", meaning: "provision of lunch (e.g. at office, school, etc.), providing a meal, lunch service" },
        { word: "給水", reading: "きゅうすい", meaning: "water supply, supplied water, water refill" },
        { word: "給付", reading: "きゅうふ", meaning: "provision (of money or goods), furnishing, conferral" }
    ],
    },
    "嗅": {
        onyomi: ["キュウ"],
        kunyomi: ["か.ぐ"],
        examples: [
        { word: "嗅ぐ", reading: "かぐ", meaning: "to sniff, to smell" }
    ],
    },
    "窮": {
        onyomi: ["キュウ", "キョウ"],
        kunyomi: ["きわ.める", "きわ.まる", "きわ.まり", "きわ.み"],
        examples: [
        { word: "窮屈", reading: "きゅうくつ", meaning: "narrow, tight, cramped" },
        { word: "窮状", reading: "きゅうじょう", meaning: "distress, wretched condition" },
        { word: "窮地", reading: "きゅうち", meaning: "dilemma, predicament" },
        { word: "窮乏", reading: "きゅうぼう", meaning: "poverty, destitution, privation" }
    ],
    },
    "牛": {
        onyomi: ["ギュウ"],
        kunyomi: ["うし"],
        examples: [
        { word: "牛舎", reading: "ぎゅうしゃ", meaning: "cow shed, cattle barn" },
        { word: "牛肉", reading: "ぎゅうにく", meaning: "beef" },
        { word: "牛乳", reading: "ぎゅうにゅう", meaning: "(cow's) milk" },
        { word: "水牛", reading: "すいぎゅう", meaning: "water buffalo (Bubalus bubalis), domestic Asian water buffalo" }
    ],
    },
    "去": {
        onyomi: ["キョ", "コ"],
        kunyomi: ["さ.る", "-さ.る"],
        examples: [
        { word: "過去", reading: "かこ", meaning: "the past, bygone days" },
        { word: "去る", reading: "さる", meaning: "to leave, to go away" },
        { word: "去就", reading: "きょしゅう", meaning: "leaving or staying" },
        { word: "去年", reading: "きょねん", meaning: "last year" }
    ],
    },
    "巨": {
        onyomi: ["キョ"],
        kunyomi: [],
        examples: [
        { word: "巨額", reading: "きょがく", meaning: "huge sum (esp. of money), enormous sum, massive amount" },
        { word: "巨漢", reading: "きょかん", meaning: "giant" },
        { word: "巨匠", reading: "きょしょう", meaning: "master, masterhand, maestro" },
        { word: "巨人", reading: "きょじん", meaning: "giant, great man" }
    ],
    },
    "居": {
        onyomi: ["キョ", "コ"],
        kunyomi: ["い.る", "-い", "お.る"],
        examples: [
        { word: "隠居", reading: "いんきょ", meaning: "retirement (from work), leading a quiet life (after retirement)" },
        { word: "居間", reading: "いま", meaning: "living room (Western style), sitting room" },
        { word: "居候", reading: "いそうろう", meaning: "lodger who pays nothing for room and board, freeloader, sponger" },
        { word: "居住", reading: "きょじゅう", meaning: "residence, living (at, in), abode" }
    ],
    },
    "拒": {
        onyomi: ["キョ", "ゴ"],
        kunyomi: ["こば.む"],
        examples: [
        { word: "拒む", reading: "こばむ", meaning: "to refuse, to reject, to decline" },
        { word: "拒絶", reading: "きょぜつ", meaning: "refusal, rejection" },
        { word: "拒否", reading: "きょひ", meaning: "refusal, rejection, denial" },
        { word: "拒否権", reading: "きょひけん", meaning: "right of veto" }
    ],
    },
    "拠": {
        onyomi: ["キョ", "コ"],
        kunyomi: ["よ.る"],
        examples: [
        { word: "拠点", reading: "きょてん", meaning: "base (of operations), site, location" },
        { word: "根拠", reading: "こんきょ", meaning: "basis, grounds, foundation" },
        { word: "準拠", reading: "じゅんきょ", meaning: "being based on, following (a rule, guidelines, etc.), conforming to (standards, regulations, etc.)" },
        { word: "証拠", reading: "しょうこ", meaning: "evidence, proof" }
    ],
    },
    "挙": {
        onyomi: ["キョ"],
        kunyomi: ["あ.げる", "あ.がる", "こぞ.る"],
        examples: [
        { word: "一挙", reading: "いっきょ", meaning: "one effort, one action" },
        { word: "快挙", reading: "かいきょ", meaning: "brilliant achievement, spectacular feat, splendid accomplishment" },
        { word: "挙式", reading: "きょしき", meaning: "holding a ceremony, wedding ceremony" },
        { word: "挙党", reading: "きょとう", meaning: "whole party, party as a whole" }
    ],
    },
    "虚": {
        onyomi: ["キョ", "コ"],
        kunyomi: ["むな.しい", "うつ.ろ"],
        examples: [
        { word: "虚栄", reading: "きょえい", meaning: "vanity, vainglory" },
        { word: "虚偽", reading: "きょぎ", meaning: "falsehood, untruth, lie" },
        { word: "虚空", reading: "こくう", meaning: "empty space, empty sky" },
        { word: "虚構", reading: "きょこう", meaning: "fiction, fabrication, concoction" }
    ],
    },
    "許": {
        onyomi: ["キョ"],
        kunyomi: ["ゆる.す", "もと"],
        examples: [
        { word: "許し", reading: "ゆるし", meaning: "pardon, forgiveness, exemption" },
        { word: "許す", reading: "ゆるす", meaning: "to permit, to allow, to approve" },
        { word: "許可", reading: "きょか", meaning: "permission, approval, authorization" },
        { word: "許諾", reading: "きょだく", meaning: "consent, assent, approval" }
    ],
    },
    "距": {
        onyomi: ["キョ"],
        kunyomi: ["へだ.たる", "けづめ"],
        examples: [
        { word: "距離", reading: "きょり", meaning: "distance, range, interval" },
        { word: "遠距離", reading: "えんきょり", meaning: "long distance, long range" },
        { word: "近距離", reading: "きんきょり", meaning: "short distance, close range" },
        { word: "短距離", reading: "たんきょり", meaning: "short distance, short range, short-haul" }
    ],
    },
    "魚": {
        onyomi: ["ギョ"],
        kunyomi: ["うお", "さかな", "-ざかな"],
        examples: [
        { word: "魚屋", reading: "さかなや", meaning: "fish market, fish dealer, fishmonger" },
        { word: "魚介", reading: "ぎょかい", meaning: "marine products, seafood, fish and shellfish" },
        { word: "魚群", reading: "ぎょぐん", meaning: "school of fish, shoal of fish" },
        { word: "魚肉", reading: "ぎょにく", meaning: "fish meat" }
    ],
    },
    "御": {
        onyomi: ["ギョ", "ゴ"],
        kunyomi: ["おん-", "お-", "み-"],
        examples: [
        { word: "御苑", reading: "ぎょえん", meaning: "imperial garden" },
        { word: "御社", reading: "おんしゃ", meaning: "your company" },
        { word: "御所", reading: "ごしょ", meaning: "imperial palace (esp. Kyoto Imperial Palace), imperial residence, residence of a shogun, minister, etc." },
        { word: "御中", reading: "おんちゅう", meaning: "... and Company, Messrs, for the attention of ..." }
    ],
    },
    "漁": {
        onyomi: ["ギョ", "リョウ"],
        kunyomi: ["あさ.る"],
        examples: [
        { word: "漁る", reading: "あさる", meaning: "to look for, to search for, to hunt for" },
        { word: "漁獲", reading: "ぎょかく", meaning: "fishery, fishing, catch" },
        { word: "漁業", reading: "ぎょぎょう", meaning: "fishing industry, fishery" },
        { word: "漁港", reading: "ぎょこう", meaning: "fishing harbour, fishing harbor" }
    ],
    },
    "凶": {
        onyomi: ["キョウ"],
        kunyomi: [],
        examples: [
        { word: "凶作", reading: "きょうさく", meaning: "bad harvest, poor crop" },
        { word: "元凶", reading: "げんきょう", meaning: "ringleader, main culprit" },
        { word: "凶悪", reading: "きょうあく", meaning: "atrocious, heinous, fiendish" },
        { word: "凶器", reading: "きょうき", meaning: "dangerous weapon, lethal weapon, deadly weapon" }
    ],
    },
    "共": {
        onyomi: ["キョウ"],
        kunyomi: ["とも", "とも.に", "-ども"],
        examples: [
        { word: "共に", reading: "ともに", meaning: "together, jointly" },
        { word: "共栄", reading: "きょうえい", meaning: "mutual prosperity" },
        { word: "共演", reading: "きょうえん", meaning: "appearing together (in a film, play, etc.), performing together (at a concert, etc.), acting together" },
        { word: "共学", reading: "きょうがく", meaning: "coeducation, mixed-sex education" }
    ],
    },
    "叫": {
        onyomi: ["キョウ"],
        kunyomi: ["さけ.ぶ"],
        examples: [
        { word: "叫び", reading: "さけび", meaning: "shout, cry, outcry" },
        { word: "叫ぶ", reading: "さけぶ", meaning: "to shout, to cry (out), to scream" },
        { word: "絶叫", reading: "ぜっきょう", meaning: "scream, shriek, shout" },
        { word: "叫び声", reading: "さけびごえ", meaning: "shout, yell, scream" }
    ],
    },
    "狂": {
        onyomi: ["キョウ"],
        kunyomi: ["くる.う", "くる.おしい", "くるお.しい"],
        examples: [
        { word: "狂う", reading: "くるう", meaning: "to go mad, to lose one's mind, to go crazy" },
        { word: "狂気", reading: "きょうき", meaning: "madness, insanity" },
        { word: "狂言", reading: "きょうげん", meaning: "kyogen, farce presented between noh plays or during the interlude of a noh play" },
        { word: "狂奔", reading: "きょうほん", meaning: "rushing around, running wild" }
    ],
    },
    "京": {
        onyomi: ["キョウ", "ケイ", "キン"],
        kunyomi: ["みやこ"],
        examples: [
        { word: "帰京", reading: "ききょう", meaning: "returning (home) to Tokyo, returning to the capital" },
        { word: "京阪", reading: "けいはん", meaning: "Kyoto and Osaka, Kyoto-Osaka area" },
        { word: "上京", reading: "じょうきょう", meaning: "going (up) to the capital, going to Tokyo" },
        { word: "中京", reading: "ちゅうきょう", meaning: "Nagoya (city)" }
    ],
    },
    "享": {
        onyomi: ["キョウ", "コウ"],
        kunyomi: ["う.ける"],
        examples: [
        { word: "享受", reading: "きょうじゅ", meaning: "enjoyment (of freedom, beauty, etc.), reception (of a right, privilege, rank, etc.), having" }
    ],
    },
    "供": {
        onyomi: ["キョウ", "ク", "クウ", "グ"],
        kunyomi: ["そな.える", "とも", "-ども"],
        examples: [
        { word: "供給", reading: "きょうきゅう", meaning: "supply, provision, service" },
        { word: "供出", reading: "きょうしゅつ", meaning: "obligatory supply (of goods to the government, e.g. during wartime), delivery (to the government at a fixed price, e.g. of rice)" },
        { word: "供述", reading: "きょうじゅつ", meaning: "affidavit, deposition, testimony" },
        { word: "供物", reading: "くもつ", meaning: "offering (e.g. to the gods), votive offering" }
    ],
    },
    "協": {
        onyomi: ["キョウ"],
        kunyomi: [],
        examples: [
        { word: "協会", reading: "きょうかい", meaning: "association, society, organization" },
        { word: "協議", reading: "きょうぎ", meaning: "conference, consultation, discussion" },
        { word: "協賛", reading: "きょうさん", meaning: "support, mutual aid, cooperation" },
        { word: "協調", reading: "きょうちょう", meaning: "cooperation, conciliation, harmony" }
    ],
    },
    "況": {
        onyomi: ["キョウ"],
        kunyomi: ["まし.て", "いわ.んや", "おもむき"],
        examples: [
        { word: "概況", reading: "がいきょう", meaning: "outlook, general situation" },
        { word: "活況", reading: "かっきょう", meaning: "activity, briskness, prosperity" },
        { word: "近況", reading: "きんきょう", meaning: "recent state, present state, present condition" },
        { word: "現況", reading: "げんきょう", meaning: "present condition" }
    ],
    },
    "峡": {
        onyomi: ["キョウ", "コウ"],
        kunyomi: ["はざま"],
        examples: [
        { word: "海峡", reading: "かいきょう", meaning: "channel (e.g. between two land masses), strait" },
        { word: "峡谷", reading: "きょうこく", meaning: "gorge, ravine, canyon" }
    ],
    },
    "挟": {
        onyomi: ["キョウ", "ショウ"],
        kunyomi: ["はさ.む", "はさ.まる", "わきばさ.む", "さしはさ.む"],
        examples: [
        { word: "挟む", reading: "はさむ", meaning: "to hold between (e.g. one's fingers, chopsticks), to grip (from both sides)" },
        { word: "挟まる", reading: "はさまる", meaning: "to get between, to be caught in" },
        { word: "挟み撃ち", reading: "はさみうち", meaning: "attack on both sides, pincer movement, double envelopment" }
    ],
    },
    "狭": {
        onyomi: ["キョウ", "コウ"],
        kunyomi: ["せま.い", "せば.める", "せば.まる", "さ"],
        examples: [
        { word: "狭い", reading: "せまい", meaning: "narrow, confined, small" },
        { word: "偏狭", reading: "へんきょう", meaning: "narrow-mindedness, intolerance, illiberality" },
        { word: "狭間", reading: "はざま", meaning: "gap, narrow space between things, interstice" },
        { word: "狭まる", reading: "せばまる", meaning: "to narrow, to contract" }
    ],
    },
    "恐": {
        onyomi: ["キョウ"],
        kunyomi: ["おそ.れる", "おそ.る", "おそ.ろしい", "こわ.い", "こわ.がる"],
        examples: [
        { word: "恐れ", reading: "おそれ", meaning: "fear, horror, anxiety" },
        { word: "恐喝", reading: "きょうかつ", meaning: "blackmail, extortion, threat (to extort money)" },
        { word: "恐慌", reading: "きょうこう", meaning: "panic, scare, alarm" },
        { word: "恐縮", reading: "きょうしゅく", meaning: "feeling (much) obliged, being (very) grateful, being thankful" }
    ],
    },
    "恭": {
        onyomi: ["キョウ"],
        kunyomi: ["うやうや.しい"],
        examples: [
        { word: "恭敬", reading: "きょうけい", meaning: "respect, reverence, veneration" },
        { word: "恭謙", reading: "きょうけん", meaning: "modesty, humility" },
        { word: "恭順", reading: "きょうじゅん", meaning: "allegiance, obedience, submission" },
        { word: "恭倹", reading: "きょうけん", meaning: "respectfulness and modesty, deference" }
    ],
    },
    "胸": {
        onyomi: ["キョウ"],
        kunyomi: ["むね", "むな-"],
        examples: [
        { word: "胸襟", reading: "きょうきん", meaning: "one's heart" },
        { word: "胸像", reading: "きょうぞう", meaning: "bust (sculpture), half-length portrait" },
        { word: "胸中", reading: "きょうちゅう", meaning: "one's heart, one's mind, one's intentions" },
        { word: "胸部", reading: "きょうぶ", meaning: "chest, breast" }
    ],
    },
    "脅": {
        onyomi: ["キョウ"],
        kunyomi: ["おびや.かす", "おど.す", "おど.かす"],
        examples: [
        { word: "脅す", reading: "おどす", meaning: "to threaten, to menace, to frighten (into doing)" },
        { word: "脅威", reading: "きょうい", meaning: "threat, menace" },
        { word: "脅迫", reading: "きょうはく", meaning: "threat, menace, coercion" },
        { word: "脅し", reading: "おどし", meaning: "threat" }
    ],
    },
    "強": {
        onyomi: ["キョウ", "ゴウ"],
        kunyomi: ["つよ.い", "つよ.まる", "つよ.める", "し.いる", "こわ.い"],
        examples: [
        { word: "頑強", reading: "がんきょう", meaning: "stubborn, dogged, persistent" },
        { word: "強い", reading: "つよい", meaning: "strong, potent, competent" },
        { word: "強さ", reading: "つよさ", meaning: "strength, power" },
        { word: "強み", reading: "つよみ", meaning: "forte, strong point" }
    ],
    },
    "教": {
        onyomi: ["キョウ"],
        kunyomi: ["おし.える", "おそ.わる"],
        examples: [
        { word: "教え", reading: "おしえ", meaning: "teaching, instruction, teachings" },
        { word: "教育", reading: "きょういく", meaning: "education, schooling, training" },
        { word: "教員", reading: "きょういん", meaning: "teacher, instructor, teaching staff" },
        { word: "教科", reading: "きょうか", meaning: "subject, curriculum" }
    ],
    },
    "郷": {
        onyomi: ["キョウ", "ゴウ"],
        kunyomi: ["さと"],
        examples: [
        { word: "郷愁", reading: "きょうしゅう", meaning: "nostalgia, homesickness" },
        { word: "郷土", reading: "きょうど", meaning: "native place, birth-place, one's old home" },
        { word: "郷里", reading: "きょうり", meaning: "hometown, birthplace" },
        { word: "同郷", reading: "どうきょう", meaning: "(being from the) same town (province, birthplace, etc.)" }
    ],
    },
    "境": {
        onyomi: ["キョウ", "ケイ"],
        kunyomi: ["さかい"],
        examples: [
        { word: "越境", reading: "えっきょう", meaning: "crossing a border (illegally), border violation, border transgression" },
        { word: "佳境", reading: "かきょう", meaning: "most interesting part (of a story), climax, good part" },
        { word: "環境", reading: "かんきょう", meaning: "environment, surroundings, circumstances" },
        { word: "逆境", reading: "ぎゃっきょう", meaning: "adverse circumstances, unfortunate situation, adversity" }
    ],
    },
    "橋": {
        onyomi: ["キョウ"],
        kunyomi: ["はし"],
        examples: [
        { word: "橋脚", reading: "きょうきゃく", meaning: "bridge pier, pontoon bridge" },
        { word: "桟橋", reading: "さんばし", meaning: "wharf, bridge, jetty" },
        { word: "石橋", reading: "いしばし", meaning: "stone bridge" },
        { word: "鉄橋", reading: "てっきょう", meaning: "railway bridge, iron bridge" }
    ],
    },
    "矯": {
        onyomi: ["キョウ"],
        kunyomi: ["た.める"],
        examples: [
        { word: "矯正", reading: "きょうせい", meaning: "correction (of a fault, defect, flaw, etc.), remedy, rectification" }
    ],
    },
    "鏡": {
        onyomi: ["キョウ", "ケイ"],
        kunyomi: ["かがみ"],
        examples: [
        { word: "鏡台", reading: "きょうだい", meaning: "dresser, dressing table, vanity table" },
        { word: "眼鏡", reading: "めがね", meaning: "glasses, eyeglasses, spectacles" },
        { word: "顕微鏡", reading: "けんびきょう", meaning: "microscope" },
        { word: "双眼鏡", reading: "そうがんきょう", meaning: "binoculars, field glasses" }
    ],
    },
    "競": {
        onyomi: ["キョウ", "ケイ"],
        kunyomi: ["きそ.う", "せ.る", "くら.べる"],
        examples: [
        { word: "競う", reading: "きそう", meaning: "to compete, to contend, to vie" },
        { word: "競る", reading: "せる", meaning: "to compete" },
        { word: "競泳", reading: "きょうえい", meaning: "competitive swimming, swimming race" },
        { word: "競演", reading: "きょうえん", meaning: "contest (between performers), competitive performance" }
    ],
    },
    "響": {
        onyomi: ["キョウ"],
        kunyomi: ["ひび.く"],
        examples: [
        { word: "影響", reading: "えいきょう", meaning: "influence, effect, impact" },
        { word: "音響", reading: "おんきょう", meaning: "sound, noise, audio" },
        { word: "響く", reading: "ひびく", meaning: "to resound, to be heard far away" },
        { word: "反響", reading: "はんきょう", meaning: "echo, reverberation" }
    ],
    },
    "驚": {
        onyomi: ["キョウ"],
        kunyomi: ["おどろ.く", "おどろ.かす"],
        examples: [
        { word: "驚き", reading: "おどろき", meaning: "surprise, astonishment, wonder" },
        { word: "驚く", reading: "おどろく", meaning: "to be surprised, to be taken aback, to be amazed" },
        { word: "驚異", reading: "きょうい", meaning: "wonder, miracle, amazement" },
        { word: "驚嘆", reading: "きょうたん", meaning: "wonder, admiration, being struck with admiration" }
    ],
    },
    "仰": {
        onyomi: ["ギョウ", "コウ"],
        kunyomi: ["あお.ぐ", "おお.せ", "お.っしゃる", "おっしゃ.る"],
        examples: [
        { word: "仰ぐ", reading: "あおぐ", meaning: "to look up (at)" },
        { word: "仰る", reading: "おっしゃる", meaning: "to say, to speak, to tell" },
        { word: "仰天", reading: "ぎょうてん", meaning: "being amazed, being horrified, being taken aback" },
        { word: "信仰", reading: "しんこう", meaning: "(religious) faith, belief, creed" }
    ],
    },
    "暁": {
        onyomi: ["ギョウ", "キョウ"],
        kunyomi: ["あかつき", "さと.る"],
        examples: [
        { word: "暁星", reading: "ぎょうせい", meaning: "morning star, Venus, rarity" },
        { word: "暁", reading: "あかつき", meaning: "dawn, daybreak" }
    ],
    },
    "業": {
        onyomi: ["ギョウ", "ゴウ"],
        kunyomi: ["わざ"],
        examples: [
        { word: "偉業", reading: "いぎょう", meaning: "great achievement, great feat, great work" },
        { word: "営業", reading: "えいぎょう", meaning: "business, trade, operations" },
        { word: "家業", reading: "かぎょう", meaning: "family business, family trade" },
        { word: "稼業", reading: "かぎょう", meaning: "trade, business, occupation" }
    ],
    },
    "凝": {
        onyomi: ["ギョウ"],
        kunyomi: ["こ.る", "こ.らす", "こご.らす", "こご.らせる", "こご.る"],
        examples: [
        { word: "凝る", reading: "こる", meaning: "to become stiff (of muscles)" },
        { word: "凝固", reading: "ぎょうこ", meaning: "coagulation, freezing, solidification" },
        { word: "凝視", reading: "ぎょうし", meaning: "stare, gaze, fixation" },
        { word: "凝縮", reading: "ぎょうしゅく", meaning: "condensation (of ideas, emotions, etc.), concentration" }
    ],
    },
    "曲": {
        onyomi: ["キョク"],
        kunyomi: ["ま.がる", "ま.げる", "くま"],
        examples: [
        { word: "一曲", reading: "いっきょく", meaning: "tune (melody, piece of music)" },
        { word: "歌曲", reading: "かきょく", meaning: "melody, tune, song" },
        { word: "楽曲", reading: "がっきょく", meaning: "musical composition, tune" },
        { word: "戯曲", reading: "ぎきょく", meaning: "drama, play" }
    ],
    },
    "局": {
        onyomi: ["キョク"],
        kunyomi: ["つぼね"],
        examples: [
        { word: "医局", reading: "いきょく", meaning: "medical office (esp. in a hospital), doctor's office" },
        { word: "一局", reading: "いっきょく", meaning: "one game (of go, shogi, etc.)" },
        { word: "開局", reading: "かいきょく", meaning: "opening (of a broadcasting station, post office, bureau, etc.), establishment" },
        { word: "局員", reading: "きょくいん", meaning: "clerk, (bureau, post-office) staff" }
    ],
    },
    "極": {
        onyomi: ["キョク", "ゴク"],
        kunyomi: ["きわ.める", "きわ.まる", "きわ.まり", "きわ.み", "き.める", "-ぎ.め", "き.まる"],
        examples: [
        { word: "究極", reading: "きゅうきょく", meaning: "ultimate, final, last" },
        { word: "極み", reading: "きわみ", meaning: "height, acme, extremity" },
        { word: "極右", reading: "きょくう", meaning: "far right (in politics), extreme right, ultraright" },
        { word: "極楽", reading: "ごくらく", meaning: "Sukhavati (Amitabha's Pure Land)" }
    ],
    },
    "玉": {
        onyomi: ["ギョク"],
        kunyomi: ["たま", "たま-", "-だま"],
        examples: [
        { word: "玉砕", reading: "ぎょくさい", meaning: "honorable death, death without surrender, honorable defeat" },
        { word: "珠玉", reading: "しゅぎょく", meaning: "jewel, gem" },
        { word: "水玉", reading: "みずたま", meaning: "drop of water" },
        { word: "目玉", reading: "めだま", meaning: "eyeball" }
    ],
    },
    "巾": {
        onyomi: ["キン", "フク"],
        kunyomi: ["おお.い", "ちきり", "きれ"],
        examples: [
        { word: "雑巾", reading: "ぞうきん", meaning: "house-cloth, dust cloth" },
        { word: "布巾", reading: "ふきん", meaning: "dish towel, tea towel, dishcloth" }
    ],
    },
    "斤": {
        onyomi: ["キン"],
        kunyomi: [],
        examples: [
        { word: "英斤", reading: "ポンド", meaning: "pound (unit of weight)" },
        { word: "一斤", reading: "いっきん", meaning: "1 kin (approx. 0.6 kg)" },
        { word: "斤量", reading: "きんりょう", meaning: "impost, assigned weight" },
        { word: "斤目", reading: "きんめ", meaning: "weight" }
    ],
    },
    "均": {
        onyomi: ["キン"],
        kunyomi: ["なら.す"],
        examples: [
        { word: "均一", reading: "きんいつ", meaning: "uniformity, equality" },
        { word: "均衡", reading: "きんこう", meaning: "balance, equilibrium" },
        { word: "均質", reading: "きんしつ", meaning: "homogeneous, homogeneity" },
        { word: "均整", reading: "きんせい", meaning: "symmetry, balance, proportion" }
    ],
    },
    "近": {
        onyomi: ["キン", "コン"],
        kunyomi: ["ちか.い"],
        examples: [
        { word: "間近", reading: "まぢか", meaning: "near, close (to), nearby" },
        { word: "近い", reading: "ちかい", meaning: "near, close, short (distance)" },
        { word: "近く", reading: "ちかく", meaning: "near, neighbourhood, neighborhood" },
        { word: "近海", reading: "きんかい", meaning: "coastal waters, adjacent seas" }
    ],
    },
    "金": {
        onyomi: ["キン", "コン", "ゴン"],
        kunyomi: ["かね", "かな-", "-がね"],
        examples: [
        { word: "お金", reading: "おかね", meaning: "money" },
        { word: "黄金", reading: "おうごん", meaning: "gold (Au)" },
        { word: "換金", reading: "かんきん", meaning: "realization (of goods into money), conversion (into money), liquidation" },
        { word: "基金", reading: "ききん", meaning: "fund, foundation" }
    ],
    },
    "菌": {
        onyomi: ["キン"],
        kunyomi: [],
        examples: [
        { word: "球菌", reading: "きゅうきん", meaning: "coccus" },
        { word: "抗菌", reading: "こうきん", meaning: "antibacterial, antimicrobial" },
        { word: "細菌", reading: "さいきん", meaning: "bacterium, bacteria, germ" },
        { word: "殺菌", reading: "さっきん", meaning: "sterilization, sterilisation, disinfection" }
    ],
    },
    "勤": {
        onyomi: ["キン", "ゴン"],
        kunyomi: ["つと.める", "-づと.め", "つと.まる", "いそ.しむ"],
        examples: [
        { word: "勤め", reading: "つとめ", meaning: "service, duty, business" },
        { word: "勤続", reading: "きんぞく", meaning: "continuous service" },
        { word: "勤勉", reading: "きんべん", meaning: "diligent, hard-working, industrious" },
        { word: "勤務", reading: "きんむ", meaning: "service, duty, work" }
    ],
    },
    "琴": {
        onyomi: ["キン", "ゴン"],
        kunyomi: ["こと"],
        examples: [
        { word: "琴", reading: "こと", meaning: "koto (13-stringed Japanese zither)" }
    ],
    },
    "筋": {
        onyomi: ["キン"],
        kunyomi: ["すじ"],
        examples: [
        { word: "筋道", reading: "すじみち", meaning: "reason, logic" },
        { word: "筋肉", reading: "きんにく", meaning: "muscle" },
        { word: "筋力", reading: "きんりょく", meaning: "physical strength, muscle strength" },
        { word: "粗筋", reading: "あらすじ", meaning: "outline, summary, argument" }
    ],
    },
    "僅": {
        onyomi: ["キン", "ゴン"],
        kunyomi: ["わず.か"],
        examples: [
        { word: "僅か", reading: "わずか", meaning: "a little, a few, small" }
    ],
    },
    "禁": {
        onyomi: ["キン"],
        kunyomi: [],
        examples: [
        { word: "解禁", reading: "かいきん", meaning: "lifting a ban, raising an embargo, opening a season (hunting, fishing, etc.)" },
        { word: "監禁", reading: "かんきん", meaning: "confinement, imprisonment, incarceration" },
        { word: "禁煙", reading: "きんえん", meaning: "abstaining from smoking, quitting smoking" },
        { word: "禁句", reading: "きんく", meaning: "taboo word, forbidden topic" }
    ],
    },
    "緊": {
        onyomi: ["キン"],
        kunyomi: ["し.める", "し.まる"],
        examples: [
        { word: "緊急", reading: "きんきゅう", meaning: "urgency, emergency" },
        { word: "緊縮", reading: "きんしゅく", meaning: "tightening, shrinkage, contraction" },
        { word: "緊張", reading: "きんちょう", meaning: "tension, strain, nervousness" },
        { word: "緊迫", reading: "きんぱく", meaning: "tension, strain" }
    ],
    },
    "錦": {
        onyomi: ["キン"],
        kunyomi: ["にしき"],
        examples: [
        { word: "錦", reading: "にしき", meaning: "brocade" }
    ],
    },
    "謹": {
        onyomi: ["キン"],
        kunyomi: ["つつし.む"],
        examples: [
        { word: "謹慎", reading: "きんしん", meaning: "self restraint, moderating one's own behavior, penitence" },
        { word: "謹賀新年", reading: "きんがしんねん", meaning: "Happy New Year" }
    ],
    },
    "襟": {
        onyomi: ["キン"],
        kunyomi: ["えり"],
        examples: [
        { word: "胸襟", reading: "きょうきん", meaning: "one's heart" },
        { word: "襟元", reading: "えりもと", meaning: "(around the) neck, nape" },
        { word: "襟巻き", reading: "えりまき", meaning: "scarf (esp. one worn for warmth), muffler" },
        { word: "襟", reading: "えり", meaning: "collar, lapel, neckband" }
    ],
    },
    "吟": {
        onyomi: ["ギン"],
        kunyomi: [],
        examples: [
        { word: "吟味", reading: "ぎんみ", meaning: "close examination, careful investigation, close inspection" }
    ],
    },
    "銀": {
        onyomi: ["ギン"],
        kunyomi: ["しろがね"],
        examples: [
        { word: "銀河", reading: "ぎんが", meaning: "Milky Way" },
        { word: "銀貨", reading: "ぎんか", meaning: "silver coin" },
        { word: "銀行", reading: "ぎんこう", meaning: "bank, banking institution" },
        { word: "銀座", reading: "ぎんざ", meaning: "Ginza (district in Tokyo)" }
    ],
    },
    "区": {
        onyomi: ["ク", "オウ", "コウ"],
        kunyomi: [],
        examples: [
        { word: "学区", reading: "がっく", meaning: "school district, school area" },
        { word: "管区", reading: "かんく", meaning: "jurisdiction" },
        { word: "区域", reading: "くいき", meaning: "area, zone, district" },
        { word: "区間", reading: "くかん", meaning: "section (of track, etc.), segment, dimension" }
    ],
    },
    "句": {
        onyomi: ["ク"],
        kunyomi: [],
        examples: [
        { word: "禁句", reading: "きんく", meaning: "taboo word, forbidden topic" },
        { word: "句集", reading: "くしゅう", meaning: "collection of haiku poems" },
        { word: "語句", reading: "ごく", meaning: "words and phrases, words" },
        { word: "絶句", reading: "ぜっく", meaning: "being lost for words, becoming speechless" }
    ],
    },
    "苦": {
        onyomi: ["ク"],
        kunyomi: ["くる.しい", "-ぐる.しい", "くる.しむ", "くる.しめる", "にが.い", "にが.る"],
        examples: [
        { word: "苦い", reading: "にがい", meaning: "bitter (taste)" },
        { word: "苦境", reading: "くきょう", meaning: "difficult situation, adverse circumstances, predicament" },
        { word: "苦言", reading: "くげん", meaning: "candid advice, frank advice, honest opinion" },
        { word: "苦手", reading: "にがて", meaning: "poor (at), weak (in), not very good (at)" }
    ],
    },
    "駆": {
        onyomi: ["ク"],
        kunyomi: ["か.ける", "か.る"],
        examples: [
        { word: "駆る", reading: "かる", meaning: "to spur on, to urge forward, to impel" },
        { word: "駆使", reading: "くし", meaning: "using freely, making full use of, having a good command of" },
        { word: "駆除", reading: "くじょ", meaning: "extermination (of pests), eradication, stamping out (e.g. a social evil)" },
        { word: "駆逐", reading: "くちく", meaning: "expulsion, driving out, driving away" }
    ],
    },
    "具": {
        onyomi: ["グ"],
        kunyomi: ["そな.える", "つぶさ.に"],
        examples: [
        { word: "雨具", reading: "あまぐ", meaning: "rain gear" },
        { word: "家具", reading: "かぐ", meaning: "furniture" },
        { word: "玩具", reading: "おもちゃ", meaning: "toy" },
        { word: "器具", reading: "きぐ", meaning: "utensil, implement, tool" }
    ],
    },
    "惧": {
        onyomi: ["ク", "グ"],
        kunyomi: ["おそ.れる"],
        examples: [
        { word: "危惧", reading: "きぐ", meaning: "apprehension, misgivings, uneasiness" }
    ],
    },
    "愚": {
        onyomi: ["グ"],
        kunyomi: ["おろ.か"],
        examples: [
        { word: "愚か", reading: "おろか", meaning: "foolish, stupid, silly" },
        { word: "愚痴", reading: "ぐち", meaning: "idle complaint, grumble" },
        { word: "愚連隊", reading: "ぐれんたい", meaning: "gang of young toughs, hooligans, hoodlums" },
        { word: "愚", reading: "ぐ", meaning: "foolishness, silliness, stupidity" }
    ],
    },
    "空": {
        onyomi: ["クウ"],
        kunyomi: ["そら", "あ.く", "あ.き", "あ.ける", "から", "す.く", "す.かす", "むな.しい"],
        examples: [
        { word: "架空", reading: "かくう", meaning: "fictitious, imaginary, fanciful" },
        { word: "虚空", reading: "こくう", meaning: "empty space, empty sky" },
        { word: "空間", reading: "くうかん", meaning: "space, room, airspace" },
        { word: "空気", reading: "くうき", meaning: "air, atmosphere" }
    ],
    },
    "偶": {
        onyomi: ["グウ"],
        kunyomi: ["たま"],
        examples: [
        { word: "偶数", reading: "ぐうすう", meaning: "even number" },
        { word: "偶然", reading: "ぐうぜん", meaning: "coincidence, chance, accident" },
        { word: "偶像", reading: "ぐうぞう", meaning: "image, idol, statue" },
        { word: "偶発", reading: "ぐうはつ", meaning: "sudden outbreak, accidental, incidental" }
    ],
    },
    "遇": {
        onyomi: ["グウ"],
        kunyomi: ["あ.う"],
        examples: [
        { word: "境遇", reading: "きょうぐう", meaning: "one's circumstances, environment, situation (in life)" },
        { word: "処遇", reading: "しょぐう", meaning: "treatment (of a person), dealing with" },
        { word: "遭遇", reading: "そうぐう", meaning: "encounter, running into, meeting with (e.g. an accident)" },
        { word: "待遇", reading: "たいぐう", meaning: "treatment, reception, service" }
    ],
    },
    "隅": {
        onyomi: ["グウ"],
        kunyomi: ["すみ"],
        examples: [
        { word: "四隅", reading: "よすみ", meaning: "four corners" },
        { word: "片隅", reading: "かたすみ", meaning: "corner, nook" },
        { word: "一隅", reading: "いちぐう", meaning: "corner, nook" },
        { word: "隅々", reading: "すみずみ", meaning: "every corner, every nook and cranny, all the ins and outs" }
    ],
    },
    "串": {
        onyomi: ["カン", "ケン", "セン"],
        kunyomi: ["くし", "つらぬ.く"],
        examples: [
        { word: "串焼", reading: "くしやき", meaning: "grilling on a skewer, spit-roasting" },
        { word: "串揚", reading: "くしあげ", meaning: "kushiage, deep-fried skewered meat and vegetables" },
        { word: "串戯", reading: "じょうだん", meaning: "joke, jest, funny story" },
        { word: "竹串", reading: "たけぐし", meaning: "bamboo skewer" }
    ],
    },
    "屈": {
        onyomi: ["クツ"],
        kunyomi: ["かが.む", "かが.める"],
        examples: [
        { word: "窮屈", reading: "きゅうくつ", meaning: "narrow, tight, cramped" },
        { word: "屈指", reading: "くっし", meaning: "leading, foremost, preeminent" },
        { word: "屈辱", reading: "くつじょく", meaning: "disgrace, humiliation" },
        { word: "屈折", reading: "くっせつ", meaning: "bending, curving, twisting" }
    ],
    },
    "掘": {
        onyomi: ["クツ"],
        kunyomi: ["ほ.る"],
        examples: [
        { word: "掘る", reading: "ほる", meaning: "to dig, to excavate, to hollow" },
        { word: "採掘", reading: "さいくつ", meaning: "mining, digging, working (a mine)" },
        { word: "発掘", reading: "はっくつ", meaning: "excavation, exhumation, digging up" },
        { word: "掘削", reading: "くっさく", meaning: "digging out, excavation" }
    ],
    },
    "窟": {
        onyomi: ["クツ", "コツ"],
        kunyomi: ["いわや", "いはや", "あな"],
        examples: [
        { word: "洞窟", reading: "どうくつ", meaning: "cave, cavern, grotto" }
    ],
    },
    "熊": {
        onyomi: ["ユウ"],
        kunyomi: ["くま"],
        examples: [
        { word: "熊", reading: "くま", meaning: "bear (any mammal of family Ursidae)" }
    ],
    },
    "繰": {
        onyomi: ["ソウ"],
        kunyomi: ["く.る"],
        examples: [
        { word: "繰る", reading: "くる", meaning: "to reel, to wind, to spin (thread)" },
        { word: "繰入", reading: "くりいれ", meaning: "inward transfer (of money), carry over (money from previous period)" },
        { word: "やり繰り", reading: "やりくり", meaning: "making do, getting by (somehow), managing" },
        { word: "繰り延べ", reading: "くりのべ", meaning: "postponement" }
    ],
    },
    "君": {
        onyomi: ["クン"],
        kunyomi: ["きみ", "-ぎみ"],
        examples: [
        { word: "君子", reading: "くんし", meaning: "man of virtue, wise man, (true) gentleman" },
        { word: "君主", reading: "くんしゅ", meaning: "monarch, sovereign, ruler" },
        { word: "君臨", reading: "くんりん", meaning: "reigning (over a country)" },
        { word: "諸君", reading: "しょくん", meaning: "you (people)" }
    ],
    },
    "訓": {
        onyomi: ["クン", "キン"],
        kunyomi: ["おし.える", "よ.む", "くん.ずる"],
        examples: [
        { word: "音訓", reading: "おんくん", meaning: "kanji readings" },
        { word: "教訓", reading: "きょうくん", meaning: "lesson, precept, teachings" },
        { word: "訓戒", reading: "くんかい", meaning: "warning, admonition, lesson or a phrase that teaches you not to do something" },
        { word: "訓示", reading: "くんじ", meaning: "instruction, direction, briefing" }
    ],
    },
    "勲": {
        onyomi: ["クン"],
        kunyomi: ["いさお"],
        examples: [
        { word: "勲章", reading: "くんしょう", meaning: "decoration, order, medal" },
        { word: "殊勲", reading: "しゅくん", meaning: "distinguished services, meritorious deeds" },
        { word: "叙勲", reading: "じょくん", meaning: "conferring of decorations" },
        { word: "文化勲章", reading: "ぶんかくんしょう", meaning: "Order of Culture (Japan), Order of Cultural Merit (South Korea)" }
    ],
    },
    "薫": {
        onyomi: ["クン"],
        kunyomi: ["かお.る"],
        examples: [
        { word: "薫香", reading: "くんこう", meaning: "incense, fragrance" },
        { word: "薫製", reading: "くんせい", meaning: "smoked food, smoking (fish, meat, etc.)" },
        { word: "薫陶", reading: "くんとう", meaning: "education, training, discipline" },
        { word: "薫風", reading: "くんぷう", meaning: "balmy breeze, summer breeze" }
    ],
    },
    "軍": {
        onyomi: ["グン"],
        kunyomi: ["いくさ"],
        examples: [
        { word: "一軍", reading: "いちぐん", meaning: "an army" },
        { word: "援軍", reading: "えんぐん", meaning: "reinforcement" },
        { word: "海軍", reading: "かいぐん", meaning: "navy, naval force" },
        { word: "空軍", reading: "くうぐん", meaning: "air force" }
    ],
    },
    "郡": {
        onyomi: ["グン"],
        kunyomi: ["こおり"],
        examples: [
        { word: "郡部", reading: "ぐんぶ", meaning: "rural districts, counties" },
        { word: "郡", reading: "ぐん", meaning: "district, county" }
    ],
    },
    "群": {
        onyomi: ["グン"],
        kunyomi: ["む.れる", "む.れ", "むら", "むら.がる"],
        examples: [
        { word: "魚群", reading: "ぎょぐん", meaning: "school of fish, shoal of fish" },
        { word: "群れ", reading: "むれ", meaning: "group, crowd, flock" },
        { word: "群像", reading: "ぐんぞう", meaning: "lively group (esp. of young people), dynamic bunch" },
        { word: "群島", reading: "ぐんとう", meaning: "island group, archipelago" }
    ],
    },
    "兄": {
        onyomi: ["ケイ", "キョウ"],
        kunyomi: ["あに"],
        examples: [
        { word: "義兄", reading: "ぎけい", meaning: "brother-in-law (spouse's older brother or older sister's husband)" },
        { word: "兄貴", reading: "あにき", meaning: "elder brother" },
        { word: "兄弟", reading: "きょうだい", meaning: "brothers and sisters, siblings" },
        { word: "実兄", reading: "じっけい", meaning: "biological older brother" }
    ],
    },
    "刑": {
        onyomi: ["ケイ"],
        kunyomi: [],
        examples: [
        { word: "求刑", reading: "きゅうけい", meaning: "recommended sentence, prosecution's demand for punishment" },
        { word: "刑事", reading: "けいじ", meaning: "(police) detective" },
        { word: "刑罰", reading: "けいばつ", meaning: "(criminal) punishment, penalty, sentence" },
        { word: "刑法", reading: "けいほう", meaning: "criminal law, penal code" }
    ],
    },
    "形": {
        onyomi: ["ケイ", "ギョウ"],
        kunyomi: ["かた", "-がた", "かたち", "なり"],
        examples: [
        { word: "花形", reading: "はながた", meaning: "floral pattern, flourish, ornament" },
        { word: "形見", reading: "かたみ", meaning: "memento (esp. of a deceased person), keepsake, heirloom" },
        { word: "形式", reading: "けいしき", meaning: "form (as opposed to substance)" },
        { word: "形状", reading: "けいじょう", meaning: "shape, form" }
    ],
    },
    "系": {
        onyomi: ["ケイ"],
        kunyomi: [],
        examples: [
        { word: "家系", reading: "かけい", meaning: "family lineage" },
        { word: "系図", reading: "けいず", meaning: "family tree, pedigree, genealogy" },
        { word: "系統", reading: "けいとう", meaning: "system" },
        { word: "系譜", reading: "けいふ", meaning: "genealogy, lineage, family tree" }
    ],
    },
    "径": {
        onyomi: ["ケイ"],
        kunyomi: ["みち", "こみち", "さしわたし", "ただちに"],
        examples: [
        { word: "口径", reading: "こうけい", meaning: "aperture, bore, calibre" },
        { word: "半径", reading: "はんけい", meaning: "radius" },
        { word: "直径", reading: "ちょっけい", meaning: "diameter" }
    ],
    },
    "茎": {
        onyomi: ["ケイ", "キョウ"],
        kunyomi: ["くき"],
        examples: [
        { word: "茎", reading: "くき", meaning: "stalk, stem" }
    ],
    },
    "係": {
        onyomi: ["ケイ"],
        kunyomi: ["かか.る", "かかり", "-がかり", "かか.わる"],
        examples: [
        { word: "関係", reading: "かんけい", meaning: "relation, relationship, connection" },
        { word: "係官", reading: "かかりかん", meaning: "official in charge" },
        { word: "係争", reading: "けいそう", meaning: "dispute, contention, conflict" },
        { word: "係長", reading: "かかりちょう", meaning: "subsection head, assistant manager, chief clerk" }
    ],
    },
    "型": {
        onyomi: ["ケイ"],
        kunyomi: ["かた", "-がた"],
        examples: [
        { word: "原型", reading: "げんけい", meaning: "model, prototype, archetype" },
        { word: "新型", reading: "しんがた", meaning: "new type, new style, new model" },
        { word: "体型", reading: "たいけい", meaning: "figure, body shape, build" },
        { word: "大型", reading: "おおがた", meaning: "large, large-sized, large-scale" }
    ],
    },
    "契": {
        onyomi: ["ケイ"],
        kunyomi: ["ちぎ.る"],
        examples: [
        { word: "契機", reading: "けいき", meaning: "opportunity, chance" },
        { word: "契約", reading: "けいやく", meaning: "contract, compact, agreement" },
        { word: "契約書", reading: "けいやくしょ", meaning: "(written) contract, agreement" }
    ],
    },
    "計": {
        onyomi: ["ケイ"],
        kunyomi: ["はか.る", "はか.らう"],
        examples: [
        { word: "家計", reading: "かけい", meaning: "household economy, family finances" },
        { word: "会計", reading: "かいけい", meaning: "accounting, finance, account" },
        { word: "計画", reading: "けいかく", meaning: "plan, project, schedule" },
        { word: "計器", reading: "けいき", meaning: "meter, gauge" }
    ],
    },
    "恵": {
        onyomi: ["ケイ", "エ"],
        kunyomi: ["めぐ.む", "めぐ.み"],
        examples: [
        { word: "恩恵", reading: "おんけい", meaning: "grace, favor, favour" },
        { word: "恵み", reading: "めぐみ", meaning: "blessing, grace" },
        { word: "恵む", reading: "めぐむ", meaning: "to bless, to show mercy to" },
        { word: "知恵", reading: "ちえ", meaning: "wisdom, wit, sagacity" }
    ],
    },
    "啓": {
        onyomi: ["ケイ"],
        kunyomi: ["ひら.く", "さと.す"],
        examples: [
        { word: "啓示", reading: "けいじ", meaning: "(divine) revelation" },
        { word: "啓発", reading: "けいはつ", meaning: "enlightenment, development, edification" },
        { word: "啓蒙", reading: "けいもう", meaning: "enlightenment, illumination" },
        { word: "拝啓", reading: "はいけい", meaning: "Dear (so and so), Dear Sir, Dear Madam" }
    ],
    },
    "掲": {
        onyomi: ["ケイ"],
        kunyomi: ["かか.げる"],
        examples: [
        { word: "掲載", reading: "けいさい", meaning: "publication (e.g. of an article in a newspaper), carrying (e.g. a story), running (e.g. a serial)" },
        { word: "掲示", reading: "けいじ", meaning: "notice, bulletin, post" },
        { word: "掲揚", reading: "けいよう", meaning: "hoisting (e.g. a flag), raising, flying" },
        { word: "掲げる", reading: "かかげる", meaning: "to put up (a notice, sign, etc.), to hang out (e.g. a banner), to fly (e.g. a flag)" }
    ],
    },
    "渓": {
        onyomi: ["ケイ"],
        kunyomi: ["たに", "たにがわ"],
        examples: [
        { word: "渓谷", reading: "けいこく", meaning: "valley (with a river running through it), gorge, ravine" },
        { word: "渓流", reading: "けいりゅう", meaning: "mountain stream, mountain torrent" },
        { word: "雪渓", reading: "せっけい", meaning: "snowy valley" }
    ],
    },
    "経": {
        onyomi: ["ケイ", "キョウ", "キン"],
        kunyomi: ["へ.る", "た.つ", "たていと", "はか.る", "のり"],
        examples: [
        { word: "経つ", reading: "たつ", meaning: "to pass (of time), to elapse" },
        { word: "経る", reading: "へる", meaning: "to pass, to elapse, to go by" },
        { word: "経緯", reading: "けいい", meaning: "details, particulars, sequence of events" },
        { word: "経営", reading: "けいえい", meaning: "management, administration, operation" }
    ],
    },
    "蛍": {
        onyomi: ["ケイ"],
        kunyomi: ["ほたる"],
        examples: [
        { word: "蛍光灯", reading: "けいこうとう", meaning: "fluorescent lamp, fluorescent light" },
        { word: "蛍", reading: "ほたる", meaning: "firefly (Luciola cruciata), lightning bug, glowworm" }
    ],
    },
    "敬": {
        onyomi: ["ケイ", "キョウ"],
        kunyomi: ["うやま.う"],
        examples: [
        { word: "敬う", reading: "うやまう", meaning: "to show respect for, to revere, to honour" },
        { word: "敬意", reading: "けいい", meaning: "respect, honour, honor" },
        { word: "敬遠", reading: "けいえん", meaning: "pretending to respect (someone) while in fact staying distant, keeping at arm's length, giving a wide berth" },
        { word: "敬具", reading: "けいぐ", meaning: "yours sincerely, sincerely yours, yours truly" }
    ],
    },
    "景": {
        onyomi: ["ケイ"],
        kunyomi: [],
        examples: [
        { word: "景観", reading: "けいかん", meaning: "scenery" },
        { word: "景気", reading: "けいき", meaning: "business conditions, the market, economic activity" },
        { word: "景勝", reading: "けいしょう", meaning: "picturesque scenery, place of scenic beauty" },
        { word: "景色", reading: "けしき", meaning: "scenery, scene, landscape" }
    ],
    },
    "軽": {
        onyomi: ["ケイ", "キョウ", "キン"],
        kunyomi: ["かる.い", "かろ.やか", "かろ.んじる"],
        examples: [
        { word: "気軽", reading: "きがる", meaning: "carefree, buoyant, lighthearted" },
        { word: "軽い", reading: "かるい", meaning: "light (i.e. not heavy), feeling light (i.e. offering little resistance, moving easily)" },
        { word: "軽快", reading: "けいかい", meaning: "light (of movements), nimble, sprightly" },
        { word: "軽減", reading: "けいげん", meaning: "abatement, reduction" }
    ],
    },
    "傾": {
        onyomi: ["ケイ"],
        kunyomi: ["かたむ.く", "かたむ.ける", "かたぶ.く", "かた.げる", "かし.げる"],
        examples: [
        { word: "傾向", reading: "けいこう", meaning: "tendency, trend, inclination" },
        { word: "傾斜", reading: "けいしゃ", meaning: "inclination, slant, slope" },
        { word: "傾注", reading: "けいちゅう", meaning: "devoting (oneself) to, concentrating (one's efforts) on" },
        { word: "傾聴", reading: "けいちょう", meaning: "listening closely" }
    ],
    },
    "携": {
        onyomi: ["ケイ"],
        kunyomi: ["たずさ.える", "たずさ.わる"],
        examples: [
        { word: "携帯", reading: "けいたい", meaning: "carrying (on one's person or in the hand)" },
        { word: "提携", reading: "ていけい", meaning: "cooperation, tie-up, joint business" },
        { word: "必携", reading: "ひっけい", meaning: "indispensable, essential, must-have" },
        { word: "連携", reading: "れんけい", meaning: "cooperation, coordination, collaboration" }
    ],
    },
    "継": {
        onyomi: ["ケイ"],
        kunyomi: ["つ.ぐ", "まま-"],
        examples: [
        { word: "継ぐ", reading: "つぐ", meaning: "to succeed (a person, to a position, etc.), to inherit, to take over" },
        { word: "継承", reading: "けいしょう", meaning: "inheritance, succession, accession" },
        { word: "継続", reading: "けいぞく", meaning: "continuation, continuance, maintenance" },
        { word: "継投", reading: "けいとう", meaning: "relieving the (starting) pitcher" }
    ],
    },
    "詣": {
        onyomi: ["ケイ", "ゲイ"],
        kunyomi: ["けい.する", "まい.る", "いた.る", "もう.でる"],
        examples: [
        { word: "初詣", reading: "はつもうで", meaning: "first shrine visit of the New Year" }
    ],
    },
    "慶": {
        onyomi: ["ケイ"],
        kunyomi: ["よろこ.び"],
        examples: [
        { word: "慶事", reading: "けいじ", meaning: "happy event, auspicious event, matter for congratulation" },
        { word: "慶祝", reading: "けいしゅく", meaning: "congratulation, celebration" },
        { word: "慶弔", reading: "けいちょう", meaning: "congratulations and condolences" },
        { word: "弁慶", reading: "べんけい", meaning: "strong person, person putting on a brave front" }
    ],
    },
    "憬": {
        onyomi: ["ケイ"],
        kunyomi: ["あこが.れる"],
        examples: [
        { word: "憬れ", reading: "あこがれ", meaning: "yearning, longing, aspiration" },
        { word: "憧憬", reading: "どうけい", meaning: "longing, yearning, aspiration" },
        { word: "憬れる", reading: "あこがれる", meaning: "to long for, to yearn for, to hanker after" },
        { word: "憧憬れる", reading: "あこがれる", meaning: "to long for, to yearn for, to hanker after" }
    ],
    },
    "稽": {
        onyomi: ["ケイ"],
        kunyomi: ["かんが.える", "とど.める"],
        examples: [
        { word: "滑稽", reading: "こっけい", meaning: "funny, comical, humorous" },
        { word: "稽古", reading: "けいこ", meaning: "practice, practicing, training" }
    ],
    },
    "憩": {
        onyomi: ["ケイ"],
        kunyomi: ["いこ.い", "いこ.う"],
        examples: [
        { word: "休憩", reading: "きゅうけい", meaning: "rest, break, recess" },
        { word: "憩い", reading: "いこい", meaning: "rest, relaxation" },
        { word: "憩う", reading: "いこう", meaning: "to rest, to relax, to repose" },
        { word: "休憩所", reading: "きゅうけいじょ", meaning: "rest area, rest stop, service area (next to a highway)" }
    ],
    },
    "警": {
        onyomi: ["ケイ"],
        kunyomi: ["いまし.める"],
        examples: [
        { word: "警戒", reading: "けいかい", meaning: "vigilance, caution, alertness" },
        { word: "警官", reading: "けいかん", meaning: "police officer, policeman, constable" },
        { word: "警護", reading: "けいご", meaning: "bodyguard, escort" },
        { word: "警告", reading: "けいこく", meaning: "warning, caution, admonition" }
    ],
    },
    "鶏": {
        onyomi: ["ケイ"],
        kunyomi: ["にわとり", "とり"],
        examples: [
        { word: "鶏肉", reading: "とりにく", meaning: "chicken meat" },
        { word: "鶏卵", reading: "けいらん", meaning: "hen's egg" },
        { word: "養鶏", reading: "ようけい", meaning: "poultry raising, poultry farming, chicken farming" },
        { word: "鶏", reading: "にわとり", meaning: "chicken (Gallus gallus domesticus), domestic chicken" }
    ],
    },
    "芸": {
        onyomi: ["ゲイ", "ウン"],
        kunyomi: ["う.える", "のり", "わざ"],
        examples: [
        { word: "園芸", reading: "えんげい", meaning: "horticulture, gardening" },
        { word: "演芸", reading: "えんげい", meaning: "entertainment, performance" },
        { word: "学芸", reading: "がくげい", meaning: "arts and sciences, liberal arts" },
        { word: "芸者", reading: "げいしゃ", meaning: "geisha, professional female entertainer, usu. at traditional banquets" }
    ],
    },
    "迎": {
        onyomi: ["ゲイ"],
        kunyomi: ["むか.える"],
        examples: [
        { word: "歓迎", reading: "かんげい", meaning: "welcome, (warm) reception" },
        { word: "迎え", reading: "むかえ", meaning: "meeting, greeting, welcome" },
        { word: "迎撃", reading: "げいげき", meaning: "intercept, interception, counter-attack" },
        { word: "迎合", reading: "げいごう", meaning: "ingratiation, pandering, catering (to)" }
    ],
    },
    "鯨": {
        onyomi: ["ゲイ"],
        kunyomi: ["くじら"],
        examples: [
        { word: "鯨肉", reading: "げいにく", meaning: "whale meat" },
        { word: "捕鯨", reading: "ほげい", meaning: "whaling, whale hunting, whale fishing" },
        { word: "鯨", reading: "くじら", meaning: "whale (Cetacea spp.)" }
    ],
    },
    "隙": {
        onyomi: ["ゲキ", "キャク", "ケキ"],
        kunyomi: ["すき", "す.く", "す.かす", "ひま"],
        examples: [
        { word: "隙間", reading: "すきま", meaning: "gap, opening, aperture" },
        { word: "隙", reading: "すき", meaning: "gap, opening, room" }
    ],
    },
    "劇": {
        onyomi: ["ゲキ"],
        kunyomi: [],
        examples: [
        { word: "演劇", reading: "えんげき", meaning: "drama, theatre, theater" },
        { word: "歌劇", reading: "かげき", meaning: "opera" },
        { word: "観劇", reading: "かんげき", meaning: "theatre-going, theater-going" },
        { word: "喜劇", reading: "きげき", meaning: "comedy" }
    ],
    },
    "撃": {
        onyomi: ["ゲキ"],
        kunyomi: ["う.つ"],
        examples: [
        { word: "一撃", reading: "いちげき", meaning: "one blow, one hit, one stroke" },
        { word: "迎撃", reading: "げいげき", meaning: "intercept, interception, counter-attack" },
        { word: "撃つ", reading: "うつ", meaning: "to shoot (a gun, person, etc.), to fire" },
        { word: "撃沈", reading: "げきちん", meaning: "(attacking and) sinking (a ship), sending (a ship) to the bottom" }
    ],
    },
    "激": {
        onyomi: ["ゲキ"],
        kunyomi: ["はげ.しい"],
        examples: [
        { word: "過激", reading: "かげき", meaning: "extreme (measure, idea, etc.), radical, violent (language)" },
        { word: "感激", reading: "かんげき", meaning: "deep emotion, impression, inspiration" },
        { word: "急激", reading: "きゅうげき", meaning: "sudden, abrupt, rapid" },
        { word: "激化", reading: "げきか", meaning: "intensification, aggravation" }
    ],
    },
    "桁": {
        onyomi: ["コウ"],
        kunyomi: ["けた"],
        examples: [
        { word: "桁", reading: "けた", meaning: "column, beam, girder" }
    ],
    },
    "欠": {
        onyomi: ["ケツ", "ケン"],
        kunyomi: ["か.ける", "か.く"],
        examples: [
        { word: "欠く", reading: "かく", meaning: "to chip, to nick, to break" },
        { word: "欠員", reading: "けついん", meaning: "vacant position, vacancy, opening" },
        { word: "欠陥", reading: "けっかん", meaning: "defect, fault, flaw" },
        { word: "欠伸", reading: "あくび", meaning: "yawn, yawning" }
    ],
    },
    "穴": {
        onyomi: ["ケツ"],
        kunyomi: ["あな"],
        examples: [
        { word: "洞穴", reading: "ほらあな", meaning: "cave, cavern, den" },
        { word: "墓穴", reading: "ぼけつ", meaning: "grave (pit)" },
        { word: "風穴", reading: "かざあな", meaning: "air hole, windhole, air vent" },
        { word: "穴埋め", reading: "あなうめ", meaning: "filling (up) a hole" }
    ],
    },
    "血": {
        onyomi: ["ケツ"],
        kunyomi: ["ち"],
        examples: [
        { word: "血圧", reading: "けつあつ", meaning: "blood pressure" },
        { word: "血液", reading: "けつえき", meaning: "blood" },
        { word: "血縁", reading: "けつえん", meaning: "blood relationship, consanguinity" },
        { word: "血管", reading: "けっかん", meaning: "blood vessel, vein" }
    ],
    },
    "決": {
        onyomi: ["ケツ"],
        kunyomi: ["き.める", "-ぎ.め", "き.まる", "さ.く"],
        examples: [
        { word: "可決", reading: "かけつ", meaning: "approval, adoption (of a motion, bill, etc.), passage" },
        { word: "解決", reading: "かいけつ", meaning: "settlement, solution, resolution" },
        { word: "議決", reading: "ぎけつ", meaning: "resolution, decision, vote" },
        { word: "決意", reading: "けつい", meaning: "decision, determination, resolution" }
    ],
    },
    "結": {
        onyomi: ["ケツ", "ケチ"],
        kunyomi: ["むす.ぶ", "ゆ.う", "ゆ.わえる"],
        examples: [
        { word: "完結", reading: "かんけつ", meaning: "conclusion, completion" },
        { word: "結う", reading: "ゆう", meaning: "to do up (hair), to dress, to arrange" },
        { word: "結び", reading: "むすび", meaning: "ending, conclusion" },
        { word: "結ぶ", reading: "むすぶ", meaning: "to tie, to bind, to link" }
    ],
    },
    "傑": {
        onyomi: ["ケツ"],
        kunyomi: ["すぐ.れる"],
        examples: [
        { word: "傑作", reading: "けっさく", meaning: "masterpiece, masterwork, chef d'oeuvre" },
        { word: "傑出", reading: "けっしゅつ", meaning: "being outstanding, excelling, being foremost" },
        { word: "豪傑", reading: "ごうけつ", meaning: "hero, bold person, daring person" }
    ],
    },
    "潔": {
        onyomi: ["ケツ"],
        kunyomi: ["いさぎよ.い"],
        examples: [
        { word: "簡潔", reading: "かんけつ", meaning: "concise, brief, succinct" },
        { word: "潔い", reading: "いさぎよい", meaning: "gracious (defeat, apology, etc.), graceful, honourable (e.g. death)" },
        { word: "潔白", reading: "けっぱく", meaning: "innocence, guiltlessness, purity" },
        { word: "潔癖", reading: "けっぺき", meaning: "fastidiousness, love of cleanliness" }
    ],
    },
    "月": {
        onyomi: ["ゲツ", "ガツ"],
        kunyomi: ["つき"],
        examples: [
        { word: "１月", reading: "いちがつ", meaning: "January" },
        { word: "一月", reading: "いちがつ", meaning: "January" },
        { word: "ヶ月", reading: "かげつ", meaning: "counter for months" },
        { word: "ヵ月", reading: "かげつ", meaning: "counter for months" }
    ],
    },
    "犬": {
        onyomi: ["ケン"],
        kunyomi: ["いぬ", "いぬ-"],
        examples: [
        { word: "愛犬", reading: "あいけん", meaning: "pet dog, beloved dog" },
        { word: "番犬", reading: "ばんけん", meaning: "watchdog, guard dog" },
        { word: "野犬", reading: "やけん", meaning: "stray dog, ownerless dog" },
        { word: "猟犬", reading: "りょうけん", meaning: "hound, hunting dog, gun dog" }
    ],
    },
    "件": {
        onyomi: ["ケン"],
        kunyomi: ["くだん"],
        examples: [
        { word: "案件", reading: "あんけん", meaning: "matter (to discuss), item (on the agenda), issue" },
        { word: "一件", reading: "いっけん", meaning: "(one) matter, (one) item, (one) case" },
        { word: "件数", reading: "けんすう", meaning: "number of cases, incidents, items, messages, accounts, etc." },
        { word: "事件", reading: "じけん", meaning: "event, affair, incident" }
    ],
    },
    "見": {
        onyomi: ["ケン"],
        kunyomi: ["み.る", "み.える", "み.せる"],
        examples: [
        { word: "意見", reading: "いけん", meaning: "opinion, view, comment" },
        { word: "一見", reading: "いっけん", meaning: "look, glimpse, glance" },
        { word: "下見", reading: "したみ", meaning: "preliminary inspection, having a look in advance" },
        { word: "花見", reading: "はなみ", meaning: "cherry blossom viewing, flower viewing" }
    ],
    },
    "券": {
        onyomi: ["ケン"],
        kunyomi: [],
        examples: [
        { word: "株券", reading: "かぶけん", meaning: "stock certificate" },
        { word: "債券", reading: "さいけん", meaning: "bond, debenture" },
        { word: "証券", reading: "しょうけん", meaning: "bond, bill, certificate" },
        { word: "旅券", reading: "りょけん", meaning: "passport" }
    ],
    },
    "肩": {
        onyomi: ["ケン"],
        kunyomi: ["かた"],
        examples: [
        { word: "肩書", reading: "かたがき", meaning: "title (e.g. Doctor, Professor, Lord), job title, position (in a company)" },
        { word: "肩こり", reading: "かたこり", meaning: "stiff neck, stiff shoulders" },
        { word: "肩書き", reading: "かたがき", meaning: "title (e.g. Doctor, Professor, Lord), job title, position (in a company)" },
        { word: "肩代わり", reading: "かたがわり", meaning: "taking over (another's debt, work), shouldering someone else's burden, subrogation" }
    ],
    },
    "建": {
        onyomi: ["ケン", "コン"],
        kunyomi: ["た.てる", "た.て", "-だ.て", "た.つ"],
        examples: [
        { word: "建議", reading: "けんぎ", meaning: "proposition, motion, proposal" },
        { word: "建国", reading: "けんこく", meaning: "founding of a nation" },
        { word: "建材", reading: "けんざい", meaning: "building material" },
        { word: "建設", reading: "けんせつ", meaning: "construction, establishment" }
    ],
    },
    "研": {
        onyomi: ["ケン"],
        kunyomi: ["と.ぐ"],
        examples: [
        { word: "研究", reading: "けんきゅう", meaning: "research, study, investigation" },
        { word: "研修", reading: "けんしゅう", meaning: "training (esp. in-service), induction course" },
        { word: "研磨", reading: "けんま", meaning: "grinding, polishing" },
        { word: "研ぐ", reading: "とぐ", meaning: "to sharpen, to hone, to whet" }
    ],
    },
    "県": {
        onyomi: ["ケン"],
        kunyomi: ["か.ける"],
        examples: [
        { word: "県営", reading: "けんえい", meaning: "(under) prefectural management" },
        { word: "県下", reading: "けんか", meaning: "in the prefecture, prefectural" },
        { word: "県会", reading: "けんかい", meaning: "prefectural assembly" },
        { word: "県議", reading: "けんぎ", meaning: "prefectural assembly member" }
    ],
    },
    "倹": {
        onyomi: ["ケン"],
        kunyomi: ["つま.しい", "つづまやか"],
        examples: [
        { word: "倹約", reading: "けんやく", meaning: "thrift, economy, frugality" }
    ],
    },
    "兼": {
        onyomi: ["ケン"],
        kunyomi: ["か.ねる", "-か.ねる"],
        examples: [
        { word: "兼任", reading: "けんにん", meaning: "serving concurrently as, holding the additional post of" },
        { word: "兼務", reading: "けんむ", meaning: "serving concurrently as, concurrently holding the position of, holding the additional post of" },
        { word: "兼業", reading: "けんぎょう", meaning: "pursuing as a side business, doing in addition to one's main work, running (businesses) simultaneously" },
        { word: "気兼ね", reading: "きがね", meaning: "constraint, reserve, feeling hesitant" }
    ],
    },
    "剣": {
        onyomi: ["ケン"],
        kunyomi: ["つるぎ"],
        examples: [
        { word: "剣劇", reading: "けんげき", meaning: "sword play, samurai drama" },
        { word: "剣士", reading: "けんし", meaning: "swordsman, swordswoman, fencer" },
        { word: "剣道", reading: "けんどう", meaning: "kendo, Japanese martial art using bamboo swords" },
        { word: "真剣", reading: "しんけん", meaning: "serious, earnest" }
    ],
    },
    "拳": {
        onyomi: ["ケン", "ゲン"],
        kunyomi: ["こぶし"],
        examples: [
        { word: "拳骨", reading: "げんこつ", meaning: "(clenched) fist, knuckles" },
        { word: "拳銃", reading: "けんじゅう", meaning: "pistol, handgun" },
        { word: "拳", reading: "こぶし", meaning: "fist" }
    ],
    },
    "軒": {
        onyomi: ["ケン"],
        kunyomi: ["のき"],
        examples: [
        { word: "一軒", reading: "いっけん", meaning: "one house" },
        { word: "軒先", reading: "のきさき", meaning: "edge of the eaves, house frontage" },
        { word: "軒並", reading: "のきなみ", meaning: "row of houses" },
        { word: "軒並み", reading: "のきなみ", meaning: "row of houses" }
    ],
    },
    "健": {
        onyomi: ["ケン"],
        kunyomi: ["すこ.やか"],
        examples: [
        { word: "穏健", reading: "おんけん", meaning: "moderate (view, politics, etc.), temperate, sensible" },
        { word: "健気", reading: "けなげ", meaning: "admirable, commendable, praiseworthy" },
        { word: "健康", reading: "けんこう", meaning: "health" },
        { word: "健在", reading: "けんざい", meaning: "in good health, alive and well, going strong" }
    ],
    },
    "険": {
        onyomi: ["ケン"],
        kunyomi: ["けわ.しい"],
        examples: [
        { word: "危険", reading: "きけん", meaning: "danger, peril, hazard" },
        { word: "険悪", reading: "けんあく", meaning: "dangerous, perilous, threatening" },
        { word: "保険", reading: "ほけん", meaning: "insurance" },
        { word: "冒険", reading: "ぼうけん", meaning: "adventure, venture" }
    ],
    },
    "圏": {
        onyomi: ["ケン"],
        kunyomi: ["かこ.い"],
        examples: [
        { word: "圏外", reading: "けんがい", meaning: "outside (a region, area, etc.), out of range (of a mobile network, radar, etc.), outside the sphere (of influence, etc.)" },
        { word: "圏内", reading: "けんない", meaning: "inside (a region, area, etc.), within the range (of), within the sphere (of influence, etc.)" },
        { word: "首都圏", reading: "しゅとけん", meaning: "Greater Tokyo Metropolitan area" },
        { word: "成層圏", reading: "せいそうけん", meaning: "stratosphere" }
    ],
    },
    "堅": {
        onyomi: ["ケン"],
        kunyomi: ["かた.い", "-がた.い"],
        examples: [
        { word: "堅い", reading: "かたい", meaning: "hard, solid, tough" },
        { word: "堅固", reading: "けんご", meaning: "solid, strong, firm" },
        { word: "堅持", reading: "けんじ", meaning: "adhering to (a view, policy, etc.), sticking to, holding fast to" },
        { word: "堅調", reading: "けんちょう", meaning: "firm (market), bullish" }
    ],
    },
    "検": {
        onyomi: ["ケン"],
        kunyomi: ["しら.べる"],
        examples: [
        { word: "検診", reading: "けんしん", meaning: "medical examination (for a specific condition or disease), health screening" },
        { word: "検疫", reading: "けんえき", meaning: "quarantine, medical inspection" },
        { word: "検閲", reading: "けんえつ", meaning: "censorship" },
        { word: "検挙", reading: "けんきょ", meaning: "arrest, roundup" }
    ],
    },
    "嫌": {
        onyomi: ["ケン", "ゲン"],
        kunyomi: ["きら.う", "きら.い", "いや"],
        examples: [
        { word: "機嫌", reading: "きげん", meaning: "humour, humor, temper" },
        { word: "嫌い", reading: "きらい", meaning: "disliking, hating, detesting" },
        { word: "嫌う", reading: "きらう", meaning: "to hate, to dislike, to loathe" },
        { word: "嫌悪", reading: "けんお", meaning: "disgust, hate, repugnance" }
    ],
    },
    "献": {
        onyomi: ["ケン", "コン"],
        kunyomi: ["たてまつ.る"],
        examples: [
        { word: "献金", reading: "けんきん", meaning: "donation, contribution, offering" },
        { word: "献血", reading: "けんけつ", meaning: "blood donation" },
        { word: "献上", reading: "けんじょう", meaning: "presenting (to)" },
        { word: "献立", reading: "こんだて", meaning: "menu, bill of fare" }
    ],
    },
    "絹": {
        onyomi: ["ケン"],
        kunyomi: ["きぬ"],
        examples: [
        { word: "絹布", reading: "けんぷ", meaning: "silk, silk cloth" },
        { word: "絹糸", reading: "きぬいと", meaning: "silk thread, silk yarn" },
        { word: "絹織物", reading: "きぬおりもの", meaning: "silk goods" },
        { word: "絹", reading: "きぬ", meaning: "silk" }
    ],
    },
    "遣": {
        onyomi: ["ケン"],
        kunyomi: ["つか.う", "-つか.い", "-づか.い", "つか.わす", "や.る"],
        examples: [
        { word: "先遣", reading: "せんけん", meaning: "sending ahead" },
        { word: "派遣", reading: "はけん", meaning: "dispatch, despatch, deployment" },
        { word: "気遣い", reading: "きづかい", meaning: "consideration, concern, fear" },
        { word: "遣唐使", reading: "けんとうし", meaning: "envoy to Tang China" }
    ],
    },
    "権": {
        onyomi: ["ケン", "ゴン"],
        kunyomi: ["おもり", "かり", "はか.る"],
        examples: [
        { word: "越権", reading: "えっけん", meaning: "going beyond authority, unauthorized, unauthorised" },
        { word: "棄権", reading: "きけん", meaning: "abstention (from voting), renunciation (of a right), withdrawal (from a contest)" },
        { word: "権威", reading: "けんい", meaning: "authority, power, influence" },
        { word: "権益", reading: "けんえき", meaning: "rights and interests (esp. those a country holds abroad)" }
    ],
    },
    "憲": {
        onyomi: ["ケン"],
        kunyomi: [],
        examples: [
        { word: "違憲", reading: "いけん", meaning: "unconstitutionality" },
        { word: "改憲", reading: "かいけん", meaning: "constitutional change, revising the constitution" },
        { word: "官憲", reading: "かんけん", meaning: "officials, authorities" },
        { word: "憲章", reading: "けんしょう", meaning: "charter" }
    ],
    },
    "賢": {
        onyomi: ["ケン"],
        kunyomi: ["かしこ.い"],
        examples: [
        { word: "賢い", reading: "かしこい", meaning: "wise, clever, smart" },
        { word: "賢人", reading: "けんじん", meaning: "wise person, virtuous person, sage" },
        { word: "賢母", reading: "けんぼ", meaning: "wise mother" },
        { word: "賢明", reading: "けんめい", meaning: "wise, sensible, well-advised" }
    ],
    },
    "謙": {
        onyomi: ["ケン"],
        kunyomi: ["へりくだ.る"],
        examples: [
        { word: "謙虚", reading: "けんきょ", meaning: "modest, humble" },
        { word: "謙遜", reading: "けんそん", meaning: "modesty, humility, being humble" }
    ],
    },
    "鍵": {
        onyomi: ["ケン"],
        kunyomi: ["かぎ"],
        examples: [
        { word: "鍵盤", reading: "けんばん", meaning: "keyboard (of a piano, typewriter, etc.)" },
        { word: "鍵", reading: "かぎ", meaning: "key" }
    ],
    },
    "繭": {
        onyomi: ["ケン"],
        kunyomi: ["まゆ", "きぬ"],
        examples: [
        { word: "繭", reading: "まゆ", meaning: "cocoon" }
    ],
    },
    "顕": {
        onyomi: ["ケン"],
        kunyomi: ["あきらか", "あらわ.れる"],
        examples: [
        { word: "顕在", reading: "けんざい", meaning: "being actual (as opposed to hidden or latent), being apparent, being obvious" },
        { word: "顕彰", reading: "けんしょう", meaning: "honouring (publicly), honoring, making someone's good deeds or achievements well-known" },
        { word: "顕著", reading: "けんちょ", meaning: "remarkable, striking, obvious" },
        { word: "露顕", reading: "ろけん", meaning: "discovery (of a plot, misdeed, etc.), detection, exposure" }
    ],
    },
    "験": {
        onyomi: ["ケン", "ゲン"],
        kunyomi: ["あかし", "しるし", "ため.す", "ためし"],
        examples: [
        { word: "経験", reading: "けいけん", meaning: "experience" },
        { word: "試験", reading: "しけん", meaning: "examination, exam, test" },
        { word: "実験", reading: "じっけん", meaning: "experiment, experimentation" },
        { word: "受験", reading: "じゅけん", meaning: "taking an examination (esp. for entrance to a school or university)" }
    ],
    },
    "懸": {
        onyomi: ["ケン", "ケ"],
        kunyomi: ["か.ける", "か.かる"],
        examples: [
        { word: "懸案", reading: "けんあん", meaning: "pending question, unresolved problem" },
        { word: "懸賞", reading: "けんしょう", meaning: "offering a prize, prize competition, prize" },
        { word: "懸垂", reading: "けんすい", meaning: "pull-up (exercise), chin-up, chinning" },
        { word: "懸念", reading: "けねん", meaning: "worry, fear, anxiety" }
    ],
    },
    "元": {
        onyomi: ["ゲン", "ガン"],
        kunyomi: ["もと"],
        examples: [
        { word: "一元", reading: "いちげん", meaning: "single element, unitary" },
        { word: "家元", reading: "いえもと", meaning: "head of a school (of music, dance), head family of a school" },
        { word: "還元", reading: "かんげん", meaning: "restoration, return" },
        { word: "紀元", reading: "きげん", meaning: "era" }
    ],
    },
    "幻": {
        onyomi: ["ゲン"],
        kunyomi: ["まぼろし"],
        examples: [
        { word: "幻影", reading: "げんえい", meaning: "phantom, vision, illusion" },
        { word: "幻覚", reading: "げんかく", meaning: "hallucination, illusion" },
        { word: "幻想", reading: "げんそう", meaning: "fantasy, illusion, vision" },
        { word: "幻滅", reading: "げんめつ", meaning: "disillusionment, disillusion, disenchantment" }
    ],
    },
    "玄": {
        onyomi: ["ゲン"],
        kunyomi: ["くろ", "くろ.い"],
        examples: [
        { word: "玄関", reading: "げんかん", meaning: "entrance, front door, entryway" },
        { word: "玄人", reading: "くろうと", meaning: "expert, professional, master" },
        { word: "玄米", reading: "げんまい", meaning: "unpolished rice, unmilled rice, brown rice" }
    ],
    },
    "言": {
        onyomi: ["ゲン", "ゴン"],
        kunyomi: ["い.う", "こと"],
        examples: [
        { word: "遺言", reading: "ゆいごん", meaning: "will, testament, one's dying wish" },
        { word: "過言", reading: "かごん", meaning: "exaggeration, overstatement, saying too much" },
        { word: "甘言", reading: "かんげん", meaning: "sweet words, smooth talk, cajolery" },
        { word: "狂言", reading: "きょうげん", meaning: "kyogen, farce presented between noh plays or during the interlude of a noh play" }
    ],
    },
    "弦": {
        onyomi: ["ゲン"],
        kunyomi: ["つる"],
        examples: [
        { word: "弦楽", reading: "げんがく", meaning: "music for strings, string music" },
        { word: "管弦楽", reading: "かんげんがく", meaning: "orchestral music" },
        { word: "弦楽器", reading: "げんがっき", meaning: "string instrument, stringed instrument" },
        { word: "管弦楽団", reading: "かんげんがくだん", meaning: "orchestra" }
    ],
    },
    "限": {
        onyomi: ["ゲン"],
        kunyomi: ["かぎ.る", "かぎ.り", "-かぎ.り"],
        examples: [
        { word: "下限", reading: "かげん", meaning: "lower limit" },
        { word: "期限", reading: "きげん", meaning: "term, period, time frame" },
        { word: "極限", reading: "きょくげん", meaning: "utmost limits, extremity" },
        { word: "権限", reading: "けんげん", meaning: "power, authority, jurisdiction" }
    ],
    },
    "原": {
        onyomi: ["ゲン"],
        kunyomi: ["はら"],
        examples: [
        { word: "原案", reading: "げんあん", meaning: "original plan, original bill, original motion" },
        { word: "原因", reading: "げんいん", meaning: "cause, origin, source" },
        { word: "原画", reading: "げんが", meaning: "original picture" },
        { word: "原義", reading: "げんぎ", meaning: "original meaning" }
    ],
    },
    "現": {
        onyomi: ["ゲン"],
        kunyomi: ["あらわ.れる", "あらわ.す", "うつつ", "うつ.つ"],
        examples: [
        { word: "現す", reading: "あらわす", meaning: "to represent, to signify, to stand for" },
        { word: "現に", reading: "げんに", meaning: "actually, really" },
        { word: "現況", reading: "げんきょう", meaning: "present condition" },
        { word: "現金", reading: "げんきん", meaning: "cash, ready money, money on hand" }
    ],
    },
    "舷": {
        onyomi: ["ゲン"],
        kunyomi: ["ふなばた", "ふなべり"],
        examples: [
        { word: "右舷", reading: "うげん", meaning: "starboard (right side of vessel)" },
        { word: "乾舷", reading: "かんげん", meaning: "freeboard" },
        { word: "舷側", reading: "げんそく", meaning: "ship's side, broadside" },
        { word: "左舷", reading: "さげん", meaning: "port (left side of vessel)" }
    ],
    },
    "減": {
        onyomi: ["ゲン"],
        kunyomi: ["へ.る", "へ.らす"],
        examples: [
        { word: "加減", reading: "かげん", meaning: "degree, extent, amount" },
        { word: "軽減", reading: "けいげん", meaning: "abatement, reduction" },
        { word: "激減", reading: "げきげん", meaning: "dramatic decrease, sharp drop, sudden fall" },
        { word: "減る", reading: "へる", meaning: "to decrease (in size or number), to diminish, to abate" }
    ],
    },
    "源": {
        onyomi: ["ゲン"],
        kunyomi: ["みなもと"],
        examples: [
        { word: "源泉", reading: "げんせん", meaning: "source (of a spring, etc.)" },
        { word: "源流", reading: "げんりゅう", meaning: "source (e.g. of a river), headwaters" },
        { word: "語源", reading: "ごげん", meaning: "origin of a word, derivation of a word, etymology" },
        { word: "根源", reading: "こんげん", meaning: "root, source, origin" }
    ],
    },
    "厳": {
        onyomi: ["ゲン", "ゴン"],
        kunyomi: ["おごそ.か", "きび.しい", "いか.めしい", "いつくし"],
        examples: [
        { word: "威厳", reading: "いげん", meaning: "dignity, majesty, solemnity" },
        { word: "厳か", reading: "おごそか", meaning: "solemn (ceremony, atmosphere, etc.), austere, grave" },
        { word: "厳戒", reading: "げんかい", meaning: "strict guard" },
        { word: "厳格", reading: "げんかく", meaning: "strict, severe, stern" }
    ],
    },
    "己": {
        onyomi: ["コ", "キ"],
        kunyomi: ["おのれ", "つちのと", "な"],
        examples: [
        { word: "自己", reading: "じこ", meaning: "self, oneself" },
        { word: "知己", reading: "ちき", meaning: "acquaintance" },
        { word: "利己", reading: "りこ", meaning: "self-interest" },
        { word: "自己紹介", reading: "じこしょうかい", meaning: "self-introduction" }
    ],
    },
    "戸": {
        onyomi: ["コ"],
        kunyomi: ["と"],
        examples: [
        { word: "井戸", reading: "いど", meaning: "water well" },
        { word: "雨戸", reading: "あまど", meaning: "sliding storm shutter" },
        { word: "下戸", reading: "げこ", meaning: "non-drinker, someone who cannot drink" },
        { word: "戸外", reading: "こがい", meaning: "open air, outdoors, outside" }
    ],
    },
    "古": {
        onyomi: ["コ"],
        kunyomi: ["ふる.い", "ふる-", "-ふる.す"],
        examples: [
        { word: "稽古", reading: "けいこ", meaning: "practice, practicing, training" },
        { word: "古い", reading: "ふるい", meaning: "old, aged, ancient" },
        { word: "古語", reading: "こご", meaning: "archaic word, obsolete word, archaism" },
        { word: "古今", reading: "ここん", meaning: "ancient and modern times, all ages, past and present" }
    ],
    },
    "呼": {
        onyomi: ["コ"],
        kunyomi: ["よ.ぶ"],
        examples: [
        { word: "呼ぶ", reading: "よぶ", meaning: "to call out (to), to call, to invoke" },
        { word: "呼応", reading: "こおう", meaning: "hailing each other" },
        { word: "呼吸", reading: "こきゅう", meaning: "breathing, respiration" },
        { word: "呼称", reading: "こしょう", meaning: "name, designation, denomination" }
    ],
    },
    "固": {
        onyomi: ["コ"],
        kunyomi: ["かた.める", "かた.まる", "かた.まり", "かた.い"],
        examples: [
        { word: "確固", reading: "かっこ", meaning: "firm, unshakeable, resolute" },
        { word: "頑固", reading: "がんこ", meaning: "stubborn, obstinate, pigheaded" },
        { word: "凝固", reading: "ぎょうこ", meaning: "coagulation, freezing, solidification" },
        { word: "禁固", reading: "きんこ", meaning: "imprisonment (without forced labour), incarceration, confinement" }
    ],
    },
    "股": {
        onyomi: ["コ"],
        kunyomi: ["また", "もも"],
        examples: [
        { word: "股", reading: "また", meaning: "groin, thigh, crotch" }
    ],
    },
    "虎": {
        onyomi: ["コ"],
        kunyomi: ["とら"],
        examples: [
        { word: "虎", reading: "とら", meaning: "tiger (Panthera tigris)" }
    ],
    },
    "孤": {
        onyomi: ["コ"],
        kunyomi: [],
        examples: [
        { word: "孤児", reading: "こじ", meaning: "orphan" },
        { word: "孤島", reading: "ことう", meaning: "solitary island, isolated island" },
        { word: "孤独", reading: "こどく", meaning: "solitude, loneliness, isolation" },
        { word: "孤立", reading: "こりつ", meaning: "isolation, being alone, being friendless" }
    ],
    },
    "弧": {
        onyomi: ["コ"],
        kunyomi: [],
        examples: [
        { word: "円弧", reading: "えんこ", meaning: "arc" },
        { word: "括弧", reading: "かっこ", meaning: "brackets, parentheses" }
    ],
    },
    "故": {
        onyomi: ["コ"],
        kunyomi: ["ゆえ", "ふる.い", "もと"],
        examples: [
        { word: "故に", reading: "ゆえに", meaning: "therefore, consequently" },
        { word: "故意", reading: "こい", meaning: "intent, intention, bad faith" },
        { word: "故国", reading: "ここく", meaning: "one's native land" },
        { word: "故事", reading: "こじ", meaning: "historical event, ancient event" }
    ],
    },
    "枯": {
        onyomi: ["コ"],
        kunyomi: ["か.れる", "か.らす"],
        examples: [
        { word: "栄枯", reading: "えいこ", meaning: "vicissitudes, ups and downs" },
        { word: "枯死", reading: "こし", meaning: "withering, dying" },
        { word: "枯木", reading: "かれき", meaning: "dead tree, withered tree" },
        { word: "枯葉", reading: "かれは", meaning: "dead leaf, dry leaves" }
    ],
    },
    "個": {
        onyomi: ["コ", "カ"],
        kunyomi: [],
        examples: [
        { word: "一個", reading: "いっこ", meaning: "one (thing), one piece, one item" },
        { word: "個室", reading: "こしつ", meaning: "single (room), room for one, one's own room" },
        { word: "個人", reading: "こじん", meaning: "individual, private person, personal" },
        { word: "個性", reading: "こせい", meaning: "individuality, personality, quirk" }
    ],
    },
    "庫": {
        onyomi: ["コ", "ク"],
        kunyomi: ["くら"],
        examples: [
        { word: "金庫", reading: "きんこ", meaning: "safe, strongbox, cashbox" },
        { word: "公庫", reading: "こうこ", meaning: "finance corporation" },
        { word: "国庫", reading: "こっこ", meaning: "national treasury" },
        { word: "在庫", reading: "ざいこ", meaning: "stock, inventory" }
    ],
    },
    "湖": {
        onyomi: ["コ"],
        kunyomi: ["みずうみ"],
        examples: [
        { word: "湖沼", reading: "こしょう", meaning: "lake, marsh, wetland" },
        { word: "湖水", reading: "こすい", meaning: "lake, lake water" },
        { word: "湖畔", reading: "こはん", meaning: "lakeside, lakeshore, lakefront" },
        { word: "琵琶湖", reading: "びわこ", meaning: "Lake Biwa, Biwako" }
    ],
    },
    "雇": {
        onyomi: ["コ"],
        kunyomi: ["やと.う"],
        examples: [
        { word: "解雇", reading: "かいこ", meaning: "dismissal (of an employee), discharge, firing" },
        { word: "雇用", reading: "こよう", meaning: "employment, hire" },
        { word: "雇う", reading: "やとう", meaning: "to employ, to hire, to take on" },
        { word: "雇い主", reading: "やといぬし", meaning: "employer" }
    ],
    },
    "誇": {
        onyomi: ["コ"],
        kunyomi: ["ほこ.る"],
        examples: [
        { word: "誇り", reading: "ほこり", meaning: "pride, boast, credit (to)" },
        { word: "誇る", reading: "ほこる", meaning: "to boast of, to be proud of, to take pride in" },
        { word: "誇示", reading: "こじ", meaning: "flaunting, showing off, display (of power, wealth, etc.)" },
        { word: "誇大", reading: "こだい", meaning: "exaggeration, hyperbole" }
    ],
    },
    "鼓": {
        onyomi: ["コ"],
        kunyomi: ["つづみ"],
        examples: [
        { word: "鼓動", reading: "こどう", meaning: "beat, palpitation, pulsation" },
        { word: "鼓舞", reading: "こぶ", meaning: "encouragement, inspiration, rousing" },
        { word: "鼓膜", reading: "こまく", meaning: "eardrum, tympanic membrane" },
        { word: "太鼓", reading: "たいこ", meaning: "drum" }
    ],
    },
    "錮": {
        onyomi: ["コ"],
        kunyomi: ["ふさ.ぐ"],
        examples: [
        { word: "禁錮", reading: "きんこ", meaning: "imprisonment (without forced labour), incarceration, confinement" }
    ],
    },
    "顧": {
        onyomi: ["コ"],
        kunyomi: ["かえり.みる"],
        examples: [
        { word: "回顧", reading: "かいこ", meaning: "recollecting, reminiscing, looking back" },
        { word: "顧問", reading: "こもん", meaning: "adviser, advisor, consultant" },
        { word: "顧客", reading: "こきゃく", meaning: "customer, client, patron" },
        { word: "回顧録", reading: "かいころく", meaning: "memoirs, reminiscences" }
    ],
    },
    "五": {
        onyomi: ["ゴ"],
        kunyomi: ["いつ", "いつ.つ"],
        examples: [
        { word: "五つ", reading: "いつつ", meaning: "five" },
        { word: "五感", reading: "ごかん", meaning: "the five senses" },
        { word: "五月", reading: "ごがつ", meaning: "May" },
        { word: "五体", reading: "ごたい", meaning: "the whole body" }
    ],
    },
    "互": {
        onyomi: ["ゴ"],
        kunyomi: ["たが.い", "かたみ.に"],
        examples: [
        { word: "互い", reading: "たがい", meaning: "each other, one another" },
        { word: "互角", reading: "ごかく", meaning: "equal (in ability), even, evenly matched" },
        { word: "互換", reading: "ごかん", meaning: "interchange" },
        { word: "互助", reading: "ごじょ", meaning: "mutual aid, cooperation, benefit" }
    ],
    },
    "午": {
        onyomi: ["ゴ"],
        kunyomi: ["うま"],
        examples: [
        { word: "午後", reading: "ごご", meaning: "afternoon, p.m." },
        { word: "午前", reading: "ごぜん", meaning: "morning, a.m." },
        { word: "正午", reading: "しょうご", meaning: "noon, midday" },
        { word: "午前中", reading: "ごぜんちゅう", meaning: "in the morning, during the morning" }
    ],
    },
    "呉": {
        onyomi: ["ゴ"],
        kunyomi: ["く.れる", "くれ"],
        examples: [
        { word: "呉服", reading: "ごふく", meaning: "cloth (for Japanese clothes), kimono fabrics, textile" },
        { word: "呉越同舟", reading: "ごえつどうしゅう", meaning: "bitter enemies in the same boat, rivals finding themselves together by chance, strange bedfellows" }
    ],
    },
    "後": {
        onyomi: ["ゴ", "コウ"],
        kunyomi: ["のち", "うし.ろ", "うしろ", "あと", "おく.れる"],
        examples: [
        { word: "以後", reading: "いご", meaning: "after this, from now on, hereafter" },
        { word: "午後", reading: "ごご", meaning: "afternoon, p.m." },
        { word: "後ろ", reading: "うしろ", meaning: "back, behind, rear" },
        { word: "後援", reading: "こうえん", meaning: "support, backing" }
    ],
    },
    "娯": {
        onyomi: ["ゴ"],
        kunyomi: [],
        examples: [
        { word: "娯楽", reading: "ごらく", meaning: "amusement, entertainment, recreation" }
    ],
    },
    "悟": {
        onyomi: ["ゴ"],
        kunyomi: ["さと.る"],
        examples: [
        { word: "覚悟", reading: "かくご", meaning: "readiness, (mental) preparedness" },
        { word: "悟り", reading: "さとり", meaning: "comprehension, understanding" },
        { word: "悟る", reading: "さとる", meaning: "to sense, to perceive, to notice" }
    ],
    },
    "碁": {
        onyomi: ["ゴ"],
        kunyomi: [],
        examples: [
        { word: "囲碁", reading: "いご", meaning: "go (board game)" },
        { word: "碁盤", reading: "ごばん", meaning: "Go board" },
        { word: "碁", reading: "ご", meaning: "go (board game)" }
    ],
    },
    "語": {
        onyomi: ["ゴ"],
        kunyomi: ["かた.る", "かた.らう"],
        examples: [
        { word: "隠語", reading: "いんご", meaning: "secret language, jargon, cant" },
        { word: "英語", reading: "えいご", meaning: "English (language)" },
        { word: "漢語", reading: "かんご", meaning: "Japanese word of Chinese origin, Sino-Japanese word" },
        { word: "季語", reading: "きご", meaning: "seasonal word (in haiku)" }
    ],
    },
    "誤": {
        onyomi: ["ゴ"],
        kunyomi: ["あやま.る", "-あやま.る"],
        examples: [
        { word: "誤り", reading: "あやまり", meaning: "error, mistake, slip" },
        { word: "誤る", reading: "あやまる", meaning: "to make a mistake (in), to commit an error, to do incorrectly" },
        { word: "誤解", reading: "ごかい", meaning: "misunderstanding" },
        { word: "誤差", reading: "ごさ", meaning: "measurement error, calculation error" }
    ],
    },
    "護": {
        onyomi: ["ゴ"],
        kunyomi: ["まも.る"],
        examples: [
        { word: "愛護", reading: "あいご", meaning: "protection, tender care" },
        { word: "介護", reading: "かいご", meaning: "nursing, care, caregiving" },
        { word: "看護", reading: "かんご", meaning: "nursing, (army) nurse" },
        { word: "警護", reading: "けいご", meaning: "bodyguard, escort" }
    ],
    },
    "口": {
        onyomi: ["コウ", "ク"],
        kunyomi: ["くち"],
        examples: [
        { word: "一口", reading: "ひとくち", meaning: "mouthful, morsel, bite" },
        { word: "陰口", reading: "かげぐち", meaning: "malicious gossip, backbiting, speaking ill behind someone's back" },
        { word: "開口", reading: "かいこう", meaning: "opening, aperture (e.g. camera)" },
        { word: "間口", reading: "まぐち", meaning: "frontage, width (of a building, plot of land, etc.)" }
    ],
    },
    "工": {
        onyomi: ["コウ", "ク", "グ"],
        kunyomi: [],
        examples: [
        { word: "加工", reading: "かこう", meaning: "manufacturing, processing, treatment" },
        { word: "起工", reading: "きこう", meaning: "setting to work" },
        { word: "工員", reading: "こういん", meaning: "factory worker" },
        { word: "工科", reading: "こうか", meaning: "engineering course" }
    ],
    },
    "公": {
        onyomi: ["コウ", "ク"],
        kunyomi: ["おおやけ"],
        examples: [
        { word: "公安", reading: "こうあん", meaning: "public peace, public safety, public security" },
        { word: "公営", reading: "こうえい", meaning: "public management" },
        { word: "公益", reading: "こうえき", meaning: "public interest, public benefit, public good" },
        { word: "公園", reading: "こうえん", meaning: "(public) park" }
    ],
    },
    "勾": {
        onyomi: ["コウ", "ク"],
        kunyomi: ["かぎ", "ま.がる"],
        examples: [
        { word: "勾配", reading: "こうばい", meaning: "slope, incline, gradient" }
    ],
    },
    "孔": {
        onyomi: ["コウ", "ク"],
        kunyomi: ["あな"],
        examples: [
        { word: "気孔", reading: "きこう", meaning: "pore, stoma, stigma" },
        { word: "鍵孔", reading: "かぎあな", meaning: "keyhole" },
        { word: "孔子", reading: "こうし", meaning: "Confucius" },
        { word: "孔雀", reading: "くじゃく", meaning: "peafowl (incl. the male peacock, female peahen, and young peachick)" }
    ],
    },
    "功": {
        onyomi: ["コウ", "ク"],
        kunyomi: ["いさお"],
        examples: [
        { word: "功績", reading: "こうせき", meaning: "achievement, meritorious deed, distinguished service" },
        { word: "功名", reading: "こうみょう", meaning: "great achievement, glorious deed, (gaining) fame" },
        { word: "功労", reading: "こうろう", meaning: "meritorious deed, services" },
        { word: "成功", reading: "せいこう", meaning: "success, achievement" }
    ],
    },
    "巧": {
        onyomi: ["コウ"],
        kunyomi: ["たく.み", "たく.む", "うま.い"],
        examples: [
        { word: "技巧", reading: "ぎこう", meaning: "technique, finesse" },
        { word: "巧み", reading: "たくみ", meaning: "skillful, adroit, dexterous" },
        { word: "巧者", reading: "こうしゃ", meaning: "cleverness, skill, tact" },
        { word: "巧拙", reading: "こうせつ", meaning: "skill, workmanship, dexterity" }
    ],
    },
    "広": {
        onyomi: ["コウ"],
        kunyomi: ["ひろ.い", "ひろ.まる", "ひろ.める", "ひろ.がる", "ひろ.げる"],
        examples: [
        { word: "広い", reading: "ひろい", meaning: "spacious, vast, wide" },
        { word: "広さ", reading: "ひろさ", meaning: "area, extent, dimensions" },
        { word: "広域", reading: "こういき", meaning: "wide area" },
        { word: "広告", reading: "こうこく", meaning: "advertisement, advertising" }
    ],
    },
    "甲": {
        onyomi: ["コウ", "カン"],
        kunyomi: ["きのえ"],
        examples: [
        { word: "甲乙", reading: "こうおつ", meaning: "first and second, A and B" },
        { word: "甲種", reading: "こうしゅ", meaning: "A-grade, first-class" },
        { word: "甲斐", reading: "かい", meaning: "result (that makes an act worthwhile), worth (in doing something), value" },
        { word: "装甲", reading: "そうこう", meaning: "armoring, armouring, armor" }
    ],
    },
    "交": {
        onyomi: ["コウ"],
        kunyomi: ["まじ.わる", "まじ.える", "ま.じる", "まじ.る", "ま.ざる", "ま.ぜる", "-か.う", "か.わす", "かわ.す", "こもごも"],
        examples: [
        { word: "外交", reading: "がいこう", meaning: "diplomacy" },
        { word: "交易", reading: "こうえき", meaning: "trade, commerce" },
        { word: "交換", reading: "こうかん", meaning: "exchange, interchange, switching" },
        { word: "交互", reading: "こうご", meaning: "alternate, alternating" }
    ],
    },
    "光": {
        onyomi: ["コウ"],
        kunyomi: ["ひか.る", "ひかり"],
        examples: [
        { word: "栄光", reading: "えいこう", meaning: "glory" },
        { word: "観光", reading: "かんこう", meaning: "sightseeing, tourism" },
        { word: "月光", reading: "げっこう", meaning: "moonlight, moonbeam" },
        { word: "光る", reading: "ひかる", meaning: "to shine, to glitter, to be bright" }
    ],
    },
    "向": {
        onyomi: ["コウ"],
        kunyomi: ["む.く", "む.い", "-む.き", "む.ける", "-む.け", "む.かう", "む.かい", "む.こう", "む.こう-", "むこ", "むか.い"],
        examples: [
        { word: "一向", reading: "いっこう", meaning: "completely, absolutely, totally" },
        { word: "傾向", reading: "けいこう", meaning: "tendency, trend, inclination" },
        { word: "向き", reading: "むき", meaning: "direction, orientation, aspect" },
        { word: "向く", reading: "むく", meaning: "to turn toward, to look (up, down, etc.)" }
    ],
    },
    "后": {
        onyomi: ["コウ", "ゴ"],
        kunyomi: ["きさき"],
        examples: [
        { word: "皇后", reading: "こうごう", meaning: "empress (consort)" },
        { word: "皇太后", reading: "こうたいごう", meaning: "Empress Dowager, Queen Mother" }
    ],
    },
    "好": {
        onyomi: ["コウ"],
        kunyomi: ["この.む", "す.く", "よ.い", "い.い"],
        examples: [
        { word: "愛好", reading: "あいこう", meaning: "love, adoration, being fond of" },
        { word: "好き", reading: "すき", meaning: "liking, being fond of, to one's liking" },
        { word: "好み", reading: "このみ", meaning: "liking, taste, fancy" },
        { word: "好む", reading: "このむ", meaning: "to like, to prefer" }
    ],
    },
    "江": {
        onyomi: ["コウ"],
        kunyomi: ["え"],
        examples: [
        { word: "江戸", reading: "えど", meaning: "Edo (shogunate capital; former name of Tokyo), Yedo" },
        { word: "堀江", reading: "ほりえ", meaning: "canal" },
        { word: "江戸っ子", reading: "えどっこ", meaning: "(true) Tokyoite, Edoite, Tokyo native" },
        { word: "江戸時代", reading: "えどじだい", meaning: "Edo period (1603-1868)" }
    ],
    },
    "考": {
        onyomi: ["コウ"],
        kunyomi: ["かんが.える", "かんが.え"],
        examples: [
        { word: "考え", reading: "かんがえ", meaning: "thinking, thought, view" },
        { word: "考案", reading: "こうあん", meaning: "plan, device, idea" },
        { word: "考察", reading: "こうさつ", meaning: "consideration, inquiry, enquiry" },
        { word: "考証", reading: "こうしょう", meaning: "investigation into historical evidence, study of historical artifacts" }
    ],
    },
    "行": {
        onyomi: ["コウ", "ギョウ", "アン"],
        kunyomi: ["い.く", "ゆ.く", "-ゆ.き", "-ゆき", "-い.き", "-いき", "おこな.う", "おこ.なう"],
        examples: [
        { word: "移行", reading: "いこう", meaning: "transition, changeover, switchover" },
        { word: "運行", reading: "うんこう", meaning: "operation (of a bus or train service), service, running" },
        { word: "奥行", reading: "おくゆき", meaning: "depth, length" },
        { word: "横行", reading: "おうこう", meaning: "being rampant, being widespread, being prevalent" }
    ],
    },
    "坑": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "坑道", reading: "こうどう", meaning: "tunnel, (mining) gallery, level" },
        { word: "廃坑", reading: "はいこう", meaning: "closure of a mine, abandoned mine, disused mine" }
    ],
    },
    "孝": {
        onyomi: ["コウ", "キョウ"],
        kunyomi: [],
        examples: [
        { word: "孝行", reading: "こうこう", meaning: "filial piety" },
        { word: "不孝", reading: "ふこう", meaning: "undutifulness to one's parents, lack of filial piety" },
        { word: "親孝行", reading: "おやこうこう", meaning: "filial piety, being kind to one's parents, taking care of one's parents" },
        { word: "親不孝", reading: "おやふこう", meaning: "lack of filial piety, disobedience to one's parents" }
    ],
    },
    "抗": {
        onyomi: ["コウ"],
        kunyomi: ["あらが.う"],
        examples: [
        { word: "抗議", reading: "こうぎ", meaning: "protest, objection" },
        { word: "抗菌", reading: "こうきん", meaning: "antibacterial, antimicrobial" },
        { word: "抗原", reading: "こうげん", meaning: "antigen" },
        { word: "抗争", reading: "こうそう", meaning: "rivalry, feud, conflict" }
    ],
    },
    "攻": {
        onyomi: ["コウ"],
        kunyomi: ["せ.める"],
        examples: [
        { word: "攻め", reading: "せめ", meaning: "attack, offence, offense" },
        { word: "攻撃", reading: "こうげき", meaning: "attack, assault, raid" },
        { word: "攻守", reading: "こうしゅ", meaning: "offense and defense, offence and defence, batting and fielding" },
        { word: "攻勢", reading: "こうせい", meaning: "offensive (movement), aggression" }
    ],
    },
    "更": {
        onyomi: ["コウ"],
        kunyomi: ["さら", "さら.に", "ふ.ける", "ふ.かす"],
        examples: [
        { word: "更に", reading: "さらに", meaning: "furthermore, again, after all" },
        { word: "更改", reading: "こうかい", meaning: "renewal, extension, revision" },
        { word: "更新", reading: "こうしん", meaning: "renewal, update, replacement" },
        { word: "更正", reading: "こうせい", meaning: "correction, revision, rectification" }
    ],
    },
    "効": {
        onyomi: ["コウ"],
        kunyomi: ["き.く", "ききめ", "なら.う"],
        examples: [
        { word: "効果", reading: "こうか", meaning: "effect, effectiveness, efficacy" },
        { word: "効能", reading: "こうのう", meaning: "effect, effectiveness, efficacy" },
        { word: "効用", reading: "こうよう", meaning: "use, utility, effect" },
        { word: "効率", reading: "こうりつ", meaning: "efficiency" }
    ],
    },
    "幸": {
        onyomi: ["コウ"],
        kunyomi: ["さいわ.い", "さち", "しあわ.せ"],
        examples: [
        { word: "幸い", reading: "さいわい", meaning: "happiness, blessedness, luck" },
        { word: "幸福", reading: "こうふく", meaning: "happiness, well-being, joy" },
        { word: "不幸", reading: "ふこう", meaning: "unhappiness, sorrow, misfortune" },
        { word: "幸運", reading: "こううん", meaning: "good luck, fortune" }
    ],
    },
    "拘": {
        onyomi: ["コウ"],
        kunyomi: ["かか.わる"],
        examples: [
        { word: "拘禁", reading: "こうきん", meaning: "detention, custody, confinement" },
        { word: "拘束", reading: "こうそく", meaning: "restriction, restraint, binding" },
        { word: "拘置", reading: "こうち", meaning: "detention, confinement, arrest" },
        { word: "拘留", reading: "こうりゅう", meaning: "custody, detention, confinement" }
    ],
    },
    "肯": {
        onyomi: ["コウ"],
        kunyomi: ["がえんじ.る"],
        examples: [
        { word: "肯定", reading: "こうてい", meaning: "affirmation" }
    ],
    },
    "侯": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "侯爵", reading: "こうしゃく", meaning: "marquis, marquess" },
        { word: "王侯", reading: "おうこう", meaning: "the king and his feudal lords" },
        { word: "侯", reading: "こう", meaning: "marquis, second highest rank of the five ranks of nobility" }
    ],
    },
    "厚": {
        onyomi: ["コウ"],
        kunyomi: ["あつ.い", "あか"],
        examples: [
        { word: "温厚", reading: "おんこう", meaning: "gentle, mild-mannered" },
        { word: "厚い", reading: "あつい", meaning: "thick, deep, heavy" },
        { word: "厚さ", reading: "あつさ", meaning: "thickness" },
        { word: "厚意", reading: "こうい", meaning: "kindness (shown by others), courtesy, favor" }
    ],
    },
    "恒": {
        onyomi: ["コウ"],
        kunyomi: ["つね", "つねに"],
        examples: [
        { word: "恒久", reading: "こうきゅう", meaning: "permanence, perpetuity" },
        { word: "恒常", reading: "こうじょう", meaning: "constancy, permanence" },
        { word: "恒星", reading: "こうせい", meaning: "star" },
        { word: "恒例", reading: "こうれい", meaning: "established practice, custom" }
    ],
    },
    "洪": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "洪水", reading: "こうずい", meaning: "flood, flooding" }
    ],
    },
    "皇": {
        onyomi: ["コウ", "オウ"],
        kunyomi: [],
        examples: [
        { word: "皇位", reading: "こうい", meaning: "imperial throne" },
        { word: "皇居", reading: "こうきょ", meaning: "Imperial Palace (of Japan), imperial residence" },
        { word: "皇后", reading: "こうごう", meaning: "empress (consort)" },
        { word: "皇室", reading: "こうしつ", meaning: "Imperial household" }
    ],
    },
    "紅": {
        onyomi: ["コウ", "ク"],
        kunyomi: ["べに", "くれない", "あか.い"],
        examples: [
        { word: "口紅", reading: "くちべに", meaning: "lipstick" },
        { word: "紅茶", reading: "こうちゃ", meaning: "black tea" },
        { word: "紅梅", reading: "こうばい", meaning: "red-blossomed plum tree, red Japanese apricot" },
        { word: "紅白", reading: "こうはく", meaning: "red and white, colours for festive or auspicious occasions (colors)" }
    ],
    },
    "荒": {
        onyomi: ["コウ"],
        kunyomi: ["あ.らす", "あ.れる", "あら.い", "すさ.ぶ", "すさ.む", "あ.らし"],
        examples: [
        { word: "荒い", reading: "あらい", meaning: "rough, wild, violent" },
        { word: "荒波", reading: "あらなみ", meaning: "raging waves, stormy seas" },
        { word: "荒廃", reading: "こうはい", meaning: "ruin, destruction, devastation" },
        { word: "荒木", reading: "あらき", meaning: "logs in bark, rough wood, unseasoned timber" }
    ],
    },
    "郊": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "近郊", reading: "きんこう", meaning: "outskirts, environs (of a city), surrounding area" },
        { word: "郊外", reading: "こうがい", meaning: "suburb, residential area on the outskirt of a city, commuter belt" }
    ],
    },
    "香": {
        onyomi: ["コウ", "キョウ"],
        kunyomi: ["か", "かお.り", "かお.る"],
        examples: [
        { word: "香気", reading: "こうき", meaning: "fragrance" },
        { word: "香港", reading: "ホンコン", meaning: "Hong Kong" },
        { word: "香水", reading: "こうすい", meaning: "perfume, scent" },
        { word: "香料", reading: "こうりょう", meaning: "flavoring, flavouring, spices" }
    ],
    },
    "候": {
        onyomi: ["コウ"],
        kunyomi: ["そうろう"],
        examples: [
        { word: "気候", reading: "きこう", meaning: "climate" },
        { word: "居候", reading: "いそうろう", meaning: "lodger who pays nothing for room and board, freeloader, sponger" },
        { word: "候補", reading: "こうほ", meaning: "candidate, contender, prospect" },
        { word: "症候", reading: "しょうこう", meaning: "symptom" }
    ],
    },
    "校": {
        onyomi: ["コウ", "キョウ"],
        kunyomi: [],
        examples: [
        { word: "開校", reading: "かいこう", meaning: "opening a school" },
        { word: "学校", reading: "がっこう", meaning: "school" },
        { word: "休校", reading: "きゅうこう", meaning: "(temporary) closure of school" },
        { word: "校閲", reading: "こうえつ", meaning: "revision, proofreading" }
    ],
    },
    "耕": {
        onyomi: ["コウ"],
        kunyomi: ["たがや.す"],
        examples: [
        { word: "耕す", reading: "たがやす", meaning: "to till, to plow, to plough" },
        { word: "耕作", reading: "こうさく", meaning: "cultivation, farming" },
        { word: "耕地", reading: "こうち", meaning: "arable land, plantation, farmland" },
        { word: "農耕", reading: "のうこう", meaning: "farming, agriculture, cultivation" }
    ],
    },
    "航": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "運航", reading: "うんこう", meaning: "operation (of a ship or aircraft route), service, navigation" },
        { word: "航海", reading: "こうかい", meaning: "(sea) voyage, navigation, sailing" },
        { word: "航空", reading: "こうくう", meaning: "aviation, flying" },
        { word: "航行", reading: "こうこう", meaning: "cruise, navigation, sailing" }
    ],
    },
    "貢": {
        onyomi: ["コウ", "ク"],
        kunyomi: ["みつ.ぐ"],
        examples: [
        { word: "貢献", reading: "こうけん", meaning: "contribution (furthering a goal or cause), services (to a cause)" }
    ],
    },
    "降": {
        onyomi: ["コウ", "ゴ"],
        kunyomi: ["お.りる", "お.ろす", "ふ.る", "ふ.り", "くだ.る", "くだ.す"],
        examples: [
        { word: "以降", reading: "いこう", meaning: "on and after, from ... onward, since" },
        { word: "下降", reading: "かこう", meaning: "descent, fall, drop" },
        { word: "滑降", reading: "かっこう", meaning: "descent (esp. in skiing), sliding down, skiing down" },
        { word: "降る", reading: "ふる", meaning: "to fall (of rain, snow, ash, etc.), to come down" }
    ],
    },
    "高": {
        onyomi: ["コウ"],
        kunyomi: ["たか.い", "たか", "-だか", "たか.まる", "たか.める"],
        examples: [
        { word: "円高", reading: "えんだか", meaning: "appreciation of the yen, strong yen" },
        { word: "高い", reading: "たかい", meaning: "high, tall" },
        { word: "高さ", reading: "たかさ", meaning: "height, altitude, elevation" },
        { word: "高圧", reading: "こうあつ", meaning: "high voltage, high pressure" }
    ],
    },
    "康": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "健康", reading: "けんこう", meaning: "health" },
        { word: "小康", reading: "しょうこう", meaning: "lull, breathing spell, respite" },
        { word: "健康的", reading: "けんこうてき", meaning: "hygienic, healthy, healthful" },
        { word: "不健康", reading: "ふけんこう", meaning: "poor health, ill health, unhealthy" }
    ],
    },
    "控": {
        onyomi: ["コウ"],
        kunyomi: ["ひか.える", "ひか.え"],
        examples: [
        { word: "控え", reading: "ひかえ", meaning: "reserve, spare, backup" },
        { word: "控除", reading: "こうじょ", meaning: "subtraction, deduction (e.g. of tax)" },
        { word: "控訴", reading: "こうそ", meaning: "appeal to a higher court, intermediate appeal" },
        { word: "控室", reading: "ひかえしつ", meaning: "waiting room, anteroom, antechamber" }
    ],
    },
    "梗": {
        onyomi: ["コウ", "キョウ"],
        kunyomi: ["ふさぐ", "やまにれ", "おおむね"],
        examples: [
        { word: "梗塞", reading: "こうそく", meaning: "stoppage, blocking" }
    ],
    },
    "黄": {
        onyomi: ["コウ", "オウ"],
        kunyomi: ["き", "こ-"],
        examples: [
        { word: "黄金", reading: "おうごん", meaning: "gold (Au)" },
        { word: "黄身", reading: "きみ", meaning: "egg yolk" },
        { word: "硫黄", reading: "いおう", meaning: "sulfur (S), sulphur" },
        { word: "黄昏", reading: "たそがれ", meaning: "dusk, twilight" }
    ],
    },
    "喉": {
        onyomi: ["コウ"],
        kunyomi: ["のど"],
        examples: [
        { word: "喉", reading: "のど", meaning: "throat" }
    ],
    },
    "慌": {
        onyomi: ["コウ"],
        kunyomi: ["あわ.てる", "あわ.ただしい"],
        examples: [
        { word: "恐慌", reading: "きょうこう", meaning: "panic, scare, alarm" },
        { word: "慌てる", reading: "あわてる", meaning: "to become confused (disconcerted, disorganized, disorganised), to be flustered, to panic" },
        { word: "慌ただしい", reading: "あわただしい", meaning: "busy, hectic, hurried" }
    ],
    },
    "港": {
        onyomi: ["コウ"],
        kunyomi: ["みなと"],
        examples: [
        { word: "開港", reading: "かいこう", meaning: "opening a port (seaport, airport, etc.), starting operations at a port" },
        { word: "寄港", reading: "きこう", meaning: "calling at a port" },
        { word: "漁港", reading: "ぎょこう", meaning: "fishing harbour, fishing harbor" },
        { word: "空港", reading: "くうこう", meaning: "airport" }
    ],
    },
    "硬": {
        onyomi: ["コウ"],
        kunyomi: ["かた.い"],
        examples: [
        { word: "強硬", reading: "きょうこう", meaning: "firm, strong, unbending" },
        { word: "硬い", reading: "かたい", meaning: "hard, solid, tough" },
        { word: "硬化", reading: "こうか", meaning: "hardening, vulcanization, vulcanisation" },
        { word: "硬貨", reading: "こうか", meaning: "coin" }
    ],
    },
    "絞": {
        onyomi: ["コウ"],
        kunyomi: ["しぼ.る", "し.める", "し.まる"],
        examples: [
        { word: "絞り", reading: "しぼり", meaning: "shibori, tie-dye, tie-dyeing" },
        { word: "絞殺", reading: "こうさつ", meaning: "strangling (to death), strangulation" },
        { word: "絞る", reading: "しぼる", meaning: "to wring (towel, rag), to squeeze" },
        { word: "お絞り", reading: "おしぼり", meaning: "wet towel (supplied at table), hot, moistened hand towel" }
    ],
    },
    "項": {
        onyomi: ["コウ"],
        kunyomi: ["うなじ"],
        examples: [
        { word: "項目", reading: "こうもく", meaning: "item, heading, category" },
        { word: "事項", reading: "じこう", meaning: "matter, item, facts" },
        { word: "条項", reading: "じょうこう", meaning: "clause, article, stipulations" },
        { word: "要項", reading: "ようこう", meaning: "important points, main points, gist" }
    ],
    },
    "溝": {
        onyomi: ["コウ"],
        kunyomi: ["みぞ"],
        examples: [
        { word: "海溝", reading: "かいこう", meaning: "oceanic trench, deep-sea trench, deep" },
        { word: "溝", reading: "みぞ", meaning: "ditch, drain, gutter" }
    ],
    },
    "鉱": {
        onyomi: ["コウ"],
        kunyomi: ["あらがね"],
        examples: [
        { word: "鉱業", reading: "こうぎょう", meaning: "mining industry" },
        { word: "鉱山", reading: "こうざん", meaning: "mine (ore)" },
        { word: "鉱石", reading: "こうせき", meaning: "ore, mineral, crystal" },
        { word: "鉱物", reading: "こうぶつ", meaning: "mineral" }
    ],
    },
    "構": {
        onyomi: ["コウ"],
        kunyomi: ["かま.える", "かま.う"],
        examples: [
        { word: "遺構", reading: "いこう", meaning: "(archaeological) remains, remnants (of ancient structures), ancient foundation" },
        { word: "機構", reading: "きこう", meaning: "mechanism, machinery" },
        { word: "虚構", reading: "きょこう", meaning: "fiction, fabrication, concoction" },
        { word: "結構", reading: "けっこう", meaning: "splendid, nice, wonderful" }
    ],
    },
    "綱": {
        onyomi: ["コウ"],
        kunyomi: ["つな"],
        examples: [
        { word: "横綱", reading: "よこづな", meaning: "yokozuna (highest rank in sumo), grand champion" },
        { word: "綱紀", reading: "こうき", meaning: "law and order, (official) discipline" },
        { word: "綱領", reading: "こうりょう", meaning: "general plan, main points, summary" },
        { word: "手綱", reading: "たづな", meaning: "reins, bridle" }
    ],
    },
    "酵": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "酵素", reading: "こうそ", meaning: "enzyme" },
        { word: "酵母", reading: "こうぼ", meaning: "yeast, leaven" },
        { word: "発酵", reading: "はっこう", meaning: "fermentation, zymosis" }
    ],
    },
    "稿": {
        onyomi: ["コウ"],
        kunyomi: ["わら", "したがき"],
        examples: [
        { word: "原稿", reading: "げんこう", meaning: "manuscript, copy, draft" },
        { word: "稿料", reading: "こうりょう", meaning: "manuscript fee, payment for a piece of writing" },
        { word: "草稿", reading: "そうこう", meaning: "notes, draft, manuscript" },
        { word: "投稿", reading: "とうこう", meaning: "contribution (to a newspaper, magazine, etc.), submission, post (on a blog, social media, etc.)" }
    ],
    },
    "興": {
        onyomi: ["コウ", "キョウ"],
        kunyomi: ["おこ.る", "おこ.す"],
        examples: [
        { word: "興す", reading: "おこす", meaning: "to vitalize (e.g. an industry), to invigorate, to energize" },
        { word: "興業", reading: "こうぎょう", meaning: "promotion of industry, inauguration of a new industrial enterprise" },
        { word: "興行", reading: "こうぎょう", meaning: "show, performance, act" },
        { word: "興奮", reading: "こうふん", meaning: "excitement, stimulation, agitation" }
    ],
    },
    "衡": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "均衡", reading: "きんこう", meaning: "balance, equilibrium" },
        { word: "平衡", reading: "へいこう", meaning: "balance, equilibrium" },
        { word: "不均衡", reading: "ふきんこう", meaning: "imbalance, lack of balance, lopsidedness" },
        { word: "拡大均衡", reading: "かくだいきんこう", meaning: "an expanded or expanding equilibrium" }
    ],
    },
    "鋼": {
        onyomi: ["コウ"],
        kunyomi: ["はがね"],
        examples: [
        { word: "鋼材", reading: "こうざい", meaning: "steel material" },
        { word: "鋼鉄", reading: "こうてつ", meaning: "steel" },
        { word: "製鋼", reading: "せいこう", meaning: "steel manufacture" },
        { word: "鉄鋼", reading: "てっこう", meaning: "iron and steel" }
    ],
    },
    "講": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "休講", reading: "きゅうこう", meaning: "cancellation (of a lecture, class, etc.)" },
        { word: "講演", reading: "こうえん", meaning: "lecture, address, speech" },
        { word: "講義", reading: "こうぎ", meaning: "lecture" },
        { word: "講座", reading: "こうざ", meaning: "course (e.g. of lectures)" }
    ],
    },
    "購": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "購読", reading: "こうどく", meaning: "buying and reading (book, magazine, etc.), subscribing (incl. free subscriptions), taking (e.g. newspaper)" },
        { word: "購入", reading: "こうにゅう", meaning: "purchase, buying" },
        { word: "購買", reading: "こうばい", meaning: "procurement, purchase, buying" },
        { word: "購買力", reading: "こうばいりょく", meaning: "buying power, purchasing power" }
    ],
    },
    "乞": {
        onyomi: ["コツ", "キツ", "キ", "キケ", "コチ"],
        kunyomi: ["こ.う"],
        examples: [
        { word: "乞食", reading: "こじき", meaning: "beggar" },
        { word: "乞う", reading: "こう", meaning: "to beg, to ask, to request" }
    ],
    },
    "号": {
        onyomi: ["ゴウ"],
        kunyomi: ["さけ.ぶ", "よびな"],
        examples: [
        { word: "暗号", reading: "あんごう", meaning: "code, password, cipher" },
        { word: "記号", reading: "きごう", meaning: "sign, symbol, mark" },
        { word: "元号", reading: "げんごう", meaning: "name of an imperial era (e.g. Heisei, Shōwa), Japanese era name" },
        { word: "号外", reading: "ごうがい", meaning: "newspaper extra" }
    ],
    },
    "合": {
        onyomi: ["ゴウ", "ガッ", "カッ"],
        kunyomi: ["あ.う", "-あ.う", "あ.い", "あい-", "-あ.い", "-あい", "あ.わす", "あ.わせる", "-あ.わせる"],
        examples: [
        { word: "化合", reading: "かごう", meaning: "chemical combination" },
        { word: "会合", reading: "かいごう", meaning: "meeting, assembly, gathering" },
        { word: "糾合", reading: "きゅうごう", meaning: "rally, muster" },
        { word: "競合", reading: "きょうごう", meaning: "contention, competition, rivalry" }
    ],
    },
    "拷": {
        onyomi: ["ゴウ"],
        kunyomi: [],
        examples: [
        { word: "拷問", reading: "ごうもん", meaning: "torture" }
    ],
    },
    "剛": {
        onyomi: ["ゴウ"],
        kunyomi: [],
        examples: [
        { word: "剛健", reading: "ごうけん", meaning: "vigour, vigor, virility" }
    ],
    },
    "傲": {
        onyomi: ["ゴウ"],
        kunyomi: ["おご.る", "あなど.る"],
        examples: [
        { word: "傲慢", reading: "ごうまん", meaning: "haughty, arrogant, insolent" }
    ],
    },
    "豪": {
        onyomi: ["ゴウ"],
        kunyomi: ["えら.い"],
        examples: [
        { word: "豪雨", reading: "ごうう", meaning: "torrential rain, heavy rain, cloudburst" },
        { word: "豪華", reading: "ごうか", meaning: "extravagant, lavish, opulent" },
        { word: "豪快", reading: "ごうかい", meaning: "hearty, tremendous, magnificent" },
        { word: "豪傑", reading: "ごうけつ", meaning: "hero, bold person, daring person" }
    ],
    },
    "克": {
        onyomi: ["コク"],
        kunyomi: ["か.つ"],
        examples: [
        { word: "克服", reading: "こくふく", meaning: "conquest (of a difficulty, illness, crisis, etc.), overcoming, surmounting" },
        { word: "克明", reading: "こくめい", meaning: "detailed, scrupulous, careful" }
    ],
    },
    "告": {
        onyomi: ["コク"],
        kunyomi: ["つ.げる"],
        examples: [
        { word: "戒告", reading: "かいこく", meaning: "admonition, warning, caution" },
        { word: "勧告", reading: "かんこく", meaning: "advice, counsel, remonstrance" },
        { word: "警告", reading: "けいこく", meaning: "warning, caution, admonition" },
        { word: "原告", reading: "げんこく", meaning: "plaintiff, accuser, prosecutor" }
    ],
    },
    "谷": {
        onyomi: ["コク"],
        kunyomi: ["たに", "きわ.まる"],
        examples: [
        { word: "峡谷", reading: "きょうこく", meaning: "gorge, ravine, canyon" },
        { word: "渓谷", reading: "けいこく", meaning: "valley (with a river running through it), gorge, ravine" },
        { word: "谷間", reading: "たにま", meaning: "valley, ravine, gorge" },
        { word: "谷川", reading: "たにがわ", meaning: "mountain stream" }
    ],
    },
    "刻": {
        onyomi: ["コク"],
        kunyomi: ["きざ.む", "きざ.み"],
        examples: [
        { word: "一刻", reading: "いっこく", meaning: "a moment, a minute, an instant" },
        { word: "刻々", reading: "こっこく", meaning: "moment by moment, hour by hour" },
        { word: "刻み", reading: "きざみ", meaning: "mincing, cutting, chopping" },
        { word: "刻む", reading: "きざむ", meaning: "to mince, to cut fine, to chop up" }
    ],
    },
    "国": {
        onyomi: ["コク"],
        kunyomi: ["くに"],
        examples: [
        { word: "愛国", reading: "あいこく", meaning: "love of one's country, patriotism" },
        { word: "異国", reading: "いこく", meaning: "foreign country" },
        { word: "一国", reading: "いっこく", meaning: "one country" },
        { word: "英国", reading: "えいこく", meaning: "United Kingdom, Britain, Great Britain" }
    ],
    },
    "黒": {
        onyomi: ["コク"],
        kunyomi: ["くろ", "くろ.ずむ", "くろ.い"],
        examples: [
        { word: "黒い", reading: "くろい", meaning: "black" },
        { word: "黒鉛", reading: "こくえん", meaning: "graphite" },
        { word: "黒海", reading: "こっかい", meaning: "Black Sea" },
        { word: "黒字", reading: "くろじ", meaning: "(being in) the black, surplus" }
    ],
    },
    "穀": {
        onyomi: ["コク"],
        kunyomi: [],
        examples: [
        { word: "穀倉", reading: "こくそう", meaning: "granary" },
        { word: "穀物", reading: "こくもつ", meaning: "grain, cereal, corn" },
        { word: "穀類", reading: "こくるい", meaning: "grains" },
        { word: "米穀", reading: "べいこく", meaning: "rice" }
    ],
    },
    "酷": {
        onyomi: ["コク"],
        kunyomi: ["ひど.い"],
        examples: [
        { word: "酷使", reading: "こくし", meaning: "exploitation, overuse, abuse" },
        { word: "酷似", reading: "こくじ", meaning: "resembling closely, being strikingly similar, bearing a strong likeness" },
        { word: "酷暑", reading: "こくしょ", meaning: "intense heat, severe heat" },
        { word: "酷評", reading: "こくひょう", meaning: "severe criticism, sharp criticism, scathing criticism" }
    ],
    },
    "獄": {
        onyomi: ["ゴク"],
        kunyomi: [],
        examples: [
        { word: "監獄", reading: "かんごく", meaning: "prison" },
        { word: "疑獄", reading: "ぎごく", meaning: "bribery scandal, graft case" },
        { word: "獄中", reading: "ごくちゅう", meaning: "during imprisonment, while in jail" },
        { word: "出獄", reading: "しゅつごく", meaning: "release (from prison)" }
    ],
    },
    "骨": {
        onyomi: ["コツ"],
        kunyomi: ["ほね"],
        examples: [
        { word: "遺骨", reading: "いこつ", meaning: "cremated remains (esp. the bones), ashes" },
        { word: "骸骨", reading: "がいこつ", meaning: "skeleton" },
        { word: "拳骨", reading: "げんこつ", meaning: "(clenched) fist, knuckles" },
        { word: "骨格", reading: "こっかく", meaning: "skeleton, skeletal structure, build" }
    ],
    },
    "駒": {
        onyomi: ["ク"],
        kunyomi: ["こま"],
        examples: [
        { word: "駒", reading: "こま", meaning: "piece (in shogi, chess, etc.)" }
    ],
    },
    "込": {
        onyomi: [],
        kunyomi: ["-こ.む", "こ.む", "こ.み", "-こ.み", "こ.める"],
        examples: [
        { word: "込む", reading: "こむ", meaning: "to be crowded, to be packed, to be congested" },
        { word: "振込", reading: "ふりこみ", meaning: "payment made via bank deposit transfer" },
        { word: "申込", reading: "もうしこみ", meaning: "application, entry, request" },
        { word: "見込む", reading: "みこむ", meaning: "to anticipate, to expect, to estimate" }
    ],
    },
    "頃": {
        onyomi: ["ケイ", "キョウ"],
        kunyomi: ["ころ", "ごろ", "しばら.く"],
        examples: [
        { word: "近頃", reading: "ちかごろ", meaning: "lately, recently, nowadays" },
        { word: "今頃", reading: "いまごろ", meaning: "about this time, about now" },
        { word: "日頃", reading: "ひごろ", meaning: "usually, habitually, always" },
        { word: "年頃", reading: "としごろ", meaning: "approximate age, apparent age" }
    ],
    },
    "今": {
        onyomi: ["コン", "キン"],
        kunyomi: ["いま"],
        examples: [
        { word: "古今", reading: "ここん", meaning: "ancient and modern times, all ages, past and present" },
        { word: "今に", reading: "いまに", meaning: "before long, even now" },
        { word: "今や", reading: "いまや", meaning: "now (esp. in contrast to the past), now at last, at present" },
        { word: "今一", reading: "いまいち", meaning: "not quite (right), not very good, somewhat (lacking)" }
    ],
    },
    "困": {
        onyomi: ["コン"],
        kunyomi: ["こま.る"],
        examples: [
        { word: "困る", reading: "こまる", meaning: "to be troubled, to have difficulty, to be in a fix" },
        { word: "困窮", reading: "こんきゅう", meaning: "poverty, need, destitution" },
        { word: "困難", reading: "こんなん", meaning: "difficulty, hardship, trouble" },
        { word: "困惑", reading: "こんわく", meaning: "bewilderment, perplexity, embarrassment" }
    ],
    },
    "昆": {
        onyomi: ["コン"],
        kunyomi: [],
        examples: [
        { word: "昆虫", reading: "こんちゅう", meaning: "insect, bug" },
        { word: "昆布", reading: "こんぶ", meaning: "kombu (usu. Saccharina japonica), konbu, kelp" }
    ],
    },
    "恨": {
        onyomi: ["コン"],
        kunyomi: ["うら.む", "うら.めしい"],
        examples: [
        { word: "遺恨", reading: "いこん", meaning: "grudge, ill will, enmity" },
        { word: "恨み", reading: "うらみ", meaning: "resentment, grudge, malice" },
        { word: "恨む", reading: "うらむ", meaning: "to bear a grudge against, to resent, to blame" },
        { word: "痛恨", reading: "つうこん", meaning: "deep regret, great sorrow, bitter grief" }
    ],
    },
    "根": {
        onyomi: ["コン"],
        kunyomi: ["ね", "-ね"],
        examples: [
        { word: "羽根", reading: "はね", meaning: "feather, plume, down" },
        { word: "屋根", reading: "やね", meaning: "roof" },
        { word: "禍根", reading: "かこん", meaning: "root of an evil, source of a problem, source of trouble" },
        { word: "垣根", reading: "かきね", meaning: "hedge, fence" }
    ],
    },
    "婚": {
        onyomi: ["コン"],
        kunyomi: [],
        examples: [
        { word: "既婚", reading: "きこん", meaning: "married" },
        { word: "結婚", reading: "けっこん", meaning: "marriage" },
        { word: "婚姻", reading: "こんいん", meaning: "marriage, matrimony" },
        { word: "婚約", reading: "こんやく", meaning: "engagement, betrothal" }
    ],
    },
    "混": {
        onyomi: ["コン"],
        kunyomi: ["ま.じる", "-ま.じり", "ま.ざる", "ま.ぜる", "こ.む"],
        examples: [
        { word: "混血", reading: "こんけつ", meaning: "mixed race, mixed parentage" },
        { word: "混合", reading: "こんごう", meaning: "mixing, mixture, meld" },
        { word: "混雑", reading: "こんざつ", meaning: "congestion, crush, crowding" },
        { word: "混成", reading: "こんせい", meaning: "mixed (e.g. team, chorus)" }
    ],
    },
    "痕": {
        onyomi: ["コン"],
        kunyomi: ["あと"],
        examples: [
        { word: "血痕", reading: "けっこん", meaning: "bloodstain" },
        { word: "痕跡", reading: "こんせき", meaning: "trace, vestige, mark" }
    ],
    },
    "紺": {
        onyomi: ["コン"],
        kunyomi: [],
        examples: [
        { word: "濃紺", reading: "のうこん", meaning: "dark blue" },
        { word: "紺屋", reading: "こうや", meaning: "dyer" },
        { word: "紺", reading: "こん", meaning: "navy blue, deep blue" }
    ],
    },
    "魂": {
        onyomi: ["コン"],
        kunyomi: ["たましい", "たま"],
        examples: [
        { word: "魂胆", reading: "こんたん", meaning: "ulterior motive, plot, scheme" },
        { word: "商魂", reading: "しょうこん", meaning: "commercial spirit" },
        { word: "鎮魂", reading: "ちんこん", meaning: "repose of a soul" },
        { word: "魂", reading: "たましい", meaning: "soul, spirit, mind" }
    ],
    },
    "墾": {
        onyomi: ["コン"],
        kunyomi: ["は.る", "ひら.く"],
        examples: [
        { word: "開墾", reading: "かいこん", meaning: "cultivating new land, clearing, reclamation" }
    ],
    },
    "懇": {
        onyomi: ["コン"],
        kunyomi: ["ねんご.ろ"],
        examples: [
        { word: "懇意", reading: "こんい", meaning: "friendship, (on) familiar terms, intimacy" },
        { word: "懇願", reading: "こんがん", meaning: "pleading, entreaty, supplication" },
        { word: "懇親", reading: "こんしん", meaning: "friendship, intimacy" },
        { word: "懇切", reading: "こんせつ", meaning: "kind and careful (instruction, explanation, etc.), considerate, helpful" }
    ],
    },
    "左": {
        onyomi: ["サ", "シャ"],
        kunyomi: ["ひだり"],
        examples: [
        { word: "左右", reading: "さゆう", meaning: "left and right, right and left" },
        { word: "左記", reading: "さき", meaning: "undermentioned (statement), the following, at left" },
        { word: "左手", reading: "ひだりて", meaning: "left hand" },
        { word: "左上", reading: "ひだりうえ", meaning: "upper left" }
    ],
    },
    "佐": {
        onyomi: ["サ"],
        kunyomi: [],
        examples: [
        { word: "少佐", reading: "しょうさ", meaning: "major, lieutenant commander, wing commander" },
        { word: "大佐", reading: "たいさ", meaning: "colonel, (navy) captain" },
        { word: "中佐", reading: "ちゅうさ", meaning: "lieutenant colonel, commander (navy)" },
        { word: "補佐", reading: "ほさ", meaning: "aid, help, assistance" }
    ],
    },
    "沙": {
        onyomi: ["サ", "シャ"],
        kunyomi: ["すな", "よなげる"],
        examples: [
        { word: "ご無沙汰", reading: "ごぶさた", meaning: "not writing or contacting for a while, neglecting (failing) to write (call, visit, etc.), long silence" },
        { word: "御無沙汰", reading: "ごぶさた", meaning: "not writing or contacting for a while, neglecting (failing) to write (call, visit, etc.), long silence" }
    ],
    },
    "査": {
        onyomi: ["サ"],
        kunyomi: [],
        examples: [
        { word: "検査", reading: "けんさ", meaning: "inspection (e.g. customs, factory), examination, test" },
        { word: "査察", reading: "ささつ", meaning: "inspection (for compliance), investigation (tax, etc.)" },
        { word: "査証", reading: "さしょう", meaning: "visa" },
        { word: "査定", reading: "さてい", meaning: "assessment (of value, damages, etc.), revision (of a budget)" }
    ],
    },
    "砂": {
        onyomi: ["サ", "シャ"],
        kunyomi: ["すな"],
        examples: [
        { word: "砂丘", reading: "さきゅう", meaning: "sand dune, sand hill" },
        { word: "砂糖", reading: "さとう", meaning: "sugar" },
        { word: "砂浜", reading: "すなはま", meaning: "sandy beach" },
        { word: "砂防", reading: "さぼう", meaning: "erosion control" }
    ],
    },
    "唆": {
        onyomi: ["サ"],
        kunyomi: ["そそ.る", "そそのか.す"],
        examples: [
        { word: "教唆", reading: "きょうさ", meaning: "instigation" },
        { word: "唆す", reading: "そそのかす", meaning: "to instigate, to tempt, to entice" },
        { word: "示唆", reading: "しさ", meaning: "suggestion, hint, implication" }
    ],
    },
    "差": {
        onyomi: ["サ"],
        kunyomi: ["さ.す", "さ.し"],
        examples: [
        { word: "格差", reading: "かくさ", meaning: "qualitative difference, disparity, gap" },
        { word: "誤差", reading: "ごさ", meaning: "measurement error, calculation error" },
        { word: "交差", reading: "こうさ", meaning: "crossing, intersection" },
        { word: "差す", reading: "さす", meaning: "to shine" }
    ],
    },
    "詐": {
        onyomi: ["サ"],
        kunyomi: ["いつわ.る"],
        examples: [
        { word: "詐欺", reading: "さぎ", meaning: "fraud, swindle, graft" },
        { word: "詐取", reading: "さしゅ", meaning: "defrauding, swindle" },
        { word: "詐称", reading: "さしょう", meaning: "misrepresentation, false statement" },
        { word: "詐欺師", reading: "さぎし", meaning: "swindler, fraudster, trickster" }
    ],
    },
    "鎖": {
        onyomi: ["サ"],
        kunyomi: ["くさり", "とざ.す"],
        examples: [
        { word: "鎖国", reading: "さこく", meaning: "national isolation, closing the country (to foreigners)" },
        { word: "封鎖", reading: "ふうさ", meaning: "blockade, lockdown, sealing off (an area)" },
        { word: "閉鎖", reading: "へいさ", meaning: "closing, closure" },
        { word: "連鎖", reading: "れんさ", meaning: "chain, series, connection" }
    ],
    },
    "座": {
        onyomi: ["ザ"],
        kunyomi: ["すわ.る"],
        examples: [
        { word: "一座", reading: "いちざ", meaning: "the whole company, the party, all those present" },
        { word: "王座", reading: "おうざ", meaning: "throne" },
        { word: "銀座", reading: "ぎんざ", meaning: "Ginza (district in Tokyo)" },
        { word: "口座", reading: "こうざ", meaning: "account (e.g. bank)" }
    ],
    },
    "挫": {
        onyomi: ["ザ", "サ"],
        kunyomi: ["くじ.く", "くじ.ける"],
        examples: [
        { word: "挫折", reading: "ざせつ", meaning: "setback, failure (e.g. plans, business), frustration" },
        { word: "捻挫", reading: "ねんざ", meaning: "sprain, twist, wrench" }
    ],
    },
    "才": {
        onyomi: ["サイ"],
        kunyomi: [],
        examples: [
        { word: "鬼才", reading: "きさい", meaning: "wizard, genius, remarkable talent" },
        { word: "才能", reading: "さいのう", meaning: "talent, ability" },
        { word: "秀才", reading: "しゅうさい", meaning: "bright person, talented student, prodigy" },
        { word: "多才", reading: "たさい", meaning: "talented" }
    ],
    },
    "再": {
        onyomi: ["サイ", "サ"],
        kunyomi: ["ふたた.び"],
        examples: [
        { word: "再び", reading: "ふたたび", meaning: "again, once more, a second time" },
        { word: "再演", reading: "さいえん", meaning: "another showing (of a play)" },
        { word: "再会", reading: "さいかい", meaning: "meeting again, reunion" },
        { word: "再開", reading: "さいかい", meaning: "reopening, resumption, restarting" }
    ],
    },
    "災": {
        onyomi: ["サイ"],
        kunyomi: ["わざわ.い"],
        examples: [
        { word: "火災", reading: "かさい", meaning: "conflagration, fire" },
        { word: "災い", reading: "わざわい", meaning: "disaster, calamity, misfortune" },
        { word: "災害", reading: "さいがい", meaning: "calamity, disaster, misfortune" },
        { word: "災難", reading: "さいなん", meaning: "calamity, misfortune, disaster" }
    ],
    },
    "妻": {
        onyomi: ["サイ"],
        kunyomi: ["つま"],
        examples: [
        { word: "稲妻", reading: "いなずま", meaning: "lightning, flash of lightning, lightning bolt" },
        { word: "後妻", reading: "ごさい", meaning: "second wife" },
        { word: "妻子", reading: "さいし", meaning: "wife and children" },
        { word: "人妻", reading: "ひとづま", meaning: "married woman" }
    ],
    },
    "采": {
        onyomi: ["サイ"],
        kunyomi: ["と.る", "いろどり"],
        examples: [
        { word: "喝采", reading: "かっさい", meaning: "cheers, applause, ovation" },
        { word: "采配", reading: "さいはい", meaning: "baton (of command)" },
        { word: "采幣", reading: "さいはい", meaning: "baton (of command)" },
        { word: "風采", reading: "ふうさい", meaning: "appearance, air, mien" }
    ],
    },
    "砕": {
        onyomi: ["サイ"],
        kunyomi: ["くだ.く", "くだ.ける"],
        examples: [
        { word: "玉砕", reading: "ぎょくさい", meaning: "honorable death, death without surrender, honorable defeat" },
        { word: "砕く", reading: "くだく", meaning: "to break (into pieces), to smash, to crush" },
        { word: "砕石", reading: "さいせき", meaning: "crushed stone, macadam" },
        { word: "粉砕", reading: "ふんさい", meaning: "pulverization, pulverisation" }
    ],
    },
    "宰": {
        onyomi: ["サイ"],
        kunyomi: [],
        examples: [
        { word: "宰相", reading: "さいしょう", meaning: "prime minister, premier, chancellor" },
        { word: "主宰", reading: "しゅさい", meaning: "chairmanship, presidency, management" }
    ],
    },
    "栽": {
        onyomi: ["サイ"],
        kunyomi: [],
        examples: [
        { word: "栽培", reading: "さいばい", meaning: "cultivation" },
        { word: "盆栽", reading: "ぼんさい", meaning: "bonsai, miniature potted plant" }
    ],
    },
    "彩": {
        onyomi: ["サイ"],
        kunyomi: ["いろど.る"],
        examples: [
        { word: "光彩", reading: "こうさい", meaning: "brilliance, splendour, splendor" },
        { word: "彩り", reading: "いろどり", meaning: "coloring, colouring, coloration" },
        { word: "彩る", reading: "いろどる", meaning: "to colour, to color, to paint" },
        { word: "彩色", reading: "さいしき", meaning: "colouring, coloring, colouration" }
    ],
    },
    "採": {
        onyomi: ["サイ"],
        kunyomi: ["と.る"],
        examples: [
        { word: "採掘", reading: "さいくつ", meaning: "mining, digging, working (a mine)" },
        { word: "採決", reading: "さいけつ", meaning: "vote, ballot, division" },
        { word: "採算", reading: "さいさん", meaning: "profit" },
        { word: "採取", reading: "さいしゅ", meaning: "picking, collecting, harvesting" }
    ],
    },
    "済": {
        onyomi: ["サイ", "セイ"],
        kunyomi: ["す.む", "-ず.み", "-ずみ", "す.まない", "す.ます", "-す.ます", "すく.う", "な.す", "わたし", "わた.る"],
        examples: [
        { word: "救済", reading: "きゅうさい", meaning: "relief, aid, help" },
        { word: "共済", reading: "きょうさい", meaning: "mutual aid" },
        { word: "経済", reading: "けいざい", meaning: "economy, economics" },
        { word: "決済", reading: "けっさい", meaning: "settlement (of an account), liquidation of debts, payment" }
    ],
    },
    "祭": {
        onyomi: ["サイ"],
        kunyomi: ["まつ.る", "まつ.り", "まつり"],
        examples: [
        { word: "祭る", reading: "まつる", meaning: "to deify, to enshrine" },
        { word: "祭壇", reading: "さいだん", meaning: "altar" },
        { word: "祭典", reading: "さいてん", meaning: "festival" },
        { word: "祭日", reading: "さいじつ", meaning: "national holiday, festival day" }
    ],
    },
    "斎": {
        onyomi: ["サイ"],
        kunyomi: ["とき", "つつし.む", "ものいみ", "い.む", "いわ.う", "いつ.く"],
        examples: [
        { word: "斎場", reading: "さいじょう", meaning: "funeral hall" },
        { word: "書斎", reading: "しょさい", meaning: "study, library, den" }
    ],
    },
    "細": {
        onyomi: ["サイ"],
        kunyomi: ["ほそ.い", "ほそ.る", "こま.か", "こま.かい"],
        examples: [
        { word: "些細", reading: "ささい", meaning: "trivial, trifling, slight" },
        { word: "細々", reading: "こまごま", meaning: "minutely, in detail, with particular attention" },
        { word: "細い", reading: "ほそい", meaning: "thin, slender, fine" },
        { word: "細か", reading: "こまか", meaning: "small, fine, detailed" }
    ],
    },
    "菜": {
        onyomi: ["サイ"],
        kunyomi: ["な"],
        examples: [
        { word: "菜園", reading: "さいえん", meaning: "vegetable garden" },
        { word: "菜種", reading: "なたね", meaning: "rapeseed, coleseed" },
        { word: "菜食", reading: "さいしょく", meaning: "vegetable diet" },
        { word: "山菜", reading: "さんさい", meaning: "edible wild plants" }
    ],
    },
    "最": {
        onyomi: ["サイ", "シュ"],
        kunyomi: ["もっと.も", "つま"],
        examples: [
        { word: "最も", reading: "もっとも", meaning: "most, extremely" },
        { word: "最愛", reading: "さいあい", meaning: "beloved, dearest" },
        { word: "最悪", reading: "さいあく", meaning: "worst" },
        { word: "最期", reading: "さいご", meaning: "one's last moment, one's death, one's end" }
    ],
    },
    "裁": {
        onyomi: ["サイ"],
        kunyomi: ["た.つ", "さば.く"],
        examples: [
        { word: "決裁", reading: "けっさい", meaning: "sanction, approval, decision" },
        { word: "裁く", reading: "さばく", meaning: "to judge, to try, to sit in judgement (on)" },
        { word: "裁つ", reading: "たつ", meaning: "to cut (cloth)" },
        { word: "裁決", reading: "さいけつ", meaning: "decision, ruling, judgement" }
    ],
    },
    "債": {
        onyomi: ["サイ"],
        kunyomi: [],
        examples: [
        { word: "起債", reading: "きさい", meaning: "issuing of bonds" },
        { word: "公債", reading: "こうさい", meaning: "public debt, public bond, government securities" },
        { word: "国債", reading: "こくさい", meaning: "national debt, national securities, government bonds" },
        { word: "債券", reading: "さいけん", meaning: "bond, debenture" }
    ],
    },
    "催": {
        onyomi: ["サイ"],
        kunyomi: ["もよう.す", "もよお.す"],
        examples: [
        { word: "開催", reading: "かいさい", meaning: "holding (a conference, exhibition, etc.), opening, hosting (e.g. the Olympics)" },
        { word: "共催", reading: "きょうさい", meaning: "joint sponsorship (of an event), cosponsorship, joint hosting" },
        { word: "催し", reading: "もよおし", meaning: "event, festivities, function" },
        { word: "催す", reading: "もよおす", meaning: "to hold (an event), to give (a dinner, party, etc.)" }
    ],
    },
    "塞": {
        onyomi: ["ソク", "サイ"],
        kunyomi: ["ふさ.ぐ", "とりで", "み.ちる"],
        examples: [
        { word: "梗塞", reading: "こうそく", meaning: "stoppage, blocking" },
        { word: "閉塞", reading: "へいそく", meaning: "blockage, blockade, blocking up" },
        { word: "塞ぐ", reading: "ふさぐ", meaning: "to stop up, to close up, to block (up)" },
        { word: "塞がる", reading: "ふさがる", meaning: "to be closed, to be blocked, to be healed (e.g. wound)" }
    ],
    },
    "歳": {
        onyomi: ["サイ", "セイ"],
        kunyomi: ["とし", "とせ", "よわい"],
        examples: [
        { word: "何歳", reading: "なんさい", meaning: "how old, what age" },
        { word: "歳月", reading: "さいげつ", meaning: "time, years" },
        { word: "歳出", reading: "さいしゅつ", meaning: "annual expenditure (of a state, organization, etc.)" },
        { word: "歳入", reading: "さいにゅう", meaning: "annual revenue (government), annual income (government), budget receipts" }
    ],
    },
    "載": {
        onyomi: ["サイ"],
        kunyomi: ["の.せる", "の.る"],
        examples: [
        { word: "記載", reading: "きさい", meaning: "mention (in a document), record, entry" },
        { word: "掲載", reading: "けいさい", meaning: "publication (e.g. of an article in a newspaper), carrying (e.g. a story), running (e.g. a serial)" },
        { word: "積載", reading: "せきさい", meaning: "loading, carrying" },
        { word: "搭載", reading: "とうさい", meaning: "loading (on a ship), equipping (an aircraft, car, etc.) with, being equipped with" }
    ],
    },
    "際": {
        onyomi: ["サイ"],
        kunyomi: ["きわ", "-ぎわ"],
        examples: [
        { word: "間際", reading: "まぎわ", meaning: "the point just before ..., the point of (doing), the verge (of)" },
        { word: "交際", reading: "こうさい", meaning: "company, friendship, association" },
        { word: "国際", reading: "こくさい", meaning: "international" },
        { word: "際限", reading: "さいげん", meaning: "limits, end, bounds" }
    ],
    },
    "埼": {
        onyomi: ["キ"],
        kunyomi: ["さき", "さい", "みさき"],
        examples: [
        { word: "埼玉", reading: "さいたま", meaning: "Saitama (city, prefecture)" }
    ],
    },
    "在": {
        onyomi: ["ザイ"],
        kunyomi: ["あ.る"],
        examples: [
        { word: "介在", reading: "かいざい", meaning: "existing (between), interposition, intervention" },
        { word: "健在", reading: "けんざい", meaning: "in good health, alive and well, going strong" },
        { word: "顕在", reading: "けんざい", meaning: "being actual (as opposed to hidden or latent), being apparent, being obvious" },
        { word: "現在", reading: "げんざい", meaning: "the present, present time, now" }
    ],
    },
    "材": {
        onyomi: ["ザイ"],
        kunyomi: [],
        examples: [
        { word: "器材", reading: "きざい", meaning: "tools and materials, equipment and materials" },
        { word: "機材", reading: "きざい", meaning: "machinery and materials, equipment" },
        { word: "教材", reading: "きょうざい", meaning: "teaching materials" },
        { word: "建材", reading: "けんざい", meaning: "building material" }
    ],
    },
    "剤": {
        onyomi: ["ザイ", "スイ", "セイ"],
        kunyomi: ["かる", "けず.る"],
        examples: [
        { word: "錠剤", reading: "じょうざい", meaning: "pill, lozenge, tablet" },
        { word: "洗剤", reading: "せんざい", meaning: "detergent, cleanser, cleaning agent" },
        { word: "調剤", reading: "ちょうざい", meaning: "making up a prescription, dispensing a prescription, preparing a medicine" },
        { word: "薬剤", reading: "やくざい", meaning: "medicine, drug" }
    ],
    },
    "財": {
        onyomi: ["ザイ", "サイ", "ゾク"],
        kunyomi: ["たから"],
        examples: [
        { word: "家財", reading: "かざい", meaning: "household belongings, household goods" },
        { word: "財界", reading: "ざいかい", meaning: "financial world, business circles" },
        { word: "財源", reading: "ざいげん", meaning: "source of funds, resources, finances" },
        { word: "財産", reading: "ざいさん", meaning: "property, fortune, assets" }
    ],
    },
    "罪": {
        onyomi: ["ザイ"],
        kunyomi: ["つみ"],
        examples: [
        { word: "罪人", reading: "ざいにん", meaning: "criminal, lawbreaker, wrongdoer" },
        { word: "謝罪", reading: "しゃざい", meaning: "apology" },
        { word: "犯罪", reading: "はんざい", meaning: "crime, offence, offense" },
        { word: "無罪", reading: "むざい", meaning: "innocence, being not guilty" }
    ],
    },
    "崎": {
        onyomi: ["キ"],
        kunyomi: ["さき", "さい", "みさき"],
        examples: [
        { word: "川崎", reading: "かわさき", meaning: "Kawasaki (city)" },
        { word: "長崎", reading: "ながさき", meaning: "Nagasaki (city, prefecture)" },
        { word: "崎", reading: "さき", meaning: "small peninsula, cape, promontory" }
    ],
    },
    "作": {
        onyomi: ["サク", "サ"],
        kunyomi: ["つく.る", "つく.り", "-づく.り"],
        examples: [
        { word: "遺作", reading: "いさく", meaning: "posthumous works" },
        { word: "稲作", reading: "いなさく", meaning: "rice cultivation, rice crop" },
        { word: "佳作", reading: "かさく", meaning: "fine (piece of) work, excellent work" },
        { word: "凶作", reading: "きょうさく", meaning: "bad harvest, poor crop" }
    ],
    },
    "削": {
        onyomi: ["サク"],
        kunyomi: ["けず.る", "はつ.る", "そ.ぐ"],
        examples: [
        { word: "削る", reading: "けずる", meaning: "to shave (wood, leather, etc.), to sharpen (e.g. pencil), to plane" },
        { word: "削減", reading: "さくげん", meaning: "cut, reduction, curtailment" },
        { word: "削除", reading: "さくじょ", meaning: "deletion, elimination, erasure" },
        { word: "添削", reading: "てんさく", meaning: "correction, looking over, touching up" }
    ],
    },
    "昨": {
        onyomi: ["サク"],
        kunyomi: [],
        examples: [
        { word: "昨今", reading: "さっこん", meaning: "these days, nowadays, recently" },
        { word: "昨春", reading: "さくしゅん", meaning: "last spring, the spring of last year" },
        { word: "昨年", reading: "さくねん", meaning: "last year" },
        { word: "昨晩", reading: "さくばん", meaning: "last night" }
    ],
    },
    "柵": {
        onyomi: ["サク", "サン"],
        kunyomi: ["しがら.む", "しがらみ", "とりで", "やらい"],
        examples: [
        { word: "柵", reading: "さく", meaning: "fence, paling, railing" }
    ],
    },
    "索": {
        onyomi: ["サク"],
        kunyomi: [],
        examples: [
        { word: "検索", reading: "けんさく", meaning: "looking up (e.g. a word in a dictionary), search (e.g. on the Internet), retrieval (of information)" },
        { word: "索引", reading: "さくいん", meaning: "index (in a book)" },
        { word: "思索", reading: "しさく", meaning: "speculation, thinking, meditation" },
        { word: "捜索", reading: "そうさく", meaning: "search (esp. for someone or something missing), manhunt" }
    ],
    },
    "策": {
        onyomi: ["サク"],
        kunyomi: [],
        examples: [
        { word: "国策", reading: "こくさく", meaning: "national policy" },
        { word: "策定", reading: "さくてい", meaning: "formulation (of a plan, policy, etc.), decision, settling on" },
        { word: "策略", reading: "さくりゃく", meaning: "stratagem, artifice, trick" },
        { word: "散策", reading: "さんさく", meaning: "walking, strolling, roaming" }
    ],
    },
    "酢": {
        onyomi: ["サク"],
        kunyomi: ["す"],
        examples: [
        { word: "甘酢", reading: "あまず", meaning: "sweet vinegar" },
        { word: "酢酸", reading: "さくさん", meaning: "acetic acid" },
        { word: "お酢", reading: "おす", meaning: "vinegar" },
        { word: "酢の物", reading: "すのもの", meaning: "vinegared dish, pickled dish" }
    ],
    },
    "搾": {
        onyomi: ["サク"],
        kunyomi: ["しぼ.る"],
        examples: [
        { word: "搾取", reading: "さくしゅ", meaning: "exploitation, bleeding dry, squeezing dry" },
        { word: "搾乳", reading: "さくにゅう", meaning: "milking (a cow, goat, etc.)" },
        { word: "搾る", reading: "しぼる", meaning: "to wring (towel, rag), to squeeze" }
    ],
    },
    "錯": {
        onyomi: ["サク", "シャク"],
        kunyomi: [],
        examples: [
        { word: "交錯", reading: "こうさく", meaning: "mixture, blending, complication" },
        { word: "錯覚", reading: "さっかく", meaning: "illusion, hallucination" },
        { word: "錯誤", reading: "さくご", meaning: "mistake, error, discrepancy" },
        { word: "錯乱", reading: "さくらん", meaning: "confusion, distraction, derangement" }
    ],
    },
    "咲": {
        onyomi: ["ショウ"],
        kunyomi: ["さ.く", "-ざき"],
        examples: [
        { word: "咲く", reading: "さく", meaning: "to bloom, to flower, to blossom" },
        { word: "遅咲き", reading: "おそざき", meaning: "blooming late, flowering late, blossoming late" },
        { word: "返り咲き", reading: "かえりざき", meaning: "comeback (e.g. in business), reinstatement" },
        { word: "咲き乱れる", reading: "さきみだれる", meaning: "to bloom in profusion" }
    ],
    },
    "冊": {
        onyomi: ["サツ", "サク"],
        kunyomi: ["ふみ"],
        examples: [
        { word: "一冊", reading: "いっさつ", meaning: "one copy (of a book, magazine, etc.), one volume" },
        { word: "冊子", reading: "さっし", meaning: "book, booklet, story book" },
        { word: "短冊", reading: "たんざく", meaning: "tanzaku, long, narrow strip of paper used for writing poetry, wishes, decorations, etc." },
        { word: "分冊", reading: "ぶんさつ", meaning: "separate volume, fascicle, fascicule" }
    ],
    },
    "札": {
        onyomi: ["サツ"],
        kunyomi: ["ふだ"],
        examples: [
        { word: "荷札", reading: "にふだ", meaning: "label, tag" },
        { word: "改札", reading: "かいさつ", meaning: "examination of tickets" },
        { word: "札束", reading: "さつたば", meaning: "bundle of banknotes, stack of bills" },
        { word: "入札", reading: "にゅうさつ", meaning: "bid, tender, bidding" }
    ],
    },
    "刷": {
        onyomi: ["サツ"],
        kunyomi: ["す.る", "-ず.り", "-ずり", "は.く"],
        examples: [
        { word: "印刷", reading: "いんさつ", meaning: "printing" },
        { word: "刷る", reading: "する", meaning: "to print" },
        { word: "刷新", reading: "さっしん", meaning: "reform, renovation" },
        { word: "増刷", reading: "ぞうさつ", meaning: "additional printing, additional print run, reprint" }
    ],
    },
    "刹": {
        onyomi: ["セチ", "セツ", "サツ"],
        kunyomi: [],
        examples: [
        { word: "刹那", reading: "せつな", meaning: "moment, instant" }
    ],
    },
    "拶": {
        onyomi: ["サツ"],
        kunyomi: ["せま.る"],
        examples: [
        { word: "挨拶", reading: "あいさつ", meaning: "greeting, greetings, salutation" }
    ],
    },
    "殺": {
        onyomi: ["サツ", "サイ", "セツ"],
        kunyomi: ["ころ.す", "-ごろ.し", "そ.ぐ", "あや.める"],
        examples: [
        { word: "暗殺", reading: "あんさつ", meaning: "assassination" },
        { word: "虐殺", reading: "ぎゃくさつ", meaning: "slaughter, massacre" },
        { word: "絞殺", reading: "こうさつ", meaning: "strangling (to death), strangulation" },
        { word: "殺し", reading: "ころし", meaning: "murder, killing, murderer" }
    ],
    },
    "察": {
        onyomi: ["サツ"],
        kunyomi: [],
        examples: [
        { word: "監察", reading: "かんさつ", meaning: "inspection, inspector" },
        { word: "観察", reading: "かんさつ", meaning: "observation, survey, watching" },
        { word: "警察", reading: "けいさつ", meaning: "police" },
        { word: "検察", reading: "けんさつ", meaning: "criminal investigation, prosecution" }
    ],
    },
    "撮": {
        onyomi: ["サツ"],
        kunyomi: ["と.る", "つま.む", "-ど.り"],
        examples: [
        { word: "撮る", reading: "とる", meaning: "to take (a photograph)" },
        { word: "撮影", reading: "さつえい", meaning: "photography (still or motion), photographing, filming" },
        { word: "写真撮影", reading: "しゃしんさつえい", meaning: "photography, taking photographs" }
    ],
    },
    "擦": {
        onyomi: ["サツ"],
        kunyomi: ["す.る", "す.れる", "-ず.れ", "こす.る", "こす.れる"],
        examples: [
        { word: "擦る", reading: "こする", meaning: "to rub, to scrub, to scrape" },
        { word: "摩擦", reading: "まさつ", meaning: "friction" },
        { word: "擦り傷", reading: "すりきず", meaning: "scratch, graze, scrape" }
    ],
    },
    "雑": {
        onyomi: ["ザツ", "ゾウ"],
        kunyomi: ["まじ.える", "まじ.る"],
        examples: [
        { word: "混雑", reading: "こんざつ", meaning: "congestion, crush, crowding" },
        { word: "雑音", reading: "ざつおん", meaning: "noise (usu. unpleasant)" },
        { word: "雑貨", reading: "ざっか", meaning: "miscellaneous goods, general goods, sundries" },
        { word: "雑居", reading: "ざっきょ", meaning: "living together, mixed residence, sharing living quarters" }
    ],
    },
    "皿": {
        onyomi: ["ベイ"],
        kunyomi: ["さら"],
        examples: [
        { word: "灰皿", reading: "はいざら", meaning: "ashtray" },
        { word: "小皿", reading: "こざら", meaning: "small plate, small dish" },
        { word: "皿洗い", reading: "さらあらい", meaning: "washing-up, dish-washing" },
        { word: "受け皿", reading: "うけざら", meaning: "saucer" }
    ],
    },
    "三": {
        onyomi: ["サン", "ゾウ"],
        kunyomi: ["み", "み.つ", "みっ.つ"],
        examples: [
        { word: "再三", reading: "さいさん", meaning: "again and again, repeatedly" },
        { word: "三つ", reading: "みっつ", meaning: "three" },
        { word: "三回", reading: "さんかい", meaning: "three times" },
        { word: "三角", reading: "さんかく", meaning: "triangle, triangular shape" }
    ],
    },
    "山": {
        onyomi: ["サン", "セン"],
        kunyomi: ["やま"],
        examples: [
        { word: "奥山", reading: "おくやま", meaning: "remote mountain, mountain recesses" },
        { word: "下山", reading: "げざん", meaning: "descending a mountain, descent" },
        { word: "火山", reading: "かざん", meaning: "volcano" },
        { word: "岩山", reading: "いわやま", meaning: "rocky mountain" }
    ],
    },
    "参": {
        onyomi: ["サン", "シン"],
        kunyomi: ["まい.る", "まい-", "まじわる", "みつ"],
        examples: [
        { word: "古参", reading: "こさん", meaning: "senior, veteran, old-timer" },
        { word: "降参", reading: "こうさん", meaning: "surrender, submission, capitulation" },
        { word: "参る", reading: "まいる", meaning: "to go, to come" },
        { word: "参院", reading: "さんいん", meaning: "House of Councillors (upper house of the National Diet of Japan)" }
    ],
    },
    "桟": {
        onyomi: ["サン", "セン"],
        kunyomi: ["かけはし"],
        examples: [
        { word: "桟橋", reading: "さんばし", meaning: "wharf, bridge, jetty" }
    ],
    },
    "蚕": {
        onyomi: ["サン", "テン"],
        kunyomi: ["かいこ", "こ"],
        examples: [
        { word: "蚕糸", reading: "さんし", meaning: "silk thread, silk yarn" },
        { word: "養蚕", reading: "ようさん", meaning: "sericulture, silkworm culture, silkworm raising" },
        { word: "蚕", reading: "かいこ", meaning: "silkworm (Bombyx mori)" }
    ],
    },
    "惨": {
        onyomi: ["サン", "ザン"],
        kunyomi: ["みじ.め", "いた.む", "むご.い"],
        examples: [
        { word: "惨め", reading: "みじめ", meaning: "miserable, wretched, unhappy" },
        { word: "惨事", reading: "さんじ", meaning: "disaster, tragedy, tragic incident" },
        { word: "惨状", reading: "さんじょう", meaning: "disastrous scene, terrible spectacle" },
        { word: "悲惨", reading: "ひさん", meaning: "disastrous, tragic, miserable" }
    ],
    },
    "産": {
        onyomi: ["サン"],
        kunyomi: ["う.む", "う.まれる", "うぶ-", "む.す"],
        examples: [
        { word: "お産", reading: "おさん", meaning: "(giving) birth, childbirth, delivery" },
        { word: "遺産", reading: "いさん", meaning: "inheritance, bequest, legacy" },
        { word: "共産", reading: "きょうさん", meaning: "communism" },
        { word: "原産", reading: "げんさん", meaning: "place of origin, habitat" }
    ],
    },
    "傘": {
        onyomi: ["サン"],
        kunyomi: ["かさ"],
        examples: [
        { word: "傘下", reading: "さんか", meaning: "affiliated with, under jurisdiction of, under the umbrella" },
        { word: "日傘", reading: "ひがさ", meaning: "parasol (esp. one carried in the hand), sunshade" },
        { word: "傘", reading: "かさ", meaning: "umbrella, parasol" }
    ],
    },
    "散": {
        onyomi: ["サン"],
        kunyomi: ["ち.る", "ち.らす", "-ち.らす", "ち.らかす", "ち.らかる", "ち.らばる", "ばら", "ばら.ける"],
        examples: [
        { word: "解散", reading: "かいさん", meaning: "breaking up (a meeting, gathering, etc.), dispersal (e.g. of a crowd)" },
        { word: "拡散", reading: "かくさん", meaning: "spreading, disseminating, scattering" },
        { word: "閑散", reading: "かんさん", meaning: "deserted (esp. store, market, town, streets), quiet, still" },
        { word: "散る", reading: "ちる", meaning: "to fall (e.g. blossoms, leaves)" }
    ],
    },
    "算": {
        onyomi: ["サン"],
        kunyomi: ["そろ"],
        examples: [
        { word: "演算", reading: "えんざん", meaning: "operation, calculation" },
        { word: "加算", reading: "かさん", meaning: "addition, adding, supplement" },
        { word: "概算", reading: "がいさん", meaning: "approximation, rough estimate, ballpark figure" },
        { word: "換算", reading: "かんさん", meaning: "conversion (e.g. yen to dollars), change, exchange" }
    ],
    },
    "酸": {
        onyomi: ["サン"],
        kunyomi: ["す.い"],
        examples: [
        { word: "塩酸", reading: "えんさん", meaning: "hydrochloric acid" },
        { word: "核酸", reading: "かくさん", meaning: "nucleic acid" },
        { word: "酸化", reading: "さんか", meaning: "oxidation, oxidization" },
        { word: "酸性", reading: "さんせい", meaning: "acidity" }
    ],
    },
    "賛": {
        onyomi: ["サン"],
        kunyomi: ["たす.ける", "たた.える"],
        examples: [
        { word: "協賛", reading: "きょうさん", meaning: "support, mutual aid, cooperation" },
        { word: "賛歌", reading: "さんか", meaning: "song of praise, eulogy, paean" },
        { word: "賛辞", reading: "さんじ", meaning: "eulogy, compliment" },
        { word: "賛助", reading: "さんじょ", meaning: "support, patronage" }
    ],
    },
    "残": {
        onyomi: ["ザン", "サン"],
        kunyomi: ["のこ.る", "のこ.す", "そこな.う", "のこ.り"],
        examples: [
        { word: "残り", reading: "のこり", meaning: "remainder, remnant, the rest" },
        { word: "残る", reading: "のこる", meaning: "to remain, to be left" },
        { word: "残虐", reading: "ざんぎゃく", meaning: "cruel, brutal, savage" },
        { word: "残業", reading: "ざんぎょう", meaning: "overtime (work)" }
    ],
    },
    "斬": {
        onyomi: ["ザン", "サン", "セン", "ゼン"],
        kunyomi: ["き.る"],
        examples: [
        { word: "斬る", reading: "きる", meaning: "to kill (a human) using a blade (sword, machete, knife, etc.), to slice (off), to lop (off)" },
        { word: "斬新", reading: "ざんしん", meaning: "novel, original, new" }
    ],
    },
    "暫": {
        onyomi: ["ザン"],
        kunyomi: ["しばら.く"],
        examples: [
        { word: "暫く", reading: "しばらく", meaning: "for a moment, for a minute" },
        { word: "暫定", reading: "ざんてい", meaning: "provisional, temporary, tentative" }
    ],
    },
    "士": {
        onyomi: ["シ"],
        kunyomi: ["さむらい"],
        examples: [
        { word: "学士", reading: "がくし", meaning: "university graduate, bachelor" },
        { word: "棋士", reading: "きし", meaning: "professional shogi player, professional go player" },
        { word: "騎士", reading: "きし", meaning: "(medieval) knight" },
        { word: "剣士", reading: "けんし", meaning: "swordsman, swordswoman, fencer" }
    ],
    },
    "子": {
        onyomi: ["シ", "ス", "ツ"],
        kunyomi: ["こ", "-こ", "ね"],
        examples: [
        { word: "椅子", reading: "いす", meaning: "chair, seat, stool" },
        { word: "因子", reading: "いんし", meaning: "factor" },
        { word: "王子", reading: "おうじ", meaning: "prince" },
        { word: "茄子", reading: "なす", meaning: "eggplant (Solanum melongena), aubergine" }
    ],
    },
    "支": {
        onyomi: ["シ"],
        kunyomi: ["ささ.える", "つか.える", "か.う"],
        examples: [
        { word: "支援", reading: "しえん", meaning: "support, backing, aid" },
        { word: "支給", reading: "しきゅう", meaning: "provision, supply, payment" },
        { word: "支局", reading: "しきょく", meaning: "branch office" },
        { word: "支持", reading: "しじ", meaning: "support, backing, endorsement" }
    ],
    },
    "止": {
        onyomi: ["シ"],
        kunyomi: ["と.まる", "-ど.まり", "と.める", "-と.める", "-ど.め", "とど.める", "とど.め", "とど.まる", "や.める", "や.む", "-や.む", "よ.す", "-さ.す", "-さ.し"],
        examples: [
        { word: "休止", reading: "きゅうし", meaning: "pause, suspension, rest" },
        { word: "禁止", reading: "きんし", meaning: "prohibition, inhibition, ban" },
        { word: "止す", reading: "よす", meaning: "to stop (doing), to cease, to desist" },
        { word: "止む", reading: "やむ", meaning: "to cease, to stop, to be over" }
    ],
    },
    "氏": {
        onyomi: ["シ"],
        kunyomi: ["うじ", "-うじ"],
        examples: [
        { word: "氏神", reading: "うじがみ", meaning: "patron god, tutelar deity, guardian deity" },
        { word: "氏名", reading: "しめい", meaning: "(full) name, identity" },
        { word: "摂氏", reading: "せっし", meaning: "Celsius, centigrade" },
        { word: "同氏", reading: "どうし", meaning: "the said person, he, she" }
    ],
    },
    "仕": {
        onyomi: ["シ", "ジ"],
        kunyomi: ["つか.える"],
        examples: [
        { word: "仕業", reading: "しわざ", meaning: "deed (esp. negative), act, action" },
        { word: "仕事", reading: "しごと", meaning: "work, job, labor" },
        { word: "仕手", reading: "して", meaning: "doer, performer" },
        { word: "仕草", reading: "しぐさ", meaning: "gesture, movement, action" }
    ],
    },
    "史": {
        onyomi: ["シ"],
        kunyomi: [],
        examples: [
        { word: "史家", reading: "しか", meaning: "historian" },
        { word: "史学", reading: "しがく", meaning: "study of history" },
        { word: "史実", reading: "しじつ", meaning: "historical fact" },
        { word: "史上", reading: "しじょう", meaning: "in history, ever, historical" }
    ],
    },
    "司": {
        onyomi: ["シ"],
        kunyomi: ["つかさど.る"],
        examples: [
        { word: "公司", reading: "コンス", meaning: "company (in China), firm" },
        { word: "行司", reading: "ぎょうじ", meaning: "referee" },
        { word: "司る", reading: "つかさどる", meaning: "to be in charge of, to manage, to direct" },
        { word: "司会", reading: "しかい", meaning: "leading a meeting, presiding over a meeting, officiating at a ceremony" }
    ],
    },
    "四": {
        onyomi: ["シ"],
        kunyomi: ["よ", "よ.つ", "よっ.つ", "よん"],
        examples: [
        { word: "四つ", reading: "よっつ", meaning: "four, 4" },
        { word: "四角", reading: "しかく", meaning: "quadrilateral, square" },
        { word: "四季", reading: "しき", meaning: "the four seasons" },
        { word: "四球", reading: "しきゅう", meaning: "base on balls, walk, pass" }
    ],
    },
    "市": {
        onyomi: ["シ"],
        kunyomi: ["いち"],
        examples: [
        { word: "市営", reading: "しえい", meaning: "(under) municipal management (transport, housing, etc.), city facility management" },
        { word: "市会", reading: "しかい", meaning: "city council" },
        { word: "市外", reading: "しがい", meaning: "outside the city, suburbs" },
        { word: "市街", reading: "しがい", meaning: "urban areas, the streets, town" }
    ],
    },
    "矢": {
        onyomi: ["シ"],
        kunyomi: ["や"],
        examples: [
        { word: "弓矢", reading: "ゆみや", meaning: "bow and arrow" },
        { word: "矢印", reading: "やじるし", meaning: "arrow (symbol)" },
        { word: "矢先", reading: "やさき", meaning: "arrowhead" },
        { word: "無理矢理", reading: "むりやり", meaning: "forcibly, by force, against one's will" }
    ],
    },
    "旨": {
        onyomi: ["シ"],
        kunyomi: ["むね", "うま.い"],
        examples: [
        { word: "旨い", reading: "うまい", meaning: "skillful, skilful, skilled" },
        { word: "趣旨", reading: "しゅし", meaning: "meaning, point (e.g. of a statement), gist" },
        { word: "本旨", reading: "ほんし", meaning: "main object, principal object, true aim" },
        { word: "要旨", reading: "ようし", meaning: "(main) point, gist, key points" }
    ],
    },
    "死": {
        onyomi: ["シ"],
        kunyomi: ["し.ぬ", "し.に-"],
        examples: [
        { word: "急死", reading: "きゅうし", meaning: "sudden death" },
        { word: "枯死", reading: "こし", meaning: "withering, dying" },
        { word: "死ぬ", reading: "しぬ", meaning: "to die, to pass away" },
        { word: "死因", reading: "しいん", meaning: "cause of death" }
    ],
    },
    "糸": {
        onyomi: ["シ"],
        kunyomi: ["いと"],
        examples: [
        { word: "蚕糸", reading: "さんし", meaning: "silk thread, silk yarn" },
        { word: "糸口", reading: "いとぐち", meaning: "beginning, start, first step" },
        { word: "生糸", reading: "きいと", meaning: "raw silk thread" },
        { word: "毛糸", reading: "けいと", meaning: "knitting wool, woolen yarn, woollen yarn" }
    ],
    },
    "至": {
        onyomi: ["シ"],
        kunyomi: ["いた.る"],
        examples: [
        { word: "夏至", reading: "げし", meaning: "summer solstice" },
        { word: "至る", reading: "いたる", meaning: "to arrive at (e.g. a decision), to reach (a stage), to attain" },
        { word: "至急", reading: "しきゅう", meaning: "urgent, pressing, immediate" },
        { word: "至上", reading: "しじょう", meaning: "supremacy" }
    ],
    },
    "伺": {
        onyomi: ["シ"],
        kunyomi: ["うかが.う"],
        examples: [
        { word: "伺う", reading: "うかがう", meaning: "to call on someone, to call at a place, to pay a visit" },
        { word: "進退伺い", reading: "しんたいうかがい", meaning: "informal resignation, unofficial resignation" }
    ],
    },
    "志": {
        onyomi: ["シ"],
        kunyomi: ["シリング", "こころざ.す", "こころざし"],
        examples: [
        { word: "意志", reading: "いし", meaning: "will, volition, intention" },
        { word: "遺志", reading: "いし", meaning: "wishes of a deceased person, dying wish" },
        { word: "志す", reading: "こころざす", meaning: "to aspire to, to aim for, to intend" },
        { word: "志願", reading: "しがん", meaning: "aspiration, volunteering, desire" }
    ],
    },
    "私": {
        onyomi: ["シ"],
        kunyomi: ["わたくし", "わたし"],
        examples: [
        { word: "公私", reading: "こうし", meaning: "public and private matters, official and personal affairs, professional and personal lives" },
        { word: "私見", reading: "しけん", meaning: "personal opinion" },
        { word: "私塾", reading: "しじゅく", meaning: "small private school (esp. for cramming)" },
        { word: "私設", reading: "しせつ", meaning: "private" }
    ],
    },
    "使": {
        onyomi: ["シ"],
        kunyomi: ["つか.う", "つか.い", "-つか.い", "-づか.い"],
        examples: [
        { word: "駆使", reading: "くし", meaning: "using freely, making full use of, having a good command of" },
        { word: "公使", reading: "こうし", meaning: "envoy, diplomat below the rank of ambassador (e.g. deputy chief of mission, charge d'affaires), minister (of legation)" },
        { word: "行使", reading: "こうし", meaning: "use, exercise (of one's right, authority, power, etc.)" },
        { word: "酷使", reading: "こくし", meaning: "exploitation, overuse, abuse" }
    ],
    },
    "刺": {
        onyomi: ["シ"],
        kunyomi: ["さ.す", "さ.さる", "さ.し", "さし", "とげ"],
        examples: [
        { word: "刺し", reading: "さし", meaning: "grain thief, sharpened tube for testing rice in bags" },
        { word: "刺す", reading: "さす", meaning: "to pierce, to stab, to prick" },
        { word: "刺繍", reading: "ししゅう", meaning: "embroidery" },
        { word: "刺身", reading: "さしみ", meaning: "sashimi (raw sliced fish, shellfish or crustaceans)" }
    ],
    },
    "始": {
        onyomi: ["シ"],
        kunyomi: ["はじ.める", "-はじ.める", "はじ.まる"],
        examples: [
        { word: "開始", reading: "かいし", meaning: "start, commencement, beginning" },
        { word: "原始", reading: "げんし", meaning: "origin, beginning, genesis" },
        { word: "始業", reading: "しぎょう", meaning: "start of work, commencement, opening" },
        { word: "始終", reading: "しじゅう", meaning: "continuously, from beginning to end, from first to last" }
    ],
    },
    "姉": {
        onyomi: ["シ"],
        kunyomi: ["あね", "はは"],
        examples: [
        { word: "義姉", reading: "ぎし", meaning: "sister-in-law (spouse's older sister or older brother's wife)" },
        { word: "姉妹", reading: "しまい", meaning: "sisters" },
        { word: "姉さん", reading: "ねえさん", meaning: "older sister, elder sister" },
        { word: "従姉妹", reading: "いとこ", meaning: "cousin (female)" }
    ],
    },
    "枝": {
        onyomi: ["シ"],
        kunyomi: ["えだ"],
        examples: [
        { word: "枝豆", reading: "えだまめ", meaning: "edamame (green soybeans)" },
        { word: "小枝", reading: "こえだ", meaning: "twig, spray" },
        { word: "大枝", reading: "おおえだ", meaning: "large branch, bough" },
        { word: "枝葉", reading: "えだは", meaning: "branches and leaves, foliage" }
    ],
    },
    "祉": {
        onyomi: ["シ"],
        kunyomi: [],
        examples: [
        { word: "福祉", reading: "ふくし", meaning: "welfare, well-being, social welfare" },
        { word: "社会福祉", reading: "しゃかいふくし", meaning: "social welfare" },
        { word: "老人福祉", reading: "ろうじんふくし", meaning: "welfare for the aged" }
    ],
    },
    "肢": {
        onyomi: ["シ"],
        kunyomi: [],
        examples: [
        { word: "下肢", reading: "かし", meaning: "lower limbs, legs" },
        { word: "四肢", reading: "しし", meaning: "the (four) limbs, arms and legs" },
        { word: "肢体", reading: "したい", meaning: "limbs, arms and legs, body" },
        { word: "選択肢", reading: "せんたくし", meaning: "choices, alternatives, options" }
    ],
    },
    "姿": {
        onyomi: ["シ"],
        kunyomi: ["すがた"],
        examples: [
        { word: "姿勢", reading: "しせい", meaning: "posture, pose, position" },
        { word: "容姿", reading: "ようし", meaning: "(physical) appearance (of a person), one's face and figure" },
        { word: "後ろ姿", reading: "うしろすがた", meaning: "(a person's) appearance from behind, person as seen from behind, back view" },
        { word: "姿", reading: "すがた", meaning: "figure, form, shape" }
    ],
    },
    "思": {
        onyomi: ["シ"],
        kunyomi: ["おも.う", "おもえら.く", "おぼ.す"],
        examples: [
        { word: "意思", reading: "いし", meaning: "intention, wish, purpose" },
        { word: "思案", reading: "しあん", meaning: "careful thought, consideration, deliberation" },
        { word: "思考", reading: "しこう", meaning: "thought, consideration, thinking" },
        { word: "思索", reading: "しさく", meaning: "speculation, thinking, meditation" }
    ],
    },
    "指": {
        onyomi: ["シ"],
        kunyomi: ["ゆび", "さ.す", "-さ.し"],
        examples: [
        { word: "屈指", reading: "くっし", meaning: "leading, foremost, preeminent" },
        { word: "指す", reading: "さす", meaning: "to point" },
        { word: "指揮", reading: "しき", meaning: "command, direction, supervision" },
        { word: "指示", reading: "しじ", meaning: "indication, denotation, designation" }
    ],
    },
    "施": {
        onyomi: ["シ", "セ"],
        kunyomi: ["ほどこ.す"],
        examples: [
        { word: "施す", reading: "ほどこす", meaning: "to give (time, money, goods), to donate" },
        { word: "施策", reading: "しさく", meaning: "policy, measure" },
        { word: "施政", reading: "しせい", meaning: "government, administration, statesmanship" },
        { word: "施設", reading: "しせつ", meaning: "facility, facilities, institution" }
    ],
    },
    "師": {
        onyomi: ["シ"],
        kunyomi: ["いくさ"],
        examples: [
        { word: "医師", reading: "いし", meaning: "doctor, physician" },
        { word: "恩師", reading: "おんし", meaning: "teacher (to whom one owes a debt of gratitude), mentor, one's former teacher" },
        { word: "技師", reading: "ぎし", meaning: "engineer, technical officer" },
        { word: "漁師", reading: "りょうし", meaning: "fisherman" }
    ],
    },
    "恣": {
        onyomi: ["シ"],
        kunyomi: ["ほしいまま"],
        examples: [
        { word: "恣意", reading: "しい", meaning: "arbitrariness, self-will, whim" },
        { word: "驕恣", reading: "きょうし", meaning: "being proud and self-willed" },
        { word: "放恣", reading: "ほうし", meaning: "licentious, self-indulgent" },
        { word: "恣心", reading: "ししん", meaning: "selfish, self-indulgent heart" }
    ],
    },
    "紙": {
        onyomi: ["シ"],
        kunyomi: ["かみ"],
        examples: [
        { word: "印紙", reading: "いんし", meaning: "(revenue) stamp" },
        { word: "銀紙", reading: "ぎんがみ", meaning: "aluminum foil, aluminium foil, tinfoil" },
        { word: "厚紙", reading: "あつがみ", meaning: "cardboard, thick paper" },
        { word: "紙袋", reading: "かみぶくろ", meaning: "paper bag" }
    ],
    },
    "脂": {
        onyomi: ["シ"],
        kunyomi: ["あぶら"],
        examples: [
        { word: "脂身", reading: "あぶらみ", meaning: "fat (of meat), fatty meat" },
        { word: "脂肪", reading: "しぼう", meaning: "fat, grease, blubber" },
        { word: "樹脂", reading: "じゅし", meaning: "resin, rosin" },
        { word: "油脂", reading: "ゆし", meaning: "fats and oils" }
    ],
    },
    "視": {
        onyomi: ["シ"],
        kunyomi: ["み.る"],
        examples: [
        { word: "監視", reading: "かんし", meaning: "monitoring, watching, observation" },
        { word: "凝視", reading: "ぎょうし", meaning: "stare, gaze, fixation" },
        { word: "近視", reading: "きんし", meaning: "myopia, shortsightedness, nearsightedness" },
        { word: "警視", reading: "けいし", meaning: "police superintendent" }
    ],
    },
    "紫": {
        onyomi: ["シ"],
        kunyomi: ["むらさき"],
        examples: [
        { word: "紫色", reading: "むらさきいろ", meaning: "purple, violet" },
        { word: "紫外線", reading: "しがいせん", meaning: "ultraviolet rays, ultraviolet radiation, UV radiation" },
        { word: "紫陽花", reading: "あじさい", meaning: "bigleaf hydrangea (Hydrangea macrophylla), French hydrangea" },
        { word: "紫", reading: "むらさき", meaning: "purple, violet" }
    ],
    },
    "詞": {
        onyomi: ["シ"],
        kunyomi: ["ことば"],
        examples: [
        { word: "歌詞", reading: "かし", meaning: "song lyrics, words of a song, libretto" },
        { word: "作詞", reading: "さくし", meaning: "(writing) song lyrics" },
        { word: "助詞", reading: "じょし", meaning: "particle, postpositional word in Japanese grammar that functions as an auxiliary to a main word" },
        { word: "動詞", reading: "どうし", meaning: "verb" }
    ],
    },
    "歯": {
        onyomi: ["シ"],
        kunyomi: ["よわい", "は", "よわ.い", "よわい.する"],
        examples: [
        { word: "義歯", reading: "ぎし", meaning: "artificial tooth" },
        { word: "歯科", reading: "しか", meaning: "dentistry" },
        { word: "歯車", reading: "はぐるま", meaning: "gear, cogwheel" },
        { word: "虫歯", reading: "むしば", meaning: "tooth decay, decayed tooth, dental cavity" }
    ],
    },
    "嗣": {
        onyomi: ["シ"],
        kunyomi: [],
        examples: [
        { word: "嗣ぐ", reading: "つぐ", meaning: "to succeed (a person, to a position, etc.), to inherit, to take over" },
        { word: "継嗣", reading: "けいし", meaning: "successor, heir, heiress" },
        { word: "後嗣", reading: "こうし", meaning: "heir, successor" },
        { word: "嗣子", reading: "しし", meaning: "heir" }
    ],
    },
    "試": {
        onyomi: ["シ"],
        kunyomi: ["こころ.みる", "ため.す"],
        examples: [
        { word: "試し", reading: "ためし", meaning: "trial, test, try" },
        { word: "試す", reading: "ためす", meaning: "to try (out), to have a try (at), to test" },
        { word: "試み", reading: "こころみ", meaning: "attempt, trial, experiment" },
        { word: "試案", reading: "しあん", meaning: "tentative plan, draft plan" }
    ],
    },
    "詩": {
        onyomi: ["シ"],
        kunyomi: ["うた"],
        examples: [
        { word: "漢詩", reading: "かんし", meaning: "Chinese poem, Chinese poetry" },
        { word: "詩集", reading: "ししゅう", meaning: "poetry anthology, collection of poems, collected poems" },
        { word: "詩情", reading: "しじょう", meaning: "poetic sentiment" },
        { word: "詩人", reading: "しじん", meaning: "poet" }
    ],
    },
    "資": {
        onyomi: ["シ"],
        kunyomi: [],
        examples: [
        { word: "外資", reading: "がいし", meaning: "foreign capital (e.g. in a company), foreign investment" },
        { word: "資格", reading: "しかく", meaning: "qualifications, requirements, capabilities" },
        { word: "資金", reading: "しきん", meaning: "funds, capital" },
        { word: "資源", reading: "しげん", meaning: "resources" }
    ],
    },
    "飼": {
        onyomi: ["シ"],
        kunyomi: ["か.う"],
        examples: [
        { word: "飼う", reading: "かう", meaning: "to keep (a pet or other animal), to have, to own" },
        { word: "飼育", reading: "しいく", meaning: "breeding, raising, rearing" },
        { word: "飼料", reading: "しりょう", meaning: "fodder, feed" },
        { word: "飼い犬", reading: "かいいぬ", meaning: "pet dog" }
    ],
    },
    "誌": {
        onyomi: ["シ"],
        kunyomi: [],
        examples: [
        { word: "雑誌", reading: "ざっし", meaning: "magazine, journal, periodical" },
        { word: "誌上", reading: "しじょう", meaning: "in a magazine" },
        { word: "誌面", reading: "しめん", meaning: "page of a magazine" },
        { word: "地誌", reading: "ちし", meaning: "topography, geographical description" }
    ],
    },
    "雌": {
        onyomi: ["シ"],
        kunyomi: ["め-", "めす", "めん"],
        examples: [
        { word: "雌花", reading: "めばな", meaning: "female flower, pistillate flower" },
        { word: "雌雄", reading: "しゆう", meaning: "male and female (animals), the two sexes" },
        { word: "雌", reading: "めす", meaning: "female (animal, plant)" }
    ],
    },
    "摯": {
        onyomi: ["シ"],
        kunyomi: ["いた.る", "つか.む", "にえ"],
        examples: [
        { word: "真摯", reading: "しんし", meaning: "sincere, earnest, serious" }
    ],
    },
    "賜": {
        onyomi: ["シ"],
        kunyomi: ["たまわ.る", "たま.う", "たも.う"],
        examples: [
        { word: "恩賜", reading: "おんし", meaning: "Imperial gift" },
        { word: "賜杯", reading: "しはい", meaning: "Emperor's cup, trophy given by the Emperor" }
    ],
    },
    "諮": {
        onyomi: ["シ"],
        kunyomi: ["はか.る"],
        examples: [
        { word: "諮る", reading: "はかる", meaning: "to consult with, to discuss, to confer" },
        { word: "諮問", reading: "しもん", meaning: "consultation, question, enquiry" }
    ],
    },
    "示": {
        onyomi: ["ジ", "シ"],
        kunyomi: ["しめ.す"],
        examples: [
        { word: "暗示", reading: "あんじ", meaning: "hint, suggestion, clue" },
        { word: "開示", reading: "かいじ", meaning: "release (of information, documents, etc.), disclosure, display" },
        { word: "教示", reading: "きょうじ", meaning: "instruction, teaching, guidance" },
        { word: "訓示", reading: "くんじ", meaning: "instruction, direction, briefing" }
    ],
    },
    "字": {
        onyomi: ["ジ"],
        kunyomi: ["あざ", "あざな", "-な"],
        examples: [
        { word: "一字", reading: "いちじ", meaning: "(one) letter, (one) character" },
        { word: "英字", reading: "えいじ", meaning: "English letter, alphabetic character" },
        { word: "活字", reading: "かつじ", meaning: "(piece of) type, movable type, moveable type" },
        { word: "漢字", reading: "かんじ", meaning: "kanji, Chinese character" }
    ],
    },
    "寺": {
        onyomi: ["ジ"],
        kunyomi: ["てら"],
        examples: [
        { word: "山寺", reading: "やまでら", meaning: "mountain temple" },
        { word: "寺院", reading: "じいん", meaning: "Buddhist temple" },
        { word: "禅寺", reading: "ぜんでら", meaning: "Zen temple" },
        { word: "国分寺", reading: "こくぶんじ", meaning: "state-supported provincial temple (Nara period)" }
    ],
    },
    "次": {
        onyomi: ["ジ", "シ"],
        kunyomi: ["つ.ぐ", "つぎ"],
        examples: [
        { word: "次ぐ", reading: "つぐ", meaning: "to follow, to come after, to come next (to)" },
        { word: "次回", reading: "じかい", meaning: "next time (occasion)" },
        { word: "次官", reading: "じかん", meaning: "vice-minister, undersecretary" },
        { word: "次期", reading: "じき", meaning: "next term, next period" }
    ],
    },
    "耳": {
        onyomi: ["ジ"],
        kunyomi: ["みみ"],
        examples: [
        { word: "耳目", reading: "じもく", meaning: "eyes and ears, seeing and hearing" },
        { word: "中耳", reading: "ちゅうじ", meaning: "middle ear, tympanum" },
        { word: "耳元", reading: "みみもと", meaning: "close to the ear" },
        { word: "耳障り", reading: "みみざわり", meaning: "hard (on the ears), offensive (to the ear), rasping" }
    ],
    },
    "自": {
        onyomi: ["ジ", "シ"],
        kunyomi: ["みずか.ら", "おの.ずから", "おの.ずと"],
        examples: [
        { word: "各自", reading: "かくじ", meaning: "each (person), everyone, individual" },
        { word: "自ら", reading: "みずから", meaning: "oneself" },
        { word: "自営", reading: "じえい", meaning: "running one's own business, doing business on one's own, self-employment" },
        { word: "自衛", reading: "じえい", meaning: "self-defense, self-defence" }
    ],
    },
    "似": {
        onyomi: ["ジ"],
        kunyomi: ["に.る", "ひ.る"],
        examples: [
        { word: "酷似", reading: "こくじ", meaning: "resembling closely, being strikingly similar, bearing a strong likeness" },
        { word: "似る", reading: "にる", meaning: "to resemble, to look like, to be like" },
        { word: "似顔", reading: "にがお", meaning: "portrait, likeness" },
        { word: "真似", reading: "まね", meaning: "imitating, copying, mimicry" }
    ],
    },
    "児": {
        onyomi: ["ジ", "ニ", "ゲイ"],
        kunyomi: ["こ", "-こ", "-っこ"],
        examples: [
        { word: "遺児", reading: "いじ", meaning: "orphan, child left by the deceased" },
        { word: "育児", reading: "いくじ", meaning: "childcare, child-rearing, nursing" },
        { word: "園児", reading: "えんじ", meaning: "kindergarten pupil, kindergartener, preschooler" },
        { word: "孤児", reading: "こじ", meaning: "orphan" }
    ],
    },
    "事": {
        onyomi: ["ジ", "ズ"],
        kunyomi: ["こと", "つか.う", "つか.える"],
        examples: [
        { word: "悪事", reading: "あくじ", meaning: "evil deed, wrongdoing, crime" },
        { word: "何事", reading: "なにごと", meaning: "what, what sort of thing" },
        { word: "家事", reading: "かじ", meaning: "housework, domestic chores" },
        { word: "火事", reading: "かじ", meaning: "fire, conflagration" }
    ],
    },
    "侍": {
        onyomi: ["ジ", "シ"],
        kunyomi: ["さむらい", "はべ.る"],
        examples: [
        { word: "侍医", reading: "じい", meaning: "court physician" },
        { word: "侍従", reading: "じじゅう", meaning: "chamberlain" },
        { word: "侍女", reading: "じじょ", meaning: "lady attendant, female servant, lady's maid" },
        { word: "侍", reading: "さむらい", meaning: "warrior (esp. of military retainers of daimyos in the Edo period), samurai" }
    ],
    },
    "治": {
        onyomi: ["ジ", "チ"],
        kunyomi: ["おさ.める", "おさ.まる", "なお.る", "なお.す"],
        examples: [
        { word: "治安", reading: "ちあん", meaning: "public order, public peace, public security" },
        { word: "治水", reading: "ちすい", meaning: "river management, river improvement, flood control" },
        { word: "治癒", reading: "ちゆ", meaning: "healing, cure, recovery" },
        { word: "治療", reading: "ちりょう", meaning: "(medical) treatment, care, therapy" }
    ],
    },
    "持": {
        onyomi: ["ジ"],
        kunyomi: ["も.つ", "-も.ち", "も.てる"],
        examples: [
        { word: "維持", reading: "いじ", meaning: "maintenance, preservation, improvement" },
        { word: "堅持", reading: "けんじ", meaning: "adhering to (a view, policy, etc.), sticking to, holding fast to" },
        { word: "支持", reading: "しじ", meaning: "support, backing, endorsement" },
        { word: "持つ", reading: "もつ", meaning: "to hold (in one's hand), to take, to carry" }
    ],
    },
    "時": {
        onyomi: ["ジ"],
        kunyomi: ["とき", "-どき"],
        examples: [
        { word: "一時", reading: "ひととき", meaning: "a (short) time, a while, moment" },
        { word: "何時", reading: "なんじ", meaning: "what time, which hour" },
        { word: "今時", reading: "いまどき", meaning: "these days, nowadays, today" },
        { word: "三時", reading: "さんじ", meaning: "3 o'clock" }
    ],
    },
    "滋": {
        onyomi: ["ジ", "シ"],
        kunyomi: [],
        examples: [
        { word: "滋養", reading: "じよう", meaning: "nourishment, nutrition" }
    ],
    },
    "慈": {
        onyomi: ["ジ"],
        kunyomi: ["いつく.しむ"],
        examples: [
        { word: "慈愛", reading: "じあい", meaning: "affection (esp. parental), love, fondness" },
        { word: "慈善", reading: "じぜん", meaning: "charity, benevolence, philanthropy" },
        { word: "慈悲", reading: "じひ", meaning: "mercy, compassion, clemency" }
    ],
    },
    "辞": {
        onyomi: ["ジ"],
        kunyomi: ["や.める", "いな.む"],
        examples: [
        { word: "賛辞", reading: "さんじ", meaning: "eulogy, compliment" },
        { word: "辞意", reading: "じい", meaning: "intention to resign" },
        { word: "辞書", reading: "じしょ", meaning: "dictionary, lexicon" },
        { word: "辞職", reading: "じしょく", meaning: "resignation" }
    ],
    },
    "磁": {
        onyomi: ["ジ"],
        kunyomi: [],
        examples: [
        { word: "磁器", reading: "じき", meaning: "porcelain, china, chinaware" },
        { word: "磁気", reading: "じき", meaning: "magnetism" },
        { word: "磁石", reading: "じしゃく", meaning: "magnet" },
        { word: "磁場", reading: "じば", meaning: "magnetic field" }
    ],
    },
    "餌": {
        onyomi: ["ジ", "ニ"],
        kunyomi: ["え", "えば", "えさ", "もち"],
        examples: [
        { word: "餌", reading: "えさ", meaning: "(animal) feed, fodder, pet food" }
    ],
    },
    "璽": {
        onyomi: ["ジ"],
        kunyomi: [],
        examples: [
        { word: "印璽", reading: "いんじ", meaning: "imperial seal" },
        { word: "玉璽", reading: "ぎょくじ", meaning: "sovereign's seal" },
        { word: "剣璽", reading: "けんじ", meaning: "sacred sword and jewels (imperial regalia)" },
        { word: "御璽", reading: "ぎょじ", meaning: "imperial seal, privy seal" }
    ],
    },
    "鹿": {
        onyomi: ["ロク"],
        kunyomi: ["しか", "か"],
        examples: [
        { word: "馬鹿", reading: "ばか", meaning: "idiot, moron, fool" },
        { word: "鹿", reading: "しか", meaning: "deer (esp. the sika deer, Cervus nippon), cervid" },
        { word: "馬鹿らしい", reading: "ばからしい", meaning: "absurd, foolish, stupid" }
    ],
    },
    "式": {
        onyomi: ["シキ"],
        kunyomi: [],
        examples: [
        { word: "一式", reading: "いっしき", meaning: "(complete) set, outfit, kit" },
        { word: "株式", reading: "かぶしき", meaning: "share (in a company), stock" },
        { word: "儀式", reading: "ぎしき", meaning: "ceremony, rite, ritual" },
        { word: "旧式", reading: "きゅうしき", meaning: "old type, old style" }
    ],
    },
    "識": {
        onyomi: ["シキ"],
        kunyomi: ["し.る", "しる.す"],
        examples: [
        { word: "意識", reading: "いしき", meaning: "consciousness" },
        { word: "学識", reading: "がくしき", meaning: "scholarship, scientific attainments" },
        { word: "見識", reading: "けんしき", meaning: "views, opinion, discernment" },
        { word: "識者", reading: "しきしゃ", meaning: "well-informed person, thinking person, intelligent person" }
    ],
    },
    "軸": {
        onyomi: ["ジク"],
        kunyomi: [],
        examples: [
        { word: "車軸", reading: "しゃじく", meaning: "axle" },
        { word: "主軸", reading: "しゅじく", meaning: "main spindle, main shaft" },
        { word: "枢軸", reading: "すうじく", meaning: "axle, pivot" },
        { word: "中軸", reading: "ちゅうじく", meaning: "axis, pivot, central figure" }
    ],
    },
    "七": {
        onyomi: ["シチ"],
        kunyomi: ["なな", "なな.つ", "なの"],
        examples: [
        { word: "七つ", reading: "ななつ", meaning: "seven" },
        { word: "七月", reading: "しちがつ", meaning: "July" },
        { word: "七十", reading: "ななじゅう", meaning: "seventy, 70" },
        { word: "七日", reading: "なのか", meaning: "7th day of the month" }
    ],
    },
    "𠮟": {
        onyomi: ["シツ", "シチ", "カ"],
        kunyomi: ["しか.る"],
        examples: [
        { word: "𠮟", reading: "しっ", meaning: "shh!, sh!, shush!" },
        { word: "𠮟る", reading: "しかる", meaning: "to scold, to chide, to rebuke" },
        { word: "𠮟責", reading: "しっせき", meaning: "reprimand, rebuke, reproach" },
        { word: "𠮟咤", reading: "しった", meaning: "scolding, rebuke, reprimand" }
    ],
    },
    "失": {
        onyomi: ["シツ"],
        kunyomi: ["うしな.う", "う.せる"],
        examples: [
        { word: "過失", reading: "かしつ", meaning: "accident (caused by negligence), error, blunder" },
        { word: "失う", reading: "うしなう", meaning: "to lose" },
        { word: "失意", reading: "しつい", meaning: "disappointment, despair, despondency" },
        { word: "失格", reading: "しっかく", meaning: "disqualification, elimination, incapacity" }
    ],
    },
    "室": {
        onyomi: ["シツ"],
        kunyomi: ["むろ"],
        examples: [
        { word: "一室", reading: "いっしつ", meaning: "one room" },
        { word: "王室", reading: "おうしつ", meaning: "royal family" },
        { word: "温室", reading: "おんしつ", meaning: "greenhouse, hothouse, conservatory" },
        { word: "客室", reading: "きゃくしつ", meaning: "guest room (at a hotel), guest cabin (on a boat), passenger cabin (on a plane)" }
    ],
    },
    "疾": {
        onyomi: ["シツ"],
        kunyomi: ["はや.い"],
        examples: [
        { word: "疾患", reading: "しっかん", meaning: "disease, illness, disorder" },
        { word: "疾走", reading: "しっそう", meaning: "sprint, dash, scampering" },
        { word: "疾病", reading: "しっぺい", meaning: "illness, disease" },
        { word: "疾風", reading: "しっぷう", meaning: "gale, strong wind, swift wind" }
    ],
    },
    "執": {
        onyomi: ["シツ", "シュウ"],
        kunyomi: ["と.る"],
        examples: [
        { word: "確執", reading: "かくしつ", meaning: "discord, antagonism" },
        { word: "執行", reading: "しっこう", meaning: "execution, carrying out, performance" },
        { word: "執念", reading: "しゅうねん", meaning: "tenacity, persistence, obsession" },
        { word: "執筆", reading: "しっぴつ", meaning: "writing, authoring" }
    ],
    },
    "湿": {
        onyomi: ["シツ", "シュウ"],
        kunyomi: ["しめ.る", "しめ.す", "うるお.う", "うるお.す"],
        examples: [
        { word: "湿る", reading: "しめる", meaning: "to become damp, to become moist, to become wet" },
        { word: "湿気", reading: "しっけ", meaning: "moisture, humidity, dampness" },
        { word: "湿原", reading: "しつげん", meaning: "marshy grassland, wetlands" },
        { word: "湿疹", reading: "しっしん", meaning: "eczema, rash" }
    ],
    },
    "嫉": {
        onyomi: ["シツ"],
        kunyomi: ["そね.む", "ねた.む", "にく.む"],
        examples: [
        { word: "嫉妬", reading: "しっと", meaning: "jealousy, envy" }
    ],
    },
    "漆": {
        onyomi: ["シツ"],
        kunyomi: ["うるし"],
        examples: [
        { word: "漆器", reading: "しっき", meaning: "lacquer ware, lacquerware, lacquer work" },
        { word: "漆黒", reading: "しっこく", meaning: "pitch-black, jet-black" },
        { word: "漆塗り", reading: "うるしぬり", meaning: "lacquering, lacquer ware" },
        { word: "漆", reading: "うるし", meaning: "East Asian lacquer, japan" }
    ],
    },
    "質": {
        onyomi: ["シツ", "シチ", "チ"],
        kunyomi: ["たち", "ただ.す", "もと", "わりふ"],
        examples: [
        { word: "悪質", reading: "あくしつ", meaning: "malicious, vicious, malignant" },
        { word: "異質", reading: "いしつ", meaning: "different (quality, nature), heterogeneous" },
        { word: "音質", reading: "おんしつ", meaning: "tone quality, sound quality" },
        { word: "気質", reading: "きしつ", meaning: "disposition, temperament, nature" }
    ],
    },
    "実": {
        onyomi: ["ジツ", "シツ"],
        kunyomi: ["み", "みの.る", "まこと", "みの", "みち.る"],
        examples: [
        { word: "忠実", reading: "ちゅうじつ", meaning: "faithful, devoted, loyal" },
        { word: "果実", reading: "かじつ", meaning: "fruit, nut, berry" },
        { word: "確実", reading: "かくじつ", meaning: "certain, sure, definite" },
        { word: "現実", reading: "げんじつ", meaning: "reality, actuality, hard fact" }
    ],
    },
    "芝": {
        onyomi: ["シ"],
        kunyomi: ["しば"],
        examples: [
        { word: "芝居", reading: "しばい", meaning: "play, drama" },
        { word: "芝生", reading: "しばふ", meaning: "lawn, grass, turf" },
        { word: "芝草", reading: "しばくさ", meaning: "lawn, sod, turf" },
        { word: "紙芝居", reading: "かみしばい", meaning: "kamishibai, storytelling with pictures, form of Japanese street theater and storytelling (popular from the 1930s to the 1950s)" }
    ],
    },
    "写": {
        onyomi: ["シャ", "ジャ"],
        kunyomi: ["うつ.す", "うつ.る", "うつ-", "うつ.し"],
        examples: [
        { word: "試写", reading: "ししゃ", meaning: "preview, private showing" },
        { word: "写し", reading: "うつし", meaning: "copy, duplicate, facsimile" },
        { word: "写る", reading: "うつる", meaning: "to be photographed, to be projected" },
        { word: "写真", reading: "しゃしん", meaning: "photograph, photo, picture" }
    ],
    },
    "社": {
        onyomi: ["シャ"],
        kunyomi: ["やしろ"],
        examples: [
        { word: "会社", reading: "かいしゃ", meaning: "company, corporation, firm" },
        { word: "貴社", reading: "きしゃ", meaning: "your company" },
        { word: "結社", reading: "けっしゃ", meaning: "association, society" },
        { word: "御社", reading: "おんしゃ", meaning: "your company" }
    ],
    },
    "車": {
        onyomi: ["シャ"],
        kunyomi: ["くるま"],
        examples: [
        { word: "下車", reading: "げしゃ", meaning: "alighting (from a train, bus, etc.), getting off, getting out (of a car)" },
        { word: "貨車", reading: "かしゃ", meaning: "freight car, van" },
        { word: "外車", reading: "がいしゃ", meaning: "foreign car, imported car" },
        { word: "汽車", reading: "きしゃ", meaning: "steam locomotive, steam train" }
    ],
    },
    "舎": {
        onyomi: ["シャ", "セキ"],
        kunyomi: ["やど.る"],
        examples: [
        { word: "牛舎", reading: "ぎゅうしゃ", meaning: "cow shed, cattle barn" },
        { word: "校舎", reading: "こうしゃ", meaning: "school building, schoolhouse" },
        { word: "宿舎", reading: "しゅくしゃ", meaning: "lodging (house), accommodation, hotel" },
        { word: "庁舎", reading: "ちょうしゃ", meaning: "government office building" }
    ],
    },
    "者": {
        onyomi: ["シャ"],
        kunyomi: ["もの"],
        examples: [
        { word: "悪者", reading: "わるもの", meaning: "bad guy, villain, evildoer" },
        { word: "医者", reading: "いしゃ", meaning: "doctor, physician" },
        { word: "王者", reading: "おうじゃ", meaning: "king, monarch, ruler" },
        { word: "何者", reading: "なにもの", meaning: "who, what kind of person" }
    ],
    },
    "射": {
        onyomi: ["シャ"],
        kunyomi: ["い.る", "さ.す", "う.つ"],
        examples: [
        { word: "射す", reading: "さす", meaning: "to shine" },
        { word: "射る", reading: "いる", meaning: "to shoot (arrow, bolt, dart)" },
        { word: "射撃", reading: "しゃげき", meaning: "firing, shooting, fire" },
        { word: "射殺", reading: "しゃさつ", meaning: "shooting to death" }
    ],
    },
    "捨": {
        onyomi: ["シャ"],
        kunyomi: ["す.てる"],
        examples: [
        { word: "取捨", reading: "しゅしゃ", meaning: "adoption or rejection, selection, choice" },
        { word: "捨てる", reading: "すてる", meaning: "to throw away, to cast away, to dump" },
        { word: "捨て子", reading: "すてご", meaning: "abandoned child, foundling" },
        { word: "見捨てる", reading: "みすてる", meaning: "to abandon, to fail, to desert" }
    ],
    },
    "赦": {
        onyomi: ["シャ"],
        kunyomi: ["ゆる.す"],
        examples: [
        { word: "恩赦", reading: "おんしゃ", meaning: "amnesty, pardon" },
        { word: "赦免", reading: "しゃめん", meaning: "pardon, remission, amnesty" },
        { word: "特赦", reading: "とくしゃ", meaning: "special pardon, (general) amnesty" },
        { word: "容赦", reading: "ようしゃ", meaning: "pardon, forgiveness, tolerance" }
    ],
    },
    "斜": {
        onyomi: ["シャ"],
        kunyomi: ["なな.め", "はす"],
        examples: [
        { word: "傾斜", reading: "けいしゃ", meaning: "inclination, slant, slope" },
        { word: "斜め", reading: "ななめ", meaning: "slanting, tilted, sloping" },
        { word: "斜面", reading: "しゃめん", meaning: "slope, slanting surface, bevel" },
        { word: "斜陽", reading: "しゃよう", meaning: "setting sun" }
    ],
    },
    "煮": {
        onyomi: ["シャ"],
        kunyomi: ["に.る", "-に", "に.える", "に.やす"],
        examples: [
        { word: "雑煮", reading: "ぞうに", meaning: "soup containing rice cakes and vegetables (New Year's dish)" },
        { word: "煮る", reading: "にる", meaning: "to boil, to simmer, to stew" },
        { word: "煮物", reading: "にもの", meaning: "nimono, food cooked by boiling or stewing" },
        { word: "煮える", reading: "にえる", meaning: "to be boiled, to be cooked" }
    ],
    },
    "遮": {
        onyomi: ["シャ"],
        kunyomi: ["さえぎ.る"],
        examples: [
        { word: "遮る", reading: "さえぎる", meaning: "to interrupt, to obstruct (a view, someone's way, etc.), to block (light, wind, etc.)" },
        { word: "遮断", reading: "しゃだん", meaning: "isolation, cut off, blockade" },
        { word: "遮断機", reading: "しゃだんき", meaning: "(railway) crossing gate, barrier (at a toll booth, parking lot, etc.)" },
        { word: "遮断器", reading: "しゃだんき", meaning: "circuit breaker" }
    ],
    },
    "謝": {
        onyomi: ["シャ"],
        kunyomi: ["あやま.る"],
        examples: [
        { word: "感謝", reading: "かんしゃ", meaning: "thanks, gratitude, appreciation" },
        { word: "月謝", reading: "げっしゃ", meaning: "monthly tuition fee" },
        { word: "謝る", reading: "あやまる", meaning: "to apologize (apologise)" },
        { word: "謝意", reading: "しゃい", meaning: "gratitude, thanks" }
    ],
    },
    "邪": {
        onyomi: ["ジャ"],
        kunyomi: ["よこし.ま"],
        examples: [
        { word: "邪道", reading: "じゃどう", meaning: "improper way (of doing), wrong way, unorthodox method" },
        { word: "邪魔", reading: "じゃま", meaning: "hindrance, obstacle, nuisance" },
        { word: "風邪", reading: "かぜ", meaning: "(common) cold, influenza, flu" },
        { word: "無邪気", reading: "むじゃき", meaning: "innocent, childlike, sweet and innocent" }
    ],
    },
    "蛇": {
        onyomi: ["ジャ", "ダ", "イ", "ヤ"],
        kunyomi: ["へび"],
        examples: [
        { word: "蛇口", reading: "じゃぐち", meaning: "faucet, tap" },
        { word: "蛇行", reading: "だこう", meaning: "meandering, snaking, zigzagging" },
        { word: "蛇の目", reading: "じゃのめ", meaning: "bull's-eye (pattern), double ring (pattern)" },
        { word: "長蛇の列", reading: "ちょうだのれつ", meaning: "long line, long queue" }
    ],
    },
    "尺": {
        onyomi: ["シャク", "セキ"],
        kunyomi: ["さし"],
        examples: [
        { word: "尺度", reading: "しゃくど", meaning: "gauge, standard, measure" },
        { word: "尺八", reading: "しゃくはち", meaning: "shakuhachi, end-blown fippleless bamboo flute" },
        { word: "縮尺", reading: "しゅくしゃく", meaning: "reduced scale, scaling down" },
        { word: "巻尺", reading: "まきじゃく", meaning: "tape measure" }
    ],
    },
    "借": {
        onyomi: ["シャク"],
        kunyomi: ["か.りる"],
        examples: [
        { word: "借り", reading: "かり", meaning: "borrowing, debt, loan" },
        { word: "借款", reading: "しゃっかん", meaning: "loan (esp. between governments)" },
        { word: "借金", reading: "しゃっきん", meaning: "debt, loan, liabilities" },
        { word: "借地", reading: "しゃくち", meaning: "leased land" }
    ],
    },
    "酌": {
        onyomi: ["シャク"],
        kunyomi: ["く.む"],
        examples: [
        { word: "媒酌", reading: "ばいしゃく", meaning: "matchmaking, acting as a go-between" },
        { word: "晩酌", reading: "ばんしゃく", meaning: "drink at home with one's evening meal, dinner-time drink" }
    ],
    },
    "釈": {
        onyomi: ["シャク", "セキ"],
        kunyomi: ["とく", "す.てる", "ゆる.す"],
        examples: [
        { word: "会釈", reading: "えしゃく", meaning: "slight bow (as a greeting or sign of gratitude), nod, salutation" },
        { word: "解釈", reading: "かいしゃく", meaning: "interpretation, explanation, reading" },
        { word: "釈迦", reading: "しゃか", meaning: "Gautama Buddha, Shakyamuni, the historical Buddha" },
        { word: "釈放", reading: "しゃくほう", meaning: "release, liberation, acquittal" }
    ],
    },
    "爵": {
        onyomi: ["シャク"],
        kunyomi: [],
        examples: [
        { word: "侯爵", reading: "こうしゃく", meaning: "marquis, marquess" },
        { word: "公爵", reading: "こうしゃく", meaning: "prince, duke" },
        { word: "男爵", reading: "だんしゃく", meaning: "baron" },
        { word: "伯爵", reading: "はくしゃく", meaning: "count, earl" }
    ],
    },
    "若": {
        onyomi: ["ジャク", "ニャク", "ニャ"],
        kunyomi: ["わか.い", "わか-", "も.しくわ", "も.し", "も.しくは", "ごと.し"],
        examples: [
        { word: "若い", reading: "わかい", meaning: "young, youthful" },
        { word: "若さ", reading: "わかさ", meaning: "youth, youthfulness" },
        { word: "若干", reading: "じゃっかん", meaning: "some, few, a number of" },
        { word: "若者", reading: "わかもの", meaning: "young person, youngster, young people" }
    ],
    },
    "弱": {
        onyomi: ["ジャク"],
        kunyomi: ["よわ.い", "よわ.る", "よわ.まる", "よわ.める"],
        examples: [
        { word: "虚弱", reading: "きょじゃく", meaning: "feebleness, weakness, imbecility" },
        { word: "強弱", reading: "きょうじゃく", meaning: "strength and weakness, (degree of) strength" },
        { word: "弱い", reading: "よわい", meaning: "weak, frail, delicate" },
        { word: "弱る", reading: "よわる", meaning: "to weaken, to grow weak, to wane" }
    ],
    },
    "寂": {
        onyomi: ["ジャク", "セキ"],
        kunyomi: ["さび", "さび.しい", "さび.れる", "さみ.しい"],
        examples: [
        { word: "静寂", reading: "せいじゃく", meaning: "silence, stillness, quietness" },
        { word: "寂然", reading: "せきぜん", meaning: "lonely, desolate" },
        { word: "寂しい", reading: "さびしい", meaning: "lonely, lonesome, solitary" },
        { word: "寂", reading: "さび", meaning: "patina, antique look" }
    ],
    },
    "手": {
        onyomi: ["シュ", "ズ"],
        kunyomi: ["て", "て-", "-て", "た-"],
        examples: [
        { word: "握手", reading: "あくしゅ", meaning: "handshake" },
        { word: "一手", reading: "いって", meaning: "one move (in go, shogi, etc.)" },
        { word: "右手", reading: "みぎて", meaning: "right hand" },
        { word: "王手", reading: "おうて", meaning: "check" }
    ],
    },
    "主": {
        onyomi: ["シュ", "ス", "シュウ"],
        kunyomi: ["ぬし", "おも", "あるじ"],
        examples: [
        { word: "家主", reading: "やぬし", meaning: "landlord, landlady" },
        { word: "株主", reading: "かぶぬし", meaning: "shareholder, stockholder" },
        { word: "君主", reading: "くんしゅ", meaning: "monarch, sovereign, ruler" },
        { word: "自主", reading: "じしゅ", meaning: "independence, autonomy, self-reliance" }
    ],
    },
    "守": {
        onyomi: ["シュ", "ス"],
        kunyomi: ["まも.る", "まも.り", "もり", "-もり", "かみ"],
        examples: [
        { word: "看守", reading: "かんしゅ", meaning: "prison guard, warder, jailer" },
        { word: "厳守", reading: "げんしゅ", meaning: "strict observance, rigid adherence, scrupulous compliance" },
        { word: "攻守", reading: "こうしゅ", meaning: "offense and defense, offence and defence, batting and fielding" },
        { word: "子守", reading: "こもり", meaning: "looking after a baby, taking care of a baby, babysitting" }
    ],
    },
    "朱": {
        onyomi: ["シュ"],
        kunyomi: ["あけ"],
        examples: [
        { word: "朱印", reading: "しゅいん", meaning: "red seal" },
        { word: "朱", reading: "あけ", meaning: "red, vermilion, cinnabar" }
    ],
    },
    "取": {
        onyomi: ["シュ"],
        kunyomi: ["と.る", "と.り", "と.り-", "とり", "-ど.り"],
        examples: [
        { word: "詐取", reading: "さしゅ", meaning: "defrauding, swindle" },
        { word: "採取", reading: "さいしゅ", meaning: "picking, collecting, harvesting" },
        { word: "搾取", reading: "さくしゅ", meaning: "exploitation, bleeding dry, squeezing dry" },
        { word: "取る", reading: "とる", meaning: "to take, to pick up, to grab" }
    ],
    },
    "狩": {
        onyomi: ["シュ"],
        kunyomi: ["か.る", "か.り", "-が.り"],
        examples: [
        { word: "狩り", reading: "かり", meaning: "hunting, hunt, shooting" },
        { word: "狩人", reading: "かりゅうど", meaning: "hunter" },
        { word: "狩猟", reading: "しゅりょう", meaning: "hunting" },
        { word: "狩場", reading: "かりば", meaning: "hunting ground, hunting preserve" }
    ],
    },
    "首": {
        onyomi: ["シュ"],
        kunyomi: ["くび"],
        examples: [
        { word: "一首", reading: "いっしゅ", meaning: "one tanka, one poem" },
        { word: "機首", reading: "きしゅ", meaning: "nose (of plane)" },
        { word: "元首", reading: "げんしゅ", meaning: "sovereign, ruler, head of state" },
        { word: "自首", reading: "じしゅ", meaning: "surrender (to the authorities), giving oneself up, turning oneself in" }
    ],
    },
    "殊": {
        onyomi: ["シュ"],
        kunyomi: ["こと"],
        examples: [
        { word: "殊に", reading: "ことに", meaning: "especially, particularly, unusually" },
        { word: "殊勲", reading: "しゅくん", meaning: "distinguished services, meritorious deeds" },
        { word: "殊勝", reading: "しゅしょう", meaning: "admirable, laudable" },
        { word: "特殊", reading: "とくしゅ", meaning: "special, particular, peculiar" }
    ],
    },
    "珠": {
        onyomi: ["シュ"],
        kunyomi: ["たま"],
        examples: [
        { word: "珠玉", reading: "しゅぎょく", meaning: "jewel, gem" },
        { word: "珠算", reading: "しゅざん", meaning: "calculation on an abacus" },
        { word: "真珠", reading: "しんじゅ", meaning: "pearl" },
        { word: "数珠", reading: "じゅず", meaning: "rosary, string of prayer beads" }
    ],
    },
    "酒": {
        onyomi: ["シュ"],
        kunyomi: ["さけ", "さか-"],
        examples: [
        { word: "飲酒", reading: "いんしゅ", meaning: "drinking alcohol" },
        { word: "禁酒", reading: "きんしゅ", meaning: "abstinence from alcohol, temperance" },
        { word: "酒屋", reading: "さかや", meaning: "liquor store, wine shop, bottle shop" },
        { word: "酒場", reading: "さかば", meaning: "bar, pub, tavern" }
    ],
    },
    "腫": {
        onyomi: ["シュ", "ショウ"],
        kunyomi: ["は.れる", "は.れ", "は.らす", "はれもの"],
        examples: [
        { word: "腫瘍", reading: "しゅよう", meaning: "tumor, tumour, neoplasm" },
        { word: "腫れる", reading: "はれる", meaning: "to swell (from inflammation), to become swollen" }
    ],
    },
    "種": {
        onyomi: ["シュ"],
        kunyomi: ["たね", "-ぐさ"],
        examples: [
        { word: "一種", reading: "いっしゅ", meaning: "a kind, a sort, a variety" },
        { word: "火種", reading: "ひだね", meaning: "live coals (for firelighting)" },
        { word: "各種", reading: "かくしゅ", meaning: "every kind, all sorts" },
        { word: "機種", reading: "きしゅ", meaning: "model (of machine, device)" }
    ],
    },
    "趣": {
        onyomi: ["シュ"],
        kunyomi: ["おもむき", "おもむ.く"],
        examples: [
        { word: "趣向", reading: "しゅこう", meaning: "plan, idea, design" },
        { word: "趣旨", reading: "しゅし", meaning: "meaning, point (e.g. of a statement), gist" },
        { word: "趣味", reading: "しゅみ", meaning: "hobby, pastime" },
        { word: "趣", reading: "おもむき", meaning: "meaning, tenor, gist" }
    ],
    },
    "寿": {
        onyomi: ["ジュ", "ス", "シュウ"],
        kunyomi: ["ことぶき", "ことぶ.く", "ことほ.ぐ"],
        examples: [
        { word: "喜寿", reading: "きじゅ", meaning: "77th birthday" },
        { word: "寿命", reading: "じゅみょう", meaning: "lifespan, life, lifetime" },
        { word: "長寿", reading: "ちょうじゅ", meaning: "long life, longevity" },
        { word: "天寿", reading: "てんじゅ", meaning: "natural span of life" }
    ],
    },
    "受": {
        onyomi: ["ジュ"],
        kunyomi: ["う.ける", "-う.け", "う.かる"],
        examples: [
        { word: "享受", reading: "きょうじゅ", meaning: "enjoyment (of freedom, beauty, etc.), reception (of a right, privilege, rank, etc.), having" },
        { word: "受刑", reading: "じゅけい", meaning: "punishment" },
        { word: "受験", reading: "じゅけん", meaning: "taking an examination (esp. for entrance to a school or university)" },
        { word: "受講", reading: "じゅこう", meaning: "taking a lecture, attending a class, taking a course" }
    ],
    },
    "呪": {
        onyomi: ["ジュ", "シュ", "シュウ", "ズ"],
        kunyomi: ["まじな.う", "のろ.い", "まじな.い", "のろ.う"],
        examples: [
        { word: "呪い", reading: "のろい", meaning: "curse, spell, malediction" },
        { word: "呪う", reading: "のろう", meaning: "to curse, to put a curse on, to detest intensely" }
    ],
    },
    "授": {
        onyomi: ["ジュ"],
        kunyomi: ["さず.ける", "さず.かる"],
        examples: [
        { word: "教授", reading: "きょうじゅ", meaning: "professor" },
        { word: "授業", reading: "じゅぎょう", meaning: "lesson, class, teaching" },
        { word: "授受", reading: "じゅじゅ", meaning: "giving and receiving, transferring, transfer" },
        { word: "授賞", reading: "じゅしょう", meaning: "awarding a prize, giving an award" }
    ],
    },
    "需": {
        onyomi: ["ジュ"],
        kunyomi: [],
        examples: [
        { word: "外需", reading: "がいじゅ", meaning: "foreign demand" },
        { word: "軍需", reading: "ぐんじゅ", meaning: "munitions, military stores" },
        { word: "需給", reading: "じゅきゅう", meaning: "supply and demand" },
        { word: "需要", reading: "じゅよう", meaning: "demand, need" }
    ],
    },
    "儒": {
        onyomi: ["ジュ"],
        kunyomi: [],
        examples: [
        { word: "儒学", reading: "じゅがく", meaning: "Confucianism" },
        { word: "儒教", reading: "じゅきょう", meaning: "Confucianism" }
    ],
    },
    "樹": {
        onyomi: ["ジュ"],
        kunyomi: ["き"],
        examples: [
        { word: "果樹", reading: "かじゅ", meaning: "fruit tree" },
        { word: "樹脂", reading: "じゅし", meaning: "resin, rosin" },
        { word: "樹皮", reading: "じゅひ", meaning: "bark (of a tree, etc.)" },
        { word: "樹木", reading: "じゅもく", meaning: "tree, trees and shrubs" }
    ],
    },
    "収": {
        onyomi: ["シュウ"],
        kunyomi: ["おさ.める", "おさ.まる"],
        examples: [
        { word: "押収", reading: "おうしゅう", meaning: "seizure, confiscation" },
        { word: "回収", reading: "かいしゅう", meaning: "collection, recovery, withdrawal" },
        { word: "吸収", reading: "きゅうしゅう", meaning: "absorption, suction, attraction" },
        { word: "月収", reading: "げっしゅう", meaning: "monthly income" }
    ],
    },
    "囚": {
        onyomi: ["シュウ"],
        kunyomi: ["とら.われる"],
        examples: [
        { word: "囚人", reading: "しゅうじん", meaning: "prisoner, convict" },
        { word: "死刑囚", reading: "しけいしゅう", meaning: "criminal condemned to death, convict on death row" }
    ],
    },
    "州": {
        onyomi: ["シュウ", "ス"],
        kunyomi: ["す"],
        examples: [
        { word: "欧州", reading: "おうしゅう", meaning: "Europe" },
        { word: "九州", reading: "きゅうしゅう", meaning: "Kyūshū (southernmost of the four main islands of Japan)" },
        { word: "広州", reading: "こうしゅう", meaning: "Guangzhou (China), Canton" },
        { word: "州都", reading: "しゅうと", meaning: "state capital, provincial capital, county town" }
    ],
    },
    "舟": {
        onyomi: ["シュウ"],
        kunyomi: ["ふね", "ふな-", "-ぶね"],
        examples: [
        { word: "舟艇", reading: "しゅうてい", meaning: "boat, watercraft" },
        { word: "小舟", reading: "こぶね", meaning: "small boat" },
        { word: "呉越同舟", reading: "ごえつどうしゅう", meaning: "bitter enemies in the same boat, rivals finding themselves together by chance, strange bedfellows" }
    ],
    },
    "秀": {
        onyomi: ["シュウ"],
        kunyomi: ["ひい.でる"],
        examples: [
        { word: "秀逸", reading: "しゅういつ", meaning: "excellent, superb, first-rate" },
        { word: "秀才", reading: "しゅうさい", meaning: "bright person, talented student, prodigy" },
        { word: "優秀", reading: "ゆうしゅう", meaning: "superior, excellent, brilliant" },
        { word: "秀作", reading: "しゅうさく", meaning: "excellent (piece of) work" }
    ],
    },
    "周": {
        onyomi: ["シュウ"],
        kunyomi: ["まわ.り"],
        examples: [
        { word: "円周", reading: "えんしゅう", meaning: "circumference" },
        { word: "周囲", reading: "しゅうい", meaning: "surroundings, environs" },
        { word: "周期", reading: "しゅうき", meaning: "cycle, period" },
        { word: "周知", reading: "しゅうち", meaning: "common knowledge, being well-known, making (something) well-known" }
    ],
    },
    "宗": {
        onyomi: ["シュウ", "ソウ"],
        kunyomi: ["むね"],
        examples: [
        { word: "改宗", reading: "かいしゅう", meaning: "religious conversion" },
        { word: "宗家", reading: "そうけ", meaning: "head of family, head house" },
        { word: "宗教", reading: "しゅうきょう", meaning: "religion, religious affiliation, belief" },
        { word: "宗祖", reading: "しゅうそ", meaning: "sect founder" }
    ],
    },
    "拾": {
        onyomi: ["シュウ", "ジュウ"],
        kunyomi: ["ひろ.う"],
        examples: [
        { word: "収拾", reading: "しゅうしゅう", meaning: "control, bringing under control, settling (a matter)" },
        { word: "拾う", reading: "ひろう", meaning: "to pick up, to gather" },
        { word: "拾得", reading: "しゅうとく", meaning: "finding (lost property), picking up" },
        { word: "拾い物", reading: "ひろいもの", meaning: "found article, thing picked up (e.g. in the street)" }
    ],
    },
    "秋": {
        onyomi: ["シュウ"],
        kunyomi: ["あき", "とき"],
        examples: [
        { word: "今秋", reading: "こんしゅう", meaning: "this autumn, this fall, autumn of this year" },
        { word: "秋口", reading: "あきぐち", meaning: "beginning of autumn, beginning of fall" },
        { word: "秋風", reading: "あきかぜ", meaning: "autumn breeze, fall breeze" },
        { word: "秋分", reading: "しゅうぶん", meaning: "autumnal equinox, autumn equinox, fall equinox" }
    ],
    },
    "臭": {
        onyomi: ["シュウ"],
        kunyomi: ["くさ.い", "-くさ.い", "にお.う", "にお.い"],
        examples: [
        { word: "悪臭", reading: "あくしゅう", meaning: "bad smell, foul smell, offensive odor" },
        { word: "臭い", reading: "くさい", meaning: "stinking, smelly" },
        { word: "臭気", reading: "しゅうき", meaning: "bad smell, stink" },
        { word: "臭う", reading: "におう", meaning: "to be fragrant, to smell (good)" }
    ],
    },
    "修": {
        onyomi: ["シュウ", "シュ"],
        kunyomi: ["おさ.める", "おさ.まる"],
        examples: [
        { word: "改修", reading: "かいしゅう", meaning: "repair, improvement" },
        { word: "監修", reading: "かんしゅう", meaning: "(editorial) supervision, general editorship" },
        { word: "研修", reading: "けんしゅう", meaning: "training (esp. in-service), induction course" },
        { word: "修士", reading: "しゅうし", meaning: "master's (degree)" }
    ],
    },
    "袖": {
        onyomi: ["シュウ"],
        kunyomi: ["そで"],
        examples: [
        { word: "長袖", reading: "ながそで", meaning: "long sleeves" },
        { word: "半袖", reading: "はんそで", meaning: "short sleeves" },
        { word: "領袖", reading: "りょうしゅう", meaning: "leader, chief, boss" },
        { word: "袖", reading: "そで", meaning: "sleeve" }
    ],
    },
    "終": {
        onyomi: ["シュウ"],
        kunyomi: ["お.わる", "-お.わる", "おわ.る", "お.える", "つい", "つい.に"],
        examples: [
        { word: "最終", reading: "さいしゅう", meaning: "last, final, closing" },
        { word: "始終", reading: "しじゅう", meaning: "continuously, from beginning to end, from first to last" },
        { word: "終局", reading: "しゅうきょく", meaning: "end, close, conclusion" },
        { word: "終結", reading: "しゅうけつ", meaning: "end, close" }
    ],
    },
    "羞": {
        onyomi: ["シュウ"],
        kunyomi: ["はじ.る", "すすめ.る", "は.ずかしい"],
        examples: [
        { word: "羞む", reading: "はにかむ", meaning: "to be shy, to be bashful, to look shy" },
        { word: "嬌羞", reading: "きょうしゅう", meaning: "charming and coy" },
        { word: "羞恥", reading: "しゅうち", meaning: "shyness, bashfulness, shame" },
        { word: "羞い", reading: "はじらい", meaning: "shyness, bashfulness" }
    ],
    },
    "習": {
        onyomi: ["シュウ", "ジュ"],
        kunyomi: ["なら.う", "なら.い"],
        examples: [
        { word: "演習", reading: "えんしゅう", meaning: "practice, exercise, drill" },
        { word: "学習", reading: "がくしゅう", meaning: "learning, study" },
        { word: "慣習", reading: "かんしゅう", meaning: "custom, convention, common practice" },
        { word: "教習", reading: "きょうしゅう", meaning: "training, instruction" }
    ],
    },
    "週": {
        onyomi: ["シュウ"],
        kunyomi: [],
        examples: [
        { word: "今週", reading: "こんしゅう", meaning: "this week" },
        { word: "週刊", reading: "しゅうかん", meaning: "weekly publication" },
        { word: "週間", reading: "しゅうかん", meaning: "week" },
        { word: "週末", reading: "しゅうまつ", meaning: "weekend" }
    ],
    },
    "就": {
        onyomi: ["シュウ", "ジュ"],
        kunyomi: ["つ.く", "つ.ける"],
        examples: [
        { word: "去就", reading: "きょしゅう", meaning: "leaving or staying" },
        { word: "就く", reading: "つく", meaning: "to take (seat, position, course, office, etc.), to assume, to be hired" },
        { word: "就学", reading: "しゅうがく", meaning: "entering school, school attendance" },
        { word: "就業", reading: "しゅうぎょう", meaning: "starting work (for the day)" }
    ],
    },
    "衆": {
        onyomi: ["シュウ", "シュ"],
        kunyomi: ["おお.い"],
        examples: [
        { word: "観衆", reading: "かんしゅう", meaning: "spectators, onlookers, members of the audience" },
        { word: "公衆", reading: "こうしゅう", meaning: "the public, general public" },
        { word: "衆院", reading: "しゅういん", meaning: "House of Representatives (lower house of the National Diet of Japan)" },
        { word: "大衆", reading: "たいしゅう", meaning: "general public, the masses" }
    ],
    },
    "集": {
        onyomi: ["シュウ"],
        kunyomi: ["あつ.まる", "あつ.める", "つど.う"],
        examples: [
        { word: "歌集", reading: "かしゅう", meaning: "collection of waka poems, anthology" },
        { word: "句集", reading: "くしゅう", meaning: "collection of haiku poems" },
        { word: "結集", reading: "けっしゅう", meaning: "concentration (of efforts, forces, etc.), gathering together, regimentation" },
        { word: "採集", reading: "さいしゅう", meaning: "collecting, gathering" }
    ],
    },
    "愁": {
        onyomi: ["シュウ"],
        kunyomi: ["うれ.える", "うれ.い"],
        examples: [
        { word: "哀愁", reading: "あいしゅう", meaning: "pathos, sorrow, grief" },
        { word: "郷愁", reading: "きょうしゅう", meaning: "nostalgia, homesickness" }
    ],
    },
    "酬": {
        onyomi: ["シュウ", "シュ", "トウ"],
        kunyomi: ["むく.いる"],
        examples: [
        { word: "応酬", reading: "おうしゅう", meaning: "exchange (of words, views, punches, cups, etc.), give-and-take" },
        { word: "報酬", reading: "ほうしゅう", meaning: "remuneration, recompense, reward" },
        { word: "無報酬", reading: "むほうしゅう", meaning: "unpaid, without pay, gratuitous" }
    ],
    },
    "醜": {
        onyomi: ["シュウ"],
        kunyomi: ["みにく.い", "しこ"],
        examples: [
        { word: "醜い", reading: "みにくい", meaning: "ugly, unattractive, bad-looking" },
        { word: "醜悪", reading: "しゅうあく", meaning: "ugly, unsightly, hideous" },
        { word: "醜態", reading: "しゅうたい", meaning: "disgraceful behavior, disgraceful behaviour, shameful conduct" },
        { word: "醜聞", reading: "しゅうぶん", meaning: "scandal" }
    ],
    },
    "蹴": {
        onyomi: ["シュク", "シュウ"],
        kunyomi: ["け.る"],
        examples: [
        { word: "蹴る", reading: "ける", meaning: "to kick" }
    ],
    },
    "襲": {
        onyomi: ["シュウ"],
        kunyomi: ["おそ.う", "かさ.ね"],
        examples: [
        { word: "奇襲", reading: "きしゅう", meaning: "surprise attack" },
        { word: "逆襲", reading: "ぎゃくしゅう", meaning: "counterattack" },
        { word: "空襲", reading: "くうしゅう", meaning: "air-raid" },
        { word: "襲う", reading: "おそう", meaning: "to attack, to assail, to make an assault" }
    ],
    },
    "十": {
        onyomi: ["ジュウ", "ジッ", "ジュッ"],
        kunyomi: ["とお", "と", "そ"],
        examples: [
        { word: "十一", reading: "じゅういち", meaning: "eleven, 11" },
        { word: "十億", reading: "じゅうおく", meaning: "1,000,000,000, billion" },
        { word: "十九", reading: "じゅうきゅう", meaning: "nineteen, 19" },
        { word: "十月", reading: "じゅうがつ", meaning: "October" }
    ],
    },
    "汁": {
        onyomi: ["ジュウ"],
        kunyomi: ["しる", "-しる", "つゆ"],
        examples: [
        { word: "果汁", reading: "かじゅう", meaning: "fruit juice" },
        { word: "味噌汁", reading: "みそしる", meaning: "miso soup" },
        { word: "汁", reading: "しる", meaning: "juice, sap" }
    ],
    },
    "充": {
        onyomi: ["ジュウ"],
        kunyomi: ["あ.てる", "み.たす"],
        examples: [
        { word: "拡充", reading: "かくじゅう", meaning: "expansion" },
        { word: "充実", reading: "じゅうじつ", meaning: "fullness, completeness, perfection" },
        { word: "充足", reading: "じゅうそく", meaning: "sufficiency" },
        { word: "充填", reading: "じゅうてん", meaning: "filling (up), replenishing, filling in (a tooth)" }
    ],
    },
    "住": {
        onyomi: ["ジュウ", "ヂュウ", "チュウ"],
        kunyomi: ["す.む", "す.まう", "-ず.まい"],
        examples: [
        { word: "安住", reading: "あんじゅう", meaning: "living in peace, living a quiet life" },
        { word: "移住", reading: "いじゅう", meaning: "migration, move, emigration" },
        { word: "永住", reading: "えいじゅう", meaning: "permanent residence" },
        { word: "居住", reading: "きょじゅう", meaning: "residence, living (at, in), abode" }
    ],
    },
    "柔": {
        onyomi: ["ジュウ", "ニュウ"],
        kunyomi: ["やわ.らか", "やわ.らかい", "やわ", "やわ.ら"],
        examples: [
        { word: "懐柔", reading: "かいじゅう", meaning: "winning over, placation, gentle persuasion" },
        { word: "柔道", reading: "じゅうどう", meaning: "judo" },
        { word: "柔軟", reading: "じゅうなん", meaning: "flexible, lithe, soft" },
        { word: "柔和", reading: "にゅうわ", meaning: "gentle, mild, meek" }
    ],
    },
    "重": {
        onyomi: ["ジュウ", "チョウ"],
        kunyomi: ["え", "おも.い", "おも.り", "おも.なう", "かさ.ねる", "かさ.なる", "おも"],
        examples: [
        { word: "貴重", reading: "きちょう", meaning: "precious, valuable" },
        { word: "九重", reading: "ここのえ", meaning: "ninefold" },
        { word: "厳重", reading: "げんじゅう", meaning: "strict, severe, stringent" },
        { word: "重い", reading: "おもい", meaning: "heavy, weighty" }
    ],
    },
    "従": {
        onyomi: ["ジュウ", "ショウ", "ジュ"],
        kunyomi: ["したが.う", "したが.える", "より"],
        examples: [
        { word: "侍従", reading: "じじゅう", meaning: "chamberlain" },
        { word: "従う", reading: "したがう", meaning: "to obey (an order, law, etc.), to abide by (a rule, custom, etc.), to follow" },
        { word: "従軍", reading: "じゅうぐん", meaning: "military service, serving in a war, taking part in a campaign" },
        { word: "従事", reading: "じゅうじ", meaning: "engaging in (work), pursuing (e.g. studies), following (a profession)" }
    ],
    },
    "渋": {
        onyomi: ["ジュウ", "シュウ"],
        kunyomi: ["しぶ", "しぶ.い", "しぶ.る"],
        examples: [
        { word: "苦渋", reading: "くじゅう", meaning: "bitterness, distress, pain" },
        { word: "渋い", reading: "しぶい", meaning: "astringent, bitter, puckery" },
        { word: "渋る", reading: "しぶる", meaning: "to be reluctant (to do), to be unwilling (to do), to hesitate (to do)" },
        { word: "渋滞", reading: "じゅうたい", meaning: "(traffic) congestion, traffic jam, gridlock" }
    ],
    },
    "銃": {
        onyomi: ["ジュウ"],
        kunyomi: ["つつ"],
        examples: [
        { word: "拳銃", reading: "けんじゅう", meaning: "pistol, handgun" },
        { word: "銃器", reading: "じゅうき", meaning: "small arms" },
        { word: "銃殺", reading: "じゅうさつ", meaning: "death by shooting" },
        { word: "銃声", reading: "じゅうせい", meaning: "sound of a gunshot, report of a gun" }
    ],
    },
    "獣": {
        onyomi: ["ジュウ"],
        kunyomi: ["けもの", "けだもの"],
        examples: [
        { word: "怪獣", reading: "かいじゅう", meaning: "monster" },
        { word: "獣医", reading: "じゅうい", meaning: "veterinarian, veterinary surgeon, vet" },
        { word: "猛獣", reading: "もうじゅう", meaning: "fierce animal, beast of prey, big game" },
        { word: "野獣", reading: "やじゅう", meaning: "wild beast, wild animal, brute" }
    ],
    },
    "縦": {
        onyomi: ["ジュウ"],
        kunyomi: ["たて"],
        examples: [
        { word: "縦書", reading: "たてがき", meaning: "writing vertically, vertical writing" },
        { word: "縦断", reading: "じゅうだん", meaning: "running through (north-south), cutting across, travelling across" },
        { word: "操縦", reading: "そうじゅう", meaning: "steering, piloting, flying" },
        { word: "縦横", reading: "じゅうおう", meaning: "length and width, length and breadth, lengthwise and crosswise" }
    ],
    },
    "叔": {
        onyomi: ["シュク"],
        kunyomi: [],
        examples: [
        { word: "叔父", reading: "おじ", meaning: "uncle" },
        { word: "叔母", reading: "おば", meaning: "aunt" }
    ],
    },
    "祝": {
        onyomi: ["シュク", "シュウ"],
        kunyomi: ["いわ.う"],
        examples: [
        { word: "慶祝", reading: "けいしゅく", meaning: "congratulation, celebration" },
        { word: "祝い", reading: "いわい", meaning: "congratulation, congratulations, celebration" },
        { word: "祝う", reading: "いわう", meaning: "to celebrate, to congratulate, to observe (a festival)" },
        { word: "祝賀", reading: "しゅくが", meaning: "celebration, congratulations" }
    ],
    },
    "宿": {
        onyomi: ["シュク"],
        kunyomi: ["やど", "やど.る", "やど.す"],
        examples: [
        { word: "下宿", reading: "げしゅく", meaning: "boarding, lodging, board and lodging" },
        { word: "合宿", reading: "がっしゅく", meaning: "lodging together, training camp, boarding house" },
        { word: "宿す", reading: "やどす", meaning: "to house, to contain, to harbour (a feeling)" },
        { word: "宿る", reading: "やどる", meaning: "to dwell (in), to exist (within), to form" }
    ],
    },
    "淑": {
        onyomi: ["シュク"],
        kunyomi: ["しと.やか"],
        examples: [
        { word: "淑女", reading: "しゅくじょ", meaning: "lady" },
        { word: "淑徳", reading: "しゅくとく", meaning: "womanly virtues" },
        { word: "淑やか", reading: "しとやか", meaning: "graceful, ladylike, modest" }
    ],
    },
    "粛": {
        onyomi: ["シュク", "スク"],
        kunyomi: ["つつし.む"],
        examples: [
        { word: "厳粛", reading: "げんしゅく", meaning: "grave, solemn, serious" },
        { word: "自粛", reading: "じしゅく", meaning: "self-restraint, voluntary restraint, self-imposed control" },
        { word: "粛清", reading: "しゅくせい", meaning: "(political) purge" },
        { word: "静粛", reading: "せいしゅく", meaning: "silent" }
    ],
    },
    "縮": {
        onyomi: ["シュク"],
        kunyomi: ["ちぢ.む", "ちぢ.まる", "ちぢ.める", "ちぢ.れる", "ちぢ.らす"],
        examples: [
        { word: "圧縮", reading: "あっしゅく", meaning: "compression" },
        { word: "恐縮", reading: "きょうしゅく", meaning: "feeling (much) obliged, being (very) grateful, being thankful" },
        { word: "凝縮", reading: "ぎょうしゅく", meaning: "condensation (of ideas, emotions, etc.), concentration" },
        { word: "緊縮", reading: "きんしゅく", meaning: "tightening, shrinkage, contraction" }
    ],
    },
    "塾": {
        onyomi: ["ジュク"],
        kunyomi: [],
        examples: [
        { word: "私塾", reading: "しじゅく", meaning: "small private school (esp. for cramming)" },
        { word: "塾生", reading: "じゅくせい", meaning: "cram school student, student of a private-tutoring school" },
        { word: "塾長", reading: "じゅくちょう", meaning: "principal of a private school" },
        { word: "塾", reading: "じゅく", meaning: "cram school, private tutoring school, juku" }
    ],
    },
    "熟": {
        onyomi: ["ジュク"],
        kunyomi: ["う.れる"],
        examples: [
        { word: "円熟", reading: "えんじゅく", meaning: "ripeness, mellowness, maturity" },
        { word: "熟語", reading: "じゅくご", meaning: "kanji compound" },
        { word: "熟睡", reading: "じゅくすい", meaning: "deep sleep, sound sleep, profound sleep" },
        { word: "熟知", reading: "じゅくち", meaning: "being familiar with, having a thorough knowledge of, being well-informed about" }
    ],
    },
    "出": {
        onyomi: ["シュツ", "スイ"],
        kunyomi: ["で.る", "-で", "だ.す", "-だ.す", "い.でる", "い.だす"],
        examples: [
        { word: "演出", reading: "えんしゅつ", meaning: "direction (of a play, film, etc.), production" },
        { word: "家出", reading: "いえで", meaning: "running away from home, elopement" },
        { word: "外出", reading: "がいしゅつ", meaning: "going out, outing, leaving (one's home, office, etc.)" },
        { word: "救出", reading: "きゅうしゅつ", meaning: "rescue, extricate, reclaim" }
    ],
    },
    "述": {
        onyomi: ["ジュツ"],
        kunyomi: ["の.べる"],
        examples: [
        { word: "記述", reading: "きじゅつ", meaning: "description, account" },
        { word: "供述", reading: "きょうじゅつ", meaning: "affidavit, deposition, testimony" },
        { word: "口述", reading: "こうじゅつ", meaning: "dictation, verbal statement" },
        { word: "述懐", reading: "じゅっかい", meaning: "speaking about (one's thoughts, memories, etc.), relating (one's feelings, reminiscences, etc.), recollection" }
    ],
    },
    "術": {
        onyomi: ["ジュツ"],
        kunyomi: ["すべ"],
        examples: [
        { word: "学術", reading: "がくじゅつ", meaning: "science, learning, scholarship" },
        { word: "奇術", reading: "きじゅつ", meaning: "magic, conjuring, sleight of hand" },
        { word: "技術", reading: "ぎじゅつ", meaning: "technology, engineering" },
        { word: "芸術", reading: "げいじゅつ", meaning: "art, the arts" }
    ],
    },
    "俊": {
        onyomi: ["シュン"],
        kunyomi: [],
        examples: [
        { word: "俊英", reading: "しゅんえい", meaning: "excellence, genius" },
        { word: "俊足", reading: "しゅんそく", meaning: "swiftness of foot, fast runner" }
    ],
    },
    "春": {
        onyomi: ["シュン"],
        kunyomi: ["はる"],
        examples: [
        { word: "今春", reading: "こんしゅん", meaning: "this spring, spring this year" },
        { word: "昨春", reading: "さくしゅん", meaning: "last spring, the spring of last year" },
        { word: "春秋", reading: "しゅんじゅう", meaning: "spring and autumn, spring and fall" },
        { word: "春先", reading: "はるさき", meaning: "beginning of spring" }
    ],
    },
    "瞬": {
        onyomi: ["シュン"],
        kunyomi: ["またた.く", "まじろ.ぐ"],
        examples: [
        { word: "一瞬", reading: "いっしゅん", meaning: "instant, moment, for an instant" },
        { word: "瞬く", reading: "またたく", meaning: "to twinkle (e.g. stars), to flicker, to waver" },
        { word: "瞬間", reading: "しゅんかん", meaning: "moment, instant, second" },
        { word: "瞬時", reading: "しゅんじ", meaning: "instant, moment, (split) second" }
    ],
    },
    "旬": {
        onyomi: ["ジュン", "シュン"],
        kunyomi: [],
        examples: [
        { word: "下旬", reading: "げじゅん", meaning: "last third of a month, 21st to the last day of a month" },
        { word: "初旬", reading: "しょじゅん", meaning: "first 10 days of the month" },
        { word: "上旬", reading: "じょうじゅん", meaning: "first third of a month, first ten days of a month" },
        { word: "中旬", reading: "ちゅうじゅん", meaning: "middle ten days of a month, 11th to 20th day of a month" }
    ],
    },
    "巡": {
        onyomi: ["ジュン"],
        kunyomi: ["めぐ.る", "めぐ.り"],
        examples: [
        { word: "巡る", reading: "めぐる", meaning: "to go around, to make a circle around" },
        { word: "巡回", reading: "じゅんかい", meaning: "going around, patrol, round" },
        { word: "巡業", reading: "じゅんぎょう", meaning: "provincial tour" },
        { word: "巡航", reading: "じゅんこう", meaning: "cruise, cruising" }
    ],
    },
    "盾": {
        onyomi: ["ジュン"],
        kunyomi: ["たて"],
        examples: [
        { word: "矛盾", reading: "むじゅん", meaning: "contradiction, inconsistency" },
        { word: "後ろ盾", reading: "うしろだて", meaning: "backing, support, backer" },
        { word: "盾", reading: "たて", meaning: "shield, buckler, escutcheon" }
    ],
    },
    "准": {
        onyomi: ["ジュン"],
        kunyomi: [],
        examples: [
        { word: "批准", reading: "ひじゅん", meaning: "ratification" }
    ],
    },
    "殉": {
        onyomi: ["ジュン"],
        kunyomi: [],
        examples: [
        { word: "殉職", reading: "じゅんしょく", meaning: "dying at one's post, being killed in the line of duty" },
        { word: "殉難", reading: "じゅんなん", meaning: "martyrdom" }
    ],
    },
    "純": {
        onyomi: ["ジュン"],
        kunyomi: [],
        examples: [
        { word: "純益", reading: "じゅんえき", meaning: "clear profit, net income, net profit" },
        { word: "純金", reading: "じゅんきん", meaning: "pure gold, solid gold, fine gold" },
        { word: "純情", reading: "じゅんじょう", meaning: "pure heart, naivete, innocence" },
        { word: "純粋", reading: "じゅんすい", meaning: "pure, true, genuine" }
    ],
    },
    "循": {
        onyomi: ["ジュン"],
        kunyomi: [],
        examples: [
        { word: "循環", reading: "じゅんかん", meaning: "circulation, rotation, cycle" },
        { word: "悪循環", reading: "あくじゅんかん", meaning: "vicious circle, vicious cycle" },
        { word: "循環器", reading: "じゅんかんき", meaning: "circulatory organ" }
    ],
    },
    "順": {
        onyomi: ["ジュン"],
        kunyomi: [],
        examples: [
        { word: "手順", reading: "てじゅん", meaning: "process, procedure, sequence" },
        { word: "順守", reading: "じゅんしゅ", meaning: "observance (of laws, rules, etc.), adherence, obeying" },
        { word: "順に", reading: "じゅんに", meaning: "in order, in turn, one by one" },
        { word: "順位", reading: "じゅんい", meaning: "order, rank, position (e.g. in a race)" }
    ],
    },
    "準": {
        onyomi: ["ジュン"],
        kunyomi: ["じゅん.じる", "じゅん.ずる", "なぞら.える", "のり", "ひと.しい", "みずもり"],
        examples: [
        { word: "準急", reading: "じゅんきゅう", meaning: "semi-express train, local express train, sub-express train" },
        { word: "準拠", reading: "じゅんきょ", meaning: "being based on, following (a rule, guidelines, etc.), conforming to (standards, regulations, etc.)" },
        { word: "準備", reading: "じゅんび", meaning: "preparation, arrangements, getting ready" },
        { word: "照準", reading: "しょうじゅん", meaning: "sight (e.g. of a gun), aim, alignment" }
    ],
    },
    "潤": {
        onyomi: ["ジュン"],
        kunyomi: ["うるお.う", "うるお.す", "うる.む"],
        examples: [
        { word: "潤い", reading: "うるおい", meaning: "moisture, damp, wetness" },
        { word: "潤う", reading: "うるおう", meaning: "to become moist, to be moistened, to become damp" },
        { word: "潤す", reading: "うるおす", meaning: "to moisten, to wet" },
        { word: "潤む", reading: "うるむ", meaning: "to be wet (with tears), to be moist" }
    ],
    },
    "遵": {
        onyomi: ["ジュン"],
        kunyomi: [],
        examples: [
        { word: "遵守", reading: "じゅんしゅ", meaning: "observance (of laws, rules, etc.), adherence, obeying" }
    ],
    },
    "処": {
        onyomi: ["ショ"],
        kunyomi: ["ところ", "-こ", "お.る"],
        examples: [
        { word: "処遇", reading: "しょぐう", meaning: "treatment (of a person), dealing with" },
        { word: "処刑", reading: "しょけい", meaning: "execution" },
        { word: "処女", reading: "しょじょ", meaning: "virgin (usu. female), maiden" },
        { word: "処置", reading: "しょち", meaning: "measure, step, dealing with" }
    ],
    },
    "初": {
        onyomi: ["ショ"],
        kunyomi: ["はじ.め", "はじ.めて", "はつ", "はつ-", "うい-", "-そ.める", "-ぞ.め"],
        examples: [
        { word: "最初", reading: "さいしょ", meaning: "beginning, outset, first" },
        { word: "初め", reading: "はじめ", meaning: "beginning, start, outset" },
        { word: "初演", reading: "しょえん", meaning: "first performance, premiere" },
        { word: "初夏", reading: "しょか", meaning: "early summer" }
    ],
    },
    "所": {
        onyomi: ["ショ"],
        kunyomi: ["ところ", "-ところ", "どころ", "とこ"],
        examples: [
        { word: "所が", reading: "ところが", meaning: "even so, however, still" },
        { word: "急所", reading: "きゅうしょ", meaning: "vital part (of the body), tender spot, weak point" },
        { word: "近所", reading: "きんじょ", meaning: "neighbourhood, neighborhood, vicinity" },
        { word: "御所", reading: "ごしょ", meaning: "imperial palace (esp. Kyoto Imperial Palace), imperial residence, residence of a shogun, minister, etc." }
    ],
    },
    "書": {
        onyomi: ["ショ"],
        kunyomi: ["か.く", "-が.き", "-がき"],
        examples: [
        { word: "遺書", reading: "いしょ", meaning: "note left by a dead person, suicide note, testamentary letter" },
        { word: "願書", reading: "がんしょ", meaning: "(written) application, written request, petition" },
        { word: "教書", reading: "きょうしょ", meaning: "message (delivered by the US president or a state governor), address" },
        { word: "原書", reading: "げんしょ", meaning: "original document (not a copy or adaptation), book in its original language (esp. a European language)" }
    ],
    },
    "庶": {
        onyomi: ["ショ"],
        kunyomi: [],
        examples: [
        { word: "庶民", reading: "しょみん", meaning: "common people, ordinary people, masses" },
        { word: "庶務", reading: "しょむ", meaning: "general affairs" },
        { word: "庶民的", reading: "しょみんてき", meaning: "popular, folksy, plebeian" }
    ],
    },
    "暑": {
        onyomi: ["ショ"],
        kunyomi: ["あつ.い"],
        examples: [
        { word: "酷暑", reading: "こくしょ", meaning: "intense heat, severe heat" },
        { word: "残暑", reading: "ざんしょ", meaning: "late summer heat, lingering summer heat" },
        { word: "暑い", reading: "あつい", meaning: "hot, warm, sultry" },
        { word: "暑さ", reading: "あつさ", meaning: "heat (of the weather), hotness" }
    ],
    },
    "署": {
        onyomi: ["ショ"],
        kunyomi: [],
        examples: [
        { word: "署名", reading: "しょめい", meaning: "signature, autograph" },
        { word: "部署", reading: "ぶしょ", meaning: "one's post, one's station, department" },
        { word: "署長", reading: "しょちょう", meaning: "chief (of police), head (of office)" },
        { word: "署員", reading: "しょいん", meaning: "staff member, station employee, official" }
    ],
    },
    "緒": {
        onyomi: ["ショ", "チョ"],
        kunyomi: ["お", "いとぐち"],
        examples: [
        { word: "一緒", reading: "いっしょ", meaning: "(doing) together" },
        { word: "緒戦", reading: "しょせん", meaning: "beginning of hostilities, beginning of competition" },
        { word: "端緒", reading: "たんしょ", meaning: "start, beginning, first step" },
        { word: "内緒", reading: "ないしょ", meaning: "secrecy, confidentiality, privacy" }
    ],
    },
    "諸": {
        onyomi: ["ショ"],
        kunyomi: ["もろ"],
        examples: [
        { word: "諸君", reading: "しょくん", meaning: "you (people)" },
        { word: "諸国", reading: "しょこく", meaning: "various countries, various regions, various provinces" },
        { word: "諸島", reading: "しょとう", meaning: "archipelago, group of islands" },
        { word: "諸", reading: "しょ", meaning: "various, many, several" }
    ],
    },
    "女": {
        onyomi: ["ジョ", "ニョ", "ニョウ"],
        kunyomi: ["おんな", "め"],
        examples: [
        { word: "悪女", reading: "あくじょ", meaning: "wicked woman" },
        { word: "王女", reading: "おうじょ", meaning: "princess" },
        { word: "皇女", reading: "こうじょ", meaning: "imperial princess" },
        { word: "三女", reading: "さんじょ", meaning: "third daughter" }
    ],
    },
    "如": {
        onyomi: ["ジョ", "ニョ"],
        kunyomi: ["ごと.し"],
        examples: [
        { word: "欠如", reading: "けつじょ", meaning: "lack, absence, shortage" },
        { word: "突如", reading: "とつじょ", meaning: "suddenly, all of a sudden, unexpectedly" },
        { word: "如し", reading: "ごとし", meaning: "like, as if, the same as" },
        { word: "如実", reading: "にょじつ", meaning: "reality, actuality, actual conditions" }
    ],
    },
    "助": {
        onyomi: ["ジョ"],
        kunyomi: ["たす.ける", "たす.かる", "す.ける", "すけ"],
        examples: [
        { word: "一助", reading: "いちじょ", meaning: "(some small) help, an aid, some assistance" },
        { word: "援助", reading: "えんじょ", meaning: "assistance, aid, support" },
        { word: "救助", reading: "きゅうじょ", meaning: "relief, aid, rescue" },
        { word: "互助", reading: "ごじょ", meaning: "mutual aid, cooperation, benefit" }
    ],
    },
    "序": {
        onyomi: ["ジョ"],
        kunyomi: ["つい.で", "ついで"],
        examples: [
        { word: "順序", reading: "じゅんじょ", meaning: "order, sequence" },
        { word: "序で", reading: "ついで", meaning: "opportunity, occasion, chance" },
        { word: "序曲", reading: "じょきょく", meaning: "overture, prelude" },
        { word: "序説", reading: "じょせつ", meaning: "introduction" }
    ],
    },
    "叙": {
        onyomi: ["ジョ"],
        kunyomi: ["つい.ず", "ついで"],
        examples: [
        { word: "叙勲", reading: "じょくん", meaning: "conferring of decorations" },
        { word: "叙述", reading: "じょじゅつ", meaning: "description, account, delineation" },
        { word: "叙情", reading: "じょじょう", meaning: "lyricism, description of one's feelings" },
        { word: "自叙伝", reading: "じじょでん", meaning: "autobiography" }
    ],
    },
    "徐": {
        onyomi: ["ジョ"],
        kunyomi: ["おもむ.ろに"],
        examples: [
        { word: "徐行", reading: "じょこう", meaning: "going slowly (esp. to enable a vehicle to stop immediately), going at a reduced speed, slowing down" },
        { word: "徐々に", reading: "じょじょに", meaning: "gradually, steadily, slowly" }
    ],
    },
    "除": {
        onyomi: ["ジョ", "ジ"],
        kunyomi: ["のぞ.く", "-よ.け"],
        examples: [
        { word: "解除", reading: "かいじょ", meaning: "termination (of a contract), cancellation, rescinding" },
        { word: "駆除", reading: "くじょ", meaning: "extermination (of pests), eradication, stamping out (e.g. a social evil)" },
        { word: "控除", reading: "こうじょ", meaning: "subtraction, deduction (e.g. of tax)" },
        { word: "削除", reading: "さくじょ", meaning: "deletion, elimination, erasure" }
    ],
    },
    "小": {
        onyomi: ["ショウ"],
        kunyomi: ["ちい.さい", "こ-", "お-", "さ-"],
        examples: [
        { word: "最小", reading: "さいしょう", meaning: "smallest (in size, degree, etc.), least, minimum" },
        { word: "縮小", reading: "しゅくしょう", meaning: "reduction, curtailment, cut" },
        { word: "小雨", reading: "こさめ", meaning: "light rain, drizzle" },
        { word: "小屋", reading: "こや", meaning: "hut, cabin, shed" }
    ],
    },
    "升": {
        onyomi: ["ショウ"],
        kunyomi: ["ます"],
        examples: [
        { word: "升", reading: "ます", meaning: "measuring container, measuring box, measure" }
    ],
    },
    "少": {
        onyomi: ["ショウ"],
        kunyomi: ["すく.ない", "すこ.し"],
        examples: [
        { word: "希少", reading: "きしょう", meaning: "scarce, rare" },
        { word: "減少", reading: "げんしょう", meaning: "decrease, reduction, decline" },
        { word: "最少", reading: "さいしょう", meaning: "fewest, least, smallest (number)" },
        { word: "少尉", reading: "しょうい", meaning: "second lieutenant, sublieutenant, ensign" }
    ],
    },
    "召": {
        onyomi: ["ショウ"],
        kunyomi: ["め.す"],
        examples: [
        { word: "応召", reading: "おうしょう", meaning: "responding to a call-up for military service, answering a call-up" },
        { word: "召す", reading: "めす", meaning: "to call, to summon, to send for" },
        { word: "召喚", reading: "しょうかん", meaning: "summons, subpoena, citation" },
        { word: "召集", reading: "しょうしゅう", meaning: "convening, calling together (e.g. parliament), call-up (for military service)" }
    ],
    },
    "匠": {
        onyomi: ["ショウ"],
        kunyomi: ["たくみ"],
        examples: [
        { word: "意匠", reading: "いしょう", meaning: "design" },
        { word: "巨匠", reading: "きょしょう", meaning: "master, masterhand, maestro" },
        { word: "師匠", reading: "ししょう", meaning: "master, teacher" },
        { word: "匠", reading: "たくみ", meaning: "craftsman, artisan, workman" }
    ],
    },
    "床": {
        onyomi: ["ショウ"],
        kunyomi: ["とこ", "ゆか"],
        examples: [
        { word: "温床", reading: "おんしょう", meaning: "hotbed, breeding ground" },
        { word: "起床", reading: "きしょう", meaning: "rising (from one's bed), getting up, getting out of bed" },
        { word: "床屋", reading: "とこや", meaning: "barbershop, barber shop, barber" },
        { word: "床下", reading: "ゆかした", meaning: "under the floor" }
    ],
    },
    "抄": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "抄本", reading: "しょうほん", meaning: "excerpt, abridgment, abridgement" },
        { word: "抄録", reading: "しょうろく", meaning: "quotation, abstract, selection" }
    ],
    },
    "肖": {
        onyomi: ["ショウ"],
        kunyomi: ["あやか.る"],
        examples: [
        { word: "肖像", reading: "しょうぞう", meaning: "portrait, likeness, picture" },
        { word: "不肖", reading: "ふしょう", meaning: "unworthy (of one's father, teacher, etc.)" }
    ],
    },
    "尚": {
        onyomi: ["ショウ"],
        kunyomi: ["なお"],
        examples: [
        { word: "高尚", reading: "こうしょう", meaning: "high, noble, refined" },
        { word: "尚更", reading: "なおさら", meaning: "still more, even more, all the more" },
        { word: "和尚", reading: "おしょう", meaning: "priestly teacher, preceptor" },
        { word: "尚且つ", reading: "なおかつ", meaning: "besides, furthermore, on top of that" }
    ],
    },
    "招": {
        onyomi: ["ショウ"],
        kunyomi: ["まね.く"],
        examples: [
        { word: "招き", reading: "まねき", meaning: "invitation" },
        { word: "招く", reading: "まねく", meaning: "to invite, to ask" },
        { word: "招集", reading: "しょうしゅう", meaning: "call, summons, convening" },
        { word: "招待", reading: "しょうたい", meaning: "invitation" }
    ],
    },
    "承": {
        onyomi: ["ショウ", "ジョウ"],
        kunyomi: ["うけたまわ.る", "う.ける"],
        examples: [
        { word: "継承", reading: "けいしょう", meaning: "inheritance, succession, accession" },
        { word: "承る", reading: "うけたまわる", meaning: "to hear, to be told, to know" },
        { word: "承諾", reading: "しょうだく", meaning: "consent, approval, acceptance" },
        { word: "承知", reading: "しょうち", meaning: "knowledge, awareness" }
    ],
    },
    "昇": {
        onyomi: ["ショウ"],
        kunyomi: ["のぼ.る"],
        examples: [
        { word: "昇格", reading: "しょうかく", meaning: "promotion, raising of status" },
        { word: "昇級", reading: "しょうきゅう", meaning: "promotion, advancement" },
        { word: "昇給", reading: "しょうきゅう", meaning: "salary raise" },
        { word: "昇進", reading: "しょうしん", meaning: "promotion, advancement, rising in rank" }
    ],
    },
    "松": {
        onyomi: ["ショウ"],
        kunyomi: ["まつ"],
        examples: [
        { word: "松林", reading: "まつばやし", meaning: "pine forest" },
        { word: "門松", reading: "かどまつ", meaning: "New Year's pine decoration" },
        { word: "赤松", reading: "あかまつ", meaning: "Japanese red pine (Pinus densiflora), Japanese umbrella pine, tanyosho pine" },
        { word: "浜松", reading: "はままつ", meaning: "Hamamatsu (city)" }
    ],
    },
    "沼": {
        onyomi: ["ショウ"],
        kunyomi: ["ぬま"],
        examples: [
        { word: "湖沼", reading: "こしょう", meaning: "lake, marsh, wetland" },
        { word: "沼沢", reading: "しょうたく", meaning: "marsh, swamp, bog" },
        { word: "沼地", reading: "ぬまち", meaning: "marshland, wetland, swampland" },
        { word: "泥沼", reading: "どろぬま", meaning: "bog, marsh, swamp" }
    ],
    },
    "昭": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "昭和", reading: "しょうわ", meaning: "Shōwa era (1926.12.25-1989.1.7)" }
    ],
    },
    "宵": {
        onyomi: ["ショウ"],
        kunyomi: ["よい"],
        examples: [
        { word: "今宵", reading: "こよい", meaning: "this evening, tonight" },
        { word: "宵", reading: "よい", meaning: "evening, early night hours" }
    ],
    },
    "将": {
        onyomi: ["ショウ", "ソウ"],
        kunyomi: ["まさ.に", "はた", "まさ", "ひきい.る", "もって"],
        examples: [
        { word: "王将", reading: "おうしょう", meaning: "(senior player's) king" },
        { word: "主将", reading: "しゅしょう", meaning: "commander-in-chief, supreme commander" },
        { word: "将棋", reading: "しょうぎ", meaning: "shogi, Japanese chess" },
        { word: "将軍", reading: "しょうぐん", meaning: "general" }
    ],
    },
    "消": {
        onyomi: ["ショウ"],
        kunyomi: ["き.える", "け.す"],
        examples: [
        { word: "解消", reading: "かいしょう", meaning: "cancellation, liquidation, resolution" },
        { word: "消す", reading: "けす", meaning: "to erase, to rub out, to rub off" },
        { word: "消化", reading: "しょうか", meaning: "digestion (of food)" },
        { word: "消火", reading: "しょうか", meaning: "extinguishing a fire, fire fighting" }
    ],
    },
    "症": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "炎症", reading: "えんしょう", meaning: "inflammation, irritation" },
        { word: "重症", reading: "じゅうしょう", meaning: "serious illness" },
        { word: "症候", reading: "しょうこう", meaning: "symptom" },
        { word: "症状", reading: "しょうじょう", meaning: "symptoms, condition (of a patient)" }
    ],
    },
    "祥": {
        onyomi: ["ショウ"],
        kunyomi: ["さいわ.い", "きざ.し", "よ.い", "つまび.らか"],
        examples: [
        { word: "発祥", reading: "はっしょう", meaning: "origin" },
        { word: "発祥地", reading: "はっしょうち", meaning: "birthplace (e.g. of jazz, Buddhism), cradle (e.g. of civilization), place of origin" },
        { word: "不祥事", reading: "ふしょうじ", meaning: "scandal, impropriety, misconduct" }
    ],
    },
    "称": {
        onyomi: ["ショウ"],
        kunyomi: ["たた.える", "とな.える", "あ.げる", "かな.う", "はか.り", "はか.る", "ほめ.る"],
        examples: [
        { word: "愛称", reading: "あいしょう", meaning: "pet name, nickname, affectionate name" },
        { word: "仮称", reading: "かしょう", meaning: "temporary name, provisional name" },
        { word: "敬称", reading: "けいしょう", meaning: "honorific title, honorific term of address" },
        { word: "呼称", reading: "こしょう", meaning: "name, designation, denomination" }
    ],
    },
    "笑": {
        onyomi: ["ショウ"],
        kunyomi: ["わら.う", "え.む"],
        examples: [
        { word: "苦笑", reading: "くしょう", meaning: "bitter smile, wry smile, strained laugh" },
        { word: "笑い", reading: "わらい", meaning: "laugh, laughter" },
        { word: "笑う", reading: "わらう", meaning: "to laugh" },
        { word: "笑み", reading: "えみ", meaning: "smile" }
    ],
    },
    "唱": {
        onyomi: ["ショウ"],
        kunyomi: ["とな.える"],
        examples: [
        { word: "歌唱", reading: "かしょう", meaning: "song, singing" },
        { word: "合唱", reading: "がっしょう", meaning: "singing together, singing in union, chorus" },
        { word: "唱歌", reading: "しょうか", meaning: "singing, song" },
        { word: "斉唱", reading: "せいしょう", meaning: "singing in unison, chanting in unison" }
    ],
    },
    "商": {
        onyomi: ["ショウ"],
        kunyomi: ["あきな.う"],
        examples: [
        { word: "画商", reading: "がしょう", meaning: "picture dealer, commercial art gallery" },
        { word: "商い", reading: "あきない", meaning: "trade, business, trading" },
        { word: "商会", reading: "しょうかい", meaning: "firm, company" },
        { word: "商業", reading: "しょうぎょう", meaning: "commerce, trade, business" }
    ],
    },
    "渉": {
        onyomi: ["ショウ"],
        kunyomi: ["わた.る"],
        examples: [
        { word: "干渉", reading: "かんしょう", meaning: "interference, intervention, meddling" },
        { word: "交渉", reading: "こうしょう", meaning: "negotiations, bargaining, discussions" },
        { word: "渉外", reading: "しょうがい", meaning: "public relations, client liaison, client relations" }
    ],
    },
    "章": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "楽章", reading: "がくしょう", meaning: "movement" },
        { word: "記章", reading: "きしょう", meaning: "medal, badge, insignia" },
        { word: "勲章", reading: "くんしょう", meaning: "decoration, order, medal" },
        { word: "憲章", reading: "けんしょう", meaning: "charter" }
    ],
    },
    "紹": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "紹介", reading: "しょうかい", meaning: "introduction, presentation, referral" },
        { word: "紹介者", reading: "しょうかいしゃ", meaning: "person who introduces someone, introducer" },
        { word: "紹介文", reading: "しょうかいぶん", meaning: "introductory text, introductory essay" },
        { word: "自己紹介", reading: "じこしょうかい", meaning: "self-introduction" }
    ],
    },
    "訟": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "訴訟", reading: "そしょう", meaning: "lawsuit, suit, (legal) action" },
        { word: "行政訴訟", reading: "ぎょうせいそしょう", meaning: "administrative litigation (action)" }
    ],
    },
    "勝": {
        onyomi: ["ショウ"],
        kunyomi: ["か.つ", "-が.ち", "まさ.る", "すぐ.れる", "かつ"],
        examples: [
        { word: "圧勝", reading: "あっしょう", meaning: "overwhelming victory, crushing victory, sweeping victory" },
        { word: "景勝", reading: "けいしょう", meaning: "picturesque scenery, place of scenic beauty" },
        { word: "決勝", reading: "けっしょう", meaning: "decision of a contest" },
        { word: "殊勝", reading: "しゅしょう", meaning: "admirable, laudable" }
    ],
    },
    "掌": {
        onyomi: ["ショウ"],
        kunyomi: ["てのひら", "たなごころ"],
        examples: [
        { word: "合掌", reading: "がっしょう", meaning: "pressing one's hands together in prayer" },
        { word: "車掌", reading: "しゃしょう", meaning: "(train) conductor" },
        { word: "掌握", reading: "しょうあく", meaning: "grasping, seizing, holding" },
        { word: "掌中", reading: "しょうちゅう", meaning: "in the hand, (something) easily manipulated" }
    ],
    },
    "晶": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "液晶", reading: "えきしょう", meaning: "liquid crystal" },
        { word: "結晶", reading: "けっしょう", meaning: "crystal, crystallization, crystallisation" },
        { word: "水晶", reading: "すいしょう", meaning: "(rock) crystal, high purity quartz" }
    ],
    },
    "焼": {
        onyomi: ["ショウ"],
        kunyomi: ["や.く", "や.き", "や.き-", "-や.き", "や.ける"],
        examples: [
        { word: "焼芋", reading: "やきいも", meaning: "roasted sweet potato, baked sweet potato" },
        { word: "焼く", reading: "やく", meaning: "to burn" },
        { word: "焼却", reading: "しょうきゃく", meaning: "incineration, destruction by fire" },
        { word: "焼酎", reading: "しょうちゅう", meaning: "shōchū, Japanese spirit distilled from sweet potatoes, rice, etc." }
    ],
    },
    "焦": {
        onyomi: ["ショウ"],
        kunyomi: ["こ.げる", "こ.がす", "こ.がれる", "あせ.る", "じ.れる", "じ.らす"],
        examples: [
        { word: "焦り", reading: "あせり", meaning: "impatience" },
        { word: "焦る", reading: "あせる", meaning: "to be in a hurry, to be impatient, to be anxious (to do)" },
        { word: "焦燥", reading: "しょうそう", meaning: "impatience, irritation, frustration" },
        { word: "焦点", reading: "しょうてん", meaning: "focus, focal point" }
    ],
    },
    "硝": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "硝煙", reading: "しょうえん", meaning: "gunpowder smoke" },
        { word: "硝酸", reading: "しょうさん", meaning: "nitric acid" }
    ],
    },
    "粧": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "化粧", reading: "けしょう", meaning: "make-up, makeup, cosmetics" }
    ],
    },
    "詔": {
        onyomi: ["ショウ"],
        kunyomi: ["みことのり"],
        examples: [
        { word: "詔書", reading: "しょうしょ", meaning: "imperial edict, decree" },
        { word: "詔", reading: "みことのり", meaning: "imperial decree, imperial edict" }
    ],
    },
    "証": {
        onyomi: ["ショウ"],
        kunyomi: ["あかし"],
        examples: [
        { word: "偽証", reading: "ぎしょう", meaning: "false evidence, perjury, false testimony" },
        { word: "検証", reading: "けんしょう", meaning: "verification, confirmation, substantiation" },
        { word: "考証", reading: "こうしょう", meaning: "investigation into historical evidence, study of historical artifacts" },
        { word: "査証", reading: "さしょう", meaning: "visa" }
    ],
    },
    "象": {
        onyomi: ["ショウ", "ゾウ"],
        kunyomi: ["かたど.る"],
        examples: [
        { word: "印象", reading: "いんしょう", meaning: "impression" },
        { word: "気象", reading: "きしょう", meaning: "weather (conditions)" },
        { word: "具象", reading: "ぐしょう", meaning: "concreteness, embodiment, expressing concretely" },
        { word: "現象", reading: "げんしょう", meaning: "phenomenon" }
    ],
    },
    "傷": {
        onyomi: ["ショウ"],
        kunyomi: ["きず", "いた.む", "いた.める"],
        examples: [
        { word: "外傷", reading: "がいしょう", meaning: "external injury, external wound, (physical) trauma" },
        { word: "軽傷", reading: "けいしょう", meaning: "minor injury" },
        { word: "殺傷", reading: "さっしょう", meaning: "killing and wounding, bloodshed" },
        { word: "傷害", reading: "しょうがい", meaning: "injury, inflicting bodily injury" }
    ],
    },
    "奨": {
        onyomi: ["ショウ", "ソウ"],
        kunyomi: ["すす.める"],
        examples: [
        { word: "勧奨", reading: "かんしょう", meaning: "encouragement, stimulation" },
        { word: "奨励", reading: "しょうれい", meaning: "encouragement, promotion, inducement" },
        { word: "推奨", reading: "すいしょう", meaning: "recommendation, endorsement" },
        { word: "選奨", reading: "せんしょう", meaning: "recommendation" }
    ],
    },
    "照": {
        onyomi: ["ショウ"],
        kunyomi: ["て.る", "て.らす", "て.れる"],
        examples: [
        { word: "参照", reading: "さんしょう", meaning: "reference (e.g. to a dictionary, passage, footnotes), consultation, comparison" },
        { word: "照る", reading: "てる", meaning: "to shine" },
        { word: "照会", reading: "しょうかい", meaning: "inquiry, query, enquiry" },
        { word: "照射", reading: "しょうしゃ", meaning: "irradiation, radiation, beaming" }
    ],
    },
    "詳": {
        onyomi: ["ショウ"],
        kunyomi: ["くわ.しい", "つまび.らか"],
        examples: [
        { word: "詳細", reading: "しょうさい", meaning: "details, particulars, specifics" },
        { word: "詳述", reading: "しょうじゅつ", meaning: "detailed explanation" },
        { word: "詳報", reading: "しょうほう", meaning: "detailed report, full report, details" },
        { word: "不詳", reading: "ふしょう", meaning: "unknown, unidentified, unspecified" }
    ],
    },
    "彰": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "顕彰", reading: "けんしょう", meaning: "honouring (publicly), honoring, making someone's good deeds or achievements well-known" },
        { word: "表彰", reading: "ひょうしょう", meaning: "(official) commendation, public recognition (of someone's achievements, good deeds, etc.), awarding" },
        { word: "表彰状", reading: "ひょうしょうじょう", meaning: "testimonial, certificate of commendation" }
    ],
    },
    "障": {
        onyomi: ["ショウ"],
        kunyomi: ["さわ.る"],
        examples: [
        { word: "気障", reading: "きざ", meaning: "affected, smug, pompous" },
        { word: "故障", reading: "こしょう", meaning: "fault, trouble, breakdown" },
        { word: "支障", reading: "ししょう", meaning: "obstacle, hindrance, impediment" },
        { word: "障る", reading: "さわる", meaning: "to be harmful to, to hinder, to interfere with" }
    ],
    },
    "憧": {
        onyomi: ["ショウ", "トウ", "ドウ"],
        kunyomi: ["あこが.れる"],
        examples: [
        { word: "憧れ", reading: "あこがれ", meaning: "yearning, longing, aspiration" },
        { word: "憧れる", reading: "あこがれる", meaning: "to long for, to yearn for, to hanker after" },
        { word: "憧れの的", reading: "あこがれのまと", meaning: "object of adoration, longing" }
    ],
    },
    "衝": {
        onyomi: ["ショウ"],
        kunyomi: ["つ.く"],
        examples: [
        { word: "衝撃", reading: "しょうげき", meaning: "impact, shock, impulse" },
        { word: "衝動", reading: "しょうどう", meaning: "impulse, urge, impetus" },
        { word: "衝突", reading: "しょうとつ", meaning: "collision, crash, impact" },
        { word: "折衝", reading: "せっしょう", meaning: "negotiation" }
    ],
    },
    "賞": {
        onyomi: ["ショウ"],
        kunyomi: ["ほ.める"],
        examples: [
        { word: "観賞", reading: "かんしょう", meaning: "admiration, appreciation, enjoyment" },
        { word: "鑑賞", reading: "かんしょう", meaning: "appreciation (of art, music, poetry, etc.)" },
        { word: "懸賞", reading: "けんしょう", meaning: "offering a prize, prize competition, prize" },
        { word: "受賞", reading: "じゅしょう", meaning: "winning a prize, receiving an award, being awarded" }
    ],
    },
    "償": {
        onyomi: ["ショウ"],
        kunyomi: ["つぐな.う"],
        examples: [
        { word: "償い", reading: "つぐない", meaning: "recompense, indemnity, atonement" },
        { word: "償う", reading: "つぐなう", meaning: "to make up for, to compensate for, to indemnify" },
        { word: "償還", reading: "しょうかん", meaning: "repayment, redemption, amortization" },
        { word: "償却", reading: "しょうきゃく", meaning: "repayment, redemption" }
    ],
    },
    "礁": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "暗礁", reading: "あんしょう", meaning: "reef, sunken rock" },
        { word: "環礁", reading: "かんしょう", meaning: "atoll, circular coral reef" },
        { word: "岩礁", reading: "がんしょう", meaning: "reef" }
    ],
    },
    "鐘": {
        onyomi: ["ショウ"],
        kunyomi: ["かね"],
        examples: [
        { word: "警鐘", reading: "けいしょう", meaning: "alarm bell, fire bell" },
        { word: "鐘楼", reading: "しょうろう", meaning: "belfry, bell tower" },
        { word: "鐘", reading: "かね", meaning: "bell (often a large hanging bell), chime" }
    ],
    },
    "上": {
        onyomi: ["ジョウ", "ショウ", "シャン"],
        kunyomi: ["うえ", "-うえ", "うわ-", "かみ", "あ.げる", "-あ.げる", "あ.がる", "-あ.がる", "あ.がり", "-あ.がり", "のぼ.る", "のぼ.り", "のぼ.せる", "のぼ.す", "たてまつ.る"],
        examples: [
        { word: "以上", reading: "いじょう", meaning: "not less than ..., ... and over, ... and above" },
        { word: "右上", reading: "みぎうえ", meaning: "upper right" },
        { word: "炎上", reading: "えんじょう", meaning: "going up in flames, destruction by fire (esp. of a large building)" },
        { word: "屋上", reading: "おくじょう", meaning: "rooftop" }
    ],
    },
    "丈": {
        onyomi: ["ジョウ"],
        kunyomi: ["たけ", "だけ"],
        examples: [
        { word: "頑丈", reading: "がんじょう", meaning: "solid, firm, stout" },
        { word: "気丈", reading: "きじょう", meaning: "stout-hearted, firm, courageous" },
        { word: "背丈", reading: "せたけ", meaning: "stature, height" },
        { word: "丈夫", reading: "じょうぶ", meaning: "healthy, robust, strong" }
    ],
    },
    "冗": {
        onyomi: ["ジョウ"],
        kunyomi: [],
        examples: [
        { word: "冗談", reading: "じょうだん", meaning: "joke, jest, funny story" }
    ],
    },
    "条": {
        onyomi: ["ジョウ", "チョウ", "デキ"],
        kunyomi: ["えだ", "すじ"],
        examples: [
        { word: "一条", reading: "いちじょう", meaning: "one line, one streak, one stripe" },
        { word: "条件", reading: "じょうけん", meaning: "condition, term, requirement" },
        { word: "条項", reading: "じょうこう", meaning: "clause, article, stipulations" },
        { word: "条文", reading: "じょうぶん", meaning: "text (of a law, treaty, contract, etc.), provisions" }
    ],
    },
    "状": {
        onyomi: ["ジョウ"],
        kunyomi: [],
        examples: [
        { word: "異状", reading: "いじょう", meaning: "something wrong, something unusual, abnormality" },
        { word: "賀状", reading: "がじょう", meaning: "New Year's card" },
        { word: "環状", reading: "かんじょう", meaning: "annulation, ring shape, loop shape" },
        { word: "窮状", reading: "きゅうじょう", meaning: "distress, wretched condition" }
    ],
    },
    "乗": {
        onyomi: ["ジョウ", "ショウ"],
        kunyomi: ["の.る", "-の.り", "の.せる"],
        examples: [
        { word: "乗り", reading: "のり", meaning: "riding, ride" },
        { word: "乗る", reading: "のる", meaning: "to get on (train, plane, bus, ship, etc.), to get in, to board" },
        { word: "乗員", reading: "じょういん", meaning: "crew member, crewman, crew" },
        { word: "乗降", reading: "じょうこう", meaning: "getting on and off, embarking and disembarking" }
    ],
    },
    "城": {
        onyomi: ["ジョウ", "セイ"],
        kunyomi: ["しろ"],
        examples: [
        { word: "開城", reading: "かいじょう", meaning: "surrender of a castle, surrender of a fortress, capitulation of a stronghold" },
        { word: "古城", reading: "こじょう", meaning: "old castle, old fortress" },
        { word: "城郭", reading: "じょうかく", meaning: "castle, citadel, fortress" },
        { word: "城主", reading: "じょうしゅ", meaning: "lord of a castle" }
    ],
    },
    "浄": {
        onyomi: ["ジョウ", "セイ"],
        kunyomi: ["きよ.める", "きよ.い"],
        examples: [
        { word: "浄化", reading: "じょうか", meaning: "purification" },
        { word: "浄水", reading: "じょうすい", meaning: "clean water, purified water" },
        { word: "浄土", reading: "じょうど", meaning: "pure land (esp. the Western Pure Land paradise of Amitabha), (Buddhist) paradise" },
        { word: "清浄", reading: "せいじょう", meaning: "pure, clean, purity" }
    ],
    },
    "剰": {
        onyomi: ["ジョウ"],
        kunyomi: ["あまつさえ", "あま.り", "あま.る"],
        examples: [
        { word: "過剰", reading: "かじょう", meaning: "excess, surplus, superabundance" },
        { word: "余剰", reading: "よじょう", meaning: "surplus, remainder, residue" },
        { word: "剰余金", reading: "じょうよきん", meaning: "surplus, balance" }
    ],
    },
    "常": {
        onyomi: ["ジョウ"],
        kunyomi: ["つね", "とこ-"],
        examples: [
        { word: "異常", reading: "いじょう", meaning: "abnormal, unusual, extraordinary" },
        { word: "恒常", reading: "こうじょう", meaning: "constancy, permanence" },
        { word: "常に", reading: "つねに", meaning: "always, constantly, at all times" },
        { word: "常軌", reading: "じょうき", meaning: "normal course (of action), proper course, regular way" }
    ],
    },
    "情": {
        onyomi: ["ジョウ", "セイ"],
        kunyomi: ["なさ.け"],
        examples: [
        { word: "愛情", reading: "あいじょう", meaning: "love, affection" },
        { word: "感情", reading: "かんじょう", meaning: "emotion, feeling, feelings" },
        { word: "苦情", reading: "くじょう", meaning: "complaint, troubles, objection" },
        { word: "激情", reading: "げきじょう", meaning: "violent emotion, passion, fury" }
    ],
    },
    "場": {
        onyomi: ["ジョウ", "チョウ"],
        kunyomi: ["ば"],
        examples: [
        { word: "夏場", reading: "なつば", meaning: "summertime, summer season" },
        { word: "会場", reading: "かいじょう", meaning: "assembly hall, meeting place, venue" },
        { word: "開場", reading: "かいじょう", meaning: "opening (the doors of a venue)" },
        { word: "議場", reading: "ぎじょう", meaning: "assembly hall, the House" }
    ],
    },
    "畳": {
        onyomi: ["ジョウ", "チョウ"],
        kunyomi: ["たた.む", "たたみ", "かさ.なる"],
        examples: [
        { word: "畳む", reading: "たたむ", meaning: "to fold (clothes, umbrella)" },
        { word: "四畳半", reading: "よじょうはん", meaning: "four and a half tatami mats, four-and-a-half-mat room" },
        { word: "折り畳み", reading: "おりたたみ", meaning: "folding, collapsible, telescopic" },
        { word: "畳", reading: "じょう", meaning: "tatami mat (esp. as a measure of room size, either 1.82 sqm or 1.54 sqm)" }
    ],
    },
    "蒸": {
        onyomi: ["ジョウ", "セイ"],
        kunyomi: ["む.す", "む.れる", "む.らす"],
        examples: [
        { word: "蒸す", reading: "むす", meaning: "to steam (food, towel, etc.)" },
        { word: "蒸気", reading: "じょうき", meaning: "steam, vapour, vapor" },
        { word: "蒸発", reading: "じょうはつ", meaning: "evaporation" },
        { word: "蒸し", reading: "むし", meaning: "steaming" }
    ],
    },
    "縄": {
        onyomi: ["ジョウ"],
        kunyomi: ["なわ", "ただ.す"],
        examples: [
        { word: "沖縄", reading: "おきなわ", meaning: "Okinawa (city, prefecture)" },
        { word: "縄文", reading: "じょうもん", meaning: "straw-rope pattern pressed into earthenware" },
        { word: "縄跳び", reading: "なわとび", meaning: "skipping rope, jump rope" },
        { word: "縄張り", reading: "なわばり", meaning: "stretching a rope around, roping off, cordoning off" }
    ],
    },
    "壌": {
        onyomi: ["ジョウ"],
        kunyomi: ["つち"],
        examples: [
        { word: "土壌", reading: "どじょう", meaning: "soil" },
        { word: "平壌", reading: "ピョンヤン", meaning: "Pyongyang (North Korea)" }
    ],
    },
    "嬢": {
        onyomi: ["ジョウ"],
        kunyomi: ["むすめ"],
        examples: [
        { word: "令嬢", reading: "れいじょう", meaning: "(your) daughter, young woman" },
        { word: "お嬢さん", reading: "おじょうさん", meaning: "(another's) daughter" },
        { word: "嬢", reading: "じょう", meaning: "unmarried woman" }
    ],
    },
    "錠": {
        onyomi: ["ジョウ"],
        kunyomi: [],
        examples: [
        { word: "手錠", reading: "てじょう", meaning: "handcuffs, manacles" },
        { word: "錠剤", reading: "じょうざい", meaning: "pill, lozenge, tablet" },
        { word: "錠", reading: "じょう", meaning: "lock, padlock" }
    ],
    },
    "譲": {
        onyomi: ["ジョウ"],
        kunyomi: ["ゆず.る"],
        examples: [
        { word: "割譲", reading: "かつじょう", meaning: "cession (of territory)" },
        { word: "譲る", reading: "ゆずる", meaning: "to hand over, to transfer, to turn over" },
        { word: "譲渡", reading: "じょうと", meaning: "transfer, assignment, conveyance" },
        { word: "譲歩", reading: "じょうほ", meaning: "concession, conciliation, compromise" }
    ],
    },
    "醸": {
        onyomi: ["ジョウ"],
        kunyomi: ["かも.す"],
        examples: [
        { word: "醸成", reading: "じょうせい", meaning: "brewing, fermenting" },
        { word: "醸造", reading: "じょうぞう", meaning: "brewing" }
    ],
    },
    "色": {
        onyomi: ["ショク", "シキ"],
        kunyomi: ["いろ"],
        examples: [
        { word: "異色", reading: "いしょく", meaning: "unique, distinctive, novel" },
        { word: "灰色", reading: "はいいろ", meaning: "grey, gray, ashen" },
        { word: "褐色", reading: "かっしょく", meaning: "dark brown, colour of tanned skin" },
        { word: "顔色", reading: "かおいろ", meaning: "complexion, skin tone, skin colour" }
    ],
    },
    "拭": {
        onyomi: ["ショク", "シキ"],
        kunyomi: ["ぬぐ.う", "ふ.く"],
        examples: [
        { word: "拭う", reading: "ぬぐう", meaning: "to wipe, to mop up" },
        { word: "拭く", reading: "ふく", meaning: "to wipe, to dry" },
        { word: "払拭", reading: "ふっしょく", meaning: "wiping out, sweeping away, eradicating" },
        { word: "手拭い", reading: "てぬぐい", meaning: "tenugui, (hand) towel (usu. thin cotton cloth)" }
    ],
    },
    "食": {
        onyomi: ["ショク", "ジキ"],
        kunyomi: ["く.う", "く.らう", "た.べる", "は.む"],
        examples: [
        { word: "飲食", reading: "いんしょく", meaning: "food and drink, eating and drinking" },
        { word: "会食", reading: "かいしょく", meaning: "eating together, dining together, having a meal together" },
        { word: "外食", reading: "がいしょく", meaning: "eating out, dining out" },
        { word: "間食", reading: "かんしょく", meaning: "eating between meals, snacking" }
    ],
    },
    "植": {
        onyomi: ["ショク"],
        kunyomi: ["う.える", "う.わる"],
        examples: [
        { word: "移植", reading: "いしょく", meaning: "transplanting (a plant), transplant, grafting" },
        { word: "誤植", reading: "ごしょく", meaning: "misprint, typographical error, typo" },
        { word: "植樹", reading: "しょくじゅ", meaning: "tree-planting" },
        { word: "植物", reading: "しょくぶつ", meaning: "plant, vegetation" }
    ],
    },
    "殖": {
        onyomi: ["ショク"],
        kunyomi: ["ふ.える", "ふ.やす"],
        examples: [
        { word: "生殖", reading: "せいしょく", meaning: "reproduction" },
        { word: "増殖", reading: "ぞうしょく", meaning: "increase, multiplication, propagation" },
        { word: "拓殖", reading: "たくしょく", meaning: "colonization, colonisation, development" },
        { word: "繁殖", reading: "はんしょく", meaning: "breeding, propagation, reproduction" }
    ],
    },
    "飾": {
        onyomi: ["ショク"],
        kunyomi: ["かざ.る", "かざ.り"],
        examples: [
        { word: "飾り", reading: "かざり", meaning: "decoration, ornament, trimmings" },
        { word: "飾る", reading: "かざる", meaning: "to decorate, to ornament, to adorn" },
        { word: "装飾", reading: "そうしょく", meaning: "ornament, decoration" },
        { word: "服飾", reading: "ふくしょく", meaning: "clothing and accessories, attire" }
    ],
    },
    "触": {
        onyomi: ["ショク"],
        kunyomi: ["ふ.れる", "さわ.る", "さわ"],
        examples: [
        { word: "感触", reading: "かんしょく", meaning: "feel (of something), touch, texture" },
        { word: "触る", reading: "さわる", meaning: "to touch, to feel, to handle" },
        { word: "触覚", reading: "しょっかく", meaning: "sense of touch" },
        { word: "触媒", reading: "しょくばい", meaning: "catalyst" }
    ],
    },
    "嘱": {
        onyomi: ["ショク"],
        kunyomi: ["しょく.する", "たの.む"],
        examples: [
        { word: "嘱託", reading: "しょくたく", meaning: "commission, entrusting with (work)" },
        { word: "嘱望", reading: "しょくぼう", meaning: "having great hopes for (someone's future), expecting much of, pinning one's hopes on" },
        { word: "委嘱", reading: "いしょく", meaning: "commissioning, entrusting (with), request" }
    ],
    },
    "織": {
        onyomi: ["ショク", "シキ"],
        kunyomi: ["お.る", "お.り", "おり", "-おり", "-お.り"],
        examples: [
        { word: "羽織", reading: "はおり", meaning: "haori (Japanese formal coat)" },
        { word: "織る", reading: "おる", meaning: "to weave" },
        { word: "織機", reading: "しょっき", meaning: "loom, weaving machine" },
        { word: "織物", reading: "おりもの", meaning: "textile, fabric" }
    ],
    },
    "職": {
        onyomi: ["ショク", "ソク"],
        kunyomi: [],
        examples: [
        { word: "汚職", reading: "おしょく", meaning: "corruption (esp. by a government employee), bribery, graft" },
        { word: "休職", reading: "きゅうしょく", meaning: "temporary retirement, leave of absence, suspension from office" },
        { word: "求職", reading: "きゅうしょく", meaning: "job hunting, seeking employment" },
        { word: "現職", reading: "げんしょく", meaning: "present post, current office, (an) incumbent" }
    ],
    },
    "辱": {
        onyomi: ["ジョク"],
        kunyomi: ["はずかし.める"],
        examples: [
        { word: "屈辱", reading: "くつじょく", meaning: "disgrace, humiliation" },
        { word: "雪辱", reading: "せつじょく", meaning: "vindication of honour, vindication of honor, making up for loss" },
        { word: "恥辱", reading: "ちじょく", meaning: "disgrace, shame, insult" },
        { word: "侮辱", reading: "ぶじょく", meaning: "insult, affront, slight" }
    ],
    },
    "尻": {
        onyomi: ["コウ"],
        kunyomi: ["しり"],
        examples: [
        { word: "尻尾", reading: "しっぽ", meaning: "tail (of an animal)" },
        { word: "尻", reading: "しり", meaning: "buttocks, behind, rump" }
    ],
    },
    "心": {
        onyomi: ["シン"],
        kunyomi: ["こころ", "-ごころ"],
        examples: [
        { word: "安心", reading: "あんしん", meaning: "peace of mind, relief, (sense of) security" },
        { word: "一心", reading: "いっしん", meaning: "one mind" },
        { word: "会心", reading: "かいしん", meaning: "congeniality, satisfaction, gratification" },
        { word: "核心", reading: "かくしん", meaning: "core, heart (of the matter), point" }
    ],
    },
    "申": {
        onyomi: ["シン"],
        kunyomi: ["もう.す", "もう.し-", "さる"],
        examples: [
        { word: "上申", reading: "じょうしん", meaning: "report to a superior" },
        { word: "申す", reading: "もうす", meaning: "to say, to be called" },
        { word: "申告", reading: "しんこく", meaning: "report, return (e.g. tax), statement" },
        { word: "申請", reading: "しんせい", meaning: "application, request, petition" }
    ],
    },
    "伸": {
        onyomi: ["シン"],
        kunyomi: ["の.びる", "の.ばす", "の.べる", "の.す"],
        examples: [
        { word: "欠伸", reading: "あくび", meaning: "yawn, yawning" },
        { word: "伸し", reading: "のし", meaning: "stretching" },
        { word: "伸縮", reading: "しんしゅく", meaning: "expansion and contraction, elasticity, flexibility" },
        { word: "追伸", reading: "ついしん", meaning: "postscript, post scriptum, PS" }
    ],
    },
    "臣": {
        onyomi: ["シン", "ジン"],
        kunyomi: [],
        examples: [
        { word: "大臣", reading: "だいじん", meaning: "cabinet minister" },
        { word: "忠臣", reading: "ちゅうしん", meaning: "loyal retainer, loyal subject" },
        { word: "国務大臣", reading: "こくむだいじん", meaning: "minister of state, cabinet minister (in Japan)" },
        { word: "総理大臣", reading: "そうりだいじん", meaning: "prime minister (as the head of a cabinet government), premier" }
    ],
    },
    "芯": {
        onyomi: ["シン"],
        kunyomi: [],
        examples: [
        { word: "芯", reading: "しん", meaning: "wick, marrow, staple (for stapler)" }
    ],
    },
    "身": {
        onyomi: ["シン"],
        kunyomi: ["み"],
        examples: [
        { word: "一身", reading: "いっしん", meaning: "oneself, one's body" },
        { word: "黄身", reading: "きみ", meaning: "egg yolk" },
        { word: "刺身", reading: "さしみ", meaning: "sashimi (raw sliced fish, shellfish or crustaceans)" },
        { word: "脂身", reading: "あぶらみ", meaning: "fat (of meat), fatty meat" }
    ],
    },
    "辛": {
        onyomi: ["シン"],
        kunyomi: ["から.い", "つら.い", "-づら.い", "かのと"],
        examples: [
        { word: "辛子", reading: "からし", meaning: "mustard" },
        { word: "辛い", reading: "からい", meaning: "spicy, hot" },
        { word: "辛苦", reading: "しんく", meaning: "hardship, toil, trouble" },
        { word: "辛酸", reading: "しんさん", meaning: "hardships, privation" }
    ],
    },
    "侵": {
        onyomi: ["シン"],
        kunyomi: ["おか.す"],
        examples: [
        { word: "侵す", reading: "おかす", meaning: "to invade, to raid, to violate (airspace, etc.)" },
        { word: "侵害", reading: "しんがい", meaning: "infringement, violation, invasion" },
        { word: "侵食", reading: "しんしょく", meaning: "encroachment, invasion, erosion (e.g. of market share, rights)" },
        { word: "侵入", reading: "しんにゅう", meaning: "invasion, incursion, raid" }
    ],
    },
    "信": {
        onyomi: ["シン"],
        kunyomi: [],
        examples: [
        { word: "威信", reading: "いしん", meaning: "prestige, dignity" },
        { word: "外信", reading: "がいしん", meaning: "external communication" },
        { word: "確信", reading: "かくしん", meaning: "conviction, belief, confidence" },
        { word: "交信", reading: "こうしん", meaning: "telecommunications, correspondence" }
    ],
    },
    "津": {
        onyomi: ["シン"],
        kunyomi: ["つ"],
        examples: [
        { word: "津波", reading: "つなみ", meaning: "tsunami, tidal wave" },
        { word: "興味津々", reading: "きょうみしんしん", meaning: "very interesting, of absorbing interest, having a keen interest (in)" }
    ],
    },
    "神": {
        onyomi: ["シン", "ジン"],
        kunyomi: ["かみ", "かん-", "こう-"],
        examples: [
        { word: "神輿", reading: "みこし", meaning: "mikoshi, portable Shinto shrine carried through the streets during festivals" },
        { word: "阪神", reading: "はんしん", meaning: "Osaka-Kobe" },
        { word: "氏神", reading: "うじがみ", meaning: "patron god, tutelar deity, guardian deity" },
        { word: "女神", reading: "めがみ", meaning: "goddess" }
    ],
    },
    "唇": {
        onyomi: ["シン"],
        kunyomi: ["くちびる"],
        examples: [
        { word: "下唇", reading: "したくちびる", meaning: "lower lip" },
        { word: "上唇", reading: "うわくちびる", meaning: "upper lip" },
        { word: "唇", reading: "くちびる", meaning: "lip, lips" }
    ],
    },
    "娠": {
        onyomi: ["シン"],
        kunyomi: [],
        examples: [
        { word: "妊娠", reading: "にんしん", meaning: "pregnancy, conception, gestation" }
    ],
    },
    "振": {
        onyomi: ["シン"],
        kunyomi: ["ふ.る", "ふ.れる", "ふ.るう"],
        examples: [
        { word: "三振", reading: "さんしん", meaning: "strikeout" },
        { word: "振り", reading: "ふり", meaning: "swing, shake, sweep" },
        { word: "振る", reading: "ふる", meaning: "to wave, to shake, to swing" },
        { word: "振興", reading: "しんこう", meaning: "promotion, encouragement" }
    ],
    },
    "浸": {
        onyomi: ["シン"],
        kunyomi: ["ひた.す", "ひた.る", "つ.かる"],
        examples: [
        { word: "浸す", reading: "ひたす", meaning: "to soak, to dip, to steep" },
        { word: "浸る", reading: "ひたる", meaning: "to be soaked in, to be flooded, to be submerged" },
        { word: "浸水", reading: "しんすい", meaning: "inundation, submersion, flood" },
        { word: "浸透", reading: "しんとう", meaning: "permeation (of thought, ideology, culture, etc.), infiltration (e.g. of ideas), spread" }
    ],
    },
    "真": {
        onyomi: ["シン"],
        kunyomi: ["ま", "ま-", "まこと"],
        examples: [
        { word: "写真", reading: "しゃしん", meaning: "photograph, photo, picture" },
        { word: "真意", reading: "しんい", meaning: "real intention, true motive, true meaning" },
        { word: "真価", reading: "しんか", meaning: "true value, real worth" },
        { word: "真夏", reading: "まなつ", meaning: "middle of summer, height of summer, midsummer" }
    ],
    },
    "針": {
        onyomi: ["シン"],
        kunyomi: ["はり"],
        examples: [
        { word: "指針", reading: "ししん", meaning: "needle (compass, gauge, etc.), hand (clock), indicator" },
        { word: "針金", reading: "はりがね", meaning: "wire" },
        { word: "方針", reading: "ほうしん", meaning: "policy, course, plan (of action)" },
        { word: "羅針盤", reading: "らしんばん", meaning: "compass" }
    ],
    },
    "深": {
        onyomi: ["シン"],
        kunyomi: ["ふか.い", "-ぶか.い", "ふか.まる", "ふか.める", "み-"],
        examples: [
        { word: "深い", reading: "ふかい", meaning: "deep" },
        { word: "深さ", reading: "ふかさ", meaning: "depth, profundity" },
        { word: "深み", reading: "ふかみ", meaning: "deep place, depths" },
        { word: "深海", reading: "しんかい", meaning: "deep sea, depths of the sea, ocean depths" }
    ],
    },
    "紳": {
        onyomi: ["シン"],
        kunyomi: [],
        examples: [
        { word: "紳士", reading: "しんし", meaning: "gentleman" },
        { word: "紳士協定", reading: "しんしきょうてい", meaning: "gentlemen's agreement" }
    ],
    },
    "進": {
        onyomi: ["シン"],
        kunyomi: ["すす.む", "すす.める"],
        examples: [
        { word: "勧進", reading: "かんじん", meaning: "temple solicitation" },
        { word: "急進", reading: "きゅうしん", meaning: "rapid progress, radical progress" },
        { word: "行進", reading: "こうしん", meaning: "march, parade" },
        { word: "昇進", reading: "しょうしん", meaning: "promotion, advancement, rising in rank" }
    ],
    },
    "森": {
        onyomi: ["シン"],
        kunyomi: ["もり"],
        examples: [
        { word: "森林", reading: "しんりん", meaning: "forest, woods" },
        { word: "森", reading: "もり", meaning: "forest" }
    ],
    },
    "診": {
        onyomi: ["シン"],
        kunyomi: ["み.る"],
        examples: [
        { word: "往診", reading: "おうしん", meaning: "doctor's visit, house call" },
        { word: "検診", reading: "けんしん", meaning: "medical examination (for a specific condition or disease), health screening" },
        { word: "診る", reading: "みる", meaning: "to examine (medically), to have a look at, to check (a patient's pulse)" },
        { word: "診察", reading: "しんさつ", meaning: "medical examination, checkup, consultation" }
    ],
    },
    "寝": {
        onyomi: ["シン"],
        kunyomi: ["ね.る", "ね.かす", "い.ぬ", "みたまや", "や.める"],
        examples: [
        { word: "就寝", reading: "しゅうしん", meaning: "going to bed, retiring (for the night)" },
        { word: "寝る", reading: "ねる", meaning: "to sleep (lying down)" },
        { word: "寝巻", reading: "ねまき", meaning: "nightclothes, nightwear, sleepwear" },
        { word: "寝顔", reading: "ねがお", meaning: "sleeping face" }
    ],
    },
    "慎": {
        onyomi: ["シン"],
        kunyomi: ["つつし.む", "つつ.ましい", "つつし", "つつし.み"],
        examples: [
        { word: "謹慎", reading: "きんしん", meaning: "self restraint, moderating one's own behavior, penitence" },
        { word: "慎重", reading: "しんちょう", meaning: "careful, cautious, prudent" },
        { word: "慎む", reading: "つつしむ", meaning: "to be careful, to be discreet" }
    ],
    },
    "新": {
        onyomi: ["シン"],
        kunyomi: ["あたら.しい", "あら.た", "あら-", "にい-"],
        examples: [
        { word: "維新", reading: "いしん", meaning: "reformation, revolution, renewal" },
        { word: "一新", reading: "いっしん", meaning: "complete change, reform, restoration" },
        { word: "改新", reading: "かいしん", meaning: "reformation" },
        { word: "革新", reading: "かくしん", meaning: "reform, innovation" }
    ],
    },
    "審": {
        onyomi: ["シン"],
        kunyomi: ["つまび.らか", "つぶさ.に"],
        examples: [
        { word: "一審", reading: "いっしん", meaning: "first instance, first trial" },
        { word: "再審", reading: "さいしん", meaning: "retrial, reopening of a case" },
        { word: "主審", reading: "しゅしん", meaning: "chief umpire, referee (soccer, boxing, etc.)" },
        { word: "審議", reading: "しんぎ", meaning: "deliberation, discussion, consideration" }
    ],
    },
    "震": {
        onyomi: ["シン"],
        kunyomi: ["ふる.う", "ふる.える", "ふる.わせる", "ふる.わす"],
        examples: [
        { word: "軽震", reading: "けいしん", meaning: "weak earthquake" },
        { word: "震源", reading: "しんげん", meaning: "hypocentre (of an earthquake), hypocenter, focus" },
        { word: "震災", reading: "しんさい", meaning: "earthquake disaster" },
        { word: "震度", reading: "しんど", meaning: "seismic intensity" }
    ],
    },
    "薪": {
        onyomi: ["シン"],
        kunyomi: ["たきぎ", "まき"],
        examples: [
        { word: "薪炭", reading: "しんたん", meaning: "wood and charcoal, fuel" },
        { word: "薪", reading: "まき", meaning: "piece(s) of firewood (esp. chopped or split from logs)" }
    ],
    },
    "親": {
        onyomi: ["シン"],
        kunyomi: ["おや", "おや-", "した.しい", "した.しむ"],
        examples: [
        { word: "近親", reading: "きんしん", meaning: "near relative" },
        { word: "懇親", reading: "こんしん", meaning: "friendship, intimacy" },
        { word: "親愛", reading: "しんあい", meaning: "deep affection" },
        { word: "親衛", reading: "しんえい", meaning: "monarch's guards" }
    ],
    },
    "人": {
        onyomi: ["ジン", "ニン"],
        kunyomi: ["ひと", "-り", "-と"],
        examples: [
        { word: "愛人", reading: "あいじん", meaning: "lover, mistress" },
        { word: "悪人", reading: "あくにん", meaning: "bad person, villain, scoundrel" },
        { word: "偉人", reading: "いじん", meaning: "great person, eminent figure" },
        { word: "恩人", reading: "おんじん", meaning: "benefactor, patron, person to whom one owes a great deal" }
    ],
    },
    "刃": {
        onyomi: ["ジン", "ニン"],
        kunyomi: ["は", "やいば", "き.る"],
        examples: [
        { word: "刃先", reading: "はさき", meaning: "edge of blade" },
        { word: "刃物", reading: "はもの", meaning: "edged tool, cutting instrument, knife" },
        { word: "刃渡り", reading: "はわたり", meaning: "length of a blade" },
        { word: "刃", reading: "は", meaning: "edge (of a knife or sword), blade" }
    ],
    },
    "仁": {
        onyomi: ["ジン", "ニ", "ニン"],
        kunyomi: [],
        examples: [
        { word: "仁義", reading: "じんぎ", meaning: "humanity and justice (esp. in Confucianism), virtue" },
        { word: "仁王", reading: "におう", meaning: "two Deva kings, guardian gods of Buddhism who stand at the entrance of a Buddhist temple" },
        { word: "仁", reading: "じん", meaning: "benevolence (esp. as a virtue of Confucianism), consideration, compassion" }
    ],
    },
    "尽": {
        onyomi: ["ジン", "サン"],
        kunyomi: ["つ.きる", "つ.くす", "つ.かす", "-づ.く", "-ず.く", "ことごと.く"],
        examples: [
        { word: "尽力", reading: "じんりょく", meaning: "efforts, exertion, endeavour" },
        { word: "尽きる", reading: "つきる", meaning: "to be used up, to be run out, to be exhausted" },
        { word: "尽くす", reading: "つくす", meaning: "to use up, to exhaust, to run out of" },
        { word: "無尽蔵", reading: "むじんぞう", meaning: "inexhaustible supply" }
    ],
    },
    "迅": {
        onyomi: ["ジン"],
        kunyomi: [],
        examples: [
        { word: "迅速", reading: "じんそく", meaning: "(very) quick, rapid, swift" }
    ],
    },
    "甚": {
        onyomi: ["ジン"],
        kunyomi: ["はなは.だ", "はなは.だしい"],
        examples: [
        { word: "甚だ", reading: "はなはだ", meaning: "very, greatly, extremely" },
        { word: "甚大", reading: "じんだい", meaning: "very great, enormous, serious" },
        { word: "激甚", reading: "げきじん", meaning: "intense, violent, severe" },
        { word: "甚だしい", reading: "はなはだしい", meaning: "extreme, excessive, terrible" }
    ],
    },
    "陣": {
        onyomi: ["ジン"],
        kunyomi: [],
        examples: [
        { word: "出陣", reading: "しゅつじん", meaning: "going into battle, departure for the front" },
        { word: "陣営", reading: "じんえい", meaning: "camp (supporters of a doctrine, party, etc.), faction (of a party)" },
        { word: "陣地", reading: "じんち", meaning: "encampment, position" },
        { word: "陣中", reading: "じんちゅう", meaning: "in camp, at the front" }
    ],
    },
    "尋": {
        onyomi: ["ジン"],
        kunyomi: ["たず.ねる", "ひろ"],
        examples: [
        { word: "尋常", reading: "じんじょう", meaning: "common, usual" },
        { word: "尋問", reading: "じんもん", meaning: "questioning, interrogation, examination (of a witness)" },
        { word: "尋ねる", reading: "たずねる", meaning: "to ask, to enquire, to inquire" },
        { word: "尋ね人", reading: "たずねびと", meaning: "missing person, wanted person" }
    ],
    },
    "腎": {
        onyomi: ["ジン"],
        kunyomi: [],
        examples: [
        { word: "腎臓", reading: "じんぞう", meaning: "kidney" }
    ],
    },
    "須": {
        onyomi: ["ス", "シュ"],
        kunyomi: ["すべから.く", "すべし", "ひげ", "まつ", "もち.いる", "もと.める"],
        examples: [
        { word: "必須", reading: "ひっす", meaning: "indispensable, essential, requisite" },
        { word: "必須条件", reading: "ひっすじょうけん", meaning: "essential condition" }
    ],
    },
    "図": {
        onyomi: ["ズ", "ト"],
        kunyomi: ["え", "はか.る"],
        examples: [
        { word: "意図", reading: "いと", meaning: "intention, aim, design" },
        { word: "企図", reading: "きと", meaning: "plan, project, scheme" },
        { word: "系図", reading: "けいず", meaning: "family tree, pedigree, genealogy" },
        { word: "構図", reading: "こうず", meaning: "composition (of painting), structural outline, compositional arrangement" }
    ],
    },
    "水": {
        onyomi: ["スイ"],
        kunyomi: ["みず", "みず-"],
        examples: [
        { word: "汚水", reading: "おすい", meaning: "filthy water, sewage" },
        { word: "下水", reading: "げすい", meaning: "drainage, ditch, gutter" },
        { word: "海水", reading: "かいすい", meaning: "seawater, saltwater" },
        { word: "渇水", reading: "かっすい", meaning: "water shortage" }
    ],
    },
    "吹": {
        onyomi: ["スイ"],
        kunyomi: ["ふ.く"],
        examples: [
        { word: "吹く", reading: "ふく", meaning: "to blow (of the wind)" },
        { word: "吹雪", reading: "ふぶき", meaning: "snow storm, blizzard" },
        { word: "息吹", reading: "いぶき", meaning: "breath" },
        { word: "吹き込む", reading: "ふきこむ", meaning: "to blow in (of wind, rain, etc.)" }
    ],
    },
    "垂": {
        onyomi: ["スイ"],
        kunyomi: ["た.れる", "た.らす", "た.れ", "-た.れ", "なんなんと.す"],
        examples: [
        { word: "懸垂", reading: "けんすい", meaning: "pull-up (exercise), chin-up, chinning" },
        { word: "垂直", reading: "すいちょく", meaning: "vertical" },
        { word: "垂らす", reading: "たらす", meaning: "to dribble, to spill" },
        { word: "垂れる", reading: "たれる", meaning: "to hang, to droop, to dangle" }
    ],
    },
    "炊": {
        onyomi: ["スイ"],
        kunyomi: ["た.く", "-だ.き"],
        examples: [
        { word: "雑炊", reading: "ぞうすい", meaning: "rice porridge made by simmering cooked rice in a seasoned broth, often containing vegetables, fish, etc. (usu. made from leftovers)" },
        { word: "自炊", reading: "じすい", meaning: "cooking for oneself, cooking one's own food, doing one's own cooking" },
        { word: "炊事", reading: "すいじ", meaning: "cooking, kitchen work" },
        { word: "炊く", reading: "たく", meaning: "to cook (grains, e.g. rice)" }
    ],
    },
    "帥": {
        onyomi: ["スイ"],
        kunyomi: [],
        examples: [
        { word: "元帥", reading: "げんすい", meaning: "(field) marshal, (fleet) admiral, general of the army" },
        { word: "総帥", reading: "そうすい", meaning: "commander-in-chief, leader, head of a group of companies" },
        { word: "統帥", reading: "とうすい", meaning: "supreme command, high command" }
    ],
    },
    "粋": {
        onyomi: ["スイ"],
        kunyomi: ["いき"],
        examples: [
        { word: "純粋", reading: "じゅんすい", meaning: "pure, true, genuine" },
        { word: "抜粋", reading: "ばっすい", meaning: "extract, excerpt, selection" },
        { word: "粋", reading: "いき", meaning: "chic, smart, stylish" }
    ],
    },
    "衰": {
        onyomi: ["スイ"],
        kunyomi: ["おとろ.える"],
        examples: [
        { word: "衰弱", reading: "すいじゃく", meaning: "weakness, debility, breakdown" },
        { word: "衰退", reading: "すいたい", meaning: "decline, degeneration, decay" },
        { word: "盛衰", reading: "せいすい", meaning: "rise and fall, ups and downs, welfare" },
        { word: "老衰", reading: "ろうすい", meaning: "senility, senile decay, infirmity (through age)" }
    ],
    },
    "推": {
        onyomi: ["スイ"],
        kunyomi: ["お.す"],
        examples: [
        { word: "推す", reading: "おす", meaning: "to recommend, to endorse (e.g. a candidate), to nominate" },
        { word: "推移", reading: "すいい", meaning: "transition, change, progress" },
        { word: "推計", reading: "すいけい", meaning: "estimate, estimation" },
        { word: "推奨", reading: "すいしょう", meaning: "recommendation, endorsement" }
    ],
    },
    "酔": {
        onyomi: ["スイ"],
        kunyomi: ["よ.う", "よ.い", "よ"],
        examples: [
        { word: "心酔", reading: "しんすい", meaning: "adoration, admiration" },
        { word: "酔う", reading: "よう", meaning: "to get drunk, to become intoxicated" },
        { word: "泥酔", reading: "でいすい", meaning: "being dead drunk, drunken stupor" },
        { word: "陶酔", reading: "とうすい", meaning: "intoxication" }
    ],
    },
    "遂": {
        onyomi: ["スイ"],
        kunyomi: ["と.げる", "つい.に"],
        examples: [
        { word: "完遂", reading: "かんすい", meaning: "successful execution, accomplishment, completion" },
        { word: "遂に", reading: "ついに", meaning: "finally, in the end, at last" },
        { word: "遂行", reading: "すいこう", meaning: "accomplishment, execution" },
        { word: "未遂", reading: "みすい", meaning: "failed attempt (at a crime, suicide, etc.)" }
    ],
    },
    "睡": {
        onyomi: ["スイ"],
        kunyomi: ["ねむ.る", "ねむ.い"],
        examples: [
        { word: "昏睡", reading: "こんすい", meaning: "coma" },
        { word: "熟睡", reading: "じゅくすい", meaning: "deep sleep, sound sleep, profound sleep" },
        { word: "睡眠", reading: "すいみん", meaning: "sleep" }
    ],
    },
    "穂": {
        onyomi: ["スイ"],
        kunyomi: ["ほ"],
        examples: [
        { word: "稲穂", reading: "いなほ", meaning: "ear (head) of rice" },
        { word: "穂", reading: "ほ", meaning: "ear (of a cereal plant), head, spike" }
    ],
    },
    "随": {
        onyomi: ["ズイ"],
        kunyomi: ["まにま.に", "したが.う"],
        examples: [
        { word: "随意", reading: "ずいい", meaning: "voluntary, optional, free" },
        { word: "随一", reading: "ずいいち", meaning: "best, greatest, first" },
        { word: "随時", reading: "ずいじ", meaning: "whenever necessary, as needed, as required" },
        { word: "随所", reading: "ずいしょ", meaning: "everywhere, all over the place, here and there" }
    ],
    },
    "髄": {
        onyomi: ["ズイ"],
        kunyomi: [],
        examples: [
        { word: "骨髄", reading: "こつずい", meaning: "bone marrow, medulla" },
        { word: "真髄", reading: "しんずい", meaning: "essence, quintessence, spirit" },
        { word: "神髄", reading: "しんずい", meaning: "essence, quintessence, spirit" },
        { word: "脊髄", reading: "せきずい", meaning: "spinal cord" }
    ],
    },
    "枢": {
        onyomi: ["スウ", "シュ"],
        kunyomi: ["とぼそ", "からくり"],
        examples: [
        { word: "枢軸", reading: "すうじく", meaning: "axle, pivot" },
        { word: "中枢", reading: "ちゅうすう", meaning: "centre, center, pivot" }
    ],
    },
    "崇": {
        onyomi: ["スウ"],
        kunyomi: ["あが.める"],
        examples: [
        { word: "崇高", reading: "すうこう", meaning: "lofty, sublime, noble" },
        { word: "崇拝", reading: "すうはい", meaning: "worship, adoration, admiration" }
    ],
    },
    "数": {
        onyomi: ["スウ", "ス", "サク", "ソク", "シュ"],
        kunyomi: ["かず", "かぞ.える", "しばしば", "せ.める", "わずらわ.しい"],
        examples: [
        { word: "員数", reading: "いんずう", meaning: "(total) number (of people or things), count, quota" },
        { word: "画数", reading: "かくすう", meaning: "stroke count (of a kanji)" },
        { word: "回数", reading: "かいすう", meaning: "number of times, frequency, count" },
        { word: "奇数", reading: "きすう", meaning: "odd number" }
    ],
    },
    "据": {
        onyomi: ["キョ"],
        kunyomi: ["す.える", "す.わる"],
        examples: [
        { word: "据える", reading: "すえる", meaning: "to place (in position), to fix, to set (e.g. table)" },
        { word: "据え置き", reading: "すえおき", meaning: "deferment (e.g. of savings), leaving (something) as it stands" },
        { word: "据え付ける", reading: "すえつける", meaning: "to install, to equip, to mount" }
    ],
    },
    "杉": {
        onyomi: ["サン"],
        kunyomi: ["すぎ"],
        examples: [
        { word: "杉", reading: "すぎ", meaning: "Japanese cedar (Cryptomeria japonica)" }
    ],
    },
    "裾": {
        onyomi: ["キョ", "コ"],
        kunyomi: ["すそ"],
        examples: [
        { word: "裾", reading: "すそ", meaning: "hem, (trouser) cuff, shirttail" }
    ],
    },
    "寸": {
        onyomi: ["スン"],
        kunyomi: [],
        examples: [
        { word: "寸暇", reading: "すんか", meaning: "moment's leisure, free minute" },
        { word: "寸前", reading: "すんぜん", meaning: "just before, on the verge of, on the brink of" },
        { word: "寸断", reading: "すんだん", meaning: "cutting to pieces, tearing to pieces" },
        { word: "寸法", reading: "すんぽう", meaning: "measurement, size, extent" }
    ],
    },
    "瀬": {
        onyomi: ["ライ"],
        kunyomi: ["せ"],
        examples: [
        { word: "瀬戸", reading: "せと", meaning: "strait, channel" },
        { word: "浅瀬", reading: "あさせ", meaning: "shoal, shallows, sand bar" },
        { word: "早瀬", reading: "はやせ", meaning: "swift current, rapids" },
        { word: "高瀬", reading: "たかせ", meaning: "shallow river, shallows" }
    ],
    },
    "是": {
        onyomi: ["ゼ", "シ"],
        kunyomi: ["これ", "この", "ここ"],
        examples: [
        { word: "国是", reading: "こくぜ", meaning: "national policy" },
        { word: "是正", reading: "ぜせい", meaning: "correction, revision, redressing" },
        { word: "是認", reading: "ぜにん", meaning: "approval, approbation, endorsement" },
        { word: "是非", reading: "ぜひ", meaning: "certainly, without fail" }
    ],
    },
    "井": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["い"],
        examples: [
        { word: "井戸", reading: "いど", meaning: "water well" },
        { word: "天井", reading: "てんじょう", meaning: "ceiling" },
        { word: "油井", reading: "ゆせい", meaning: "oil well" },
        { word: "筒井", reading: "つつい", meaning: "round well" }
    ],
    },
    "世": {
        onyomi: ["セイ", "セ", "ソウ"],
        kunyomi: ["よ"],
        examples: [
        { word: "近世", reading: "きんせい", meaning: "recent past, recent times" },
        { word: "後世", reading: "こうせい", meaning: "posterity, future generations, future life" },
        { word: "出世", reading: "しゅっせ", meaning: "success in life, getting ahead, successful career" },
        { word: "世界", reading: "せかい", meaning: "the world, society, the universe" }
    ],
    },
    "正": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["ただ.しい", "ただ.す", "まさ", "まさ.に"],
        examples: [
        { word: "賀正", reading: "がしょう", meaning: "A Happy New Year!" },
        { word: "改正", reading: "かいせい", meaning: "revision, amendment, alteration" },
        { word: "矯正", reading: "きょうせい", meaning: "correction (of a fault, defect, flaw, etc.), remedy, rectification" },
        { word: "公正", reading: "こうせい", meaning: "justice, fairness, impartiality" }
    ],
    },
    "生": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["い.きる", "い.かす", "い.ける", "う.まれる", "うま.れる", "う.まれ", "うまれ", "う.む", "お.う", "は.える", "は.やす", "き", "なま", "なま-", "な.る", "な.す", "む.す", "-う"],
        examples: [
        { word: "衛生", reading: "えいせい", meaning: "hygiene, sanitation, cleanliness" },
        { word: "往生", reading: "おうじょう", meaning: "passing on to the next life" },
        { word: "回生", reading: "かいせい", meaning: "resurrection, resuscitation, coming back to life" },
        { word: "学生", reading: "がくせい", meaning: "student (esp. a university student)" }
    ],
    },
    "成": {
        onyomi: ["セイ", "ジョウ"],
        kunyomi: ["な.る", "な.す", "-な.す"],
        examples: [
        { word: "成す", reading: "なす", meaning: "to form, to make, to constitute" },
        { word: "化成", reading: "かせい", meaning: "change, transformation" },
        { word: "完成", reading: "かんせい", meaning: "completion, perfection, accomplishment" },
        { word: "既成", reading: "きせい", meaning: "established, existing, accomplished" }
    ],
    },
    "西": {
        onyomi: ["セイ", "サイ", "ス"],
        kunyomi: ["にし"],
        examples: [
        { word: "関西", reading: "かんさい", meaning: "Kansai (region comprising Kyoto, Osaka, Kobe and surrounding prefectures)" },
        { word: "西瓜", reading: "すいか", meaning: "watermelon (Citrullus lanatus)" },
        { word: "西欧", reading: "せいおう", meaning: "Western Europe" },
        { word: "西口", reading: "にしぐち", meaning: "west entrance, west exit" }
    ],
    },
    "声": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["こえ", "こわ-"],
        examples: [
        { word: "音声", reading: "おんせい", meaning: "voice, speech" },
        { word: "歓声", reading: "かんせい", meaning: "cheer, shout of joy" },
        { word: "銃声", reading: "じゅうせい", meaning: "sound of a gunshot, report of a gun" },
        { word: "声援", reading: "せいえん", meaning: "(shout of) encouragement, cheering, rooting" }
    ],
    },
    "制": {
        onyomi: ["セイ"],
        kunyomi: [],
        examples: [
        { word: "管制", reading: "かんせい", meaning: "control (by the state), controlling, coordination" },
        { word: "規制", reading: "きせい", meaning: "regulation, (traffic) policing, control" },
        { word: "旧制", reading: "きゅうせい", meaning: "old system, old order" },
        { word: "強制", reading: "きょうせい", meaning: "compulsion, coercion, forcing (to do)" }
    ],
    },
    "姓": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: [],
        examples: [
        { word: "旧姓", reading: "きゅうせい", meaning: "one's original family name, maiden name" },
        { word: "姓名", reading: "せいめい", meaning: "(full) name, family name and given name" },
        { word: "同姓", reading: "どうせい", meaning: "same surname" },
        { word: "百姓", reading: "ひゃくしょう", meaning: "farmer, peasant, farm laborer" }
    ],
    },
    "征": {
        onyomi: ["セイ"],
        kunyomi: [],
        examples: [
        { word: "遠征", reading: "えんせい", meaning: "(military) expedition, campaign" },
        { word: "出征", reading: "しゅっせい", meaning: "going to war, departure for the front" },
        { word: "征服", reading: "せいふく", meaning: "conquest, subjugation" }
    ],
    },
    "性": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["さが"],
        examples: [
        { word: "悪性", reading: "あくせい", meaning: "malignant (cancer), virulent, pernicious (anemia, anaemia)" },
        { word: "異性", reading: "いせい", meaning: "the opposite sex" },
        { word: "陰性", reading: "いんせい", meaning: "negative (result)" },
        { word: "活性", reading: "かっせい", meaning: "activity" }
    ],
    },
    "青": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["あお", "あお-", "あお.い"],
        examples: [
        { word: "青い", reading: "あおい", meaning: "blue, azure" },
        { word: "青果", reading: "せいか", meaning: "fruits and vegetables, produce" },
        { word: "青空", reading: "あおぞら", meaning: "blue sky" },
        { word: "青酸", reading: "せいさん", meaning: "hydrocyanic acid, prussic acid, hydrogen cyanide" }
    ],
    },
    "斉": {
        onyomi: ["セイ", "サイ"],
        kunyomi: ["そろ.う", "ひと.しい", "ひと.しく", "あたる", "はやい"],
        examples: [
        { word: "一斉", reading: "いっせい", meaning: "simultaneous, all at once" },
        { word: "斉唱", reading: "せいしょう", meaning: "singing in unison, chanting in unison" },
        { word: "一斉に", reading: "いっせいに", meaning: "simultaneously, all at once, in unison" }
    ],
    },
    "政": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["まつりごと", "まん"],
        examples: [
        { word: "家政", reading: "かせい", meaning: "household economy, housekeeping, homemaking" },
        { word: "軍政", reading: "ぐんせい", meaning: "military administration, military government, military junta" },
        { word: "憲政", reading: "けんせい", meaning: "constitutional government" },
        { word: "行政", reading: "ぎょうせい", meaning: "executive, government" }
    ],
    },
    "星": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["ほし", "-ぼし"],
        examples: [
        { word: "衛星", reading: "えいせい", meaning: "(natural) satellite, moon" },
        { word: "火星", reading: "かせい", meaning: "Mars (planet)" },
        { word: "巨星", reading: "きょせい", meaning: "giant star" },
        { word: "暁星", reading: "ぎょうせい", meaning: "morning star, Venus, rarity" }
    ],
    },
    "牲": {
        onyomi: ["セイ"],
        kunyomi: [],
        examples: [
        { word: "犠牲", reading: "ぎせい", meaning: "sacrifice" },
        { word: "犠牲者", reading: "ぎせいしゃ", meaning: "victim (esp. someone killed), casualty" }
    ],
    },
    "省": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["かえり.みる", "はぶ.く"],
        examples: [
        { word: "帰省", reading: "きせい", meaning: "homecoming, returning home" },
        { word: "三省", reading: "さんせい", meaning: "frequent reflection, frequent meditation" },
        { word: "自省", reading: "じせい", meaning: "self-examination, reflection" },
        { word: "省く", reading: "はぶく", meaning: "to omit, to leave out, to exclude" }
    ],
    },
    "凄": {
        onyomi: ["セイ", "サイ"],
        kunyomi: ["さむ.い", "すご.い", "すさ.まじい"],
        examples: [
        { word: "凄い", reading: "すごい", meaning: "terrible, dreadful" },
        { word: "物凄い", reading: "ものすごい", meaning: "terrific, staggering, tremendous" },
        { word: "凄まじい", reading: "すさまじい", meaning: "terrible, dreadful, awful" }
    ],
    },
    "逝": {
        onyomi: ["セイ"],
        kunyomi: ["ゆ.く", "い.く"],
        examples: [
        { word: "急逝", reading: "きゅうせい", meaning: "sudden death, unexpected death" },
        { word: "逝去", reading: "せいきょ", meaning: "death, passing" }
    ],
    },
    "清": {
        onyomi: ["セイ", "ショウ", "シン"],
        kunyomi: ["きよ.い", "きよ.まる", "きよ.める"],
        examples: [
        { word: "粛清", reading: "しゅくせい", meaning: "(political) purge" },
        { word: "清い", reading: "きよい", meaning: "clean, clear" },
        { word: "清潔", reading: "せいけつ", meaning: "clean, hygienic, sanitary" },
        { word: "清算", reading: "せいさん", meaning: "(financial) settlement, squaring accounts, clearing debts" }
    ],
    },
    "盛": {
        onyomi: ["セイ", "ジョウ"],
        kunyomi: ["も.る", "さか.る", "さか.ん"],
        examples: [
        { word: "旺盛", reading: "おうせい", meaning: "lively, vigorous, energetic" },
        { word: "盛り", reading: "さかり", meaning: "height (e.g. of summer), peak (e.g. of cherry blossom season), (in) season" },
        { word: "盛る", reading: "もる", meaning: "to serve (in a bowl, on a plate, etc.), to dish out, to dish up" },
        { word: "盛ん", reading: "さかん", meaning: "prosperous, flourishing, thriving" }
    ],
    },
    "婿": {
        onyomi: ["セイ"],
        kunyomi: ["むこ"],
        examples: [
        { word: "花婿", reading: "はなむこ", meaning: "bridegroom" },
        { word: "娘婿", reading: "むすめむこ", meaning: "son-in-law" },
        { word: "婿", reading: "むこ", meaning: "husband, groom" }
    ],
    },
    "晴": {
        onyomi: ["セイ"],
        kunyomi: ["は.れる", "は.れ", "は.れ-", "-ば.れ", "は.らす"],
        examples: [
        { word: "快晴", reading: "かいせい", meaning: "clear weather, cloudless weather, good weather" },
        { word: "晴れ", reading: "はれ", meaning: "clear weather, fine weather" },
        { word: "晴天", reading: "せいてん", meaning: "fine weather (i.e. little or no clouds), fair weather, clear weather" },
        { word: "晴らす", reading: "はらす", meaning: "to dispel, to clear away, to refresh (oneself)" }
    ],
    },
    "勢": {
        onyomi: ["セイ", "ゼイ"],
        kunyomi: ["いきお.い", "はずみ"],
        examples: [
        { word: "威勢", reading: "いせい", meaning: "power, might, authority" },
        { word: "気勢", reading: "きせい", meaning: "fervour, fervor, vigour" },
        { word: "形勢", reading: "けいせい", meaning: "condition, situation, prospects" },
        { word: "攻勢", reading: "こうせい", meaning: "offensive (movement), aggression" }
    ],
    },
    "聖": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["ひじり"],
        examples: [
        { word: "神聖", reading: "しんせい", meaning: "holiness, sacredness, sanctity" },
        { word: "聖域", reading: "せいいき", meaning: "sacred precincts, sanctuary, consecrated ground" },
        { word: "聖書", reading: "せいしょ", meaning: "Bible, the Scriptures, Holy Writ" },
        { word: "聖人", reading: "せいじん", meaning: "saint" }
    ],
    },
    "誠": {
        onyomi: ["セイ"],
        kunyomi: ["まこと"],
        examples: [
        { word: "誠に", reading: "まことに", meaning: "really, truly, very" },
        { word: "誠意", reading: "せいい", meaning: "sincerity, good faith" },
        { word: "誠実", reading: "せいじつ", meaning: "sincere, honest, faithful" },
        { word: "丹誠", reading: "たんせい", meaning: "working earnestly, sincerity, diligence" }
    ],
    },
    "精": {
        onyomi: ["セイ", "ショウ"],
        kunyomi: ["しら.げる", "くわ.しい"],
        examples: [
        { word: "射精", reading: "しゃせい", meaning: "ejaculation" },
        { word: "精鋭", reading: "せいえい", meaning: "elite, best, pick" },
        { word: "精液", reading: "せいえき", meaning: "semen, seminal fluid, sperm" },
        { word: "精巧", reading: "せいこう", meaning: "elaborate, delicate, exquisite" }
    ],
    },
    "製": {
        onyomi: ["セイ"],
        kunyomi: [],
        examples: [
        { word: "既製", reading: "きせい", meaning: "ready-made, off the shelf" },
        { word: "作製", reading: "さくせい", meaning: "manufacture, production" },
        { word: "手製", reading: "てせい", meaning: "handmade, homemade" },
        { word: "精製", reading: "せいせい", meaning: "refining, purification" }
    ],
    },
    "誓": {
        onyomi: ["セイ"],
        kunyomi: ["ちか.う"],
        examples: [
        { word: "誓い", reading: "ちかい", meaning: "oath, vow" },
        { word: "誓う", reading: "ちかう", meaning: "to swear, to vow, to take an oath" },
        { word: "誓約", reading: "せいやく", meaning: "oath, vow, pledge" },
        { word: "宣誓", reading: "せんせい", meaning: "oath, abjuration, pledge" }
    ],
    },
    "静": {
        onyomi: ["セイ", "ジョウ"],
        kunyomi: ["しず-", "しず.か", "しず.まる", "しず.める"],
        examples: [
        { word: "安静", reading: "あんせい", meaning: "rest, quiet, repose" },
        { word: "閑静", reading: "かんせい", meaning: "quiet (e.g. neighbourhood), peaceful, tranquil" },
        { word: "静か", reading: "しずか", meaning: "quiet, silent" },
        { word: "静観", reading: "せいかん", meaning: "watchful waiting, careful supervision" }
    ],
    },
    "請": {
        onyomi: ["セイ", "シン", "ショウ"],
        kunyomi: ["こ.う", "う.ける"],
        examples: [
        { word: "申請", reading: "しんせい", meaning: "application, request, petition" },
        { word: "請願", reading: "せいがん", meaning: "petition" },
        { word: "請求", reading: "せいきゅう", meaning: "claim, demand, charge" },
        { word: "要請", reading: "ようせい", meaning: "appeal, call for something, request" }
    ],
    },
    "整": {
        onyomi: ["セイ"],
        kunyomi: ["ととの.える", "ととの.う"],
        examples: [
        { word: "均整", reading: "きんせい", meaning: "symmetry, balance, proportion" },
        { word: "整合", reading: "せいごう", meaning: "adjustment, coordination, integration" },
        { word: "整数", reading: "せいすう", meaning: "integer" },
        { word: "整頓", reading: "せいとん", meaning: "orderliness, put in order, tidying up" }
    ],
    },
    "醒": {
        onyomi: ["セイ"],
        kunyomi: ["さ.ます", "さ.める"],
        examples: [
        { word: "覚醒", reading: "かくせい", meaning: "waking up, awakening, arousal" },
        { word: "覚醒剤", reading: "かくせいざい", meaning: "stimulant (e.g. psychoactive drugs like methamphetamine, ritalin, etc.)" }
    ],
    },
    "税": {
        onyomi: ["ゼイ"],
        kunyomi: [],
        examples: [
        { word: "印税", reading: "いんぜい", meaning: "royalty (on book)" },
        { word: "課税", reading: "かぜい", meaning: "taxation" },
        { word: "関税", reading: "かんぜい", meaning: "customs (duties), duty, tariff" },
        { word: "減税", reading: "げんぜい", meaning: "tax reduction" }
    ],
    },
    "夕": {
        onyomi: ["セキ"],
        kunyomi: ["ゆう"],
        examples: [
        { word: "朝夕", reading: "あさゆう", meaning: "morning and evening" },
        { word: "夕刊", reading: "ゆうかん", meaning: "evening edition (of a daily newspaper), evening paper" },
        { word: "夕刻", reading: "ゆうこく", meaning: "evening, evening hour" },
        { word: "夕食", reading: "ゆうしょく", meaning: "evening meal, dinner" }
    ],
    },
    "斥": {
        onyomi: ["セキ"],
        kunyomi: ["しりぞ.ける"],
        examples: [
        { word: "排斥", reading: "はいせき", meaning: "rejection, expulsion, boycott" }
    ],
    },
    "石": {
        onyomi: ["セキ", "シャク", "コク"],
        kunyomi: ["いし"],
        examples: [
        { word: "一石", reading: "いっせき", meaning: "one game (of go)" },
        { word: "化石", reading: "かせき", meaning: "fossil" },
        { word: "岩石", reading: "がんせき", meaning: "rock" },
        { word: "鉱石", reading: "こうせき", meaning: "ore, mineral, crystal" }
    ],
    },
    "赤": {
        onyomi: ["セキ", "シャク"],
        kunyomi: ["あか", "あか-", "あか.い", "あか.らむ", "あか.らめる"],
        examples: [
        { word: "赤い", reading: "あかい", meaning: "red, crimson, scarlet" },
        { word: "赤軍", reading: "せきぐん", meaning: "Red Army (Soviet Union, 1918-1946), Workers' and Peasants' Red Army" },
        { word: "赤字", reading: "あかじ", meaning: "(being in) the red, deficit" },
        { word: "赤道", reading: "せきどう", meaning: "equator" }
    ],
    },
    "昔": {
        onyomi: ["セキ", "シャク"],
        kunyomi: ["むかし"],
        examples: [
        { word: "一昔", reading: "ひとむかし", meaning: "an age (ago), a long time (ago), a decade (ago)" },
        { word: "昔話", reading: "むかしばなし", meaning: "old tale, folk tale, legend" },
        { word: "大昔", reading: "おおむかし", meaning: "ancient times, prehistoric times, the distant past" },
        { word: "今昔", reading: "こんじゃく", meaning: "past and present" }
    ],
    },
    "析": {
        onyomi: ["セキ"],
        kunyomi: [],
        examples: [
        { word: "解析", reading: "かいせき", meaning: "analysis, analytical study" },
        { word: "分析", reading: "ぶんせき", meaning: "analysis" },
        { word: "透析", reading: "とうせき", meaning: "dialysis" }
    ],
    },
    "席": {
        onyomi: ["セキ"],
        kunyomi: ["むしろ"],
        examples: [
        { word: "宴席", reading: "えんせき", meaning: "banquet, dinner party" },
        { word: "寄席", reading: "よせ", meaning: "entertainment hall (for rakugo, manzai, magic, music, etc.), vaudeville theater (theatre), music hall" },
        { word: "議席", reading: "ぎせき", meaning: "parliamentary seat" },
        { word: "客席", reading: "きゃくせき", meaning: "guest seating (e.g. theater, stadium), passenger seat (e.g. taxi)" }
    ],
    },
    "脊": {
        onyomi: ["セキ"],
        kunyomi: ["せ", "せい"],
        examples: [
        { word: "脊髄", reading: "せきずい", meaning: "spinal cord" }
    ],
    },
    "隻": {
        onyomi: ["セキ"],
        kunyomi: [],
        examples: [
        { word: "一隻", reading: "いっせき", meaning: "one boat, one ship" },
        { word: "数隻", reading: "すうせき", meaning: "several (boats)" },
        { word: "隻眼", reading: "せきがん", meaning: "one eye" },
        { word: "隻手", reading: "せきしゅ", meaning: "one hand, one arm" }
    ],
    },
    "惜": {
        onyomi: ["セキ"],
        kunyomi: ["お.しい", "お.しむ"],
        examples: [
        { word: "惜敗", reading: "せきはい", meaning: "regrettable defeat, defeat by a narrow margin" },
        { word: "惜しい", reading: "おしい", meaning: "regrettable, disappointing, unfortunate" },
        { word: "惜しむ", reading: "おしむ", meaning: "to spare, to grudge, to be sparing (with)" },
        { word: "名残惜しい", reading: "なごりおしい", meaning: "reluctant (to part)" }
    ],
    },
    "戚": {
        onyomi: ["ソク", "セキ"],
        kunyomi: ["いた.む", "うれ.える", "みうち"],
        examples: [
        { word: "親戚", reading: "しんせき", meaning: "relative, relation, kin" }
    ],
    },
    "責": {
        onyomi: ["セキ"],
        kunyomi: ["せ.める"],
        examples: [
        { word: "引責", reading: "いんせき", meaning: "taking responsibility" },
        { word: "自責", reading: "じせき", meaning: "self-condemnation, self-reproach, self-accusation" },
        { word: "重責", reading: "じゅうせき", meaning: "heavy responsibility" },
        { word: "責任", reading: "せきにん", meaning: "duty, responsibility (incl. supervision of staff)" }
    ],
    },
    "跡": {
        onyomi: ["セキ"],
        kunyomi: ["あと"],
        examples: [
        { word: "遺跡", reading: "いせき", meaning: "(archeological) remains, ruins, relics" },
        { word: "軌跡", reading: "きせき", meaning: "tire track" },
        { word: "形跡", reading: "けいせき", meaning: "traces, evidence" },
        { word: "痕跡", reading: "こんせき", meaning: "trace, vestige, mark" }
    ],
    },
    "積": {
        onyomi: ["セキ"],
        kunyomi: ["つ.む", "-づ.み", "つ.もる", "つ.もり"],
        examples: [
        { word: "集積", reading: "しゅうせき", meaning: "accumulation" },
        { word: "積立", reading: "つみたて", meaning: "saving, savings, accumulation" },
        { word: "積む", reading: "つむ", meaning: "to pile up, to stack" },
        { word: "積極", reading: "せっきょく", meaning: "active, positive, progressive" }
    ],
    },
    "績": {
        onyomi: ["セキ"],
        kunyomi: [],
        examples: [
        { word: "業績", reading: "ぎょうせき", meaning: "achievement, performance, results" },
        { word: "功績", reading: "こうせき", meaning: "achievement, meritorious deed, distinguished service" },
        { word: "実績", reading: "じっせき", meaning: "achievements, actual results, accomplishments" },
        { word: "成績", reading: "せいせき", meaning: "results, record, grades" }
    ],
    },
    "籍": {
        onyomi: ["セキ"],
        kunyomi: [],
        examples: [
        { word: "移籍", reading: "いせき", meaning: "transfer (of one's name into another family register)" },
        { word: "戸籍", reading: "こせき", meaning: "family register" },
        { word: "国籍", reading: "こくせき", meaning: "nationality, citizenship" },
        { word: "在籍", reading: "ざいせき", meaning: "being enrolled (at a school), being registered, being a member (of a team, organization, etc.)" }
    ],
    },
    "切": {
        onyomi: ["セツ", "サイ"],
        kunyomi: ["き.る", "-き.る", "き.り", "-き.り", "-ぎ.り", "き.れる", "-き.れる", "き.れ", "-き.れ", "-ぎ.れ"],
        examples: [
        { word: "一切", reading: "いっさい", meaning: "all, everything, entirety" },
        { word: "懇切", reading: "こんせつ", meaning: "kind and careful (instruction, explanation, etc.), considerate, helpful" },
        { word: "親切", reading: "しんせつ", meaning: "kind, gentle, considerate" },
        { word: "切り", reading: "きり", meaning: "end, finish, place to stop" }
    ],
    },
    "折": {
        onyomi: ["セツ", "シャク"],
        kunyomi: ["お.る", "おり", "お.り", "-お.り", "お.れる"],
        examples: [
        { word: "右折", reading: "うせつ", meaning: "turning to the right, right turn" },
        { word: "曲折", reading: "きょくせつ", meaning: "bending, winding, meandering" },
        { word: "屈折", reading: "くっせつ", meaning: "bending, curving, twisting" },
        { word: "骨折", reading: "こっせつ", meaning: "bone fracture" }
    ],
    },
    "拙": {
        onyomi: ["セツ"],
        kunyomi: ["つたな.い"],
        examples: [
        { word: "巧拙", reading: "こうせつ", meaning: "skill, workmanship, dexterity" },
        { word: "拙速", reading: "せっそく", meaning: "rough-and-ready, knocked-up, hasty" },
        { word: "拙劣", reading: "せつれつ", meaning: "clumsy, unskillful" },
        { word: "稚拙", reading: "ちせつ", meaning: "unskillful, childish, immature" }
    ],
    },
    "窃": {
        onyomi: ["セツ"],
        kunyomi: ["ぬす.む", "ひそ.か"],
        examples: [
        { word: "窃盗", reading: "せっとう", meaning: "theft, stealing, larceny" }
    ],
    },
    "接": {
        onyomi: ["セツ", "ショウ"],
        kunyomi: ["つ.ぐ"],
        examples: [
        { word: "応接", reading: "おうせつ", meaning: "reception (e.g. of visitors), dealing with" },
        { word: "間接", reading: "かんせつ", meaning: "indirection, indirectness" },
        { word: "接近", reading: "せっきん", meaning: "getting closer, drawing nearer, approaching" },
        { word: "接見", reading: "せっけん", meaning: "(official) audience, interview, reception" }
    ],
    },
    "設": {
        onyomi: ["セツ"],
        kunyomi: ["もう.ける"],
        examples: [
        { word: "架設", reading: "かせつ", meaning: "construction, building" },
        { word: "開設", reading: "かいせつ", meaning: "establishment, opening, setting up" },
        { word: "建設", reading: "けんせつ", meaning: "construction, establishment" },
        { word: "公設", reading: "こうせつ", meaning: "public (institution)" }
    ],
    },
    "雪": {
        onyomi: ["セツ"],
        kunyomi: ["ゆき"],
        examples: [
        { word: "降雪", reading: "こうせつ", meaning: "snowfall, snow" },
        { word: "初雪", reading: "はつゆき", meaning: "first snow (of the season), first snowfall" },
        { word: "新雪", reading: "しんせつ", meaning: "fresh snow, new snow" },
        { word: "吹雪", reading: "ふぶき", meaning: "snow storm, blizzard" }
    ],
    },
    "摂": {
        onyomi: ["セツ", "ショウ"],
        kunyomi: ["おさ.める", "かね.る", "と.る"],
        examples: [
        { word: "摂氏", reading: "せっし", meaning: "Celsius, centigrade" },
        { word: "摂取", reading: "せっしゅ", meaning: "intake (e.g. of salt), ingestion" },
        { word: "摂理", reading: "せつり", meaning: "laws (of nature)" },
        { word: "摂る", reading: "とる", meaning: "to have (e.g. lunch), to take (e.g. vitamins)" }
    ],
    },
    "節": {
        onyomi: ["セツ", "セチ"],
        kunyomi: ["ふし", "-ぶし", "のっと"],
        examples: [
        { word: "関節", reading: "かんせつ", meaning: "joint" },
        { word: "季節", reading: "きせつ", meaning: "season, time of year" },
        { word: "使節", reading: "しせつ", meaning: "envoy, ambassador, delegate" },
        { word: "時節", reading: "じせつ", meaning: "season" }
    ],
    },
    "説": {
        onyomi: ["セツ", "ゼイ"],
        kunyomi: ["と.く"],
        examples: [
        { word: "演説", reading: "えんぜつ", meaning: "speech, address" },
        { word: "解説", reading: "かいせつ", meaning: "explanation, commentary, exposition" },
        { word: "学説", reading: "がくせつ", meaning: "theory" },
        { word: "逆説", reading: "ぎゃくせつ", meaning: "paradox" }
    ],
    },
    "舌": {
        onyomi: ["ゼツ"],
        kunyomi: ["した"],
        examples: [
        { word: "舌戦", reading: "ぜっせん", meaning: "war of words" },
        { word: "毒舌", reading: "どくぜつ", meaning: "wicked tongue, sharp tongue, abusive language" },
        { word: "猫舌", reading: "ねこじた", meaning: "dislike of very hot food or drink, inability to take hot food, cat tongue" },
        { word: "弁舌", reading: "べんぜつ", meaning: "speech, eloquence, manner of speaking" }
    ],
    },
    "絶": {
        onyomi: ["ゼツ"],
        kunyomi: ["た.える", "た.やす", "た.つ"],
        examples: [
        { word: "気絶", reading: "きぜつ", meaning: "faint, fainting, losing consciousness" },
        { word: "拒絶", reading: "きょぜつ", meaning: "refusal, rejection" },
        { word: "根絶", reading: "こんぜつ", meaning: "eradication, extermination, rooting out" },
        { word: "絶縁", reading: "ぜつえん", meaning: "breaking off relations (with), severing one's connections (with), breaking with (e.g. one's past)" }
    ],
    },
    "千": {
        onyomi: ["セン"],
        kunyomi: ["ち"],
        examples: [
        { word: "一千", reading: "いっせん", meaning: "1,000, one thousand" },
        { word: "何千", reading: "なんぜん", meaning: "many thousands" },
        { word: "三千", reading: "さんぜん", meaning: "3000, three thousand" },
        { word: "数千", reading: "すうせん", meaning: "thousands, several thousand" }
    ],
    },
    "川": {
        onyomi: ["セン"],
        kunyomi: ["かわ"],
        examples: [
        { word: "河川", reading: "かせん", meaning: "rivers" },
        { word: "山川", reading: "さんせん", meaning: "mountains and rivers" },
        { word: "小川", reading: "おがわ", meaning: "stream, brook, creek" },
        { word: "川下", reading: "かわしも", meaning: "downstream" }
    ],
    },
    "仙": {
        onyomi: ["セン", "セント"],
        kunyomi: [],
        examples: [
        { word: "水仙", reading: "すいせん", meaning: "daffodil (esp. Narcissus tazetta var. chinensis), narcissus" },
        { word: "仙人", reading: "せんにん", meaning: "immortal mountain wizard (in Taoism), mountain man (esp. a hermit)" },
        { word: "仙台", reading: "せんだい", meaning: "Sendai (city in Miyagi)" }
    ],
    },
    "占": {
        onyomi: ["セン"],
        kunyomi: ["し.める", "うらな.う"],
        examples: [
        { word: "寡占", reading: "かせん", meaning: "oligopoly, control of a market" },
        { word: "占い", reading: "うらない", meaning: "fortune-telling, divination" },
        { word: "占う", reading: "うらなう", meaning: "to tell someone's fortune, to divine (the future)" },
        { word: "占拠", reading: "せんきょ", meaning: "occupation, taking and maintaining exclusive control (of a location)" }
    ],
    },
    "先": {
        onyomi: ["セン"],
        kunyomi: ["さき", "ま.ず"],
        examples: [
        { word: "軒先", reading: "のきさき", meaning: "edge of the eaves, house frontage" },
        { word: "口先", reading: "くちさき", meaning: "lip service, mere words, professions" },
        { word: "指先", reading: "ゆびさき", meaning: "fingertip, finger" },
        { word: "春先", reading: "はるさき", meaning: "beginning of spring" }
    ],
    },
    "宣": {
        onyomi: ["セン"],
        kunyomi: ["のたま.う"],
        examples: [
        { word: "宣言", reading: "せんげん", meaning: "declaration, proclamation, announcement" },
        { word: "宣告", reading: "せんこく", meaning: "sentencing, pronouncement of a verdict, passing of sentence" },
        { word: "宣誓", reading: "せんせい", meaning: "oath, abjuration, pledge" },
        { word: "宣戦", reading: "せんせん", meaning: "declaration of war" }
    ],
    },
    "専": {
        onyomi: ["セン"],
        kunyomi: ["もっぱ.ら"],
        examples: [
        { word: "住専", reading: "じゅうせん", meaning: "housing-loan corporation" },
        { word: "専ら", reading: "もっぱら", meaning: "wholly, solely, entirely" },
        { word: "専横", reading: "せんおう", meaning: "arbitrariness, despotism, high-handedness" },
        { word: "専業", reading: "せんぎょう", meaning: "special occupation, principal occupation, specialty" }
    ],
    },
    "泉": {
        onyomi: ["セン"],
        kunyomi: ["いずみ"],
        examples: [
        { word: "温泉", reading: "おんせん", meaning: "hot spring" },
        { word: "源泉", reading: "げんせん", meaning: "source (of a spring, etc.)" },
        { word: "泉水", reading: "せんすい", meaning: "garden pond, miniature lake" },
        { word: "天然温泉", reading: "てんねんおんせん", meaning: "natural hot spring" }
    ],
    },
    "浅": {
        onyomi: ["セン"],
        kunyomi: ["あさ.い"],
        examples: [
        { word: "遠浅", reading: "とおあさ", meaning: "shoal, wide shallow beach" },
        { word: "浅い", reading: "あさい", meaning: "shallow, superficial" },
        { word: "浅瀬", reading: "あさせ", meaning: "shoal, shallows, sand bar" },
        { word: "浅見", reading: "せんけん", meaning: "shallow view, superficial idea" }
    ],
    },
    "洗": {
        onyomi: ["セン"],
        kunyomi: ["あら.う"],
        examples: [
        { word: "水洗", reading: "すいせん", meaning: "washing with water, rinsing, flushing" },
        { word: "洗う", reading: "あらう", meaning: "to wash, to cleanse, to rinse" },
        { word: "洗剤", reading: "せんざい", meaning: "detergent, cleanser, cleaning agent" },
        { word: "洗浄", reading: "せんじょう", meaning: "washing, cleansing, cleaning" }
    ],
    },
    "染": {
        onyomi: ["セン"],
        kunyomi: ["そ.める", "そ.まる", "し.みる", "し.み"],
        examples: [
        { word: "汚染", reading: "おせん", meaning: "pollution, contamination" },
        { word: "感染", reading: "かんせん", meaning: "infection, contagion, becoming infected" },
        { word: "染み", reading: "しみ", meaning: "stain, spot, smudge" },
        { word: "染色", reading: "せんしょく", meaning: "dyeing" }
    ],
    },
    "扇": {
        onyomi: ["セン"],
        kunyomi: ["おうぎ"],
        examples: [
        { word: "扇子", reading: "せんす", meaning: "folding fan" },
        { word: "扇動", reading: "せんどう", meaning: "incitement, sedition, agitation" },
        { word: "団扇", reading: "うちわ", meaning: "uchiwa, type of traditional Japanese handheld fan" },
        { word: "扇形", reading: "おうぎがた", meaning: "fan shape" }
    ],
    },
    "栓": {
        onyomi: ["セン"],
        kunyomi: [],
        examples: [
        { word: "栓抜き", reading: "せんぬき", meaning: "bottle opener, corkscrew" },
        { word: "栓", reading: "せん", meaning: "stopper, cork, plug" }
    ],
    },
    "旋": {
        onyomi: ["セン"],
        kunyomi: ["め.ぐる", "いばり"],
        examples: [
        { word: "斡旋", reading: "あっせん", meaning: "good offices, kind offices, services" },
        { word: "旋回", reading: "せんかい", meaning: "revolution, rotation, turning" },
        { word: "旋風", reading: "せんぷう", meaning: "whirlwind" },
        { word: "旋律", reading: "せんりつ", meaning: "melody, tune" }
    ],
    },
    "船": {
        onyomi: ["セン"],
        kunyomi: ["ふね", "ふな-"],
        examples: [
        { word: "艦船", reading: "かんせん", meaning: "warships and other vessels" },
        { word: "汽船", reading: "きせん", meaning: "steamship, steamboat, steamer" },
        { word: "客船", reading: "きゃくせん", meaning: "passenger boat" },
        { word: "漁船", reading: "ぎょせん", meaning: "fishing boat" }
    ],
    },
    "戦": {
        onyomi: ["セン"],
        kunyomi: ["いくさ", "たたか.う", "おのの.く", "そよ.ぐ", "わなな.く"],
        examples: [
        { word: "一戦", reading: "いっせん", meaning: "battle, game, bout" },
        { word: "開戦", reading: "かいせん", meaning: "outbreak of war, starting a war" },
        { word: "観戦", reading: "かんせん", meaning: "watching a (sports) game, spectating, observing (military operations)" },
        { word: "休戦", reading: "きゅうせん", meaning: "cease-fire, truce, armistice" }
    ],
    },
    "煎": {
        onyomi: ["セン"],
        kunyomi: ["せん.じる", "い.る", "に.る"],
        examples: [
        { word: "煎餅", reading: "せんべい", meaning: "(Japanese) rice cracker, senbei" }
    ],
    },
    "羨": {
        onyomi: ["セン", "エン"],
        kunyomi: ["うらや.む", "あまり"],
        examples: [
        { word: "羨ましい", reading: "うらやましい", meaning: "envious, jealous" }
    ],
    },
    "腺": {
        onyomi: ["セン"],
        kunyomi: [],
        examples: [
        { word: "甲状腺", reading: "こうじょうせん", meaning: "thyroid (gland)" }
    ],
    },
    "詮": {
        onyomi: ["セン"],
        kunyomi: ["せん.ずる", "かい", "あき.らか"],
        examples: [
        { word: "所詮", reading: "しょせん", meaning: "after all, in the end, anyway" }
    ],
    },
    "践": {
        onyomi: ["セン"],
        kunyomi: ["ふ.む"],
        examples: [
        { word: "実践", reading: "じっせん", meaning: "practice, putting into practice, implementation" }
    ],
    },
    "箋": {
        onyomi: ["セン"],
        kunyomi: ["ふだ"],
        examples: [
        { word: "便箋", reading: "びんせん", meaning: "writing paper, stationery, notepaper" },
        { word: "処方箋", reading: "しょほうせん", meaning: "prescription" }
    ],
    },
    "銭": {
        onyomi: ["セン", "ゼン"],
        kunyomi: ["ぜに", "すき"],
        examples: [
        { word: "金銭", reading: "きんせん", meaning: "money, cash" },
        { word: "小銭", reading: "こぜに", meaning: "small change, pocket change, coins" },
        { word: "銭湯", reading: "せんとう", meaning: "public bath, bathhouse" },
        { word: "釣り銭", reading: "つりせん", meaning: "change (for a purchase)" }
    ],
    },
    "潜": {
        onyomi: ["セン"],
        kunyomi: ["ひそ.む", "もぐ.る", "かく.れる", "くぐ.る", "ひそ.める"],
        examples: [
        { word: "原潜", reading: "げんせん", meaning: "nuclear submarine" },
        { word: "潜む", reading: "ひそむ", meaning: "to lurk, to be hidden, to be concealed" },
        { word: "潜在", reading: "せんざい", meaning: "potentiality, dormancy, latency" },
        { word: "潜水", reading: "せんすい", meaning: "diving, submerging, going underwater" }
    ],
    },
    "線": {
        onyomi: ["セン"],
        kunyomi: ["すじ"],
        examples: [
        { word: "Ｘ線", reading: "エックスせん", meaning: "X-ray" },
        { word: "一線", reading: "いっせん", meaning: "one line, (a) single line" },
        { word: "沿線", reading: "えんせん", meaning: "places alongside a railway line, bus route, major thoroughfare, etc." },
        { word: "横線", reading: "おうせん", meaning: "horizontal line" }
    ],
    },
    "遷": {
        onyomi: ["セン"],
        kunyomi: ["うつ.る", "うつ.す", "みやこがえ"],
        examples: [
        { word: "左遷", reading: "させん", meaning: "demotion, relegation, reduction in rank" },
        { word: "変遷", reading: "へんせん", meaning: "change, transition, vicissitudes" },
        { word: "遷都", reading: "せんと", meaning: "relocation of the capital, transfer of the capital" }
    ],
    },
    "選": {
        onyomi: ["セン"],
        kunyomi: ["えら.ぶ", "え.る", "よ.る"],
        examples: [
        { word: "改選", reading: "かいせん", meaning: "election (for a seat or position at the end of a term)" },
        { word: "互選", reading: "ごせん", meaning: "election by mutual vote, election from within a committee (party, etc.), internal vote" },
        { word: "公選", reading: "こうせん", meaning: "public election, election by popular vote" },
        { word: "再選", reading: "さいせん", meaning: "re-election, reelection" }
    ],
    },
    "薦": {
        onyomi: ["セン"],
        kunyomi: ["すす.める"],
        examples: [
        { word: "自薦", reading: "じせん", meaning: "self-recommendation, self-nomination, putting oneself forward" },
        { word: "推薦", reading: "すいせん", meaning: "recommendation, referral, endorsement" },
        { word: "他薦", reading: "たせん", meaning: "recommendation (by others)" },
        { word: "薦める", reading: "すすめる", meaning: "to recommend (someone to do), to advise, to encourage" }
    ],
    },
    "繊": {
        onyomi: ["セン"],
        kunyomi: [],
        examples: [
        { word: "化繊", reading: "かせん", meaning: "synthetic fiber, synthetic fibre, chemical fiber" },
        { word: "繊維", reading: "せんい", meaning: "fibre, fiber" },
        { word: "繊細", reading: "せんさい", meaning: "dainty, delicate (e.g. fingers), fine" },
        { word: "合繊", reading: "ごうせん", meaning: "synthetic fiber, synthetic fibre" }
    ],
    },
    "鮮": {
        onyomi: ["セン"],
        kunyomi: ["あざ.やか"],
        examples: [
        { word: "新鮮", reading: "しんせん", meaning: "fresh" },
        { word: "鮮魚", reading: "せんぎょ", meaning: "fresh fish" },
        { word: "鮮度", reading: "せんど", meaning: "(degree of) freshness" },
        { word: "鮮明", reading: "せんめい", meaning: "vivid, clear, distinct" }
    ],
    },
    "全": {
        onyomi: ["ゼン"],
        kunyomi: ["まった.く", "すべ.て"],
        examples: [
        { word: "安全", reading: "あんぜん", meaning: "safety, security" },
        { word: "完全", reading: "かんぜん", meaning: "perfect, complete" },
        { word: "健全", reading: "けんぜん", meaning: "healthy, sound, wholesome" },
        { word: "全く", reading: "まったく", meaning: "really, truly, entirely" }
    ],
    },
    "前": {
        onyomi: ["ゼン"],
        kunyomi: ["まえ", "-まえ"],
        examples: [
        { word: "お前", reading: "おまえ", meaning: "you" },
        { word: "以前", reading: "いぜん", meaning: "before, prior to, ago" },
        { word: "駅前", reading: "えきまえ", meaning: "in front of a station" },
        { word: "気前", reading: "きまえ", meaning: "generosity" }
    ],
    },
    "善": {
        onyomi: ["ゼン"],
        kunyomi: ["よ.い", "い.い", "よ.く", "よし.とする"],
        examples: [
        { word: "改善", reading: "かいぜん", meaning: "betterment, improvement" },
        { word: "最善", reading: "さいぜん", meaning: "the very best, utmost" },
        { word: "慈善", reading: "じぜん", meaning: "charity, benevolence, philanthropy" },
        { word: "親善", reading: "しんぜん", meaning: "friendship, goodwill, friendly relations" }
    ],
    },
    "然": {
        onyomi: ["ゼン", "ネン"],
        kunyomi: ["しか", "しか.り", "しか.し", "さ"],
        examples: [
        { word: "依然", reading: "いぜん", meaning: "still, as yet, as it has been" },
        { word: "敢然", reading: "かんぜん", meaning: "boldly, bravely, resolutely" },
        { word: "偶然", reading: "ぐうぜん", meaning: "coincidence, chance, accident" },
        { word: "公然", reading: "こうぜん", meaning: "open, public, official" }
    ],
    },
    "禅": {
        onyomi: ["ゼン", "セン"],
        kunyomi: ["しずか", "ゆず.る"],
        examples: [
        { word: "座禅", reading: "ざぜん", meaning: "zazen (seated Zen meditation, usu. in a cross-legged position)" },
        { word: "禅寺", reading: "ぜんでら", meaning: "Zen temple" },
        { word: "禅宗", reading: "ぜんしゅう", meaning: "Zen (Buddhism)" },
        { word: "禅僧", reading: "ぜんそう", meaning: "Zen priest" }
    ],
    },
    "漸": {
        onyomi: ["ゼン"],
        kunyomi: ["ようや.く", "やや", "ようよ.う", "すす.む"],
        examples: [
        { word: "漸減", reading: "ぜんげん", meaning: "gradual decrease, decline" },
        { word: "漸次", reading: "ぜんじ", meaning: "gradually, slowly, little by little" },
        { word: "漸進", reading: "ぜんしん", meaning: "gradual progress, steady advance" }
    ],
    },
    "膳": {
        onyomi: ["ゼン", "セン"],
        kunyomi: ["かしわ", "すす.める", "そな.える"],
        examples: [
        { word: "膳", reading: "ぜん", meaning: "small dining table (usu. for a single person), serving tray (with legs)" }
    ],
    },
    "繕": {
        onyomi: ["ゼン"],
        kunyomi: ["つくろ.う"],
        examples: [
        { word: "営繕", reading: "えいぜん", meaning: "maintenance and repair, upkeep (of equipment)" },
        { word: "修繕", reading: "しゅうぜん", meaning: "repair, mending" },
        { word: "繕う", reading: "つくろう", meaning: "to mend, to patch up, to repair" }
    ],
    },
    "狙": {
        onyomi: ["ソ", "ショ"],
        kunyomi: ["ねら.う", "ねら.い"],
        examples: [
        { word: "狙い", reading: "ねらい", meaning: "aim (of a gun, bow, etc.)" },
        { word: "狙う", reading: "ねらう", meaning: "to aim at (with a weapon, etc.)" }
    ],
    },
    "阻": {
        onyomi: ["ソ"],
        kunyomi: ["はば.む"],
        examples: [
        { word: "阻む", reading: "はばむ", meaning: "to keep someone from doing, to stop, to prevent" },
        { word: "阻害", reading: "そがい", meaning: "obstruction, impediment, hindrance" },
        { word: "阻止", reading: "そし", meaning: "obstruction, prevention, hindrance" }
    ],
    },
    "祖": {
        onyomi: ["ソ"],
        kunyomi: [],
        examples: [
        { word: "教祖", reading: "きょうそ", meaning: "founder of a religious sect" },
        { word: "元祖", reading: "がんそ", meaning: "originator, pioneer, inventor" },
        { word: "宗祖", reading: "しゅうそ", meaning: "sect founder" },
        { word: "先祖", reading: "せんぞ", meaning: "ancestor, forefather, foremother" }
    ],
    },
    "租": {
        onyomi: ["ソ"],
        kunyomi: [],
        examples: [
        { word: "租界", reading: "そかい", meaning: "(foreign) concession (in China), settlement" },
        { word: "租税", reading: "そぜい", meaning: "taxes, taxation" }
    ],
    },
    "素": {
        onyomi: ["ソ", "ス"],
        kunyomi: ["もと"],
        examples: [
        { word: "塩素", reading: "えんそ", meaning: "chlorine (Cl)" },
        { word: "簡素", reading: "かんそ", meaning: "simple, plain, modest" },
        { word: "酵素", reading: "こうそ", meaning: "enzyme" },
        { word: "酸素", reading: "さんそ", meaning: "oxygen (O)" }
    ],
    },
    "措": {
        onyomi: ["ソ"],
        kunyomi: ["お.く"],
        examples: [
        { word: "措置", reading: "そち", meaning: "measure, step, action" }
    ],
    },
    "粗": {
        onyomi: ["ソ"],
        kunyomi: ["あら.い", "あら-"],
        examples: [
        { word: "粗い", reading: "あらい", meaning: "coarse, rough" },
        { word: "粗悪", reading: "そあく", meaning: "coarse, crude, inferior" },
        { word: "粗筋", reading: "あらすじ", meaning: "outline, summary, argument" },
        { word: "粗大", reading: "そだい", meaning: "coarse, rough, bulky" }
    ],
    },
    "組": {
        onyomi: ["ソ"],
        kunyomi: ["く.む", "くみ", "-ぐみ"],
        examples: [
        { word: "改組", reading: "かいそ", meaning: "reorganization, reorganisation, reshuffle" },
        { word: "組み", reading: "くみ", meaning: "class (of students)" },
        { word: "組む", reading: "くむ", meaning: "to cross (legs or arms), to link (arms)" },
        { word: "組閣", reading: "そかく", meaning: "formation of a cabinet" }
    ],
    },
    "疎": {
        onyomi: ["ソ", "ショ"],
        kunyomi: ["うと.い", "うと.む", "まば.ら"],
        examples: [
        { word: "過疎", reading: "かそ", meaning: "underpopulation, low population density, depopulation" },
        { word: "空疎", reading: "くうそ", meaning: "empty (e.g. argument), insubstantial, hollow" },
        { word: "疎か", reading: "おろそか", meaning: "negligent, neglectful, careless" },
        { word: "疎遠", reading: "そえん", meaning: "estrangement, alienation, neglecting to stay in contact" }
    ],
    },
    "訴": {
        onyomi: ["ソ"],
        kunyomi: ["うった.える"],
        examples: [
        { word: "起訴", reading: "きそ", meaning: "prosecution, indictment" },
        { word: "公訴", reading: "こうそ", meaning: "(public) prosecution, indictment, accusation" },
        { word: "控訴", reading: "こうそ", meaning: "appeal to a higher court, intermediate appeal" },
        { word: "告訴", reading: "こくそ", meaning: "accusation, complaint, charge" }
    ],
    },
    "塑": {
        onyomi: ["ソ"],
        kunyomi: ["でく"],
        examples: [
        { word: "彫塑", reading: "ちょうそ", meaning: "carving, engraving" }
    ],
    },
    "遡": {
        onyomi: ["ソ", "サク"],
        kunyomi: ["さかのぼ.る"],
        examples: [
        { word: "遡る", reading: "さかのぼる", meaning: "to go upstream, to go up (a river)" }
    ],
    },
    "礎": {
        onyomi: ["ソ"],
        kunyomi: ["いしずえ"],
        examples: [
        { word: "基礎", reading: "きそ", meaning: "foundation, basis" },
        { word: "礎石", reading: "そせき", meaning: "foundation stone, cornerstone" },
        { word: "礎", reading: "いしずえ", meaning: "foundation stone, cornerstone" }
    ],
    },
    "双": {
        onyomi: ["ソウ"],
        kunyomi: ["ふた", "たぐい", "ならぶ", "ふたつ"],
        examples: [
        { word: "双子", reading: "ふたご", meaning: "twins, twin" },
        { word: "双方", reading: "そうほう", meaning: "both parties, both sides" },
        { word: "双葉", reading: "ふたば", meaning: "seed leaves (of a dicot), cotyledons, bud" },
        { word: "双眼鏡", reading: "そうがんきょう", meaning: "binoculars, field glasses" }
    ],
    },
    "壮": {
        onyomi: ["ソウ"],
        kunyomi: ["さかん"],
        examples: [
        { word: "強壮", reading: "きょうそう", meaning: "able-bodied, robust, sturdy" },
        { word: "壮行", reading: "そうこう", meaning: "(rousing) send-off, farewell" },
        { word: "壮大", reading: "そうだい", meaning: "magnificent, grand, majestic" },
        { word: "壮年", reading: "そうねん", meaning: "prime of life" }
    ],
    },
    "早": {
        onyomi: ["ソウ", "サッ"],
        kunyomi: ["はや.い", "はや", "はや-", "はや.まる", "はや.める", "さ-"],
        examples: [
        { word: "最早", reading: "もはや", meaning: "already, now" },
        { word: "早く", reading: "はやく", meaning: "early, soon" },
        { word: "早期", reading: "そうき", meaning: "early stage" },
        { word: "早口", reading: "はやくち", meaning: "fast-talking, rapid talking" }
    ],
    },
    "争": {
        onyomi: ["ソウ"],
        kunyomi: ["あらそ.う", "いか.でか"],
        examples: [
        { word: "競争", reading: "きょうそう", meaning: "competition, contest, rivalry" },
        { word: "係争", reading: "けいそう", meaning: "dispute, contention, conflict" },
        { word: "抗争", reading: "こうそう", meaning: "rivalry, feud, conflict" },
        { word: "戦争", reading: "せんそう", meaning: "war" }
    ],
    },
    "走": {
        onyomi: ["ソウ"],
        kunyomi: ["はし.る"],
        examples: [
        { word: "滑走", reading: "かっそう", meaning: "gliding, sliding, skating (on ice)" },
        { word: "完走", reading: "かんそう", meaning: "finishing (a race), running the whole distance, reaching the goal" },
        { word: "競走", reading: "きょうそう", meaning: "race, run, dash" },
        { word: "疾走", reading: "しっそう", meaning: "sprint, dash, scampering" }
    ],
    },
    "奏": {
        onyomi: ["ソウ"],
        kunyomi: ["かな.でる"],
        examples: [
        { word: "合奏", reading: "がっそう", meaning: "ensemble (e.g. orchestra, chamber group, etc.), concert" },
        { word: "奏者", reading: "そうしゃ", meaning: "instrumentalist, player" },
        { word: "独奏", reading: "どくそう", meaning: "(instrumental) solo, recital" },
        { word: "伴奏", reading: "ばんそう", meaning: "accompaniment" }
    ],
    },
    "相": {
        onyomi: ["ソウ", "ショウ"],
        kunyomi: ["あい-"],
        examples: [
        { word: "外相", reading: "がいしょう", meaning: "Foreign Minister" },
        { word: "厚相", reading: "こうしょう", meaning: "Welfare Minister" },
        { word: "宰相", reading: "さいしょう", meaning: "prime minister, premier, chancellor" },
        { word: "首相", reading: "しゅしょう", meaning: "prime minister, chancellor (Germany, Austria, etc.), premier" }
    ],
    },
    "荘": {
        onyomi: ["ソウ", "ショウ", "チャン"],
        kunyomi: ["ほうき", "おごそ.か"],
        examples: [
        { word: "山荘", reading: "さんそう", meaning: "mountain villa, mountain retreat, mountain cottage" },
        { word: "荘厳", reading: "そうごん", meaning: "solemn, sublime, grand" },
        { word: "別荘", reading: "べっそう", meaning: "holiday house, vacation home, villa" }
    ],
    },
    "草": {
        onyomi: ["ソウ"],
        kunyomi: ["くさ", "くさ-", "-ぐさ"],
        examples: [
        { word: "起草", reading: "きそう", meaning: "drafting (e.g. a bill), drawing up" },
        { word: "雑草", reading: "ざっそう", meaning: "weed" },
        { word: "仕草", reading: "しぐさ", meaning: "gesture, movement, action" },
        { word: "芝草", reading: "しばくさ", meaning: "lawn, sod, turf" }
    ],
    },
    "送": {
        onyomi: ["ソウ"],
        kunyomi: ["おく.る"],
        examples: [
        { word: "移送", reading: "いそう", meaning: "transfer, transport, transportation" },
        { word: "回送", reading: "かいそう", meaning: "forwarding, sending on, redirecting (e.g. mail)" },
        { word: "護送", reading: "ごそう", meaning: "escort (e.g. under guard), convoy" },
        { word: "葬送", reading: "そうそう", meaning: "attending a funeral procession, seeing off the deceased, burial of someone's remains" }
    ],
    },
    "倉": {
        onyomi: ["ソウ"],
        kunyomi: ["くら"],
        examples: [
        { word: "穀倉", reading: "こくそう", meaning: "granary" },
        { word: "倉庫", reading: "そうこ", meaning: "storehouse, warehouse, godown" },
        { word: "倉敷", reading: "くらしき", meaning: "Kurashiki (city)" },
        { word: "米倉", reading: "こめぐら", meaning: "rice granary" }
    ],
    },
    "捜": {
        onyomi: ["ソウ", "シュ", "シュウ"],
        kunyomi: ["さが.す"],
        examples: [
        { word: "捜査", reading: "そうさ", meaning: "search (esp. in criminal investigations), investigation, inquiry" },
        { word: "捜索", reading: "そうさく", meaning: "search (esp. for someone or something missing), manhunt" },
        { word: "捜す", reading: "さがす", meaning: "to search for, to look for, to hunt for" },
        { word: "特捜", reading: "とくそう", meaning: "special investigation" }
    ],
    },
    "挿": {
        onyomi: ["ソウ"],
        kunyomi: ["さ.す", "はさ.む"],
        examples: [
        { word: "挿入", reading: "そうにゅう", meaning: "insertion, interposition, interpolation" },
        { word: "挿話", reading: "そうわ", meaning: "episode, side story, story within a story" },
        { word: "挿絵", reading: "さしえ", meaning: "illustration (in a book, newspaper, etc.), picture" }
    ],
    },
    "桑": {
        onyomi: ["ソウ"],
        kunyomi: ["くわ"],
        examples: [
        { word: "桑田", reading: "そうでん", meaning: "mulberry plantation" },
        { word: "桑畑", reading: "くわばたけ", meaning: "mulberry field, mulberry plantation" },
        { word: "桑原", reading: "くわばら", meaning: "mulberry field" },
        { word: "桑", reading: "くわ", meaning: "mulberry (tree)" }
    ],
    },
    "巣": {
        onyomi: ["ソウ"],
        kunyomi: ["す", "す.くう"],
        examples: [
        { word: "古巣", reading: "ふるす", meaning: "old haunts, former homes" },
        { word: "卵巣", reading: "らんそう", meaning: "ovary" },
        { word: "巣立ち", reading: "すだち", meaning: "leaving the nest" },
        { word: "空き巣", reading: "あきす", meaning: "empty nest" }
    ],
    },
    "掃": {
        onyomi: ["ソウ", "シュ"],
        kunyomi: ["は.く"],
        examples: [
        { word: "一掃", reading: "いっそう", meaning: "clean sweep, purging, doing away with" },
        { word: "清掃", reading: "せいそう", meaning: "cleaning, clean-up, garbage collection" },
        { word: "掃く", reading: "はく", meaning: "to sweep, to brush, to clean" },
        { word: "掃海", reading: "そうかい", meaning: "sweeping the sea for mines, dragging for mines" }
    ],
    },
    "曹": {
        onyomi: ["ソウ", "ゾウ"],
        kunyomi: [],
        examples: [
        { word: "法曹", reading: "ほうそう", meaning: "legal profession, judicial officer, lawyer" },
        { word: "法曹界", reading: "ほうそうかい", meaning: "legal circles" }
    ],
    },
    "曽": {
        onyomi: ["ソウ", "ソ", "ゾウ"],
        kunyomi: ["かつ", "かつて", "すなわち"],
        examples: [
        { word: "曽遊", reading: "そうゆう", meaning: "former visit" },
        { word: "曽て", reading: "かつて", meaning: "once, before, formerly" },
        { word: "曽孫", reading: "ひまご", meaning: "great-grandchild" },
        { word: "熊曽", reading: "くまそ", meaning: "Kumaso (ancient Japanese people who lived in southern Kyushu)" }
    ],
    },
    "爽": {
        onyomi: ["ソウ"],
        kunyomi: ["あき.らか", "さわ.やか", "たがう"],
        examples: [
        { word: "爽快", reading: "そうかい", meaning: "refreshing, exhilarating, invigorating" },
        { word: "爽やか", reading: "さわやか", meaning: "fresh, refreshing, invigorating" }
    ],
    },
    "窓": {
        onyomi: ["ソウ", "ス"],
        kunyomi: ["まど", "てんまど", "けむだし"],
        examples: [
        { word: "車窓", reading: "しゃそう", meaning: "train window, car window" },
        { word: "窓口", reading: "まどぐち", meaning: "counter, window, teller window" },
        { word: "窓際", reading: "まどぎわ", meaning: "at the window, by the window, next to the window" },
        { word: "同窓", reading: "どうそう", meaning: "being a graduate of the same school, person who went to the same school, fellow alumnus" }
    ],
    },
    "創": {
        onyomi: ["ソウ", "ショウ"],
        kunyomi: ["つく.る", "はじ.める", "きず", "けず.しける"],
        examples: [
        { word: "創意", reading: "そうい", meaning: "original idea, originality" },
        { word: "創刊", reading: "そうかん", meaning: "foundation (of a newspaper, magazine, etc.), starting, launching" },
        { word: "創業", reading: "そうぎょう", meaning: "establishment (of a business), founding" },
        { word: "創作", reading: "そうさく", meaning: "creation, production, creative work (novel, film, etc.)" }
    ],
    },
    "喪": {
        onyomi: ["ソウ"],
        kunyomi: ["も"],
        examples: [
        { word: "喪失", reading: "そうしつ", meaning: "loss, forfeit" },
        { word: "喪主", reading: "もしゅ", meaning: "chief mourner" },
        { word: "喪章", reading: "もしょう", meaning: "mourning band, mourning ribbon" },
        { word: "喪服", reading: "もふく", meaning: "mourning clothes, mourning attire, mourning dress" }
    ],
    },
    "痩": {
        onyomi: ["ソウ", "チュウ", "シュウ", "シュ"],
        kunyomi: ["や.せる"],
        examples: [
        { word: "痩身", reading: "そうしん", meaning: "slim figure, slender body" },
        { word: "痩せる", reading: "やせる", meaning: "to become thin, to lose weight, to slim" }
    ],
    },
    "葬": {
        onyomi: ["ソウ"],
        kunyomi: ["ほうむ.る"],
        examples: [
        { word: "火葬", reading: "かそう", meaning: "cremation" },
        { word: "葬る", reading: "ほうむる", meaning: "to bury, to inter, to entomb" },
        { word: "葬儀", reading: "そうぎ", meaning: "funeral, funeral service" },
        { word: "葬式", reading: "そうしき", meaning: "funeral" }
    ],
    },
    "装": {
        onyomi: ["ソウ", "ショウ"],
        kunyomi: ["よそお.う", "よそお.い"],
        examples: [
        { word: "衣装", reading: "いしょう", meaning: "clothing, costume, outfit" },
        { word: "仮装", reading: "かそう", meaning: "costume, fancy dress, masquerade" },
        { word: "改装", reading: "かいそう", meaning: "remodelling, remodeling, reorganization" },
        { word: "正装", reading: "せいそう", meaning: "full dress, formal dress, uniform" }
    ],
    },
    "僧": {
        onyomi: ["ソウ"],
        kunyomi: [],
        examples: [
        { word: "高僧", reading: "こうそう", meaning: "high priest, highly ranked priest" },
        { word: "小僧", reading: "こぞう", meaning: "youngster, boy, kid" },
        { word: "禅僧", reading: "ぜんそう", meaning: "Zen priest" },
        { word: "僧院", reading: "そういん", meaning: "monastery, temple" }
    ],
    },
    "想": {
        onyomi: ["ソウ", "ソ"],
        kunyomi: ["おも.う"],
        examples: [
        { word: "仮想", reading: "かそう", meaning: "imagination, supposition, virtual" },
        { word: "回想", reading: "かいそう", meaning: "recollection, retrospection, reflection" },
        { word: "感想", reading: "かんそう", meaning: "impressions, thoughts, feelings" },
        { word: "空想", reading: "くうそう", meaning: "daydream, fantasy, fancy" }
    ],
    },
    "層": {
        onyomi: ["ソウ"],
        kunyomi: [],
        examples: [
        { word: "一層", reading: "いっそう", meaning: "even more, still more, all the more" },
        { word: "階層", reading: "かいそう", meaning: "class, level, stratum" },
        { word: "高層", reading: "こうそう", meaning: "high-rise (building), multistory, multistoried" },
        { word: "上層", reading: "じょうそう", meaning: "upper stratum (classes, stories, storeys), upper layer, layer above" }
    ],
    },
    "総": {
        onyomi: ["ソウ"],
        kunyomi: ["す.べて", "すべ.て", "ふさ"],
        examples: [
        { word: "総意", reading: "そうい", meaning: "consensus, collective will, collective opinion" },
        { word: "総会", reading: "そうかい", meaning: "general meeting" },
        { word: "総額", reading: "そうがく", meaning: "total amount (of money), total sum, sum total" },
        { word: "総括", reading: "そうかつ", meaning: "summarization, summary, generalization" }
    ],
    },
    "遭": {
        onyomi: ["ソウ"],
        kunyomi: ["あ.う", "あ.わせる"],
        examples: [
        { word: "遭う", reading: "あう", meaning: "to meet, to encounter, to see" },
        { word: "遭遇", reading: "そうぐう", meaning: "encounter, running into, meeting with (e.g. an accident)" },
        { word: "遭難", reading: "そうなん", meaning: "(meeting with) disaster, (having an) accident, mishap" }
    ],
    },
    "槽": {
        onyomi: ["ソウ"],
        kunyomi: ["ふね"],
        examples: [
        { word: "水槽", reading: "すいそう", meaning: "water tank, cistern" },
        { word: "浴槽", reading: "よくそう", meaning: "bathtub" },
        { word: "浄化槽", reading: "じょうかそう", meaning: "water-purification tank" }
    ],
    },
    "踪": {
        onyomi: ["ソウ", "ショウ"],
        kunyomi: ["あと"],
        examples: [
        { word: "失踪", reading: "しっそう", meaning: "disappearance, running away, going missing" }
    ],
    },
    "操": {
        onyomi: ["ソウ", "サン"],
        kunyomi: ["みさお", "あやつ.る"],
        examples: [
        { word: "節操", reading: "せっそう", meaning: "integrity, fidelity, constancy" },
        { word: "操る", reading: "あやつる", meaning: "to operate (e.g. a machine), to handle, to manage" },
        { word: "操業", reading: "そうぎょう", meaning: "operation (of a machine, factory, fishing boat, etc.), work" },
        { word: "操作", reading: "そうさ", meaning: "operation, management, handling" }
    ],
    },
    "燥": {
        onyomi: ["ソウ"],
        kunyomi: ["はしゃ.ぐ"],
        examples: [
        { word: "乾燥", reading: "かんそう", meaning: "dryness, aridity, drying (e.g. clothes)" },
        { word: "焦燥", reading: "しょうそう", meaning: "impatience, irritation, frustration" }
    ],
    },
    "霜": {
        onyomi: ["ソウ"],
        kunyomi: ["しも"],
        examples: [
        { word: "霜降り", reading: "しもふり", meaning: "speckled with white, salt-and-pepper (pattern, fabric, etc.)" },
        { word: "霜", reading: "しも", meaning: "frost" }
    ],
    },
    "騒": {
        onyomi: ["ソウ"],
        kunyomi: ["さわ.ぐ", "うれい", "さわ.がしい"],
        examples: [
        { word: "騒ぎ", reading: "さわぎ", meaning: "uproar, disturbance" },
        { word: "騒ぐ", reading: "さわぐ", meaning: "to make noise, to make racket, to be noisy" },
        { word: "騒音", reading: "そうおん", meaning: "noise, din" },
        { word: "騒然", reading: "そうぜん", meaning: "noisy, confused, uproarious" }
    ],
    },
    "藻": {
        onyomi: ["ソウ"],
        kunyomi: ["も"],
        examples: [
        { word: "海藻", reading: "かいそう", meaning: "seaweed" },
        { word: "藻類", reading: "そうるい", meaning: "seaweeds, algae, waterweeds" },
        { word: "藻", reading: "も", meaning: "algae, waterweed, seaweed" }
    ],
    },
    "造": {
        onyomi: ["ゾウ"],
        kunyomi: ["つく.る", "つく.り", "-づく.り"],
        examples: [
        { word: "改造", reading: "かいぞう", meaning: "remodeling, remodelling, reconstruction" },
        { word: "偽造", reading: "ぎぞう", meaning: "forgery, counterfeiting, fabrication" },
        { word: "建造", reading: "けんぞう", meaning: "building, construction" },
        { word: "構造", reading: "こうぞう", meaning: "structure, construction, makeup" }
    ],
    },
    "像": {
        onyomi: ["ゾウ"],
        kunyomi: [],
        examples: [
        { word: "映像", reading: "えいぞう", meaning: "image (on a screen), picture (e.g. on a TV)" },
        { word: "画像", reading: "がぞう", meaning: "image, picture, portrait" },
        { word: "胸像", reading: "きょうぞう", meaning: "bust (sculpture), half-length portrait" },
        { word: "偶像", reading: "ぐうぞう", meaning: "image, idol, statue" }
    ],
    },
    "増": {
        onyomi: ["ゾウ"],
        kunyomi: ["ま.す", "ま.し", "ふ.える", "ふ.やす"],
        examples: [
        { word: "急増", reading: "きゅうぞう", meaning: "rapid increase, sharp rise, proliferation" },
        { word: "増す", reading: "ます", meaning: "to increase, to grow" },
        { word: "増員", reading: "ぞういん", meaning: "increasing the number of staff, hiring more people" },
        { word: "増加", reading: "ぞうか", meaning: "increase, rise, growth" }
    ],
    },
    "憎": {
        onyomi: ["ゾウ"],
        kunyomi: ["にく.む", "にく.い", "にく.らしい", "にく.しみ"],
        examples: [
        { word: "生憎", reading: "あいにく", meaning: "unfortunately, sorry, but ..." },
        { word: "憎い", reading: "にくい", meaning: "hateful, detestable, abominable" },
        { word: "憎む", reading: "にくむ", meaning: "to hate, to detest" },
        { word: "憎悪", reading: "ぞうお", meaning: "hatred, abhorrence, loathing" }
    ],
    },
    "蔵": {
        onyomi: ["ゾウ", "ソウ"],
        kunyomi: ["くら", "おさ.める", "かく.れる"],
        examples: [
        { word: "蔵書", reading: "ぞうしょ", meaning: "collection of books, (personal) library" },
        { word: "蔵相", reading: "ぞうしょう", meaning: "Minister of Finance" },
        { word: "大蔵", reading: "おおくら", meaning: "Ministry of Finance" },
        { word: "地蔵", reading: "じぞう", meaning: "Kshitigarbha (bodhisattva who looks over children, travellers and the underworld), Ksitigarbha, Jizō" }
    ],
    },
    "贈": {
        onyomi: ["ゾウ", "ソウ"],
        kunyomi: ["おく.る"],
        examples: [
        { word: "贈る", reading: "おくる", meaning: "to give (as a gift), to present" },
        { word: "贈呈", reading: "ぞうてい", meaning: "presentation (of a gift, prize, etc.)" },
        { word: "贈答", reading: "ぞうとう", meaning: "exchange of presents" },
        { word: "贈与", reading: "ぞうよ", meaning: "donation, presentation" }
    ],
    },
    "臓": {
        onyomi: ["ゾウ"],
        kunyomi: ["はらわた"],
        examples: [
        { word: "肝臓", reading: "かんぞう", meaning: "liver" },
        { word: "心臓", reading: "しんぞう", meaning: "heart" },
        { word: "腎臓", reading: "じんぞう", meaning: "kidney" },
        { word: "臓器", reading: "ぞうき", meaning: "internal organs, viscera" }
    ],
    },
    "即": {
        onyomi: ["ソク"],
        kunyomi: ["つ.く", "つ.ける", "すなわ.ち"],
        examples: [
        { word: "即ち", reading: "すなわち", meaning: "that is (to say), namely, i.e." },
        { word: "即位", reading: "そくい", meaning: "accession to the throne, enthronement" },
        { word: "即興", reading: "そっきょう", meaning: "improvisation" },
        { word: "即効", reading: "そっこう", meaning: "immediate effect, instant effect" }
    ],
    },
    "束": {
        onyomi: ["ソク"],
        kunyomi: ["たば", "たば.ねる", "つか", "つか.ねる"],
        examples: [
        { word: "花束", reading: "はなたば", meaning: "bunch of flowers, bouquet" },
        { word: "結束", reading: "けっそく", meaning: "union, unity, solidarity" },
        { word: "拘束", reading: "こうそく", meaning: "restriction, restraint, binding" },
        { word: "札束", reading: "さつたば", meaning: "bundle of banknotes, stack of bills" }
    ],
    },
    "足": {
        onyomi: ["ソク"],
        kunyomi: ["あし", "た.りる", "た.る", "た.す"],
        examples: [
        { word: "一足", reading: "いっそく", meaning: "a pair (of shoes or socks)" },
        { word: "右足", reading: "みぎあし", meaning: "right foot" },
        { word: "遠足", reading: "えんそく", meaning: "school trip, field trip, excursion" },
        { word: "左足", reading: "ひだりあし", meaning: "left foot" }
    ],
    },
    "促": {
        onyomi: ["ソク"],
        kunyomi: ["うなが.す"],
        examples: [
        { word: "催促", reading: "さいそく", meaning: "pressing, urging, demanding" },
        { word: "促す", reading: "うながす", meaning: "to urge, to encourage, to press" },
        { word: "促進", reading: "そくしん", meaning: "promotion, acceleration, encouragement" },
        { word: "促成", reading: "そくせい", meaning: "promotion of growth" }
    ],
    },
    "則": {
        onyomi: ["ソク"],
        kunyomi: ["のっと.る", "のり", "すなわち"],
        examples: [
        { word: "会則", reading: "かいそく", meaning: "society regulations, club regulations, constitution" },
        { word: "規則", reading: "きそく", meaning: "rule, regulation" },
        { word: "原則", reading: "げんそく", meaning: "principle, general rule" },
        { word: "校則", reading: "こうそく", meaning: "school rules, school regulations" }
    ],
    },
    "息": {
        onyomi: ["ソク"],
        kunyomi: ["いき"],
        examples: [
        { word: "一息", reading: "ひといき", meaning: "one breath" },
        { word: "休息", reading: "きゅうそく", meaning: "rest, relief, relaxation" },
        { word: "子息", reading: "しそく", meaning: "(another's) son" },
        { word: "終息", reading: "しゅうそく", meaning: "cessation, (coming to an) end" }
    ],
    },
    "捉": {
        onyomi: ["ソク", "サク"],
        kunyomi: ["とら.える"],
        examples: [
        { word: "捉える", reading: "とらえる", meaning: "to catch, to capture, to seize" }
    ],
    },
    "速": {
        onyomi: ["ソク"],
        kunyomi: ["はや.い", "はや-", "はや.める", "すみ.やか"],
        examples: [
        { word: "加速", reading: "かそく", meaning: "acceleration, speeding up" },
        { word: "快速", reading: "かいそく", meaning: "high speed, rapidity" },
        { word: "急速", reading: "きゅうそく", meaning: "rapid (e.g. progress)" },
        { word: "減速", reading: "げんそく", meaning: "deceleration" }
    ],
    },
    "側": {
        onyomi: ["ソク"],
        kunyomi: ["かわ", "がわ", "そば"],
        examples: [
        { word: "縁側", reading: "えんがわ", meaning: "engawa, external corridor on the outer side of traditional Japanese houses" },
        { word: "西側", reading: "にしがわ", meaning: "west side, west bank" },
        { word: "側近", reading: "そっきん", meaning: "close aide (of a powerful person), close associate, entourage" },
        { word: "側面", reading: "そくめん", meaning: "side, flank, profile" }
    ],
    },
    "測": {
        onyomi: ["ソク"],
        kunyomi: ["はか.る"],
        examples: [
        { word: "観測", reading: "かんそく", meaning: "observation, survey, measurement" },
        { word: "計測", reading: "けいそく", meaning: "measuring, measurement" },
        { word: "推測", reading: "すいそく", meaning: "guess, conjecture" },
        { word: "測定", reading: "そくてい", meaning: "measurement" }
    ],
    },
    "俗": {
        onyomi: ["ゾク"],
        kunyomi: [],
        examples: [
        { word: "俗語", reading: "ぞくご", meaning: "colloquialism, colloquial language, slang" },
        { word: "風俗", reading: "ふうぞく", meaning: "manners, customs" },
        { word: "民俗", reading: "みんぞく", meaning: "folk customs, folkways, ethnic customs" },
        { word: "通俗的", reading: "つうぞくてき", meaning: "popular, common, commonplace" }
    ],
    },
    "族": {
        onyomi: ["ゾク"],
        kunyomi: [],
        examples: [
        { word: "遺族", reading: "いぞく", meaning: "bereaved family, surviving family, family of the deceased" },
        { word: "一族", reading: "いちぞく", meaning: "family, relatives, dependents" },
        { word: "王族", reading: "おうぞく", meaning: "royalty, royal family" },
        { word: "家族", reading: "かぞく", meaning: "family" }
    ],
    },
    "属": {
        onyomi: ["ゾク", "ショク"],
        kunyomi: ["さかん", "つく", "やから"],
        examples: [
        { word: "帰属", reading: "きぞく", meaning: "belonging, ascription, attribution" },
        { word: "金属", reading: "きんぞく", meaning: "metal" },
        { word: "軍属", reading: "ぐんぞく", meaning: "civilian in military employ" },
        { word: "従属", reading: "じゅうぞく", meaning: "subordination, dependency" }
    ],
    },
    "賊": {
        onyomi: ["ゾク"],
        kunyomi: [],
        examples: [
        { word: "海賊", reading: "かいぞく", meaning: "pirate" },
        { word: "山賊", reading: "さんぞく", meaning: "bandit, brigand" },
        { word: "盗賊", reading: "とうぞく", meaning: "thief, robber, burglar" }
    ],
    },
    "続": {
        onyomi: ["ゾク", "ショク", "コウ", "キョウ"],
        kunyomi: ["つづ.く", "つづ.ける", "つぐ.ない"],
        examples: [
        { word: "永続", reading: "えいぞく", meaning: "permanence, continuation" },
        { word: "勤続", reading: "きんぞく", meaning: "continuous service" },
        { word: "継続", reading: "けいぞく", meaning: "continuation, continuance, maintenance" },
        { word: "後続", reading: "こうぞく", meaning: "succeeding, following, trailing" }
    ],
    },
    "卒": {
        onyomi: ["ソツ", "シュツ"],
        kunyomi: ["そっ.する", "お.える", "お.わる", "ついに", "にわか"],
        examples: [
        { word: "何卒", reading: "なにとぞ", meaning: "please, kindly, I beg of you" },
        { word: "学卒", reading: "がくそつ", meaning: "college graduate" },
        { word: "高卒", reading: "こうそつ", meaning: "having graduated from high school (as one's highest completed level of education), high school graduate" },
        { word: "卒業", reading: "そつぎょう", meaning: "graduation, completion (of a course)" }
    ],
    },
    "率": {
        onyomi: ["ソツ", "リツ", "シュツ"],
        kunyomi: ["ひき.いる"],
        examples: [
        { word: "確率", reading: "かくりつ", meaning: "probability, likelihood, chances" },
        { word: "軽率", reading: "けいそつ", meaning: "rash, thoughtless, careless" },
        { word: "効率", reading: "こうりつ", meaning: "efficiency" },
        { word: "税率", reading: "ぜいりつ", meaning: "tariff" }
    ],
    },
    "存": {
        onyomi: ["ソン", "ゾン"],
        kunyomi: ["ながら.える", "あ.る", "たも.つ", "と.う"],
        examples: [
        { word: "温存", reading: "おんぞん", meaning: "preservation, retainment, keeping" },
        { word: "既存", reading: "きそん", meaning: "existing" },
        { word: "残存", reading: "ざんぞん", meaning: "survival, remaining, being extant" },
        { word: "生存", reading: "せいぞん", meaning: "existence, being, life" }
    ],
    },
    "村": {
        onyomi: ["ソン"],
        kunyomi: ["むら"],
        examples: [
        { word: "寒村", reading: "かんそん", meaning: "poor village, desolate village, lonely village" },
        { word: "漁村", reading: "ぎょそん", meaning: "fishing village" },
        { word: "村人", reading: "むらびと", meaning: "villager" },
        { word: "村長", reading: "そんちょう", meaning: "village headman, village mayor" }
    ],
    },
    "孫": {
        onyomi: ["ソン"],
        kunyomi: ["まご"],
        examples: [
        { word: "子孫", reading: "しそん", meaning: "descendant, progeny, offspring" },
        { word: "孫娘", reading: "まごむすめ", meaning: "granddaughter" },
        { word: "孫", reading: "まご", meaning: "grandchild" }
    ],
    },
    "尊": {
        onyomi: ["ソン"],
        kunyomi: ["たっと.い", "とうと.い", "たっと.ぶ", "とうと.ぶ"],
        examples: [
        { word: "自尊", reading: "じそん", meaning: "self-respect, esteem, self-importance" },
        { word: "尊敬", reading: "そんけい", meaning: "respect, esteem, reverence" },
        { word: "尊厳", reading: "そんげん", meaning: "dignity, majesty, sanctity" },
        { word: "尊重", reading: "そんちょう", meaning: "respect, esteem, regard" }
    ],
    },
    "損": {
        onyomi: ["ソン"],
        kunyomi: ["そこ.なう", "そこな.う", "-そこ.なう", "そこ.ねる", "-そこ.ねる"],
        examples: [
        { word: "欠損", reading: "けっそん", meaning: "deficit, shortage, loss" },
        { word: "損益", reading: "そんえき", meaning: "profit and loss, advantage and disadvantage" },
        { word: "損害", reading: "そんがい", meaning: "damage, injury, loss" },
        { word: "損失", reading: "そんしつ", meaning: "loss (of assets, profit, etc.)" }
    ],
    },
    "遜": {
        onyomi: ["ソン"],
        kunyomi: ["したが.う", "へりくだ.る", "ゆず.る"],
        examples: [
        { word: "謙遜", reading: "けんそん", meaning: "modesty, humility, being humble" }
    ],
    },
    "他": {
        onyomi: ["タ"],
        kunyomi: ["ほか"],
        examples: [
        { word: "他に", reading: "ほかに", meaning: "else, in addition, besides" },
        { word: "自他", reading: "じた", meaning: "oneself and others" },
        { word: "他国", reading: "たこく", meaning: "foreign country, another country" },
        { word: "他殺", reading: "たさつ", meaning: "murder" }
    ],
    },
    "多": {
        onyomi: ["タ"],
        kunyomi: ["おお.い", "まさ.に", "まさ.る"],
        examples: [
        { word: "過多", reading: "かた", meaning: "excess, surplus, superabundance" },
        { word: "多い", reading: "おおい", meaning: "many, numerous, a lot" },
        { word: "多寡", reading: "たか", meaning: "degree (of something), greatness or smallness (of something), quantity" },
        { word: "多額", reading: "たがく", meaning: "large (amount of money), huge, hefty" }
    ],
    },
    "汰": {
        onyomi: ["タ", "タイ"],
        kunyomi: ["おご.る", "にご.る", "よな.げる"],
        examples: [
        { word: "ご無沙汰", reading: "ごぶさた", meaning: "not writing or contacting for a while, neglecting (failing) to write (call, visit, etc.), long silence" },
        { word: "御無沙汰", reading: "ごぶさた", meaning: "not writing or contacting for a while, neglecting (failing) to write (call, visit, etc.), long silence" }
    ],
    },
    "打": {
        onyomi: ["ダ", "ダース"],
        kunyomi: ["う.つ", "う.ち-", "ぶ.つ"],
        examples: [
        { word: "安打", reading: "あんだ", meaning: "safe hit" },
        { word: "一打", reading: "いちだ", meaning: "stroke, blow" },
        { word: "殴打", reading: "おうだ", meaning: "hit, strike, blow" },
        { word: "犠打", reading: "ぎだ", meaning: "sacrifice (bunt or fly)" }
    ],
    },
    "妥": {
        onyomi: ["ダ"],
        kunyomi: [],
        examples: [
        { word: "妥協", reading: "だきょう", meaning: "compromise, giving in" },
        { word: "妥結", reading: "だけつ", meaning: "settlement, an agreement" },
        { word: "妥当", reading: "だとう", meaning: "valid, proper, right" }
    ],
    },
    "唾": {
        onyomi: ["ダ", "タ"],
        kunyomi: ["つば", "つばき"],
        examples: [
        { word: "唾", reading: "つば", meaning: "saliva, spit, spittle" }
    ],
    },
    "堕": {
        onyomi: ["ダ"],
        kunyomi: ["お.ちる", "くず.す", "くず.れる"],
        examples: [
        { word: "堕胎", reading: "だたい", meaning: "abortion, feticide" },
        { word: "堕落", reading: "だらく", meaning: "depravity, corruption, degradation" }
    ],
    },
    "惰": {
        onyomi: ["ダ"],
        kunyomi: [],
        examples: [
        { word: "惰性", reading: "だせい", meaning: "force of habit" },
        { word: "怠惰", reading: "たいだ", meaning: "lazy, idle, indolent" }
    ],
    },
    "駄": {
        onyomi: ["ダ", "タ"],
        kunyomi: [],
        examples: [
        { word: "下駄", reading: "げた", meaning: "geta, traditional Japanese wooden sandal" },
        { word: "駄目", reading: "だめ", meaning: "no good, not serving its purpose, useless" },
        { word: "無駄", reading: "むだ", meaning: "futility, waste, uselessness" },
        { word: "駄菓子", reading: "だがし", meaning: "penny candy, cheap individually wrapped sweets" }
    ],
    },
    "太": {
        onyomi: ["タイ", "タ"],
        kunyomi: ["ふと.い", "ふと.る"],
        examples: [
        { word: "丸太", reading: "まるた", meaning: "log" },
        { word: "太い", reading: "ふとい", meaning: "fat, thick" },
        { word: "太る", reading: "ふとる", meaning: "to put on weight, to gain weight, to grow fat" },
        { word: "太古", reading: "たいこ", meaning: "ancient times, prehistoric times" }
    ],
    },
    "対": {
        onyomi: ["タイ", "ツイ"],
        kunyomi: ["あいて", "こた.える", "そろ.い", "つれあ.い", "なら.ぶ", "むか.う"],
        examples: [
        { word: "応対", reading: "おうたい", meaning: "dealing with (people, customers, complaints, etc.), receiving (callers, visitors, etc.), attending to" },
        { word: "絶対", reading: "ぜったい", meaning: "absolutely, definitely, unconditionally" },
        { word: "相対", reading: "あいたい", meaning: "involving only the parties concerned, tete-a-tete" },
        { word: "対案", reading: "たいあん", meaning: "counter-proposal, counter-suggestion" }
    ],
    },
    "体": {
        onyomi: ["タイ", "テイ"],
        kunyomi: ["からだ", "かたち"],
        examples: [
        { word: "遺体", reading: "いたい", meaning: "(dead) body, corpse, remains" },
        { word: "一体", reading: "いったい", meaning: "(what) the heck, (why) in the world, (who) on earth" },
        { word: "液体", reading: "えきたい", meaning: "liquid" },
        { word: "解体", reading: "かいたい", meaning: "demolition, taking down, dismantling" }
    ],
    },
    "耐": {
        onyomi: ["タイ"],
        kunyomi: ["た.える"],
        examples: [
        { word: "耐火", reading: "たいか", meaning: "fireproof" },
        { word: "耐久", reading: "たいきゅう", meaning: "endurance, persistence" },
        { word: "耐熱", reading: "たいねつ", meaning: "heat-resisting" },
        { word: "忍耐", reading: "にんたい", meaning: "endurance, perseverance, patience" }
    ],
    },
    "待": {
        onyomi: ["タイ"],
        kunyomi: ["ま.つ", "-ま.ち"],
        examples: [
        { word: "歓待", reading: "かんたい", meaning: "warm welcome, friendly reception, hospitality" },
        { word: "期待", reading: "きたい", meaning: "expectation, anticipation, hope" },
        { word: "虐待", reading: "ぎゃくたい", meaning: "abuse, ill-treatment, maltreatment" },
        { word: "招待", reading: "しょうたい", meaning: "invitation" }
    ],
    },
    "怠": {
        onyomi: ["タイ"],
        kunyomi: ["おこた.る", "なま.ける"],
        examples: [
        { word: "怠い", reading: "だるい", meaning: "sluggish, languid, listless" },
        { word: "倦怠", reading: "けんたい", meaning: "weariness, fatigue, languor" },
        { word: "怠る", reading: "おこたる", meaning: "to neglect, to be negligent in, to be neglectful of" },
        { word: "怠惰", reading: "たいだ", meaning: "lazy, idle, indolent" }
    ],
    },
    "胎": {
        onyomi: ["タイ"],
        kunyomi: [],
        examples: [
        { word: "受胎", reading: "じゅたい", meaning: "conception, fertilization, fertilisation" },
        { word: "堕胎", reading: "だたい", meaning: "abortion, feticide" },
        { word: "胎児", reading: "たいじ", meaning: "fetus, foetus, embryo" },
        { word: "胎動", reading: "たいどう", meaning: "fetal movement, movements of the fetus, quickening" }
    ],
    },
    "退": {
        onyomi: ["タイ"],
        kunyomi: ["しりぞ.く", "しりぞ.ける", "ひ.く", "の.く", "の.ける", "ど.く"],
        examples: [
        { word: "引退", reading: "いんたい", meaning: "retirement" },
        { word: "減退", reading: "げんたい", meaning: "decline, ebb, failure" },
        { word: "後退", reading: "こうたい", meaning: "retreat, falling back, moving backwards" },
        { word: "辞退", reading: "じたい", meaning: "declining, refusal, nonacceptance" }
    ],
    },
    "帯": {
        onyomi: ["タイ"],
        kunyomi: ["お.びる", "おび"],
        examples: [
        { word: "一帯", reading: "いったい", meaning: "whole area, whole region" },
        { word: "温帯", reading: "おんたい", meaning: "temperate zone" },
        { word: "携帯", reading: "けいたい", meaning: "carrying (on one's person or in the hand)" },
        { word: "世帯", reading: "せたい", meaning: "household, family" }
    ],
    },
    "泰": {
        onyomi: ["タイ"],
        kunyomi: [],
        examples: [
        { word: "安泰", reading: "あんたい", meaning: "security, stability, safety" }
    ],
    },
    "堆": {
        onyomi: ["タイ", "ツイ"],
        kunyomi: ["うずたか.い"],
        examples: [
        { word: "堆積", reading: "たいせき", meaning: "accumulation, pile, heap" },
        { word: "堆肥", reading: "たいひ", meaning: "compost, manure" }
    ],
    },
    "袋": {
        onyomi: ["タイ", "ダイ"],
        kunyomi: ["ふくろ"],
        examples: [
        { word: "お袋", reading: "おふくろ", meaning: "(one's) mother" },
        { word: "胃袋", reading: "いぶくろ", meaning: "stomach" },
        { word: "紙袋", reading: "かみぶくろ", meaning: "paper bag" },
        { word: "手袋", reading: "てぶくろ", meaning: "glove, mitten, mitt" }
    ],
    },
    "逮": {
        onyomi: ["タイ"],
        kunyomi: [],
        examples: [
        { word: "逮捕", reading: "たいほ", meaning: "arrest, apprehension, capture" }
    ],
    },
    "替": {
        onyomi: ["タイ"],
        kunyomi: ["か.える", "か.え-", "か.わる"],
        examples: [
        { word: "為替", reading: "かわせ", meaning: "money order, draft" },
        { word: "替え", reading: "かえ", meaning: "change, alteration" },
        { word: "両替", reading: "りょうがえ", meaning: "change, money exchange" },
        { word: "代替", reading: "だいたい", meaning: "substitution" }
    ],
    },
    "貸": {
        onyomi: ["タイ"],
        kunyomi: ["か.す", "か.し-", "かし-"],
        examples: [
        { word: "貸し", reading: "かし", meaning: "loan, lending, hire" },
        { word: "貸付", reading: "かしつけ", meaning: "loan" },
        { word: "貸す", reading: "かす", meaning: "to lend, to loan" },
        { word: "貸家", reading: "かしや", meaning: "house for rent" }
    ],
    },
    "隊": {
        onyomi: ["タイ"],
        kunyomi: [],
        examples: [
        { word: "楽隊", reading: "がくたい", meaning: "band, orchestra" },
        { word: "艦隊", reading: "かんたい", meaning: "(naval) fleet, armada" },
        { word: "軍隊", reading: "ぐんたい", meaning: "armed forces, military, troops" },
        { word: "隊員", reading: "たいいん", meaning: "troops, group members, team members" }
    ],
    },
    "滞": {
        onyomi: ["タイ", "テイ"],
        kunyomi: ["とどこお.る"],
        examples: [
        { word: "延滞", reading: "えんたい", meaning: "arrears, (being) overdue, delay (e.g. in payment)" },
        { word: "渋滞", reading: "じゅうたい", meaning: "(traffic) congestion, traffic jam, gridlock" },
        { word: "滞在", reading: "たいざい", meaning: "stay, sojourn" },
        { word: "滞納", reading: "たいのう", meaning: "falling behind (with a payment), being in arrears, non-payment" }
    ],
    },
    "態": {
        onyomi: ["タイ"],
        kunyomi: ["わざ.と"],
        examples: [
        { word: "旧態", reading: "きゅうたい", meaning: "old state of affairs" },
        { word: "形態", reading: "けいたい", meaning: "form, shape, figure" },
        { word: "実態", reading: "じったい", meaning: "true state, actual condition, reality" },
        { word: "醜態", reading: "しゅうたい", meaning: "disgraceful behavior, disgraceful behaviour, shameful conduct" }
    ],
    },
    "戴": {
        onyomi: ["タイ"],
        kunyomi: ["いただ.く"],
        examples: [
        { word: "頂戴", reading: "ちょうだい", meaning: "receiving, getting, accepting" }
    ],
    },
    "大": {
        onyomi: ["ダイ", "タイ"],
        kunyomi: ["おお-", "おお.きい", "-おお.いに"],
        examples: [
        { word: "偉大", reading: "いだい", meaning: "great, grand, magnificent" },
        { word: "医大", reading: "いだい", meaning: "medical university, medical college, medical school" },
        { word: "一大", reading: "いちだい", meaning: "one large ..., a great ..." },
        { word: "過大", reading: "かだい", meaning: "excessive, too much, unreasonable" }
    ],
    },
    "代": {
        onyomi: ["ダイ", "タイ"],
        kunyomi: ["か.わる", "かわ.る", "かわ.り", "か.わり", "-がわ.り", "-が.わり", "か.える", "よ", "しろ"],
        examples: [
        { word: "一代", reading: "いちだい", meaning: "generation, lifetime, age" },
        { word: "永代", reading: "えいたい", meaning: "permanence, eternity" },
        { word: "近代", reading: "きんだい", meaning: "present day, modern times, recent times" },
        { word: "現代", reading: "げんだい", meaning: "present age, present day, today" }
    ],
    },
    "台": {
        onyomi: ["ダイ", "タイ"],
        kunyomi: ["うてな", "われ", "つかさ"],
        examples: [
        { word: "一台", reading: "いちだい", meaning: "one machine, one vehicle" },
        { word: "屋台", reading: "やたい", meaning: "cart (esp. a food cart), stall, stand" },
        { word: "荷台", reading: "にだい", meaning: "(truck) load-carrying tray, (bicycle) luggage carrier, roof rack" },
        { word: "鏡台", reading: "きょうだい", meaning: "dresser, dressing table, vanity table" }
    ],
    },
    "第": {
        onyomi: ["ダイ", "テイ"],
        kunyomi: [],
        examples: [
        { word: "次第", reading: "しだい", meaning: "depending on" },
        { word: "第一", reading: "だいいち", meaning: "first, foremost, number one" },
        { word: "第二", reading: "だいに", meaning: "second" },
        { word: "落第", reading: "らくだい", meaning: "failure (in an examination), failing to advance (to the next year)" }
    ],
    },
    "題": {
        onyomi: ["ダイ"],
        kunyomi: [],
        examples: [
        { word: "課題", reading: "かだい", meaning: "subject, theme, issue" },
        { word: "議題", reading: "ぎだい", meaning: "topic of discussion, agenda" },
        { word: "主題", reading: "しゅだい", meaning: "subject, theme, motif" },
        { word: "宿題", reading: "しゅくだい", meaning: "homework, assignment" }
    ],
    },
    "滝": {
        onyomi: ["ロウ", "ソウ"],
        kunyomi: ["たき"],
        examples: [
        { word: "滝口", reading: "たきぐち", meaning: "top of a waterfall" },
        { word: "滝川", reading: "たきがわ", meaning: "rapids" },
        { word: "滝", reading: "たき", meaning: "waterfall" }
    ],
    },
    "宅": {
        onyomi: ["タク"],
        kunyomi: [],
        examples: [
        { word: "お宅", reading: "おたく", meaning: "your house, your home, your family" },
        { word: "家宅", reading: "かたく", meaning: "domicile, premises" },
        { word: "帰宅", reading: "きたく", meaning: "returning home, going home, coming home" },
        { word: "在宅", reading: "ざいたく", meaning: "being at home, being in" }
    ],
    },
    "択": {
        onyomi: ["タク"],
        kunyomi: ["えら.ぶ"],
        examples: [
        { word: "採択", reading: "さいたく", meaning: "adoption, selection, choice" },
        { word: "選択", reading: "せんたく", meaning: "choice, selection, option" },
        { word: "択一", reading: "たくいつ", meaning: "choosing one from among several, multiple choice" },
        { word: "選択肢", reading: "せんたくし", meaning: "choices, alternatives, options" }
    ],
    },
    "沢": {
        onyomi: ["タク"],
        kunyomi: ["さわ", "うるお.い", "うるお.す", "つや"],
        examples: [
        { word: "光沢", reading: "こうたく", meaning: "brilliance, polish, lustre" },
        { word: "沼沢", reading: "しょうたく", meaning: "marsh, swamp, bog" },
        { word: "沢山", reading: "たくさん", meaning: "a lot, lots, plenty" },
        { word: "贅沢", reading: "ぜいたく", meaning: "luxury, extravagance" }
    ],
    },
    "卓": {
        onyomi: ["タク"],
        kunyomi: [],
        examples: [
        { word: "円卓", reading: "えんたく", meaning: "round table" },
        { word: "食卓", reading: "しょくたく", meaning: "dining table" },
        { word: "卓越", reading: "たくえつ", meaning: "preeminence, excellence, superiority" },
        { word: "卓球", reading: "たっきゅう", meaning: "table tennis, ping-pong" }
    ],
    },
    "拓": {
        onyomi: ["タク"],
        kunyomi: ["ひら.く"],
        examples: [
        { word: "開拓", reading: "かいたく", meaning: "reclamation (e.g. of wasteland), cultivation, development" },
        { word: "干拓", reading: "かんたく", meaning: "land reclamation (from sea)" },
        { word: "拓殖", reading: "たくしょく", meaning: "colonization, colonisation, development" },
        { word: "拓本", reading: "たくほん", meaning: "rubbing, rubbed copy" }
    ],
    },
    "託": {
        onyomi: ["タク"],
        kunyomi: ["かこつ.ける", "かこ.つ", "かこ.つける"],
        examples: [
        { word: "委託", reading: "いたく", meaning: "entrusting (something to a person), consignment (of goods), putting in someone's charge" },
        { word: "屈託", reading: "くったく", meaning: "worry, care, concern" },
        { word: "結託", reading: "けったく", meaning: "conspiracy, collusion" },
        { word: "受託", reading: "じゅたく", meaning: "being entrusted with, taking charge of" }
    ],
    },
    "濯": {
        onyomi: ["タク"],
        kunyomi: ["すす.ぐ", "ゆす.ぐ"],
        examples: [
        { word: "洗濯", reading: "せんたく", meaning: "washing, laundry" },
        { word: "洗濯機", reading: "せんたくき", meaning: "washing machine, (clothes) washer" },
        { word: "洗濯物", reading: "せんたくもの", meaning: "laundry, the washing" }
    ],
    },
    "諾": {
        onyomi: ["ダク"],
        kunyomi: [],
        examples: [
        { word: "許諾", reading: "きょだく", meaning: "consent, assent, approval" },
        { word: "受諾", reading: "じゅだく", meaning: "acceptance" },
        { word: "承諾", reading: "しょうだく", meaning: "consent, approval, acceptance" },
        { word: "諾否", reading: "だくひ", meaning: "consent or refusal, yes or no, decision to accept or decline" }
    ],
    },
    "濁": {
        onyomi: ["ダク", "ジョク"],
        kunyomi: ["にご.る", "にご.す"],
        examples: [
        { word: "汚濁", reading: "おだく", meaning: "pollution, contamination, corruption" },
        { word: "濁す", reading: "にごす", meaning: "to make muddy (of a liquid), to make cloudy, to make turbid" },
        { word: "濁る", reading: "にごる", meaning: "to become muddy, to become cloudy, to become turbid" },
        { word: "濁流", reading: "だくりゅう", meaning: "muddy stream" }
    ],
    },
    "但": {
        onyomi: ["タン"],
        kunyomi: ["ただ.し"],
        examples: [
        { word: "但し", reading: "ただし", meaning: "but, however, provided that" }
    ],
    },
    "達": {
        onyomi: ["タツ", "ダ"],
        kunyomi: ["-たち"],
        examples: [
        { word: "伊達", reading: "だて", meaning: "elegance, dandyism, sophistication" },
        { word: "私達", reading: "わたしたち", meaning: "we, us" },
        { word: "上達", reading: "じょうたつ", meaning: "improvement (e.g. in skill, ability), advance, progress" },
        { word: "人達", reading: "ひとたち", meaning: "people" }
    ],
    },
    "脱": {
        onyomi: ["ダツ"],
        kunyomi: ["ぬ.ぐ", "ぬ.げる"],
        examples: [
        { word: "逸脱", reading: "いつだつ", meaning: "deviation, departure" },
        { word: "脱ぐ", reading: "ぬぐ", meaning: "to take off (clothes, shoes, etc.), to undress" },
        { word: "脱却", reading: "だっきゃく", meaning: "ridding oneself, freeing oneself of, growing out of" },
        { word: "脱出", reading: "だっしゅつ", meaning: "escape, getting away (from), getting out (of)" }
    ],
    },
    "奪": {
        onyomi: ["ダツ"],
        kunyomi: ["うば.う"],
        examples: [
        { word: "強奪", reading: "ごうだつ", meaning: "robbery, pillage, seizure" },
        { word: "争奪", reading: "そうだつ", meaning: "struggle (for), scramble, contest" },
        { word: "奪う", reading: "うばう", meaning: "to take (by force), to take away, to snatch" },
        { word: "奪回", reading: "だっかい", meaning: "recovery, rescue, recapture" }
    ],
    },
    "棚": {
        onyomi: ["ホウ"],
        kunyomi: ["たな", "-だな"],
        examples: [
        { word: "戸棚", reading: "とだな", meaning: "cupboard, locker, closet" },
        { word: "本棚", reading: "ほんだな", meaning: "bookshelves, bookshelf, bookcase" },
        { word: "大陸棚", reading: "たいりくだな", meaning: "continental shelf" },
        { word: "棚上げ", reading: "たなあげ", meaning: "shelving (a matter, plan, etc.), pigeonholing, tabling" }
    ],
    },
    "誰": {
        onyomi: ["スイ"],
        kunyomi: ["だれ", "たれ", "た"],
        examples: [
        { word: "誰か", reading: "だれか", meaning: "someone, somebody" },
        { word: "誰も", reading: "だれも", meaning: "everyone, anyone" },
        { word: "誰でも", reading: "だれでも", meaning: "anyone, anybody, everyone" },
        { word: "誰にも", reading: "だれにも", meaning: "to anyone, to everyone" }
    ],
    },
    "丹": {
        onyomi: ["タン"],
        kunyomi: ["に"],
        examples: [
        { word: "丹精", reading: "たんせい", meaning: "working earnestly, sincerity, diligence" },
        { word: "丹誠", reading: "たんせい", meaning: "working earnestly, sincerity, diligence" },
        { word: "丹念", reading: "たんねん", meaning: "painstaking, careful, meticulous" }
    ],
    },
    "旦": {
        onyomi: ["タン", "ダン"],
        kunyomi: ["あき.らか", "あきら", "ただし", "あさ", "あした"],
        examples: [
        { word: "一旦", reading: "いったん", meaning: "once" },
        { word: "元旦", reading: "がんたん", meaning: "New Year's Day, first day of the year" },
        { word: "旦那", reading: "だんな", meaning: "master (of a house, shop, etc.)" }
    ],
    },
    "担": {
        onyomi: ["タン"],
        kunyomi: ["かつ.ぐ", "にな.う"],
        examples: [
        { word: "担ぐ", reading: "かつぐ", meaning: "to shoulder, to carry on one's shoulder" },
        { word: "担架", reading: "たんか", meaning: "stretcher, litter, gurney" },
        { word: "担当", reading: "たんとう", meaning: "being in charge (of an area of responsibility), being responsible (for a work role, etc.)" },
        { word: "担任", reading: "たんにん", meaning: "being in charge of (esp. a class or subject), taking charge of" }
    ],
    },
    "単": {
        onyomi: ["タン"],
        kunyomi: ["ひとえ"],
        examples: [
        { word: "簡単", reading: "かんたん", meaning: "simple, easy, uncomplicated" },
        { word: "単に", reading: "たんに", meaning: "simply, merely, only" },
        { word: "単位", reading: "たんい", meaning: "unit (e.g. meters, grams, etc.), denomination" },
        { word: "単一", reading: "たんいつ", meaning: "single, simple, sole" }
    ],
    },
    "炭": {
        onyomi: ["タン"],
        kunyomi: ["すみ"],
        examples: [
        { word: "採炭", reading: "さいたん", meaning: "coal mining, coal extraction" },
        { word: "薪炭", reading: "しんたん", meaning: "wood and charcoal, fuel" },
        { word: "石炭", reading: "せきたん", meaning: "coal" },
        { word: "炭酸", reading: "たんさん", meaning: "carbonic acid" }
    ],
    },
    "胆": {
        onyomi: ["タン"],
        kunyomi: ["きも"],
        examples: [
        { word: "魂胆", reading: "こんたん", meaning: "ulterior motive, plot, scheme" },
        { word: "大胆", reading: "だいたん", meaning: "bold, daring, audacious" },
        { word: "胆石", reading: "たんせき", meaning: "gallstone" },
        { word: "落胆", reading: "らくたん", meaning: "discouragement, despondency, dejection" }
    ],
    },
    "探": {
        onyomi: ["タン"],
        kunyomi: ["さぐ.る", "さが.す"],
        examples: [
        { word: "探る", reading: "さぐる", meaning: "to feel around for, to fumble for, to grope for" },
        { word: "探求", reading: "たんきゅう", meaning: "search, quest, pursuit" },
        { word: "探究", reading: "たんきゅう", meaning: "research, investigation, enquiry" },
        { word: "探査", reading: "たんさ", meaning: "probe, inquiry, enquiry" }
    ],
    },
    "淡": {
        onyomi: ["タン"],
        kunyomi: ["あわ.い"],
        examples: [
        { word: "淡い", reading: "あわい", meaning: "light (color, taste, etc.), faint (e.g. smell), pale" },
        { word: "淡水", reading: "たんすい", meaning: "fresh water (i.e. not salt water)" },
        { word: "濃淡", reading: "のうたん", meaning: "light and shade, shade (of colour, color)" },
        { word: "冷淡", reading: "れいたん", meaning: "cool, indifferent, apathetic" }
    ],
    },
    "短": {
        onyomi: ["タン"],
        kunyomi: ["みじか.い"],
        examples: [
        { word: "最短", reading: "さいたん", meaning: "shortest" },
        { word: "短い", reading: "みじかい", meaning: "short" },
        { word: "短歌", reading: "たんか", meaning: "tanka, 31-mora Japanese poem" },
        { word: "短期", reading: "たんき", meaning: "short-term" }
    ],
    },
    "嘆": {
        onyomi: ["タン"],
        kunyomi: ["なげ.く", "なげ.かわしい"],
        examples: [
        { word: "感嘆", reading: "かんたん", meaning: "admiration, wonder, astonishment" },
        { word: "驚嘆", reading: "きょうたん", meaning: "wonder, admiration, being struck with admiration" },
        { word: "嘆き", reading: "なげき", meaning: "grief, lamentation" },
        { word: "嘆く", reading: "なげく", meaning: "to lament, to grieve, to regret" }
    ],
    },
    "端": {
        onyomi: ["タン"],
        kunyomi: ["はし", "は", "はた", "-ばた", "はな"],
        examples: [
        { word: "異端", reading: "いたん", meaning: "heresy, nonconformism, heathenism" },
        { word: "一端", reading: "いったん", meaning: "one end, an end" },
        { word: "極端", reading: "きょくたん", meaning: "extreme, extremity" },
        { word: "先端", reading: "せんたん", meaning: "pointed end, tip, point" }
    ],
    },
    "綻": {
        onyomi: ["タン"],
        kunyomi: ["ほころ.びる"],
        examples: [
        { word: "破綻", reading: "はたん", meaning: "failure, collapse, breakdown" },
        { word: "綻びる", reading: "ほころびる", meaning: "to come apart at the seams, to be ripped, to be torn" }
    ],
    },
    "誕": {
        onyomi: ["タン"],
        kunyomi: [],
        examples: [
        { word: "生誕", reading: "せいたん", meaning: "birth (esp. of a famous person), nativity" },
        { word: "誕生", reading: "たんじょう", meaning: "birth (of a person), nativity" },
        { word: "誕生日", reading: "たんじょうび", meaning: "birthday" },
        { word: "お誕生日", reading: "おたんじょうび", meaning: "birthday" }
    ],
    },
    "鍛": {
        onyomi: ["タン"],
        kunyomi: ["きた.える"],
        examples: [
        { word: "鍛錬", reading: "たんれん", meaning: "tempering (metal), annealing, forging" },
        { word: "鍛える", reading: "きたえる", meaning: "to forge, to temper" }
    ],
    },
    "団": {
        onyomi: ["ダン", "トン"],
        kunyomi: ["かたまり", "まる.い"],
        examples: [
        { word: "一団", reading: "いちだん", meaning: "body, group, party" },
        { word: "営団", reading: "えいだん", meaning: "corporation, foundation" },
        { word: "楽団", reading: "がくだん", meaning: "orchestra, band" },
        { word: "球団", reading: "きゅうだん", meaning: "baseball team" }
    ],
    },
    "男": {
        onyomi: ["ダン", "ナン"],
        kunyomi: ["おとこ", "お"],
        examples: [
        { word: "一男", reading: "いちなん", meaning: "boy, eldest son" },
        { word: "三男", reading: "さんなん", meaning: "three sons" },
        { word: "次男", reading: "じなん", meaning: "second son" },
        { word: "大男", reading: "おおおとこ", meaning: "big man, large man, tall man" }
    ],
    },
    "段": {
        onyomi: ["ダン", "タン"],
        kunyomi: [],
        examples: [
        { word: "一段", reading: "いちだん", meaning: "even more, still more, much more" },
        { word: "階段", reading: "かいだん", meaning: "stairs, stairway, staircase" },
        { word: "格段", reading: "かくだん", meaning: "dramatic (improvement), remarkable (difference), marked" },
        { word: "手段", reading: "しゅだん", meaning: "means, way, measure" }
    ],
    },
    "断": {
        onyomi: ["ダン"],
        kunyomi: ["た.つ", "ことわ.る", "さだ.める"],
        examples: [
        { word: "横断", reading: "おうだん", meaning: "crossing (a road, river, etc.), cutting through (e.g. of a river through a town), cutting across" },
        { word: "決断", reading: "けつだん", meaning: "decision, determination" },
        { word: "遮断", reading: "しゃだん", meaning: "isolation, cut off, blockade" },
        { word: "縦断", reading: "じゅうだん", meaning: "running through (north-south), cutting across, travelling across" }
    ],
    },
    "弾": {
        onyomi: ["ダン", "タン"],
        kunyomi: ["ひ.く", "-ひ.き", "はず.む", "たま", "はじ.く", "はじ.ける", "ただ.す", "はじ.きゆみ"],
        examples: [
        { word: "糾弾", reading: "きゅうだん", meaning: "censure, denunciation, (verbal) attack" },
        { word: "実弾", reading: "じつだん", meaning: "real bullet, live ammunition, live round" },
        { word: "銃弾", reading: "じゅうだん", meaning: "bullet (from a rifle)" },
        { word: "弾く", reading: "はじく", meaning: "to flip, to snap, to flick" }
    ],
    },
    "暖": {
        onyomi: ["ダン", "ノン"],
        kunyomi: ["あたた.か", "あたた.かい", "あたた.まる", "あたた.める"],
        examples: [
        { word: "温暖", reading: "おんだん", meaning: "warm, mild, temperate" },
        { word: "暖冬", reading: "だんとう", meaning: "mild winter, warm winter" },
        { word: "暖房", reading: "だんぼう", meaning: "(indoor) heating" },
        { word: "暖流", reading: "だんりゅう", meaning: "warm current" }
    ],
    },
    "談": {
        onyomi: ["ダン"],
        kunyomi: [],
        examples: [
        { word: "縁談", reading: "えんだん", meaning: "marriage proposal, marriage talks" },
        { word: "会談", reading: "かいだん", meaning: "talks (i.e. formal discussions), conference, meeting" },
        { word: "怪談", reading: "かいだん", meaning: "ghost story, tale of the supernatural" },
        { word: "歓談", reading: "かんだん", meaning: "pleasant talk, chat" }
    ],
    },
    "壇": {
        onyomi: ["ダン", "タン"],
        kunyomi: [],
        examples: [
        { word: "演壇", reading: "えんだん", meaning: "rostrum, platform" },
        { word: "教壇", reading: "きょうだん", meaning: "(teacher's) platform, podium, dais" },
        { word: "祭壇", reading: "さいだん", meaning: "altar" },
        { word: "仏壇", reading: "ぶつだん", meaning: "Buddhist (household) altar" }
    ],
    },
    "地": {
        onyomi: ["チ", "ジ"],
        kunyomi: [],
        examples: [
        { word: "意地", reading: "いじ", meaning: "stubbornness, obstinacy, willpower" },
        { word: "下地", reading: "したじ", meaning: "groundwork, foundation" },
        { word: "各地", reading: "かくち", meaning: "each place, every place, various places" },
        { word: "基地", reading: "きち", meaning: "base (military, expedition, etc.)" }
    ],
    },
    "池": {
        onyomi: ["チ"],
        kunyomi: ["いけ"],
        examples: [
        { word: "電池", reading: "でんち", meaning: "battery, cell" },
        { word: "乾電池", reading: "かんでんち", meaning: "dry cell battery" },
        { word: "蓄電池", reading: "ちくでんち", meaning: "storage battery" },
        { word: "貯水池", reading: "ちょすいち", meaning: "reservoir" }
    ],
    },
    "知": {
        onyomi: ["チ"],
        kunyomi: ["し.る", "し.らせる"],
        examples: [
        { word: "関知", reading: "かんち", meaning: "(one's) concern, having (something) to do with" },
        { word: "告知", reading: "こくち", meaning: "notice, notification, announcement" },
        { word: "察知", reading: "さっち", meaning: "to sense, to infer, to gather" },
        { word: "周知", reading: "しゅうち", meaning: "common knowledge, being well-known, making (something) well-known" }
    ],
    },
    "値": {
        onyomi: ["チ"],
        kunyomi: ["ね", "あたい"],
        examples: [
        { word: "安値", reading: "やすね", meaning: "low price" },
        { word: "下値", reading: "したね", meaning: "lowest price" },
        { word: "価値", reading: "かち", meaning: "value, worth, merit" },
        { word: "高値", reading: "たかね", meaning: "high price" }
    ],
    },
    "恥": {
        onyomi: ["チ"],
        kunyomi: ["は.じる", "はじ", "は.じらう", "は.ずかしい"],
        examples: [
        { word: "恥辱", reading: "ちじょく", meaning: "disgrace, shame, insult" },
        { word: "無恥", reading: "むち", meaning: "shameless" },
        { word: "恥じる", reading: "はじる", meaning: "to feel ashamed" },
        { word: "恥じらう", reading: "はじらう", meaning: "to feel shy, to be bashful, to blush" }
    ],
    },
    "致": {
        onyomi: ["チ"],
        kunyomi: ["いた.す"],
        examples: [
        { word: "一致", reading: "いっち", meaning: "agreement, accord, correspondence" },
        { word: "雅致", reading: "がち", meaning: "artistry, good taste, elegance" },
        { word: "合致", reading: "がっち", meaning: "agreement, concurrence, conformance" },
        { word: "招致", reading: "しょうち", meaning: "invitation, summons, bidding (e.g. to host the Olympics)" }
    ],
    },
    "遅": {
        onyomi: ["チ"],
        kunyomi: ["おく.れる", "おく.らす", "おそ.い"],
        examples: [
        { word: "遅い", reading: "おそい", meaning: "slow" },
        { word: "遅れ", reading: "おくれ", meaning: "delay, lag, falling behind" },
        { word: "遅延", reading: "ちえん", meaning: "delay, latency" },
        { word: "遅刻", reading: "ちこく", meaning: "lateness, tardiness, arriving late" }
    ],
    },
    "痴": {
        onyomi: ["チ"],
        kunyomi: ["し.れる", "おろか"],
        examples: [
        { word: "愚痴", reading: "ぐち", meaning: "idle complaint, grumble" },
        { word: "痴漢", reading: "ちかん", meaning: "molester, groper, masher" },
        { word: "痴呆", reading: "ちほう", meaning: "dementia" },
        { word: "音痴", reading: "おんち", meaning: "tone deafness, amusia, having no ear for music" }
    ],
    },
    "稚": {
        onyomi: ["チ", "ジ"],
        kunyomi: ["いとけない", "おさない", "おくて", "おでる"],
        examples: [
        { word: "稚魚", reading: "ちぎょ", meaning: "fry, juvenile fish, fingerling" },
        { word: "稚拙", reading: "ちせつ", meaning: "unskillful, childish, immature" },
        { word: "幼稚", reading: "ようち", meaning: "infancy" },
        { word: "幼稚園", reading: "ようちえん", meaning: "kindergarten (in Japan, non-compulsory education from age 3 until primary school), preschool" }
    ],
    },
    "置": {
        onyomi: ["チ"],
        kunyomi: ["お.く", "-お.き"],
        examples: [
        { word: "拘置", reading: "こうち", meaning: "detention, confinement, arrest" },
        { word: "処置", reading: "しょち", meaning: "measure, step, dealing with" },
        { word: "設置", reading: "せっち", meaning: "establishment, institution" },
        { word: "措置", reading: "そち", meaning: "measure, step, action" }
    ],
    },
    "緻": {
        onyomi: ["チ"],
        kunyomi: ["こまか.い"],
        examples: [
        { word: "緻密", reading: "ちみつ", meaning: "fine (grain, workmanship, etc.), close (weave), delicate" }
    ],
    },
    "竹": {
        onyomi: ["チク"],
        kunyomi: ["たけ"],
        examples: [
        { word: "竹刀", reading: "しない", meaning: "bamboo sword (for kendo), bamboo fencing stick" },
        { word: "竹林", reading: "ちくりん", meaning: "bamboo thicket, bamboo grove" },
        { word: "爆竹", reading: "ばくちく", meaning: "firecracker" },
        { word: "竹", reading: "たけ", meaning: "bamboo (any grass of subfamily Bambusoideae)" }
    ],
    },
    "畜": {
        onyomi: ["チク"],
        kunyomi: [],
        examples: [
        { word: "家畜", reading: "かちく", meaning: "domestic animals, livestock, cattle" },
        { word: "畜産", reading: "ちくさん", meaning: "animal husbandry, livestock industry" },
        { word: "畜生", reading: "ちくしょう", meaning: "damn it, damn, son of a bitch" },
        { word: "牧畜", reading: "ぼくちく", meaning: "stock-farming, livestock farming, cattle breeding" }
    ],
    },
    "逐": {
        onyomi: ["チク"],
        kunyomi: [],
        examples: [
        { word: "駆逐", reading: "くちく", meaning: "expulsion, driving out, driving away" },
        { word: "逐一", reading: "ちくいち", meaning: "one by one, in detail, minutely" },
        { word: "逐次", reading: "ちくじ", meaning: "successively, one after another, sequentially" },
        { word: "放逐", reading: "ほうちく", meaning: "expulsion, ousting, ejection" }
    ],
    },
    "蓄": {
        onyomi: ["チク"],
        kunyomi: ["たくわ.える"],
        examples: [
        { word: "含蓄", reading: "がんちく", meaning: "implication, significance, connotation" },
        { word: "蓄財", reading: "ちくざい", meaning: "amassing of wealth" },
        { word: "蓄積", reading: "ちくせき", meaning: "accumulation, accumulate, store" },
        { word: "備蓄", reading: "びちく", meaning: "stocking up (in case of emergency), stockpile, reserves" }
    ],
    },
    "築": {
        onyomi: ["チク"],
        kunyomi: ["きず.く"],
        examples: [
        { word: "改築", reading: "かいちく", meaning: "structural alteration (of a building), reconstruction, rebuilding" },
        { word: "建築", reading: "けんちく", meaning: "construction, architecture (of buildings)" },
        { word: "構築", reading: "こうちく", meaning: "construction, building, putting up" },
        { word: "新築", reading: "しんちく", meaning: "new building, new construction" }
    ],
    },
    "秩": {
        onyomi: ["チツ"],
        kunyomi: [],
        examples: [
        { word: "秩序", reading: "ちつじょ", meaning: "order, discipline, regularity" },
        { word: "無秩序", reading: "むちつじょ", meaning: "disorder, chaos, confusion" }
    ],
    },
    "窒": {
        onyomi: ["チツ"],
        kunyomi: [],
        examples: [
        { word: "窒素", reading: "ちっそ", meaning: "nitrogen (N)" },
        { word: "窒息", reading: "ちっそく", meaning: "suffocation, choking, asphyxia" }
    ],
    },
    "茶": {
        onyomi: ["チャ", "サ"],
        kunyomi: [],
        examples: [
        { word: "お茶", reading: "おちゃ", meaning: "tea (esp. green or barley)" },
        { word: "喫茶", reading: "きっさ", meaning: "tea drinking" },
        { word: "紅茶", reading: "こうちゃ", meaning: "black tea" },
        { word: "茶屋", reading: "ちゃや", meaning: "teahouse, (Edo period) rest stop" }
    ],
    },
    "着": {
        onyomi: ["チャク", "ジャク"],
        kunyomi: ["き.る", "き.せる", "つ.く", "つ.ける"],
        examples: [
        { word: "一着", reading: "いっちゃく", meaning: "first place (in a race), first to arrive" },
        { word: "横着", reading: "おうちゃく", meaning: "laziness, shirking" },
        { word: "下着", reading: "したぎ", meaning: "underwear, undergarment, underclothes" },
        { word: "古着", reading: "ふるぎ", meaning: "old clothes, secondhand clothing" }
    ],
    },
    "嫡": {
        onyomi: ["チャク", "テキ"],
        kunyomi: [],
        examples: [
        { word: "嫡子", reading: "ちゃくし", meaning: "heir" },
        { word: "嫡出", reading: "ちゃくしゅつ", meaning: "legitimate birth" }
    ],
    },
    "中": {
        onyomi: ["チュウ"],
        kunyomi: ["なか", "うち", "あた.る"],
        examples: [
        { word: "渦中", reading: "かちゅう", meaning: "vortex, maelstrom, whirlpool" },
        { word: "海中", reading: "かいちゅう", meaning: "in the sea" },
        { word: "寒中", reading: "かんちゅう", meaning: "mid-winter, cold season" },
        { word: "間中", reading: "あいだじゅう", meaning: "during" }
    ],
    },
    "仲": {
        onyomi: ["チュウ"],
        kunyomi: ["なか"],
        examples: [
        { word: "仲介", reading: "ちゅうかい", meaning: "agency, intermediation" },
        { word: "仲間", reading: "なかま", meaning: "companion, fellow, friend" },
        { word: "仲裁", reading: "ちゅうさい", meaning: "arbitration, intercession, mediation" },
        { word: "仲人", reading: "なこうど", meaning: "matchmaker" }
    ],
    },
    "虫": {
        onyomi: ["チュウ", "キ"],
        kunyomi: ["むし"],
        examples: [
        { word: "害虫", reading: "がいちゅう", meaning: "harmful insect, noxious insect, pest" },
        { word: "昆虫", reading: "こんちゅう", meaning: "insect, bug" },
        { word: "弱虫", reading: "よわむし", meaning: "coward, weakling, scaredy cat" },
        { word: "毛虫", reading: "けむし", meaning: "hairy caterpillar, woolly bear" }
    ],
    },
    "沖": {
        onyomi: ["チュウ"],
        kunyomi: ["おき", "おきつ", "ちゅう.する", "わく"],
        examples: [
        { word: "沖縄", reading: "おきなわ", meaning: "Okinawa (city, prefecture)" },
        { word: "沖合", reading: "おきあい", meaning: "off the coast, offshore, out at sea" },
        { word: "沖合い", reading: "おきあい", meaning: "off the coast, offshore, out at sea" },
        { word: "沖", reading: "おき", meaning: "open sea" }
    ],
    },
    "宙": {
        onyomi: ["チュウ"],
        kunyomi: [],
        examples: [
        { word: "宇宙", reading: "うちゅう", meaning: "universe, cosmos, space" },
        { word: "大宇宙", reading: "だいうちゅう", meaning: "macrocosmos, macrocosm, the universe" },
        { word: "宙返り", reading: "ちゅうがえり", meaning: "somersault, looping-the-loop" },
        { word: "宇宙空間", reading: "うちゅうくうかん", meaning: "(outer) space" }
    ],
    },
    "忠": {
        onyomi: ["チュウ"],
        kunyomi: [],
        examples: [
        { word: "忠実", reading: "ちゅうじつ", meaning: "faithful, devoted, loyal" },
        { word: "忠義", reading: "ちゅうぎ", meaning: "loyalty, devotion" },
        { word: "忠告", reading: "ちゅうこく", meaning: "advice, warning" },
        { word: "忠誠", reading: "ちゅうせい", meaning: "loyalty, sincerity, allegiance" }
    ],
    },
    "抽": {
        onyomi: ["チュウ"],
        kunyomi: ["ひき-"],
        examples: [
        { word: "抽出", reading: "ちゅうしゅつ", meaning: "extraction, abstraction" },
        { word: "抽象", reading: "ちゅうしょう", meaning: "abstraction" },
        { word: "抽選", reading: "ちゅうせん", meaning: "lottery, raffle, drawing (of lots)" },
        { word: "抽象的", reading: "ちゅうしょうてき", meaning: "abstract" }
    ],
    },
    "注": {
        onyomi: ["チュウ"],
        kunyomi: ["そそ.ぐ", "さ.す", "つ.ぐ"],
        examples: [
        { word: "傾注", reading: "けいちゅう", meaning: "devoting (oneself) to, concentrating (one's efforts) on" },
        { word: "受注", reading: "じゅちゅう", meaning: "accepting an order, receiving an order, orders received" },
        { word: "注意", reading: "ちゅうい", meaning: "attention, notice, heed" },
        { word: "注射", reading: "ちゅうしゃ", meaning: "injection, jab, shot" }
    ],
    },
    "昼": {
        onyomi: ["チュウ"],
        kunyomi: ["ひる"],
        examples: [
        { word: "昼寝", reading: "ひるね", meaning: "(afternoon) nap, sleeping during the day, siesta" },
        { word: "昼前", reading: "ひるまえ", meaning: "morning, forenoon" },
        { word: "昼飯", reading: "ひるめし", meaning: "lunch, midday meal" },
        { word: "昼夜", reading: "ちゅうや", meaning: "day and night" }
    ],
    },
    "柱": {
        onyomi: ["チュウ"],
        kunyomi: ["はしら"],
        examples: [
        { word: "円柱", reading: "えんちゅう", meaning: "column, shaft, cylinder" },
        { word: "支柱", reading: "しちゅう", meaning: "prop, stay, support" },
        { word: "電柱", reading: "でんちゅう", meaning: "utility pole, power pole, telephone pole" },
        { word: "大黒柱", reading: "だいこくばしら", meaning: "central pillar (of a building)" }
    ],
    },
    "衷": {
        onyomi: ["チュウ"],
        kunyomi: [],
        examples: [
        { word: "折衷", reading: "せっちゅう", meaning: "compromise, cross, blending" },
        { word: "衷心", reading: "ちゅうしん", meaning: "innermost feelings" },
        { word: "和洋折衷", reading: "わようせっちゅう", meaning: "blending of Japanese and Western styles" }
    ],
    },
    "酎": {
        onyomi: ["チュウ", "チュ"],
        kunyomi: ["かも.す"],
        examples: [
        { word: "焼酎", reading: "しょうちゅう", meaning: "shōchū, Japanese spirit distilled from sweet potatoes, rice, etc." }
    ],
    },
    "鋳": {
        onyomi: ["チュウ", "イ", "シュ", "シュウ"],
        kunyomi: ["い.る"],
        examples: [
        { word: "鋳型", reading: "いがた", meaning: "mold, mould, template" },
        { word: "鋳造", reading: "ちゅうぞう", meaning: "casting, founding, minting" },
        { word: "鋳物", reading: "いもの", meaning: "casting, cast-metal object" },
        { word: "鋳る", reading: "いる", meaning: "to cast, to mint, to coin" }
    ],
    },
    "駐": {
        onyomi: ["チュウ"],
        kunyomi: [],
        examples: [
        { word: "常駐", reading: "じょうちゅう", meaning: "permanent stationing, staying permanently" },
        { word: "進駐", reading: "しんちゅう", meaning: "occupation, stationing" },
        { word: "駐在", reading: "ちゅうざい", meaning: "residence, stay, (job) posting" },
        { word: "駐車", reading: "ちゅうしゃ", meaning: "parking (a vehicle)" }
    ],
    },
    "著": {
        onyomi: ["チョ", "チャク"],
        kunyomi: ["あらわ.す", "いちじる.しい"],
        examples: [
        { word: "共著", reading: "きょうちょ", meaning: "joint authorship, co-authorship, collaboration" },
        { word: "顕著", reading: "けんちょ", meaning: "remarkable, striking, obvious" },
        { word: "著す", reading: "あらわす", meaning: "to write, to publish" },
        { word: "著作", reading: "ちょさく", meaning: "writing (a book), book, (literary) work" }
    ],
    },
    "貯": {
        onyomi: ["チョ"],
        kunyomi: ["た.める", "たくわ.える"],
        examples: [
        { word: "貯金", reading: "ちょきん", meaning: "putting money aside, savings, deposit (e.g. in a bank)" },
        { word: "貯水", reading: "ちょすい", meaning: "storage of water" },
        { word: "貯蔵", reading: "ちょぞう", meaning: "storage, preservation, stocking" },
        { word: "貯蓄", reading: "ちょちく", meaning: "savings" }
    ],
    },
    "丁": {
        onyomi: ["チョウ", "テイ", "チン", "トウ", "チ"],
        kunyomi: ["ひのと"],
        examples: [
        { word: "一丁", reading: "いっちょう", meaning: "one leaf (of a book bound in Japanese style)" },
        { word: "丁重", reading: "ていちょう", meaning: "polite, courteous, hospitable" },
        { word: "丁度", reading: "ちょうど", meaning: "exactly, precisely, just" },
        { word: "丁寧", reading: "ていねい", meaning: "polite, courteous, civil" }
    ],
    },
    "弔": {
        onyomi: ["チョウ"],
        kunyomi: ["とむら.う", "とぶら.う"],
        examples: [
        { word: "慶弔", reading: "けいちょう", meaning: "congratulations and condolences" },
        { word: "弔辞", reading: "ちょうじ", meaning: "memorial address, words of condolence, funeral oration" },
        { word: "弔電", reading: "ちょうでん", meaning: "telegram of condolence" },
        { word: "弔問", reading: "ちょうもん", meaning: "condolence call, visiting a bereaved family to offer condolences" }
    ],
    },
    "庁": {
        onyomi: ["チョウ", "テイ"],
        kunyomi: ["やくしょ"],
        examples: [
        { word: "官庁", reading: "かんちょう", meaning: "government office, government agency, authorities" },
        { word: "県庁", reading: "けんちょう", meaning: "prefectural office" },
        { word: "省庁", reading: "しょうちょう", meaning: "ministries and government offices, the authorities" },
        { word: "庁舎", reading: "ちょうしゃ", meaning: "government office building" }
    ],
    },
    "兆": {
        onyomi: ["チョウ"],
        kunyomi: ["きざ.す", "きざ.し"],
        examples: [
        { word: "吉兆", reading: "きっちょう", meaning: "lucky omen, good omen" },
        { word: "兆し", reading: "きざし", meaning: "sign, indication, omen" },
        { word: "前兆", reading: "ぜんちょう", meaning: "omen, portent, sign" },
        { word: "兆候", reading: "ちょうこう", meaning: "sign, indication, omen" }
    ],
    },
    "町": {
        onyomi: ["チョウ"],
        kunyomi: ["まち"],
        examples: [
        { word: "下町", reading: "したまち", meaning: "low-lying part of a city (usu. containing shops, factories, etc.)" },
        { word: "町角", reading: "まちかど", meaning: "street corner" },
        { word: "町人", reading: "ちょうにん", meaning: "chōnin (Edo-period social class of town-dwelling commoners, esp. landowning merchants), townspeople, townsfolk" },
        { word: "町村", reading: "ちょうそん", meaning: "towns and villages" }
    ],
    },
    "長": {
        onyomi: ["チョウ"],
        kunyomi: ["なが.い", "おさ"],
        examples: [
        { word: "医長", reading: "いちょう", meaning: "medical director, chief physician" },
        { word: "院長", reading: "いんちょう", meaning: "director (of a hospital, institution, academy, etc.), superintendent, rector" },
        { word: "駅長", reading: "えきちょう", meaning: "station master" },
        { word: "園長", reading: "えんちょう", meaning: "head of a garden, kindergarten principal, nursery school principal" }
    ],
    },
    "挑": {
        onyomi: ["チョウ"],
        kunyomi: ["いど.む"],
        examples: [
        { word: "挑む", reading: "いどむ", meaning: "to challenge to (a fight, game, etc.), to throw down the gauntlet, to contend for" },
        { word: "挑戦", reading: "ちょうせん", meaning: "challenge, defiance, dare" },
        { word: "挑発", reading: "ちょうはつ", meaning: "provocation, stirring up, arousal" },
        { word: "挑発的", reading: "ちょうはつてき", meaning: "provocative, incendiary, inflammatory" }
    ],
    },
    "帳": {
        onyomi: ["チョウ"],
        kunyomi: ["とばり"],
        examples: [
        { word: "記帳", reading: "きちょう", meaning: "registry, entry, book-keeping" },
        { word: "台帳", reading: "だいちょう", meaning: "account book, ledger, register" },
        { word: "帳簿", reading: "ちょうぼ", meaning: "account book, register, ledger" },
        { word: "通帳", reading: "つうちょう", meaning: "passbook, bankbook" }
    ],
    },
    "張": {
        onyomi: ["チョウ"],
        kunyomi: ["は.る", "-は.り", "-ば.り"],
        examples: [
        { word: "拡張", reading: "かくちょう", meaning: "expansion, extension, enlargement" },
        { word: "緊張", reading: "きんちょう", meaning: "tension, strain, nervousness" },
        { word: "誇張", reading: "こちょう", meaning: "exaggeration" },
        { word: "主張", reading: "しゅちょう", meaning: "claim, insistence, assertion" }
    ],
    },
    "彫": {
        onyomi: ["チョウ"],
        kunyomi: ["ほ.る", "-ぼ.り"],
        examples: [
        { word: "彫る", reading: "ほる", meaning: "to carve, to engrave, to sculpt" },
        { word: "彫金", reading: "ちょうきん", meaning: "chasing, metal carving, metal engraving" },
        { word: "彫刻", reading: "ちょうこく", meaning: "carving, engraving, sculpture" },
        { word: "彫塑", reading: "ちょうそ", meaning: "carving, engraving" }
    ],
    },
    "眺": {
        onyomi: ["チョウ"],
        kunyomi: ["なが.める"],
        examples: [
        { word: "眺望", reading: "ちょうぼう", meaning: "view, vista, panorama" },
        { word: "眺め", reading: "ながめ", meaning: "scene, view, prospect" },
        { word: "眺める", reading: "ながめる", meaning: "to look at, to gaze at, to watch" }
    ],
    },
    "釣": {
        onyomi: ["チョウ"],
        kunyomi: ["つ.る", "つ.り", "つ.り-"],
        examples: [
        { word: "釣り", reading: "つり", meaning: "fishing, angling" },
        { word: "釣る", reading: "つる", meaning: "to fish, to angle, to catch" },
        { word: "釣合", reading: "つりあい", meaning: "balance, equilibrium" },
        { word: "お釣り", reading: "おつり", meaning: "change (for a purchase)" }
    ],
    },
    "頂": {
        onyomi: ["チョウ"],
        kunyomi: ["いただ.く", "いただき"],
        examples: [
        { word: "山頂", reading: "さんちょう", meaning: "summit (of a mountain)" },
        { word: "絶頂", reading: "ぜっちょう", meaning: "top (of a mountain), summit" },
        { word: "頂上", reading: "ちょうじょう", meaning: "top, summit, peak" },
        { word: "頂戴", reading: "ちょうだい", meaning: "receiving, getting, accepting" }
    ],
    },
    "鳥": {
        onyomi: ["チョウ"],
        kunyomi: ["とり"],
        examples: [
        { word: "花鳥", reading: "かちょう", meaning: "flowers and birds" },
        { word: "小鳥", reading: "ことり", meaning: "small bird, little bird" },
        { word: "千鳥", reading: "ちどり", meaning: "plover" },
        { word: "鳥居", reading: "とりい", meaning: "torii (Shinto shrine archway)" }
    ],
    },
    "朝": {
        onyomi: ["チョウ"],
        kunyomi: ["あさ"],
        examples: [
        { word: "王朝", reading: "おうちょう", meaning: "dynasty" },
        { word: "早朝", reading: "そうちょう", meaning: "early morning" },
        { word: "朝刊", reading: "ちょうかん", meaning: "morning edition (of a daily newspaper), morning paper" },
        { word: "朝顔", reading: "あさがお", meaning: "Japanese morning glory (Ipomoea nil), picotee morning glory, ivy morning glory" }
    ],
    },
    "貼": {
        onyomi: ["テン", "チョウ"],
        kunyomi: ["は.る", "つ.く"],
        examples: [
        { word: "貼る", reading: "はる", meaning: "to stick, to paste, to affix" },
        { word: "貼付", reading: "ちょうふ", meaning: "pasting, sticking, attaching" },
        { word: "貼り付ける", reading: "はりつける", meaning: "to paste, to stick, to affix" }
    ],
    },
    "超": {
        onyomi: ["チョウ"],
        kunyomi: ["こ.える", "こ.す"],
        examples: [
        { word: "超す", reading: "こす", meaning: "to cross over (e.g. mountain), to go across" },
        { word: "超越", reading: "ちょうえつ", meaning: "transcendence, transcendency" },
        { word: "超過", reading: "ちょうか", meaning: "excess, surplus, exceeding (a limit, estimate, etc.)" },
        { word: "超人", reading: "ちょうじん", meaning: "superman, superwoman" }
    ],
    },
    "腸": {
        onyomi: ["チョウ"],
        kunyomi: ["はらわた", "わた"],
        examples: [
        { word: "胃腸", reading: "いちょう", meaning: "stomach and intestines, gastrointestinal tract, digestive organs" },
        { word: "大腸", reading: "だいちょう", meaning: "large intestine, large bowel, colon" },
        { word: "盲腸", reading: "もうちょう", meaning: "cecum, caecum, blind gut" },
        { word: "大腸菌", reading: "だいちょうきん", meaning: "Escherichia coli (E. coli)" }
    ],
    },
    "跳": {
        onyomi: ["チョウ"],
        kunyomi: ["は.ねる", "と.ぶ", "-と.び"],
        examples: [
        { word: "跳ぶ", reading: "とぶ", meaning: "to fly, to soar" },
        { word: "跳躍", reading: "ちょうやく", meaning: "jump, leap, skip" },
        { word: "跳ねる", reading: "はねる", meaning: "to jump, to leap, to prance" },
        { word: "縄跳び", reading: "なわとび", meaning: "skipping rope, jump rope" }
    ],
    },
    "徴": {
        onyomi: ["チョウ", "チ"],
        kunyomi: ["しるし"],
        examples: [
        { word: "象徴", reading: "しょうちょう", meaning: "symbol (of something abstract), emblem, (symbolic) representation" },
        { word: "徴収", reading: "ちょうしゅう", meaning: "collection (of fees, taxes, etc.), levy" },
        { word: "徴税", reading: "ちょうぜい", meaning: "tax collection, taxation" },
        { word: "徴兵", reading: "ちょうへい", meaning: "conscription, (military) draft, (compulsory) enlistment" }
    ],
    },
    "嘲": {
        onyomi: ["チョウ", "トウ"],
        kunyomi: ["あざけ.る"],
        examples: [
        { word: "嘲る", reading: "あざける", meaning: "to scoff, to laugh at, to make fun of" }
    ],
    },
    "潮": {
        onyomi: ["チョウ"],
        kunyomi: ["しお", "うしお"],
        examples: [
        { word: "黒潮", reading: "くろしお", meaning: "Kuroshio Current, Japan Current" },
        { word: "潮時", reading: "しおどき", meaning: "tidal hour" },
        { word: "潮流", reading: "ちょうりゅう", meaning: "tide, tidal current" },
        { word: "風潮", reading: "ふうちょう", meaning: "tide, current" }
    ],
    },
    "澄": {
        onyomi: ["チョウ"],
        kunyomi: ["す.む", "す.ます", "-す.ます"],
        examples: [
        { word: "澄む", reading: "すむ", meaning: "to become clear (water, air, etc.), to become transparent" },
        { word: "清澄", reading: "せいちょう", meaning: "clear, serene" },
        { word: "澄ます", reading: "すます", meaning: "to clear, to make clear" },
        { word: "澄み切る", reading: "すみきる", meaning: "to be perfectly clear (water, air, etc.), to clear up" }
    ],
    },
    "調": {
        onyomi: ["チョウ"],
        kunyomi: ["しら.べる", "しら.べ", "ととの.う", "ととの.える"],
        examples: [
        { word: "快調", reading: "かいちょう", meaning: "good (condition), going well, fine" },
        { word: "基調", reading: "きちょう", meaning: "basic tone, underlying tone, basic theme" },
        { word: "協調", reading: "きょうちょう", meaning: "cooperation, conciliation, harmony" },
        { word: "強調", reading: "きょうちょう", meaning: "emphasis, stress, highlighting" }
    ],
    },
    "聴": {
        onyomi: ["チョウ", "テイ"],
        kunyomi: ["き.く", "ゆる.す"],
        examples: [
        { word: "傾聴", reading: "けいちょう", meaning: "listening closely" },
        { word: "視聴", reading: "しちょう", meaning: "looking and listening, (television) viewing, watching" },
        { word: "聴覚", reading: "ちょうかく", meaning: "(sense of) hearing, auditory perception" },
        { word: "聴講", reading: "ちょうこう", meaning: "lecture attendance, auditing" }
    ],
    },
    "懲": {
        onyomi: ["チョウ"],
        kunyomi: ["こ.りる", "こ.らす", "こ.らしめる"],
        examples: [
        { word: "懲戒", reading: "ちょうかい", meaning: "discipline, punishment, reprimand" },
        { word: "懲罰", reading: "ちょうばつ", meaning: "discipline, punishment, reprimand" },
        { word: "懲役", reading: "ちょうえき", meaning: "penal servitude, imprisonment with hard labor (hard labour)" },
        { word: "懲りる", reading: "こりる", meaning: "to learn by experience, to learn one's lesson, to learn the hard way" }
    ],
    },
    "直": {
        onyomi: ["チョク", "ジキ", "ジカ"],
        kunyomi: ["ただ.ちに", "なお.す", "-なお.す", "なお.る", "なお.き", "す.ぐ"],
        examples: [
        { word: "硬直", reading: "こうちょく", meaning: "stiffening, rigidity, rigor" },
        { word: "垂直", reading: "すいちょく", meaning: "vertical" },
        { word: "正直", reading: "しょうじき", meaning: "honest, frank, candid" },
        { word: "素直", reading: "すなお", meaning: "obedient, meek, docile" }
    ],
    },
    "勅": {
        onyomi: ["チョク"],
        kunyomi: ["いまし.める", "みことのり"],
        examples: [
        { word: "勅", reading: "みことのり", meaning: "imperial decree, imperial edict" }
    ],
    },
    "捗": {
        onyomi: ["チョク", "ホ"],
        kunyomi: ["はかど.る"],
        examples: [
        { word: "進捗", reading: "しんちょく", meaning: "progress, advance, making (good) progress" },
        { word: "捗る", reading: "はかどる", meaning: "to make (good) progress, to move right ahead (with the work), to advance" }
    ],
    },
    "沈": {
        onyomi: ["チン", "ジン"],
        kunyomi: ["しず.む", "しず.める"],
        examples: [
        { word: "撃沈", reading: "げきちん", meaning: "(attacking and) sinking (a ship), sending (a ship) to the bottom" },
        { word: "沈む", reading: "しずむ", meaning: "to sink, to go under, to submerge" },
        { word: "沈下", reading: "ちんか", meaning: "sinking, subsidence" },
        { word: "沈静", reading: "ちんせい", meaning: "settling down, quieting down, cooling down" }
    ],
    },
    "珍": {
        onyomi: ["チン"],
        kunyomi: ["めずら.しい", "たから"],
        examples: [
        { word: "珍重", reading: "ちんちょう", meaning: "prizing, valuing highly, esteeming" },
        { word: "珍品", reading: "ちんぴん", meaning: "curio, rare article" },
        { word: "珍味", reading: "ちんみ", meaning: "delicacy, dainties" },
        { word: "珍しい", reading: "めずらしい", meaning: "rare, uncommon, unusual" }
    ],
    },
    "朕": {
        onyomi: ["チン"],
        kunyomi: [],
        examples: [
        { word: "朕", reading: "ちん", meaning: "We" }
    ],
    },
    "陳": {
        onyomi: ["チン"],
        kunyomi: ["ひ.ねる"],
        examples: [
        { word: "陳謝", reading: "ちんしゃ", meaning: "apology" },
        { word: "陳述", reading: "ちんじゅつ", meaning: "statement, declaration" },
        { word: "陳情", reading: "ちんじょう", meaning: "petition, appeal" },
        { word: "陳腐", reading: "ちんぷ", meaning: "stale, hackneyed, clichéd" }
    ],
    },
    "賃": {
        onyomi: ["チン"],
        kunyomi: [],
        examples: [
        { word: "運賃", reading: "うんちん", meaning: "(passenger) fare" },
        { word: "家賃", reading: "やちん", meaning: "rent" },
        { word: "賃金", reading: "ちんぎん", meaning: "wages, pay" },
        { word: "賃借", reading: "ちんしゃく", meaning: "renting, rental, hiring" }
    ],
    },
    "鎮": {
        onyomi: ["チン"],
        kunyomi: ["しず.める", "しず.まる", "おさえ"],
        examples: [
        { word: "重鎮", reading: "じゅうちん", meaning: "leader, authority, mainstay" },
        { word: "鎮圧", reading: "ちんあつ", meaning: "suppression (of a riot, revolt, etc.), repression, putting down" },
        { word: "鎮魂", reading: "ちんこん", meaning: "repose of a soul" },
        { word: "鎮守", reading: "ちんじゅ", meaning: "local Shinto deity, tutelary god" }
    ],
    },
    "追": {
        onyomi: ["ツイ"],
        kunyomi: ["お.う"],
        examples: [
        { word: "訴追", reading: "そつい", meaning: "prosecution, indictment" },
        { word: "追う", reading: "おう", meaning: "to chase, to run after, to pursue" },
        { word: "追加", reading: "ついか", meaning: "addition, supplement, appending" },
        { word: "追及", reading: "ついきゅう", meaning: "investigation (e.g. into someone's guilt), questioning, pressing" }
    ],
    },
    "椎": {
        onyomi: ["ツイ", "スイ"],
        kunyomi: ["つち", "う.つ"],
        examples: [
        { word: "椎茸", reading: "しいたけ", meaning: "shiitake mushroom (Lentinula edodes), shitake" }
    ],
    },
    "墜": {
        onyomi: ["ツイ"],
        kunyomi: ["お.ちる", "お.つ"],
        examples: [
        { word: "撃墜", reading: "げきつい", meaning: "shooting down (an aircraft)" },
        { word: "失墜", reading: "しっつい", meaning: "abasement, fall, forfeiture" },
        { word: "墜落", reading: "ついらく", meaning: "fall, crash (of an aircraft)" }
    ],
    },
    "通": {
        onyomi: ["ツウ", "ツ"],
        kunyomi: ["とお.る", "とお.り", "-とお.り", "-どお.り", "とお.す", "とお.し", "-どお.し", "かよ.う"],
        examples: [
        { word: "一通", reading: "いっつう", meaning: "one copy (of a document), one letter" },
        { word: "開通", reading: "かいつう", meaning: "opening (of a new road, railway, etc.), going into operation (e.g. telephone communication), beginning services" },
        { word: "貫通", reading: "かんつう", meaning: "passing through (of a tunnel, bullet, etc.), going (right) through, penetrating" },
        { word: "共通", reading: "きょうつう", meaning: "common, shared, mutual" }
    ],
    },
    "痛": {
        onyomi: ["ツウ"],
        kunyomi: ["いた.い", "いた.む", "いた.ましい", "いた.める"],
        examples: [
        { word: "苦痛", reading: "くつう", meaning: "pain, agony, suffering" },
        { word: "腰痛", reading: "ようつう", meaning: "lower back pain, lumbago" },
        { word: "陣痛", reading: "じんつう", meaning: "labour pains, labor pains, birth pains" },
        { word: "痛い", reading: "いたい", meaning: "painful, sore" }
    ],
    },
    "塚": {
        onyomi: ["チョウ"],
        kunyomi: ["つか", "-づか"],
        examples: [
        { word: "一里塚", reading: "いちりづか", meaning: "milestone (1 ri apart)" },
        { word: "塚", reading: "つか", meaning: "mound, heap, hillock" }
    ],
    },
    "漬": {
        onyomi: ["シ"],
        kunyomi: ["つ.ける", "つ.かる", "-づ.け", "-づけ"],
        examples: [
        { word: "漬物", reading: "つけもの", meaning: "tsukemono (pickled vegetables)" },
        { word: "漬ける", reading: "つける", meaning: "to soak (in), to steep, to dip" },
        { word: "漬け物", reading: "つけもの", meaning: "tsukemono (pickled vegetables)" }
    ],
    },
    "坪": {
        onyomi: ["ヘイ"],
        kunyomi: ["つぼ"],
        examples: [
        { word: "坪", reading: "つぼ", meaning: "tsubo, traditional unit of land area, approx. 3.3 square meters" }
    ],
    },
    "爪": {
        onyomi: ["ソウ"],
        kunyomi: ["つめ", "つま-"],
        examples: [
        { word: "爪楊枝", reading: "つまようじ", meaning: "toothpick" },
        { word: "爪切り", reading: "つめきり", meaning: "nail clippers" },
        { word: "爪", reading: "つめ", meaning: "nail (e.g. fingernail, toenail), claw, talon" }
    ],
    },
    "鶴": {
        onyomi: ["カク"],
        kunyomi: ["つる"],
        examples: [
        { word: "鶴", reading: "つる", meaning: "crane (any bird of the family Gruidae, esp. the red-crowned crane, Grus japonensis)" }
    ],
    },
    "低": {
        onyomi: ["テイ"],
        kunyomi: ["ひく.い", "ひく.める", "ひく.まる"],
        examples: [
        { word: "高低", reading: "こうてい", meaning: "high and low, rise and fall" },
        { word: "最低", reading: "さいてい", meaning: "least, lowest, minimum" },
        { word: "低い", reading: "ひくい", meaning: "low (rank, degree, value, content, quality, etc.)" },
        { word: "低下", reading: "ていか", meaning: "fall, decline, lowering" }
    ],
    },
    "呈": {
        onyomi: ["テイ"],
        kunyomi: [],
        examples: [
        { word: "進呈", reading: "しんてい", meaning: "presentation (e.g. of a gift)" },
        { word: "贈呈", reading: "ぞうてい", meaning: "presentation (of a gift, prize, etc.)" },
        { word: "露呈", reading: "ろてい", meaning: "exposure, disclosure" }
    ],
    },
    "廷": {
        onyomi: ["テイ"],
        kunyomi: [],
        examples: [
        { word: "開廷", reading: "かいてい", meaning: "court session, trial" },
        { word: "宮廷", reading: "きゅうてい", meaning: "imperial court, royal court" },
        { word: "出廷", reading: "しゅってい", meaning: "appearance in court" },
        { word: "法廷", reading: "ほうてい", meaning: "court (of law), courtroom" }
    ],
    },
    "弟": {
        onyomi: ["テイ", "ダイ", "デ"],
        kunyomi: ["おとうと"],
        examples: [
        { word: "義弟", reading: "ぎてい", meaning: "brother-in-law (spouse's younger brother or younger sister's husband)" },
        { word: "兄弟", reading: "きょうだい", meaning: "brothers and sisters, siblings" },
        { word: "子弟", reading: "してい", meaning: "children, sons, children and younger brothers" },
        { word: "師弟", reading: "してい", meaning: "teacher and student" }
    ],
    },
    "定": {
        onyomi: ["テイ", "ジョウ"],
        kunyomi: ["さだ.める", "さだ.まる", "さだ.か"],
        examples: [
        { word: "安定", reading: "あんてい", meaning: "stability, steadiness, consistency" },
        { word: "一定", reading: "いってい", meaning: "to fix, to settle, to standardize" },
        { word: "仮定", reading: "かてい", meaning: "assumption, supposition, hypothesis" },
        { word: "改定", reading: "かいてい", meaning: "revision (of a rule, price, etc.), alteration, change" }
    ],
    },
    "底": {
        onyomi: ["テイ"],
        kunyomi: ["そこ"],
        examples: [
        { word: "海底", reading: "かいてい", meaning: "bottom of the ocean, seafloor, seabed" },
        { word: "根底", reading: "こんてい", meaning: "root, basis, foundation" },
        { word: "谷底", reading: "たにぞこ", meaning: "valley floor, bottom of a gorge, bottom of a ravine" },
        { word: "底値", reading: "そこね", meaning: "bottom price" }
    ],
    },
    "抵": {
        onyomi: ["テイ"],
        kunyomi: [],
        examples: [
        { word: "大抵", reading: "たいてい", meaning: "mostly, ordinarily, usually" },
        { word: "抵抗", reading: "ていこう", meaning: "resistance, opposition, standing up to" },
        { word: "抵触", reading: "ていしょく", meaning: "infringement (of a law, treaty, etc.), contravention, running afoul" },
        { word: "抵当", reading: "ていとう", meaning: "mortgage, security, hypothec" }
    ],
    },
    "邸": {
        onyomi: ["テイ"],
        kunyomi: ["やしき"],
        examples: [
        { word: "官邸", reading: "かんてい", meaning: "official residence (e.g. of the prime minister)" },
        { word: "公邸", reading: "こうてい", meaning: "official residence" },
        { word: "私邸", reading: "してい", meaning: "private residence" },
        { word: "邸宅", reading: "ていたく", meaning: "(large) house, residence, mansion" }
    ],
    },
    "亭": {
        onyomi: ["テイ", "チン"],
        kunyomi: [],
        examples: [
        { word: "亭主", reading: "ていしゅ", meaning: "household head, master, host (e.g. of a tea gathering)" },
        { word: "料亭", reading: "りょうてい", meaning: "ryotei, traditional Japanese restaurant (esp. a luxurious one)" }
    ],
    },
    "貞": {
        onyomi: ["テイ", "ジョウ"],
        kunyomi: ["ただし.い", "さだ"],
        examples: [
        { word: "貞潔", reading: "ていけつ", meaning: "chastity, purity" },
        { word: "貞淑", reading: "ていしゅく", meaning: "chastity, virtue, fidelity" },
        { word: "貞女", reading: "ていじょ", meaning: "virtuous woman, faithful wife" },
        { word: "貞節", reading: "ていせつ", meaning: "chastity, fidelity, faithfulness" }
    ],
    },
    "帝": {
        onyomi: ["テイ"],
        kunyomi: ["みかど"],
        examples: [
        { word: "皇帝", reading: "こうてい", meaning: "emperor" },
        { word: "帝国", reading: "ていこく", meaning: "empire" },
        { word: "帝政", reading: "ていせい", meaning: "imperial government, imperialism, monarchical rule" },
        { word: "帝国主義", reading: "ていこくしゅぎ", meaning: "imperialism" }
    ],
    },
    "訂": {
        onyomi: ["テイ"],
        kunyomi: ["ただ.す"],
        examples: [
        { word: "改訂", reading: "かいてい", meaning: "revision (of text), alteration, change" },
        { word: "訂正", reading: "ていせい", meaning: "correction, revision, amendment" },
        { word: "改訂版", reading: "かいていばん", meaning: "revised edition" }
    ],
    },
    "庭": {
        onyomi: ["テイ"],
        kunyomi: ["にわ"],
        examples: [
        { word: "家庭", reading: "かてい", meaning: "home, household, family" },
        { word: "校庭", reading: "こうてい", meaning: "schoolyard, school playground, school grounds" },
        { word: "前庭", reading: "ぜんてい", meaning: "front garden, front yard" },
        { word: "中庭", reading: "なかにわ", meaning: "courtyard, quadrangle, middle court" }
    ],
    },
    "逓": {
        onyomi: ["テイ"],
        kunyomi: ["かわ.る", "たがいに"],
        examples: [
        { word: "逓減", reading: "ていげん", meaning: "gradual decrease, gradual diminution" },
        { word: "逓信", reading: "ていしん", meaning: "communications (e.g. post, telegraph)" },
        { word: "逓送", reading: "ていそう", meaning: "forwarding" },
        { word: "逓増", reading: "ていぞう", meaning: "gradual increase" }
    ],
    },
    "停": {
        onyomi: ["テイ"],
        kunyomi: ["と.める", "と.まる"],
        examples: [
        { word: "調停", reading: "ちょうてい", meaning: "mediation, arbitration, intervention" },
        { word: "停学", reading: "ていがく", meaning: "suspension from school" },
        { word: "停止", reading: "ていし", meaning: "stoppage, coming to a stop, halt" },
        { word: "停車", reading: "ていしゃ", meaning: "stopping (of a train, car, etc.), stop" }
    ],
    },
    "偵": {
        onyomi: ["テイ"],
        kunyomi: [],
        examples: [
        { word: "探偵", reading: "たんてい", meaning: "detective, investigator, sleuth" },
        { word: "偵察", reading: "ていさつ", meaning: "scouting, reconnaissance" },
        { word: "内偵", reading: "ないてい", meaning: "secret investigation, private enquiry, private inquiry" }
    ],
    },
    "堤": {
        onyomi: ["テイ"],
        kunyomi: ["つつみ"],
        examples: [
        { word: "堤防", reading: "ていぼう", meaning: "bank, weir, embankment" },
        { word: "防波堤", reading: "ぼうはてい", meaning: "breakwater, mole" },
        { word: "堤", reading: "つつみ", meaning: "bank, embankment, dike" }
    ],
    },
    "提": {
        onyomi: ["テイ", "チョウ", "ダイ"],
        kunyomi: ["さ.げる"],
        examples: [
        { word: "前提", reading: "ぜんてい", meaning: "condition, assumption, prerequisite" },
        { word: "提案", reading: "ていあん", meaning: "proposal, proposition, suggestion" },
        { word: "提起", reading: "ていき", meaning: "raising (a question), posing (a problem), bringing up (an issue)" },
        { word: "提供", reading: "ていきょう", meaning: "offer, tender, providing" }
    ],
    },
    "程": {
        onyomi: ["テイ"],
        kunyomi: ["ほど", "-ほど"],
        examples: [
        { word: "音程", reading: "おんてい", meaning: "interval, step" },
        { word: "課程", reading: "かてい", meaning: "course, curriculum" },
        { word: "過程", reading: "かてい", meaning: "process, course, mechanism" },
        { word: "規程", reading: "きてい", meaning: "official regulations, inner rules" }
    ],
    },
    "艇": {
        onyomi: ["テイ"],
        kunyomi: [],
        examples: [
        { word: "艦艇", reading: "かんてい", meaning: "naval vessels, warships" },
        { word: "競艇", reading: "きょうてい", meaning: "kyōtei, boat race, hydroplane racing event and gambling sport in Japan" },
        { word: "舟艇", reading: "しゅうてい", meaning: "boat, watercraft" }
    ],
    },
    "締": {
        onyomi: ["テイ"],
        kunyomi: ["し.まる", "し.まり", "し.める", "-し.め", "-じ.め"],
        examples: [
        { word: "締結", reading: "ていけつ", meaning: "conclusion, execution (of a contract), entering (into treaty)" },
        { word: "締約", reading: "ていやく", meaning: "conclusion of a treaty" },
        { word: "締切", reading: "しめきり", meaning: "deadline, closing, cut-off" },
        { word: "締め", reading: "しめ", meaning: "tying up, binding, fastening" }
    ],
    },
    "諦": {
        onyomi: ["テイ", "タイ"],
        kunyomi: ["あきら.める", "つまびらか", "まこと"],
        examples: [
        { word: "諦める", reading: "あきらめる", meaning: "to give up, to abandon (hope, plans), to resign oneself (to)" }
    ],
    },
    "泥": {
        onyomi: ["デイ", "ナイ", "デ", "ニ"],
        kunyomi: ["どろ", "なず.む"],
        examples: [
        { word: "泥沼", reading: "どろぬま", meaning: "bog, marsh, swamp" },
        { word: "泥酔", reading: "でいすい", meaning: "being dead drunk, drunken stupor" },
        { word: "泥炭", reading: "でいたん", meaning: "peat" },
        { word: "泥棒", reading: "どろぼう", meaning: "thief, burglar, robber" }
    ],
    },
    "的": {
        onyomi: ["テキ"],
        kunyomi: ["まと"],
        examples: [
        { word: "劇的", reading: "げきてき", meaning: "dramatic, exciting, touching" },
        { word: "公的", reading: "こうてき", meaning: "public, official" },
        { word: "私的", reading: "してき", meaning: "private, personal" },
        { word: "質的", reading: "しつてき", meaning: "qualitative" }
    ],
    },
    "笛": {
        onyomi: ["テキ"],
        kunyomi: ["ふえ"],
        examples: [
        { word: "汽笛", reading: "きてき", meaning: "steam whistle" },
        { word: "警笛", reading: "けいてき", meaning: "horn, alarm, whistle" },
        { word: "口笛", reading: "くちぶえ", meaning: "whistle (sound made with the lips)" },
        { word: "笛", reading: "ふえ", meaning: "flute, fife, pipe" }
    ],
    },
    "摘": {
        onyomi: ["テキ"],
        kunyomi: ["つ.む"],
        examples: [
        { word: "指摘", reading: "してき", meaning: "pointing out, identification" },
        { word: "摘み", reading: "つまみ", meaning: "knob, handle, button" },
        { word: "摘む", reading: "つむ", meaning: "to pick, to pluck" },
        { word: "摘出", reading: "てきしゅつ", meaning: "picking out, taking out, (surgical) removal" }
    ],
    },
    "滴": {
        onyomi: ["テキ"],
        kunyomi: ["しずく", "したた.る"],
        examples: [
        { word: "水滴", reading: "すいてき", meaning: "drop of water" },
        { word: "点滴", reading: "てんてき", meaning: "raindrops, falling drop of water" },
        { word: "滴", reading: "しずく", meaning: "drop (e.g. of water), drip" }
    ],
    },
    "適": {
        onyomi: ["テキ"],
        kunyomi: ["かな.う"],
        examples: [
        { word: "快適", reading: "かいてき", meaning: "pleasant, agreeable, comfortable" },
        { word: "最適", reading: "さいてき", meaning: "most suitable, optimum, optimal" },
        { word: "適確", reading: "てきかく", meaning: "accurate, precise, exact" },
        { word: "適応", reading: "てきおう", meaning: "adaptation, accommodation, conformity" }
    ],
    },
    "敵": {
        onyomi: ["テキ"],
        kunyomi: ["かたき", "あだ", "かな.う"],
        examples: [
        { word: "強敵", reading: "きょうてき", meaning: "formidable enemy, strong enemy, tough enemy" },
        { word: "宿敵", reading: "しゅくてき", meaning: "old enemy, longtime enemy, arch-enemy" },
        { word: "政敵", reading: "せいてき", meaning: "political opponent" },
        { word: "素敵", reading: "すてき", meaning: "lovely, wonderful, charming" }
    ],
    },
    "溺": {
        onyomi: ["デキ", "ジョウ", "ニョウ"],
        kunyomi: ["いばり", "おぼ.れる"],
        examples: [
        { word: "溺れる", reading: "おぼれる", meaning: "to struggle in the water, to be drowning, to sink below the surface and become unable to breathe" }
    ],
    },
    "迭": {
        onyomi: ["テツ"],
        kunyomi: [],
        examples: [
        { word: "更迭", reading: "こうてつ", meaning: "change (of personnel), reshuffle (e.g. of a cabinet), shake-up" }
    ],
    },
    "哲": {
        onyomi: ["テツ"],
        kunyomi: ["さとい", "あきらか"],
        examples: [
        { word: "哲学", reading: "てつがく", meaning: "philosophy" },
        { word: "哲人", reading: "てつじん", meaning: "wise man, philosopher, sage" }
    ],
    },
    "鉄": {
        onyomi: ["テツ"],
        kunyomi: ["くろがね"],
        examples: [
        { word: "鋼鉄", reading: "こうてつ", meaning: "steel" },
        { word: "国鉄", reading: "こくてつ", meaning: "national railway" },
        { word: "私鉄", reading: "してつ", meaning: "private railway" },
        { word: "製鉄", reading: "せいてつ", meaning: "iron manufacture" }
    ],
    },
    "徹": {
        onyomi: ["テツ"],
        kunyomi: [],
        examples: [
        { word: "貫徹", reading: "かんてつ", meaning: "accomplishment, realization, attainment" },
        { word: "徹底", reading: "てってい", meaning: "thoroughness, completeness, consistency" },
        { word: "徹夜", reading: "てつや", meaning: "staying up all night" },
        { word: "冷徹", reading: "れいてつ", meaning: "cool-headed, level-headed, hard-headed" }
    ],
    },
    "撤": {
        onyomi: ["テツ"],
        kunyomi: [],
        examples: [
        { word: "撤回", reading: "てっかい", meaning: "withdrawal, retraction, revocation" },
        { word: "撤去", reading: "てっきょ", meaning: "removal, taking away, dismantling (a building, facilities, etc.)" },
        { word: "撤収", reading: "てっしゅう", meaning: "removal (of a building, equipment, etc.), dismantling (e.g. a tent), striking (a stage set, camp, etc.)" },
        { word: "撤退", reading: "てったい", meaning: "evacuation, withdrawal, revocation" }
    ],
    },
    "天": {
        onyomi: ["テン"],
        kunyomi: ["あまつ", "あめ", "あま-"],
        examples: [
        { word: "雨天", reading: "うてん", meaning: "rainy weather" },
        { word: "炎天", reading: "えんてん", meaning: "blazing heat, scorching sun" },
        { word: "仰天", reading: "ぎょうてん", meaning: "being amazed, being horrified, being taken aback" },
        { word: "晴天", reading: "せいてん", meaning: "fine weather (i.e. little or no clouds), fair weather, clear weather" }
    ],
    },
    "典": {
        onyomi: ["テン", "デン"],
        kunyomi: ["ふみ", "のり"],
        examples: [
        { word: "古典", reading: "こてん", meaning: "classic (work, esp. book), the classics" },
        { word: "祭典", reading: "さいてん", meaning: "festival" },
        { word: "事典", reading: "じてん", meaning: "encyclopedia" },
        { word: "式典", reading: "しきてん", meaning: "ceremony, rites" }
    ],
    },
    "店": {
        onyomi: ["テン"],
        kunyomi: ["みせ", "たな"],
        examples: [
        { word: "開店", reading: "かいてん", meaning: "opening a new shop" },
        { word: "支店", reading: "してん", meaning: "branch office, branch store" },
        { word: "書店", reading: "しょてん", meaning: "bookshop, bookstore" },
        { word: "商店", reading: "しょうてん", meaning: "shop, store, firm" }
    ],
    },
    "点": {
        onyomi: ["テン"],
        kunyomi: ["つ.ける", "つ.く", "た.てる", "さ.す", "とぼ.す", "とも.す", "ぼち"],
        examples: [
        { word: "一点", reading: "いってん", meaning: "point, dot, speck" },
        { word: "汚点", reading: "おてん", meaning: "stain, blot, flaw" },
        { word: "観点", reading: "かんてん", meaning: "point of view, viewpoint, standpoint" },
        { word: "起点", reading: "きてん", meaning: "starting point, origin" }
    ],
    },
    "展": {
        onyomi: ["テン"],
        kunyomi: [],
        examples: [
        { word: "個展", reading: "こてん", meaning: "solo exhibition, one-man exhibition, one-woman exhibition" },
        { word: "出展", reading: "しゅってん", meaning: "exhibit, display" },
        { word: "進展", reading: "しんてん", meaning: "progress, development" },
        { word: "展開", reading: "てんかい", meaning: "development, evolution, progression" }
    ],
    },
    "添": {
        onyomi: ["テン"],
        kunyomi: ["そ.える", "そ.う"],
        examples: [
        { word: "添う", reading: "そう", meaning: "to meet (wishes, expectations, etc.), to satisfy, to comply with" },
        { word: "添加", reading: "てんか", meaning: "addition, annexing" },
        { word: "添削", reading: "てんさく", meaning: "correction, looking over, touching up" },
        { word: "添付", reading: "てんぷ", meaning: "attaching (documents, etc.), appending, affixing" }
    ],
    },
    "転": {
        onyomi: ["テン"],
        kunyomi: ["ころ.がる", "ころ.げる", "ころ.がす", "ころ.ぶ", "まろ.ぶ", "うたた", "うつ.る", "くる.めく"],
        examples: [
        { word: "移転", reading: "いてん", meaning: "moving, relocation, change of address" },
        { word: "運転", reading: "うんてん", meaning: "operation (of a machine), running, working" },
        { word: "横転", reading: "おうてん", meaning: "toppling sideways, turning sideways, falling over sideways" },
        { word: "回転", reading: "かいてん", meaning: "rotation, revolution, turn" }
    ],
    },
    "塡": {
        onyomi: ["テン", "チン"],
        kunyomi: ["はま.る", "うず.める", "は.める", "ふさ.ぐ"],
        examples: [
        { word: "充塡", reading: "じゅうてん", meaning: "filling (up), replenishing, filling in (a tooth)" },
        { word: "装塡", reading: "そうてん", meaning: "loading, charging, filling" },
        { word: "補塡", reading: "ほてん", meaning: "covering (a loss, deficit, etc.), making up (for), compensating (for)" },
        { word: "塡補", reading: "てんぽ", meaning: "making up (a deficit, loss, etc.), covering, compensation" }
    ],
    },
    "田": {
        onyomi: ["デン"],
        kunyomi: ["た"],
        examples: [
        { word: "塩田", reading: "えんでん", meaning: "saltpan, field for drying salt" },
        { word: "桑田", reading: "そうでん", meaning: "mulberry plantation" },
        { word: "上田", reading: "じょうでん", meaning: "high rice field, very fertile rice field" },
        { word: "水田", reading: "すいでん", meaning: "(water-filled) paddy field" }
    ],
    },
    "伝": {
        onyomi: ["デン", "テン"],
        kunyomi: ["つた.わる", "つた.える", "つた.う", "つだ.う", "-づた.い", "つて"],
        examples: [
        { word: "遺伝", reading: "いでん", meaning: "heredity, (genetic) inheritance" },
        { word: "駅伝", reading: "えきでん", meaning: "long-distance relay race" },
        { word: "自伝", reading: "じでん", meaning: "autobiography" },
        { word: "宣伝", reading: "せんでん", meaning: "publicity, advertisement, advertising" }
    ],
    },
    "殿": {
        onyomi: ["デン", "テン"],
        kunyomi: ["との", "-どの"],
        examples: [
        { word: "宮殿", reading: "きゅうでん", meaning: "palace" },
        { word: "御殿", reading: "ごてん", meaning: "palace, court" },
        { word: "神殿", reading: "しんでん", meaning: "temple, shrine, sanctuary" },
        { word: "殿下", reading: "でんか", meaning: "Your Highness, His Highness, Her Highness" }
    ],
    },
    "電": {
        onyomi: ["デン"],
        kunyomi: [],
        examples: [
        { word: "家電", reading: "かでん", meaning: "household (electrical) appliances, home appliances, consumer electronics" },
        { word: "外電", reading: "がいでん", meaning: "foreign telegram" },
        { word: "終電", reading: "しゅうでん", meaning: "last train (of the day)" },
        { word: "充電", reading: "じゅうでん", meaning: "charging (electrically)" }
    ],
    },
    "斗": {
        onyomi: ["ト", "トウ"],
        kunyomi: [],
        examples: [
        { word: "斗", reading: "と", meaning: "to, traditional unit of volume, approx. 18 litres" }
    ],
    },
    "吐": {
        onyomi: ["ト"],
        kunyomi: ["は.く", "つ.く"],
        examples: [
        { word: "吐く", reading: "つく", meaning: "to breathe out, to breathe" },
        { word: "吐露", reading: "とろ", meaning: "expressing one's mind, speaking out" },
        { word: "嘔吐", reading: "おうと", meaning: "vomiting, emesis" },
        { word: "吐き気", reading: "はきけ", meaning: "nausea, feeling like throwing up, feeling sick" }
    ],
    },
    "妬": {
        onyomi: ["ト", "ツ"],
        kunyomi: ["ねた.む", "そね.む", "つも.る", "ふさ.ぐ"],
        examples: [
        { word: "嫉妬", reading: "しっと", meaning: "jealousy, envy" },
        { word: "妬む", reading: "ねたむ", meaning: "to be jealous of, to envy, to begrudge" }
    ],
    },
    "徒": {
        onyomi: ["ト"],
        kunyomi: ["いたずら", "あだ"],
        examples: [
        { word: "学徒", reading: "がくと", meaning: "student, follower, students and pupils" },
        { word: "教徒", reading: "きょうと", meaning: "believer, adherent" },
        { word: "使徒", reading: "しと", meaning: "apostle, disciple" },
        { word: "信徒", reading: "しんと", meaning: "layman, believer, adherent" }
    ],
    },
    "途": {
        onyomi: ["ト"],
        kunyomi: ["みち"],
        examples: [
        { word: "帰途", reading: "きと", meaning: "(the) way home, return trip, (the) way back" },
        { word: "使途", reading: "しと", meaning: "purpose for which money is spent, the way money is spent, how goods are used" },
        { word: "前途", reading: "ぜんと", meaning: "future, prospects, outlook" },
        { word: "中途", reading: "ちゅうと", meaning: "halfway, midway, partway" }
    ],
    },
    "都": {
        onyomi: ["ト", "ツ"],
        kunyomi: ["みやこ"],
        examples: [
        { word: "古都", reading: "こと", meaning: "ancient city, former capital" },
        { word: "首都", reading: "しゅと", meaning: "(national) capital (city), metropolis" },
        { word: "都会", reading: "とかい", meaning: "city" },
        { word: "都合", reading: "つごう", meaning: "circumstances, condition, convenience" }
    ],
    },
    "渡": {
        onyomi: ["ト"],
        kunyomi: ["わた.る", "-わた.る", "わた.す"],
        examples: [
        { word: "過渡", reading: "かと", meaning: "crossing, ferry" },
        { word: "譲渡", reading: "じょうと", meaning: "transfer, assignment, conveyance" },
        { word: "渡す", reading: "わたす", meaning: "to ferry across (e.g. a river), to carry across, to traverse" },
        { word: "渡り", reading: "わたり", meaning: "crossing, passage, transit" }
    ],
    },
    "塗": {
        onyomi: ["ト"],
        kunyomi: ["ぬ.る", "ぬ.り", "まみ.れる"],
        examples: [
        { word: "塗る", reading: "ぬる", meaning: "to paint, to spread, to plaster" },
        { word: "塗装", reading: "とそう", meaning: "coating, painting" },
        { word: "塗布", reading: "とふ", meaning: "application (of ointment, etc.)" },
        { word: "塗料", reading: "とりょう", meaning: "paint, coating, varnish" }
    ],
    },
    "賭": {
        onyomi: ["ト"],
        kunyomi: ["か.ける", "かけ"],
        examples: [
        { word: "賭け", reading: "かけ", meaning: "bet, wager, stake" },
        { word: "賭ける", reading: "かける", meaning: "to wager, to bet, to risk" }
    ],
    },
    "土": {
        onyomi: ["ド", "ト"],
        kunyomi: ["つち"],
        examples: [
        { word: "郷土", reading: "きょうど", meaning: "native place, birth-place, one's old home" },
        { word: "国土", reading: "こくど", meaning: "country, territory, domain" },
        { word: "出土", reading: "しゅつど", meaning: "archeological excavation (archaeological)" },
        { word: "浄土", reading: "じょうど", meaning: "pure land (esp. the Western Pure Land paradise of Amitabha), (Buddhist) paradise" }
    ],
    },
    "奴": {
        onyomi: ["ド"],
        kunyomi: ["やつ", "やっこ"],
        examples: [
        { word: "奴隷", reading: "どれい", meaning: "slave, servant" },
        { word: "奴ら", reading: "やつら", meaning: "they, those guys" },
        { word: "売国奴", reading: "ばいこくど", meaning: "traitor (to one's country), quisling" },
        { word: "奴", reading: "やつ", meaning: "fellow, guy, chap" }
    ],
    },
    "努": {
        onyomi: ["ド"],
        kunyomi: ["つと.める"],
        examples: [
        { word: "努力", reading: "どりょく", meaning: "effort, exertion, endeavour" },
        { word: "努める", reading: "つとめる", meaning: "to endeavor (to do), to endeavour, to try hard" },
        { word: "努めて", reading: "つとめて", meaning: "as much as possible, as far as possible, to the best of one's ability" }
    ],
    },
    "度": {
        onyomi: ["ド", "ト", "タク"],
        kunyomi: ["たび", "-た.い"],
        examples: [
        { word: "度に", reading: "たびに", meaning: "each time, every time, whenever (something happens)" },
        { word: "緯度", reading: "いど", meaning: "latitude" },
        { word: "温度", reading: "おんど", meaning: "temperature" },
        { word: "何度", reading: "なんど", meaning: "how many times" }
    ],
    },
    "怒": {
        onyomi: ["ド", "ヌ"],
        kunyomi: ["いか.る", "おこ.る"],
        examples: [
        { word: "激怒", reading: "げきど", meaning: "rage, fury" },
        { word: "怒り", reading: "いかり", meaning: "anger, rage, fury" },
        { word: "怒る", reading: "おこる", meaning: "to get angry, to get mad, to lose one's temper" },
        { word: "怒気", reading: "どき", meaning: "anger, wrath" }
    ],
    },
    "刀": {
        onyomi: ["トウ"],
        kunyomi: ["かたな", "そり"],
        examples: [
        { word: "小刀", reading: "こがたな", meaning: "(small) knife" },
        { word: "太刀", reading: "たち", meaning: "long sword (as opposed to the shorter katana)" },
        { word: "短刀", reading: "たんとう", meaning: "short sword, knife, dagger" },
        { word: "竹刀", reading: "しない", meaning: "bamboo sword (for kendo), bamboo fencing stick" }
    ],
    },
    "冬": {
        onyomi: ["トウ"],
        kunyomi: ["ふゆ"],
        examples: [
        { word: "越冬", reading: "えっとう", meaning: "passing the winter, hibernation" },
        { word: "真冬", reading: "まふゆ", meaning: "midwinter, dead of winter" },
        { word: "暖冬", reading: "だんとう", meaning: "mild winter, warm winter" },
        { word: "冬季", reading: "とうき", meaning: "winter season, winter" }
    ],
    },
    "灯": {
        onyomi: ["トウ"],
        kunyomi: ["ひ", "ほ-", "ともしび", "とも.す", "あかり"],
        examples: [
        { word: "街灯", reading: "がいとう", meaning: "street light, streetlamp" },
        { word: "電灯", reading: "でんとう", meaning: "electric light" },
        { word: "灯台", reading: "とうだい", meaning: "lighthouse" },
        { word: "灯油", reading: "とうゆ", meaning: "kerosene, paraffin, lamp oil" }
    ],
    },
    "当": {
        onyomi: ["トウ"],
        kunyomi: ["あ.たる", "あ.たり", "あ.てる", "あ.て", "まさ.に", "まさ.にべし"],
        examples: [
        { word: "穏当", reading: "おんとう", meaning: "proper, reasonable, right" },
        { word: "過当", reading: "かとう", meaning: "excessive, exorbitant" },
        { word: "該当", reading: "がいとう", meaning: "corresponding to, being applicable to, being relevant to" },
        { word: "見当", reading: "けんとう", meaning: "estimate, guess, conjecture" }
    ],
    },
    "投": {
        onyomi: ["トウ"],
        kunyomi: ["な.げる", "-な.げ"],
        examples: [
        { word: "継投", reading: "けいとう", meaning: "relieving the (starting) pitcher" },
        { word: "好投", reading: "こうとう", meaning: "good (nice) pitching" },
        { word: "投影", reading: "とうえい", meaning: "projection (of a shadow), casting (a reflection), reflection" },
        { word: "投機", reading: "とうき", meaning: "speculation, venture, stockjobbing" }
    ],
    },
    "豆": {
        onyomi: ["トウ", "ズ"],
        kunyomi: ["まめ", "まめ-"],
        examples: [
        { word: "枝豆", reading: "えだまめ", meaning: "edamame (green soybeans)" },
        { word: "小豆", reading: "あずき", meaning: "adzuki bean (Vigna angularis)" },
        { word: "大豆", reading: "だいず", meaning: "soya bean (Glycine max), soybean, soy" },
        { word: "豆乳", reading: "とうにゅう", meaning: "soy milk" }
    ],
    },
    "東": {
        onyomi: ["トウ"],
        kunyomi: ["ひがし"],
        examples: [
        { word: "関東", reading: "かんとう", meaning: "Kantō (region comprising Tokyo and surrounding prefectures)" },
        { word: "極東", reading: "きょくとう", meaning: "Far East" },
        { word: "広東", reading: "カントン", meaning: "Guangdong (China), Kwangtung" },
        { word: "中東", reading: "ちゅうとう", meaning: "Middle East" }
    ],
    },
    "到": {
        onyomi: ["トウ"],
        kunyomi: ["いた.る"],
        examples: [
        { word: "殺到", reading: "さっとう", meaning: "rush, flood, deluge" },
        { word: "周到", reading: "しゅうとう", meaning: "careful, thorough, meticulous" },
        { word: "到達", reading: "とうたつ", meaning: "reaching, attaining, arrival" },
        { word: "到着", reading: "とうちゃく", meaning: "arrival" }
    ],
    },
    "逃": {
        onyomi: ["トウ"],
        kunyomi: ["に.げる", "に.がす", "のが.す", "のが.れる"],
        examples: [
        { word: "逃す", reading: "のがす", meaning: "to miss (e.g. a chance), to lose, to let get away" },
        { word: "逃走", reading: "とうそう", meaning: "flight, desertion, escape" },
        { word: "逃避", reading: "とうひ", meaning: "escape, evasion, flight" },
        { word: "逃亡", reading: "とうぼう", meaning: "escape, flight, running away" }
    ],
    },
    "倒": {
        onyomi: ["トウ"],
        kunyomi: ["たお.れる", "-だお.れ", "たお.す", "さかさま", "さかさ", "さかしま"],
        examples: [
        { word: "圧倒", reading: "あっとう", meaning: "to overwhelm (e.g. an opponent), to overpower, to crush" },
        { word: "倒さ", reading: "さかさ", meaning: "inverted, upside down, reversed" },
        { word: "傾倒", reading: "けいとう", meaning: "devoting oneself to, concentrating on, being an ardent admirer of" },
        { word: "打倒", reading: "だとう", meaning: "overthrow, defeat, bringing down" }
    ],
    },
    "凍": {
        onyomi: ["トウ"],
        kunyomi: ["こお.る", "こご.える", "こご.る", "い.てる", "し.みる"],
        examples: [
        { word: "凍結", reading: "とうけつ", meaning: "freezing (e.g. water)" },
        { word: "凍死", reading: "とうし", meaning: "death from cold, freezing to death" },
        { word: "冷凍", reading: "れいとう", meaning: "freezing, cold storage, refrigeration" },
        { word: "凍る", reading: "こおる", meaning: "to freeze, to become frozen, to freeze over" }
    ],
    },
    "唐": {
        onyomi: ["トウ"],
        kunyomi: ["から"],
        examples: [
        { word: "唐突", reading: "とうとつ", meaning: "abrupt, sudden" },
        { word: "遣唐使", reading: "けんとうし", meaning: "envoy to Tang China" },
        { word: "唐辛子", reading: "とうがらし", meaning: "capsicum (Capsicum annuum, esp. the cultivated chili peppers), chili pepper (chile, chilli), cayenne" },
        { word: "唐", reading: "とう", meaning: "Tang dynasty (of China; 618-907), T'ang dynasty" }
    ],
    },
    "島": {
        onyomi: ["トウ"],
        kunyomi: ["しま"],
        examples: [
        { word: "群島", reading: "ぐんとう", meaning: "island group, archipelago" },
        { word: "孤島", reading: "ことう", meaning: "solitary island, isolated island" },
        { word: "諸島", reading: "しょとう", meaning: "archipelago, group of islands" },
        { word: "小島", reading: "こじま", meaning: "small island, islet" }
    ],
    },
    "桃": {
        onyomi: ["トウ"],
        kunyomi: ["もも"],
        examples: [
        { word: "胡桃", reading: "くるみ", meaning: "walnut (Juglans spp., esp. Juglans regia)" },
        { word: "桃色", reading: "ももいろ", meaning: "pink (colour, color), peach" },
        { word: "桃", reading: "もも", meaning: "peach (Prunus persica)" }
    ],
    },
    "討": {
        onyomi: ["トウ"],
        kunyomi: ["う.つ"],
        examples: [
        { word: "検討", reading: "けんとう", meaning: "consideration, examination, investigation" },
        { word: "掃討", reading: "そうとう", meaning: "cleaning up (enemy remnants), sweeping clean (of opponents), mopping up" },
        { word: "討議", reading: "とうぎ", meaning: "debate, discussion" },
        { word: "討論", reading: "とうろん", meaning: "debate, discussion" }
    ],
    },
    "透": {
        onyomi: ["トウ"],
        kunyomi: ["す.く", "す.かす", "す.ける", "とう.る", "とう.す"],
        examples: [
        { word: "浸透", reading: "しんとう", meaning: "permeation (of thought, ideology, culture, etc.), infiltration (e.g. of ideas), spread" },
        { word: "透視", reading: "とうし", meaning: "seeing through" },
        { word: "透明", reading: "とうめい", meaning: "transparent, clear" },
        { word: "透析", reading: "とうせき", meaning: "dialysis" }
    ],
    },
    "党": {
        onyomi: ["トウ"],
        kunyomi: ["なかま", "むら"],
        examples: [
        { word: "一党", reading: "いっとう", meaning: "one party, one faction, one clique" },
        { word: "挙党", reading: "きょとう", meaning: "whole party, party as a whole" },
        { word: "結党", reading: "けっとう", meaning: "formation of a (political) party" },
        { word: "新党", reading: "しんとう", meaning: "new (political) party" }
    ],
    },
    "悼": {
        onyomi: ["トウ"],
        kunyomi: ["いた.む"],
        examples: [
        { word: "哀悼", reading: "あいとう", meaning: "condolence, regret, tribute" },
        { word: "追悼", reading: "ついとう", meaning: "mourning" },
        { word: "悼む", reading: "いたむ", meaning: "to grieve over, to mourn, to lament" }
    ],
    },
    "盗": {
        onyomi: ["トウ"],
        kunyomi: ["ぬす.む", "ぬす.み"],
        examples: [
        { word: "強盗", reading: "ごうとう", meaning: "robber, mugger" },
        { word: "窃盗", reading: "せっとう", meaning: "theft, stealing, larceny" },
        { word: "盗み", reading: "ぬすみ", meaning: "stealing, theft" },
        { word: "盗む", reading: "ぬすむ", meaning: "to steal" }
    ],
    },
    "陶": {
        onyomi: ["トウ"],
        kunyomi: ["すえ"],
        examples: [
        { word: "陶器", reading: "とうき", meaning: "pottery, earthenware, ceramics" },
        { word: "陶芸", reading: "とうげい", meaning: "ceramic art, ceramics" },
        { word: "陶工", reading: "とうこう", meaning: "potter, ceramist, ceramicist" },
        { word: "陶酔", reading: "とうすい", meaning: "intoxication" }
    ],
    },
    "塔": {
        onyomi: ["トウ"],
        kunyomi: [],
        examples: [
        { word: "管制塔", reading: "かんせいとう", meaning: "control tower" },
        { word: "バベルの塔", reading: "バベルのとう", meaning: "Tower of Babel" },
        { word: "塔", reading: "とう", meaning: "tower, steeple, spire" },
        { word: "エッフェル塔", reading: "エッフェルとう", meaning: "Eiffel Tower" }
    ],
    },
    "搭": {
        onyomi: ["トウ"],
        kunyomi: [],
        examples: [
        { word: "搭載", reading: "とうさい", meaning: "loading (on a ship), equipping (an aircraft, car, etc.) with, being equipped with" },
        { word: "搭乗", reading: "とうじょう", meaning: "embarkation, boarding (a ship or aircraft)" }
    ],
    },
    "棟": {
        onyomi: ["トウ"],
        kunyomi: ["むね", "むな-"],
        examples: [
        { word: "病棟", reading: "びょうとう", meaning: "(hospital) ward" },
        { word: "別棟", reading: "べつむね", meaning: "separate building, outbuilding, outhouse" },
        { word: "棟", reading: "むね", meaning: "ridge (of roof)" }
    ],
    },
    "湯": {
        onyomi: ["トウ"],
        kunyomi: ["ゆ"],
        examples: [
        { word: "銭湯", reading: "せんとう", meaning: "public bath, bathhouse" },
        { word: "湯気", reading: "ゆげ", meaning: "steam, vapour, vapor" },
        { word: "湯治", reading: "とうじ", meaning: "hot-spring cure, taking the baths" },
        { word: "熱湯", reading: "ねっとう", meaning: "boiling water" }
    ],
    },
    "痘": {
        onyomi: ["トウ"],
        kunyomi: [],
        examples: [
        { word: "種痘", reading: "しゅとう", meaning: "smallpox vaccination, inoculation against smallpox" },
        { word: "天然痘", reading: "てんねんとう", meaning: "smallpox, variola" }
    ],
    },
    "登": {
        onyomi: ["トウ", "ト", "ドウ", "ショウ", "チョウ"],
        kunyomi: ["のぼ.る", "あ.がる"],
        examples: [
        { word: "登る", reading: "のぼる", meaning: "to ascend, to go up, to climb" },
        { word: "登記", reading: "とうき", meaning: "registry, registration" },
        { word: "登校", reading: "とうこう", meaning: "attendance (at school), going to school" },
        { word: "登山", reading: "とざん", meaning: "mountain climbing, mountaineering, ascent of a mountain" }
    ],
    },
    "答": {
        onyomi: ["トウ"],
        kunyomi: ["こた.える", "こた.え"],
        examples: [
        { word: "応答", reading: "おうとう", meaning: "reply, answer, response" },
        { word: "解答", reading: "かいとう", meaning: "answer, solution" },
        { word: "回答", reading: "かいとう", meaning: "reply, answer" },
        { word: "贈答", reading: "ぞうとう", meaning: "exchange of presents" }
    ],
    },
    "等": {
        onyomi: ["トウ"],
        kunyomi: ["ひと.しい", "など", "-ら"],
        examples: [
        { word: "等閑", reading: "なおざり", meaning: "neglect, negligence, disregard" },
        { word: "一等", reading: "いっとう", meaning: "first class, first rank, first grade" },
        { word: "下等", reading: "かとう", meaning: "inferior, base, vulgar" },
        { word: "均等", reading: "きんとう", meaning: "equal (distribution, treatment, level, etc.), even, uniform" }
    ],
    },
    "筒": {
        onyomi: ["トウ"],
        kunyomi: ["つつ"],
        examples: [
        { word: "円筒", reading: "えんとう", meaning: "cylinder" },
        { word: "気筒", reading: "きとう", meaning: "cylinder" },
        { word: "水筒", reading: "すいとう", meaning: "canteen, flask, water bottle" },
        { word: "封筒", reading: "ふうとう", meaning: "envelope" }
    ],
    },
    "統": {
        onyomi: ["トウ"],
        kunyomi: ["す.べる"],
        examples: [
        { word: "系統", reading: "けいとう", meaning: "system" },
        { word: "正統", reading: "せいとう", meaning: "legitimate, orthodox, traditional" },
        { word: "総統", reading: "そうとう", meaning: "supreme ruler, generalissimo" },
        { word: "伝統", reading: "でんとう", meaning: "tradition, convention" }
    ],
    },
    "稲": {
        onyomi: ["トウ", "テ"],
        kunyomi: ["いね", "いな-"],
        examples: [
        { word: "稲妻", reading: "いなずま", meaning: "lightning, flash of lightning, lightning bolt" },
        { word: "稲作", reading: "いなさく", meaning: "rice cultivation, rice crop" },
        { word: "稲穂", reading: "いなほ", meaning: "ear (head) of rice" },
        { word: "水稲", reading: "すいとう", meaning: "wet-land rice" }
    ],
    },
    "踏": {
        onyomi: ["トウ"],
        kunyomi: ["ふ.む", "ふ.まえる"],
        examples: [
        { word: "踏む", reading: "ふむ", meaning: "to step on, to tread on, to trample on" },
        { word: "舞踏", reading: "ぶとう", meaning: "dance (esp. Western style), dancing" },
        { word: "雑踏", reading: "ざっとう", meaning: "hustle and bustle, throng, crowd" },
        { word: "踏切", reading: "ふみきり", meaning: "railway crossing, railroad crossing, train crossing" }
    ],
    },
    "糖": {
        onyomi: ["トウ"],
        kunyomi: [],
        examples: [
        { word: "血糖", reading: "けっとう", meaning: "blood sugar" },
        { word: "砂糖", reading: "さとう", meaning: "sugar" },
        { word: "製糖", reading: "せいとう", meaning: "sugar manufacture" },
        { word: "糖質", reading: "とうしつ", meaning: "sugariness, saccharinity, carbohydrate" }
    ],
    },
    "頭": {
        onyomi: ["トウ", "ズ", "ト"],
        kunyomi: ["あたま", "かしら", "-がしら", "かぶり"],
        examples: [
        { word: "音頭", reading: "おんど", meaning: "lead (in a cheer, toast, song, etc.), (someone's) lead" },
        { word: "会頭", reading: "かいとう", meaning: "society president" },
        { word: "街頭", reading: "がいとう", meaning: "(on the) street" },
        { word: "口頭", reading: "こうとう", meaning: "oral, verbal, spoken" }
    ],
    },
    "謄": {
        onyomi: ["トウ"],
        kunyomi: [],
        examples: [
        { word: "謄本", reading: "とうほん", meaning: "certified copy, transcript" },
        { word: "戸籍謄本", reading: "こせきとうほん", meaning: "official copy of the family register" }
    ],
    },
    "藤": {
        onyomi: ["トウ", "ドウ"],
        kunyomi: ["ふじ"],
        examples: [
        { word: "葛藤", reading: "かっとう", meaning: "conflict, complication, troubles" },
        { word: "藤", reading: "ふじ", meaning: "wisteria (esp. Japanese wisteria, Wisteria floribunda), wistaria" }
    ],
    },
    "闘": {
        onyomi: ["トウ"],
        kunyomi: ["たたか.う", "あらそ.う"],
        examples: [
        { word: "格闘", reading: "かくとう", meaning: "(hand-to-hand) fight, grapple, scuffle" },
        { word: "敢闘", reading: "かんとう", meaning: "fighting bravely" },
        { word: "共闘", reading: "きょうとう", meaning: "joint struggle, common (united) front" },
        { word: "健闘", reading: "けんとう", meaning: "fighting bravely, strenuous efforts" }
    ],
    },
    "騰": {
        onyomi: ["トウ"],
        kunyomi: ["あが.る", "のぼ.る"],
        examples: [
        { word: "急騰", reading: "きゅうとう", meaning: "sudden rise (in price), sharp rise, jump" },
        { word: "高騰", reading: "こうとう", meaning: "sharp rise (in prices), steep rise, substantial increase" },
        { word: "騰貴", reading: "とうき", meaning: "rise (in price or value), appreciation, advance" },
        { word: "沸騰", reading: "ふっとう", meaning: "boiling, seething" }
    ],
    },
    "同": {
        onyomi: ["ドウ"],
        kunyomi: ["おな.じ"],
        examples: [
        { word: "一同", reading: "いちどう", meaning: "all present, all concerned, all of us" },
        { word: "合同", reading: "ごうどう", meaning: "combination, union, joining" },
        { word: "混同", reading: "こんどう", meaning: "confusion, mixing, merger" },
        { word: "賛同", reading: "さんどう", meaning: "approval, endorsement" }
    ],
    },
    "洞": {
        onyomi: ["ドウ"],
        kunyomi: ["ほら"],
        examples: [
        { word: "空洞", reading: "くうどう", meaning: "cavity, hollow, cave" },
        { word: "洞窟", reading: "どうくつ", meaning: "cave, cavern, grotto" },
        { word: "洞穴", reading: "ほらあな", meaning: "cave, cavern, den" },
        { word: "洞察", reading: "どうさつ", meaning: "discernment, insight" }
    ],
    },
    "胴": {
        onyomi: ["ドウ"],
        kunyomi: [],
        examples: [
        { word: "胴体", reading: "どうたい", meaning: "trunk, torso, body" },
        { word: "胴上げ", reading: "どうあげ", meaning: "tossing (someone) into the air (in celebration)" },
        { word: "胴", reading: "どう", meaning: "trunk, torso, body" }
    ],
    },
    "動": {
        onyomi: ["ドウ"],
        kunyomi: ["うご.く", "うご.かす"],
        examples: [
        { word: "異動", reading: "いどう", meaning: "(personnel) change, transfer, relocation" },
        { word: "移動", reading: "いどう", meaning: "movement, transfer, migration" },
        { word: "運動", reading: "うんどう", meaning: "exercise, physical training, workout" },
        { word: "活動", reading: "かつどう", meaning: "activity (of a person, organization, animal, volcano, etc.), action, operation" }
    ],
    },
    "堂": {
        onyomi: ["ドウ"],
        kunyomi: [],
        examples: [
        { word: "一堂", reading: "いちどう", meaning: "one building (hall, temple, shrine, room)" },
        { word: "会堂", reading: "かいどう", meaning: "church, chapel, synagogue" },
        { word: "講堂", reading: "こうどう", meaning: "auditorium, lecture hall" },
        { word: "食堂", reading: "しょくどう", meaning: "dining room, dining hall, cafeteria" }
    ],
    },
    "童": {
        onyomi: ["ドウ"],
        kunyomi: ["わらべ"],
        examples: [
        { word: "学童", reading: "がくどう", meaning: "schoolchild, pupil" },
        { word: "児童", reading: "じどう", meaning: "children, juvenile" },
        { word: "神童", reading: "しんどう", meaning: "child prodigy, infant genius, wonder child" },
        { word: "童顔", reading: "どうがん", meaning: "child's face" }
    ],
    },
    "道": {
        onyomi: ["ドウ", "トウ"],
        kunyomi: ["みち", "いう"],
        examples: [
        { word: "沿道", reading: "えんどう", meaning: "roadside, wayside, route" },
        { word: "横道", reading: "よこみち", meaning: "byway, side street, cross street" },
        { word: "花道", reading: "はなみち", meaning: "elevated walkway through the audience to the stage" },
        { word: "街道", reading: "かいどう", meaning: "highway (esp. one existing from the Edo period), main road" }
    ],
    },
    "働": {
        onyomi: ["ドウ"],
        kunyomi: ["はたら.く"],
        examples: [
        { word: "働き", reading: "はたらき", meaning: "work, labor, labour" },
        { word: "働く", reading: "はたらく", meaning: "to work, to labor, to labour" },
        { word: "稼働", reading: "かどう", meaning: "operation (of a machine), running" },
        { word: "労働", reading: "ろうどう", meaning: "labor, labour, work" }
    ],
    },
    "銅": {
        onyomi: ["ドウ"],
        kunyomi: ["あかがね"],
        examples: [
        { word: "青銅", reading: "せいどう", meaning: "bronze" },
        { word: "銅貨", reading: "どうか", meaning: "copper coin" },
        { word: "銅山", reading: "どうざん", meaning: "copper mine" },
        { word: "銅像", reading: "どうぞう", meaning: "bronze statue" }
    ],
    },
    "導": {
        onyomi: ["ドウ"],
        kunyomi: ["みちび.く"],
        examples: [
        { word: "指導", reading: "しどう", meaning: "guidance, leadership, instruction" },
        { word: "主導", reading: "しゅどう", meaning: "leadership, initiative, spearhead" },
        { word: "先導", reading: "せんどう", meaning: "guidance, leadership, leading the way" },
        { word: "導く", reading: "みちびく", meaning: "to guide, to lead, to show the way" }
    ],
    },
    "瞳": {
        onyomi: ["ドウ", "トウ"],
        kunyomi: ["ひとみ"],
        examples: [
        { word: "瞳", reading: "ひとみ", meaning: "pupil (of the eye)" }
    ],
    },
    "峠": {
        onyomi: [],
        kunyomi: ["とうげ"],
        examples: [
        { word: "峠", reading: "とうげ", meaning: "(mountain) pass, highest point on a mountain road, ridge" }
    ],
    },
    "匿": {
        onyomi: ["トク"],
        kunyomi: ["かくま.う"],
        examples: [
        { word: "隠匿", reading: "いんとく", meaning: "concealment (esp. of wrongdoings or criminals), sheltering, harboring" },
        { word: "匿名", reading: "とくめい", meaning: "anonymity, using an assumed name" }
    ],
    },
    "特": {
        onyomi: ["トク"],
        kunyomi: [],
        examples: [
        { word: "特に", reading: "とくに", meaning: "particularly, especially, in particular" },
        { word: "特異", reading: "とくい", meaning: "unique, peculiar, singular" },
        { word: "特技", reading: "とくぎ", meaning: "special skill" },
        { word: "特急", reading: "とっきゅう", meaning: "limited express (train for which a limited-express ticket is required)" }
    ],
    },
    "得": {
        onyomi: ["トク"],
        kunyomi: ["え.る", "う.る"],
        examples: [
        { word: "お得", reading: "おとく", meaning: "good-value, economical, advantageous (price, deal, etc.)" },
        { word: "獲得", reading: "かくとく", meaning: "acquisition, possession" },
        { word: "取得", reading: "しゅとく", meaning: "obtaining (a qualification, right, object, etc.), acquisition (of land, property, etc.), gaining possession (of)" },
        { word: "拾得", reading: "しゅうとく", meaning: "finding (lost property), picking up" }
    ],
    },
    "督": {
        onyomi: ["トク"],
        kunyomi: [],
        examples: [
        { word: "監督", reading: "かんとく", meaning: "supervision, control, superintendence" },
        { word: "総督", reading: "そうとく", meaning: "governor-general, governor, viceroy" },
        { word: "督促", reading: "とくそく", meaning: "urge, demand, importunity" }
    ],
    },
    "徳": {
        onyomi: ["トク"],
        kunyomi: [],
        examples: [
        { word: "悪徳", reading: "あくとく", meaning: "vice, immorality, corruption" },
        { word: "淑徳", reading: "しゅくとく", meaning: "womanly virtues" },
        { word: "道徳", reading: "どうとく", meaning: "morals, morality" },
        { word: "不徳", reading: "ふとく", meaning: "lack of virtue, immorality, vice" }
    ],
    },
    "篤": {
        onyomi: ["トク"],
        kunyomi: ["あつ.い"],
        examples: [
        { word: "危篤", reading: "きとく", meaning: "critical condition, being on the verge of death" },
        { word: "篤志家", reading: "とくしか", meaning: "charitable person, philanthropist, volunteer" }
    ],
    },
    "毒": {
        onyomi: ["ドク"],
        kunyomi: [],
        examples: [
        { word: "消毒", reading: "しょうどく", meaning: "disinfection, sterilization, sterilisation" },
        { word: "中毒", reading: "ちゅうどく", meaning: "poisoning" },
        { word: "毒殺", reading: "どくさつ", meaning: "killing by poisoning, killing with poison, poisoning (to death)" },
        { word: "毒性", reading: "どくせい", meaning: "toxicity, virulence" }
    ],
    },
    "独": {
        onyomi: ["ドク", "トク"],
        kunyomi: ["ひと.り"],
        examples: [
        { word: "孤独", reading: "こどく", meaning: "solitude, loneliness, isolation" },
        { word: "単独", reading: "たんどく", meaning: "sole, single, solo" },
        { word: "独演", reading: "どくえん", meaning: "solo, solo performance" },
        { word: "独学", reading: "どくがく", meaning: "self-education, self-instruction, self-study" }
    ],
    },
    "読": {
        onyomi: ["ドク", "トク", "トウ"],
        kunyomi: ["よ.む", "-よ.み"],
        examples: [
        { word: "愛読", reading: "あいどく", meaning: "reading with pleasure" },
        { word: "音読", reading: "おんどく", meaning: "reading aloud" },
        { word: "解読", reading: "かいどく", meaning: "deciphering, decoding" },
        { word: "購読", reading: "こうどく", meaning: "buying and reading (book, magazine, etc.), subscribing (incl. free subscriptions), taking (e.g. newspaper)" }
    ],
    },
    "栃": {
        onyomi: [],
        kunyomi: ["とち"],
        examples: [
        { word: "栃若", reading: "とちわか", meaning: "Tochinishiki and Wakanohana I (dominant 1950s yokozuna)" },
        { word: "栃麺", reading: "とちめん", meaning: "noodles made from regular flour and horse chestnut flour" },
        { word: "栃餅", reading: "とちもち", meaning: "cake made from pounded horse chestnuts and mochi rice" },
        { word: "栃木", reading: "とちぎ", meaning: "Tochigi (city, prefecture)" }
    ],
    },
    "凸": {
        onyomi: ["トツ"],
        kunyomi: ["でこ"],
        examples: [
        { word: "凹凸", reading: "おうとつ", meaning: "unevenness, bumpiness, roughness" },
        { word: "凸版", reading: "とっぱん", meaning: "letterpress, relief printing" },
        { word: "凸凹", reading: "でこぼこ", meaning: "unevenness, roughness, ruggedness" },
        { word: "凸版印刷", reading: "とっぱんいんさつ", meaning: "letterpress, relief printing" }
    ],
    },
    "突": {
        onyomi: ["トツ", "カ"],
        kunyomi: ["つ.く"],
        examples: [
        { word: "煙突", reading: "えんとつ", meaning: "chimney, smokestack, funnel (of a ship)" },
        { word: "激突", reading: "げきとつ", meaning: "crash, smashing (into), ramming" },
        { word: "衝突", reading: "しょうとつ", meaning: "collision, crash, impact" },
        { word: "追突", reading: "ついとつ", meaning: "rear-end collision" }
    ],
    },
    "届": {
        onyomi: ["カイ"],
        kunyomi: ["とど.ける", "-とど.け", "とど.く"],
        examples: [
        { word: "届く", reading: "とどく", meaning: "to reach, to touch, to get to" },
        { word: "届け", reading: "とどけ", meaning: "report, notification, registration" },
        { word: "届ける", reading: "とどける", meaning: "to deliver, to forward, to send" },
        { word: "届け出", reading: "とどけで", meaning: "report, notification" }
    ],
    },
    "屯": {
        onyomi: ["トン"],
        kunyomi: ["たむろ"],
        examples: [
        { word: "駐屯", reading: "ちゅうとん", meaning: "stationing (troops), garrisoning" }
    ],
    },
    "豚": {
        onyomi: ["トン"],
        kunyomi: ["ぶた"],
        examples: [
        { word: "豚肉", reading: "ぶたにく", meaning: "pork" },
        { word: "養豚", reading: "ようとん", meaning: "pig-keeping, pig farming" },
        { word: "豚カツ", reading: "とんカツ", meaning: "tonkatsu, breaded pork cutlet" },
        { word: "豚", reading: "ぶた", meaning: "pig (Sus scrofa domesticus)" }
    ],
    },
    "頓": {
        onyomi: ["トン", "トツ"],
        kunyomi: ["にわか.に", "とん.と", "つまず.く", "とみ.に", "ぬかずく"],
        examples: [
        { word: "整頓", reading: "せいとん", meaning: "orderliness, put in order, tidying up" }
    ],
    },
    "貪": {
        onyomi: ["タン", "ドン", "トン"],
        kunyomi: ["むさぼ.る"],
        examples: [
        { word: "貪る", reading: "むさぼる", meaning: "to covet, to crave, to be greedy for" },
        { word: "貪欲", reading: "どんよく", meaning: "greedy, avaricious, covetous" }
    ],
    },
    "鈍": {
        onyomi: ["ドン"],
        kunyomi: ["にぶ.い", "にぶ.る", "にぶ-", "なま.る", "なまく.ら"],
        examples: [
        { word: "鈍化", reading: "どんか", meaning: "becoming dull, slowing down" },
        { word: "鈍感", reading: "どんかん", meaning: "thickheaded, insensitive, dull" },
        { word: "鈍器", reading: "どんき", meaning: "blunt weapon" },
        { word: "鈍い", reading: "にぶい", meaning: "dull (e.g. a knife), blunt" }
    ],
    },
    "曇": {
        onyomi: ["ドン"],
        kunyomi: ["くも.る"],
        examples: [
        { word: "曇る", reading: "くもる", meaning: "to get cloudy, to cloud over, to become overcast" },
        { word: "曇り", reading: "くもり", meaning: "cloudiness, cloudy weather" }
    ],
    },
    "丼": {
        onyomi: ["トン", "タン", "ショウ", "セイ"],
        kunyomi: ["どんぶり"],
        examples: [
        { word: "牛丼", reading: "ぎゅうどん", meaning: "gyudon, rice covered with sliced beef, usu. with fried onion" },
        { word: "丼", reading: "どんぶり", meaning: "porcelain bowl" }
    ],
    },
    "那": {
        onyomi: ["ナ", "ダ"],
        kunyomi: ["なに", "なんぞ", "いかん"],
        examples: [
        { word: "旦那", reading: "だんな", meaning: "master (of a house, shop, etc.)" },
        { word: "刹那", reading: "せつな", meaning: "moment, instant" }
    ],
    },
    "奈": {
        onyomi: ["ナ", "ナイ", "ダイ"],
        kunyomi: ["いかん", "からなし"],
        examples: [
        { word: "奈良", reading: "なら", meaning: "Nara (city, prefecture)" }
    ],
    },
    "内": {
        onyomi: ["ナイ", "ダイ"],
        kunyomi: ["うち"],
        examples: [
        { word: "案内", reading: "あんない", meaning: "guidance, leading (the way), showing around" },
        { word: "以内", reading: "いない", meaning: "within, inside of, less than" },
        { word: "域内", reading: "いきない", meaning: "inside the area" },
        { word: "屋内", reading: "おくない", meaning: "indoors" }
    ],
    },
    "梨": {
        onyomi: ["リ"],
        kunyomi: ["なし"],
        examples: [
        { word: "梨", reading: "なし", meaning: "nashi (esp. Pyrus pyrifolia), Japanese pear, Asian pear" }
    ],
    },
    "謎": {
        onyomi: ["メイ", "ベイ"],
        kunyomi: ["なぞ"],
        examples: [
        { word: "謎々", reading: "なぞなぞ", meaning: "riddle, puzzle, enigma" },
        { word: "謎", reading: "なぞ", meaning: "riddle, puzzle, enigma" }
    ],
    },
    "鍋": {
        onyomi: ["カ"],
        kunyomi: ["なべ"],
        examples: [
        { word: "鍋料理", reading: "なべりょうり", meaning: "hot pot cooking" },
        { word: "もつ鍋", reading: "もつなべ", meaning: "hot pot stew made with offal, vegetables and (often) miso" },
        { word: "鍋", reading: "なべ", meaning: "pan, pot, saucepan" }
    ],
    },
    "南": {
        onyomi: ["ナン", "ナ"],
        kunyomi: ["みなみ"],
        examples: [
        { word: "西南", reading: "せいなん", meaning: "south-west" },
        { word: "東南", reading: "とうなん", meaning: "south-east" },
        { word: "南緯", reading: "なんい", meaning: "southern latitude" },
        { word: "南海", reading: "なんかい", meaning: "southern sea" }
    ],
    },
    "軟": {
        onyomi: ["ナン"],
        kunyomi: ["やわ.らか", "やわ.らかい"],
        examples: [
        { word: "柔軟", reading: "じゅうなん", meaning: "flexible, lithe, soft" },
        { word: "軟化", reading: "なんか", meaning: "softening" },
        { word: "軟骨", reading: "なんこつ", meaning: "cartilage" },
        { word: "軟式", reading: "なんしき", meaning: "soft (esp. of softball, tennis, etc.)" }
    ],
    },
    "難": {
        onyomi: ["ナン"],
        kunyomi: ["かた.い", "-がた.い", "むずか.しい", "むづか.しい", "むつか.しい", "-にく.い"],
        examples: [
        { word: "海難", reading: "かいなん", meaning: "accident at sea, sea disaster, shipwreck" },
        { word: "苦難", reading: "くなん", meaning: "suffering, distress, hardship" },
        { word: "困難", reading: "こんなん", meaning: "difficulty, hardship, trouble" },
        { word: "災難", reading: "さいなん", meaning: "calamity, misfortune, disaster" }
    ],
    },
    "二": {
        onyomi: ["ニ", "ジ"],
        kunyomi: ["ふた", "ふた.つ", "ふたたび"],
        examples: [
        { word: "十二", reading: "じゅうに", meaning: "twelve, 12" },
        { word: "第二", reading: "だいに", meaning: "second" },
        { word: "二つ", reading: "ふたつ", meaning: "two" },
        { word: "二院", reading: "にいん", meaning: "the two houses of legislature" }
    ],
    },
    "尼": {
        onyomi: ["ニ"],
        kunyomi: ["あま"],
        examples: [
        { word: "尼僧", reading: "にそう", meaning: "Buddhist nun" },
        { word: "尼", reading: "あま", meaning: "Buddhist nun" }
    ],
    },
    "弐": {
        onyomi: ["ニ", "ジ"],
        kunyomi: ["ふた.つ", "そえ"],
        examples: [
        { word: "弐拾", reading: "にじゅう", meaning: "twenty, 20" },
        { word: "弐心", reading: "ふたごころ", meaning: "duplicity, treachery, double-dealing" },
        { word: "弐つ", reading: "ふたつ", meaning: "two" },
        { word: "疑弐", reading: "ぎじ", meaning: "doubt, distrust, disobedience" }
    ],
    },
    "匂": {
        onyomi: [],
        kunyomi: ["にお.う", "にお.い", "にお.わせる"],
        examples: [
        { word: "匂い", reading: "におい", meaning: "smell, scent, odour" },
        { word: "匂う", reading: "におう", meaning: "to be fragrant, to smell (good)" }
    ],
    },
    "肉": {
        onyomi: ["ニク"],
        kunyomi: ["しし"],
        examples: [
        { word: "牛肉", reading: "ぎゅうにく", meaning: "beef" },
        { word: "魚肉", reading: "ぎょにく", meaning: "fish meat" },
        { word: "筋肉", reading: "きんにく", meaning: "muscle" },
        { word: "鶏肉", reading: "とりにく", meaning: "chicken meat" }
    ],
    },
    "虹": {
        onyomi: ["コウ"],
        kunyomi: ["にじ"],
        examples: [
        { word: "虹", reading: "にじ", meaning: "rainbow" }
    ],
    },
    "日": {
        onyomi: ["ニチ", "ジツ"],
        kunyomi: ["ひ", "-び", "-か"],
        examples: [
        { word: "何日", reading: "なんにち", meaning: "what day" },
        { word: "幾日", reading: "いくにち", meaning: "(for) how many days" },
        { word: "期日", reading: "きじつ", meaning: "fixed date, appointed date, set date" },
        { word: "休日", reading: "きゅうじつ", meaning: "holiday, day off" }
    ],
    },
    "入": {
        onyomi: ["ニュウ", "ジュ"],
        kunyomi: ["い.る", "-い.る", "-い.り", "い.れる", "-い.れ", "はい.る"],
        examples: [
        { word: "加入", reading: "かにゅう", meaning: "joining (a club, organization, etc.), becoming a member, entry" },
        { word: "介入", reading: "かいにゅう", meaning: "intervention" },
        { word: "記入", reading: "きにゅう", meaning: "entry (in a form, register, diary, etc.), filling in, filling out" },
        { word: "吸入", reading: "きゅうにゅう", meaning: "inhalation" }
    ],
    },
    "乳": {
        onyomi: ["ニュウ"],
        kunyomi: ["ちち", "ち"],
        examples: [
        { word: "牛乳", reading: "ぎゅうにゅう", meaning: "(cow's) milk" },
        { word: "搾乳", reading: "さくにゅう", meaning: "milking (a cow, goat, etc.)" },
        { word: "豆乳", reading: "とうにゅう", meaning: "soy milk" },
        { word: "乳児", reading: "にゅうじ", meaning: "infant (below 1 year old), suckling baby" }
    ],
    },
    "尿": {
        onyomi: ["ニョウ"],
        kunyomi: ["ゆばり", "いばり", "しと"],
        examples: [
        { word: "尿酸", reading: "にょうさん", meaning: "uric acid" },
        { word: "糖尿病", reading: "とうにょうびょう", meaning: "diabetes, diabetes mellitus" },
        { word: "泌尿器", reading: "ひにょうき", meaning: "urinary organs" },
        { word: "尿", reading: "にょう", meaning: "urine" }
    ],
    },
    "任": {
        onyomi: ["ニン"],
        kunyomi: ["まか.せる", "まか.す"],
        examples: [
        { word: "委任", reading: "いにん", meaning: "entrusting, charge, delegation" },
        { word: "一任", reading: "いちにん", meaning: "entrusting (everything to), leaving (a matter) entirely with" },
        { word: "解任", reading: "かいにん", meaning: "dismissal (from a post), discharge, removal" },
        { word: "兼任", reading: "けんにん", meaning: "serving concurrently as, holding the additional post of" }
    ],
    },
    "妊": {
        onyomi: ["ニン", "ジン"],
        kunyomi: ["はら.む", "みごも.る"],
        examples: [
        { word: "妊娠", reading: "にんしん", meaning: "pregnancy, conception, gestation" },
        { word: "妊婦", reading: "にんぷ", meaning: "pregnant woman" },
        { word: "避妊", reading: "ひにん", meaning: "contraception, birth control" },
        { word: "不妊", reading: "ふにん", meaning: "infertility, sterility, barrenness" }
    ],
    },
    "忍": {
        onyomi: ["ニン"],
        kunyomi: ["しの.ぶ", "しの.ばせる"],
        examples: [
        { word: "残忍", reading: "ざんにん", meaning: "brutal, cruel, merciless" },
        { word: "忍ぶ", reading: "しのぶ", meaning: "to conceal oneself, to hide" },
        { word: "忍者", reading: "にんじゃ", meaning: "ninja, person trained in ninjutsu and employed for covert purposes in feudal Japan" },
        { word: "忍耐", reading: "にんたい", meaning: "endurance, perseverance, patience" }
    ],
    },
    "認": {
        onyomi: ["ニン"],
        kunyomi: ["みと.める", "したた.める"],
        examples: [
        { word: "確認", reading: "かくにん", meaning: "confirmation, verification, validation" },
        { word: "誤認", reading: "ごにん", meaning: "misrecognition, mistaking (x for y)" },
        { word: "公認", reading: "こうにん", meaning: "official recognition, official approval, certification" },
        { word: "承認", reading: "しょうにん", meaning: "recognition, acknowledgement, acknowledgment" }
    ],
    },
    "寧": {
        onyomi: ["ネイ"],
        kunyomi: ["むし.ろ"],
        examples: [
        { word: "丁寧", reading: "ていねい", meaning: "polite, courteous, civil" },
        { word: "寧ろ", reading: "むしろ", meaning: "rather, better, instead" }
    ],
    },
    "熱": {
        onyomi: ["ネツ"],
        kunyomi: ["あつ.い"],
        examples: [
        { word: "加熱", reading: "かねつ", meaning: "heating, application of heat" },
        { word: "過熱", reading: "かねつ", meaning: "overheating, excessive heating" },
        { word: "解熱", reading: "げねつ", meaning: "lowering a fever, alleviation of fever" },
        { word: "高熱", reading: "こうねつ", meaning: "high fever" }
    ],
    },
    "年": {
        onyomi: ["ネン"],
        kunyomi: ["とし"],
        examples: [
        { word: "越年", reading: "えつねん", meaning: "seeing the old year out, greeting the New Year, passing the winter" },
        { word: "往年", reading: "おうねん", meaning: "years gone by, earlier years, former years" },
        { word: "何年", reading: "なんねん", meaning: "how many years, how long" },
        { word: "学年", reading: "がくねん", meaning: "academic year, school year" }
    ],
    },
    "念": {
        onyomi: ["ネン"],
        kunyomi: [],
        examples: [
        { word: "概念", reading: "がいねん", meaning: "general idea, concept, notion" },
        { word: "観念", reading: "かんねん", meaning: "idea, notion, concept" },
        { word: "祈念", reading: "きねん", meaning: "prayer" },
        { word: "記念", reading: "きねん", meaning: "commemoration, celebration, remembrance" }
    ],
    },
    "捻": {
        onyomi: ["ネン", "ジョウ"],
        kunyomi: ["ね.じる", "ねじ.る", "ひね.くる", "ひね.る"],
        examples: [
        { word: "捻る", reading: "ひねる", meaning: "to twist, to wrench, to turn (a tap, switch, etc.)" },
        { word: "捻挫", reading: "ねんざ", meaning: "sprain, twist, wrench" }
    ],
    },
    "粘": {
        onyomi: ["ネン"],
        kunyomi: ["ねば.る"],
        examples: [
        { word: "粘り", reading: "ねばり", meaning: "stickiness, viscosity" },
        { word: "粘る", reading: "ねばる", meaning: "to be sticky, to be adhesive" },
        { word: "粘着", reading: "ねんちゃく", meaning: "cohesion, adhesion" },
        { word: "粘土", reading: "ねんど", meaning: "clay" }
    ],
    },
    "燃": {
        onyomi: ["ネン"],
        kunyomi: ["も.える", "も.やす", "も.す"],
        examples: [
        { word: "再燃", reading: "さいねん", meaning: "recurrence, revival, resuscitation" },
        { word: "燃焼", reading: "ねんしょう", meaning: "burning, combustion" },
        { word: "燃費", reading: "ねんぴ", meaning: "fuel consumption, gas mileage" },
        { word: "燃料", reading: "ねんりょう", meaning: "fuel" }
    ],
    },
    "悩": {
        onyomi: ["ノウ"],
        kunyomi: ["なや.む", "なや.ます", "なや.ましい", "なやみ"],
        examples: [
        { word: "苦悩", reading: "くのう", meaning: "(mental) agony, anguish, suffering" },
        { word: "悩み", reading: "なやみ", meaning: "trouble, troubles, worry" },
        { word: "悩む", reading: "なやむ", meaning: "to be worried, to be troubled" },
        { word: "煩悩", reading: "ぼんのう", meaning: "worldly desires, evil passions, appetites of the flesh" }
    ],
    },
    "納": {
        onyomi: ["ノウ", "ナッ", "ナ", "ナン", "トウ"],
        kunyomi: ["おさ.める", "-おさ.める", "おさ.まる"],
        examples: [
        { word: "収納", reading: "しゅうのう", meaning: "storage, putting away" },
        { word: "出納", reading: "すいとう", meaning: "receipts and expenditure (disbursements)" },
        { word: "滞納", reading: "たいのう", meaning: "falling behind (with a payment), being in arrears, non-payment" },
        { word: "納屋", reading: "なや", meaning: "barn (for storage), shed, outbuilding" }
    ],
    },
    "能": {
        onyomi: ["ノウ"],
        kunyomi: ["よ.く", "あた.う"],
        examples: [
        { word: "可能", reading: "かのう", meaning: "possible, potential, practicable" },
        { word: "堪能", reading: "たんのう", meaning: "proficient, skilled, skillful" },
        { word: "機能", reading: "きのう", meaning: "function, facility, faculty" },
        { word: "技能", reading: "ぎのう", meaning: "technical skill, ability, capacity" }
    ],
    },
    "脳": {
        onyomi: ["ノウ", "ドウ"],
        kunyomi: ["のうずる"],
        examples: [
        { word: "首脳", reading: "しゅのう", meaning: "head, leader, top" },
        { word: "洗脳", reading: "せんのう", meaning: "brainwashing" },
        { word: "大脳", reading: "だいのう", meaning: "cerebrum" },
        { word: "頭脳", reading: "ずのう", meaning: "head, brains" }
    ],
    },
    "農": {
        onyomi: ["ノウ"],
        kunyomi: [],
        examples: [
        { word: "農園", reading: "のうえん", meaning: "farm, plantation" },
        { word: "農家", reading: "のうか", meaning: "farmer, farming family" },
        { word: "農協", reading: "のうきょう", meaning: "agricultural cooperative" },
        { word: "農業", reading: "のうぎょう", meaning: "agriculture, farming" }
    ],
    },
    "濃": {
        onyomi: ["ノウ"],
        kunyomi: ["こ.い"],
        examples: [
        { word: "濃い", reading: "こい", meaning: "deep (colour), dark" },
        { word: "濃厚", reading: "のうこう", meaning: "rich (flavor, color, etc.), strong (e.g. odor), heavy" },
        { word: "濃紺", reading: "のうこん", meaning: "dark blue" },
        { word: "濃縮", reading: "のうしゅく", meaning: "concentration (e.g. of a solution), enrichment, condensation" }
    ],
    },
    "把": {
        onyomi: ["ハ", "ワ"],
        kunyomi: [],
        examples: [
        { word: "把握", reading: "はあく", meaning: "grasp (of the situation, meaning, etc.), understanding, control" },
        { word: "大雑把", reading: "おおざっぱ", meaning: "rough (estimate, summary, etc.), broad, general" },
        { word: "把", reading: "わ", meaning: "counter for bundles" }
    ],
    },
    "波": {
        onyomi: ["ハ"],
        kunyomi: ["なみ"],
        examples: [
        { word: "寒波", reading: "かんぱ", meaning: "cold wave" },
        { word: "荒波", reading: "あらなみ", meaning: "raging waves, stormy seas" },
        { word: "高波", reading: "たかなみ", meaning: "high waves, heavy seas" },
        { word: "短波", reading: "たんぱ", meaning: "short wave" }
    ],
    },
    "派": {
        onyomi: ["ハ"],
        kunyomi: [],
        examples: [
        { word: "一派", reading: "いっぱ", meaning: "one school, one sect, one denomination" },
        { word: "右派", reading: "うは", meaning: "right wing" },
        { word: "硬派", reading: "こうは", meaning: "hard-liners, diehards, hawks" },
        { word: "左派", reading: "さは", meaning: "left wing" }
    ],
    },
    "破": {
        onyomi: ["ハ"],
        kunyomi: ["やぶ.る", "やぶ.れる", "わ.れる"],
        examples: [
        { word: "喝破", reading: "かっぱ", meaning: "arguing (someone) down, loudly scolding, rebuking" },
        { word: "打破", reading: "だは", meaning: "breaking down, defeating, abolishing" },
        { word: "突破", reading: "とっぱ", meaning: "breaking through, breakthrough, penetration" },
        { word: "破る", reading: "やぶる", meaning: "to tear, to rip, to break" }
    ],
    },
    "覇": {
        onyomi: ["ハ", "ハク"],
        kunyomi: ["はたがしら"],
        examples: [
        { word: "制覇", reading: "せいは", meaning: "conquest, domination, supremacy" },
        { word: "覇気", reading: "はき", meaning: "spirit, drive, vigour" },
        { word: "覇権", reading: "はけん", meaning: "hegemony" },
        { word: "覇者", reading: "はしゃ", meaning: "supreme ruler, conqueror" }
    ],
    },
    "馬": {
        onyomi: ["バ", "メ", "マ", "ボ", "モ"],
        kunyomi: ["うま", "ま"],
        examples: [
        { word: "騎馬", reading: "きば", meaning: "horse riding, horseback riding, horseback rider" },
        { word: "競馬", reading: "けいば", meaning: "horse racing" },
        { word: "出馬", reading: "しゅつば", meaning: "running (for election), coming forward as a candidate" },
        { word: "乗馬", reading: "じょうば", meaning: "horse riding, horseback riding, mounting a horse" }
    ],
    },
    "婆": {
        onyomi: ["バ"],
        kunyomi: ["ばば", "ばあ"],
        examples: [
        { word: "老婆", reading: "ろうば", meaning: "old woman" },
        { word: "麻婆", reading: "マーボー", meaning: "mapo (style of dish), dish featuring minced meat stir-fried and seasoned with chili bean paste (e.g. mabo nasu)" },
        { word: "婆さん", reading: "ばあさん", meaning: "grandmother" }
    ],
    },
    "罵": {
        onyomi: ["バ"],
        kunyomi: ["ののし.る"],
        examples: [
        { word: "罵る", reading: "ののしる", meaning: "to abuse (verbally), to curse at, to shout abuse at" }
    ],
    },
    "拝": {
        onyomi: ["ハイ"],
        kunyomi: ["おが.む", "おろが.む"],
        examples: [
        { word: "参拝", reading: "さんぱい", meaning: "going and worshipping (at a shrine or temple), visit (to a shrine or temple to worship)" },
        { word: "崇拝", reading: "すうはい", meaning: "worship, adoration, admiration" },
        { word: "拝む", reading: "おがむ", meaning: "to assume the posture of praying, to press the palms and fingers of both hands together, to do reverence (e.g. before a statue of the Buddha)" },
        { word: "拝啓", reading: "はいけい", meaning: "Dear (so and so), Dear Sir, Dear Madam" }
    ],
    },
    "杯": {
        onyomi: ["ハイ"],
        kunyomi: ["さかずき"],
        examples: [
        { word: "一杯", reading: "いっぱい", meaning: "one cup (of), one glass (of), one bowl (of)" },
        { word: "銀杯", reading: "ぎんぱい", meaning: "silver cup" },
        { word: "祝杯", reading: "しゅくはい", meaning: "toast, congratulatory cup" },
        { word: "満杯", reading: "まんぱい", meaning: "full" }
    ],
    },
    "背": {
        onyomi: ["ハイ"],
        kunyomi: ["せ", "せい", "そむ.く", "そむ.ける"],
        examples: [
        { word: "猫背", reading: "ねこぜ", meaning: "bent back, hunchback, stoop" },
        { word: "背く", reading: "そむく", meaning: "to run counter to, to go against, to disobey" },
        { word: "背景", reading: "はいけい", meaning: "background, scenery, backdrop" },
        { word: "背後", reading: "はいご", meaning: "back, rear" }
    ],
    },
    "肺": {
        onyomi: ["ハイ"],
        kunyomi: [],
        examples: [
        { word: "肺炎", reading: "はいえん", meaning: "pneumonia" },
        { word: "肺結核", reading: "はいけっかく", meaning: "pulmonary tuberculosis" },
        { word: "肺", reading: "はい", meaning: "lung" }
    ],
    },
    "俳": {
        onyomi: ["ハイ"],
        kunyomi: [],
        examples: [
        { word: "俳句", reading: "はいく", meaning: "haiku, 17-mora poem, usu. in 3 lines of 5, 7 and 5 morae" },
        { word: "俳人", reading: "はいじん", meaning: "haiku poet" },
        { word: "俳優", reading: "はいゆう", meaning: "actor, actress, player" }
    ],
    },
    "配": {
        onyomi: ["ハイ"],
        kunyomi: ["くば.る"],
        examples: [
        { word: "気配", reading: "けはい", meaning: "indication, sign, hint" },
        { word: "軍配", reading: "ぐんばい", meaning: "gourd-shaped war fan" },
        { word: "勾配", reading: "こうばい", meaning: "slope, incline, gradient" },
        { word: "支配", reading: "しはい", meaning: "rule, domination, control" }
    ],
    },
    "排": {
        onyomi: ["ハイ"],
        kunyomi: [],
        examples: [
        { word: "排気", reading: "はいき", meaning: "exhaust, emission (of gas from an engine)" },
        { word: "排出", reading: "はいしゅつ", meaning: "discharge, evacuation, emission (e.g. of CO2)" },
        { word: "排除", reading: "はいじょ", meaning: "exclusion, removal, elimination" },
        { word: "排水", reading: "はいすい", meaning: "drainage, draining, pumping out (water)" }
    ],
    },
    "敗": {
        onyomi: ["ハイ"],
        kunyomi: ["やぶ.れる"],
        examples: [
        { word: "一敗", reading: "いっぱい", meaning: "one defeat" },
        { word: "完敗", reading: "かんぱい", meaning: "(suffering a) complete defeat, utter defeat, annihilation" },
        { word: "失敗", reading: "しっぱい", meaning: "failure, mistake, blunder" },
        { word: "勝敗", reading: "しょうはい", meaning: "victory or defeat, outcome (of a game, battle, etc.)" }
    ],
    },
    "廃": {
        onyomi: ["ハイ"],
        kunyomi: ["すた.れる", "すた.る"],
        examples: [
        { word: "荒廃", reading: "こうはい", meaning: "ruin, destruction, devastation" },
        { word: "全廃", reading: "ぜんぱい", meaning: "total abolition, full phase-out, total repeal" },
        { word: "撤廃", reading: "てっぱい", meaning: "annulment, abolition, repeal" },
        { word: "廃棄", reading: "はいき", meaning: "disposal, abandonment, scrapping" }
    ],
    },
    "輩": {
        onyomi: ["ハイ"],
        kunyomi: ["-ばら", "やから", "やかい", "ともがら"],
        examples: [
        { word: "後輩", reading: "こうはい", meaning: "junior (at work, school, etc.), younger people, younger student" },
        { word: "先輩", reading: "せんぱい", meaning: "senior (at school, work, etc.), superior, elder" },
        { word: "年輩", reading: "ねんぱい", meaning: "(approximate) age, years" },
        { word: "輩出", reading: "はいしゅつ", meaning: "producing (people) in great numbers, appearing one after the other" }
    ],
    },
    "売": {
        onyomi: ["バイ"],
        kunyomi: ["う.る", "う.れる"],
        examples: [
        { word: "競売", reading: "きょうばい", meaning: "auction" },
        { word: "商売", reading: "しょうばい", meaning: "trade, business, commerce" },
        { word: "専売", reading: "せんばい", meaning: "monopoly, monopolization, exclusive sales rights" },
        { word: "即売", reading: "そくばい", meaning: "selling on the spot" }
    ],
    },
    "倍": {
        onyomi: ["バイ"],
        kunyomi: [],
        examples: [
        { word: "一倍", reading: "いちばい", meaning: "multiplying by one, original amount" },
        { word: "倍加", reading: "ばいか", meaning: "doubling" },
        { word: "倍増", reading: "ばいぞう", meaning: "doubling, double" },
        { word: "倍率", reading: "ばいりつ", meaning: "magnification, leverage, amplification" }
    ],
    },
    "梅": {
        onyomi: ["バイ"],
        kunyomi: ["うめ"],
        examples: [
        { word: "紅梅", reading: "こうばい", meaning: "red-blossomed plum tree, red Japanese apricot" },
        { word: "入梅", reading: "つゆいり", meaning: "entering the rainy season, beginning of the rainy season" },
        { word: "梅干", reading: "うめぼし", meaning: "umeboshi, pickled dried ume, pickled dried plum" },
        { word: "梅酒", reading: "うめしゅ", meaning: "ume liqueur, Japanese plum brandy, unripe ume infused in liquor (esp. shōchū) with added sugar" }
    ],
    },
    "培": {
        onyomi: ["バイ"],
        kunyomi: ["つちか.う"],
        examples: [
        { word: "栽培", reading: "さいばい", meaning: "cultivation" },
        { word: "培う", reading: "つちかう", meaning: "to cultivate, to foster" },
        { word: "培養", reading: "ばいよう", meaning: "culture, cultivation" }
    ],
    },
    "陪": {
        onyomi: ["バイ"],
        kunyomi: [],
        examples: [
        { word: "陪審", reading: "ばいしん", meaning: "jury" }
    ],
    },
    "媒": {
        onyomi: ["バイ"],
        kunyomi: ["なこうど"],
        examples: [
        { word: "触媒", reading: "しょくばい", meaning: "catalyst" },
        { word: "媒介", reading: "ばいかい", meaning: "mediation, agency, serving as a medium" },
        { word: "媒酌", reading: "ばいしゃく", meaning: "matchmaking, acting as a go-between" },
        { word: "媒体", reading: "ばいたい", meaning: "medium, media" }
    ],
    },
    "買": {
        onyomi: ["バイ"],
        kunyomi: ["か.う"],
        examples: [
        { word: "購買", reading: "こうばい", meaning: "procurement, purchase, buying" },
        { word: "仲買", reading: "なかがい", meaning: "brokerage, broker" },
        { word: "買取", reading: "かいとり", meaning: "purchase, buying, buying out" },
        { word: "買う", reading: "かう", meaning: "to buy, to purchase" }
    ],
    },
    "賠": {
        onyomi: ["バイ"],
        kunyomi: [],
        examples: [
        { word: "賠償", reading: "ばいしょう", meaning: "compensation, reparations, indemnity" },
        { word: "賠償金", reading: "ばいしょうきん", meaning: "indemnities, reparations" },
        { word: "損害賠償", reading: "そんがいばいしょう", meaning: "restitution, damages, indemnity" }
    ],
    },
    "白": {
        onyomi: ["ハク", "ビャク"],
        kunyomi: ["しろ", "しら-", "しろ.い"],
        examples: [
        { word: "明白", reading: "めいはく", meaning: "obvious, clear, plain" },
        { word: "空白", reading: "くうはく", meaning: "blank space (in a document)" },
        { word: "潔白", reading: "けっぱく", meaning: "innocence, guiltlessness, purity" },
        { word: "紅白", reading: "こうはく", meaning: "red and white, colours for festive or auspicious occasions (colors)" }
    ],
    },
    "伯": {
        onyomi: ["ハク"],
        kunyomi: [],
        examples: [
        { word: "画伯", reading: "がはく", meaning: "master painter, great artist" },
        { word: "伯爵", reading: "はくしゃく", meaning: "count, earl" },
        { word: "伯仲", reading: "はくちゅう", meaning: "being evenly matched, being equal with, being on a par with" },
        { word: "伯父", reading: "おじ", meaning: "uncle" }
    ],
    },
    "拍": {
        onyomi: ["ハク", "ヒョウ"],
        kunyomi: [],
        examples: [
        { word: "拍車", reading: "はくしゃ", meaning: "(riding) spur" },
        { word: "拍手", reading: "はくしゅ", meaning: "clapping hands, applause" },
        { word: "拍子", reading: "ひょうし", meaning: "time, meter, metre" },
        { word: "脈拍", reading: "みゃくはく", meaning: "pulse, pulse rate, pulsation" }
    ],
    },
    "泊": {
        onyomi: ["ハク"],
        kunyomi: ["と.まる", "と.める"],
        examples: [
        { word: "一泊", reading: "いっぱく", meaning: "(staying) one night, overnight stay" },
        { word: "宿泊", reading: "しゅくはく", meaning: "accommodation, lodging" },
        { word: "停泊", reading: "ていはく", meaning: "anchorage, anchoring, mooring" },
        { word: "泊まる", reading: "とまる", meaning: "to stay at (e.g. hotel)" }
    ],
    },
    "迫": {
        onyomi: ["ハク"],
        kunyomi: ["せま.る"],
        examples: [
        { word: "圧迫", reading: "あっぱく", meaning: "pressure" },
        { word: "気迫", reading: "きはく", meaning: "spirit, soul, drive" },
        { word: "脅迫", reading: "きょうはく", meaning: "threat, menace, coercion" },
        { word: "緊迫", reading: "きんぱく", meaning: "tension, strain" }
    ],
    },
    "剝": {
        onyomi: ["ハク", "ホク"],
        kunyomi: ["へ.ぐ", "へず.る", "む.く", "む.ける", "は.がれる", "は.ぐ", "は.げる", "は.がす"],
        examples: [
        { word: "剝取", reading: "はぎとり", meaning: "tearing off, stripping off, ripping off" },
        { word: "剝く", reading: "むく", meaning: "to peel, to skin, to pare" },
        { word: "剝身", reading: "すきみ", meaning: "thin slice of meat or fish" },
        { word: "剝製", reading: "はくせい", meaning: "stuffed specimen, taxidermy mount" }
    ],
    },
    "舶": {
        onyomi: ["ハク"],
        kunyomi: [],
        examples: [
        { word: "船舶", reading: "せんぱく", meaning: "vessel, ship, shipping" },
        { word: "舶来", reading: "はくらい", meaning: "imported, foreign-made" }
    ],
    },
    "博": {
        onyomi: ["ハク", "バク"],
        kunyomi: [],
        examples: [
        { word: "博愛", reading: "はくあい", meaning: "charity, benevolence, philanthropy" },
        { word: "博学", reading: "はくがく", meaning: "erudition, extensive learning" },
        { word: "博士", reading: "はかせ", meaning: "expert, learned person" },
        { word: "博物", reading: "はくぶつ", meaning: "natural history" }
    ],
    },
    "薄": {
        onyomi: ["ハク"],
        kunyomi: ["うす.い", "うす-", "-うす", "うす.める", "うす.まる", "うす.らぐ", "うす.ら-", "うす.れる", "すすき"],
        examples: [
        { word: "軽薄", reading: "けいはく", meaning: "frivolous, flippant, superficial" },
        { word: "肉薄", reading: "にくはく", meaning: "closing in on (the enemy, first place, etc.), coming close to, pressing hard" },
        { word: "薄い", reading: "うすい", meaning: "thin (of an object)" },
        { word: "薄弱", reading: "はくじゃく", meaning: "feebleness, weakness" }
    ],
    },
    "麦": {
        onyomi: ["バク"],
        kunyomi: ["むぎ"],
        examples: [
        { word: "蕎麦", reading: "そば", meaning: "buckwheat (Fagopyrum esculentum)" },
        { word: "小麦", reading: "こむぎ", meaning: "wheat" },
        { word: "大麦", reading: "おおむぎ", meaning: "barley (Hordeum vulgare)" },
        { word: "麦芽", reading: "ばくが", meaning: "malt" }
    ],
    },
    "漠": {
        onyomi: ["バク"],
        kunyomi: [],
        examples: [
        { word: "漠然", reading: "ばくぜん", meaning: "vague, obscure, indistinct" },
        { word: "砂漠", reading: "さばく", meaning: "desert" },
        { word: "サハラ砂漠", reading: "サハラさばく", meaning: "Sahara Desert" }
    ],
    },
    "縛": {
        onyomi: ["バク"],
        kunyomi: ["しば.る"],
        examples: [
        { word: "束縛", reading: "そくばく", meaning: "restraint, restriction, fetters" },
        { word: "縛る", reading: "しばる", meaning: "to tie, to bind, to fasten" },
        { word: "金縛り", reading: "かなしばり", meaning: "binding hand and foot" },
        { word: "縛り首", reading: "しばりくび", meaning: "(death by) hanging" }
    ],
    },
    "爆": {
        onyomi: ["バク"],
        kunyomi: ["は.ぜる"],
        examples: [
        { word: "起爆", reading: "きばく", meaning: "ignition, detonation, triggering" },
        { word: "原爆", reading: "げんばく", meaning: "atomic bomb, A-bomb" },
        { word: "爆撃", reading: "ばくげき", meaning: "bombing (raid)" },
        { word: "爆笑", reading: "ばくしょう", meaning: "roar of laughter (from multiple people), burst of laughter, uproarious laughter" }
    ],
    },
    "箱": {
        onyomi: ["ソウ"],
        kunyomi: ["はこ"],
        examples: [
        { word: "重箱", reading: "じゅうばこ", meaning: "jūbako, multi-tiered food box" },
        { word: "本箱", reading: "ほんばこ", meaning: "bookcase" },
        { word: "ゴミ箱", reading: "ごみばこ", meaning: "trash can, garbage can, rubbish bin" },
        { word: "救急箱", reading: "きゅうきゅうばこ", meaning: "first-aid kit" }
    ],
    },
    "箸": {
        onyomi: ["チョ", "チャク"],
        kunyomi: ["はし"],
        examples: [
        { word: "割り箸", reading: "わりばし", meaning: "dispensable chopsticks, throwaway chopsticks" },
        { word: "箸", reading: "はし", meaning: "chopsticks" }
    ],
    },
    "畑": {
        onyomi: [],
        kunyomi: ["はた", "はたけ", "-ばたけ"],
        examples: [
        { word: "桑畑", reading: "くわばたけ", meaning: "mulberry field, mulberry plantation" },
        { word: "田畑", reading: "たはた", meaning: "fields (of rice and other crops)" },
        { word: "麦畑", reading: "むぎばたけ", meaning: "wheat field, barley field, cornfield" },
        { word: "畑", reading: "はたけ", meaning: "field (for growing wheat, fruit, vegetables, etc.), cultivated land, vegetable plot" }
    ],
    },
    "肌": {
        onyomi: ["キ"],
        kunyomi: ["はだ"],
        examples: [
        { word: "地肌", reading: "じはだ", meaning: "texture, grain" },
        { word: "肌色", reading: "はだいろ", meaning: "flesh colour (of a Japanese person), flesh color, pale orange" },
        { word: "肌着", reading: "はだぎ", meaning: "underwear, underclothes, lingerie" },
        { word: "肌寒い", reading: "はださむい", meaning: "chilly, unpleasantly cold" }
    ],
    },
    "八": {
        onyomi: ["ハチ", "ハツ"],
        kunyomi: ["や", "や.つ", "やっ.つ", "よう"],
        examples: [
        { word: "尺八", reading: "しゃくはち", meaning: "shakuhachi, end-blown fippleless bamboo flute" },
        { word: "十八", reading: "じゅうはち", meaning: "eighteen, 18" },
        { word: "八月", reading: "はちがつ", meaning: "August" },
        { word: "八日", reading: "ようか", meaning: "8th day of the month" }
    ],
    },
    "鉢": {
        onyomi: ["ハチ", "ハツ"],
        kunyomi: [],
        examples: [
        { word: "火鉢", reading: "ひばち", meaning: "brazier, hibachi" },
        { word: "鉢巻", reading: "はちまき", meaning: "headband" },
        { word: "植木鉢", reading: "うえきばち", meaning: "flowerpot, plant pot" },
        { word: "鉢植え", reading: "はちうえ", meaning: "potted plant" }
    ],
    },
    "発": {
        onyomi: ["ハツ", "ホツ"],
        kunyomi: ["た.つ", "あば.く", "おこ.る", "つか.わす", "はな.つ"],
        examples: [
        { word: "一発", reading: "いっぱつ", meaning: "one shot, one charge, one explosion" },
        { word: "開発", reading: "かいはつ", meaning: "development, cultivation, application" },
        { word: "活発", reading: "かっぱつ", meaning: "lively, active, vigorous" },
        { word: "揮発", reading: "きはつ", meaning: "volatilization, volatilisation" }
    ],
    },
    "髪": {
        onyomi: ["ハツ"],
        kunyomi: ["かみ"],
        examples: [
        { word: "金髪", reading: "きんぱつ", meaning: "blond hair, blonde hair, golden hair" },
        { word: "散髪", reading: "さんぱつ", meaning: "(having a) haircut, hair-cutting, hair-dressing" },
        { word: "洗髪", reading: "せんぱつ", meaning: "washing one's hair, having a shampoo" },
        { word: "前髪", reading: "まえがみ", meaning: "forelock, bangs" }
    ],
    },
    "伐": {
        onyomi: ["バツ", "ハツ", "カ", "ボチ"],
        kunyomi: ["き.る", "そむ.く", "う.つ"],
        examples: [
        { word: "伐採", reading: "ばっさい", meaning: "felling timber, cutting down trees, logging" },
        { word: "間伐", reading: "かんばつ", meaning: "periodic thinning (e.g. forest)" }
    ],
    },
    "抜": {
        onyomi: ["バツ", "ハツ", "ハイ"],
        kunyomi: ["ぬ.く", "-ぬ.く", "ぬ.き", "ぬ.ける", "ぬ.かす", "ぬ.かる"],
        examples: [
        { word: "海抜", reading: "かいばつ", meaning: "height above sea level" },
        { word: "奇抜", reading: "きばつ", meaning: "(very) unusual, unconventional, eccentric" },
        { word: "選抜", reading: "せんばつ", meaning: "selection, choice, picking out" },
        { word: "抜く", reading: "ぬく", meaning: "to pull out, to draw out, to extract" }
    ],
    },
    "罰": {
        onyomi: ["バツ", "バチ", "ハツ"],
        kunyomi: ["ばっ.する"],
        examples: [
        { word: "刑罰", reading: "けいばつ", meaning: "(criminal) punishment, penalty, sentence" },
        { word: "厳罰", reading: "げんばつ", meaning: "severe punishment, rigorous measures" },
        { word: "処罰", reading: "しょばつ", meaning: "punishment, penalty" },
        { word: "賞罰", reading: "しょうばつ", meaning: "reward and punishment" }
    ],
    },
    "閥": {
        onyomi: ["バツ"],
        kunyomi: [],
        examples: [
        { word: "財閥", reading: "ざいばつ", meaning: "zaibatsu, financial conglomerate, industrial group" },
        { word: "派閥", reading: "はばつ", meaning: "clique, faction" },
        { word: "閥", reading: "ばつ", meaning: "clique, clan, faction" }
    ],
    },
    "反": {
        onyomi: ["ハン", "ホン", "タン", "ホ"],
        kunyomi: ["そ.る", "そ.らす", "かえ.す", "かえ.る", "-かえ.る"],
        examples: [
        { word: "違反", reading: "いはん", meaning: "violation, offense, offence" },
        { word: "減反", reading: "げんたん", meaning: "reduction (of crop size), reduction of acreage (under cultivation)" },
        { word: "反る", reading: "そる", meaning: "to warp, to curve, to arch" },
        { word: "反応", reading: "はんのう", meaning: "reaction, response" }
    ],
    },
    "半": {
        onyomi: ["ハン"],
        kunyomi: ["なか.ば"],
        examples: [
        { word: "後半", reading: "こうはん", meaning: "second half, latter half" },
        { word: "折半", reading: "せっぱん", meaning: "halving, splitting evenly, sharing equally" },
        { word: "大半", reading: "たいはん", meaning: "majority, more than half, most (of)" },
        { word: "半ば", reading: "なかば", meaning: "middle, halfway, midway" }
    ],
    },
    "氾": {
        onyomi: ["ハン"],
        kunyomi: ["ひろ.がる"],
        examples: [
        { word: "氾濫", reading: "はんらん", meaning: "overflowing, flood, inundation" }
    ],
    },
    "犯": {
        onyomi: ["ハン", "ボン"],
        kunyomi: ["おか.す"],
        examples: [
        { word: "共犯", reading: "きょうはん", meaning: "complicity" },
        { word: "主犯", reading: "しゅはん", meaning: "principal offence, principal offense, principal offender" },
        { word: "侵犯", reading: "しんぱん", meaning: "violation (of foreign territory, rights, etc.), invasion, infringement" },
        { word: "戦犯", reading: "せんぱん", meaning: "war criminal" }
    ],
    },
    "帆": {
        onyomi: ["ハン"],
        kunyomi: ["ほ"],
        examples: [
        { word: "帆走", reading: "はんそう", meaning: "sailing" },
        { word: "帆船", reading: "はんせん", meaning: "sailing ship, sailing boat, sailing vessel" },
        { word: "帆", reading: "ほ", meaning: "sail" }
    ],
    },
    "汎": {
        onyomi: ["ハン", "ブ", "フウ", "ホウ", "ホン"],
        kunyomi: ["ただよ.う", "ひろ.い"],
        examples: [
        { word: "汎用", reading: "はんよう", meaning: "generic, general purpose, all-purpose" },
        { word: "汎", reading: "はん", meaning: "pan-" }
    ],
    },
    "伴": {
        onyomi: ["ハン", "バン"],
        kunyomi: ["ともな.う"],
        examples: [
        { word: "同伴", reading: "どうはん", meaning: "accompanying, being accompanied by, going with" },
        { word: "伴う", reading: "ともなう", meaning: "to accompany, to go hand in hand with, to be consequent upon" },
        { word: "伴奏", reading: "ばんそう", meaning: "accompaniment" },
        { word: "伴侶", reading: "はんりょ", meaning: "companion, partner, spouse" }
    ],
    },
    "判": {
        onyomi: ["ハン", "バン"],
        kunyomi: ["わか.る"],
        examples: [
        { word: "公判", reading: "こうはん", meaning: "public hearing, trial" },
        { word: "裁判", reading: "さいばん", meaning: "trial, judgement, judgment" },
        { word: "審判", reading: "しんぱん", meaning: "judgement, judgment, decision" },
        { word: "判決", reading: "はんけつ", meaning: "judicial decision, judgement, judgment" }
    ],
    },
    "坂": {
        onyomi: ["ハン"],
        kunyomi: ["さか"],
        examples: [
        { word: "坂道", reading: "さかみち", meaning: "hill road" },
        { word: "下り坂", reading: "くだりざか", meaning: "downhill, downward slope, descent" },
        { word: "上り坂", reading: "のぼりざか", meaning: "ascent, uphill, upward slope" },
        { word: "坂", reading: "さか", meaning: "slope, incline, hill" }
    ],
    },
    "阪": {
        onyomi: ["ハン"],
        kunyomi: ["さか"],
        examples: [
        { word: "京阪", reading: "けいはん", meaning: "Kyoto and Osaka, Kyoto-Osaka area" },
        { word: "阪神", reading: "はんしん", meaning: "Osaka-Kobe" },
        { word: "大阪", reading: "おおさか", meaning: "Osaka (city, prefecture)" }
    ],
    },
    "板": {
        onyomi: ["ハン", "バン"],
        kunyomi: ["いた"],
        examples: [
        { word: "看板", reading: "かんばん", meaning: "signboard, sign, billboard" },
        { word: "黒板", reading: "こくばん", meaning: "blackboard" },
        { word: "鉄板", reading: "てっぱん", meaning: "iron plate, steel plate" },
        { word: "甲板", reading: "かんぱん", meaning: "deck (of a ship)" }
    ],
    },
    "版": {
        onyomi: ["ハン"],
        kunyomi: [],
        examples: [
        { word: "出版", reading: "しゅっぱん", meaning: "publication" },
        { word: "初版", reading: "しょはん", meaning: "first edition" },
        { word: "図版", reading: "ずはん", meaning: "plate, illustration, figure" },
        { word: "凸版", reading: "とっぱん", meaning: "letterpress, relief printing" }
    ],
    },
    "班": {
        onyomi: ["ハン"],
        kunyomi: [],
        examples: [
        { word: "首班", reading: "しゅはん", meaning: "head, leader, prime minister" },
        { word: "班長", reading: "はんちょう", meaning: "squad leader, group leader, team leader" },
        { word: "班", reading: "はん", meaning: "group, party, team" }
    ],
    },
    "畔": {
        onyomi: ["ハン"],
        kunyomi: ["あぜ", "くろ", "ほとり"],
        examples: [
        { word: "河畔", reading: "かはん", meaning: "riverside" },
        { word: "湖畔", reading: "こはん", meaning: "lakeside, lakeshore, lakefront" }
    ],
    },
    "般": {
        onyomi: ["ハン"],
        kunyomi: [],
        examples: [
        { word: "一般", reading: "いっぱん", meaning: "general, universal" },
        { word: "先般", reading: "せんぱん", meaning: "some time ago, the other day" },
        { word: "全般", reading: "ぜんぱん", meaning: "(the) whole" },
        { word: "一般に", reading: "いっぱんに", meaning: "generally, in general, widely" }
    ],
    },
    "販": {
        onyomi: ["ハン"],
        kunyomi: [],
        examples: [
        { word: "再販", reading: "さいはん", meaning: "resale" },
        { word: "市販", reading: "しはん", meaning: "putting on the market, putting on sale, making commercially available" },
        { word: "販売", reading: "はんばい", meaning: "sale, sales, selling" },
        { word: "販路", reading: "はんろ", meaning: "market (for goods, services, etc.), outlet (for selling), opening" }
    ],
    },
    "斑": {
        onyomi: ["ハン"],
        kunyomi: ["ふ", "まだら"],
        examples: [
        { word: "斑", reading: "むら", meaning: "unevenness (of colour, paint, etc.), irregularity, nonuniformity" }
    ],
    },
    "飯": {
        onyomi: ["ハン"],
        kunyomi: ["めし"],
        examples: [
        { word: "ご飯", reading: "ごはん", meaning: "cooked rice" },
        { word: "御飯", reading: "ごはん", meaning: "cooked rice" },
        { word: "赤飯", reading: "せきはん", meaning: "red rice (beans and mochi) for auspicious occasions" },
        { word: "昼飯", reading: "ひるめし", meaning: "lunch, midday meal" }
    ],
    },
    "搬": {
        onyomi: ["ハン"],
        kunyomi: [],
        examples: [
        { word: "運搬", reading: "うんぱん", meaning: "transport, transportation, conveyance" },
        { word: "搬出", reading: "はんしゅつ", meaning: "carrying out (esp. heavy objects, artwork, furniture), taking out" },
        { word: "搬送", reading: "はんそう", meaning: "transportation, conveyance, delivery" },
        { word: "搬入", reading: "はんにゅう", meaning: "carrying in (esp. heavy objects, artwork, furniture), bringing in, taking in" }
    ],
    },
    "煩": {
        onyomi: ["ハン", "ボン"],
        kunyomi: ["わずら.う", "わずら.わす", "うるさ.がる", "うるさ.い"],
        examples: [
        { word: "煩い", reading: "うるさい", meaning: "noisy, loud" },
        { word: "煩雑", reading: "はんざつ", meaning: "complex, intricate, complicated" },
        { word: "煩悩", reading: "ぼんのう", meaning: "worldly desires, evil passions, appetites of the flesh" },
        { word: "煩う", reading: "わずらう", meaning: "to worry (about), to be concerned (about)" }
    ],
    },
    "頒": {
        onyomi: ["ハン"],
        kunyomi: ["わ.かつ", "わ.ける"],
        examples: [
        { word: "頒布", reading: "はんぷ", meaning: "distribution, circulation" }
    ],
    },
    "範": {
        onyomi: ["ハン"],
        kunyomi: [],
        examples: [
        { word: "広範", reading: "こうはん", meaning: "wide, extensive, comprehensive" },
        { word: "師範", reading: "しはん", meaning: "instructor (esp. of martial or traditional arts), teacher, master" },
        { word: "範囲", reading: "はんい", meaning: "extent, scope, sphere" },
        { word: "模範", reading: "もはん", meaning: "exemplar, model, example" }
    ],
    },
    "繁": {
        onyomi: ["ハン"],
        kunyomi: ["しげ.る", "しげ.く"],
        examples: [
        { word: "繁栄", reading: "はんえい", meaning: "prosperity, thriving, flourishing" },
        { word: "繁殖", reading: "はんしょく", meaning: "breeding, propagation, reproduction" },
        { word: "繁盛", reading: "はんじょう", meaning: "prosperity, flourishing, thriving" },
        { word: "繁茂", reading: "はんも", meaning: "flourishing (of plants), thriving, luxuriant growth" }
    ],
    },
    "藩": {
        onyomi: ["ハン"],
        kunyomi: [],
        examples: [
        { word: "藩主", reading: "はんしゅ", meaning: "feudal lord, daimyo" },
        { word: "藩", reading: "はん", meaning: "han (estate of a daimyo in the Edo and early Meiji periods), feudal domain, fief" }
    ],
    },
    "晩": {
        onyomi: ["バン"],
        kunyomi: [],
        examples: [
        { word: "一晩", reading: "ひとばん", meaning: "one night, one evening" },
        { word: "今晩", reading: "こんばん", meaning: "tonight, this evening" },
        { word: "昨晩", reading: "さくばん", meaning: "last night" },
        { word: "朝晩", reading: "あさばん", meaning: "morning and evening" }
    ],
    },
    "番": {
        onyomi: ["バン"],
        kunyomi: ["つが.い"],
        examples: [
        { word: "一番", reading: "いちばん", meaning: "number one, first, first place" },
        { word: "局番", reading: "きょくばん", meaning: "telephone exchange number" },
        { word: "交番", reading: "こうばん", meaning: "police box, koban, small neighborhood police station" },
        { word: "出番", reading: "でばん", meaning: "one's turn, one's shift" }
    ],
    },
    "蛮": {
        onyomi: ["バン"],
        kunyomi: ["えびす"],
        examples: [
        { word: "南蛮", reading: "なんばん", meaning: "southern barbarians (name used in ancient China for non-Chinese ethnic groups to the south)" },
        { word: "蛮行", reading: "ばんこう", meaning: "act of barbarity, barbarism, brutality" },
        { word: "蛮勇", reading: "ばんゆう", meaning: "foolhardiness, recklessness, savage valour" },
        { word: "野蛮", reading: "やばん", meaning: "savage, barbarous, barbaric" }
    ],
    },
    "盤": {
        onyomi: ["バン"],
        kunyomi: [],
        examples: [
        { word: "円盤", reading: "えんばん", meaning: "disk, discus, platter" },
        { word: "岩盤", reading: "がんばん", meaning: "bedrock" },
        { word: "基盤", reading: "きばん", meaning: "base, basis, foundation" },
        { word: "鍵盤", reading: "けんばん", meaning: "keyboard (of a piano, typewriter, etc.)" }
    ],
    },
    "比": {
        onyomi: ["ヒ"],
        kunyomi: ["くら.べる"],
        examples: [
        { word: "比べ", reading: "くらべ", meaning: "contest, comparison, competition" },
        { word: "対比", reading: "たいひ", meaning: "contrast, juxtaposition" },
        { word: "比較", reading: "ひかく", meaning: "comparison" },
        { word: "比重", reading: "ひじゅう", meaning: "specific gravity, relative density" }
    ],
    },
    "皮": {
        onyomi: ["ヒ"],
        kunyomi: ["かわ"],
        examples: [
        { word: "樹皮", reading: "じゅひ", meaning: "bark (of a tree, etc.)" },
        { word: "脱皮", reading: "だっぴ", meaning: "ecdysis, shedding (of skin), sloughing" },
        { word: "皮革", reading: "ひかく", meaning: "leather, hide" },
        { word: "皮肉", reading: "ひにく", meaning: "irony, sarcasm, cynicism" }
    ],
    },
    "妃": {
        onyomi: ["ヒ"],
        kunyomi: ["きさき"],
        examples: [
        { word: "王妃", reading: "おうひ", meaning: "queen (consort), empress (consort)" },
        { word: "妃殿下", reading: "ひでんか", meaning: "princess, Her Royal Highness" },
        { word: "皇太子妃", reading: "こうたいしひ", meaning: "crown princess" },
        { word: "妃", reading: "ひ", meaning: "princess, consort" }
    ],
    },
    "否": {
        onyomi: ["ヒ"],
        kunyomi: ["いな", "いや"],
        examples: [
        { word: "否々", reading: "いやいや", meaning: "no!, no no!, no, not at all" },
        { word: "安否", reading: "あんぴ", meaning: "safety, welfare, well-being" },
        { word: "可否", reading: "かひ", meaning: "propriety, right and wrong, advisability" },
        { word: "拒否", reading: "きょひ", meaning: "refusal, rejection, denial" }
    ],
    },
    "批": {
        onyomi: ["ヒ"],
        kunyomi: [],
        examples: [
        { word: "批准", reading: "ひじゅん", meaning: "ratification" },
        { word: "批判", reading: "ひはん", meaning: "criticism, judgement, judgment" },
        { word: "批評", reading: "ひひょう", meaning: "criticism, critique, review" },
        { word: "批判的", reading: "ひはんてき", meaning: "critical, judgmental, censorious" }
    ],
    },
    "彼": {
        onyomi: ["ヒ"],
        kunyomi: ["かれ", "かの", "か.の"],
        examples: [
        { word: "彼ら", reading: "かれら", meaning: "they, them" },
        { word: "彼岸", reading: "ひがん", meaning: "equinoctial week (when Buddhist services are held)" },
        { word: "彼氏", reading: "かれし", meaning: "boyfriend" },
        { word: "彼女", reading: "かのじょ", meaning: "she, her" }
    ],
    },
    "披": {
        onyomi: ["ヒ"],
        kunyomi: [],
        examples: [
        { word: "披瀝", reading: "ひれき", meaning: "expressing one's opinion, speaking one's mind, making known" },
        { word: "披露", reading: "ひろう", meaning: "announcement, presentation, demonstration" },
        { word: "披露宴", reading: "ひろうえん", meaning: "reception (e.g. wedding), banquet, celebration" }
    ],
    },
    "肥": {
        onyomi: ["ヒ"],
        kunyomi: ["こ.える", "こえ", "こ.やす", "こ.やし", "ふと.る"],
        examples: [
        { word: "堆肥", reading: "たいひ", meaning: "compost, manure" },
        { word: "肥大", reading: "ひだい", meaning: "swelling, enlargement, becoming fat" },
        { word: "肥満", reading: "ひまん", meaning: "corpulence, fatness, obesity" },
        { word: "肥料", reading: "ひりょう", meaning: "manure, fertilizer, fertiliser" }
    ],
    },
    "非": {
        onyomi: ["ヒ"],
        kunyomi: ["あら.ず"],
        examples: [
        { word: "是非", reading: "ぜひ", meaning: "certainly, without fail" },
        { word: "非難", reading: "ひなん", meaning: "criticism, blame, censure" },
        { word: "非行", reading: "ひこう", meaning: "delinquency, misconduct" },
        { word: "非常", reading: "ひじょう", meaning: "emergency" }
    ],
    },
    "卑": {
        onyomi: ["ヒ"],
        kunyomi: ["いや.しい", "いや.しむ", "いや.しめる"],
        examples: [
        { word: "卑怯", reading: "ひきょう", meaning: "cowardly, craven" },
        { word: "卑屈", reading: "ひくつ", meaning: "servile, subservient, obsequious" },
        { word: "卑劣", reading: "ひれつ", meaning: "mean, contemptible, despicable" },
        { word: "卑しい", reading: "いやしい", meaning: "lowborn, humble, lowly" }
    ],
    },
    "飛": {
        onyomi: ["ヒ"],
        kunyomi: ["と.ぶ", "と.ばす", "-と.ばす"],
        examples: [
        { word: "飛ぶ", reading: "とぶ", meaning: "to fly, to soar" },
        { word: "飛行", reading: "ひこう", meaning: "flight, flying, aviation" },
        { word: "飛躍", reading: "ひやく", meaning: "leap, jump" },
        { word: "犠飛", reading: "ぎひ", meaning: "sacrifice fly" }
    ],
    },
    "疲": {
        onyomi: ["ヒ"],
        kunyomi: ["つか.れる", "-づか.れ", "つか.らす"],
        examples: [
        { word: "疲れ", reading: "つかれ", meaning: "tiredness, fatigue" },
        { word: "疲弊", reading: "ひへい", meaning: "exhaustion, fatigue" },
        { word: "疲労", reading: "ひろう", meaning: "fatigue, weariness, exhaustion" },
        { word: "疲れる", reading: "つかれる", meaning: "to get tired, to tire, to get fatigued" }
    ],
    },
    "秘": {
        onyomi: ["ヒ"],
        kunyomi: ["ひ.める", "ひそ.か", "かく.す"],
        examples: [
        { word: "極秘", reading: "ごくひ", meaning: "absolute secrecy" },
        { word: "神秘", reading: "しんぴ", meaning: "mystery, mysteriousness, secret" },
        { word: "秘訣", reading: "ひけつ", meaning: "secret (method, trick, etc.), key (e.g. to success), mysteries (of an art, trade, etc.)" },
        { word: "秘書", reading: "ひしょ", meaning: "(private) secretary" }
    ],
    },
    "被": {
        onyomi: ["ヒ"],
        kunyomi: ["こうむ.る", "おお.う", "かぶ.る", "かぶ.せる"],
        examples: [
        { word: "被る", reading: "かぶる", meaning: "to put on (one's head), to wear, to have on" },
        { word: "被害", reading: "ひがい", meaning: "(suffering) damage, injury, harm" },
        { word: "被告", reading: "ひこく", meaning: "defendant, the accused" },
        { word: "被災", reading: "ひさい", meaning: "suffering (from a disaster), being hit (by an earthquake, typhoon, etc.), falling victim (to)" }
    ],
    },
    "悲": {
        onyomi: ["ヒ"],
        kunyomi: ["かな.しい", "かな.しむ"],
        examples: [
        { word: "慈悲", reading: "じひ", meaning: "mercy, compassion, clemency" },
        { word: "悲哀", reading: "ひあい", meaning: "sorrow, grief, sadness" },
        { word: "悲観", reading: "ひかん", meaning: "pessimism, (taking a) gloomy view, discouragement" },
        { word: "悲願", reading: "ひがん", meaning: "one's dearest wish" }
    ],
    },
    "扉": {
        onyomi: ["ヒ"],
        kunyomi: ["とびら"],
        examples: [
        { word: "門扉", reading: "もんぴ", meaning: "door(s) of a gate" },
        { word: "扉", reading: "とびら", meaning: "door, gate, opening" }
    ],
    },
    "費": {
        onyomi: ["ヒ"],
        kunyomi: ["つい.やす", "つい.える"],
        examples: [
        { word: "会費", reading: "かいひ", meaning: "membership fee" },
        { word: "学費", reading: "がくひ", meaning: "tuition, school expenses" },
        { word: "経費", reading: "けいひ", meaning: "expenses, expenditure, outgoings" },
        { word: "公費", reading: "こうひ", meaning: "public expense, public funds, public money" }
    ],
    },
    "碑": {
        onyomi: ["ヒ"],
        kunyomi: ["いしぶみ"],
        examples: [
        { word: "石碑", reading: "せきひ", meaning: "stone monument" },
        { word: "碑文", reading: "ひぶん", meaning: "inscription, epitaph, epigraph" },
        { word: "記念碑", reading: "きねんひ", meaning: "commemorative plaque (usu. on a stone), stone monument (bearing an inscription)" },
        { word: "碑", reading: "いしぶみ", meaning: "stone monument bearing an inscription (esp. memorial for future generations), stele, stela" }
    ],
    },
    "罷": {
        onyomi: ["ヒ"],
        kunyomi: ["まか.り-", "や.める"],
        examples: [
        { word: "罷免", reading: "ひめん", meaning: "dismissal (from a position), discharge" }
    ],
    },
    "避": {
        onyomi: ["ヒ"],
        kunyomi: ["さ.ける", "よ.ける"],
        examples: [
        { word: "回避", reading: "かいひ", meaning: "evasion, avoidance" },
        { word: "忌避", reading: "きひ", meaning: "evasion, avoidance, shirking" },
        { word: "退避", reading: "たいひ", meaning: "taking refuge, evacuation" },
        { word: "逃避", reading: "とうひ", meaning: "escape, evasion, flight" }
    ],
    },
    "尾": {
        onyomi: ["ビ"],
        kunyomi: ["お"],
        examples: [
        { word: "首尾", reading: "しゅび", meaning: "beginning and end, from beginning to end" },
        { word: "尻尾", reading: "しっぽ", meaning: "tail (of an animal)" },
        { word: "尾行", reading: "びこう", meaning: "shadow, tail, following" },
        { word: "尾根", reading: "おね", meaning: "(mountain) ridge" }
    ],
    },
    "眉": {
        onyomi: ["ビ", "ミ"],
        kunyomi: ["まゆ"],
        examples: [
        { word: "眉毛", reading: "まゆげ", meaning: "eyebrow" },
        { word: "眉", reading: "まゆ", meaning: "eyebrow, eyebrows" }
    ],
    },
    "美": {
        onyomi: ["ビ", "ミ"],
        kunyomi: ["うつく.しい"],
        examples: [
        { word: "華美", reading: "かび", meaning: "splendor, splendour, gorgeousness" },
        { word: "甘美", reading: "かんび", meaning: "sweet (taste), luscious" },
        { word: "賛美", reading: "さんび", meaning: "praise, glorification, extolment" },
        { word: "美化", reading: "びか", meaning: "beautification, cleaning up, tidiying" }
    ],
    },
    "備": {
        onyomi: ["ビ"],
        kunyomi: ["そな.える", "そな.わる", "つぶさ.に"],
        examples: [
        { word: "軍備", reading: "ぐんび", meaning: "armaments, military preparations" },
        { word: "警備", reading: "けいび", meaning: "defense, defence, guard" },
        { word: "守備", reading: "しゅび", meaning: "defense, defence" },
        { word: "準備", reading: "じゅんび", meaning: "preparation, arrangements, getting ready" }
    ],
    },
    "微": {
        onyomi: ["ビ"],
        kunyomi: ["かす.か"],
        examples: [
        { word: "微細", reading: "びさい", meaning: "minute, fine, detailed" },
        { word: "微小", reading: "びしょう", meaning: "microscopic" },
        { word: "微笑", reading: "びしょう", meaning: "smile" },
        { word: "微震", reading: "びしん", meaning: "slight earthquake" }
    ],
    },
    "鼻": {
        onyomi: ["ビ"],
        kunyomi: ["はな"],
        examples: [
        { word: "鼻水", reading: "はなみず", meaning: "nasal mucus, dripping nose, snot" },
        { word: "鼻先", reading: "はなさき", meaning: "tip of nose" },
        { word: "鼻血", reading: "はなぢ", meaning: "nosebleed" },
        { word: "鼻紙", reading: "はながみ", meaning: "tissue paper, facial tissue, paper handkerchief" }
    ],
    },
    "膝": {
        onyomi: ["シツ"],
        kunyomi: ["ひざ"],
        examples: [
        { word: "膝", reading: "ひざ", meaning: "knee" }
    ],
    },
    "肘": {
        onyomi: ["チュウ"],
        kunyomi: ["ひじ"],
        examples: [
        { word: "肘", reading: "ひじ", meaning: "elbow" }
    ],
    },
    "匹": {
        onyomi: ["ヒツ"],
        kunyomi: ["ひき"],
        examples: [
        { word: "一匹", reading: "いっぴき", meaning: "one (small animal)" },
        { word: "匹敵", reading: "ひってき", meaning: "to be a match for, to rival, to equal" },
        { word: "匹", reading: "ひき", meaning: "counter for small animals" }
    ],
    },
    "必": {
        onyomi: ["ヒツ"],
        kunyomi: ["かなら.ず"],
        examples: [
        { word: "必ず", reading: "かならず", meaning: "always, without exception, necessarily" },
        { word: "必携", reading: "ひっけい", meaning: "indispensable, essential, must-have" },
        { word: "必見", reading: "ひっけん", meaning: "must-see, not-to-be-missed" },
        { word: "必需", reading: "ひつじゅ", meaning: "necessary" }
    ],
    },
    "泌": {
        onyomi: ["ヒツ", "ヒ"],
        kunyomi: [],
        examples: [
        { word: "分泌", reading: "ぶんぴつ", meaning: "secretion" },
        { word: "内分泌", reading: "ないぶんぴつ", meaning: "endocrine" },
        { word: "泌尿器", reading: "ひにょうき", meaning: "urinary organs" }
    ],
    },
    "筆": {
        onyomi: ["ヒツ"],
        kunyomi: ["ふで"],
        examples: [
        { word: "鉛筆", reading: "えんぴつ", meaning: "(wooden) pencil" },
        { word: "自筆", reading: "じひつ", meaning: "one's own handwriting, autograph, holograph" },
        { word: "執筆", reading: "しっぴつ", meaning: "writing, authoring" },
        { word: "主筆", reading: "しゅひつ", meaning: "editor-in-chief" }
    ],
    },
    "姫": {
        onyomi: ["キ"],
        kunyomi: ["ひめ", "ひめ-"],
        examples: [
        { word: "歌姫", reading: "うたひめ", meaning: "songstress, diva" },
        { word: "姫君", reading: "ひめぎみ", meaning: "daughter of a person of high rank (esp. eldest daughter)" },
        { word: "舞姫", reading: "まいひめ", meaning: "female dancer, dancing girl, danseuse" },
        { word: "姫", reading: "ひめ", meaning: "young lady of noble birth, princess (esp. in Western contexts, tales, etc.)" }
    ],
    },
    "百": {
        onyomi: ["ヒャク", "ビャク"],
        kunyomi: ["もも"],
        examples: [
        { word: "何百", reading: "なんびゃく", meaning: "hundreds" },
        { word: "三百", reading: "さんびゃく", meaning: "300, three hundred" },
        { word: "数百", reading: "すうひゃく", meaning: "several hundred, hundreds (of)" },
        { word: "百億", reading: "ひゃくおく", meaning: "10,000,000,000, ten billion" }
    ],
    },
    "氷": {
        onyomi: ["ヒョウ"],
        kunyomi: ["こおり", "ひ", "こお.る"],
        examples: [
        { word: "氷河", reading: "ひょうが", meaning: "glacier" },
        { word: "氷山", reading: "ひょうざん", meaning: "iceberg" },
        { word: "流氷", reading: "りゅうひょう", meaning: "drift ice, ice floe" },
        { word: "かき氷", reading: "かきごおり", meaning: "shaved ice (usually served with flavored simple syrup), Italian ice, snow cone" }
    ],
    },
    "表": {
        onyomi: ["ヒョウ"],
        kunyomi: ["おもて", "-おもて", "あらわ.す", "あらわ.れる", "あら.わす"],
        examples: [
        { word: "意表", reading: "いひょう", meaning: "surprise, something unexpected" },
        { word: "表す", reading: "あらわす", meaning: "to represent, to signify, to stand for" },
        { word: "公表", reading: "こうひょう", meaning: "official announcement, proclamation" },
        { word: "辞表", reading: "じひょう", meaning: "letter of resignation" }
    ],
    },
    "俵": {
        onyomi: ["ヒョウ"],
        kunyomi: ["たわら"],
        examples: [
        { word: "土俵", reading: "どひょう", meaning: "(wrestling) ring" },
        { word: "土俵際", reading: "どひょうぎわ", meaning: "edge of the ring" },
        { word: "俵", reading: "たわら", meaning: "straw bag, sack, bale" }
    ],
    },
    "票": {
        onyomi: ["ヒョウ"],
        kunyomi: [],
        examples: [
        { word: "一票", reading: "いっぴょう", meaning: "one vote, one ballot" },
        { word: "開票", reading: "かいひょう", meaning: "counting ballots, tally (of votes)" },
        { word: "伝票", reading: "でんぴょう", meaning: "chit, slip, ticket" },
        { word: "投票", reading: "とうひょう", meaning: "voting, ballot, poll" }
    ],
    },
    "評": {
        onyomi: ["ヒョウ"],
        kunyomi: [],
        examples: [
        { word: "好評", reading: "こうひょう", meaning: "favorable reception, good reputation, popularity" },
        { word: "酷評", reading: "こくひょう", meaning: "severe criticism, sharp criticism, scathing criticism" },
        { word: "書評", reading: "しょひょう", meaning: "book review" },
        { word: "総評", reading: "そうひょう", meaning: "general comment" }
    ],
    },
    "漂": {
        onyomi: ["ヒョウ"],
        kunyomi: ["ただよ.う"],
        examples: [
        { word: "漂う", reading: "ただよう", meaning: "to drift, to float" },
        { word: "漂着", reading: "ひょうちゃく", meaning: "drifting ashore" },
        { word: "漂白", reading: "ひょうはく", meaning: "blanching, bleaching" },
        { word: "漂流", reading: "ひょうりゅう", meaning: "drifting, drift, being adrift" }
    ],
    },
    "標": {
        onyomi: ["ヒョウ"],
        kunyomi: ["しるべ", "しるし"],
        examples: [
        { word: "指標", reading: "しひょう", meaning: "index, indices, indicator" },
        { word: "商標", reading: "しょうひょう", meaning: "trademark" },
        { word: "標語", reading: "ひょうご", meaning: "motto, slogan, catchword" },
        { word: "標高", reading: "ひょうこう", meaning: "elevation, height above sea level" }
    ],
    },
    "苗": {
        onyomi: ["ビョウ", "ミョウ"],
        kunyomi: ["なえ", "なわ-"],
        examples: [
        { word: "苗床", reading: "なえどこ", meaning: "seedbed, nursery, seed-plot" },
        { word: "苗木", reading: "なえぎ", meaning: "seedling, sapling, young tree" },
        { word: "苗字", reading: "みょうじ", meaning: "surname, family name, last name" },
        { word: "苗", reading: "なえ", meaning: "seedling, young plant" }
    ],
    },
    "秒": {
        onyomi: ["ビョウ"],
        kunyomi: [],
        examples: [
        { word: "秒速", reading: "びょうそく", meaning: "speed per second, velocity per second" },
        { word: "秒読み", reading: "びょうよみ", meaning: "countdown" },
        { word: "秒", reading: "びょう", meaning: "second (unit of time)" }
    ],
    },
    "病": {
        onyomi: ["ビョウ", "ヘイ"],
        kunyomi: ["や.む", "-や.み", "やまい"],
        examples: [
        { word: "臆病", reading: "おくびょう", meaning: "cowardly, timid, easily frightened" },
        { word: "看病", reading: "かんびょう", meaning: "nursing (a patient)" },
        { word: "奇病", reading: "きびょう", meaning: "strange disease, rare disease" },
        { word: "急病", reading: "きゅうびょう", meaning: "sudden illness" }
    ],
    },
    "描": {
        onyomi: ["ビョウ"],
        kunyomi: ["えが.く", "か.く"],
        examples: [
        { word: "素描", reading: "そびょう", meaning: "drawing, sketch" },
        { word: "描写", reading: "びょうしゃ", meaning: "depiction, description, portrayal" },
        { word: "描く", reading: "えがく", meaning: "to draw, to paint, to sketch" },
        { word: "手描き", reading: "てがき", meaning: "hand-drawn, drawn by hand, hand-painted" }
    ],
    },
    "猫": {
        onyomi: ["ビョウ"],
        kunyomi: ["ねこ"],
        examples: [
        { word: "山猫", reading: "やまねこ", meaning: "wildcat (European wildcat, Iriomote cat, Tsushima cat, etc.)" },
        { word: "猫舌", reading: "ねこじた", meaning: "dislike of very hot food or drink, inability to take hot food, cat tongue" },
        { word: "猫背", reading: "ねこぜ", meaning: "bent back, hunchback, stoop" },
        { word: "子猫", reading: "こねこ", meaning: "kitten" }
    ],
    },
    "品": {
        onyomi: ["ヒン", "ホン"],
        kunyomi: ["しな"],
        examples: [
        { word: "遺品", reading: "いひん", meaning: "things left (to one) by the deceased, inherited item, estate" },
        { word: "一品", reading: "いっぴん", meaning: "item, article" },
        { word: "逸品", reading: "いっぴん", meaning: "excellent article, fine item, rare beauty" },
        { word: "下品", reading: "げひん", meaning: "vulgar, indecent, coarse" }
    ],
    },
    "浜": {
        onyomi: ["ヒン"],
        kunyomi: ["はま"],
        examples: [
        { word: "海浜", reading: "かいひん", meaning: "seashore, seaside, beach" },
        { word: "砂浜", reading: "すなはま", meaning: "sandy beach" },
        { word: "浜辺", reading: "はまべ", meaning: "beach, foreshore" },
        { word: "横浜", reading: "よこはま", meaning: "Yokohama (city)" }
    ],
    },
    "貧": {
        onyomi: ["ヒン", "ビン"],
        kunyomi: ["まず.しい"],
        examples: [
        { word: "清貧", reading: "せいひん", meaning: "poverty without selfish desire, honourable poverty (honorable), being poor yet honest" },
        { word: "貧血", reading: "ひんけつ", meaning: "anemia, anaemia" },
        { word: "貧困", reading: "ひんこん", meaning: "poverty, penury, need" },
        { word: "貧弱", reading: "ひんじゃく", meaning: "poor, meagre, meager" }
    ],
    },
    "賓": {
        onyomi: ["ヒン"],
        kunyomi: ["まろうど", "したがう"],
        examples: [
        { word: "貴賓", reading: "きひん", meaning: "noble visitor" },
        { word: "国賓", reading: "こくひん", meaning: "state guest" },
        { word: "来賓", reading: "らいひん", meaning: "guest, visitor, visitor's arrival" },
        { word: "賓客", reading: "ひんきゃく", meaning: "guest of honour, guest of honor, privileged guest" }
    ],
    },
    "頻": {
        onyomi: ["ヒン"],
        kunyomi: ["しき.りに"],
        examples: [
        { word: "頻度", reading: "ひんど", meaning: "frequency (of occurrence)" },
        { word: "頻発", reading: "ひんぱつ", meaning: "frequent occurrence" },
        { word: "頻繁", reading: "ひんぱん", meaning: "frequent, incessant" },
        { word: "頻りに", reading: "しきりに", meaning: "frequently, repeatedly, often" }
    ],
    },
    "敏": {
        onyomi: ["ビン"],
        kunyomi: ["さとい"],
        examples: [
        { word: "鋭敏", reading: "えいびん", meaning: "sharp (eyes, ears, etc.), keen, acute" },
        { word: "過敏", reading: "かびん", meaning: "nervousness, oversensitivity" },
        { word: "機敏", reading: "きびん", meaning: "quick, prompt, alert" },
        { word: "敏感", reading: "びんかん", meaning: "sensitive, alert, aware" }
    ],
    },
    "瓶": {
        onyomi: ["ビン", "ヘイ"],
        kunyomi: ["かめ"],
        examples: [
        { word: "花瓶", reading: "かびん", meaning: "(flower) vase" },
        { word: "瓶詰", reading: "びんづめ", meaning: "bottling" },
        { word: "火炎瓶", reading: "かえんびん", meaning: "Molotov cocktail, petrol bomb, gasoline bomb" },
        { word: "瓶詰め", reading: "びんづめ", meaning: "bottling" }
    ],
    },
    "不": {
        onyomi: ["フ", "ブ"],
        kunyomi: [],
        examples: [
        { word: "不安", reading: "ふあん", meaning: "anxiety, uneasiness, worry" },
        { word: "不意", reading: "ふい", meaning: "sudden, abrupt, unexpected" },
        { word: "不運", reading: "ふうん", meaning: "misfortune, bad luck, ill luck" },
        { word: "不穏", reading: "ふおん", meaning: "disquieting, threatening, turbulent" }
    ],
    },
    "夫": {
        onyomi: ["フ", "フウ", "ブ"],
        kunyomi: ["おっと", "それ"],
        examples: [
        { word: "工夫", reading: "くふう", meaning: "devising (a way), contriving, inventing" },
        { word: "夫妻", reading: "ふさい", meaning: "husband and wife, married couple" },
        { word: "夫人", reading: "ふじん", meaning: "wife, Mrs, Madam" },
        { word: "丈夫", reading: "じょうぶ", meaning: "healthy, robust, strong" }
    ],
    },
    "父": {
        onyomi: ["フ"],
        kunyomi: ["ちち"],
        examples: [
        { word: "義父", reading: "ぎふ", meaning: "father-in-law" },
        { word: "神父", reading: "しんぷ", meaning: "Catholic priest, abbe, reverend father" },
        { word: "親父", reading: "おやじ", meaning: "one's father, one's old man, dad" },
        { word: "祖父", reading: "そふ", meaning: "grandfather" }
    ],
    },
    "付": {
        onyomi: ["フ"],
        kunyomi: ["つ.ける", "-つ.ける", "-づ.ける", "つ.け", "つ.け-", "-つ.け", "-づ.け", "-づけ", "つ.く", "-づ.く", "つ.き", "-つ.き", "-つき", "-づ.き", "-づき"],
        examples: [
        { word: "外付", reading: "そとづけ", meaning: "external (hard drive, disk drive, etc.)" },
        { word: "給付", reading: "きゅうふ", meaning: "provision (of money or goods), furnishing, conferral" },
        { word: "交付", reading: "こうふ", meaning: "delivery, issuance, handing over" },
        { word: "送付", reading: "そうふ", meaning: "sending, forwarding, remitting" }
    ],
    },
    "布": {
        onyomi: ["フ", "ホ"],
        kunyomi: ["ぬの", "し.く", "きれ"],
        examples: [
        { word: "絹布", reading: "けんぷ", meaning: "silk, silk cloth" },
        { word: "公布", reading: "こうふ", meaning: "official proclamation, announcement, promulgation (e.g. of regulations)" },
        { word: "財布", reading: "さいふ", meaning: "wallet, purse, coin purse" },
        { word: "散布", reading: "さんぷ", meaning: "dissemination, scattering, sprinkling" }
    ],
    },
    "扶": {
        onyomi: ["フ"],
        kunyomi: ["たす.ける"],
        examples: [
        { word: "扶助", reading: "ふじょ", meaning: "aid, help, assistance" },
        { word: "扶養", reading: "ふよう", meaning: "support (e.g. of one's dependents), maintenance" }
    ],
    },
    "府": {
        onyomi: ["フ"],
        kunyomi: [],
        examples: [
        { word: "政府", reading: "せいふ", meaning: "government, administration, ministry" },
        { word: "府県", reading: "ふけん", meaning: "prefectures (of Japan, excl. Tokyo and Hokkaido)" },
        { word: "府庁", reading: "ふちょう", meaning: "prefectural office (of Osaka or Kyoto)" },
        { word: "幕府", reading: "ばくふ", meaning: "shogunate, bakufu" }
    ],
    },
    "怖": {
        onyomi: ["フ", "ホ"],
        kunyomi: ["こわ.い", "こわ.がる", "お.じる", "おそ.れる"],
        examples: [
        { word: "恐怖", reading: "きょうふ", meaning: "fear, dread, dismay" },
        { word: "怖い", reading: "こわい", meaning: "scary, frightening, eerie" },
        { word: "恐怖症", reading: "きょうふしょう", meaning: "phobia, morbid fear" },
        { word: "怖がる", reading: "こわがる", meaning: "to be afraid (of), to fear, to be frightened (of)" }
    ],
    },
    "阜": {
        onyomi: ["フ", "フウ"],
        kunyomi: [],
        examples: [
        { word: "岐阜", reading: "ぎふ", meaning: "Gifu (city, prefecture)" }
    ],
    },
    "附": {
        onyomi: ["フ"],
        kunyomi: ["つ.ける", "つ.く"],
        examples: [
        { word: "附属", reading: "ふぞく", meaning: "being attached (to), being affiliated (to), belonging (to)" }
    ],
    },
    "訃": {
        onyomi: ["フ"],
        kunyomi: ["しらせ"],
        examples: [
        { word: "訃音", reading: "ふおん", meaning: "report of a death" },
        { word: "訃報", reading: "ふほう", meaning: "news of someone's death, obituary" },
        { word: "訃", reading: "ふ", meaning: "news of someone's death" }
    ],
    },
    "負": {
        onyomi: ["フ"],
        kunyomi: ["ま.ける", "ま.かす", "お.う"],
        examples: [
        { word: "自負", reading: "じふ", meaning: "pride, self-confidence, thinking highly of oneself" },
        { word: "勝負", reading: "しょうぶ", meaning: "victory or defeat" },
        { word: "負う", reading: "おう", meaning: "to carry on one's back, to bear, to shoulder" },
        { word: "負け", reading: "まけ", meaning: "defeat, loss, losing (a game)" }
    ],
    },
    "赴": {
        onyomi: ["フ"],
        kunyomi: ["おもむ.く"],
        examples: [
        { word: "赴く", reading: "おもむく", meaning: "to go in the direction of, to proceed toward, to proceed according to" },
        { word: "赴任", reading: "ふにん", meaning: "moving to a different location to start a new job, (proceeding to) new appointment" },
        { word: "単身赴任", reading: "たんしんふにん", meaning: "taking up a post away from one's family, job transfer without one's family, living apart from one's family for the sake of one's job" }
    ],
    },
    "浮": {
        onyomi: ["フ"],
        kunyomi: ["う.く", "う.かれる", "う.かぶ", "う.かべる"],
        examples: [
        { word: "浮き", reading: "うき", meaning: "floating, buoyancy" },
        { word: "浮く", reading: "うく", meaning: "to float" },
        { word: "浮気", reading: "うわき", meaning: "extramarital sex, affair, fooling around" },
        { word: "浮上", reading: "ふじょう", meaning: "surfacing, rising to the surface" }
    ],
    },
    "婦": {
        onyomi: ["フ"],
        kunyomi: ["よめ"],
        examples: [
        { word: "主婦", reading: "しゅふ", meaning: "housewife, mistress (of the house), homemaker" },
        { word: "新婦", reading: "しんぷ", meaning: "bride" },
        { word: "妊婦", reading: "にんぷ", meaning: "pregnant woman" },
        { word: "婦女", reading: "ふじょ", meaning: "woman, womankind" }
    ],
    },
    "符": {
        onyomi: ["フ"],
        kunyomi: [],
        examples: [
        { word: "音符", reading: "おんぷ", meaning: "musical note, note symbol" },
        { word: "切符", reading: "きっぷ", meaning: "ticket" },
        { word: "符号", reading: "ふごう", meaning: "sign, mark, symbol" },
        { word: "符合", reading: "ふごう", meaning: "agreement, coincidence, correspondence" }
    ],
    },
    "富": {
        onyomi: ["フ", "フウ"],
        kunyomi: ["と.む", "とみ"],
        examples: [
        { word: "国富", reading: "こくふ", meaning: "national wealth" },
        { word: "貧富", reading: "ひんぷ", meaning: "wealth and poverty, rich and poor" },
        { word: "富む", reading: "とむ", meaning: "to be rich (in), to abound (in), to be abundant (in)" },
        { word: "富貴", reading: "ふうき", meaning: "riches and honours (honors), wealth and rank" }
    ],
    },
    "普": {
        onyomi: ["フ"],
        kunyomi: ["あまね.く", "あまねし"],
        examples: [
        { word: "普及", reading: "ふきゅう", meaning: "diffusion, spread, popularization" },
        { word: "普賢", reading: "ふげん", meaning: "Samantabhadra (bodhisattva), Universal Compassion" },
        { word: "普段", reading: "ふだん", meaning: "usual, normal, everyday" },
        { word: "普通", reading: "ふつう", meaning: "normal, ordinary, regular" }
    ],
    },
    "腐": {
        onyomi: ["フ"],
        kunyomi: ["くさ.る", "-くさ.る", "くさ.れる", "くさ.れ", "くさ.らす", "くさ.す"],
        examples: [
        { word: "陳腐", reading: "ちんぷ", meaning: "stale, hackneyed, clichéd" },
        { word: "豆腐", reading: "とうふ", meaning: "tofu, bean curd, beancurd" },
        { word: "腐る", reading: "くさる", meaning: "to rot, to go bad, to decay" },
        { word: "腐食", reading: "ふしょく", meaning: "rot, decay, erosion" }
    ],
    },
    "敷": {
        onyomi: ["フ"],
        kunyomi: ["し.く", "-し.き"],
        examples: [
        { word: "下敷", reading: "したじき", meaning: "desk pad, sheet of plastic (or cardboard, felt, etc.) placed under writing paper, underlay" },
        { word: "座敷", reading: "ざしき", meaning: "tatami room, tatami mat room, formal Japanese room" },
        { word: "倉敷", reading: "くらしき", meaning: "Kurashiki (city)" },
        { word: "敷く", reading: "しく", meaning: "to spread out (e.g. a futon), to lay out" }
    ],
    },
    "膚": {
        onyomi: ["フ"],
        kunyomi: ["はだ"],
        examples: [
        { word: "皮膚", reading: "ひふ", meaning: "skin" },
        { word: "皮膚科", reading: "ひふか", meaning: "dermatology" },
        { word: "皮膚病", reading: "ひふびょう", meaning: "skin disease" }
    ],
    },
    "賦": {
        onyomi: ["フ", "ブ"],
        kunyomi: [],
        examples: [
        { word: "月賦", reading: "げっぷ", meaning: "monthly installment (instalment), monthly payment" },
        { word: "賦課", reading: "ふか", meaning: "levy, imposition" }
    ],
    },
    "譜": {
        onyomi: ["フ"],
        kunyomi: [],
        examples: [
        { word: "楽譜", reading: "がくふ", meaning: "score, sheet music" },
        { word: "棋譜", reading: "きふ", meaning: "record of a game of go, shogi, chess, etc." },
        { word: "系譜", reading: "けいふ", meaning: "genealogy, lineage, family tree" },
        { word: "年譜", reading: "ねんぷ", meaning: "chronological record" }
    ],
    },
    "侮": {
        onyomi: ["ブ"],
        kunyomi: ["あなど.る", "あなず.る"],
        examples: [
        { word: "侮辱", reading: "ぶじょく", meaning: "insult, affront, slight" },
        { word: "侮蔑", reading: "ぶべつ", meaning: "scorn, disdain, contempt" },
        { word: "侮る", reading: "あなどる", meaning: "to disdain, to look down on, to make light of" }
    ],
    },
    "武": {
        onyomi: ["ブ", "ム"],
        kunyomi: ["たけ", "たけ.し"],
        examples: [
        { word: "武器", reading: "ぶき", meaning: "weapon, arms, ordnance" },
        { word: "武者", reading: "むしゃ", meaning: "warrior" },
        { word: "武将", reading: "ぶしょう", meaning: "military commander" },
        { word: "武装", reading: "ぶそう", meaning: "arms, armament, taking up arms" }
    ],
    },
    "部": {
        onyomi: ["ブ"],
        kunyomi: ["-べ"],
        examples: [
        { word: "一部", reading: "いちぶ", meaning: "one part, one portion, one section" },
        { word: "下部", reading: "かぶ", meaning: "lower part, substructure" },
        { word: "外部", reading: "がいぶ", meaning: "outside (e.g. of a building), exterior" },
        { word: "学部", reading: "がくぶ", meaning: "faculty (of a university), school, college" }
    ],
    },
    "舞": {
        onyomi: ["ブ"],
        kunyomi: ["ま.う", "-ま.う", "まい"],
        examples: [
        { word: "鼓舞", reading: "こぶ", meaning: "encouragement, inspiration, rousing" },
        { word: "舞う", reading: "まう", meaning: "to dance (orig. a whirling dance)" },
        { word: "舞楽", reading: "ぶがく", meaning: "bugaku, court dance and music" },
        { word: "舞台", reading: "ぶたい", meaning: "stage (of a theatre, concert hall, etc.)" }
    ],
    },
    "封": {
        onyomi: ["フウ", "ホウ"],
        kunyomi: [],
        examples: [
        { word: "開封", reading: "かいふう", meaning: "opening (a letter, parcel, etc.), breaking the seal" },
        { word: "完封", reading: "かんぷう", meaning: "total blockage, complete shutdown, stopping completely" },
        { word: "同封", reading: "どうふう", meaning: "enclosing (e.g. with a letter)" },
        { word: "封鎖", reading: "ふうさ", meaning: "blockade, lockdown, sealing off (an area)" }
    ],
    },
    "風": {
        onyomi: ["フウ", "フ"],
        kunyomi: ["かぜ", "かざ-"],
        examples: [
        { word: "一風", reading: "いっぷう", meaning: "oddity, eccentricity, peculiarity" },
        { word: "逆風", reading: "ぎゃくふう", meaning: "headwind, adverse wind" },
        { word: "強風", reading: "きょうふう", meaning: "strong wind, high wind, moderate gale" },
        { word: "古風", reading: "こふう", meaning: "old-fashioned, archaic, antique" }
    ],
    },
    "伏": {
        onyomi: ["フク"],
        kunyomi: ["ふ.せる", "ふ.す"],
        examples: [
        { word: "起伏", reading: "きふく", meaning: "undulation" },
        { word: "降伏", reading: "こうふく", meaning: "surrender, capitulation, submission" },
        { word: "潜伏", reading: "せんぷく", meaning: "concealment, hiding, ambush" },
        { word: "伏線", reading: "ふくせん", meaning: "foreshadowing" }
    ],
    },
    "服": {
        onyomi: ["フク"],
        kunyomi: [],
        examples: [
        { word: "衣服", reading: "いふく", meaning: "clothes" },
        { word: "軍服", reading: "ぐんぷく", meaning: "military uniform" },
        { word: "呉服", reading: "ごふく", meaning: "cloth (for Japanese clothes), kimono fabrics, textile" },
        { word: "克服", reading: "こくふく", meaning: "conquest (of a difficulty, illness, crisis, etc.), overcoming, surmounting" }
    ],
    },
    "副": {
        onyomi: ["フク"],
        kunyomi: [],
        examples: [
        { word: "副業", reading: "ふくぎょう", meaning: "side job, sideline, subsidiary business" },
        { word: "副詞", reading: "ふくし", meaning: "adverb" },
        { word: "副賞", reading: "ふくしょう", meaning: "supplementary prize, additional prize, auxiliary prize" },
        { word: "副題", reading: "ふくだい", meaning: "subtitle, subheading" }
    ],
    },
    "幅": {
        onyomi: ["フク"],
        kunyomi: ["はば"],
        examples: [
        { word: "横幅", reading: "よこはば", meaning: "breadth, width" },
        { word: "振幅", reading: "しんぷく", meaning: "amplitude (of vibration)" },
        { word: "大幅", reading: "おおはば", meaning: "big, large, drastic" },
        { word: "幅広", reading: "はばびろ", meaning: "wide (esp. of clothing), broad" }
    ],
    },
    "復": {
        onyomi: ["フク"],
        kunyomi: ["また"],
        examples: [
        { word: "往復", reading: "おうふく", meaning: "making a round trip, going and returning, coming and going" },
        { word: "回復", reading: "かいふく", meaning: "restoration, recovery, rehabilitation" },
        { word: "修復", reading: "しゅうふく", meaning: "restoration, repair, mending" },
        { word: "復活", reading: "ふっかつ", meaning: "revival (of an old system, custom, fashion, etc.), restoration, return" }
    ],
    },
    "福": {
        onyomi: ["フク"],
        kunyomi: [],
        examples: [
        { word: "幸福", reading: "こうふく", meaning: "happiness, well-being, joy" },
        { word: "至福", reading: "しふく", meaning: "beatitude, supreme bliss" },
        { word: "祝福", reading: "しゅくふく", meaning: "celebration (of a joyous occasion), blessing, giving one's blessing" },
        { word: "福音", reading: "ふくいん", meaning: "good news, glad tidings" }
    ],
    },
    "腹": {
        onyomi: ["フク"],
        kunyomi: ["はら"],
        examples: [
        { word: "お腹", reading: "おなか", meaning: "belly, abdomen, stomach" },
        { word: "空腹", reading: "くうふく", meaning: "empty stomach, hunger" },
        { word: "切腹", reading: "せっぷく", meaning: "seppuku, harakiri, ritual suicide by disembowelment" },
        { word: "中腹", reading: "ちゅうふく", meaning: "halfway up (down) a mountain, mountainside" }
    ],
    },
    "複": {
        onyomi: ["フク"],
        kunyomi: [],
        examples: [
        { word: "複合", reading: "ふくごう", meaning: "composite, combined, complex" },
        { word: "複雑", reading: "ふくざつ", meaning: "complex, complicated, intricate" },
        { word: "複写", reading: "ふくしゃ", meaning: "copying, duplication, reproduction" },
        { word: "複数", reading: "ふくすう", meaning: "plural, multiple" }
    ],
    },
    "覆": {
        onyomi: ["フク"],
        kunyomi: ["おお.う", "くつがえ.す", "くつがえ.る"],
        examples: [
        { word: "転覆", reading: "てんぷく", meaning: "overturning, capsizing" },
        { word: "覆す", reading: "くつがえす", meaning: "to overturn, to capsize, to upset" },
        { word: "覆る", reading: "くつがえる", meaning: "to topple over, to be overturned, to capsize" },
        { word: "覆面", reading: "ふくめん", meaning: "mask, veil, disguise" }
    ],
    },
    "払": {
        onyomi: ["フツ", "ヒツ", "ホツ"],
        kunyomi: ["はら.う", "-はら.い", "-ばら.い"],
        examples: [
        { word: "払う", reading: "はらう", meaning: "to pay (e.g. money, bill)" },
        { word: "払拭", reading: "ふっしょく", meaning: "wiping out, sweeping away, eradicating" },
        { word: "支払", reading: "しはらい", meaning: "payment" },
        { word: "払い", reading: "はらい", meaning: "payment, bill, account" }
    ],
    },
    "沸": {
        onyomi: ["フツ"],
        kunyomi: ["わ.く", "わ.かす"],
        examples: [
        { word: "沸騰", reading: "ふっとう", meaning: "boiling, seething" },
        { word: "沸く", reading: "わく", meaning: "to grow hot (e.g. water), to boil" },
        { word: "沸かす", reading: "わかす", meaning: "to boil, to heat (a liquid), to prepare (a bath, hot drink)" },
        { word: "湯沸かし器", reading: "ゆわかしき", meaning: "water heater, water boiler" }
    ],
    },
    "仏": {
        onyomi: ["ブツ", "フツ"],
        kunyomi: ["ほとけ"],
        examples: [
        { word: "石仏", reading: "せきぶつ", meaning: "stone Buddhist image" },
        { word: "大仏", reading: "だいぶつ", meaning: "large statue of Buddha (trad. at least 4.8m high)" },
        { word: "念仏", reading: "ねんぶつ", meaning: "nembutsu, nianfo, the three-word invocation \"Namu Amida Butsu\" dedicated to the Amitabha Buddha" },
        { word: "仏教", reading: "ぶっきょう", meaning: "Buddhism" }
    ],
    },
    "物": {
        onyomi: ["ブツ", "モツ"],
        kunyomi: ["もの", "もの-"],
        examples: [
        { word: "安物", reading: "やすもの", meaning: "cheap article, poor-quality article" },
        { word: "異物", reading: "いぶつ", meaning: "foreign substance, foreign body, foreign contamination" },
        { word: "遺物", reading: "いぶつ", meaning: "artifact, relic (of a past civilization), archaeological find" },
        { word: "汚物", reading: "おぶつ", meaning: "filth (esp. excrement, feces, urine), muck, waste" }
    ],
    },
    "粉": {
        onyomi: ["フン"],
        kunyomi: ["デシメートル", "こ", "こな"],
        examples: [
        { word: "花粉", reading: "かふん", meaning: "pollen" },
        { word: "粉砕", reading: "ふんさい", meaning: "pulverization, pulverisation" },
        { word: "粉飾", reading: "ふんしょく", meaning: "embellishment (e.g. of a story), ornamentation, decoration" },
        { word: "粉末", reading: "ふんまつ", meaning: "fine powder" }
    ],
    },
    "紛": {
        onyomi: ["フン"],
        kunyomi: ["まぎ.れる", "-まぎ.れ", "まぎ.らす", "まぎ.らわす", "まぎ.らわしい"],
        examples: [
        { word: "紛糾", reading: "ふんきゅう", meaning: "complication, confusion, disorder" },
        { word: "紛失", reading: "ふんしつ", meaning: "loss, going missing" },
        { word: "紛争", reading: "ふんそう", meaning: "dispute, conflict, trouble" },
        { word: "紛れ", reading: "まぐれ", meaning: "fluke, chance, pure luck" }
    ],
    },
    "雰": {
        onyomi: ["フン"],
        kunyomi: [],
        examples: [
        { word: "雰囲気", reading: "ふんいき", meaning: "atmosphere, mood, ambience" }
    ],
    },
    "噴": {
        onyomi: ["フン"],
        kunyomi: ["ふ.く"],
        examples: [
        { word: "噴火", reading: "ふんか", meaning: "eruption, volcanic eruption" },
        { word: "噴射", reading: "ふんしゃ", meaning: "jet, spray, emission" },
        { word: "噴出", reading: "ふんしゅつ", meaning: "spewing, gushing, spouting" },
        { word: "噴水", reading: "ふんすい", meaning: "water fountain" }
    ],
    },
    "墳": {
        onyomi: ["フン"],
        kunyomi: [],
        examples: [
        { word: "古墳", reading: "こふん", meaning: "ancient burial mound, barrow, tumulus" },
        { word: "墳墓", reading: "ふんぼ", meaning: "grave, tomb" }
    ],
    },
    "憤": {
        onyomi: ["フン"],
        kunyomi: ["いきどお.る"],
        examples: [
        { word: "憤慨", reading: "ふんがい", meaning: "indignation, resentment" },
        { word: "憤り", reading: "いきどおり", meaning: "resentment, indignation, anger" }
    ],
    },
    "奮": {
        onyomi: ["フン"],
        kunyomi: ["ふる.う"],
        examples: [
        { word: "興奮", reading: "こうふん", meaning: "excitement, stimulation, agitation" },
        { word: "奮う", reading: "ふるう", meaning: "to muster (e.g. one's courage), to call forth, to rouse up" },
        { word: "奮起", reading: "ふんき", meaning: "stirring, rousing oneself" },
        { word: "奮闘", reading: "ふんとう", meaning: "strenuous effort, hard struggle, working hard" }
    ],
    },
    "分": {
        onyomi: ["ブン", "フン", "ブ"],
        kunyomi: ["わ.ける", "わ.け", "わ.かれる", "わ.かる", "わ.かつ"],
        examples: [
        { word: "一分", reading: "いちぶ", meaning: "one tenth, one hundredth, one percent" },
        { word: "塩分", reading: "えんぶん", meaning: "salt, salt content, amount of salt" },
        { word: "応分", reading: "おうぶん", meaning: "according to one's abilities, appropriate, reasonable" },
        { word: "何分", reading: "なにぶん", meaning: "some, any, (a) little" }
    ],
    },
    "文": {
        onyomi: ["ブン", "モン"],
        kunyomi: ["ふみ", "あや"],
        examples: [
        { word: "一文", reading: "いちもん", meaning: "tiny amount of money, a penny, a cent" },
        { word: "英文", reading: "えいぶん", meaning: "English writing, English sentence, English text" },
        { word: "漢文", reading: "かんぶん", meaning: "Chinese classical writing, Chinese classics" },
        { word: "原文", reading: "げんぶん", meaning: "original text" }
    ],
    },
    "聞": {
        onyomi: ["ブン", "モン"],
        kunyomi: ["き.く", "き.こえる"],
        examples: [
        { word: "見聞", reading: "けんぶん", meaning: "information, experience, knowledge" },
        { word: "醜聞", reading: "しゅうぶん", meaning: "scandal" },
        { word: "新聞", reading: "しんぶん", meaning: "newspaper" },
        { word: "聞く", reading: "きく", meaning: "to hear" }
    ],
    },
    "丙": {
        onyomi: ["ヘイ"],
        kunyomi: ["ひのえ"],
        examples: [
        { word: "丙", reading: "へい", meaning: "third rank, third class, third person (in a contract, etc.)" }
    ],
    },
    "平": {
        onyomi: ["ヘイ", "ビョウ", "ヒョウ"],
        kunyomi: ["たい.ら", "たい.らげる", "ひら"],
        examples: [
        { word: "公平", reading: "こうへい", meaning: "fairness, impartiality, justice" },
        { word: "水平", reading: "すいへい", meaning: "horizontal, level, even" },
        { word: "不平", reading: "ふへい", meaning: "discontent, dissatisfaction, complaint" },
        { word: "平ら", reading: "たいら", meaning: "flat, level, even" }
    ],
    },
    "兵": {
        onyomi: ["ヘイ", "ヒョウ"],
        kunyomi: ["つわもの"],
        examples: [
        { word: "騎兵", reading: "きへい", meaning: "cavalry, cavalryman, trooper" },
        { word: "工兵", reading: "こうへい", meaning: "combat engineer, military engineer, combat engineering" },
        { word: "徴兵", reading: "ちょうへい", meaning: "conscription, (military) draft, (compulsory) enlistment" },
        { word: "撤兵", reading: "てっぺい", meaning: "withdrawal of troops" }
    ],
    },
    "併": {
        onyomi: ["ヘイ"],
        kunyomi: ["あわ.せる"],
        examples: [
        { word: "併記", reading: "へいき", meaning: "writing side by side, writing (down) together, writing (down) both" },
        { word: "併合", reading: "へいごう", meaning: "merger, joining into one, amalgamation" },
        { word: "併殺", reading: "へいさつ", meaning: "double play" },
        { word: "併設", reading: "へいせつ", meaning: "joint establishment (esp. schools of different levels or different courses of study), establishment as an annex (e.g. of a school), juxtaposition" }
    ],
    },
    "並": {
        onyomi: ["ヘイ", "ホウ"],
        kunyomi: ["な.み", "なみ", "なら.べる", "なら.ぶ", "なら.びに"],
        examples: [
        { word: "月並", reading: "つきなみ", meaning: "every month" },
        { word: "軒並", reading: "のきなみ", meaning: "row of houses" },
        { word: "並び", reading: "ならび", meaning: "line, row, rank" },
        { word: "並ぶ", reading: "ならぶ", meaning: "to line up, to stand in a line" }
    ],
    },
    "柄": {
        onyomi: ["ヘイ"],
        kunyomi: ["がら", "え", "つか"],
        examples: [
        { word: "横柄", reading: "おうへい", meaning: "arrogant, haughty, insolent" },
        { word: "家柄", reading: "いえがら", meaning: "social standing of a family, lineage, parentage" },
        { word: "間柄", reading: "あいだがら", meaning: "relationship, relation, terms (good, friendly, etc.)" },
        { word: "作柄", reading: "さくがら", meaning: "crop (conditions), harvest, yield" }
    ],
    },
    "陛": {
        onyomi: ["ヘイ"],
        kunyomi: [],
        examples: [
        { word: "陛下", reading: "へいか", meaning: "Your Majesty, His Majesty, Her Majesty" },
        { word: "天皇陛下", reading: "てんのうへいか", meaning: "His Majesty the Emperor" }
    ],
    },
    "閉": {
        onyomi: ["ヘイ"],
        kunyomi: ["と.じる", "と.ざす", "し.める", "し.まる", "た.てる"],
        examples: [
        { word: "開閉", reading: "かいへい", meaning: "opening and shutting, opening and closing" },
        { word: "閉会", reading: "へいかい", meaning: "closure (of a ceremony, event, meeting, etc.)" },
        { word: "閉口", reading: "へいこう", meaning: "to be stumped, to be at a loss, to be at one's wits' end" },
        { word: "閉鎖", reading: "へいさ", meaning: "closing, closure" }
    ],
    },
    "塀": {
        onyomi: ["ヘイ", "ベイ"],
        kunyomi: [],
        examples: [
        { word: "土塀", reading: "どべい", meaning: "mud wall, earthen wall, plaster wall" },
        { word: "塀", reading: "へい", meaning: "wall" }
    ],
    },
    "幣": {
        onyomi: ["ヘイ"],
        kunyomi: ["ぬさ"],
        examples: [
        { word: "貨幣", reading: "かへい", meaning: "money, currency, coin" },
        { word: "紙幣", reading: "しへい", meaning: "paper money, note, bill" },
        { word: "貨幣価値", reading: "かへいかち", meaning: "currency value" }
    ],
    },
    "弊": {
        onyomi: ["ヘイ"],
        kunyomi: [],
        examples: [
        { word: "疲弊", reading: "ひへい", meaning: "exhaustion, fatigue" },
        { word: "弊害", reading: "へいがい", meaning: "harmful effect, harmful influence, evil practice" },
        { word: "弊社", reading: "へいしゃ", meaning: "our company, our firm" }
    ],
    },
    "蔽": {
        onyomi: ["ヘイ", "ヘツ", "フツ"],
        kunyomi: ["おお.う", "おお.い"],
        examples: [
        { word: "隠蔽", reading: "いんぺい", meaning: "concealment, hiding, covering up" },
        { word: "陰蔽", reading: "いんぺい", meaning: "concealment, hiding, covering up" },
        { word: "掩蔽", reading: "えんぺい", meaning: "cover, concealment, masking" },
        { word: "遮蔽", reading: "しゃへい", meaning: "shielding, sheltering, screening" }
    ],
    },
    "餅": {
        onyomi: ["ヘイ", "ヒョウ"],
        kunyomi: ["もち", "もちい"],
        examples: [
        { word: "煎餅", reading: "せんべい", meaning: "(Japanese) rice cracker, senbei" },
        { word: "餅", reading: "もち", meaning: "mochi, small rice cake made from glutinous rice" }
    ],
    },
    "米": {
        onyomi: ["ベイ", "マイ", "メエトル"],
        kunyomi: ["こめ", "よね"],
        examples: [
        { word: "外米", reading: "がいまい", meaning: "foreign rice" },
        { word: "玄米", reading: "げんまい", meaning: "unpolished rice, unmilled rice, brown rice" },
        { word: "新米", reading: "しんまい", meaning: "new rice, first rice crop of the year" },
        { word: "精米", reading: "せいまい", meaning: "rice polishing, polished rice" }
    ],
    },
    "壁": {
        onyomi: ["ヘキ"],
        kunyomi: ["かべ"],
        examples: [
        { word: "外壁", reading: "がいへき", meaning: "outer wall" },
        { word: "岸壁", reading: "がんぺき", meaning: "quay, wharf, jetty" },
        { word: "障壁", reading: "しょうへき", meaning: "enclosing wall, boundary fence" },
        { word: "壁画", reading: "へきが", meaning: "fresco, mural, wall painting" }
    ],
    },
    "璧": {
        onyomi: ["ヘキ"],
        kunyomi: ["たま"],
        examples: [
        { word: "完璧", reading: "かんぺき", meaning: "perfect, complete, flawless" }
    ],
    },
    "癖": {
        onyomi: ["ヘキ"],
        kunyomi: ["くせ", "くせ.に"],
        examples: [
        { word: "潔癖", reading: "けっぺき", meaning: "fastidiousness, love of cleanliness" },
        { word: "口癖", reading: "くちぐせ", meaning: "pet saying, favorite phrase, stock phrase" },
        { word: "性癖", reading: "せいへき", meaning: "disposition, inclination, characteristic" },
        { word: "癖に", reading: "くせに", meaning: "and yet, though, when" }
    ],
    },
    "別": {
        onyomi: ["ベツ"],
        kunyomi: ["わか.れる", "わ.ける"],
        examples: [
        { word: "格別", reading: "かくべつ", meaning: "particular, special, exceptional" },
        { word: "鑑別", reading: "かんべつ", meaning: "discrimination, judgement, judgment" },
        { word: "区別", reading: "くべつ", meaning: "distinction, differentiation, discrimination" },
        { word: "決別", reading: "けつべつ", meaning: "separation, farewell, parting" }
    ],
    },
    "蔑": {
        onyomi: ["ベツ"],
        kunyomi: ["ないがしろ", "なみ.する", "くらい", "さげす.む"],
        examples: [
        { word: "軽蔑", reading: "けいべつ", meaning: "contempt, scorn, disdain" },
        { word: "侮蔑", reading: "ぶべつ", meaning: "scorn, disdain, contempt" },
        { word: "蔑む", reading: "さげすむ", meaning: "to scorn, to despise, to hold in contempt" }
    ],
    },
    "片": {
        onyomi: ["ヘン"],
        kunyomi: ["かた-", "かた"],
        examples: [
        { word: "欠片", reading: "かけら", meaning: "fragment, broken piece, chip" },
        { word: "断片", reading: "だんぺん", meaning: "fragment, scrap, piece" },
        { word: "破片", reading: "はへん", meaning: "fragment, broken piece, splinter" },
        { word: "片隅", reading: "かたすみ", meaning: "corner, nook" }
    ],
    },
    "辺": {
        onyomi: ["ヘン"],
        kunyomi: ["あた.り", "ほと.り", "-べ"],
        examples: [
        { word: "海辺", reading: "うみべ", meaning: "beach, seashore, seaside" },
        { word: "岸辺", reading: "きしべ", meaning: "shore, bank (of a body of water)" },
        { word: "近辺", reading: "きんぺん", meaning: "neighbourhood, neighborhood, vicinity" },
        { word: "周辺", reading: "しゅうへん", meaning: "circumference, outskirts, environs" }
    ],
    },
    "返": {
        onyomi: ["ヘン"],
        kunyomi: ["かえ.す", "-かえ.す", "かえ.る", "-かえ.る"],
        examples: [
        { word: "返す", reading: "かえす", meaning: "to return (something), to restore, to put back" },
        { word: "返る", reading: "かえる", meaning: "to return, to come back, to go back" },
        { word: "返還", reading: "へんかん", meaning: "return, restoration" },
        { word: "返却", reading: "へんきゃく", meaning: "return (of something borrowed or entrusted), returning, giving back" }
    ],
    },
    "変": {
        onyomi: ["ヘン"],
        kunyomi: ["か.わる", "か.わり", "か.える"],
        examples: [
        { word: "異変", reading: "いへん", meaning: "unusual event, strange occurrence, strange phenomenon" },
        { word: "一変", reading: "いっぺん", meaning: "complete change, about-face" },
        { word: "急変", reading: "きゅうへん", meaning: "sudden turn, sudden change" },
        { word: "事変", reading: "じへん", meaning: "accident, disaster, incident" }
    ],
    },
    "偏": {
        onyomi: ["ヘン"],
        kunyomi: ["かたよ.る"],
        examples: [
        { word: "偏り", reading: "かたより", meaning: "deviation, inclination, offset" },
        { word: "偏狭", reading: "へんきょう", meaning: "narrow-mindedness, intolerance, illiberality" },
        { word: "偏見", reading: "へんけん", meaning: "prejudice, bias, distorted view" },
        { word: "偏向", reading: "へんこう", meaning: "propensity, tendency, inclination" }
    ],
    },
    "遍": {
        onyomi: ["ヘン"],
        kunyomi: ["あまね.く"],
        examples: [
        { word: "一遍", reading: "いっぺん", meaning: "once, one time" },
        { word: "何遍", reading: "なんべん", meaning: "how many times, how often" },
        { word: "遍歴", reading: "へんれき", meaning: "travels, pilgrimage, itinerancy" },
        { word: "普遍", reading: "ふへん", meaning: "universal, general, ubiquitous" }
    ],
    },
    "編": {
        onyomi: ["ヘン"],
        kunyomi: ["あ.む", "-あ.み"],
        examples: [
        { word: "改編", reading: "かいへん", meaning: "reorganization, reorganisation" },
        { word: "再編", reading: "さいへん", meaning: "reorganization, reorganisation, reshuffle" },
        { word: "続編", reading: "ぞくへん", meaning: "sequel, continuation" },
        { word: "長編", reading: "ちょうへん", meaning: "long work, (full-length) novel, feature-length film" }
    ],
    },
    "弁": {
        onyomi: ["ベン", "ヘン"],
        kunyomi: ["かんむり", "わきま.える", "わ.ける", "はなびら", "あらそ.う"],
        examples: [
        { word: "駅弁", reading: "えきべん", meaning: "boxed lunch bought at a station (often a local specialty)" },
        { word: "花弁", reading: "はなびら", meaning: "petal" },
        { word: "勘弁", reading: "かんべん", meaning: "pardon, forgiveness, forbearance" },
        { word: "合弁", reading: "ごうべん", meaning: "joint management, pool" }
    ],
    },
    "便": {
        onyomi: ["ベン", "ビン"],
        kunyomi: ["たよ.り"],
        examples: [
        { word: "穏便", reading: "おんびん", meaning: "gentle, peaceable, amicable" },
        { word: "船便", reading: "ふなびん", meaning: "surface mail (by ship), sea mail" },
        { word: "大便", reading: "だいべん", meaning: "feces, faeces, excrement" },
        { word: "不便", reading: "ふべん", meaning: "inconvenience, inexpediency, unhandiness" }
    ],
    },
    "勉": {
        onyomi: ["ベン"],
        kunyomi: ["つと.める"],
        examples: [
        { word: "勤勉", reading: "きんべん", meaning: "diligent, hard-working, industrious" },
        { word: "勉学", reading: "べんがく", meaning: "study, pursuit of knowledge" },
        { word: "勉強", reading: "べんきょう", meaning: "study" },
        { word: "勉強中", reading: "べんきょうちゅう", meaning: "while studying, presently studying" }
    ],
    },
    "歩": {
        onyomi: ["ホ", "ブ", "フ"],
        kunyomi: ["ある.く", "あゆ.む"],
        examples: [
        { word: "一歩", reading: "いっぽ", meaning: "(a) step, one step" },
        { word: "競歩", reading: "きょうほ", meaning: "racewalking, race walking, walking race" },
        { word: "散歩", reading: "さんぽ", meaning: "walk, stroll" },
        { word: "初歩", reading: "しょほ", meaning: "basics, rudiments, elements" }
    ],
    },
    "保": {
        onyomi: ["ホ", "ホウ"],
        kunyomi: ["たも.つ"],
        examples: [
        { word: "安保", reading: "あんぽ", meaning: "security (e.g. national security)" },
        { word: "確保", reading: "かくほ", meaning: "securing, obtaining, ensuring" },
        { word: "生保", reading: "せいほ", meaning: "life insurance" },
        { word: "担保", reading: "たんぽ", meaning: "security, guarantee, collateral" }
    ],
    },
    "哺": {
        onyomi: ["ホ"],
        kunyomi: ["はぐく.む", "ふく.む"],
        examples: [
        { word: "反哺", reading: "はんぽ", meaning: "caring for one's parents in return" },
        { word: "哺乳", reading: "ほにゅう", meaning: "suckling, nursing, lactation" },
        { word: "哺育", reading: "ほいく", meaning: "nursing (esp. an animal), suckling, (feeding and) raising" },
        { word: "哺乳瓶", reading: "ほにゅうびん", meaning: "baby bottle, nursing bottle, feeding bottle" }
    ],
    },
    "捕": {
        onyomi: ["ホ"],
        kunyomi: ["と.らえる", "と.らわれる", "と.る", "とら.える", "とら.われる", "つか.まえる", "つか.まる"],
        examples: [
        { word: "逮捕", reading: "たいほ", meaning: "arrest, apprehension, capture" },
        { word: "捕る", reading: "とる", meaning: "to catch (a wild animal, fish, insect, baseball, etc.), to capture" },
        { word: "捕獲", reading: "ほかく", meaning: "capture, seizure" },
        { word: "捕鯨", reading: "ほげい", meaning: "whaling, whale hunting, whale fishing" }
    ],
    },
    "補": {
        onyomi: ["ホ"],
        kunyomi: ["おぎな.う"],
        examples: [
        { word: "候補", reading: "こうほ", meaning: "candidate, contender, prospect" },
        { word: "補う", reading: "おぎなう", meaning: "to supplement, to make up for, to compensate for" },
        { word: "補完", reading: "ほかん", meaning: "complementation, supplementation, completion" },
        { word: "補給", reading: "ほきゅう", meaning: "supply, supplying, replenishment" }
    ],
    },
    "舗": {
        onyomi: ["ホ"],
        kunyomi: [],
        examples: [
        { word: "店舗", reading: "てんぽ", meaning: "shop, store, establishment" },
        { word: "舗装", reading: "ほそう", meaning: "paving (a road), surfacing (with asphalt, concrete, etc.), pavement" },
        { word: "老舗", reading: "しにせ", meaning: "long-established shop, shop of long standing, old shop" },
        { word: "舗", reading: "ほ", meaning: "shop, store" }
    ],
    },
    "母": {
        onyomi: ["ボ"],
        kunyomi: ["はは", "も"],
        examples: [
        { word: "義母", reading: "ぎぼ", meaning: "mother-in-law" },
        { word: "空母", reading: "くうぼ", meaning: "aircraft carrier" },
        { word: "賢母", reading: "けんぼ", meaning: "wise mother" },
        { word: "酵母", reading: "こうぼ", meaning: "yeast, leaven" }
    ],
    },
    "募": {
        onyomi: ["ボ"],
        kunyomi: ["つの.る"],
        examples: [
        { word: "応募", reading: "おうぼ", meaning: "application, subscription, entry (competition, raffle, etc.)" },
        { word: "公募", reading: "こうぼ", meaning: "public appeal (e.g. for contributions), public advertisement (of a post), open recruitment" },
        { word: "募る", reading: "つのる", meaning: "to become stronger, to grow in intensity, to grow violent" },
        { word: "募金", reading: "ぼきん", meaning: "fundraising, collection of contributions" }
    ],
    },
    "墓": {
        onyomi: ["ボ"],
        kunyomi: ["はか"],
        examples: [
        { word: "墳墓", reading: "ふんぼ", meaning: "grave, tomb" },
        { word: "墓穴", reading: "ぼけつ", meaning: "grave (pit)" },
        { word: "墓参", reading: "はかまいり", meaning: "visit to a grave" },
        { word: "墓石", reading: "ぼせき", meaning: "tombstone, gravestone" }
    ],
    },
    "慕": {
        onyomi: ["ボ"],
        kunyomi: ["した.う"],
        examples: [
        { word: "思慕", reading: "しぼ", meaning: "yearning, longing for, deep affection" },
        { word: "慕う", reading: "したう", meaning: "to yearn for, to long for, to pine for" }
    ],
    },
    "暮": {
        onyomi: ["ボ"],
        kunyomi: ["く.れる", "く.らす"],
        examples: [
        { word: "歳暮", reading: "せいぼ", meaning: "year-end gift" },
        { word: "暮れ", reading: "くれ", meaning: "sunset, sundown, nightfall" },
        { word: "野暮", reading: "やぼ", meaning: "boorish, unsophisticated, unrefined" },
        { word: "日暮れ", reading: "ひぐれ", meaning: "twilight, sunset, dusk" }
    ],
    },
    "簿": {
        onyomi: ["ボ"],
        kunyomi: [],
        examples: [
        { word: "帳簿", reading: "ちょうぼ", meaning: "account book, register, ledger" },
        { word: "簿記", reading: "ぼき", meaning: "bookkeeping" },
        { word: "名簿", reading: "めいぼ", meaning: "register of names, list of names, roll" },
        { word: "家計簿", reading: "かけいぼ", meaning: "household account book" }
    ],
    },
    "方": {
        onyomi: ["ホウ"],
        kunyomi: ["かた", "-かた", "-がた"],
        examples: [
        { word: "一方", reading: "いっぽう", meaning: "one (esp. of two), the other, one way" },
        { word: "右方", reading: "うほう", meaning: "right side" },
        { word: "遠方", reading: "えんぽう", meaning: "distant place, faraway location, far away" },
        { word: "下方", reading: "かほう", meaning: "lower region, lower part, region below" }
    ],
    },
    "包": {
        onyomi: ["ホウ"],
        kunyomi: ["つつ.む", "くる.む"],
        examples: [
        { word: "梱包", reading: "こんぽう", meaning: "packing, crating, packaging" },
        { word: "内包", reading: "ないほう", meaning: "connotation, comprehension, intension" },
        { word: "包み", reading: "つつみ", meaning: "bundle, package, parcel" },
        { word: "包囲", reading: "ほうい", meaning: "siege, encirclement, envelopment" }
    ],
    },
    "芳": {
        onyomi: ["ホウ"],
        kunyomi: ["かんば.しい"],
        examples: [
        { word: "芳香", reading: "ほうこう", meaning: "perfume, fragrance, aroma" },
        { word: "芳しい", reading: "かんばしい", meaning: "sweet-smelling, fragrant, aromatic" }
    ],
    },
    "邦": {
        onyomi: ["ホウ"],
        kunyomi: ["くに"],
        examples: [
        { word: "東邦", reading: "とうほう", meaning: "Oriental country, the Orient" },
        { word: "邦画", reading: "ほうが", meaning: "Japanese film" },
        { word: "邦楽", reading: "ほうがく", meaning: "Japanese music (esp. traditional Japanese music)" },
        { word: "邦人", reading: "ほうじん", meaning: "Japanese national (esp. abroad)" }
    ],
    },
    "奉": {
        onyomi: ["ホウ", "ブ"],
        kunyomi: ["たてまつ.る", "まつ.る", "ほう.ずる"],
        examples: [
        { word: "信奉", reading: "しんぽう", meaning: "belief, faith, adherence" },
        { word: "奉公", reading: "ほうこう", meaning: "live-in domestic service, live-in apprenticeship" },
        { word: "奉行", reading: "ぶぎょう", meaning: "magistrate, shogunate administrator" },
        { word: "奉仕", reading: "ほうし", meaning: "service, ministry, attendance" }
    ],
    },
    "宝": {
        onyomi: ["ホウ"],
        kunyomi: ["たから"],
        examples: [
        { word: "国宝", reading: "こくほう", meaning: "national treasure" },
        { word: "宝庫", reading: "ほうこ", meaning: "treasury, treasure house, storehouse" },
        { word: "宝石", reading: "ほうせき", meaning: "gem, jewel, precious stone" },
        { word: "重宝", reading: "ちょうほう", meaning: "convenient, useful, handy" }
    ],
    },
    "抱": {
        onyomi: ["ホウ"],
        kunyomi: ["だ.く", "いだ.く", "かか.える"],
        examples: [
        { word: "辛抱", reading: "しんぼう", meaning: "patience, endurance, perseverance" },
        { word: "抱え", reading: "かかえ", meaning: "armful" },
        { word: "抱負", reading: "ほうふ", meaning: "aspiration, ambition, plan" },
        { word: "抱く", reading: "いだく", meaning: "to hold in one's arms (e.g. a baby), to embrace, to hug" }
    ],
    },
    "放": {
        onyomi: ["ホウ"],
        kunyomi: ["はな.す", "-っぱな.し", "はな.つ", "はな.れる", "こ.く", "ほう.る"],
        examples: [
        { word: "解放", reading: "かいほう", meaning: "release, unleashing, liberation" },
        { word: "開放", reading: "かいほう", meaning: "opening (a door, window, etc.), leaving open" },
        { word: "釈放", reading: "しゃくほう", meaning: "release, liberation, acquittal" },
        { word: "追放", reading: "ついほう", meaning: "exile, banishment, eviction" }
    ],
    },
    "法": {
        onyomi: ["ホウ", "ハッ", "ホッ", "フラン"],
        kunyomi: ["のり"],
        examples: [
        { word: "違法", reading: "いほう", meaning: "illegal, illicit, unlawful" },
        { word: "技法", reading: "ぎほう", meaning: "technique" },
        { word: "刑法", reading: "けいほう", meaning: "criminal law, penal code" },
        { word: "憲法", reading: "けんぽう", meaning: "constitution" }
    ],
    },
    "泡": {
        onyomi: ["ホウ"],
        kunyomi: ["あわ"],
        examples: [
        { word: "気泡", reading: "きほう", meaning: "(air) bubble (esp. in a liquid)" },
        { word: "水泡", reading: "すいほう", meaning: "foam, bubble" },
        { word: "発泡", reading: "はっぽう", meaning: "foaming" },
        { word: "泡", reading: "あわ", meaning: "bubble, foam, froth" }
    ],
    },
    "胞": {
        onyomi: ["ホウ"],
        kunyomi: [],
        examples: [
        { word: "細胞", reading: "さいぼう", meaning: "cell" },
        { word: "胞子", reading: "ほうし", meaning: "spore" },
        { word: "同胞", reading: "どうほう", meaning: "brethren, brothers, fellow countrymen" },
        { word: "細胞内", reading: "さいぼうない", meaning: "inside the cell, intracellular" }
    ],
    },
    "俸": {
        onyomi: ["ホウ"],
        kunyomi: [],
        examples: [
        { word: "減俸", reading: "げんぽう", meaning: "salary reduction, salary cut" },
        { word: "年俸", reading: "ねんぽう", meaning: "annual salary" },
        { word: "俸給", reading: "ほうきゅう", meaning: "salary (esp. public employees), wages, pay" }
    ],
    },
    "倣": {
        onyomi: ["ホウ"],
        kunyomi: ["なら.う"],
        examples: [
        { word: "模倣", reading: "もほう", meaning: "imitation, copying" },
        { word: "倣う", reading: "ならう", meaning: "to imitate, to follow, to copy" }
    ],
    },
    "峰": {
        onyomi: ["ホウ"],
        kunyomi: ["みね", "ね"],
        examples: [
        { word: "高峰", reading: "こうほう", meaning: "high mountain, lofty peak" },
        { word: "連峰", reading: "れんぽう", meaning: "mountain range" },
        { word: "最高峰", reading: "さいこうほう", meaning: "highest peak, highest mountain" },
        { word: "峰", reading: "みね", meaning: "peak, summit, ridge" }
    ],
    },
    "砲": {
        onyomi: ["ホウ"],
        kunyomi: [],
        examples: [
        { word: "主砲", reading: "しゅほう", meaning: "main battery, main armament" },
        { word: "大砲", reading: "たいほう", meaning: "(large) gun, cannon, artillery" },
        { word: "鉄砲", reading: "てっぽう", meaning: "gun, firearm" },
        { word: "発砲", reading: "はっぽう", meaning: "firing, discharge of gun" }
    ],
    },
    "崩": {
        onyomi: ["ホウ"],
        kunyomi: ["くず.れる", "-くず.れ", "くず.す"],
        examples: [
        { word: "雪崩", reading: "なだれ", meaning: "avalanche, snowslide" },
        { word: "崩す", reading: "くずす", meaning: "to destroy, to demolish, to pull down" },
        { word: "崩壊", reading: "ほうかい", meaning: "collapse, crumbling, breaking down" },
        { word: "崩落", reading: "ほうらく", meaning: "collapse, break, cave-in" }
    ],
    },
    "訪": {
        onyomi: ["ホウ"],
        kunyomi: ["おとず.れる", "たず.ねる", "と.う"],
        examples: [
        { word: "探訪", reading: "たんぼう", meaning: "searching, hunting for news story, journalist" },
        { word: "訪日", reading: "ほうにち", meaning: "visit to Japan" },
        { word: "訪米", reading: "ほうべい", meaning: "visit to the United States" },
        { word: "訪問", reading: "ほうもん", meaning: "call, visit" }
    ],
    },
    "報": {
        onyomi: ["ホウ"],
        kunyomi: ["むく.いる"],
        examples: [
        { word: "会報", reading: "かいほう", meaning: "bulletin (issued by a society), report, newsletter" },
        { word: "官報", reading: "かんぽう", meaning: "official daily gazette, government newsletter" },
        { word: "吉報", reading: "きっぽう", meaning: "good news" },
        { word: "警報", reading: "けいほう", meaning: "warning, alarm, alert" }
    ],
    },
    "蜂": {
        onyomi: ["ホウ"],
        kunyomi: ["はち"],
        examples: [
        { word: "蜂蜜", reading: "はちみつ", meaning: "honey" },
        { word: "蜂", reading: "はち", meaning: "bee, wasp, hornet" }
    ],
    },
    "豊": {
        onyomi: ["ホウ", "ブ"],
        kunyomi: ["ゆた.か", "とよ"],
        examples: [
        { word: "豊か", reading: "ゆたか", meaning: "abundant, plentiful, rich" },
        { word: "豊漁", reading: "ほうりょう", meaning: "good catch, good haul" },
        { word: "豊作", reading: "ほうさく", meaning: "abundant harvest, bumper crop" },
        { word: "豊年", reading: "ほうねん", meaning: "fruitful year" }
    ],
    },
    "飽": {
        onyomi: ["ホウ"],
        kunyomi: ["あ.きる", "あ.かす", "あ.く"],
        examples: [
        { word: "飽食", reading: "ほうしょく", meaning: "eating until one is full, eating one's fill, gorging (on)" },
        { word: "飽和", reading: "ほうわ", meaning: "saturation, satiation" },
        { word: "飽き", reading: "あき", meaning: "weariness, boredom, tedium" },
        { word: "飽きる", reading: "あきる", meaning: "to get tired of, to tire of, to lose interest in" }
    ],
    },
    "褒": {
        onyomi: ["ホウ"],
        kunyomi: ["ほ.める"],
        examples: [
        { word: "褒賞", reading: "ほうしょう", meaning: "prize, award, reward" },
        { word: "褒美", reading: "ほうび", meaning: "reward, prize" },
        { word: "褒める", reading: "ほめる", meaning: "to praise, to commend, to compliment" },
        { word: "ご褒美", reading: "ごほうび", meaning: "reward, prize" }
    ],
    },
    "縫": {
        onyomi: ["ホウ"],
        kunyomi: ["ぬ.う"],
        examples: [
        { word: "裁縫", reading: "さいほう", meaning: "sewing, needlework" },
        { word: "縫う", reading: "ぬう", meaning: "to sew, to stitch" },
        { word: "縫目", reading: "ぬいめ", meaning: "seam, stitch, suture" },
        { word: "縫製", reading: "ほうせい", meaning: "sewing (by machine)" }
    ],
    },
    "亡": {
        onyomi: ["ボウ", "モウ"],
        kunyomi: ["な.い", "な.き-", "ほろ.びる", "ほろ.ぶ", "ほろ.ぼす"],
        examples: [
        { word: "死亡", reading: "しぼう", meaning: "death, dying, mortality" },
        { word: "逃亡", reading: "とうぼう", meaning: "escape, flight, running away" },
        { word: "亡骸", reading: "なきがら", meaning: "remains, corpse, (dead) body" },
        { word: "亡命", reading: "ぼうめい", meaning: "fleeing from one's country, seeking asylum, defection" }
    ],
    },
    "乏": {
        onyomi: ["ボウ"],
        kunyomi: ["とぼ.しい", "とも.しい"],
        examples: [
        { word: "窮乏", reading: "きゅうぼう", meaning: "poverty, destitution, privation" },
        { word: "欠乏", reading: "けつぼう", meaning: "deficiency, insufficiency, shortage" },
        { word: "貧乏", reading: "びんぼう", meaning: "poverty-stricken, destitute, poor" },
        { word: "貧乏人", reading: "びんぼうにん", meaning: "poor person, the poor" }
    ],
    },
    "忙": {
        onyomi: ["ボウ", "モウ"],
        kunyomi: ["いそが.しい", "せわ.しい", "おそ.れる", "うれえるさま"],
        examples: [
        { word: "多忙", reading: "たぼう", meaning: "being very busy, busyness" },
        { word: "忙しい", reading: "いそがしい", meaning: "busy, occupied, hectic" }
    ],
    },
    "坊": {
        onyomi: ["ボウ", "ボッ"],
        kunyomi: [],
        examples: [
        { word: "寝坊", reading: "ねぼう", meaning: "sleeping in late, oversleeping" },
        { word: "坊主", reading: "ぼうず", meaning: "Buddhist priest, bonze" },
        { word: "赤ん坊", reading: "あかんぼう", meaning: "baby, infant" },
        { word: "朝寝坊", reading: "あさねぼう", meaning: "sleeping late in the morning, sleeping in, lie-in" }
    ],
    },
    "妨": {
        onyomi: ["ボウ"],
        kunyomi: ["さまた.げる"],
        examples: [
        { word: "妨げ", reading: "さまたげ", meaning: "obstruction, hindrance" },
        { word: "妨害", reading: "ぼうがい", meaning: "obstruction, hindrance, blocking" },
        { word: "妨げる", reading: "さまたげる", meaning: "to disturb, to prevent, to obstruct" }
    ],
    },
    "忘": {
        onyomi: ["ボウ"],
        kunyomi: ["わす.れる"],
        examples: [
        { word: "忘却", reading: "ぼうきゃく", meaning: "lapse of memory, forgetting completely, (consigning to) oblivion" },
        { word: "忘れる", reading: "わすれる", meaning: "to forget, to leave carelessly, to be forgetful of" },
        { word: "忘れ物", reading: "わすれもの", meaning: "lost article, thing left behind" },
        { word: "忘年会", reading: "ぼうねんかい", meaning: "year-end party, \"forget-the-year\" party, bōnenkai" }
    ],
    },
    "防": {
        onyomi: ["ボウ"],
        kunyomi: ["ふせ.ぐ"],
        examples: [
        { word: "攻防", reading: "こうぼう", meaning: "offense and defense, offence and defence" },
        { word: "国防", reading: "こくぼう", meaning: "national defence, national defense" },
        { word: "砂防", reading: "さぼう", meaning: "erosion control" },
        { word: "消防", reading: "しょうぼう", meaning: "fire fighting" }
    ],
    },
    "房": {
        onyomi: ["ボウ"],
        kunyomi: ["ふさ"],
        examples: [
        { word: "官房", reading: "かんぼう", meaning: "government secretariat" },
        { word: "工房", reading: "こうぼう", meaning: "workshop, studio, atelier" },
        { word: "書房", reading: "しょぼう", meaning: "study, library" },
        { word: "女房", reading: "にょうぼう", meaning: "wife (esp. one's own wife)" }
    ],
    },
    "肪": {
        onyomi: ["ボウ"],
        kunyomi: [],
        examples: [
        { word: "脂肪", reading: "しぼう", meaning: "fat, grease, blubber" }
    ],
    },
    "某": {
        onyomi: ["ボウ"],
        kunyomi: ["それがし", "なにがし"],
        examples: [
        { word: "某", reading: "ぼう", meaning: "certain, one" }
    ],
    },
    "冒": {
        onyomi: ["ボウ"],
        kunyomi: ["おか.す"],
        examples: [
        { word: "冒す", reading: "おかす", meaning: "to brave, to risk, to face" },
        { word: "冒険", reading: "ぼうけん", meaning: "adventure, venture" },
        { word: "冒頭", reading: "ぼうとう", meaning: "beginning, opening, start" }
    ],
    },
    "剖": {
        onyomi: ["ボウ"],
        kunyomi: [],
        examples: [
        { word: "解剖", reading: "かいぼう", meaning: "dissection, autopsy, postmortem examination" },
        { word: "解剖学", reading: "かいぼうがく", meaning: "anatomy" }
    ],
    },
    "紡": {
        onyomi: ["ボウ"],
        kunyomi: ["つむ.ぐ"],
        examples: [
        { word: "混紡", reading: "こんぼう", meaning: "mixed yarn, mixed spinning" },
        { word: "紡ぐ", reading: "つむぐ", meaning: "to spin, to make yarn" },
        { word: "紡織", reading: "ぼうしょく", meaning: "spinning and weaving" },
        { word: "紡績", reading: "ぼうせき", meaning: "spinning (textiles)" }
    ],
    },
    "望": {
        onyomi: ["ボウ", "モウ"],
        kunyomi: ["のぞ.む", "もち"],
        examples: [
        { word: "渇望", reading: "かつぼう", meaning: "craving, longing, thirsting" },
        { word: "希望", reading: "きぼう", meaning: "hope, wish, aspiration" },
        { word: "志望", reading: "しぼう", meaning: "wish, desire, ambition" },
        { word: "失望", reading: "しつぼう", meaning: "disappointment, despair" }
    ],
    },
    "傍": {
        onyomi: ["ボウ"],
        kunyomi: ["かたわ.ら", "わき", "おか-", "はた", "そば"],
        examples: [
        { word: "傍観", reading: "ぼうかん", meaning: "looking on, standing by and watching, sitting back and watching" },
        { word: "傍受", reading: "ぼうじゅ", meaning: "interception, monitoring, tapping" },
        { word: "傍聴", reading: "ぼうちょう", meaning: "listening (to a lecture, hearing, parliament session, etc.), attending (without participating), sitting in (e.g. on a meeting)" },
        { word: "傍ら", reading: "かたわら", meaning: "side, edge, beside" }
    ],
    },
    "帽": {
        onyomi: ["ボウ", "モウ"],
        kunyomi: ["ずきん", "おお.う"],
        examples: [
        { word: "帽子", reading: "ぼうし", meaning: "hat, cap" }
    ],
    },
    "棒": {
        onyomi: ["ボウ"],
        kunyomi: [],
        examples: [
        { word: "相棒", reading: "あいぼう", meaning: "partner, pal, accomplice" },
        { word: "鉄棒", reading: "てつぼう", meaning: "iron rod, iron bar, iron club" },
        { word: "泥棒", reading: "どろぼう", meaning: "thief, burglar, robber" },
        { word: "棒立ち", reading: "ぼうだち", meaning: "standing upright, standing bolt upright, rearing" }
    ],
    },
    "貿": {
        onyomi: ["ボウ"],
        kunyomi: [],
        examples: [
        { word: "貿易", reading: "ぼうえき", meaning: "(foreign) trade, (international) commerce, importing and exporting" }
    ],
    },
    "貌": {
        onyomi: ["ボウ", "バク"],
        kunyomi: ["かたち", "かたどる"],
        examples: [
        { word: "全貌", reading: "ぜんぼう", meaning: "full view, total picture, whole story" },
        { word: "美貌", reading: "びぼう", meaning: "beautiful face, good looks, beauty" },
        { word: "変貌", reading: "へんぼう", meaning: "transfiguration, transformation, change of appearance" }
    ],
    },
    "暴": {
        onyomi: ["ボウ", "バク"],
        kunyomi: ["あば.く", "あば.れる"],
        examples: [
        { word: "横暴", reading: "おうぼう", meaning: "violence, oppression, high-handedness" },
        { word: "粗暴", reading: "そぼう", meaning: "rough (behaviour, temperament, etc.), wild, rude" },
        { word: "暴虐", reading: "ぼうぎゃく", meaning: "tyranny, atrocity" },
        { word: "暴挙", reading: "ぼうきょ", meaning: "violence, reckless action, (an) outrage" }
    ],
    },
    "膨": {
        onyomi: ["ボウ"],
        kunyomi: ["ふく.らむ", "ふく.れる"],
        examples: [
        { word: "膨張", reading: "ぼうちょう", meaning: "expansion, swelling, increase" },
        { word: "膨大", reading: "ぼうだい", meaning: "huge, vast, enormous" },
        { word: "膨らむ", reading: "ふくらむ", meaning: "to expand, to swell (out), to get big" },
        { word: "膨れる", reading: "ふくれる", meaning: "to swell (out), to expand, to be inflated" }
    ],
    },
    "謀": {
        onyomi: ["ボウ", "ム"],
        kunyomi: ["はか.る", "たばか.る", "はかりごと"],
        examples: [
        { word: "陰謀", reading: "いんぼう", meaning: "plot, intrigue, scheme" },
        { word: "共謀", reading: "きょうぼう", meaning: "conspiracy, collusion, complicity" },
        { word: "参謀", reading: "さんぼう", meaning: "staff officer, military staff" },
        { word: "首謀", reading: "しゅぼう", meaning: "plotting, planning (crime, intrigue)" }
    ],
    },
    "頰": {
        onyomi: ["キョウ"],
        kunyomi: ["ほお", "ほほ"],
        examples: [
        { word: "頰紅", reading: "ほおべに", meaning: "cheek rouge, blusher, blush" },
        { word: "頰杖", reading: "ほおづえ", meaning: "resting one's chin in one's hands" },
        { word: "猿頰", reading: "さるぼお", meaning: "cheek pouch (monkey, squirrel, etc.)" },
        { word: "両頰", reading: "りょうほお", meaning: "both cheeks" }
    ],
    },
    "北": {
        onyomi: ["ホク"],
        kunyomi: ["きた"],
        examples: [
        { word: "東北", reading: "とうほく", meaning: "north-east" },
        { word: "南北", reading: "なんぼく", meaning: "north and south, north to south" },
        { word: "敗北", reading: "はいぼく", meaning: "defeat, loss, reverse" },
        { word: "北緯", reading: "ほくい", meaning: "north latitude" }
    ],
    },
    "木": {
        onyomi: ["ボク", "モク"],
        kunyomi: ["き", "こ-"],
        examples: [
        { word: "荒木", reading: "あらき", meaning: "logs in bark, rough wood, unseasoned timber" },
        { word: "黒木", reading: "くろき", meaning: "unbarked lumber" },
        { word: "材木", reading: "ざいもく", meaning: "wood (for building), lumber, timber" },
        { word: "樹木", reading: "じゅもく", meaning: "tree, trees and shrubs" }
    ],
    },
    "朴": {
        onyomi: ["ボク"],
        kunyomi: ["ほう", "ほお", "えのき"],
        examples: [
        { word: "素朴", reading: "そぼく", meaning: "simple, artless, naive" }
    ],
    },
    "牧": {
        onyomi: ["ボク"],
        kunyomi: ["まき"],
        examples: [
        { word: "放牧", reading: "ほうぼく", meaning: "pasturage, grazing" },
        { word: "牧師", reading: "ぼくし", meaning: "pastor, minister, clergyman" },
        { word: "牧草", reading: "ぼくそう", meaning: "pasture, grass" },
        { word: "牧畜", reading: "ぼくちく", meaning: "stock-farming, livestock farming, cattle breeding" }
    ],
    },
    "睦": {
        onyomi: ["ボク", "モク"],
        kunyomi: ["むつ.まじい", "むつ.む", "むつ.ぶ"],
        examples: [
        { word: "親睦", reading: "しんぼく", meaning: "friendship, amity" }
    ],
    },
    "僕": {
        onyomi: ["ボク"],
        kunyomi: ["しもべ"],
        examples: [
        { word: "僕ら", reading: "ぼくら", meaning: "we, us" },
        { word: "僕たち", reading: "ぼくたち", meaning: "we" },
        { word: "僕", reading: "ぼく", meaning: "I, me" }
    ],
    },
    "墨": {
        onyomi: ["ボク"],
        kunyomi: ["すみ"],
        examples: [
        { word: "墨絵", reading: "すみえ", meaning: "ink painting" },
        { word: "水墨画", reading: "すいぼくが", meaning: "India-ink painting, ink wash painting" },
        { word: "入れ墨", reading: "いれずみ", meaning: "tattoo (esp. a traditional Japanese one), tattooing" },
        { word: "お墨付き", reading: "おすみつき", meaning: "certificate, certified document, authorization" }
    ],
    },
    "撲": {
        onyomi: ["ボク"],
        kunyomi: [],
        examples: [
        { word: "相撲", reading: "すもう", meaning: "sumo (wrestling)" },
        { word: "打撲", reading: "だぼく", meaning: "blow, hit (on the body), beating" },
        { word: "撲滅", reading: "ぼくめつ", meaning: "eradication, extermination, destruction" },
        { word: "大相撲", reading: "おおずもう", meaning: "professional sumo wrestling" }
    ],
    },
    "没": {
        onyomi: ["ボツ", "モツ"],
        kunyomi: ["おぼ.れる", "しず.む", "ない"],
        examples: [
        { word: "陥没", reading: "かんぼつ", meaning: "cave-in, collapse, sinking" },
        { word: "出没", reading: "しゅつぼつ", meaning: "making frequent appearances, appearing often, appearing and disappearing" },
        { word: "戦没", reading: "せんぼつ", meaning: "death in battle, killed in action" },
        { word: "沈没", reading: "ちんぼつ", meaning: "sinking, foundering, going down" }
    ],
    },
    "勃": {
        onyomi: ["ボツ", "ホツ"],
        kunyomi: ["おこ.る", "にわかに"],
        examples: [
        { word: "勃起", reading: "ぼっき", meaning: "erection (of the penis), becoming erect, stiffening" }
    ],
    },
    "堀": {
        onyomi: ["クツ"],
        kunyomi: ["ほり"],
        examples: [
        { word: "外堀", reading: "そとぼり", meaning: "outer moat (of a castle)" },
        { word: "堀川", reading: "ほりかわ", meaning: "canal" },
        { word: "内堀", reading: "うちぼり", meaning: "inner moat, moat within the castle walls" },
        { word: "堀江", reading: "ほりえ", meaning: "canal" }
    ],
    },
    "本": {
        onyomi: ["ホン"],
        kunyomi: ["もと"],
        examples: [
        { word: "一本", reading: "いっぽん", meaning: "one long cylindrical thing, one film, TV show, etc., one goal, home run, etc." },
        { word: "絵本", reading: "えほん", meaning: "picture book" },
        { word: "基本", reading: "きほん", meaning: "basics, fundamentals, basis" },
        { word: "脚本", reading: "きゃくほん", meaning: "script, screenplay, scenario" }
    ],
    },
    "奔": {
        onyomi: ["ホン"],
        kunyomi: ["はし.る"],
        examples: [
        { word: "狂奔", reading: "きょうほん", meaning: "rushing around, running wild" },
        { word: "奔走", reading: "ほんそう", meaning: "running about, making every effort (to do), busying oneself (with)" },
        { word: "奔放", reading: "ほんぽう", meaning: "wild, uninhibited, extravagant" }
    ],
    },
    "翻": {
        onyomi: ["ホン", "ハン"],
        kunyomi: ["ひるがえ.る", "ひるがえ.す"],
        examples: [
        { word: "翻す", reading: "ひるがえす", meaning: "to turn over" },
        { word: "翻る", reading: "ひるがえる", meaning: "to flutter (in the wind), to wave, to flap" },
        { word: "翻案", reading: "ほんあん", meaning: "adaptation (of a novel, play, etc.)" },
        { word: "翻意", reading: "ほんい", meaning: "changing one's mind" }
    ],
    },
    "凡": {
        onyomi: ["ボン", "ハン"],
        kunyomi: ["およ.そ", "おうよ.そ", "すべ.て"],
        examples: [
        { word: "平凡", reading: "へいぼん", meaning: "ordinary, common, commonplace" },
        { word: "凡そ", reading: "およそ", meaning: "about, roughly, approximately" },
        { word: "凡庸", reading: "ぼんよう", meaning: "mediocre, ordinary, commonplace" },
        { word: "凡人", reading: "ぼんじん", meaning: "ordinary person, average person, mediocre person" }
    ],
    },
    "盆": {
        onyomi: ["ボン"],
        kunyomi: [],
        examples: [
        { word: "盆栽", reading: "ぼんさい", meaning: "bonsai, miniature potted plant" },
        { word: "盆地", reading: "ぼんち", meaning: "basin (e.g. between mountains)" },
        { word: "盆踊り", reading: "ぼんおどり", meaning: "Bon Festival dance, Lantern Festival dance" },
        { word: "盆", reading: "ぼん", meaning: "tray" }
    ],
    },
    "麻": {
        onyomi: ["マ", "マア"],
        kunyomi: ["あさ"],
        examples: [
        { word: "胡麻", reading: "ごま", meaning: "sesame seeds" },
        { word: "大麻", reading: "たいま", meaning: "hemp" },
        { word: "麻雀", reading: "マージャン", meaning: "mahjong, mah-jongg" },
        { word: "麻布", reading: "あさぬの", meaning: "hemp cloth, linen" }
    ],
    },
    "摩": {
        onyomi: ["マ"],
        kunyomi: ["ま.する", "さす.る", "す.る"],
        examples: [
        { word: "摩る", reading: "さする", meaning: "to rub, to pat, to stroke" },
        { word: "摩擦", reading: "まさつ", meaning: "friction" },
        { word: "あん摩", reading: "あんま", meaning: "massage (esp. anma, a traditional form of Japanese massage)" },
        { word: "薩摩芋", reading: "さつまいも", meaning: "sweet potato (Ipomoea batatas)" }
    ],
    },
    "磨": {
        onyomi: ["マ"],
        kunyomi: ["みが.く", "す.る"],
        examples: [
        { word: "達磨", reading: "だるま", meaning: "daruma, tumbling doll, round, red-painted good-luck doll in the shape of Bodhidharma, with a blank eye to be completed when a person's wish is granted" },
        { word: "磨く", reading: "みがく", meaning: "to polish, to shine, to burnish" },
        { word: "研磨", reading: "けんま", meaning: "grinding, polishing" },
        { word: "磨き", reading: "みがき", meaning: "polish, burnishing" }
    ],
    },
    "魔": {
        onyomi: ["マ"],
        kunyomi: [],
        examples: [
        { word: "悪魔", reading: "あくま", meaning: "devil, demon, fiend" },
        { word: "邪魔", reading: "じゃま", meaning: "hindrance, obstacle, nuisance" },
        { word: "魔術", reading: "まじゅつ", meaning: "magic, sorcery, witchcraft" },
        { word: "魔女", reading: "まじょ", meaning: "witch" }
    ],
    },
    "毎": {
        onyomi: ["マイ"],
        kunyomi: ["ごと", "-ごと.に"],
        examples: [
        { word: "毎に", reading: "ごとに", meaning: "one by one, each, every" },
        { word: "毎回", reading: "まいかい", meaning: "every time, each round" },
        { word: "毎時", reading: "まいじ", meaning: "every hour, hourly" },
        { word: "毎週", reading: "まいしゅう", meaning: "every week" }
    ],
    },
    "妹": {
        onyomi: ["マイ"],
        kunyomi: ["いもうと"],
        examples: [
        { word: "義妹", reading: "ぎまい", meaning: "sister-in-law (spouse's younger sister or younger brother's wife)" },
        { word: "弟妹", reading: "ていまい", meaning: "younger brother and sister" },
        { word: "姉妹", reading: "しまい", meaning: "sisters" },
        { word: "従姉妹", reading: "いとこ", meaning: "cousin (female)" }
    ],
    },
    "枚": {
        onyomi: ["マイ", "バイ"],
        kunyomi: [],
        examples: [
        { word: "一枚", reading: "いちまい", meaning: "one (thin, flat object), one sheet" },
        { word: "三枚", reading: "さんまい", meaning: "three flat objects (sheets of paper, pieces of cloth, etc.)" },
        { word: "枚挙", reading: "まいきょ", meaning: "enumeration" },
        { word: "枚数", reading: "まいすう", meaning: "the number of flat things" }
    ],
    },
    "昧": {
        onyomi: ["マイ", "バイ"],
        kunyomi: ["くら.い", "むさぼ.る"],
        examples: [
        { word: "曖昧", reading: "あいまい", meaning: "vague, ambiguous, unclear" }
    ],
    },
    "埋": {
        onyomi: ["マイ"],
        kunyomi: ["う.める", "う.まる", "う.もれる", "うず.める", "うず.まる", "い.ける"],
        examples: [
        { word: "埋葬", reading: "まいそう", meaning: "burial" },
        { word: "埋蔵", reading: "まいぞう", meaning: "burying in the ground" },
        { word: "埋没", reading: "まいぼつ", meaning: "being buried" },
        { word: "穴埋め", reading: "あなうめ", meaning: "filling (up) a hole" }
    ],
    },
    "幕": {
        onyomi: ["マク", "バク"],
        kunyomi: ["とばり"],
        examples: [
        { word: "一幕", reading: "ひとまく", meaning: "one act (of a play)" },
        { word: "開幕", reading: "かいまく", meaning: "raising the curtain" },
        { word: "黒幕", reading: "くろまく", meaning: "black curtain" },
        { word: "字幕", reading: "じまく", meaning: "subtitles, captioning" }
    ],
    },
    "膜": {
        onyomi: ["マク"],
        kunyomi: [],
        examples: [
        { word: "角膜", reading: "かくまく", meaning: "cornea" },
        { word: "鼓膜", reading: "こまく", meaning: "eardrum, tympanic membrane" },
        { word: "粘膜", reading: "ねんまく", meaning: "mucous membrane, mucosa" },
        { word: "網膜", reading: "もうまく", meaning: "retina" }
    ],
    },
    "枕": {
        onyomi: ["チン", "シン"],
        kunyomi: ["まくら"],
        examples: [
        { word: "枕", reading: "まくら", meaning: "pillow, bolster" }
    ],
    },
    "又": {
        onyomi: ["ユウ"],
        kunyomi: ["また", "また-", "また.の-"],
        examples: [
        { word: "又は", reading: "または", meaning: "or, either ... or ..." }
    ],
    },
    "末": {
        onyomi: ["マツ", "バツ"],
        kunyomi: ["すえ", "うら", "うれ"],
        examples: [
        { word: "巻末", reading: "かんまつ", meaning: "end of a book" },
        { word: "期末", reading: "きまつ", meaning: "end of term" },
        { word: "結末", reading: "けつまつ", meaning: "end, conclusion" },
        { word: "月末", reading: "げつまつ", meaning: "end of the month" }
    ],
    },
    "抹": {
        onyomi: ["マツ"],
        kunyomi: [],
        examples: [
        { word: "一抹", reading: "いちまつ", meaning: "a touch (of sadness, unease, etc.), a tinge (of), a hint (of)" },
        { word: "抹殺", reading: "まっさつ", meaning: "erasure, obliteration" },
        { word: "抹消", reading: "まっしょう", meaning: "erasure, striking off, crossing out" },
        { word: "抹茶", reading: "まっちゃ", meaning: "matcha, powdered green tea" }
    ],
    },
    "万": {
        onyomi: ["マン", "バン"],
        kunyomi: ["よろず"],
        examples: [
        { word: "十万", reading: "じゅうまん", meaning: "100,000, hundred thousand" },
        { word: "百万", reading: "ひゃくまん", meaning: "1,000,000, one million, million" },
        { word: "万一", reading: "まんいち", meaning: "(unlikely event of) emergency, the worst(-case scenario), 10000 to 1" },
        { word: "万引", reading: "まんびき", meaning: "shoplifting, shoplifter" }
    ],
    },
    "満": {
        onyomi: ["マン", "バン"],
        kunyomi: ["み.ちる", "み.つ", "み.たす"],
        examples: [
        { word: "円満", reading: "えんまん", meaning: "harmonious, peaceful, happy" },
        { word: "干満", reading: "かんまん", meaning: "ebb and flow" },
        { word: "充満", reading: "じゅうまん", meaning: "being filled with, being full of, permeation" },
        { word: "肥満", reading: "ひまん", meaning: "corpulence, fatness, obesity" }
    ],
    },
    "慢": {
        onyomi: ["マン"],
        kunyomi: [],
        examples: [
        { word: "我慢", reading: "がまん", meaning: "endurance, patience, perseverance" },
        { word: "緩慢", reading: "かんまん", meaning: "slow, sluggish, dull" },
        { word: "自慢", reading: "じまん", meaning: "pride (in one's achievements, possessions, etc.), self-praise, boast" },
        { word: "怠慢", reading: "たいまん", meaning: "negligence, neglect, carelessness" }
    ],
    },
    "漫": {
        onyomi: ["マン"],
        kunyomi: ["みだり.に", "そぞ.ろ"],
        examples: [
        { word: "散漫", reading: "さんまん", meaning: "vague, desultory, distracted" },
        { word: "漫画", reading: "まんが", meaning: "cartoon, comic, comic strip" },
        { word: "漫談", reading: "まんだん", meaning: "chat, desultory conversation" },
        { word: "漫才", reading: "まんざい", meaning: "manzai, comic dialogue, two-person comedy act, usu. presented as a fast-paced dialogue, occ. presented as a skit" }
    ],
    },
    "未": {
        onyomi: ["ミ", "ビ"],
        kunyomi: ["いま.だ", "ま.だ", "ひつじ"],
        examples: [
        { word: "未だ", reading: "まだ", meaning: "still, as yet, only" },
        { word: "未開", reading: "みかい", meaning: "uncivilized, uncivilised, primitive" },
        { word: "未決", reading: "みけつ", meaning: "pending, undecided" },
        { word: "未婚", reading: "みこん", meaning: "unmarried, not yet married" }
    ],
    },
    "味": {
        onyomi: ["ミ"],
        kunyomi: ["あじ", "あじ.わう"],
        examples: [
        { word: "意味", reading: "いみ", meaning: "meaning, significance, sense" },
        { word: "塩味", reading: "しおあじ", meaning: "salty taste, saltiness" },
        { word: "加味", reading: "かみ", meaning: "seasoning, flavoring, flavouring" },
        { word: "気味", reading: "きみ", meaning: "sensation, feeling" }
    ],
    },
    "魅": {
        onyomi: ["ミ"],
        kunyomi: [],
        examples: [
        { word: "魅了", reading: "みりょう", meaning: "charm, fascination" },
        { word: "魅力", reading: "みりょく", meaning: "charm, fascination, glamour" },
        { word: "魅惑", reading: "みわく", meaning: "fascination, captivation, charm" },
        { word: "魅力的", reading: "みりょくてき", meaning: "charming, fascinating, attractive" }
    ],
    },
    "岬": {
        onyomi: ["コウ"],
        kunyomi: ["みさき"],
        examples: [
        { word: "岬", reading: "みさき", meaning: "cape (on coast)" }
    ],
    },
    "密": {
        onyomi: ["ミツ"],
        kunyomi: ["ひそ.か"],
        examples: [
        { word: "過密", reading: "かみつ", meaning: "overcrowding, congestion, overpopulation" },
        { word: "機密", reading: "きみつ", meaning: "secrecy, highly classified information" },
        { word: "緊密", reading: "きんみつ", meaning: "rigour, rigor, closeness" },
        { word: "厳密", reading: "げんみつ", meaning: "strict, close, precise" }
    ],
    },
    "蜜": {
        onyomi: ["ミツ", "ビツ"],
        kunyomi: [],
        examples: [
        { word: "蜂蜜", reading: "はちみつ", meaning: "honey" },
        { word: "蜜柑", reading: "みかん", meaning: "mandarin (esp. the satsuma mandarin (Citrus unshiu)), mandarin orange, tangerine" },
        { word: "蜜", reading: "みつ", meaning: "nectar" }
    ],
    },
    "脈": {
        onyomi: ["ミャク"],
        kunyomi: ["すじ"],
        examples: [
        { word: "金脈", reading: "きんみゃく", meaning: "vein of gold" },
        { word: "山脈", reading: "さんみゃく", meaning: "mountain range, mountain belt" },
        { word: "人脈", reading: "じんみゃく", meaning: "personal connections" },
        { word: "静脈", reading: "じょうみゃく", meaning: "vein" }
    ],
    },
    "妙": {
        onyomi: ["ミョウ", "ビョウ"],
        kunyomi: ["たえ"],
        examples: [
        { word: "奇妙", reading: "きみょう", meaning: "strange, odd, peculiar" },
        { word: "軽妙", reading: "けいみょう", meaning: "light and easy, lambent, clever" },
        { word: "巧妙", reading: "こうみょう", meaning: "ingenious, skillful, clever" },
        { word: "神妙", reading: "しんみょう", meaning: "meek, quiet, docile" }
    ],
    },
    "民": {
        onyomi: ["ミン"],
        kunyomi: ["たみ"],
        examples: [
        { word: "移民", reading: "いみん", meaning: "immigration, emigration" },
        { word: "区民", reading: "くみん", meaning: "ward residents" },
        { word: "県民", reading: "けんみん", meaning: "resident of a prefecture, citizen of a prefecture" },
        { word: "公民", reading: "こうみん", meaning: "citizen" }
    ],
    },
    "眠": {
        onyomi: ["ミン"],
        kunyomi: ["ねむ.る", "ねむ.い"],
        examples: [
        { word: "安眠", reading: "あんみん", meaning: "sound sleep, good sleep, quiet sleep" },
        { word: "催眠", reading: "さいみん", meaning: "hypnosis" },
        { word: "睡眠", reading: "すいみん", meaning: "sleep" },
        { word: "冬眠", reading: "とうみん", meaning: "hibernation, winter sleep, brumation" }
    ],
    },
    "矛": {
        onyomi: ["ム", "ボウ"],
        kunyomi: ["ほこ"],
        examples: [
        { word: "矛盾", reading: "むじゅん", meaning: "contradiction, inconsistency" },
        { word: "矛先", reading: "ほこさき", meaning: "point of a spear, spearhead" },
        { word: "矛", reading: "ほこ", meaning: "long-handled Chinese spear, lance, pike" }
    ],
    },
    "務": {
        onyomi: ["ム"],
        kunyomi: ["つと.める"],
        examples: [
        { word: "外務", reading: "がいむ", meaning: "foreign affairs" },
        { word: "義務", reading: "ぎむ", meaning: "duty, obligation, responsibility" },
        { word: "急務", reading: "きゅうむ", meaning: "urgent business, pressing need, imperative" },
        { word: "教務", reading: "きょうむ", meaning: "academic affairs, educational affairs, school affairs" }
    ],
    },
    "無": {
        onyomi: ["ム", "ブ"],
        kunyomi: ["な.い"],
        examples: [
        { word: "皆無", reading: "かいむ", meaning: "nonexistent, nil, none" },
        { word: "虚無", reading: "きょむ", meaning: "nihility, nothingness" },
        { word: "無い", reading: "ない", meaning: "nonexistent, not being (there)" },
        { word: "無し", reading: "なし", meaning: "without" }
    ],
    },
    "夢": {
        onyomi: ["ム", "ボウ"],
        kunyomi: ["ゆめ", "ゆめ.みる", "くら.い"],
        examples: [
        { word: "悪夢", reading: "あくむ", meaning: "nightmare, bad dream" },
        { word: "初夢", reading: "はつゆめ", meaning: "first dream of the New year (believed to foretell one's luck)" },
        { word: "夢幻", reading: "むげん", meaning: "dreams, fantasy, visions" },
        { word: "夢想", reading: "むそう", meaning: "dream, vision, reverie" }
    ],
    },
    "霧": {
        onyomi: ["ム", "ボウ", "ブ"],
        kunyomi: ["きり"],
        examples: [
        { word: "朝霧", reading: "あさぎり", meaning: "morning fog, morning mist" },
        { word: "濃霧", reading: "のうむ", meaning: "heavy fog, dense fog, thick fog" },
        { word: "霧雨", reading: "きりさめ", meaning: "drizzle, light rain" },
        { word: "夕霧", reading: "ゆうぎり", meaning: "evening mist" }
    ],
    },
    "娘": {
        onyomi: ["ジョウ"],
        kunyomi: ["むすめ", "こ"],
        examples: [
        { word: "孫娘", reading: "まごむすめ", meaning: "granddaughter" },
        { word: "娘婿", reading: "むすめむこ", meaning: "son-in-law" },
        { word: "一人娘", reading: "ひとりむすめ", meaning: "only daughter" },
        { word: "娘", reading: "むすめ", meaning: "daughter" }
    ],
    },
    "名": {
        onyomi: ["メイ", "ミョウ"],
        kunyomi: ["な", "-な"],
        examples: [
        { word: "異名", reading: "いみょう", meaning: "another name, nickname, alias" },
        { word: "汚名", reading: "おめい", meaning: "bad name, bad reputation, disgrace" },
        { word: "改名", reading: "かいめい", meaning: "name change" },
        { word: "芸名", reading: "げいめい", meaning: "stage name" }
    ],
    },
    "命": {
        onyomi: ["メイ", "ミョウ"],
        kunyomi: ["いのち"],
        examples: [
        { word: "運命", reading: "うんめい", meaning: "fate, destiny, lot" },
        { word: "延命", reading: "えんめい", meaning: "keeping alive longer, prolonging life, life extension" },
        { word: "革命", reading: "かくめい", meaning: "revolution" },
        { word: "救命", reading: "きゅうめい", meaning: "lifesaving" }
    ],
    },
    "明": {
        onyomi: ["メイ", "ミョウ", "ミン"],
        kunyomi: ["あ.かり", "あか.るい", "あか.るむ", "あか.らむ", "あき.らか", "あ.ける", "-あ.け", "あ.く", "あ.くる", "あ.かす"],
        examples: [
        { word: "明白", reading: "めいはく", meaning: "obvious, clear, plain" },
        { word: "解明", reading: "かいめい", meaning: "elucidation, explication, explaining" },
        { word: "究明", reading: "きゅうめい", meaning: "investigation (esp. in academic and scientific contexts), finding out the facts, bringing (a matter) to light" },
        { word: "賢明", reading: "けんめい", meaning: "wise, sensible, well-advised" }
    ],
    },
    "迷": {
        onyomi: ["メイ"],
        kunyomi: ["まよ.う"],
        examples: [
        { word: "混迷", reading: "こんめい", meaning: "turmoil, chaos, confusion" },
        { word: "低迷", reading: "ていめい", meaning: "hanging low (of clouds)" },
        { word: "迷う", reading: "まよう", meaning: "to lose one's way, to get lost, to go astray" },
        { word: "迷宮", reading: "めいきゅう", meaning: "labyrinth, maze" }
    ],
    },
    "冥": {
        onyomi: ["メイ", "ミョウ"],
        kunyomi: ["くら.い"],
        examples: [
        { word: "冥福", reading: "めいふく", meaning: "happiness in the next world, heavenly bliss, repose of one's soul" }
    ],
    },
    "盟": {
        onyomi: ["メイ"],
        kunyomi: [],
        examples: [
        { word: "加盟", reading: "かめい", meaning: "joining (an association, agreement, etc.), participation, affiliation" },
        { word: "盟主", reading: "めいしゅ", meaning: "leader (of an alliance), leading power" },
        { word: "盟約", reading: "めいやく", meaning: "oath, pledge, pact" },
        { word: "盟友", reading: "めいゆう", meaning: "sworn friend" }
    ],
    },
    "銘": {
        onyomi: ["メイ"],
        kunyomi: [],
        examples: [
        { word: "感銘", reading: "かんめい", meaning: "deep impression, being deeply moved, being deeply touched" },
        { word: "銘々", reading: "めいめい", meaning: "each, individual" },
        { word: "銘記", reading: "めいき", meaning: "keep in mind, take note of, remember" },
        { word: "銘柄", reading: "めいがら", meaning: "brand, make, description" }
    ],
    },
    "鳴": {
        onyomi: ["メイ"],
        kunyomi: ["な.く", "な.る", "な.らす"],
        examples: [
        { word: "共鳴", reading: "きょうめい", meaning: "resonance" },
        { word: "悲鳴", reading: "ひめい", meaning: "shriek, scream" },
        { word: "鳴く", reading: "なく", meaning: "to make sound (of an animal), to call, to cry" },
        { word: "鳴る", reading: "なる", meaning: "to sound, to ring, to resound" }
    ],
    },
    "滅": {
        onyomi: ["メツ"],
        kunyomi: ["ほろ.びる", "ほろ.ぶ", "ほろ.ぼす"],
        examples: [
        { word: "隠滅", reading: "いんめつ", meaning: "destruction (esp. of evidence), spoliation, suppression" },
        { word: "壊滅", reading: "かいめつ", meaning: "(complete) destruction, annihilation, devastation" },
        { word: "幻滅", reading: "げんめつ", meaning: "disillusionment, disillusion, disenchantment" },
        { word: "自滅", reading: "じめつ", meaning: "self-destruction, ruining oneself" }
    ],
    },
    "免": {
        onyomi: ["メン"],
        kunyomi: ["まぬか.れる", "まぬが.れる"],
        examples: [
        { word: "減免", reading: "げんめん", meaning: "reduction and exemption (e.g. taxes), mitigation and remission (e.g. in criminal law)" },
        { word: "御免", reading: "ごめん", meaning: "I'm sorry, my apologies, excuse me" },
        { word: "ご免", reading: "ごめん", meaning: "I'm sorry, my apologies, excuse me" },
        { word: "赦免", reading: "しゃめん", meaning: "pardon, remission, amnesty" }
    ],
    },
    "面": {
        onyomi: ["メン", "ベン"],
        kunyomi: ["おも", "おもて", "つら"],
        examples: [
        { word: "一面", reading: "いちめん", meaning: "one face, one surface" },
        { word: "仮面", reading: "かめん", meaning: "mask" },
        { word: "画面", reading: "がめん", meaning: "screen (of a TV, computer, etc.)" },
        { word: "海面", reading: "かいめん", meaning: "sea level, (surface of) sea" }
    ],
    },
    "綿": {
        onyomi: ["メン"],
        kunyomi: ["わた"],
        examples: [
        { word: "綿布", reading: "めんぷ", meaning: "cotton cloth, cotton material" },
        { word: "綿密", reading: "めんみつ", meaning: "minute, detailed, careful" },
        { word: "木綿", reading: "もめん", meaning: "cotton (material)" },
        { word: "綿", reading: "めん", meaning: "cotton" }
    ],
    },
    "麺": {
        onyomi: ["メン", "ベン"],
        kunyomi: ["むぎこ"],
        examples: [
        { word: "麺", reading: "めん", meaning: "noodles" }
    ],
    },
    "茂": {
        onyomi: ["モ"],
        kunyomi: ["しげ.る"],
        examples: [
        { word: "繁茂", reading: "はんも", meaning: "flourishing (of plants), thriving, luxuriant growth" },
        { word: "茂る", reading: "しげる", meaning: "to grow thickly, to be in full leaf, to be rampant" }
    ],
    },
    "模": {
        onyomi: ["モ", "ボ"],
        kunyomi: [],
        examples: [
        { word: "規模", reading: "きぼ", meaning: "scale, scope, plan" },
        { word: "模擬", reading: "もぎ", meaning: "imitation" },
        { word: "模型", reading: "もけい", meaning: "model, dummy, maquette" },
        { word: "模索", reading: "もさく", meaning: "groping (for), fumbling around (for), searching (for an answer, solution, etc.)" }
    ],
    },
    "毛": {
        onyomi: ["モウ"],
        kunyomi: ["け"],
        examples: [
        { word: "羽毛", reading: "うもう", meaning: "feather, plume, plumage" },
        { word: "眉毛", reading: "まゆげ", meaning: "eyebrow" },
        { word: "不毛", reading: "ふもう", meaning: "barren, sterile, infertile" },
        { word: "毛糸", reading: "けいと", meaning: "knitting wool, woolen yarn, woollen yarn" }
    ],
    },
    "妄": {
        onyomi: ["モウ", "ボウ"],
        kunyomi: ["みだ.りに"],
        examples: [
        { word: "妄想", reading: "もうそう", meaning: "delusion, wild idea, (wild) fancy" }
    ],
    },
    "盲": {
        onyomi: ["モウ"],
        kunyomi: ["めくら"],
        examples: [
        { word: "盲人", reading: "もうじん", meaning: "blind person" },
        { word: "盲腸", reading: "もうちょう", meaning: "cecum, caecum, blind gut" },
        { word: "盲点", reading: "もうてん", meaning: "blind spot (on the retina)" },
        { word: "盲目", reading: "もうもく", meaning: "blindness" }
    ],
    },
    "耗": {
        onyomi: ["モウ", "コウ"],
        kunyomi: [],
        examples: [
        { word: "消耗", reading: "しょうもう", meaning: "exhaustion, consumption, using up" },
        { word: "消耗品", reading: "しょうもうひん", meaning: "consumable goods" },
        { word: "心神耗弱", reading: "しんしんこうじゃく", meaning: "diminished capacity, diminished responsibility" }
    ],
    },
    "猛": {
        onyomi: ["モウ"],
        kunyomi: [],
        examples: [
        { word: "猛威", reading: "もうい", meaning: "fury, power, menace" },
        { word: "猛攻", reading: "もうこう", meaning: "fierce attack" },
        { word: "猛獣", reading: "もうじゅう", meaning: "fierce animal, beast of prey, big game" },
        { word: "猛暑", reading: "もうしょ", meaning: "heat wave, fierce heat" }
    ],
    },
    "網": {
        onyomi: ["モウ"],
        kunyomi: ["あみ"],
        examples: [
        { word: "金網", reading: "かなあみ", meaning: "wire netting, wire mesh, wire gauze" },
        { word: "網戸", reading: "あみど", meaning: "window screen, insect screen, mosquito screen" },
        { word: "網膜", reading: "もうまく", meaning: "retina" },
        { word: "網羅", reading: "もうら", meaning: "encompassing, covering (exhaustively), including (all of)" }
    ],
    },
    "目": {
        onyomi: ["モク", "ボク"],
        kunyomi: ["め", "-め", "ま-"],
        examples: [
        { word: "一目", reading: "ひとめ", meaning: "glance, look, glimpse" },
        { word: "羽目", reading: "はめ", meaning: "panel, wainscoting, wainscotting" },
        { word: "演目", reading: "えんもく", meaning: "program (musical, concert, theatrical, etc.), programme" },
        { word: "横目", reading: "よこめ", meaning: "sidelong glance" }
    ],
    },
    "黙": {
        onyomi: ["モク", "ボク"],
        kunyomi: ["だま.る", "もだ.す"],
        examples: [
        { word: "暗黙", reading: "あんもく", meaning: "tacit, unspoken, implicit" },
        { word: "寡黙", reading: "かもく", meaning: "untalkative, quiet, taciturn" },
        { word: "沈黙", reading: "ちんもく", meaning: "silence, being silent, quiet" },
        { word: "黙る", reading: "だまる", meaning: "to be silent, to say nothing" }
    ],
    },
    "門": {
        onyomi: ["モン"],
        kunyomi: ["かど", "と"],
        examples: [
        { word: "一門", reading: "いちもん", meaning: "family, clan, kin" },
        { word: "関門", reading: "かんもん", meaning: "barrier, checkpoint, gateway" },
        { word: "校門", reading: "こうもん", meaning: "school gate" },
        { word: "宗門", reading: "しゅうもん", meaning: "(religious) denomination, sect" }
    ],
    },
    "紋": {
        onyomi: ["モン"],
        kunyomi: [],
        examples: [
        { word: "指紋", reading: "しもん", meaning: "fingerprint" },
        { word: "波紋", reading: "はもん", meaning: "ripple, ring on the water" },
        { word: "紋章", reading: "もんしょう", meaning: "crest, coat of arms" },
        { word: "紋切り型", reading: "もんきりがた", meaning: "formulaic, stereotyped, hackneyed" }
    ],
    },
    "問": {
        onyomi: ["モン"],
        kunyomi: ["と.う", "と.い", "とん"],
        examples: [
        { word: "慰問", reading: "いもん", meaning: "visit to console someone, giving comfort (to the sick, injured, etc.), expressing condolences (sympathy, concern, etc.)" },
        { word: "学問", reading: "がくもん", meaning: "study, scholarship, learning" },
        { word: "喚問", reading: "かんもん", meaning: "summons" },
        { word: "疑問", reading: "ぎもん", meaning: "doubt, question, suspicion" }
    ],
    },
    "冶": {
        onyomi: ["ヤ"],
        kunyomi: ["い.る"],
        examples: [
        { word: "冶具", reading: "ジグ", meaning: "jig (tool)" },
        { word: "鍛冶", reading: "かじ", meaning: "blacksmithing, forging, smithery" },
        { word: "冶金", reading: "やきん", meaning: "metallurgy" },
        { word: "冶工", reading: "やこう", meaning: "metallurgical worker" }
    ],
    },
    "夜": {
        onyomi: ["ヤ"],
        kunyomi: ["よ", "よる"],
        examples: [
        { word: "月夜", reading: "つきよ", meaning: "moonlit night" },
        { word: "今夜", reading: "こんや", meaning: "this evening, tonight" },
        { word: "深夜", reading: "しんや", meaning: "late at night" },
        { word: "前夜", reading: "ぜんや", meaning: "last night, the previous night" }
    ],
    },
    "野": {
        onyomi: ["ヤ", "ショ"],
        kunyomi: ["の", "の-"],
        examples: [
        { word: "下野", reading: "げや", meaning: "resigning from (public) office" },
        { word: "外野", reading: "がいや", meaning: "outfield" },
        { word: "原野", reading: "げんや", meaning: "waste land, wilderness, moor" },
        { word: "視野", reading: "しや", meaning: "field of vision, view" }
    ],
    },
    "弥": {
        onyomi: ["ミ", "ビ"],
        kunyomi: ["や", "いや", "いよ.いよ", "わた.る"],
        examples: [
        { word: "弥生", reading: "やよい", meaning: "third month of the lunar calendar" },
        { word: "阿弥陀", reading: "あみだ", meaning: "Amitabha (Buddha), Amida" }
    ],
    },
    "厄": {
        onyomi: ["ヤク"],
        kunyomi: [],
        examples: [
        { word: "厄介", reading: "やっかい", meaning: "trouble, burden, nuisance" },
        { word: "厄年", reading: "やくどし", meaning: "unlucky year, critical year, year (esp. age 25 and 42 for men, 19 and 33 for women) that is considered unlucky (orig. in Onmyōdō)" },
        { word: "厄", reading: "やく", meaning: "misfortune, bad luck, evil" }
    ],
    },
    "役": {
        onyomi: ["ヤク", "エキ"],
        kunyomi: [],
        examples: [
        { word: "悪役", reading: "あくやく", meaning: "villain, baddie, the villain's part" },
        { word: "現役", reading: "げんえき", meaning: "active duty, active service" },
        { word: "三役", reading: "さんやく", meaning: "three highest ranks (wrestling, unions, etc.)" },
        { word: "主役", reading: "しゅやく", meaning: "leading part, leading actor, leading actress" }
    ],
    },
    "約": {
        onyomi: ["ヤク"],
        kunyomi: ["つづ.まる", "つづ.める", "つづま.やか"],
        examples: [
        { word: "解約", reading: "かいやく", meaning: "cancellation of a contract" },
        { word: "確約", reading: "かくやく", meaning: "firm promise, definite promise" },
        { word: "規約", reading: "きやく", meaning: "agreement, rules, code" },
        { word: "旧約", reading: "きゅうやく", meaning: "old promise, old agreement, old covenant" }
    ],
    },
    "訳": {
        onyomi: ["ヤク"],
        kunyomi: ["わけ"],
        examples: [
        { word: "英訳", reading: "えいやく", meaning: "English translation" },
        { word: "全訳", reading: "ぜんやく", meaning: "complete translation" },
        { word: "通訳", reading: "つうやく", meaning: "interpretation (i.e. oral translation)" },
        { word: "内訳", reading: "うちわけ", meaning: "itemization (of expenses), the items, breakdown" }
    ],
    },
    "薬": {
        onyomi: ["ヤク"],
        kunyomi: ["くすり"],
        examples: [
        { word: "医薬", reading: "いやく", meaning: "medicine, (pharmaceutical) drug, medical treatment" },
        { word: "火薬", reading: "かやく", meaning: "gunpowder, powder" },
        { word: "劇薬", reading: "げきやく", meaning: "powerful medicine, strong poison" },
        { word: "試薬", reading: "しやく", meaning: "reagent" }
    ],
    },
    "躍": {
        onyomi: ["ヤク"],
        kunyomi: ["おど.る"],
        examples: [
        { word: "一躍", reading: "いちやく", meaning: "suddenly (rising to fame, etc.), instantly, immediately" },
        { word: "活躍", reading: "かつやく", meaning: "activity (esp. energetic or successful), great efforts, active participation" },
        { word: "跳躍", reading: "ちょうやく", meaning: "jump, leap, skip" },
        { word: "飛躍", reading: "ひやく", meaning: "leap, jump" }
    ],
    },
    "闇": {
        onyomi: ["アン", "オン"],
        kunyomi: ["やみ", "くら.い"],
        examples: [
        { word: "暗闇", reading: "くらやみ", meaning: "darkness, the dark" },
        { word: "無闇に", reading: "むやみに", meaning: "thoughtlessly, recklessly, rashly" },
        { word: "闇", reading: "やみ", meaning: "darkness, the dark" }
    ],
    },
    "由": {
        onyomi: ["ユ", "ユウ", "ユイ"],
        kunyomi: ["よし", "よ.る"],
        examples: [
        { word: "経由", reading: "けいゆ", meaning: "going through, going via, going by way of" },
        { word: "事由", reading: "じゆう", meaning: "reason, cause, whys and wherefores" },
        { word: "自由", reading: "じゆう", meaning: "freedom, liberty" },
        { word: "由緒", reading: "ゆいしょ", meaning: "history, pedigree, lineage" }
    ],
    },
    "油": {
        onyomi: ["ユ", "ユウ"],
        kunyomi: ["あぶら"],
        examples: [
        { word: "給油", reading: "きゅうゆ", meaning: "refueling (a car, plane, etc.)" },
        { word: "軽油", reading: "けいゆ", meaning: "diesel oil, diesel fuel, gas oil" },
        { word: "原油", reading: "げんゆ", meaning: "crude oil" },
        { word: "重油", reading: "じゅうゆ", meaning: "heavy oil, fuel oil" }
    ],
    },
    "喩": {
        onyomi: ["ユ"],
        kunyomi: ["たと.える", "さと.す"],
        examples: [
        { word: "比喩", reading: "ひゆ", meaning: "simile, metaphor, allegory" }
    ],
    },
    "愉": {
        onyomi: ["ユ"],
        kunyomi: ["たの.しい", "たの.しむ"],
        examples: [
        { word: "愉快", reading: "ゆかい", meaning: "pleasant, delightful, enjoyable" },
        { word: "不愉快", reading: "ふゆかい", meaning: "unpleasant, disagreeable, displeasing" }
    ],
    },
    "諭": {
        onyomi: ["ユ"],
        kunyomi: ["さと.す"],
        examples: [
        { word: "教諭", reading: "きょうゆ", meaning: "(licensed) teacher" },
        { word: "諭す", reading: "さとす", meaning: "to make (someone) understand (a fault, mistake, etc.), to reason with, to advise" }
    ],
    },
    "輸": {
        onyomi: ["ユ", "シュ"],
        kunyomi: [],
        examples: [
        { word: "運輸", reading: "うんゆ", meaning: "transportation" },
        { word: "禁輸", reading: "きんゆ", meaning: "embargo" },
        { word: "空輸", reading: "くうゆ", meaning: "air transport, air lift, airlift" },
        { word: "密輸", reading: "みつゆ", meaning: "smuggling, contraband trade" }
    ],
    },
    "癒": {
        onyomi: ["ユ"],
        kunyomi: ["い.える", "いや.す", "い.やす"],
        examples: [
        { word: "治癒", reading: "ちゆ", meaning: "healing, cure, recovery" },
        { word: "癒着", reading: "ゆちゃく", meaning: "adhesion, conglutination, accretion" }
    ],
    },
    "唯": {
        onyomi: ["ユイ", "イ"],
        kunyomi: ["ただ"],
        examples: [
        { word: "唯一", reading: "ゆいいつ", meaning: "only, sole, unique" },
        { word: "唯物論", reading: "ゆいぶつろん", meaning: "materialism" }
    ],
    },
    "友": {
        onyomi: ["ユウ"],
        kunyomi: ["とも"],
        examples: [
        { word: "学友", reading: "がくゆう", meaning: "school friend" },
        { word: "交友", reading: "こうゆう", meaning: "friend, companion, acquaintance" },
        { word: "親友", reading: "しんゆう", meaning: "close friend, bosom friend, buddy" },
        { word: "盟友", reading: "めいゆう", meaning: "sworn friend" }
    ],
    },
    "有": {
        onyomi: ["ユウ", "ウ"],
        kunyomi: ["あ.る"],
        examples: [
        { word: "含有", reading: "がんゆう", meaning: "containing (an ingredient, mineral, etc.)" },
        { word: "共有", reading: "きょうゆう", meaning: "joint ownership, co-ownership, sharing (e.g. a viewpoint)" },
        { word: "固有", reading: "こゆう", meaning: "characteristic (of), peculiar (to), inherent (in)" },
        { word: "公有", reading: "こうゆう", meaning: "public ownership" }
    ],
    },
    "勇": {
        onyomi: ["ユウ"],
        kunyomi: ["いさ.む"],
        examples: [
        { word: "蛮勇", reading: "ばんゆう", meaning: "foolhardiness, recklessness, savage valour" },
        { word: "武勇", reading: "ぶゆう", meaning: "bravery, military prowess, valour" },
        { word: "勇む", reading: "いさむ", meaning: "to be in high spirits, to be encouraged, to be lively" },
        { word: "勇敢", reading: "ゆうかん", meaning: "brave, courageous, gallant" }
    ],
    },
    "幽": {
        onyomi: ["ユウ"],
        kunyomi: ["ふか.い", "かす.か", "くら.い", "しろ.い"],
        examples: [
        { word: "幽閉", reading: "ゆうへい", meaning: "confinement, imprisonment, incarceration" },
        { word: "幽霊", reading: "ゆうれい", meaning: "ghost, specter, spectre" }
    ],
    },
    "悠": {
        onyomi: ["ユウ"],
        kunyomi: [],
        examples: [
        { word: "悠久", reading: "ゆうきゅう", meaning: "eternal, everlasting, perpetual" },
        { word: "悠長", reading: "ゆうちょう", meaning: "leisurely, slow, deliberate" },
        { word: "悠々", reading: "ゆうゆう", meaning: "quiet, calm, leisurely" }
    ],
    },
    "郵": {
        onyomi: ["ユウ"],
        kunyomi: [],
        examples: [
        { word: "郵送", reading: "ゆうそう", meaning: "mailing, posting" },
        { word: "郵便", reading: "ゆうびん", meaning: "mail service, postal service, mail" },
        { word: "郵政", reading: "ゆうせい", meaning: "postal system" },
        { word: "郵貯", reading: "ゆうちょ", meaning: "postal (post-office) savings (deposit)" }
    ],
    },
    "湧": {
        onyomi: ["ユウ", "ヨウ", "ユ"],
        kunyomi: ["わ.く"],
        examples: [
        { word: "湧く", reading: "わく", meaning: "to well (up), to gush out (of water), to spring out" },
        { word: "湧水", reading: "ゆうすい", meaning: "welling of water, spring water, spring" }
    ],
    },
    "猶": {
        onyomi: ["ユウ", "ユ"],
        kunyomi: ["なお"],
        examples: [
        { word: "猶予", reading: "ゆうよ", meaning: "postponement, deferment, extension (of time)" },
        { word: "執行猶予", reading: "しっこうゆうよ", meaning: "stay of execution, suspended sentence" },
        { word: "起訴猶予", reading: "きそゆうよ", meaning: "suspension of indictment, leaving charge on the file" }
    ],
    },
    "裕": {
        onyomi: ["ユウ"],
        kunyomi: [],
        examples: [
        { word: "富裕", reading: "ふゆう", meaning: "wealthy, rich, affluent" },
        { word: "裕福", reading: "ゆうふく", meaning: "wealthy, rich, affluent" },
        { word: "余裕", reading: "よゆう", meaning: "surplus, margin, leeway" }
    ],
    },
    "遊": {
        onyomi: ["ユウ", "ユ"],
        kunyomi: ["あそ.ぶ", "あそ.ばす"],
        examples: [
        { word: "外遊", reading: "がいゆう", meaning: "foreign travel" },
        { word: "周遊", reading: "しゅうゆう", meaning: "(circular) tour, round trip, excursion" },
        { word: "遊び", reading: "あそび", meaning: "play, playing, game" },
        { word: "遊ぶ", reading: "あそぶ", meaning: "to play (games, sports), to enjoy oneself, to have a good time" }
    ],
    },
    "雄": {
        onyomi: ["ユウ"],
        kunyomi: ["お-", "おす", "おん"],
        examples: [
        { word: "英雄", reading: "えいゆう", meaning: "hero, heroine, great person" },
        { word: "雌雄", reading: "しゆう", meaning: "male and female (animals), the two sexes" },
        { word: "雄大", reading: "ゆうだい", meaning: "grand, magnificent, majestic" },
        { word: "雄弁", reading: "ゆうべん", meaning: "eloquence, fluency (of speech)" }
    ],
    },
    "誘": {
        onyomi: ["ユウ"],
        kunyomi: ["さそ.う", "いざな.う"],
        examples: [
        { word: "勧誘", reading: "かんゆう", meaning: "invitation, solicitation, canvassing" },
        { word: "誘い", reading: "さそい", meaning: "invitation, introduction" },
        { word: "誘う", reading: "さそう", meaning: "to invite, to ask (someone to do), to call (for)" },
        { word: "誘因", reading: "ゆういん", meaning: "contributing cause, exciting cause, incentive" }
    ],
    },
    "憂": {
        onyomi: ["ユウ"],
        kunyomi: ["うれ.える", "うれ.い", "う.い", "う.き"],
        examples: [
        { word: "憂い", reading: "うれい", meaning: "sorrow, grief, anguish" },
        { word: "憂国", reading: "ゆうこく", meaning: "patriotic concern for the future of one's country" },
        { word: "憂慮", reading: "ゆうりょ", meaning: "anxiety, concern, fear" },
        { word: "憂鬱", reading: "ゆううつ", meaning: "depression, melancholy, dejection" }
    ],
    },
    "融": {
        onyomi: ["ユウ"],
        kunyomi: ["と.ける", "と.かす"],
        examples: [
        { word: "金融", reading: "きんゆう", meaning: "finance, financing, credit transacting" },
        { word: "融合", reading: "ゆうごう", meaning: "agglutination, adhesion, fusion" },
        { word: "融資", reading: "ゆうし", meaning: "financing, loan" },
        { word: "融通", reading: "ゆうずう", meaning: "lending (money, commodities, etc.), finance, loan" }
    ],
    },
    "優": {
        onyomi: ["ユウ", "ウ"],
        kunyomi: ["やさ.しい", "すぐ.れる", "まさ.る"],
        examples: [
        { word: "女優", reading: "じょゆう", meaning: "actress, female actor" },
        { word: "男優", reading: "だんゆう", meaning: "(male) actor" },
        { word: "俳優", reading: "はいゆう", meaning: "actor, actress, player" },
        { word: "優位", reading: "ゆうい", meaning: "predominance, superiority, ascendancy" }
    ],
    },
    "与": {
        onyomi: ["ヨ"],
        kunyomi: ["あた.える", "あずか.る", "くみ.する", "ともに"],
        examples: [
        { word: "関与", reading: "かんよ", meaning: "participation, taking part in, participating in" },
        { word: "寄与", reading: "きよ", meaning: "contribution, service" },
        { word: "給与", reading: "きゅうよ", meaning: "pay, salary, wages" },
        { word: "供与", reading: "きょうよ", meaning: "giving, provision, furnishing" }
    ],
    },
    "予": {
        onyomi: ["ヨ", "シャ"],
        kunyomi: ["あらかじ.め"],
        examples: [
        { word: "猶予", reading: "ゆうよ", meaning: "postponement, deferment, extension (of time)" },
        { word: "予て", reading: "かねて", meaning: "previously, already, for some time" },
        { word: "予め", reading: "あらかじめ", meaning: "beforehand, in advance, ahead of time" },
        { word: "予感", reading: "よかん", meaning: "presentiment, premonition, hunch" }
    ],
    },
    "余": {
        onyomi: ["ヨ"],
        kunyomi: ["あま.る", "あま.り", "あま.す", "あんま.り"],
        examples: [
        { word: "余す", reading: "あます", meaning: "to save, to leave over, to spare" },
        { word: "余る", reading: "あまる", meaning: "to remain, to be left over, to be in excess" },
        { word: "余韻", reading: "よいん", meaning: "reverberation, swelling (of a hymn), trailing note" },
        { word: "余暇", reading: "よか", meaning: "leisure, leisure time, spare time" }
    ],
    },
    "誉": {
        onyomi: ["ヨ"],
        kunyomi: ["ほま.れ", "ほ.める"],
        examples: [
        { word: "栄誉", reading: "えいよ", meaning: "honour, honor" },
        { word: "名誉", reading: "めいよ", meaning: "honor, honour, credit" },
        { word: "誉れ", reading: "ほまれ", meaning: "honour, honor, glory" },
        { word: "名誉職", reading: "めいよしょく", meaning: "honorary position" }
    ],
    },
    "預": {
        onyomi: ["ヨ"],
        kunyomi: ["あず.ける", "あず.かる"],
        examples: [
        { word: "預金", reading: "よきん", meaning: "deposit, bank account" },
        { word: "預託", reading: "よたく", meaning: "depositing (of money, valuables, etc.), deposition" },
        { word: "預かり", reading: "あずかり", meaning: "safekeeping, temporary custody, keeping in one's care" },
        { word: "預かる", reading: "あずかる", meaning: "to look after, to take care of, to keep" }
    ],
    },
    "幼": {
        onyomi: ["ヨウ"],
        kunyomi: ["おさな.い"],
        examples: [
        { word: "幼い", reading: "おさない", meaning: "very young, little" },
        { word: "幼子", reading: "おさなご", meaning: "infant, baby, little child" },
        { word: "幼児", reading: "ようじ", meaning: "young child, toddler" },
        { word: "幼少", reading: "ようしょう", meaning: "infancy, childhood, tender age" }
    ],
    },
    "用": {
        onyomi: ["ヨウ"],
        kunyomi: ["もち.いる"],
        examples: [
        { word: "愛用", reading: "あいよう", meaning: "favorite, favourite, habitually used" },
        { word: "悪用", reading: "あくよう", meaning: "abuse, misuse, perversion" },
        { word: "引用", reading: "いんよう", meaning: "quotation, citation, reference" },
        { word: "運用", reading: "うんよう", meaning: "making use of, application, practical use" }
    ],
    },
    "羊": {
        onyomi: ["ヨウ"],
        kunyomi: ["ひつじ"],
        examples: [
        { word: "羊肉", reading: "ようにく", meaning: "mutton, lamb (meat)" },
        { word: "羊毛", reading: "ようもう", meaning: "wool" },
        { word: "子羊", reading: "こひつじ", meaning: "lamb" },
        { word: "小羊", reading: "こひつじ", meaning: "lamb" }
    ],
    },
    "妖": {
        onyomi: ["ヨウ"],
        kunyomi: ["あや.しい", "なま.めく", "わざわ.い"],
        examples: [
        { word: "妖怪", reading: "ようかい", meaning: "ghost, apparition, phantom" },
        { word: "妖精", reading: "ようせい", meaning: "fairy, sprite, elf" }
    ],
    },
    "洋": {
        onyomi: ["ヨウ"],
        kunyomi: [],
        examples: [
        { word: "海洋", reading: "かいよう", meaning: "ocean, sea" },
        { word: "西洋", reading: "せいよう", meaning: "the West, the Occident, Western countries" },
        { word: "東洋", reading: "とうよう", meaning: "the East, the Orient, (East) Asia" },
        { word: "洋画", reading: "ようが", meaning: "Western painting" }
    ],
    },
    "要": {
        onyomi: ["ヨウ"],
        kunyomi: ["い.る", "かなめ"],
        examples: [
        { word: "概要", reading: "がいよう", meaning: "outline, summary, overview" },
        { word: "肝要", reading: "かんよう", meaning: "extremely important, essential, vital" },
        { word: "強要", reading: "きょうよう", meaning: "coercion, extortion, compulsion" },
        { word: "主要", reading: "しゅよう", meaning: "chief, main, principal" }
    ],
    },
    "容": {
        onyomi: ["ヨウ"],
        kunyomi: ["い.れる"],
        examples: [
        { word: "寛容", reading: "かんよう", meaning: "tolerance, open-mindedness, forbearance" },
        { word: "許容", reading: "きょよう", meaning: "permission, allowance, acceptance" },
        { word: "形容", reading: "けいよう", meaning: "description, expression (in words), qualification (e.g. of a noun with an adjective)" },
        { word: "受容", reading: "じゅよう", meaning: "reception" }
    ],
    },
    "庸": {
        onyomi: ["ヨウ"],
        kunyomi: [],
        examples: [
        { word: "凡庸", reading: "ぼんよう", meaning: "mediocre, ordinary, commonplace" }
    ],
    },
    "揚": {
        onyomi: ["ヨウ"],
        kunyomi: ["あ.げる", "-あ.げ", "あ.がる"],
        examples: [
        { word: "掲揚", reading: "けいよう", meaning: "hoisting (e.g. a flag), raising, flying" },
        { word: "高揚", reading: "こうよう", meaning: "elevation (of spirits), raising (of morale), uplift" },
        { word: "浮揚", reading: "ふよう", meaning: "floating (e.g. in air, water), floatation, buoyancy" },
        { word: "揚げ", reading: "あげ", meaning: "deep-frying, deep-fried food" }
    ],
    },
    "揺": {
        onyomi: ["ヨウ"],
        kunyomi: ["ゆ.れる", "ゆ.る", "ゆ.らぐ", "ゆ.るぐ", "ゆ.する", "ゆ.さぶる", "ゆ.すぶる", "うご.く"],
        examples: [
        { word: "動揺", reading: "どうよう", meaning: "shaking, trembling, pitching" },
        { word: "揺る", reading: "ゆる", meaning: "to shake, to jolt, to rock (cradle)" },
        { word: "揺らぐ", reading: "ゆらぐ", meaning: "to swing, to sway, to shake" },
        { word: "揺るぐ", reading: "ゆるぐ", meaning: "to shake, to waver, to tremble" }
    ],
    },
    "葉": {
        onyomi: ["ヨウ"],
        kunyomi: ["は"],
        examples: [
        { word: "言葉", reading: "ことば", meaning: "language, dialect" },
        { word: "若葉", reading: "わかば", meaning: "new leaves, young leaves, fresh verdure" },
        { word: "葉巻", reading: "はまき", meaning: "cigar" },
        { word: "葉書", reading: "はがき", meaning: "postcard" }
    ],
    },
    "陽": {
        onyomi: ["ヨウ"],
        kunyomi: ["ひ"],
        examples: [
        { word: "斜陽", reading: "しゃよう", meaning: "setting sun" },
        { word: "太陽", reading: "たいよう", meaning: "Sun" },
        { word: "陽気", reading: "ようき", meaning: "cheerful, jovial, merry" },
        { word: "陽光", reading: "ようこう", meaning: "sunshine, sunlight" }
    ],
    },
    "溶": {
        onyomi: ["ヨウ"],
        kunyomi: ["と.ける", "と.かす", "と.く"],
        examples: [
        { word: "溶く", reading: "とく", meaning: "to mix (e.g. water with flour), to dissolve (salt in water, paint, etc.), to mix in" },
        { word: "溶液", reading: "ようえき", meaning: "solution (liquid)" },
        { word: "溶解", reading: "ようかい", meaning: "dissolution, dissolving, solution (e.g. chemical)" },
        { word: "溶岩", reading: "ようがん", meaning: "lava" }
    ],
    },
    "腰": {
        onyomi: ["ヨウ"],
        kunyomi: ["こし"],
        examples: [
        { word: "腰掛", reading: "こしかけ", meaning: "seat, bench" },
        { word: "腰痛", reading: "ようつう", meaning: "lower back pain, lumbago" },
        { word: "腰部", reading: "ようぶ", meaning: "loins, hips, pelvic region" },
        { word: "弱腰", reading: "よわごし", meaning: "weak attitude" }
    ],
    },
    "様": {
        onyomi: ["ヨウ", "ショウ"],
        kunyomi: ["さま", "さん"],
        examples: [
        { word: "様に", reading: "ように", meaning: "like, as" },
        { word: "異様", reading: "いよう", meaning: "strange, odd, peculiar" },
        { word: "一様", reading: "いちよう", meaning: "uniform, equal, even" },
        { word: "奥様", reading: "おくさま", meaning: "wife, your wife, his wife" }
    ],
    },
    "瘍": {
        onyomi: ["ヨウ"],
        kunyomi: ["かさ"],
        examples: [
        { word: "腫瘍", reading: "しゅよう", meaning: "tumor, tumour, neoplasm" }
    ],
    },
    "踊": {
        onyomi: ["ヨウ"],
        kunyomi: ["おど.る"],
        examples: [
        { word: "舞踊", reading: "ぶよう", meaning: "dancing, dance" },
        { word: "踊る", reading: "おどる", meaning: "to dance (orig. a hopping dance)" },
        { word: "踊り", reading: "おどり", meaning: "dance" },
        { word: "盆踊り", reading: "ぼんおどり", meaning: "Bon Festival dance, Lantern Festival dance" }
    ],
    },
    "窯": {
        onyomi: ["ヨウ"],
        kunyomi: ["かま"],
        examples: [
        { word: "窯業", reading: "ようぎょう", meaning: "ceramics, ceramic industry" },
        { word: "窯元", reading: "かまもと", meaning: "pottery (i.e. the place)" },
        { word: "窯", reading: "かま", meaning: "stove, furnace, kiln" }
    ],
    },
    "養": {
        onyomi: ["ヨウ", "リョウ"],
        kunyomi: ["やしな.う"],
        examples: [
        { word: "栄養", reading: "えいよう", meaning: "nutrition, nourishment" },
        { word: "休養", reading: "きゅうよう", meaning: "rest, relaxation, recreation" },
        { word: "供養", reading: "くよう", meaning: "memorial service for the dead, holding a service" },
        { word: "教養", reading: "きょうよう", meaning: "(understanding or appreciation of) culture, (one's) education, cultivation" }
    ],
    },
    "擁": {
        onyomi: ["ヨウ"],
        kunyomi: [],
        examples: [
        { word: "擁立", reading: "ようりつ", meaning: "backing (for a position), giving support to, helping (someone) to a position" },
        { word: "抱擁", reading: "ほうよう", meaning: "embrace, hug, holding in one's arms" },
        { word: "擁護", reading: "ようご", meaning: "protection, defence, support" },
        { word: "擁する", reading: "ようする", meaning: "to embrace, to hug" }
    ],
    },
    "謡": {
        onyomi: ["ヨウ"],
        kunyomi: ["うた.い", "うた.う"],
        examples: [
        { word: "歌謡", reading: "かよう", meaning: "song, ballad" },
        { word: "童謡", reading: "どうよう", meaning: "children's song, nursery rhyme" },
        { word: "民謡", reading: "みんよう", meaning: "folk song, popular song" },
        { word: "謡曲", reading: "ようきょく", meaning: "noh song" }
    ],
    },
    "曜": {
        onyomi: ["ヨウ"],
        kunyomi: [],
        examples: [
        { word: "火曜", reading: "かよう", meaning: "Tuesday" },
        { word: "金曜", reading: "きんよう", meaning: "Friday" },
        { word: "月曜", reading: "げつよう", meaning: "Monday" },
        { word: "水曜", reading: "すいよう", meaning: "Wednesday" }
    ],
    },
    "抑": {
        onyomi: ["ヨク"],
        kunyomi: ["おさ.える"],
        examples: [
        { word: "抑圧", reading: "よくあつ", meaning: "check, restraint, oppression" },
        { word: "抑止", reading: "よくし", meaning: "keeping in check, holding back, deterrence" },
        { word: "抑制", reading: "よくせい", meaning: "control, restraint, suppression" },
        { word: "抑揚", reading: "よくよう", meaning: "intonation, accent, modulation" }
    ],
    },
    "沃": {
        onyomi: ["ヨウ", "ヨク", "オク"],
        kunyomi: ["そそ.ぐ"],
        examples: [
        { word: "豊沃", reading: "ほうよく", meaning: "fertility" },
        { word: "沃素", reading: "ようそ", meaning: "iodine (I)" },
        { word: "肥沃", reading: "ひよく", meaning: "fertile, rich, productive" },
        { word: "沃土", reading: "よくど", meaning: "rich soil, fertile land" }
    ],
    },
    "浴": {
        onyomi: ["ヨク"],
        kunyomi: ["あ.びる", "あ.びせる"],
        examples: [
        { word: "入浴", reading: "にゅうよく", meaning: "bathing, going in the bath" },
        { word: "浴室", reading: "よくしつ", meaning: "bathroom" },
        { word: "浴場", reading: "よくじょう", meaning: "bathhouse, (public) bath" },
        { word: "浴槽", reading: "よくそう", meaning: "bathtub" }
    ],
    },
    "欲": {
        onyomi: ["ヨク"],
        kunyomi: ["ほっ.する", "ほ.しい"],
        examples: [
        { word: "食欲", reading: "しょくよく", meaning: "appetite (for food)" },
        { word: "性欲", reading: "せいよく", meaning: "sexual desire, sex drive, lust" },
        { word: "無欲", reading: "むよく", meaning: "unselfish, disinterested, unavaricious" },
        { word: "欲求", reading: "よっきゅう", meaning: "desire, want, will" }
    ],
    },
    "翌": {
        onyomi: ["ヨク"],
        kunyomi: [],
        examples: [
        { word: "翌月", reading: "よくげつ", meaning: "following month" },
        { word: "翌週", reading: "よくしゅう", meaning: "the following week, the next week" },
        { word: "翌日", reading: "よくじつ", meaning: "next day" },
        { word: "翌年", reading: "よくねん", meaning: "following year" }
    ],
    },
    "翼": {
        onyomi: ["ヨク"],
        kunyomi: ["つばさ"],
        examples: [
        { word: "一翼", reading: "いちよく", meaning: "one wing" },
        { word: "右翼", reading: "うよく", meaning: "right wing" },
        { word: "左翼", reading: "さよく", meaning: "left wing" },
        { word: "両翼", reading: "りょうよく", meaning: "both wings, both flanks" }
    ],
    },
    "拉": {
        onyomi: ["ラツ", "ラ", "ロウ"],
        kunyomi: ["らっ.する", "ひし.ぐ", "くだ.く"],
        examples: [
        { word: "拉致", reading: "らち", meaning: "taking captive, carrying away, kidnapping" },
        { word: "拉致問題", reading: "らちもんだい", meaning: "abduction issue (esp. of those Japanese abducted by North Korea)" }
    ],
    },
    "裸": {
        onyomi: ["ラ"],
        kunyomi: ["はだか"],
        examples: [
        { word: "裸足", reading: "はだし", meaning: "barefoot" },
        { word: "裸婦", reading: "らふ", meaning: "nude woman, female nude" },
        { word: "裸", reading: "はだか", meaning: "nakedness, nudity" }
    ],
    },
    "羅": {
        onyomi: ["ラ"],
        kunyomi: ["うすもの"],
        examples: [
        { word: "網羅", reading: "もうら", meaning: "encompassing, covering (exhaustively), including (all of)" },
        { word: "羅列", reading: "られつ", meaning: "enumeration, citation, listing" },
        { word: "羅針盤", reading: "らしんばん", meaning: "compass" }
    ],
    },
    "来": {
        onyomi: ["ライ", "タイ"],
        kunyomi: ["く.る", "きた.る", "きた.す", "き.たす", "き.たる", "き", "こ"],
        examples: [
        { word: "以来", reading: "いらい", meaning: "since, henceforth" },
        { word: "往来", reading: "おうらい", meaning: "coming and going, traffic" },
        { word: "家来", reading: "けらい", meaning: "retainer, vassal, follower" },
        { word: "外来", reading: "がいらい", meaning: "foreign, imported" }
    ],
    },
    "雷": {
        onyomi: ["ライ"],
        kunyomi: ["かみなり", "いかずち", "いかづち"],
        examples: [
        { word: "機雷", reading: "きらい", meaning: "(sea) mine" },
        { word: "魚雷", reading: "ぎょらい", meaning: "torpedo" },
        { word: "地雷", reading: "じらい", meaning: "land mine" },
        { word: "雷雨", reading: "らいう", meaning: "thunderstorm, thundershower" }
    ],
    },
    "頼": {
        onyomi: ["ライ"],
        kunyomi: ["たの.む", "たの.もしい", "たよ.る"],
        examples: [
        { word: "依頼", reading: "いらい", meaning: "request, commission, entrusting (with a matter)" },
        { word: "信頼", reading: "しんらい", meaning: "trust (in), confidence, faith" },
        { word: "頼む", reading: "たのむ", meaning: "to request, to beg, to ask" },
        { word: "頼り", reading: "たより", meaning: "reliance, dependence" }
    ],
    },
    "絡": {
        onyomi: ["ラク"],
        kunyomi: ["から.む", "から.まる"],
        examples: [
        { word: "短絡", reading: "たんらく", meaning: "short circuit, short" },
        { word: "脈絡", reading: "みゃくらく", meaning: "logical connection, chain of reasoning, coherence" },
        { word: "絡む", reading: "からむ", meaning: "to twine, to get tangled, to get entangled" },
        { word: "連絡", reading: "れんらく", meaning: "contacting, (making) contact, getting in touch" }
    ],
    },
    "落": {
        onyomi: ["ラク"],
        kunyomi: ["お.ちる", "お.ち", "お.とす"],
        examples: [
        { word: "下落", reading: "げらく", meaning: "depreciation, decline, fall" },
        { word: "陥落", reading: "かんらく", meaning: "subsidence, sinking, cave-in" },
        { word: "急落", reading: "きゅうらく", meaning: "sudden fall, sharp fall, sudden drop" },
        { word: "集落", reading: "しゅうらく", meaning: "settlement, village, community" }
    ],
    },
    "酪": {
        onyomi: ["ラク"],
        kunyomi: [],
        examples: [
        { word: "酪農", reading: "らくのう", meaning: "dairy farming" }
    ],
    },
    "辣": {
        onyomi: ["ラツ"],
        kunyomi: ["から.い"],
        examples: [
        { word: "辣油", reading: "ラーユ", meaning: "(Chinese) chili oil, chile oil, chilli oil" },
        { word: "悪辣", reading: "あくらつ", meaning: "crafty, vicious, unscrupulous" },
        { word: "辛辣", reading: "しんらつ", meaning: "bitter (e.g. criticism), sharp, biting" },
        { word: "辣腕", reading: "らつわん", meaning: "shrewdness, sharpness, astuteness" }
    ],
    },
    "乱": {
        onyomi: ["ラン", "ロン"],
        kunyomi: ["みだ.れる", "みだ.る", "みだ.す", "みだ", "おさ.める", "わた.る"],
        examples: [
        { word: "狂乱", reading: "きょうらん", meaning: "fury, frenzy, madness" },
        { word: "混乱", reading: "こんらん", meaning: "disorder, chaos, confusion" },
        { word: "錯乱", reading: "さくらん", meaning: "confusion, distraction, derangement" },
        { word: "騒乱", reading: "そうらん", meaning: "disturbance, riot, mayhem" }
    ],
    },
    "卵": {
        onyomi: ["ラン"],
        kunyomi: ["たまご"],
        examples: [
        { word: "鶏卵", reading: "けいらん", meaning: "hen's egg" },
        { word: "産卵", reading: "さんらん", meaning: "egg-laying, spawning" },
        { word: "卵管", reading: "らんかん", meaning: "fallopian tube, oviduct" },
        { word: "卵子", reading: "らんし", meaning: "ovum, ovule, egg cell" }
    ],
    },
    "覧": {
        onyomi: ["ラン"],
        kunyomi: ["み.る"],
        examples: [
        { word: "一覧", reading: "いちらん", meaning: "look, glance, sight" },
        { word: "閲覧", reading: "えつらん", meaning: "inspection, reading, perusal" },
        { word: "回覧", reading: "かいらん", meaning: "circulation (esp. of documents), sending round" },
        { word: "観覧", reading: "かんらん", meaning: "viewing" }
    ],
    },
    "濫": {
        onyomi: ["ラン"],
        kunyomi: ["みだ.りに", "みだ.りがましい"],
        examples: [
        { word: "氾濫", reading: "はんらん", meaning: "overflowing, flood, inundation" }
    ],
    },
    "藍": {
        onyomi: ["ラン"],
        kunyomi: ["あい"],
        examples: [
        { word: "藍", reading: "あい", meaning: "dyer's knotweed (Persicaria tinctoria, used to produce indigo dye)" }
    ],
    },
    "欄": {
        onyomi: ["ラン"],
        kunyomi: ["てすり"],
        examples: [
        { word: "空欄", reading: "くうらん", meaning: "blank column, blank space" },
        { word: "欄外", reading: "らんがい", meaning: "margin" },
        { word: "欄干", reading: "らんかん", meaning: "railing, guard rail, handrail" },
        { word: "本欄", reading: "ほんらん", meaning: "this column" }
    ],
    },
    "吏": {
        onyomi: ["リ"],
        kunyomi: [],
        examples: [
        { word: "官吏", reading: "かんり", meaning: "government official, public servant, civil servant" }
    ],
    },
    "利": {
        onyomi: ["リ"],
        kunyomi: ["き.く"],
        examples: [
        { word: "営利", reading: "えいり", meaning: "money-making, commercialized, commercialised" },
        { word: "鋭利", reading: "えいり", meaning: "sharp, keen, acute" },
        { word: "金利", reading: "きんり", meaning: "interest rate, interest" },
        { word: "権利", reading: "けんり", meaning: "right, privilege" }
    ],
    },
    "里": {
        onyomi: ["リ"],
        kunyomi: ["さと"],
        examples: [
        { word: "郷里", reading: "きょうり", meaning: "hometown, birthplace" },
        { word: "千里", reading: "せんり", meaning: "1000 ri, (a) long distance" },
        { word: "万里", reading: "ばんり", meaning: "thousands of miles" },
        { word: "里子", reading: "さとご", meaning: "foster child" }
    ],
    },
    "理": {
        onyomi: ["リ"],
        kunyomi: ["ことわり"],
        examples: [
        { word: "監理", reading: "かんり", meaning: "superintendence, supervision, administration" },
        { word: "管理", reading: "かんり", meaning: "control, management (e.g. of a business)" },
        { word: "義理", reading: "ぎり", meaning: "duty, sense of duty, honor" },
        { word: "経理", reading: "けいり", meaning: "accounting, administration (of money)" }
    ],
    },
    "痢": {
        onyomi: ["リ"],
        kunyomi: [],
        examples: [
        { word: "下痢", reading: "げり", meaning: "diarrhea, diarrhoea" },
        { word: "赤痢", reading: "せきり", meaning: "dysentery" }
    ],
    },
    "裏": {
        onyomi: ["リ"],
        kunyomi: ["うら"],
        examples: [
        { word: "脳裏", reading: "のうり", meaning: "one's mind" },
        { word: "表裏", reading: "ひょうり", meaning: "front and back, inside and outside, two sides" },
        { word: "裏金", reading: "うらがね", meaning: "bribe" },
        { word: "裏口", reading: "うらぐち", meaning: "backdoor, rear entrance, rear exit" }
    ],
    },
    "履": {
        onyomi: ["リ"],
        kunyomi: ["は.く"],
        examples: [
        { word: "草履", reading: "ぞうり", meaning: "zori, traditional Japanese thonged sandals" },
        { word: "履行", reading: "りこう", meaning: "performance (of a duty), fulfillment (of a promise), fulfilment" },
        { word: "履歴", reading: "りれき", meaning: "personal history, background, career" },
        { word: "履物", reading: "はきもの", meaning: "footwear, footgear, shoes" }
    ],
    },
    "璃": {
        onyomi: ["リ"],
        kunyomi: [],
        examples: [
        { word: "瑠璃", reading: "るり", meaning: "lapis lazuli" }
    ],
    },
    "離": {
        onyomi: ["リ"],
        kunyomi: ["はな.れる", "はな.す"],
        examples: [
        { word: "隔離", reading: "かくり", meaning: "isolation, segregation, separation" },
        { word: "距離", reading: "きょり", meaning: "distance, range, interval" },
        { word: "分離", reading: "ぶんり", meaning: "separation, partition, detachment" },
        { word: "離す", reading: "はなす", meaning: "to separate, to part, to divide" }
    ],
    },
    "陸": {
        onyomi: ["リク", "ロク"],
        kunyomi: ["おか"],
        examples: [
        { word: "上陸", reading: "じょうりく", meaning: "landing, going ashore, disembarkation" },
        { word: "大陸", reading: "たいりく", meaning: "continent" },
        { word: "着陸", reading: "ちゃくりく", meaning: "landing, alighting, touch down" },
        { word: "内陸", reading: "ないりく", meaning: "inland" }
    ],
    },
    "立": {
        onyomi: ["リツ", "リュウ", "リットル"],
        kunyomi: ["た.つ", "-た.つ", "た.ち-", "た.てる", "-た.てる", "た.て-", "たて-", "-た.て", "-だ.て", "-だ.てる"],
        examples: [
        { word: "王立", reading: "おうりつ", meaning: "royal (institution)" },
        { word: "確立", reading: "かくりつ", meaning: "establishment, settlement" },
        { word: "起立", reading: "きりつ", meaning: "standing up" },
        { word: "共立", reading: "きょうりつ", meaning: "joint, common" }
    ],
    },
    "律": {
        onyomi: ["リツ", "リチ", "レツ"],
        kunyomi: [],
        examples: [
        { word: "一律", reading: "いちりつ", meaning: "uniform, even, across-the-board" },
        { word: "韻律", reading: "いんりつ", meaning: "metre (of a poem), meter, rhythm" },
        { word: "戒律", reading: "かいりつ", meaning: "(religious) precept, discipline, commandment" },
        { word: "規律", reading: "きりつ", meaning: "order, observance, discipline" }
    ],
    },
    "慄": {
        onyomi: ["リツ"],
        kunyomi: ["ふる.える", "おそ.れる", "おのの.く"],
        examples: [
        { word: "慄え", reading: "ふるえ", meaning: "shivering, trembling, shuddering" },
        { word: "慄く", reading: "おののく", meaning: "to shake (from fear, cold, excitement, etc.), to shudder, to tremble" },
        { word: "戦慄", reading: "せんりつ", meaning: "shudder, shiver, trembling with fear" },
        { word: "慄然", reading: "りつぜん", meaning: "terrified, horrified, trembling with fear" }
    ],
    },
    "略": {
        onyomi: ["リャク"],
        kunyomi: ["ほぼ", "はぶ.く", "おか.す", "おさ.める", "はかりごと", "はか.る"],
        examples: [
        { word: "概略", reading: "がいりゃく", meaning: "outline, summary, gist" },
        { word: "簡略", reading: "かんりゃく", meaning: "simple, brief" },
        { word: "攻略", reading: "こうりゃく", meaning: "capture (of enemy territory), taking (by storm), conquest" },
        { word: "策略", reading: "さくりゃく", meaning: "stratagem, artifice, trick" }
    ],
    },
    "柳": {
        onyomi: ["リュウ"],
        kunyomi: ["やなぎ"],
        examples: [
        { word: "川柳", reading: "せんりゅう", meaning: "senryū, comic haiku, humorous seventeen-mora poem" },
        { word: "花柳", reading: "かりゅう", meaning: "red-light district" },
        { word: "青柳", reading: "あおやぎ", meaning: "green willow (i.e. one that has budded)" },
        { word: "柳", reading: "やなぎ", meaning: "willow (any tree of genus Salix)" }
    ],
    },
    "流": {
        onyomi: ["リュウ", "ル"],
        kunyomi: ["なが.れる", "なが.れ", "なが.す", "-なが.す"],
        examples: [
        { word: "一流", reading: "いちりゅう", meaning: "first-class, first-rate, top-flight" },
        { word: "下流", reading: "かりゅう", meaning: "downstream, lower reaches of a river" },
        { word: "海流", reading: "かいりゅう", meaning: "ocean current" },
        { word: "還流", reading: "かんりゅう", meaning: "return current, reflux, back flow" }
    ],
    },
    "留": {
        onyomi: ["リュウ", "ル"],
        kunyomi: ["と.める", "と.まる", "とど.める", "とど.まる", "るうぶる"],
        examples: [
        { word: "拘留", reading: "こうりゅう", meaning: "custody, detention, confinement" },
        { word: "在留", reading: "ざいりゅう", meaning: "residing (esp. abroad), staying, living" },
        { word: "残留", reading: "ざんりゅう", meaning: "staying behind, remaining, residual" },
        { word: "駐留", reading: "ちゅうりゅう", meaning: "stationing (e.g. of troops), garrison" }
    ],
    },
    "竜": {
        onyomi: ["リュウ", "リョウ", "ロウ"],
        kunyomi: ["たつ", "いせ"],
        examples: [
        { word: "恐竜", reading: "きょうりゅう", meaning: "dinosaur" },
        { word: "竜巻", reading: "たつまき", meaning: "tornado, whirlwind, waterspout" },
        { word: "竜王", reading: "りゅうおう", meaning: "Dragon King" },
        { word: "登竜門", reading: "とうりゅうもん", meaning: "gateway to success" }
    ],
    },
    "粒": {
        onyomi: ["リュウ"],
        kunyomi: ["つぶ"],
        examples: [
        { word: "大粒", reading: "おおつぶ", meaning: "large drop (of rain, sweat, tears, etc.), large grain-like object (e.g. grape, cherry)" },
        { word: "米粒", reading: "こめつぶ", meaning: "grain of rice" },
        { word: "粒子", reading: "りゅうし", meaning: "particle, grain" },
        { word: "粒状", reading: "りゅうじょう", meaning: "granular, granulated" }
    ],
    },
    "隆": {
        onyomi: ["リュウ"],
        kunyomi: [],
        examples: [
        { word: "興隆", reading: "こうりゅう", meaning: "rise, prosperity" },
        { word: "隆起", reading: "りゅうき", meaning: "protuberance, bulge, protrusion" },
        { word: "隆盛", reading: "りゅうせい", meaning: "prosperity, flourishing, thriving" }
    ],
    },
    "硫": {
        onyomi: ["リュウ"],
        kunyomi: [],
        examples: [
        { word: "硫黄", reading: "いおう", meaning: "sulfur (S), sulphur" },
        { word: "硫酸", reading: "りゅうさん", meaning: "sulfuric acid, sulphuric acid" },
        { word: "脱硫", reading: "だつりゅう", meaning: "desulfurization, desulphurisation, desulphurization" }
    ],
    },
    "侶": {
        onyomi: ["リョ", "ロ"],
        kunyomi: ["とも"],
        examples: [
        { word: "僧侶", reading: "そうりょ", meaning: "priest, monk, bonze" },
        { word: "伴侶", reading: "はんりょ", meaning: "companion, partner, spouse" }
    ],
    },
    "旅": {
        onyomi: ["リョ"],
        kunyomi: ["たび"],
        examples: [
        { word: "船旅", reading: "ふなたび", meaning: "trip by boat, sea trip, voyage" },
        { word: "旅館", reading: "りょかん", meaning: "ryokan, traditional Japanese inn" },
        { word: "旅客", reading: "りょかく", meaning: "passenger" },
        { word: "旅券", reading: "りょけん", meaning: "passport" }
    ],
    },
    "虜": {
        onyomi: ["リョ", "ロ"],
        kunyomi: ["とりこ", "とりく"],
        examples: [
        { word: "捕虜", reading: "ほりょ", meaning: "prisoner (of war), POW, captive" }
    ],
    },
    "慮": {
        onyomi: ["リョ"],
        kunyomi: ["おもんぱく.る", "おもんぱか.る"],
        examples: [
        { word: "遠慮", reading: "えんりょ", meaning: "reserve, constraint, restraint" },
        { word: "苦慮", reading: "くりょ", meaning: "racking one's brains, worrying oneself, being anxious" },
        { word: "考慮", reading: "こうりょ", meaning: "consideration, taking into account" },
        { word: "配慮", reading: "はいりょ", meaning: "consideration, concern, attention" }
    ],
    },
    "了": {
        onyomi: ["リョウ"],
        kunyomi: [],
        examples: [
        { word: "完了", reading: "かんりょう", meaning: "completion, conclusion" },
        { word: "修了", reading: "しゅうりょう", meaning: "completion (of a course)" },
        { word: "終了", reading: "しゅうりょう", meaning: "end, close, conclusion" },
        { word: "満了", reading: "まんりょう", meaning: "expiration, termination" }
    ],
    },
    "両": {
        onyomi: ["リョウ"],
        kunyomi: ["てる", "ふたつ"],
        examples: [
        { word: "一両", reading: "いちりょう", meaning: "one vehicle" },
        { word: "車両", reading: "しゃりょう", meaning: "(wheeled) vehicle, car, (railroad) car" },
        { word: "十両", reading: "じゅうりょう", meaning: "second highest division, wrestlers of the second highest division" },
        { word: "両院", reading: "りょういん", meaning: "both houses of parliament, both upper and lower house" }
    ],
    },
    "良": {
        onyomi: ["リョウ"],
        kunyomi: ["よ.い", "-よ.い", "い.い", "-い.い"],
        examples: [
        { word: "改良", reading: "かいりょう", meaning: "improvement, reform" },
        { word: "最良", reading: "さいりょう", meaning: "the best, ideal" },
        { word: "善良", reading: "ぜんりょう", meaning: "good (person, nature, etc.), good-natured, virtuous" },
        { word: "不良", reading: "ふりょう", meaning: "bad, poor, inferior" }
    ],
    },
    "料": {
        onyomi: ["リョウ"],
        kunyomi: [],
        examples: [
        { word: "衣料", reading: "いりょう", meaning: "clothing" },
        { word: "飲料", reading: "いんりょう", meaning: "beverage, drink" },
        { word: "給料", reading: "きゅうりょう", meaning: "salary, wages, pay" },
        { word: "原料", reading: "げんりょう", meaning: "raw materials, ingredient" }
    ],
    },
    "涼": {
        onyomi: ["リョウ"],
        kunyomi: ["すず.しい", "すず.む", "すず.やか", "うす.い", "ひや.す", "まことに"],
        examples: [
        { word: "清涼", reading: "せいりょう", meaning: "cool, refreshing" },
        { word: "涼む", reading: "すずむ", meaning: "to cool oneself, to cool off, to enjoy the cool air" },
        { word: "涼風", reading: "りょうふう", meaning: "cool breeze, refreshing breeze" },
        { word: "涼しい", reading: "すずしい", meaning: "cool, refreshing" }
    ],
    },
    "猟": {
        onyomi: ["リョウ"],
        kunyomi: ["かり", "か.る"],
        examples: [
        { word: "狩猟", reading: "しゅりょう", meaning: "hunting" },
        { word: "密猟", reading: "みつりょう", meaning: "poaching" },
        { word: "猟犬", reading: "りょうけん", meaning: "hound, hunting dog, gun dog" },
        { word: "猟師", reading: "りょうし", meaning: "hunter, huntsman" }
    ],
    },
    "陵": {
        onyomi: ["リョウ"],
        kunyomi: ["みささぎ"],
        examples: [
        { word: "丘陵", reading: "きゅうりょう", meaning: "hill, hillock" },
        { word: "陵", reading: "みささぎ", meaning: "imperial mausoleum, Emperor's tomb" }
    ],
    },
    "量": {
        onyomi: ["リョウ"],
        kunyomi: ["はか.る"],
        examples: [
        { word: "雨量", reading: "うりょう", meaning: "(amount of) rainfall" },
        { word: "音量", reading: "おんりょう", meaning: "volume (sound)" },
        { word: "計量", reading: "けいりょう", meaning: "measuring, weighing" },
        { word: "軽量", reading: "けいりょう", meaning: "light weight" }
    ],
    },
    "僚": {
        onyomi: ["リョウ"],
        kunyomi: [],
        examples: [
        { word: "閣僚", reading: "かくりょう", meaning: "cabinet ministers" },
        { word: "官僚", reading: "かんりょう", meaning: "bureaucrat, government official, bureaucracy" },
        { word: "同僚", reading: "どうりょう", meaning: "coworker, co-worker, colleague" },
        { word: "幕僚", reading: "ばくりょう", meaning: "staff, staff officer" }
    ],
    },
    "領": {
        onyomi: ["リョウ"],
        kunyomi: ["えり"],
        examples: [
        { word: "横領", reading: "おうりょう", meaning: "embezzlement, misappropriation, usurpation" },
        { word: "綱領", reading: "こうりょう", meaning: "general plan, main points, summary" },
        { word: "受領", reading: "じゅりょう", meaning: "receipt (of a letter, money, etc.), acceptance, receiving" },
        { word: "占領", reading: "せんりょう", meaning: "occupying, having (an area) all to oneself" }
    ],
    },
    "寮": {
        onyomi: ["リョウ"],
        kunyomi: [],
        examples: [
        { word: "寮生", reading: "りょうせい", meaning: "boarder, boarding student" },
        { word: "寮", reading: "りょう", meaning: "hostel, dormitory" }
    ],
    },
    "療": {
        onyomi: ["リョウ"],
        kunyomi: [],
        examples: [
        { word: "医療", reading: "いりょう", meaning: "medical treatment, medical care" },
        { word: "治療", reading: "ちりょう", meaning: "(medical) treatment, care, therapy" },
        { word: "診療", reading: "しんりょう", meaning: "diagnosis and treatment, medical care" },
        { word: "療法", reading: "りょうほう", meaning: "(method of) treatment, therapy, remedy" }
    ],
    },
    "瞭": {
        onyomi: ["リョウ"],
        kunyomi: ["あきらか"],
        examples: [
        { word: "明瞭", reading: "めいりょう", meaning: "clear, plain, distinct" }
    ],
    },
    "糧": {
        onyomi: ["リョウ", "ロウ"],
        kunyomi: ["かて"],
        examples: [
        { word: "食糧", reading: "しょくりょう", meaning: "food (esp. staple food such as rice or wheat), provisions, rations" },
        { word: "糧食", reading: "りょうしょく", meaning: "provisions" },
        { word: "兵糧", reading: "ひょうろう", meaning: "(army) provisions, food" },
        { word: "食糧庁", reading: "しょくりょうちょう", meaning: "food agency" }
    ],
    },
    "力": {
        onyomi: ["リョク", "リキ", "リイ"],
        kunyomi: ["ちから"],
        examples: [
        { word: "握力", reading: "あくりょく", meaning: "grip (of hand), grip strength" },
        { word: "圧力", reading: "あつりょく", meaning: "pressure" },
        { word: "引力", reading: "いんりょく", meaning: "attraction (e.g. magnetic, gravitation), affinity, gravitational pull" },
        { word: "火力", reading: "かりょく", meaning: "heating power, thermal power" }
    ],
    },
    "緑": {
        onyomi: ["リョク", "ロク"],
        kunyomi: ["みどり"],
        examples: [
        { word: "新緑", reading: "しんりょく", meaning: "fresh verdure, new green leaves" },
        { word: "緑色", reading: "みどりいろ", meaning: "green, green color" },
        { word: "緑青", reading: "ろくしょう", meaning: "verdigris, green rust, copper rust" },
        { word: "緑地", reading: "りょくち", meaning: "green tract of land, green space" }
    ],
    },
    "林": {
        onyomi: ["リン"],
        kunyomi: ["はやし"],
        examples: [
        { word: "山林", reading: "さんりん", meaning: "mountain forest, forest on a mountain, forest land" },
        { word: "松林", reading: "まつばやし", meaning: "pine forest" },
        { word: "植林", reading: "しょくりん", meaning: "afforestation" },
        { word: "森林", reading: "しんりん", meaning: "forest, woods" }
    ],
    },
    "厘": {
        onyomi: ["リン"],
        kunyomi: [],
        examples: [
        { word: "厘", reading: "りん", meaning: "one-hundredth, 0.3 mm (one-hundredth of a sun), 0.1 percent (one-hundredth of a wari)" }
    ],
    },
    "倫": {
        onyomi: ["リン"],
        kunyomi: [],
        examples: [
        { word: "不倫", reading: "ふりん", meaning: "adultery, impropriety, (an) affair" },
        { word: "倫理", reading: "りんり", meaning: "ethics, morals" },
        { word: "倫理学", reading: "りんりがく", meaning: "ethics, moral philosophy" },
        { word: "倫理的", reading: "りんりてき", meaning: "ethical" }
    ],
    },
    "輪": {
        onyomi: ["リン"],
        kunyomi: ["わ"],
        examples: [
        { word: "花輪", reading: "はなわ", meaning: "wreath, garland" },
        { word: "競輪", reading: "けいりん", meaning: "keirin, cycle racing event, usu. 2 km with a paced start and sprint finish" },
        { word: "三輪", reading: "さんりん", meaning: "three wheels" },
        { word: "指輪", reading: "ゆびわ", meaning: "(finger) ring" }
    ],
    },
    "隣": {
        onyomi: ["リン"],
        kunyomi: ["とな.る", "となり"],
        examples: [
        { word: "近隣", reading: "きんりん", meaning: "neighbourhood, neighborhood, vicinity" },
        { word: "善隣", reading: "ぜんりん", meaning: "good neighbour, good neighbor" },
        { word: "隣家", reading: "りんか", meaning: "neighbouring house, neighboring house" },
        { word: "隣人", reading: "りんじん", meaning: "neighbour, neighbor, (people in the) neighbourhood" }
    ],
    },
    "臨": {
        onyomi: ["リン"],
        kunyomi: ["のぞ.む"],
        examples: [
        { word: "君臨", reading: "くんりん", meaning: "reigning (over a country)" },
        { word: "臨む", reading: "のぞむ", meaning: "to look out on, to overlook, to front onto" },
        { word: "臨界", reading: "りんかい", meaning: "boundary" },
        { word: "臨時", reading: "りんじ", meaning: "temporary, provisional, interim" }
    ],
    },
    "瑠": {
        onyomi: ["ル", "リュウ"],
        kunyomi: [],
        examples: [
        { word: "瑠璃", reading: "るり", meaning: "lapis lazuli" }
    ],
    },
    "涙": {
        onyomi: ["ルイ", "レイ"],
        kunyomi: ["なみだ"],
        examples: [
        { word: "感涙", reading: "かんるい", meaning: "tears (from being deeply moved), tears of gratitude" },
        { word: "涙声", reading: "なみだごえ", meaning: "tearful voice" },
        { word: "催涙", reading: "さいるい", meaning: "tear-inducing" },
        { word: "涙", reading: "なみだ", meaning: "tear, tears, lachrymal secretion" }
    ],
    },
    "累": {
        onyomi: ["ルイ"],
        kunyomi: [],
        examples: [
        { word: "累計", reading: "るいけい", meaning: "cumulative total, accumulated total, total up to now" },
        { word: "累進", reading: "るいしん", meaning: "successive promotion, gradual progression, rising step by step" },
        { word: "累積", reading: "るいせき", meaning: "accumulation" }
    ],
    },
    "塁": {
        onyomi: ["ルイ", "ライ", "スイ"],
        kunyomi: ["とりで"],
        examples: [
        { word: "一塁", reading: "いちるい", meaning: "first base" },
        { word: "三塁", reading: "さんるい", meaning: "third base" },
        { word: "出塁", reading: "しゅつるい", meaning: "getting on base, reaching first base" },
        { word: "盗塁", reading: "とうるい", meaning: "base stealing, steal, stolen base" }
    ],
    },
    "類": {
        onyomi: ["ルイ"],
        kunyomi: ["たぐ.い"],
        examples: [
        { word: "魚類", reading: "ぎょるい", meaning: "fish, fishes" },
        { word: "穀類", reading: "こくるい", meaning: "grains" },
        { word: "種類", reading: "しゅるい", meaning: "variety, kind, type" },
        { word: "酒類", reading: "しゅるい", meaning: "alcoholic drinks, liquor" }
    ],
    },
    "令": {
        onyomi: ["レイ"],
        kunyomi: [],
        examples: [
        { word: "訓令", reading: "くんれい", meaning: "directive, instructions" },
        { word: "号令", reading: "ごうれい", meaning: "order (esp. to a number of people), command" },
        { word: "司令", reading: "しれい", meaning: "command, commander, commandant" },
        { word: "指令", reading: "しれい", meaning: "order, directive, instructions" }
    ],
    },
    "礼": {
        onyomi: ["レイ", "ライ"],
        kunyomi: [],
        examples: [
        { word: "儀礼", reading: "ぎれい", meaning: "courtesy, etiquette, formality" },
        { word: "お礼", reading: "おれい", meaning: "thanks, gratitude" },
        { word: "祭礼", reading: "さいれい", meaning: "(religious) festival" },
        { word: "失礼", reading: "しつれい", meaning: "discourtesy, impoliteness" }
    ],
    },
    "冷": {
        onyomi: ["レイ"],
        kunyomi: ["つめ.たい", "ひ.える", "ひ.や", "ひ.ややか", "ひ.やす", "ひ.やかす", "さ.める", "さ.ます"],
        examples: [
        { word: "寒冷", reading: "かんれい", meaning: "cold, coldness, chilliness" },
        { word: "冷え", reading: "ひえ", meaning: "chilliness, coldness" },
        { word: "冷害", reading: "れいがい", meaning: "cold-weather damage (to crops)" },
        { word: "冷却", reading: "れいきゃく", meaning: "cooling, refrigeration" }
    ],
    },
    "励": {
        onyomi: ["レイ"],
        kunyomi: ["はげ.む", "はげ.ます"],
        examples: [
        { word: "激励", reading: "げきれい", meaning: "encouragement, spurring (on), cheering (on)" },
        { word: "奨励", reading: "しょうれい", meaning: "encouragement, promotion, inducement" },
        { word: "励み", reading: "はげみ", meaning: "encouragement, incentive, stimulus" },
        { word: "励む", reading: "はげむ", meaning: "to work hard, to try hard, to strive" }
    ],
    },
    "戻": {
        onyomi: ["レイ"],
        kunyomi: ["もど.す", "もど.る"],
        examples: [
        { word: "戻す", reading: "もどす", meaning: "to put back, to return, to give back" },
        { word: "戻り", reading: "もどり", meaning: "return, reaction, recovery" },
        { word: "戻る", reading: "もどる", meaning: "to turn back (e.g. half-way)" },
        { word: "戻し", reading: "もどし", meaning: "returning, giving back" }
    ],
    },
    "例": {
        onyomi: ["レイ"],
        kunyomi: ["たと.える"],
        examples: [
        { word: "異例", reading: "いれい", meaning: "exceptional, unusual, extraordinary" },
        { word: "一例", reading: "いちれい", meaning: "example, an instance" },
        { word: "慣例", reading: "かんれい", meaning: "custom, practice, convention" },
        { word: "月例", reading: "げつれい", meaning: "monthly" }
    ],
    },
    "鈴": {
        onyomi: ["レイ", "リン"],
        kunyomi: ["すず"],
        examples: [
        { word: "風鈴", reading: "ふうりん", meaning: "wind chime, wind bell" },
        { word: "鈴", reading: "すず", meaning: "bell (often globular)" }
    ],
    },
    "零": {
        onyomi: ["レイ"],
        kunyomi: ["ぜろ", "こぼ.す", "こぼ.れる"],
        examples: [
        { word: "零下", reading: "れいか", meaning: "below zero, sub-zero" },
        { word: "零細", reading: "れいさい", meaning: "insignificant, trifling, paltry" },
        { word: "零時", reading: "れいじ", meaning: "twelve o'clock, midnight, noon" },
        { word: "零点", reading: "れいてん", meaning: "zero (points, marks), no marks" }
    ],
    },
    "霊": {
        onyomi: ["レイ", "リョウ"],
        kunyomi: ["たま"],
        examples: [
        { word: "亡霊", reading: "ぼうれい", meaning: "departed spirit, soul of the dead" },
        { word: "幽霊", reading: "ゆうれい", meaning: "ghost, specter, spectre" },
        { word: "霊園", reading: "れいえん", meaning: "(garden) cemetery, park-style cemetery, memorial park" },
        { word: "慰霊", reading: "いれい", meaning: "consoling the spirits of the dead" }
    ],
    },
    "隷": {
        onyomi: ["レイ"],
        kunyomi: ["したが.う", "しもべ"],
        examples: [
        { word: "奴隷", reading: "どれい", meaning: "slave, servant" }
    ],
    },
    "齢": {
        onyomi: ["レイ"],
        kunyomi: ["よわい", "とし"],
        examples: [
        { word: "学齢", reading: "がくれい", meaning: "school age" },
        { word: "高齢", reading: "こうれい", meaning: "advanced age, old age" },
        { word: "樹齢", reading: "じゅれい", meaning: "age of a tree" },
        { word: "老齢", reading: "ろうれい", meaning: "old age, advanced age" }
    ],
    },
    "麗": {
        onyomi: ["レイ"],
        kunyomi: ["うるわ.しい", "うら.らか"],
        examples: [
        { word: "華麗", reading: "かれい", meaning: "splendid, magnificent, gorgeous" },
        { word: "綺麗", reading: "きれい", meaning: "pretty, lovely, beautiful" },
        { word: "高麗", reading: "こうらい", meaning: "Goryeo (dynasty of Korea; 918-1392 CE), Koryŏ" },
        { word: "美辞麗句", reading: "びじれいく", meaning: "flowery words, rhetorical flourishes" }
    ],
    },
    "暦": {
        onyomi: ["レキ", "リャク"],
        kunyomi: ["こよみ"],
        examples: [
        { word: "還暦", reading: "かんれき", meaning: "kanreki, one's 60th birthday (or 61st in the traditional age reckoning system) when one has lived through a full sexagenary cycle" },
        { word: "旧暦", reading: "きゅうれき", meaning: "Japan's old (lunisolar) calendar" },
        { word: "西暦", reading: "せいれき", meaning: "Common Era, CE, Christian Era" },
        { word: "暦", reading: "こよみ", meaning: "calendar, almanac" }
    ],
    },
    "歴": {
        onyomi: ["レキ", "レッキ"],
        kunyomi: [],
        examples: [
        { word: "学歴", reading: "がくれき", meaning: "academic background, academic credentials, academic record" },
        { word: "経歴", reading: "けいれき", meaning: "personal history, background, career" },
        { word: "職歴", reading: "しょくれき", meaning: "work experience, work history" },
        { word: "前歴", reading: "ぜんれき", meaning: "personal history" }
    ],
    },
    "列": {
        onyomi: ["レツ", "レ"],
        kunyomi: [],
        examples: [
        { word: "系列", reading: "けいれつ", meaning: "series, sequence, system" },
        { word: "後列", reading: "こうれつ", meaning: "back row, rear rank" },
        { word: "行列", reading: "ぎょうれつ", meaning: "line, queue, procession" },
        { word: "参列", reading: "さんれつ", meaning: "attendance, participation, presence" }
    ],
    },
    "劣": {
        onyomi: ["レツ"],
        kunyomi: ["おと.る"],
        examples: [
        { word: "拙劣", reading: "せつれつ", meaning: "clumsy, unskillful" },
        { word: "卑劣", reading: "ひれつ", meaning: "mean, contemptible, despicable" },
        { word: "優劣", reading: "ゆうれつ", meaning: "(relative) merits, superiority or inferiority, quality" },
        { word: "劣る", reading: "おとる", meaning: "to be inferior to, to be less good at, to fall behind" }
    ],
    },
    "烈": {
        onyomi: ["レツ"],
        kunyomi: ["はげ.しい"],
        examples: [
        { word: "強烈", reading: "きょうれつ", meaning: "strong, intense, severe" },
        { word: "鮮烈", reading: "せんれつ", meaning: "vivid, striking" },
        { word: "壮烈", reading: "そうれつ", meaning: "heroic, brave" },
        { word: "痛烈", reading: "つうれつ", meaning: "severe, bitter, scathing" }
    ],
    },
    "裂": {
        onyomi: ["レツ"],
        kunyomi: ["さ.く", "さ.ける", "-ぎ.れ"],
        examples: [
        { word: "裂く", reading: "さく", meaning: "to tear, to rip up" },
        { word: "亀裂", reading: "きれつ", meaning: "crack, crevice, fissure" },
        { word: "決裂", reading: "けつれつ", meaning: "breakdown (of talks, negotiations, etc.), breaking off, rupture" },
        { word: "破裂", reading: "はれつ", meaning: "bursting, rupture, explosion" }
    ],
    },
    "恋": {
        onyomi: ["レン"],
        kunyomi: ["こ.う", "こい", "こい.しい"],
        examples: [
        { word: "失恋", reading: "しつれん", meaning: "disappointed love, broken heart, unrequited love" },
        { word: "初恋", reading: "はつこい", meaning: "first love, puppy love" },
        { word: "悲恋", reading: "ひれん", meaning: "blighted love, disappointed love" },
        { word: "恋愛", reading: "れんあい", meaning: "love, romance, tender passion" }
    ],
    },
    "連": {
        onyomi: ["レン"],
        kunyomi: ["つら.なる", "つら.ねる", "つ.れる", "-づ.れ"],
        examples: [
        { word: "ソ連", reading: "ソれん", meaning: "Soviet Union, USSR" },
        { word: "一連", reading: "いちれん", meaning: "series, chain, sequence" },
        { word: "関連", reading: "かんれん", meaning: "relation, connection, relevance" },
        { word: "国連", reading: "こくれん", meaning: "United Nations, UN" }
    ],
    },
    "廉": {
        onyomi: ["レン"],
        kunyomi: [],
        examples: [
        { word: "清廉", reading: "せいれん", meaning: "honest, upright, cleanhanded" },
        { word: "廉価", reading: "れんか", meaning: "low price, moderate price" },
        { word: "廉売", reading: "れんばい", meaning: "bargain sale" }
    ],
    },
    "練": {
        onyomi: ["レン"],
        kunyomi: ["ね.る", "ね.り"],
        examples: [
        { word: "訓練", reading: "くんれん", meaning: "training, drill, practice" },
        { word: "試練", reading: "しれん", meaning: "test, trial, ordeal" },
        { word: "熟練", reading: "じゅくれん", meaning: "skill, expertise, experience" },
        { word: "洗練", reading: "せんれん", meaning: "refinement, polish" }
    ],
    },
    "錬": {
        onyomi: ["レン"],
        kunyomi: ["ね.る"],
        examples: [
        { word: "鍛錬", reading: "たんれん", meaning: "tempering (metal), annealing, forging" },
        { word: "錬金術", reading: "れんきんじゅつ", meaning: "alchemy" },
        { word: "錬金術師", reading: "れんきんじゅつし", meaning: "alchemist" }
    ],
    },
    "呂": {
        onyomi: ["ロ", "リョ"],
        kunyomi: ["せぼね"],
        examples: [
        { word: "風呂", reading: "ふろ", meaning: "bath, bathing, bathtub" },
        { word: "風呂屋", reading: "ふろや", meaning: "public bathhouse" },
        { word: "風呂場", reading: "ふろば", meaning: "bathroom" },
        { word: "風呂敷", reading: "ふろしき", meaning: "furoshiki, wrapping cloth, cloth wrapper" }
    ],
    },
    "炉": {
        onyomi: ["ロ"],
        kunyomi: ["いろり"],
        examples: [
        { word: "暖炉", reading: "だんろ", meaning: "fireplace, hearth, stove" },
        { word: "高炉", reading: "こうろ", meaning: "blast furnace" },
        { word: "炉心", reading: "ろしん", meaning: "nuclear reactor core" },
        { word: "原子炉", reading: "げんしろ", meaning: "atomic reactor, nuclear reactor" }
    ],
    },
    "賂": {
        onyomi: ["ロ"],
        kunyomi: ["まいな.い", "まいな.う"],
        examples: [
        { word: "賄賂", reading: "わいろ", meaning: "bribe, sweetener, douceur" }
    ],
    },
    "路": {
        onyomi: ["ロ", "ル"],
        kunyomi: ["-じ", "みち"],
        examples: [
        { word: "回路", reading: "かいろ", meaning: "circuit" },
        { word: "海路", reading: "かいろ", meaning: "sea route" },
        { word: "街路", reading: "がいろ", meaning: "road, street, avenue" },
        { word: "活路", reading: "かつろ", meaning: "means of survival, means of escape, way out of a difficulty" }
    ],
    },
    "露": {
        onyomi: ["ロ", "ロウ"],
        kunyomi: ["つゆ"],
        examples: [
        { word: "吐露", reading: "とろ", meaning: "expressing one's mind, speaking out" },
        { word: "披露", reading: "ひろう", meaning: "announcement, presentation, demonstration" },
        { word: "露骨", reading: "ろこつ", meaning: "open, unconcealed, undisguised" },
        { word: "露出", reading: "ろしゅつ", meaning: "exposure, laying bare, baring (e.g. skin)" }
    ],
    },
    "老": {
        onyomi: ["ロウ"],
        kunyomi: ["お.いる", "ふ.ける"],
        examples: [
        { word: "敬老", reading: "けいろう", meaning: "respect for the aged" },
        { word: "元老", reading: "げんろう", meaning: "elder statesman, doyen, old-timer" },
        { word: "初老", reading: "しょろう", meaning: "past middle age, nearing old age, near-elderly" },
        { word: "長老", reading: "ちょうろう", meaning: "elder, senior" }
    ],
    },
    "労": {
        onyomi: ["ロウ"],
        kunyomi: ["ろう.する", "いたわ.る", "いた.ずき", "ねぎら", "つか.れる", "ねぎら.う"],
        examples: [
        { word: "過労", reading: "かろう", meaning: "overwork, strain" },
        { word: "勤労", reading: "きんろう", meaning: "labor, labour, exertion" },
        { word: "苦労", reading: "くろう", meaning: "trouble, hardship, difficulty" },
        { word: "功労", reading: "こうろう", meaning: "meritorious deed, services" }
    ],
    },
    "弄": {
        onyomi: ["ロウ", "ル"],
        kunyomi: ["いじく.る", "ろう.する", "いじ.る", "ひねく.る", "たわむ.れる", "もてあそ.ぶ"],
        examples: [
        { word: "翻弄", reading: "ほんろう", meaning: "having at one's mercy, trifling with, toying with" },
        { word: "弄る", reading: "いじる", meaning: "to finger, to touch, to play with" }
    ],
    },
    "郎": {
        onyomi: ["ロウ", "リョウ"],
        kunyomi: ["おとこ"],
        examples: [
        { word: "新郎", reading: "しんろう", meaning: "bridegroom" },
        { word: "野郎", reading: "やろう", meaning: "guy, fellow, chap" }
    ],
    },
    "朗": {
        onyomi: ["ロウ"],
        kunyomi: ["ほが.らか", "あき.らか"],
        examples: [
        { word: "明朗", reading: "めいろう", meaning: "cheerful, bright" },
        { word: "朗詠", reading: "ろうえい", meaning: "recitation (of Japanese or Chinese poem)" },
        { word: "朗読", reading: "ろうどく", meaning: "reading aloud, recitation" },
        { word: "朗報", reading: "ろうほう", meaning: "good news, happy news, glad tidings" }
    ],
    },
    "浪": {
        onyomi: ["ロウ"],
        kunyomi: [],
        examples: [
        { word: "波浪", reading: "はろう", meaning: "waves, billows, surge" },
        { word: "放浪", reading: "ほうろう", meaning: "wandering, roaming, drifting" },
        { word: "流浪", reading: "るろう", meaning: "vagrancy, wandering, nomadism" },
        { word: "浪人", reading: "ろうにん", meaning: "ronin, masterless samurai" }
    ],
    },
    "廊": {
        onyomi: ["ロウ"],
        kunyomi: [],
        examples: [
        { word: "画廊", reading: "がろう", meaning: "art gallery (esp. artworks for sale), picture gallery" },
        { word: "回廊", reading: "かいろう", meaning: "corridor, gallery, hallway" },
        { word: "廊下", reading: "ろうか", meaning: "corridor, hallway, passageway" }
    ],
    },
    "楼": {
        onyomi: ["ロウ"],
        kunyomi: ["たかどの"],
        examples: [
        { word: "鐘楼", reading: "しょうろう", meaning: "belfry, bell tower" },
        { word: "楼閣", reading: "ろうかく", meaning: "multistoried building, castle, palace" },
        { word: "摩天楼", reading: "まてんろう", meaning: "skyscraper" }
    ],
    },
    "漏": {
        onyomi: ["ロウ"],
        kunyomi: ["も.る", "も.れる", "も.らす"],
        examples: [
        { word: "漏る", reading: "もる", meaning: "to leak, to run out" },
        { word: "漏洩", reading: "ろうえい", meaning: "leak (of secrets, information, etc.), disclosure, divulging" },
        { word: "雨漏り", reading: "あまもり", meaning: "roof leak" },
        { word: "漏らす", reading: "もらす", meaning: "to let leak, to let out (e.g. light)" }
    ],
    },
    "籠": {
        onyomi: ["ロウ", "ル"],
        kunyomi: ["かご", "こ.める", "こも.る", "こ.む"],
        examples: [
        { word: "籠もる", reading: "こもる", meaning: "to shut oneself in (e.g. one's room), to be confined in, to seclude oneself" },
        { word: "籠", reading: "かご", meaning: "basket (shopping, etc.), hamper, cage" }
    ],
    },
    "六": {
        onyomi: ["ロク", "リク"],
        kunyomi: ["む", "む.つ", "むっ.つ", "むい"],
        examples: [
        { word: "十六", reading: "じゅうろく", meaning: "sixteen, 16" },
        { word: "六月", reading: "ろくがつ", meaning: "June" },
        { word: "六日", reading: "むいか", meaning: "6th day of the month" },
        { word: "六つ", reading: "むっつ", meaning: "six" }
    ],
    },
    "録": {
        onyomi: ["ロク"],
        kunyomi: ["しる.す", "と.る"],
        examples: [
        { word: "記録", reading: "きろく", meaning: "record, document, minutes" },
        { word: "収録", reading: "しゅうろく", meaning: "recording (in a book, the minutes, etc.), printing, including" },
        { word: "抄録", reading: "しょうろく", meaning: "quotation, abstract, selection" },
        { word: "登録", reading: "とうろく", meaning: "registration, accession, register" }
    ],
    },
    "麓": {
        onyomi: ["ロク"],
        kunyomi: ["ふもと"],
        examples: [
        { word: "麓", reading: "ふもと", meaning: "foot (of a mountain or hill), bottom, base" }
    ],
    },
    "論": {
        onyomi: ["ロン"],
        kunyomi: ["あげつら.う"],
        examples: [
        { word: "異論", reading: "いろん", meaning: "different opinion, objection" },
        { word: "概論", reading: "がいろん", meaning: "introduction, outline, general remarks" },
        { word: "議論", reading: "ぎろん", meaning: "argument, discussion, dispute" },
        { word: "結論", reading: "けつろん", meaning: "conclusion (of an argument, discussion, study, etc.)" }
    ],
    },
    "和": {
        onyomi: ["ワ", "オ", "カ"],
        kunyomi: ["やわ.らぐ", "やわ.らげる", "なご.む", "なご.やか", "あ.える"],
        examples: [
        { word: "英和", reading: "えいわ", meaning: "English-Japanese" },
        { word: "漢和", reading: "かんわ", meaning: "China and Japan" },
        { word: "緩和", reading: "かんわ", meaning: "relief, mitigation, alleviation" },
        { word: "協和", reading: "きょうわ", meaning: "concord, harmony, concert" }
    ],
    },
    "話": {
        onyomi: ["ワ"],
        kunyomi: ["はな.す", "はなし"],
        examples: [
        { word: "逸話", reading: "いつわ", meaning: "anecdote, story, episode" },
        { word: "会話", reading: "かいわ", meaning: "conversation, talk, chat" },
        { word: "懇話", reading: "こんわ", meaning: "friendly talk, chat" },
        { word: "実話", reading: "じつわ", meaning: "true story" }
    ],
    },
    "賄": {
        onyomi: ["ワイ"],
        kunyomi: ["まかな.う"],
        examples: [
        { word: "収賄", reading: "しゅうわい", meaning: "accepting a bribe" },
        { word: "贈賄", reading: "ぞうわい", meaning: "giving a bribe, bribery" },
        { word: "賄う", reading: "まかなう", meaning: "to supply (goods, money, etc.), to cover (costs), to pay" },
        { word: "賄賂", reading: "わいろ", meaning: "bribe, sweetener, douceur" }
    ],
    },
    "脇": {
        onyomi: ["キョウ"],
        kunyomi: ["わき", "わけ"],
        examples: [
        { word: "関脇", reading: "せきわけ", meaning: "wrestler of the third highest rank" },
        { word: "脇見", reading: "わきみ", meaning: "looking aside, looking away (e.g. while driving), looking the other way" },
        { word: "脇役", reading: "わきやく", meaning: "supporting role (actor), minor role" },
        { word: "脇", reading: "わき", meaning: "armpit, under one's arm, side" }
    ],
    },
    "惑": {
        onyomi: ["ワク"],
        kunyomi: ["まど.う"],
        examples: [
        { word: "疑惑", reading: "ぎわく", meaning: "doubt, misgivings, distrust" },
        { word: "困惑", reading: "こんわく", meaning: "bewilderment, perplexity, embarrassment" },
        { word: "思惑", reading: "おもわく", meaning: "expectation, anticipation, prediction" },
        { word: "当惑", reading: "とうわく", meaning: "bewilderment, perplexity, embarrassment" }
    ],
    },
    "枠": {
        onyomi: [],
        kunyomi: ["わく"],
        examples: [
        { word: "枠内", reading: "わくない", meaning: "within the limits (framework, boundaries, price, etc.)" },
        { word: "枠外", reading: "わくがい", meaning: "(beyond the) limits, scope, boundary" },
        { word: "枠組み", reading: "わくぐみ", meaning: "frame (physical structure), framework" },
        { word: "枠", reading: "わく", meaning: "frame, framework" }
    ],
    },
    "湾": {
        onyomi: ["ワン"],
        kunyomi: ["いりえ"],
        examples: [
        { word: "港湾", reading: "こうわん", meaning: "harbour, harbor" },
        { word: "台湾", reading: "たいわん", meaning: "Taiwan" },
        { word: "湾岸", reading: "わんがん", meaning: "gulf coast, bay coast" },
        { word: "湾曲", reading: "わんきょく", meaning: "curve, bend, crook" }
    ],
    },
    "腕": {
        onyomi: ["ワン"],
        kunyomi: ["うで"],
        examples: [
        { word: "右腕", reading: "みぎうで", meaning: "right arm" },
        { word: "手腕", reading: "しゅわん", meaning: "ability, capability, skill" },
        { word: "敏腕", reading: "びんわん", meaning: "ability, capability, competence" },
        { word: "両腕", reading: "りょううで", meaning: "both arms" }
    ],
    },
    "丑": {
        onyomi: ["チュウ"],
        kunyomi: ["うし"],
        examples: [
        { word: "己丑", reading: "きちゅう", meaning: "Earth Ox (26th term of the sexagenary cycle, e.g. 1949, 2009, 2069)" },
        { word: "丁丑", reading: "ひのとのうし", meaning: "Fire Ox (14th term of the sexagenary cycle, e.g. 1937, 1997, 2057)" },
        { word: "辛丑", reading: "かのとうし", meaning: "Metal Ox (38th term of the sexagenary cycle, e.g. 1961, 2021, 2081)" }
    ],
    },
    "丞": {
        onyomi: ["ジョウ", "ショウ"],
        kunyomi: ["すく.う", "たす.ける"],
        examples: [
        { word: "左丞相", reading: "さじょうしょう", meaning: "Minister of the Left (Chinese-style title)" },
        { word: "右丞相", reading: "うじょうしょう", meaning: "Minister of the Right (Chinese-style title)" },
        { word: "丞相", reading: "じょうしょう", meaning: "grand chancellor (highest-ranking minister in ancient China), chief councillor, minister (Chinese-style title)" }
    ],
    },
    "乃": {
        onyomi: ["ナイ", "ダイ", "ノ", "アイ"],
        kunyomi: ["の", "すなわ.ち", "なんじ"],
        examples: [
        { word: "千乃正法", reading: "ちのしょうほう", meaning: "Chino Shōhō (religious group founded by Chino Yūko)" },
        { word: "乃父", reading: "だいふ", meaning: "father" },
        { word: "木乃伊", reading: "ミイラ", meaning: "mummy" }
    ],
    },
    "之": {
        onyomi: ["シ"],
        kunyomi: ["の", "これ", "ゆく", "この"],
        examples: [
        { word: "天之御中主神", reading: "あめのみなかぬしのかみ", meaning: "Amenominakanushi (first god and the source of the universe according to Shinto)" },
        { word: "実業之日本社", reading: "じつぎょうのにほんしゃ", meaning: "Jitsugyo no Nihon Sha, Ltd. (name of a publishing company)" },
        { word: "美之主貝", reading: "びのすがい", meaning: "Mercenaria stimpsoni (species of Venus clam)" }
    ],
    },
    "乎": {
        onyomi: ["コ", "オ"],
        kunyomi: ["か", "ああ", "かな", "や", "よ", "��"],
        examples: [
        { word: "乎古止点", reading: "をことてん", meaning: "diacritical marks used for interpreting classical Chinese" },
        { word: "凛乎", reading: "りんこ", meaning: "commanding, awe-inspiring" },
        { word: "弖爾乎波", reading: "てにをは", meaning: "postpositions (in Japanese), particles" }
    ],
    },
    "乘": {
        onyomi: ["ジョウ"],
        kunyomi: ["の.る", "の.せる"],
        examples: [
        { word: "搭乘", reading: "とうじょう", meaning: "embarkation, boarding (a ship or aircraft)" },
        { word: "乘る", reading: "のる", meaning: "to get on (train, plane, bus, ship, etc.), to get in, to board" }
    ],
    },
    "也": {
        onyomi: ["ヤ", "エ"],
        kunyomi: ["なり", "か", "また"],
        examples: [
        { word: "��也餅", reading: "くうやもち", meaning: "chunky mochi made with half-polished rice, stuffed with red bean paste" },
        { word: "弱き者よ汝の名は女也", reading: "よわきものよなんじのなはおんななり", meaning: "frailty, thy name is woman" },
        { word: "也行", reading: "やぎょう", meaning: "the \"ya\" column of the Japanese syllabary table (ya, yu, yo)" }
    ],
    },
    "云": {
        onyomi: ["ウン"],
        kunyomi: ["い.う", "ここに"],
        examples: [
        { word: "云爾", reading: "うんじ", meaning: "such as" },
        { word: "云為", reading: "うんい", meaning: "sayings and doings, words and deeds" },
        { word: "云い古す", reading: "いいふるす", meaning: "to say repeatedly, to say proverbially" }
    ],
    },
    "亘": {
        onyomi: ["コウ", "カン", "セン"],
        kunyomi: ["わた.る", "もと.める"],
        examples: [
        { word: "連亘", reading: "れんこう", meaning: "extending in a row" },
        { word: "幾年にも亘る", reading: "いくねんにもわたる", meaning: "extending over a number of years" },
        { word: "亘古", reading: "こうこ", meaning: "for ever, from ancient times" }
    ],
    },
    "亙": {
        onyomi: ["コウ", "カン"],
        kunyomi: ["わた.る", "もと.め���"],
        examples: [
        { word: "聯亙", reading: "れんこう", meaning: "extending in a row" },
        { word: "幾年にも亙る", reading: "いくねんにもわたる", meaning: "extending over a number of years" },
        { word: "亙古", reading: "こうこ", meaning: "from long ago up until the present day" }
    ],
    },
    "些": {
        onyomi: ["サ", "シャ"],
        kunyomi: ["ち.と", "ち.っと", "いささか"],
        examples: [
        { word: "些末主義", reading: "さまつしゅ��", meaning: "trivialism" },
        { word: "も些", reading: "もちっと", meaning: "a little more, a bit more" },
        { word: "些", reading: "いさら", meaning: "small, little" }
    ],
    },
    "亞": {
        onyomi: ["ア"],
        kunyomi: ["つ.ぐ"],
        examples: [
        { word: "亞剌比亞", reading: "アラビア", meaning: "Arabia" },
        { word: "東亞", reading: "とうあ", meaning: "East Asia, the Orient" },
        { word: "亞", reading: "あ", meaning: "sub-, second-rate, inferior" }
    ],
    },
    "亥": {
        onyomi: ["ガイ", "カイ"],
        kunyomi: ["い"],
        examples: [
        { word: "亥の子の祝", reading: "いのこのいわい", meaning: "Day-of-the-Boar Festival" },
        { word: "己亥", reading: "つちのとい", meaning: "Earth Boar (36th term of the sexagenary cycle, e.g. 1959, 2019, 2079)" },
        { word: "丁亥", reading: "ていがい", meaning: "Fire Boar (24th term of the sexagenary cycle, e.g. 1947, 2007, 2067)" }
    ],
    },
    "亦": {
        onyomi: ["エキ", "ヤク"],
        kunyomi: ["また"],
        examples: [
        { word: "如露亦如電", reading: "にょろやくにょでん", meaning: "existence (as we perceive it) is as mutable and incorporeal as is the morning dew or a flash of lightning" },
        { word: "吾亦紅", reading: "われもこう", meaning: "great burnet (Sanguisorba officinalis)" },
        { word: "心頭滅却すれば火も亦涼し", reading: "しんとうめっきゃくすればひもまたすずし", meaning: "if you clear your mind of all worldly thoughts, even fire will feel cool" }
    ],
    },
    "亨": {
        onyomi: ["コウ", "キョウ", "ホウ"],
        kunyomi: ["とお.る"],
        examples: [
        { word: "元亨", reading: "げんこう", meaning: "Genkō era (1321.2.23-1324.12.9)" },
        { word: "亨運", reading: "こううん", meaning: "good fortune" },
        { word: "亨通", reading: "こうつう", meaning: "doing well, prosperous" }
    ],
    },
    "亮": {
        onyomi: ["リョウ"],
        kunyomi: ["あきらか"],
        examples: [
        { word: "亮月", reading: "りょうげつ", meaning: "bright moonlight" },
        { word: "瀏亮", reading: "りゅうりょう", meaning: "clear and resounding (as a voice or musical instrument)" },
        { word: "亮直", reading: "りょうちょく", meaning: "rightfulness" }
    ],
    },
    "仔": {
        onyomi: ["シ"],
        kunyomi: ["こ", "た.える"],
        examples: [
        { word: "仔鹿", reading: "こじか", meaning: "fawn" },
        { word: "仔羊", reading: "こひつじ", meaning: "lamb" },
        { word: "仔虫", reading: "しちゅう", meaning: "larva" }
    ],
    },
    "伊": {
        onyomi: ["イ"],
        kunyomi: ["かれ"],
        examples: [
        { word: "伊曽保物語", reading: "いそほものがたり", meaning: "Aesop's Fables (published initially by the Jesuits in 1593)" },
        { word: "伊集", reading: "いじゅ", meaning: "Chinese guger tree (Schima wallichii)" },
        { word: "伊吹", reading: "いぶき", meaning: "Chinese juniper (Juniperus chinensis)" }
    ],
    },
    "伍": {
        onyomi: ["ゴ"],
        kunyomi: ["いつつ"],
        examples: [
        { word: "伍長", reading: "ごちょう", meaning: "corporal" },
        { word: "伍", reading: "ご", meaning: "five, 5" },
        { word: "卒伍", reading: "そつご", meaning: "rank and file, the ranks" }
    ],
    },
    "伶": {
        onyomi: ["レイ", "リョウ"],
        kunyomi: ["わざおぎ"],
        examples: [
        { word: "伶人草", reading: "レイジンソウ", meaning: "Aconitum loczyanum (monkshood species)" },
        { word: "伶官", reading: "れいかん", meaning: "court musician" },
        { word: "伶人", reading: "れいじん", meaning: "court musician, minstrel" }
    ],
    },
    "伽": {
        onyomi: ["カ", "ガ", "キャ", "ギャ"],
        kunyomi: ["とぎ"],
        examples: [
        { word: "僧伽藍摩", reading: "そうがらんま", meaning: "Buddhist convent or monastery" },
        { word: "楞伽経", reading: "りょうがきょう", meaning: "Lankavatara Sutra" },
        { word: "七堂伽藍", reading: "しちどうがらん", meaning: "complete seven-structured temple compound" }
    ],
    },
    "佃": {
        onyomi: ["テン", "デン"],
        kunyomi: ["つくだ"],
        examples: [
        { word: "佃", reading: "つくだ", meaning: "cultivated rice field" },
        { word: "佃煮", reading: "つくだに", meaning: "preserved food boiled in sweetened soy sauce" }
    ],
    },
    "佑": {
        onyomi: ["ユウ", "ウ"],
        kunyomi: ["たす.ける"],
        examples: [
        { word: "佑助", reading: "ゆうじょ", meaning: "assistance" },
        { word: "采女佑", reading: "うねめのしょう", meaning: "high-ranking staff member in the Office of Court Ladies (ritsuryō system)" },
        { word: "天佑神助", reading: "てんゆうしんじょ", meaning: "divine grace, God's help" }
    ],
    },
    "佛": {
        onyomi: ["ブツ", "フツ"],
        kunyomi: ["ほとけ"],
        examples: [
        { word: "佛陀", reading: "ブッダ", meaning: "Buddha" },
        { word: "佛教", reading: "ぶっきょう", meaning: "Buddhism" },
        { word: "佛教大学", reading: "ぶっきょうだいがく", meaning: "Bukkyo University" }
    ],
    },
    "侃": {
        onyomi: ["カン"],
        kunyomi: ["つよ.い"],
        examples: [
        { word: "侃直", reading: "かんちょく", meaning: "firm and upright (character)" },
        { word: "侃々諤々", reading: "かんかんがくがく", meaning: "outspoken, arguing (heatedly) what one believes in, insisting on something without restraint" }
    ],
    },
    "來": {
        onyomi: ["ライ", "タイ"],
        kunyomi: ["く.る", "きた.る", "きた.す", "��.たす", "き.たる"],
        examples: [
        { word: "來月", reading: "���いげつ", meaning: "next month" },
        { word: "來年", reading: "らいねん", meaning: "next year" },
        { word: "從來農法", reading: "じゅうらいのうほう", meaning: "traditional farming" }
    ],
    },
    "侑": {
        onyomi: ["ユウ", "ウ"],
        kunyomi: ["すす.める", "たす.ける"],
        examples: [
        { word: "侑觴", reading: "ゆうしょう", meaning: "urging one to drink more good wine during a banquet" }
    ],
    },
    "俄": {
        onyomi: ["ガ"],
        kunyomi: ["にわか"],
        examples: [
        { word: "俄か勉強", reading: "に���かべんきょう", meaning: "cramming" },
        { word: "俄か分限", reading: "にわかぶげん", meaning: "mushroom millionaire" },
        { word: "俄か成金", reading: "にわかなりきん", meaning: "overnight millionaire" }
    ],
    },
    "俐": {
        onyomi: ["リ"],
        kunyomi: ["かしこ.い"],
        examples: [
        { word: "伶俐", reading: "れいり", meaning: "clever, bright, sharp" }
    ],
    },
    "俠": {
        onyomi: ["キョウ", "キャン"],
        kunyomi: ["おとこだて"],
        examples: [
        { word: "俠友会", reading: "きょうゆうかい", meaning: "Kyoyukai (Hyogo-based yakuza syndicate)" },
        { word: "俠道会", reading: "きょうどうかい", meaning: "Kyōdō-kai (yakuza syndicate)" },
        { word: "義俠心", reading: "ぎきょうしん", meaning: "chivalrous spirit" }
    ],
    },
    "俣": {
        onyomi: [],
        kunyomi: ["また"],
        examples: [
        { word: "水俣病", reading: "みなまたびょう", meaning: "Minamata disease" },
        { word: "第二水俣病", reading: "だいにみなまたびょう", meaning: "Niigata Minamata disease" },
        { word: "俣", reading: "また", meaning: "groin, thigh, crotch" }
    ],
    },
    "俱": {
        onyomi: ["ク"],
        kunyomi: ["ともに"],
        examples: [
        { word: "俱利迦羅竜王", reading: "くりからりゅうおう", meaning: "Dragon King Kulika, manifestation of Acala in the form of a flame-wreathed dragon wrapped around and swallowing the tip of an upright sword" },
        { word: "俱利迦羅", reading: "くりから", meaning: "Kulika, manifestation of Acala in the form of a flame-wreathed dragon wrapped around and swallowing the tip of an upright sword" },
        { word: "俱利迦羅紋紋", reading: "くりからもんもん", meaning: "tattoo (esp. one of a flame-wreathed dragon wrapped around and swallowing the tip of an upright sword), person with a tattoo" }
    ],
    },
    "倖": {
        onyomi: ["コウ"],
        kunyomi: ["しあわ.せ", "さいわ.い"],
        examples: [
        { word: "射倖契約", reading: "しゃこうけいやく", meaning: "aleatory contract" },
        { word: "射倖", reading: "しゃこう", meaning: "speculation" },
        { word: "恩倖", reading: "おんこう", meaning: "the emperor's personal favour" }
    ],
    },
    "倦": {
        onyomi: ["ケン"],
        kunyomi: ["あき.る", "あぐ.む", "あ���.ねる", "う.む", "つか.れる"],
        examples: [
        { word: "倦憊", reading: "けんぱい", meaning: "extreme fatigue" },
        { word: "探し倦ねる", reading: "さがしあぐねる", meaning: "to give up searching (for someone or something)" },
        { word: "待ち倦む", reading: "まちあぐむ", meaning: "to tire of waiting" }
    ],
    },
    "倭": {
        onyomi: ["ワ", "イ"],
        kunyomi: ["やまと", "したが.う"],
        examples: [
        { word: "倭国", reading: "わこく", meaning: "Japan" },
        { word: "倭名", reading: "わみょう", meaning: "Japanese name (esp. for a plant or animal)" },
        { word: "倭人", reading: "わじん", meaning: "Japanese person" }
    ],
    },
    "偲": {
        onyomi: ["サイ", "シ"],
        kunyomi: ["しの.ぶ"],
        examples: [
        { word: "故人を偲ぶ", reading: "こじんをしのぶ", meaning: "to think of the dead" },
        { word: "偲ぶ会", reading: "しのぶかい", meaning: "gathering to remember a dead person, memorial meeting" },
        { word: "偲ばれる", reading: "しのばれる", meaning: "to be brought to mind, to come to mind" }
    ],
    },
    "傭": {
        onyomi: ["ヨウ", "チョウ"],
        kunyomi: ["やと.う", "あた.い", "ひと.���い"],
        examples: [
        { word: "スイス傭兵", reading: "スイスようへい", meaning: "Swiss guard" },
        { word: "裸傭船", reading: "はだかようせん", meaning: "bareboat charter" },
        { word: "傭船契約", reading: "ようせんけいやく", meaning: "chartering ships" }
    ],
    },
    "傳": {
        onyomi: ["テン", "デン"],
        kunyomi: ["つた.わる", "つた.える", "つた.う", "つて"],
        examples: [
        { word: "先哲像傳", reading: "せんてつぞうでん", meaning: "Pictures of Ancient Wise Men" },
        { word: "景徳傳燈録", reading: "けいとくでんとうろく", meaning: "Transmission of the Lamp (collection of biographies of famous Zen masters), Record of the Transmission of the Lamp" },
        { word: "南總里見八犬傳", reading: "なんそうさとみはっけんでん", meaning: "Nansō Satomi Hakkenden (1814-42; novel in 106 volumes by Kyokutei Bakin), Eight Dog Chronicles, Tale of Eight Dogs" }
    ],
    },
    "僞": {
        onyomi: ["ギ", "カ"],
        kunyomi: ["いつわ.る", "いつわ.り", "にせ"],
        examples: [],
    },
    "價": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["あたい"],
        examples: [
        { word: "價", reading: "あたい", meaning: "price, cost, value" }
    ],
    },
    "儉": {
        onyomi: ["ケン"],
        kunyomi: ["つま.しい", "つづまやか"],
        examples: [],
    },
    "儲": {
        onyomi: ["チョ"],
        kunyomi: ["もう.ける", "もう.か���", "もうけ", "たくわ.える"],
        examples: [
        { word: "儲かりまっか", reading: "もうかりまっか", meaning: "Are you making money?" },
        { word: "坊主丸儲け", reading: "ぼうずまるもうけ", meaning: "a monk's earnings are pure profit (due to needing no capital and having no expenses)" },
        { word: "浮名儲け", reading: "うきなもうけ", meaning: "gaining (in prestige, etc.) from being named in a love rumor" }
    ],
    },
    "允": {
        onyomi: ["イン"],
        kunyomi: ["じょう", "まこと.に", "ゆるす"],
        examples: [
        { word: "允文允武", reading: "いんぶんいんぶ", meaning: "being versed in the literary and military arts" },
        { word: "雅楽允", reading: "うたのじょう", meaning: "second assistant court musician (ritsuryō system)" },
        { word: "承允", reading: "しょういん", meaning: "consent, acceptance, agreement" }
    ],
    },
    "兎": {
        onyomi: ["ト", "ツ"],
        kunyomi: ["うさぎ"],
        examples: [
        { word: "兎菊", reading: "ウサギギク", meaning: "Alaskan arnica (Arnica unalascensis)" },
        { word: "アンゴラ兎", reading: "アンゴラうさぎ", meaning: "Angora rabbit" },
        { word: "北極野兎", reading: "ほっきょくのうさぎ", meaning: "Arctic hare (Lepus arcticus)" }
    ],
    },
    "兒": {
        onyomi: ["ジ", "ニ", "ゲイ"],
        kunyomi: ["こ"],
        examples: [
        { word: "鹿兒島", reading: "かごしま", meaning: "Kagoshima (city, prefecture)" },
        { word: "鹿兒島縣", reading: "かごしまけん", meaning: "Kagoshima Prefecture (Kyūshū)" }
    ],
    },
    "兜": {
        onyomi: ["トウ", "ト"],
        kunyomi: ["かぶと"],
        examples: [
        { word: "ヘラクレス大兜", reading: "ヘラクレスオオカブト", meaning: "Hercules beetle (Dynastes hercules)" },
        { word: "露兜樹", reading: "たこのき", meaning: "Pandanus boninensis (species of screw pine)" },
        { word: "兜率", reading: "とそつ", meaning: "Tusita (heaven, pure land)" }
    ],
    },
    "其": {
        onyomi: ["キ", "ギ", "ゴ"],
        kunyomi: ["それ", "その"],
        examples: [
        { word: "其処に山があるから", reading: "そこにやまがあるから", meaning: "because it's there" },
        { word: "其色月", reading: "そのいろづき", meaning: "eighth month of the lunar calendar" },
        { word: "其れなればこそ", reading: "それなればこそ", meaning: "for that very reason" }
    ],
    },
    "冨": {
        onyomi: ["フ", "フウ"],
        kunyomi: ["と.む", "とみ"],
        examples: [
        { word: "豆冨", reading: "とうふ", meaning: "tofu, bean curd, beancurd" },
        { word: "冨有", reading: "ふゆう", meaning: "wealthy, rich, affluent" }
    ],
    },
    "冴": {
        onyomi: ["ゴ", "コ"],
        kunyomi: ["さ.える", "こお.る", "ひ.える"],
        examples: [
        { word: "頭の冴え", reading: "あたまのさえ", meaning: "bright intelligence" },
        { word: "冴寒", reading: "ごかん", meaning: "extreme cold" },
        { word: "頭が冴える", reading: "あたまがさえる", meaning: "to be clear-headed" }
    ],
    },
    "凉": {
        onyomi: ["リョウ"],
        kunyomi: ["すず.しい", "すず.む", "すず.��か", "うす.い", "ひや.す", "まことに"],
        examples: [
        { word: "爽凉", reading: "そうりょう", meaning: "cool and refreshing" },
        { word: "凉", reading: "りょう", meaning: "cool breeze, cool air, refreshing coolness" },
        { word: "凉む", reading: "すずむ", meaning: "to cool oneself, to cool off, to enjoy the cool air" }
    ],
    },
    "凌": {
        onyomi: ["リョウ"],
        kunyomi: ["しの.ぐ"],
        examples: [
        { word: "凌霄", reading: "りょうしょう", meaning: "Chinese trumpet creeper (Campsis grandiflora)" },
        { word: "凌霄花", reading: "のうぜんかずら", meaning: "Chinese trumpet creeper (Campsis grandiflora)" },
        { word: "口凌ぎ", reading: "くちしのぎ", meaning: "living from hand to mouth" }
    ],
    },
    "凛": {
        onyomi: ["リン"],
        kunyomi: ["きびし.い"],
        examples: [
        { word: "寒気凛々", reading: "かんきりんりん", meaning: "it (the weather) being piercing (bitterly) cold" },
        { word: "凛乎", reading: "りんこ", meaning: "commanding, awe-inspiring" },
        { word: "凛冽", reading: "りんれつ", meaning: "biting (cold), severe, intense" }
    ],
    },
    "凜": {
        onyomi: ["リン"],
        kunyomi: ["きびし.い"],
        examples: [
        { word: "凜乎", reading: "りん��", meaning: "commanding, awe-inspiring" },
        { word: "凜烈", reading: "りんれつ", meaning: "biting (cold), severe, intense" },
        { word: "勇気凜凜", reading: "ゆうきりんりん", meaning: "full of spirit, brimming with courage, high-spirited" }
    ],
    },
    "凧": {
        onyomi: [],
        kunyomi: ["いかのぼり", "たこ"],
        examples: [
        { word: "和凧", reading: "わだこ", meaning: "Japanese kite" },
        { word: "凧", reading: "いかのぼり", meaning: "kite" },
        { word: "凧揚げ", reading: "たこあげ", meaning: "kite flying" }
    ],
    },
    "凪": {
        onyomi: [],
        kunyomi: ["なぎ", "な.ぐ"],
        examples: [
        { word: "逆凪", reading: "さかなぎ", meaning: "backfire (of a spell, curse, etc.)" },
        { word: "夜凪", reading: "よなぎ", meaning: "evening calm" },
        { word: "夕凪", reading: "ゆうなぎ", meaning: "evening calm" }
    ],
    },
    "凰": {
        onyomi: ["コウ", "オウ"],
        kunyomi: ["おおとり"],
        examples: [
        { word: "鳳凰竹", reading: "ほうおうちく", meaning: "Bambusa multiplex var. elegans (variety of hedge bamboo)" },
        { word: "鳳凰文", reading: "ほうおうもん", meaning: "Chinese phoenix pattern" },
        { word: "鳳凰丸", reading: "ほうおうまる", meaning: "Hōō Maru (Western-style Japanese frigate, launched in 1853)" }
    ],
    },
    "凱": {
        onyomi: ["ガイ", "カイ"],
        kunyomi: ["かちどき", "やわらぐ"],
        examples: [
        { word: "凱旋���演", reading: "がいせんこうえん", meaning: "performance given after a successful tour abroad" },
        { word: "凱旋軍", reading: "がいせんぐん", meaning: "returning victorious army" },
        { word: "凱風", reading: "がいふう", meaning: "southerly wind" }
    ],
    },
    "函": {
        onyomi: ["カン"],
        kunyomi: ["はこ", "い.れる"],
        examples: [
        { word: "製函", reading: "せいかん", meaning: "(cardboard) box manufacture" },
        { word: "函館戦争", reading: "はこだてせんそう", meaning: "Battle of Hakodate (battle of the Boshin War; 1868-1869)" },
        { word: "函館", reading: "はこだて", meaning: "Hakodate (city in Hokkaido)" }
    ],
    },
    "剩": {
        onyomi: ["ジョウ"],
        kunyomi: ["あまつさえ", "あま.り", "あま.る"],
        examples: [],
    },
    "劉": {
        onyomi: ["リュウ", "ル"],
        kunyomi: ["ころ.す"],
        examples: [],
    },
    "劍": {
        onyomi: ["ケン"],
        kunyomi: ["つるぎ"],
        examples: [
        { word: "劍", reading: "けん", meaning: "sword (esp. a large, double-edged one), blade, bayonet" }
    ],
    },
    "劫": {
        onyomi: ["コウ", "ゴウ", "キョウ"],
        kunyomi: ["おびや.かす"],
        examples: [
        { word: "塵劫記", reading: "じんこうき", meaning: "Jinkōki (1627 Japanese mathematics text by Yoshida Kōyū)" },
        { word: "両劫", reading: "りょうこう", meaning: "double ko" },
        { word: "劫罰", reading: "ごうばつ", meaning: "eternal punishment" }
    ],
    },
    "勁": {
        onyomi: ["ケイ"],
        kunyomi: ["つよ.い"],
        examples: [
        { word: "勁敵", reading: "けいてき", meaning: "formidable foe" },
        { word: "勁悍", reading: "けいかん", meaning: "strong and fierce" },
        { word: "勁捷", reading: "けいしょう", meaning: "strong and nimble" }
    ],
    },
    "勳": {
        onyomi: ["クン"],
        kunyomi: ["いさお"],
        examples: [
        { word: "武勳", reading: "ぶくん", meaning: "feats of arms, military exploits, distinguished military service" }
    ],
    },
    "勺": {
        onyomi: ["シャク"],
        kunyomi: [],
        examples: [
        { word: "宝玉と勺杖", reading: "ほうぎょくとしゃくじょう", meaning: "Orb and Sceptre (march by Sir William Walton)" },
        { word: "一勺", reading: "いっしゃく", meaning: "one shaku" },
        { word: "勺", reading: "しゃく", meaning: "shaku, traditional unit of volume, approx. 18 ml, shaku" }
    ],
    },
    "勿": {
        onyomi: ["モチ", "ブツ", "ボツ"],
        kunyomi: ["なか.れ", "なし"],
        examples: [
        { word: "恐るる勿れ", reading: "���そるるなかれ", meaning: "Be not afraid" },
        { word: "勿吉", reading: "もっきつ", meaning: "Mohe (one of the Tungusic-speaking tribes)" },
        { word: "己に如かざる者を友とする勿れ", reading: "おのれにしかざるものをともとするなかれ", meaning: "do not befriend those beneath you" }
    ],
    },
    "匁": {
        onyomi: [],
        kunyomi: ["もんめ", "め"],
        examples: [
        { word: "百匁", reading: "ひゃくもんめ", meaning: "375 grams (100 monme)" },
        { word: "花一匁", reading: "はないちもんめ", meaning: "children's game in which two groups compete for members by playing janken" },
        { word: "匁", reading: "もんめ", meaning: "monme (unit of weight, 3.75 g), monme, Edo-period silver coin worth between 1/50th and 1/80th of a ryō" }
    ],
    },
    "匡": {
        onyomi: ["キョウ", "オウ"],
        kunyomi: ["すく.う", "ただ.す"],
        examples: [
        { word: "匡救", reading: "きょうきゅう", meaning: "delivering from sin, succor, succour" },
        { word: "匡正", reading: "きょうせい", meaning: "correction (of a fault, mistake, flaw, etc.), remedy, rectification" },
        { word: "匡体", reading: "きょうたい", meaning: "case (of a machine, computer, etc.), casing, cabinet (arcade games)" }
    ],
    },
    "卜": {
        onyomi: ["ボク"],
        kunyomi: ["うらな.う", "うらない"],
        examples: [
        { word: "卜伝流", reading: "ぼくでんりゅう", meaning: "Shinto-ryu (school of kenjutsu)" },
        { word: "卜居", reading: "ぼっきょ", meaning: "choosing a homesite by divination" },
        { word: "卜定", reading: "ぼくじょう", meaning: "deciding through (tortoise-shell) divination" }
    ],
    },
    "卯": {
        onyomi: ["ボウ", "モウ"],
        kunyomi: ["う"],
        examples: [
        { word: "己卯", reading: "つちのとう", meaning: "Earth Rabbit (16th term of the sexagenary cycle, e.g. 1939, 1999, 2059)" },
        { word: "丁卯", reading: "ひのとう", meaning: "Fire Rabbit (4th term of the sexagenary cycle, e.g. 1927, 1987, 2047)" },
        { word: "辛卯", reading: "かのとう", meaning: "Metal Rabbit (28th term of the sexagenary cycle, e.g. 1951, 2011, 2071)" }
    ],
    },
    "卷": {
        onyomi: ["カン", "ケン"],
        kunyomi: ["ま.く", "まき"],
        examples: [],
    },
    "卽": {
        onyomi: ["ソク", "ショク"],
        kunyomi: ["つ.く", "すなわ.ち", "もし"],
        examples: [],
    },
    "卿": {
        onyomi: ["ケイ", "キョウ"],
        kunyomi: ["きみ"],
        examples: [
        { word: "枢機卿", reading: "すうききょう", meaning: "cardinal (Catholic Church)" },
        { word: "月卿雲客", reading: "げっけいうんかく", meaning: "court nobles and other courtiers allowed into the Imperial Palace" },
        { word: "卿相", reading: "けいしょう", meaning: "court nobles and state ministers" }
    ],
    },
    "厨": {
        onyomi: ["シュウ", "ズ", "チュ", "チュウ"],
        kunyomi: ["くりや"],
        examples: [
        { word: "硬派厨", reading: "こうはちゅう", meaning: "Internet tough guy" },
        { word: "厨子棚", reading: "ずしだな", meaning: "cabinet with double doors (used by the nobility to store books, etc.)" },
        { word: "厨子甕", reading: "ずしがめ", meaning: "decorated pottery container for storing the bones of one's ancestors (Okinawa)" }
    ],
    },
    "厩": {
        onyomi: ["キュウ"],
        kunyomi: ["うまや"],
        examples: [
        { word: "厩肥", reading: "きゅうひ", meaning: "manure" },
        { word: "厩出し", reading: "うまやだし", meaning: "releasing livestock to graze in spring" },
        { word: "厩", reading: "うまや", meaning: "stable, barn" }
    ],
    },
    "叉": {
        onyomi: ["サ", "シャ", "サイ"],
        kunyomi: ["また"],
        examples: [
        { word: "夜叉五倍子", reading: "やしゃぶし", meaning: "Alnus firma (species of alder)" },
        { word: "桧葉叉", reading: "ひばまた", meaning: "Arctic wrack (Fucus evanescens)" },
        { word: "犬夜叉", reading: "いぬやしゃ", meaning: "Inuyasha (manga series)" }
    ],
    },
    "叡": {
        onyomi: ["エイ"],
        kunyomi: ["あき.らか"],
        examples: [
        { word: "叡聞に", reading: "えいぶんに", meaning: "(in the) emperor's hearing" },
        { word: "叡王", reading: "えいおう", meaning: "Eiō (one of the eight major professional titles of shogi)" },
        { word: "比叡山", reading: "ひえいざん", meaning: "Mt. Hiei (in Kyoto)" }
    ],
    },
    "叢": {
        onyomi: ["ソウ", "ス"],
        kunyomi: ["くさむら", "むら.がる", "むら"],
        examples: [
        { word: "叢雲剣", reading: "むらくものつるぎ", meaning: "Murakumo no Tsurugi (alternate name for Ama-no-Murakumo no Tsurugi; the sword of the Imperial regalia)" },
        { word: "竹叢", reading: "たかむら", meaning: "bamboo grove" },
        { word: "腕神経叢", reading: "わんしんけいそう", meaning: "brachial plexus" }
    ],
    },
    "只": {
        onyomi: ["シ"],
        kunyomi: ["ただ"],
        examples: [
        { word: "只乗り", reading: "ただのり", meaning: "free ride (e.g. on train)" },
        { word: "只取り", reading: "ただどり", meaning: "getting something for nothing" },
        { word: "只今", reading: "しこん", meaning: "just now" }
    ],
    },
    "叶": {
        onyomi: ["キョウ"],
        kunyomi: ["かな.える", "かな.う"],
        examples: [
        { word: "願ったり叶ったり", reading: "ねがったりかなったり", meaning: "everything working out as desired" },
        { word: "叶わぬ夢", reading: "かなわぬゆめ", meaning: "impossible dream" },
        { word: "叶わぬ時の神頼み", reading: "かなわぬときのかみだのみ", meaning: "turning to God only in one's trouble" }
    ],
    },
    "吞": {
        onyomi: ["ドン", "トン", "テン"],
        kunyomi: ["のむ"],
        examples: [
        { word: "吞舟", reading: "どんしゅう", meaning: "swallowing a boat whole" },
        { word: "湯吞み茶碗", reading: "ゆのみぢゃわん", meaning: "teacup (small, without a handle)" },
        { word: "固唾を吞む", reading: "かたずをのむ", meaning: "to hold one's breath (in fear, anxiety, etc.)" }
    ],
    },
    "吻": {
        onyomi: ["フン", "ブン"],
        kunyomi: ["くちわき", "くちさき"],
        examples: [
        { word: "チ吻", reading: "チふん", meaning: "Chiwen (Chinese dragon)" },
        { word: "動吻動物", reading: "どうふんどうぶつ", meaning: "Kinorhyncha (phylum of marine invertebrates)" },
        { word: "吻殻綱", reading: "ふんかくこう", meaning: "Rostroconchia (class of extinct molluscs)" }
    ],
    },
    "吾": {
        onyomi: ["ゴ"],
        kunyomi: ["われ", "わが-", "あ-"],
        examples: [
        { word: "吾妻菊", reading: "アズマギク", meaning: "Erigeron thunbergii (species of flowering plant)" },
        { word: "吾輩は猫である", reading: "わがはいはねこである", meaning: "I Am a Cat (1906 novel by Natsume Soseki)" },
        { word: "吾妻鏡", reading: "あずまかがみ", meaning: "Japanese medieval text that chronicles events of the Kamakura Shogunate" }
    ],
    },
    "哉": {
        onyomi: ["サイ"],
        kunyomi: ["かな", "や"],
        examples: [
        { word: "已んぬる哉", reading: "やんぬるかな", meaning: "I give up" },
        { word: "候哉", reading: "そうろうや", meaning: "I wonder if ..." },
        { word: "果たせる哉", reading: "はたせるかな", meaning: "as expected" }
    ],
    },
    "哨": {
        onyomi: ["ショウ"],
        kunyomi: ["みはり"],
        examples: [
        { word: "民間空中哨戒部隊", reading: "みんかんくうちゅうしょうかいぶたい", meaning: "Civil Air Patrol" },
        { word: "哨吶草", reading: "チャルメルそう", meaning: "Mitella stylosa (species of miterwort)" },
        { word: "対潜哨戒機", reading: "たいせんしょうかいき", meaning: "antisubmarine patrol plane" }
    ],
    },
    "哩": {
        onyomi: ["リ"],
        kunyomi: ["まいる"],
        examples: [
        { word: "哩", reading: "マイル", meaning: "mile" },
        { word: "咖哩", reading: "カレー", meaning: "curry (esp. Japanese curry), rice and curry" }
    ],
    },
    "啄": {
        onyomi: ["タク", "ツク", "トク"],
        kunyomi: ["ついば.む", "つつ.く"],
        examples: [
        { word: "野口啄木鳥", reading: "のぐちげら", meaning: "Okinawa woodpecker (Sapheopipo noguchii)" },
        { word: "団栗啄木鳥", reading: "どんぐりきつつき", meaning: "acorn woodpecker (Melanerpes formicivorus)" },
        { word: "熊啄木鳥", reading: "くまげら", meaning: "black woodpecker (Dryocopus martius)" }
    ],
    },
    "喋": {
        onyomi: ["チョウ", "トウ"],
        kunyomi: ["しゃべ.る", "ついば.む"],
        examples: [
        { word: "喋々喃々", reading: "ちょうちょうなんなん", meaning: "billing and cooing, holding an intimate, long-winded conversation in whispers" },
        { word: "喋り", reading: "しゃべり", meaning: "talk, chat" },
        { word: "喋りまくる", reading: "しゃべりまくる", meaning: "to talk on and on, to talk one's head off" }
    ],
    },
    "喧": {
        onyomi: ["ケン"],
        kunyomi: ["やかま.しい", "かまびす.しい"],
        examples: [
        { word: "金持ち喧嘩せず", reading: "かねもちけんかせず", meaning: "a rich man never quarrels" },
        { word: "喧嘩沙汰", reading: "けんかざた", meaning: "beginning (developing into) a quarrel (a fight, an altercation)" },
        { word: "水喧嘩", reading: "みずげんか", meaning: "dispute over the distribution of water into paddies during the summer (in rural areas)" }
    ],
    },
    "喬": {
        onyomi: ["キョウ"],
        kunyomi: ["たか.い"],
        examples: [
        { word: "落葉喬木", reading: "らくようきょうぼく", meaning: "deciduous tall tree" },
        { word: "喬志", reading: "きょうし", meaning: "pride, self-conceit" },
        { word: "喬木", reading: "きょうぼく", meaning: "tall tree, forest tree, arbor" }
    ],
    },
    "單": {
        onyomi: ["タン"],
        kunyomi: ["ひとえ"],
        examples: [
        { word: "單槍匹馬", reading: "たんそうひつば", meaning: "doing something on one's own without another's help" },
        { word: "菜單", reading: "さいたん", meaning: "menu (at a Chinese restaurant)" },
        { word: "單獨行", reading: "たんどくこう", meaning: "solo hiking, solo climbing, solo travel" }
    ],
    },
    "喰": {
        onyomi: [],
        kunyomi: ["く.う", "く.らう"],
        examples: [
        { word: "羽衣虫喰", reading: "はごろもむしくい", meaning: "American redstart (Setophaga ruticilla)" },
        { word: "稲根喰葉虫", reading: "いねねくいはむし", meaning: "Donacia provostii (species of leaf beetle)" },
        { word: "襤褸団扇船喰虫", reading: "ぼろうちわふなくいむし", meaning: "Uperotus clava (species of shipworm)" }
    ],
    },
    "嘉": {
        onyomi: ["カ"],
        kunyomi: ["よみ.する", "よい"],
        examples: [
        { word: "嘉永", reading: "かえい", meaning: "Kaei era (1848.2.28-1854.11.27)" },
        { word: "嘉悦女子中学校", reading: "かえつじょしちゅうがっこう", meaning: "Kaetsu Girls' Junior High School" },
        { word: "嘉悦女子高等学校", reading: "かえつじょしこうとうがっこう", meaning: "Kaetsu Girls' Senior High School" }
    ],
    },
    "嘗": {
        onyomi: ["ショウ", "ジョウ"],
        kunyomi: ["かつ.て", "こころ.みる", "な.める"],
        examples: [
        { word: "大嘗会", reading: "だ��じょうえ", meaning: "banquet on the occasion of the first ceremonial offering of rice by the newly enthroned emperor" },
        { word: "新嘗祭", reading: "にいなめさい", meaning: "ceremonial offering to the deities by the Emperor of newly-harvested rice" },
        { word: "新嘗", reading: "にいなめ", meaning: "ceremonial offering to the deities by the Emperor of newly-harvested rice" }
    ],
    },
    "嘩": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["かまびす.しい"],
        examples: [
        { word: "金持ち喧嘩せず", reading: "かねもちけんかせず", meaning: "a rich man never quarrels" },
        { word: "喧嘩沙汰", reading: "けんかざた", meaning: "beginning (developing into) a quarrel (a fight, an altercation)" },
        { word: "水喧嘩", reading: "みずげんか", meaning: "dispute over the distribution of water into paddies during the summer (in rural areas)" }
    ],
    },
    "噂": {
        onyomi: ["ソン"],
        kunyomi: ["うわさ"],
        examples: [
        { word: "噂話", reading: "うわさばなし", meaning: "gossip" },
        { word: "噂に違わぬ", reading: "うわさにたがわぬ", meaning: "living up to (one's, its) reputation" },
        { word: "噂をすれば影", reading: "うわさをすればかげ", meaning: "speak of the devil" }
    ],
    },
    "噌": {
        onyomi: ["ソウ", "ショウ", "ソ"],
        kunyomi: ["かまびす.しい"],
        examples: [
        { word: "麦味噌", reading: "むぎみそ", meaning: "barley miso" },
        { word: "田舎味噌", reading: "いなかみそ", meaning: "barley miso" },
        { word: "泣き味噌", reading: "なきみそ", meaning: "crybaby" }
    ],
    },
    "嚴": {
        onyomi: ["ゲン", "ゴン"],
        kunyomi: ["おごそ.か", "きび.しい", "いか.めしい", "いつくし"],
        examples: [],
    },
    "圃": {
        onyomi: ["ホ", "フ"],
        kunyomi: ["はたけ", "にわ"],
        examples: [
        { word: "玄圃梨", reading: "けんぽなし", meaning: "Japanese raisin tree (Hovenia dulcis)" },
        { word: "圃場", reading: "ほじょう", meaning: "cultivated land (field, garden, orchard, etc.)" },
        { word: "花圃", reading: "かほ", meaning: "flower garden" }
    ],
    },
    "圈": {
        onyomi: ["ケン"],
        kunyomi: ["かこ.い"],
        examples: [],
    },
    "國": {
        onyomi: ["コク"],
        kunyomi: ["くに"],
        examples: [
        { word: "樞軸國", reading: "すうじくこく", meaning: "Axis powers (World War II)" },
        { word: "日本國憲法", reading: "にほんこくけんぽう", meaning: "Constitution of Japan" },
        { word: "真・三國無双", reading: "しんさんごくぶそう", meaning: "Dynasty Warriors (video game series)" }
    ],
    },
    "圓": {
        onyomi: ["エン"],
        kunyomi: ["まる.い", "まる", "まど", "まど.か", "まろ.やか"],
        examples: [
        { word: "湯圓", reading: "タンエン", meaning: "tangyuan (rice flour dumpling), tang yuan" },
        { word: "圓", reading: "えん", meaning: "yen (currency of Japan), circle" }
    ],
    },
    "團": {
        onyomi: ["ダン", "トン"],
        kunyomi: ["かたまり", "まる.い"],
        examples: [
        { word: "團平喜佐古", reading: "だんべいきさご", meaning: "Umbonium giganteum (species of sea snail)" }
    ],
    },
    "圭": {
        onyomi: ["ケイ", "ケ"],
        kunyomi: [],
        examples: [
        { word: "巴拉圭", reading: "パラグアイ", meaning: "Paraguay" },
        { word: "刀圭家", reading: "とうけいか", meaning: "doctor" },
        { word: "圭璧", reading: "けいへき", meaning: "ritual jades worn by feudal lords in ancient China" }
    ],
    },
    "坐": {
        onyomi: ["ザ", "サ"],
        kunyomi: ["すわ.る", "おわす", "そぞろに", "まします"],
        examples: [
        { word: "坐乗", reading: "ざじょう", meaning: "(commander, visiting dignitary) going on board (warship, plane)" },
        { word: "坐法", reading: "ざほう", meaning: "(formal) ways of sitting" },
        { word: "憑坐", reading: "よりまし", meaning: "child or doll used as a vessel for a spirit invoked by a shaman or miko" }
    ],
    },
    "坦": {
        onyomi: ["タン"],
        kunyomi: ["たいら"],
        examples: [
        { word: "亜富汗斯坦", reading: "アフガニスタン", meaning: "Afghanistan" },
        { word: "平坦加群", reading: "へいたんかぐん", meaning: "flat module" },
        { word: "坦懐", reading: "たんかい", meaning: "level emotion, frankness" }
    ],
    },
    "埜": {
        onyomi: ["ヤ", "ショ"],
        kunyomi: ["の"],
        examples: [
        { word: "埜", reading: "や", meaning: "plain, field, being outside the government" }
    ],
    },
    "埴": {
        onyomi: ["ショク"],
        kunyomi: ["はに", "へな"],
        examples: [
        { word: "埴生の宿", reading: "はにゅうのやど", meaning: "Home, Sweet Home" },
        { word: "埴土", reading: "へなつち", meaning: "clay" },
        { word: "埴生", reading: "はにゅう", meaning: "clay soil" }
    ],
    },
    "堯": {
        onyomi: ["ギョウ"],
        kunyomi: ["たか.い"],
        examples: [],
    },
    "堰": {
        onyomi: ["エン"],
        kunyomi: ["せき", "せ.く"],
        examples: [
        { word: "堰止湖", reading: "せきとめこ", meaning: "dammed lake (formed by natural damming of a river, esp. by landslide, volcanic eruption, etc.)" },
        { word: "堰塞", reading: "えんそく", meaning: "damming (e.g. a pond)" },
        { word: "土堰堤", reading: "どえんてい", meaning: "earthfill dam" }
    ],
    },
    "堵": {
        onyomi: ["ト"],
        kunyomi: ["かき"],
        examples: [
        { word: "本領安堵", reading: "ほんりょうあんど", meaning: "recognition and guarantee, by the shogunate, of ownership of the inherited estate of a samurai who pledged allegiance to it (in the Kamakura and early Muromachi periods)" },
        { word: "堵の如し", reading: "とのごとし", meaning: "in crowds (of spectators), in great numbers" },
        { word: "安堵感", reading: "あんどかん", meaning: "sense of relief, feeling of relief" }
    ],
    },
    "堺": {
        onyomi: ["カイ"],
        kunyomi: ["さかい"],
        examples: [
        { word: "国堺", reading: "こっかい", meaning: "border (between countries), national border" },
        { word: "堺流", reading: "さかいりゅう", meaning: "Sakai school of tea ceremony, Sakai school of calligraphy" }
    ],
    },
    "塙": {
        onyomi: ["カク", "コウ"],
        kunyomi: ["はなわ", "かた.い"],
        examples: [],
    },
    "增": {
        onyomi: ["ゾウ", "ソウ"],
        kunyomi: ["ます", "ふえる", "ふやす"],
        examples: [],
    },
    "壕": {
        onyomi: ["コウ", "ゴウ"],
        kunyomi: ["ほり"],
        examples: [
        { word: "掩壕", reading: "えんごう", meaning: "cover trench" },
        { word: "外壕", reading: "そとぼり", meaning: "outer moat (of a castle)" },
        { word: "壕跡", reading: "ごうあと", meaning: "remains of a dugout (usu. military)" }
    ],
    },
    "壘": {
        onyomi: ["ルイ", "ライ", "スイ"],
        kunyomi: ["とりで"],
        examples: [],
    },
    "壞": {
        onyomi: ["カイ", "エ"],
        kunyomi: ["こわ.す", "こわ.れる", "やぶ.る"],
        examples: [],
    },
    "壬": {
        onyomi: ["ニン", "ジン", "イ"],
        kunyomi: ["みずのえ"],
        examples: [
        { word: "壬生菜", reading: "みぶな", meaning: "Brassica campestris var. laciniifolia (variety of wild mustard)" },
        { word: "壬午軍乱", reading: "じんごぐんらん", meaning: "Imo Incident (riot in Seoul, Korea; July 23, 1882)" },
        { word: "壬申の乱", reading: "じんしんのらん", meaning: "Jinshin revolt (671 CE)" }
    ],
    },
    "壯": {
        onyomi: ["ソウ"],
        kunyomi: ["さかん"],
        examples: [],
    },
    "壽": {
        onyomi: ["ジュ", "ス", "シュウ"],
        kunyomi: ["ことぶき", "ことぶ.く", "ことほ.ぐ"],
        examples: [
        { word: "頌壽", reading: "しょうじゅ", meaning: "celebration of longevity" },
        { word: "壽司", reading: "すし", meaning: "sushi, range of dishes made with vinegared rice combined with fish, vegetables, egg, etc." },
        { word: "壽語録", reading: "すごろく", meaning: "race game (board game played with dice in which the object is to reach the end of a track), ban-sugoroku, sugoroku" }
    ],
    },
    "夷": {
        onyomi: ["イ"],
        kunyomi: ["えびす", "えみし", "ころ.す", "たい.らげる"],
        examples: [
        { word: "蝦夷にゅう", reading: "えぞにゅう", meaning: "Angelica ursina (species of perennial herb)" },
        { word: "夷俘", reading: "いふ", meaning: "Emishi allied with the central government (ritsuryō period)" },
        { word: "蝦夷鈴蘭", reading: "えぞすずらん", meaning: "Epipactis papillosa (species of orchid)" }
    ],
    },
    "奄": {
        onyomi: ["エン"],
        kunyomi: ["おお.う", "たちまち"],
        examples: [
        { word: "奄美鼻先蛙", reading: "あまみはなさきがえる", meaning: "Amami tip-nosed frog (Odorrana amamiensis)" },
        { word: "奄美棘鼠", reading: "アマミトゲネズミ", meaning: "Ryukyu spiny rat (Tokudaia osimensis)" },
        { word: "奄々", reading: "えんえん", meaning: "gasping" }
    ],
    },
    "奎": {
        onyomi: ["ケイ", "キ"],
        kunyomi: [],
        examples: [
        { word: "奎", reading: "けい", meaning: "Chinese \"Legs\" constellation (one of the 28 mansions)" },
        { word: "奎宿", reading: "とかきぼし", meaning: "Chinese \"Legs\" constellation (one of the 28 mansions)" }
    ],
    },
    "套": {
        onyomi: ["トウ"],
        kunyomi: ["かさ.ねる"],
        examples: [
        { word: "常套語", reading: "じょうとうご", meaning: "hackneyed expression" },
        { word: "外套膜", reading: "がいとうまく", meaning: "mantle (of an invertebrate)" },
        { word: "外套眼", reading: "がいとうがん", meaning: "mantle eye" }
    ],
    },
    "奧": {
        onyomi: ["オウ", "オク"],
        kunyomi: ["おく.まる", "くま"],
        examples: [
        { word: "奧", reading: "おく", meaning: "inner part, interior, back (of a drawer, one's throat, etc.)" }
    ],
    },
    "奬": {
        onyomi: ["ショウ", "ソウ"],
        kunyomi: ["すす.める"],
        examples: [],
    },
    "姥": {
        onyomi: ["ボ", "モ"],
        kunyomi: ["うば"],
        examples: [
        { word: "高砂の尉と姥", reading: "たかさごのじょうとうば", meaning: "(Japanese) Darby and Joan" },
        { word: "姥魚", reading: "うばうお", meaning: "Aspasma minima (species of clingfish)" },
        { word: "姥烏帽子貝", reading: "おばえぼしがい", meaning: "Inversidens brandti (species of freshwater mussel)" }
    ],
    },
    "姪": {
        onyomi: ["テツ", "チツ", "ジチ", "イツ", "イチ"],
        kunyomi: ["めい", "おい"],
        examples: [
        { word: "姪御", reading: "めいご", meaning: "(another person's) niece" },
        { word: "又姪", reading: "まためい", meaning: "grandniece" },
        { word: "甥姪", reading: "おいめい", meaning: "nephews and nieces" }
    ],
    },
    "娃": {
        onyomi: ["ア", "アイ", "ワ"],
        kunyomi: ["うつく.しい"],
        examples: [
        { word: "娃鬟", reading: "あいかん", meaning: "beautiful woman" },
        { word: "娃々菜", reading: "わわさい", meaning: "baby Chinese cabbage, wawasai cabbage, variety of small Chinese cabbage" }
    ],
    },
    "娩": {
        onyomi: ["ベン"],
        kunyomi: [],
        examples: [
        { word: "異常分娩", reading: "いじょうぶんべん", meaning: "abnormal delivery" },
        { word: "擬娩", reading: "ぎべん", meaning: "couvade (custom in which a male acts out the physical process of his own child being born)" },
        { word: "和痛分娩", reading: "わつうぶんべん", meaning: "delivery with little pain (i.e. through the use of pain-reducing drugs excluding epidurals)" }
    ],
    },
    "嬉": {
        onyomi: ["キ"],
        kunyomi: ["うれ.しい", "たの.しむ"],
        examples: [
        { word: "嬉笑", reading: "きしょう", meaning: "happy laughter" },
        { word: "嬉しげ", reading: "うれしげ", meaning: "seeming happy" },
        { word: "嬉ション", reading: "うれション", meaning: "(accidentally) peeing out of excitement, excitement urination" }
    ],
    },
    "孃": {
        onyomi: ["ジョウ"],
        kunyomi: ["むすめ"],
        examples: [
        { word: "愛孃", reading: "あいじょう", meaning: "one's beloved daughter" }
    ],
    },
    "孜": {
        onyomi: ["シ"],
        kunyomi: ["つと.める"],
        examples: [
        { word: "孜々", reading: "しし", meaning: "assiduously, diligently" },
        { word: "孜々として", reading: "ししとして", meaning: "assiduously, diligently" },
        { word: "孜々営々", reading: "ししえいえい", meaning: "assiduously, with unremitting zeal" }
    ],
    },
    "孟": {
        onyomi: ["モウ", "ボウ", "ミョウ"],
        kunyomi: ["かしら"],
        examples: [
        { word: "孟母断機の教え", reading: "もうぼだんきのおしえ", meaning: "(the lesson that) one should not leave things unfinished" },
        { word: "孟買", reading: "ボンベイ", meaning: "Bombay (old name for Mumbai)" },
        { word: "孔孟", reading: "こうもう", meaning: "Confucius and Mencius" }
    ],
    },
    "宋": {
        onyomi: ["ソウ"],
        kunyomi: [],
        examples: [
        { word: "呂宋", reading: "ルソン", meaning: "Luzon (Philippines)" },
        { word: "北宋", reading: "ほくそう", meaning: "Northern Song dynasty (of China; 960-1127)" },
        { word: "宋儒", reading: "そうじゅ", meaning: "Song dynasty Confucian scholars" }
    ],
    },
    "宏": {
        onyomi: ["コウ"],
        kunyomi: ["ひろ.い"],
        examples: [
        { word: "宏遠", reading: "こうえん", meaning: "vast and far-reaching" },
        { word: "宏池会", reading: "こうちかい", meaning: "Kōchikai (historically the most liberal faction of the Liberal Democratic Party), Kishida faction" },
        { word: "宏弁", reading: "こうべん", meaning: "fluency, eloquence" }
    ],
    },
    "宕": {
        onyomi: ["トウ"],
        kunyomi: ["すぎる"],
        examples: [
        { word: "豪宕", reading: "ごうとう", meaning: "bold and unrestrained, uninhibited, free-spirited" }
    ],
    },
    "宥": {
        onyomi: ["ユウ"],
        kunyomi: ["なだ.める", "ゆる.す"],
        examples: [
        { word: "贖宥", reading: "しょくゆう", meaning: "indulgence (in the Catholic Church)" },
        { word: "贖宥状", reading: "しょくゆうじょう", meaning: "indulgence (religious)" },
        { word: "宥和政策", reading: "ゆうわせいさく", meaning: "appeasement policy, policy of appeasement" }
    ],
    },
    "寅": {
        onyomi: ["イン"],
        kunyomi: ["とら"],
        examples: [
        { word: "戊寅", reading: "つちのえとら", meaning: "Earth Tiger (15th term of the sexagenary cycle, e.g. 1938, 1998, 2058)" },
        { word: "丙寅", reading: "ひのえとら", meaning: "Fire Tiger (3rd term of the sexagenary cycle, e.g. 1926, 1986, 2046)" },
        { word: "庚寅", reading: "かのえとら", meaning: "Metal Tiger (27th term of the sexagenary cycle, e.g. 1950, 2010, 2070)" }
    ],
    },
    "寓": {
        onyomi: ["グウ", "グ", "ドウ"],
        kunyomi: ["ぐう.する", "かこつ.ける", "よ.せ���", "よ.る", "かりずまい"],
        examples: [
        { word: "寓喩", reading: "ぐうゆ", meaning: "allegory" },
        { word: "寓目", reading: "ぐうもく", meaning: "fastening one's eyes upon" },
        { word: "仮寓", reading: "かぐう", meaning: "temporary residence" }
    ],
    },
    "寢": {
        onyomi: ["シン"],
        kunyomi: ["ね.る", "ね.かす", "い.ぬ", "みたまや", "や.める"],
        examples: [],
    },
    "實": {
        onyomi: ["ジツ", "シツ"],
        kunyomi: ["み", "みの.る", "まこと.に", "み��.り", "みち.る"],
        examples: [
        { word: "實踐者", reading: "じっせんしゃ", meaning: "practitioner" },
        { word: "實手", reading: "じって", meaning: "jitte, short truncheon with a hook made of metal or wood (used by policemen and private thief-takers in Edo Japan)" },
        { word: "實に", reading: "じつに", meaning: "really, truly, indeed" }
    ],
    },
    "寬": {
        onyomi: ["カン"],
        kunyomi: ["ひろい", "ゆるやか", "くつろぐ"],
        examples: [],
    },
    "寵": {
        onyomi: ["チョウ"],
        kunyomi: ["めぐ.み", "めぐ.む"],
        examples: [
        { word: "あふるる恩寵", reading: "あふるるおんちょう", meaning: "Grace Abounding (autobiography by John Bunyan)" },
        { word: "寵妃", reading: "ちょうひ", meaning: "favourite concubine" },
        { word: "聖寵", reading: "せいちょう", meaning: "grace (of God)" }
    ],
    },
    "將": {
        onyomi: ["ショウ", "ソウ"],
        kunyomi: ["まさ.に", "はた", "ひきい.る", "もって"],
        examples: [
        { word: "金將", reading: "きんしょう", meaning: "gold general" },
        { word: "玉將", reading: "ぎょくしょう", meaning: "king (of the junior player)" },
        { word: "銀將", reading: "ぎんしょう", meaning: "silver general" }
    ],
    },
    "專": {
        onyomi: ["セン"],
        kunyomi: ["もっぱ.ら"],
        examples: [
        { word: "專門", reading: "せんもん", meaning: "speciality, specialty, special subject of study" }
    ],
    },
    "尖": {
        onyomi: ["セン"],
        kunyomi: ["とが.る", "さき", "するど.い"],
        examples: [
        { word: "尖り", reading: "とんがり", meaning: "(sharp) point" },
        { word: "安曇尖鼠", reading: "あずみとがりねずみ", meaning: "Azumi shrew (Sorex hosonoi)" },
        { word: "尖閣沢蟹", reading: "センカクサワガニ", meaning: "Geothelphusa shokitai (crab species)" }
    ],
    },
    "尤": {
        onyomi: ["ユウ"],
        kunyomi: ["もっと.も", "とが.める"],
        examples: [
        { word: "蚩尤", reading: "しゆう", meaning: "Chiyou (Chinese god of war)" },
        { word: "尤度", reading: "ゆうど", meaning: "likelihood" },
        { word: "尤度関数", reading: "ゆうどかんすう", meaning: "likelihood function" }
    ],
    },
    "尭": {
        onyomi: ["ギョウ"],
        kunyomi: ["たか.い"],
        examples: [
        { word: "尭尭", reading: "ぎょうぎょう", meaning: "high (as of a mountain)" }
    ],
    },
    "屑": {
        onyomi: ["セツ"],
        kunyomi: ["くず", "いさぎよ.い"],
        examples: [
        { word: "中国藻屑蟹", reading: "チュウゴクモクズガニ", meaning: "Chinese mitten crab (Eriocheir sinensis)" },
        { word: "藻屑蟹", reading: "もくずがに", meaning: "Japanese mitten crab (Eriocheir japonica)" },
        { word: "綿屑", reading: "わたくず", meaning: "bits of cotton" }
    ],
    },
    "峨": {
        onyomi: ["ガ"],
        kunyomi: ["けわ.しい"],
        examples: [
        { word: "嵯峨美術大学", reading: "さがびじゅつだいがく", meaning: "Kyoto Saga University of Arts" },
        { word: "嵯峨野線", reading: "さがのせん", meaning: "Sagano Line (Kyoto)" },
        { word: "嵯峨", reading: "さが", meaning: "precipitous" }
    ],
    },
    "峯": {
        onyomi: ["ホウ"],
        kunyomi: ["みね", "ね"],
        examples: [
        { word: "鈴峯女子短大", reading: "れいほじょしたんだい", meaning: "Reiho Women's Junior College" },
        { word: "雲の峯", reading: "くものみね", meaning: "clouds that stand like a mountain peak during the summer" },
        { word: "連峯", reading: "れんぽう", meaning: "mountain range" }
    ],
    },
    "峻": {
        onyomi: ["シュン"],
        kunyomi: ["けわ.しい", "たか.い"],
        examples: [
        { word: "峻下剤", reading: "しゅんげざい", meaning: "drastic aperient" },
        { word: "峻別", reading: "しゅんべつ", meaning: "rigorous distinction" },
        { word: "峻拒", reading: "しゅんきょ", meaning: "refusing flatly, rejecting sternly" }
    ],
    },
    "峽": {
        onyomi: ["キョウ", "コウ"],
        kunyomi: ["はざま"],
        examples: [
        { word: "峽", reading: "かい", meaning: "gorge, ravine" }
    ],
    },
    "崚": {
        onyomi: ["リョウ"],
        kunyomi: [],
        examples: [],
    },
    "嵩": {
        onyomi: ["スウ", "シュウ"],
        kunyomi: ["かさ", "かさ.む", "たか.い"],
        examples: [
        { word: "嵩密度", reading: "かさみつど", meaning: "bulk density" },
        { word: "気嵩", reading: "きがさ", meaning: "having a competitive spirit" },
        { word: "値嵩", reading: "ねがさ", meaning: "high price" }
    ],
    },
    "嵯": {
        onyomi: ["サ", "シ"],
        kunyomi: [],
        examples: [
        { word: "嵯峨美術大学", reading: "さがびじゅつだいがく", meaning: "Kyoto Saga University of Arts" },
        { word: "嵯峨野線", reading: "さがのせん", meaning: "Sagano Line (Kyoto)" },
        { word: "嵯峨", reading: "さが", meaning: "precipitous" }
    ],
    },
    "嶋": {
        onyomi: ["トウ"],
        kunyomi: ["しま"],
        examples: [
        { word: "大八嶋国", reading: "おおやしまぐに", meaning: "Japan" },
        { word: "嶋", reading: "しま", meaning: "island, one's territory (of a sex worker, organized crime gang, etc.), one's turf" }
    ],
    },
    "嶺": {
        onyomi: ["レイ", "リョウ"],
        kunyomi: ["みね"],
        examples: [
        { word: "海嶺", reading: "かいれい", meaning: "(submarine) ridge" },
        { word: "高嶺苦菜", reading: "たかねにがな", meaning: "Ixeris dentata var. alpicola (mountain flower in the dandelion family)" },
        { word: "高嶺桜", reading: "たかねざくら", meaning: "Japanese alpine cherry (Prunus nipponica)" }
    ],
    },
    "巌": {
        onyomi: ["ガン"],
        kunyomi: ["いわ", "いわお", "けわ.しい"],
        examples: [
        { word: "巌窟王", reading: "がんくつおう", meaning: "The Count of Monte Cristo (novel by Alexandre Dumas)" },
        { word: "巉巌", reading: "ざんがん", meaning: "near-vertical cliff or peak" },
        { word: "巌松", reading: "がんしょう", meaning: "pine tree growing on a rock" }
    ],
    },
    "巖": {
        onyomi: ["ガン"],
        kunyomi: ["いわ", "いわお", "けわ.しい"],
        examples: [
        { word: "巖", reading: "いわお", meaning: "huge rock, massive boulder" }
    ],
    },
    "巢": {
        onyomi: ["ソウ"],
        kunyomi: ["す", "す.くう"],
        examples: [],
    },
    "巫": {
        onyomi: ["フ"],
        kunyomi: ["みこ", "かんなぎ"],
        examples: [
        { word: "巫俗", reading: "ふぞく", meaning: "Korean shamanism" },
        { word: "梓巫女", reading: "あずさみこ", meaning: "female medium who summons spirits by sounding the string of a catalpa bow" },
        { word: "雲雨巫山", reading: "うんうふざん", meaning: "sexual liaison" }
    ],
    },
    "已": {
        onyomi: ["イ"],
        kunyomi: ["や.む", "すで.に", "のみ", "はなはだ"],
        examples: [
        { word: "已んぬる哉", reading: "やんぬるかな", meaning: "I give up" },
        { word: "已己巳己", reading: "いこみき", meaning: "all the same" },
        { word: "死して後已む", reading: "ししてのちやむ", meaning: "duty ends only in death" }
    ],
    },
    "巳": {
        onyomi: ["シ"],
        kunyomi: ["み"],
        examples: [
        { word: "���巳", reading: "つちのとみ", meaning: "Earth Snake (6th term of the sexagenary cycle, e.g. 1929, 1989, 2049)" },
        { word: "丁巳", reading: "ひのとみ", meaning: "Fire Snake (54th term of the sexagenary cycle, e.g. 1917, 1977, 2037)" },
        { word: "辛巳", reading: "かのとみ", meaning: "Metal Snake (18th term of the sexagenary cycle, e.g. 1941, 2001, 2061)" }
    ],
    },
    "巴": {
        onyomi: ["ハ"],
        kunyomi: ["ともえ", "うずまき"],
        examples: [
        { word: "阿里巴巴", reading: "アリババ", meaning: "Alibaba" },
        { word: "巴格達", reading: "バグダッド", meaning: "Baghdad (Iraq)" },
        { word: "巴鴨", reading: "ともえがも", meaning: "Baikal teal (species of dabbling duck, Anas formosa)" }
    ],
    },
    "巷": {
        onyomi: ["コウ"],
        kunyomi: ["ちまた"],
        examples: [
        { word: "陋巷", reading: "ろうこう", meaning: "narrow, dirty backstreet" },
        { word: "修羅の巷", reading: "しゅらのちまた", meaning: "scene of carnage" },
        { word: "街談巷説", reading: "がいだんこうせつ", meaning: "street gossips and idle rumors" }
    ],
    },
    "巽": {
        onyomi: ["ソン"],
        kunyomi: ["たつみ"],
        examples: [
        { word: "巽位", reading: "そんい", meaning: "southeast" },
        { word: "巽", reading: "たつみ", meaning: "southeast" },
        { word: "巽為風", reading: "そんいふう", meaning: "xun (hexagram 57 of the I Ching: wind, the gentle)" }
    ],
    },
    "帖": {
        onyomi: ["チョウ", "ジョウ"],
        kunyomi: ["かきもの"],
        examples: [
        { word: "秋萩帖", reading: "あきはぎじょう", meaning: "Akihagijō (10C poem by Ono Michikaze, regarded as the first hiragana text)" },
        { word: "法帖", reading: "ほうじょう", meaning: "copybook printed from the works of old masters of calligraphy" },
        { word: "紋帖", reading: "もんちょう", meaning: "family crest register" }
    ],
    },
    "帶": {
        onyomi: ["タイ"],
        kunyomi: ["お.びる", "おび"],
        examples: [
        { word: "帶", reading: "おび", meaning: "obi (kimono sash), obi (strip of paper looped around a book, CD, etc. containing information about the product), band" }
    ],
    },
    "幌": {
        onyomi: ["コウ"],
        kunyomi: ["ほろ", "とばり"],
        examples: [
        { word: "札幌", reading: "さっぽろ", meaning: "Sapporo (city in Hokkaido)" },
        { word: "札幌市立大学", reading: "さっぽろしりつだいがく", meaning: "Sapporo City University" },
        { word: "札幌管区気象台", reading: "さっぽろかんくきしょうだい", meaning: "Sapporo District Meteorological Observatory" }
    ],
    },
    "幡": {
        onyomi: ["マン", "ハン", "バン", "ホン"],
        kunyomi: ["はた"],
        examples: [
        { word: "八幡大菩薩", reading: "はちまんだいぼさつ", meaning: "Great Bodhisattva Hachiman (title of Hachiman due to Shinto-Buddhist syncretism)" },
        { word: "八幡神", reading: "はちまんじん", meaning: "Hachiman (god of war)" },
        { word: "弓矢八幡", reading: "ゆみやはちまん", meaning: "Hachiman, god of war and archery" }
    ],
    },
    "庄": {
        onyomi: ["ショウ", "ソ", "ソウ", "ホウ"],
        kunyomi: [],
        examples: [
        { word: "庄屋", reading: "しょうや", meaning: "village headman (esp. in the Kansai region)" },
        { word: "庄園", reading: "しょうえん", meaning: "manor, demesne" },
        { word: "庄", reading: "しょう", meaning: "manor, villa" }
    ],
    },
    "庇": {
        onyomi: ["ヒ"],
        kunyomi: ["ひさし", "おお.う", "かば.う"],
        examples: [
        { word: "庇髪", reading: "ひさしがみ", meaning: "classic Japanese women's low pompadour hairstyle" },
        { word: "庇護欲", reading: "ひごよく", meaning: "desire to protect" },
        { word: "庇面", reading: "ひめん", meaning: "dome" }
    ],
    },
    "庚": {
        onyomi: ["コウ"],
        kunyomi: ["かのえ"],
        examples: [
        { word: "庚戌", reading: "かのえいぬ", meaning: "Metal Dog (47th term of the sexagenary cycle, e.g. 1910, 1970, 2030)" },
        { word: "庚辰", reading: "かのえたつ", meaning: "Metal Dragon (17th term of the sexagenary cycle, e.g. 1940, 2000, 2060)" },
        { word: "庚午", reading: "かのえうま", meaning: "Metal Horse (7th term of the sexagenary cycle, e.g. 1930, 1990, 2050)" }
    ],
    },
    "庵": {
        onyomi: ["アン"],
        kunyomi: ["いおり", "いお"],
        examples: [
        { word: "僧庵生活", reading: "そうあんせいかつ", meaning: "hermit life" },
        { word: "沢庵漬", reading: "たくあんづけ", meaning: "pickled daikon (radish)" },
        { word: "沢庵", reading: "たくあん", meaning: "pickled daikon radish" }
    ],
    },
    "廟": {
        onyomi: ["ビョウ", "ミョウ"],
        kunyomi: ["たまや", "みたまや", "やしろ"],
        examples: [
        { word: "聖廟", reading: "せいびょう", meaning: "Confucian temple" },
        { word: "媽祖廟", reading: "まそびょう", meaning: "Mazu temple" },
        { word: "帝廟", reading: "ていびょう", meaning: "imperial mausoleum" }
    ],
    },
    "廣": {
        onyomi: ["コウ"],
        kunyomi: ["ひろ.い", "ひろ.まる", "ひろ.める", "ひろ.がる", "ひろ.げる"],
        examples: [
        { word: "廣島", reading: "ひろしま", meaning: "Hiroshima (city, prefecture)" },
        { word: "廣島縣", reading: "ひろしまけん", meaning: "Hiroshima prefecture (Chūgoku area)" },
        { word: "廣辞林", reading: "こうじりん", meaning: "Kōjirin (Japanese dictionary published by Sanseido)" }
    ],
    },
    "廳": {
        onyomi: ["チョウ", "テイ"],
        kunyomi: ["やくしょ"],
        examples: [],
    },
    "廻": {
        onyomi: ["カイ", "エ"],
        kunyomi: ["まわ.る", "まわ.す", "もとお.る", "��ぐ.る", "めぐ.らす"],
        examples: [
        { word: "呪術廻戦", reading: "じゅじゅつかいせん", meaning: "Jujutsu Kaisen (manga series)" },
        { word: "浦廻", reading: "うらみ", meaning: "coastal indentations" },
        { word: "廻心", reading: "えしん", meaning: "conversion" }
    ],
    },
    "廿": {
        onyomi: ["ジュウ", "ニュウ"],
        kunyomi: ["にじゅう"],
        examples: [
        { word: "廿日鼠", reading: "はつかねずみ", meaning: "house mouse (Mus musculus)" },
        { word: "廿日大根", reading: "はつかだいこん", meaning: "radish (Raphanus sativus var. sativus)" },
        { word: "廿", reading: "にじゅう", meaning: "twenty, 20" }
    ],
    },
    "弘": {
        onyomi: ["コウ", "グ"],
        kunyomi: ["ひろ.い"],
        examples: [
        { word: "弘誓", reading: "ぐぜい", meaning: "Buddha's great vows" },
        { word: "元弘", reading: "げんこう", meaning: "Genkō era (1331.8.9-1334.1.29)" },
        { word: "弘前", reading: "ひろさき", meaning: "Hirosaki (city in Aomori)" }
    ],
    },
    "弛": {
        onyomi: ["チ", "シ"],
        kunyomi: ["たる.む", "たる.める", "たゆ.む", "ゆる.む", "ゆる.み"],
        examples: [
        { word: "弛緩性麻痺", reading: "しかんせいまひ", meaning: "flaccid paralysis" },
        { word: "筋弛緩薬", reading: "きんしかんやく", meaning: "muscle relaxant" },
        { word: "筋肉弛緩剤", reading: "きんにくしかんざい", meaning: "muscle relaxant" }
    ],
    },
    "彈": {
        onyomi: ["ダン", "タン"],
        kunyomi: ["ひ.く", "はず.む", "たま", "はじ.く", "はじ.ける", "ただ.す"],
        examples: [
        { word: "お彈き", reading: "おはじき", meaning: "ohajiki, traditional children's game similar to marbles, played with coin-shaped pieces of coloured glass or plastic, gun" }
    ],
    },
    "彌": {
        onyomi: ["ミ", "ビ"],
        kunyomi: ["いや", "や", "あまねし", "いよいよ", "とおい", "ひさし", "ひさ.しい", "わた.る"],
        examples: [
        { word: "阿摩彌姑", reading: "あまみきよ", meaning: "Amamikyu (Ryukyuan religion creation goddess)" },
        { word: "阿彌陀経", reading: "あみだきょう", meaning: "Sukhavati sutra" },
        { word: "天皇彌榮", reading: "すめらぎいやさか", meaning: "prosperity to the emperor" }
    ],
    },
    "彗": {
        onyomi: ["スイ", "エ", "ケイ", "セイ"],
        kunyomi: ["ほうき"],
        examples: [
        { word: "ヘール・ボップ彗星", reading: "ヘールボップすいせい", meaning: "Comet Hale-Bopp" },
        { word: "百武彗星", reading: "ひゃくたけすいせい", meaning: "Comet Hyakutake" },
        { word: "池谷・関彗星", reading: "いけやせきすいせい", meaning: "Comet Ikeya-Seki" }
    ],
    },
    "彦": {
        onyomi: ["ゲン"],
        kunyomi: ["ひこ"],
        examples: [
        { word: "猿田彦の命", reading: "さるたひこのみこと", meaning: "Saruta Hiko no Mikoto (Shintō god)" },
        { word: "猿田彦", reading: "さるたひこ", meaning: "Sarutahiko (deity)" },
        { word: "彦", reading: "ひこ", meaning: "boy" }
    ],
    },
    "彪": {
        onyomi: ["ヒョウ", "ヒュウ"],
        kunyomi: ["あや"],
        examples: [],
    },
    "彬": {
        onyomi: ["ヒン", "フン"],
        kunyomi: ["うるわ.しい", "あき.らか"],
        examples: [
        { word: "彬蔚", reading: "ひんうつ", meaning: "erudite and refined, handsome" },
        { word: "文質彬彬", reading: "ぶんしつひんぴん", meaning: "harmony of beauty and substance, (perfect) balance of looks and character, harmony of refinement and simplicity" }
    ],
    },
    "從": {
        onyomi: ["ジュウ", "ショウ", "ジュ"],
        kunyomi: ["したが.う", "したが.える", "より"],
        examples: [
        { word: "從來農法", reading: "じゅうらいのうほう", meaning: "traditional farming" },
        { word: "從う", reading: "したがう", meaning: "to obey (an order, law, etc.), to abide by (a rule, custom, etc.), to follow" }
    ],
    },
    "徠": {
        onyomi: ["ライ"],
        kunyomi: ["きた.す", "きた.る", "く.る"],
        examples: [],
    },
    "徵": {
        onyomi: ["チョウ", "チ"],
        kunyomi: ["しるし", "めす"],
        examples: [],
    },
    "德": {
        onyomi: ["トク"],
        kunyomi: ["おしえ"],
        examples: [
        { word: "德島", reading: "とくしま", meaning: "Tokushima (city, prefecture)" },
        { word: "德島縣", reading: "とくしまけん", meaning: "Tokushima Prefecture (Shikoku)" }
    ],
    },
    "徽": {
        onyomi: ["キ"],
        kunyomi: ["しるし"],
        examples: [
        { word: "安徽省", reading: "あんきしょう", meaning: "Anhui Province (China)" },
        { word: "安徽大学", reading: "あんきだいがく", meaning: "Anhui University" },
        { word: "弘徽殿", reading: "こきでん", meaning: "ladies' pavilion (of the inner Heian Palace)" }
    ],
    },
    "忽": {
        onyomi: ["コツ"],
        kunyomi: ["たちま.ち", "ゆるが.せ"],
        examples: [
        { word: "粗忽者", reading: "そこつもの", meaning: "careless person, thoughtless person" },
        { word: "忽布", reading: "ホップ", meaning: "hop (Humulus lupulus), hops" },
        { word: "忽焉", reading: "こつえん", meaning: "sudden, unexpected" }
    ],
    },
    "怜": {
        onyomi: ["レイ", "レン", "リョウ"],
        kunyomi: ["あわ.れむ", "さと.い"],
        examples: [
        { word: "怜悧狡猾", reading: "れいりこうかつ", meaning: "cunning, crafty, shrewd" },
        { word: "怜悧", reading: "れいり", meaning: "clever, bright, sharp" }
    ],
    },
    "恆": {
        onyomi: ["コウ"],
        kunyomi: ["つね.に"],
        examples: [],
    },
    "恕": {
        onyomi: ["ジョ", "ショ"],
        kunyomi: ["ゆる.す"],
        examples: [
        { word: "忠恕", reading: "ちゅうじょ", meaning: "sincerity and consideration" },
        { word: "仁恕", reading: "じんじょ", meaning: "benevolence, magnanimity" },
        { word: "宥恕", reading: "ゆうじょ", meaning: "forgiveness, generosity" }
    ],
    },
    "恢": {
        onyomi: ["カイ", "ケ"],
        kunyomi: ["ひろ.い"],
        examples: [
        { word: "天網恢恢疎にして漏らさず", reading: "てんもうかいかいそにして��らさず", meaning: "heaven's net has large meshes, but nothing escapes" },
        { word: "天網恢々", reading: "てんもうかいかい", meaning: "heaven's vengeance is slow but sure, heaven's net is wide and coarse, yet nothing slips through" },
        { word: "恢弘", reading: "かいこう", meaning: "propagation, spreading out, extending" }
    ],
    },
    "恰": {
        onyomi: ["コウ", "カッ", "チョウ", "キョウ"],
        kunyomi: ["あたか.も"],
        examples: [
        { word: "年恰好", reading: "としかっこう", meaning: "apparent age (of someone), rough age" },
        { word: "恰幅", reading: "かっぷく", meaning: "large, broad-shouldered physique (esp. that of a middle-aged man), big build" },
        { word: "恰も好し", reading: "あたかもよし", meaning: "luckily, fortunately" }
    ],
    },
    "悉": {
        onyomi: ["シツ", "シチ"],
        kunyomi: ["つ.きる", "ことごと", "ことごと.く", "つ.くす", "つぶさ.に"],
        examples: [
        { word: "悉曇文字", reading: "しったんもじ", meaning: "Siddham script" },
        { word: "悉曇学", reading: "しったんがく", meaning: "Siddham studies" },
        { word: "蘇悉地経", reading: "そしつじきょう", meaning: "Susiddhikara Sutra" }
    ],
    },
    "悌": {
        onyomi: ["テイ", "ダイ"],
        kunyomi: [],
        examples: [
        { word: "悌順", reading: "ていじゅん", meaning: "obedience" },
        { word: "孝悌", reading: "こうてい", meaning: "filial piety, brotherly love" },
        { word: "悌", reading: "てい", meaning: "respect for one's elders, harmony among siblings" }
    ],
    },
    "惇": {
        onyomi: ["シュン", "ジュン", "トン"],
        kunyomi: ["あつ.い"],
        examples: [
        { word: "惇睦", reading: "��んぼく", meaning: "cordial and friendly, affectionate" },
        { word: "惇朴", reading: "とんぼく", meaning: "honest and homely, simple" },
        { word: "惇厚", reading: "とんこう", meaning: "sincerity and kindheartedness, honesty and simplicity" }
    ],
    },
    "惚": {
        onyomi: ["コツ"],
        kunyomi: ["ほけ.る", "ぼ.ける", "ほ.れる"],
        examples: [
        { word: "ベタ惚れ", reading: "ベタぼれ", meaning: "(falling) deeply in love" },
        { word: "惚れた弱み", reading: "ほれたよわみ", meaning: "being a slave of love" },
        { word: "お惚け", reading: "おとぼけ", meaning: "feigned ignorance" }
    ],
    },
    "惟": {
        onyomi: ["イ", "ユイ"],
        kunyomi: ["おも.んみる", "これ", "おも.うに"],
        examples: [
        { word: "半跏思惟像", reading: "はんかしいぞう", meaning: "statue of a figure sitting contemplatively in the half lotus position (often of Maitreya)" },
        { word: "惟る", reading: "おもいみる", meaning: "to reflect carefully" },
        { word: "惟神の道", reading: "かんながらのみち", meaning: "the Way of the Gods, Shinto, Shintoism" }
    ],
    },
    "惠": {
        onyomi: ["ケイ", "エ"],
        kunyomi: ["めぐ.む", "めぐ.み"],
        examples: [],
    },
    "惡": {
        onyomi: ["アク", "オ"],
        kunyomi: ["わる.い", "あ.し", "にく.い", "ああ", "いずくに", "いずくんぞ", "にく.む"],
        examples: [
        { word: "惡口", reading: "わるぐち", meaning: "(verbal) abuse, speaking ill of people, bad-mouthing" },
        { word: "惡", reading: "あく", meaning: "evil, wickedness, (role of) the villain (in theatre, etc.)" },
        { word: "惡戲", reading: "いたずら", meaning: "mischief, prank, trick" }
    ],
    },
    "惣": {
        onyomi: ["ソウ"],
        kunyomi: ["すべ.て"],
        examples: [
        { word: "惣管領", reading: "そうかんりょう", meaning: "(hist.) governor-general" },
        { word: "惣無事令", reading: "そうぶじれい", meaning: "1585 edict by Toyotomi Hideyoshi which banned war between feudal lords in Japan" },
        { word: "惣太鰹", reading: "そうだがつお", meaning: "frigate tuna (Auxis spp.)" }
    ],
    },
    "惹": {
        onyomi: ["ジャク", "ジャ"],
        kunyomi: ["ひ.く"],
        examples: [
        { word: "惹句", reading: "じゃっく", meaning: "catchphrase (esp. in advertising)" },
        { word: "注意を惹く", reading: "ちゅういをひく", meaning: "to attract attention" },
        { word: "惹く", reading: "ひく", meaning: "to draw (attention, sympathy, etc.), to attract (e.g. interest)" }
    ],
    },
    "惺": {
        onyomi: ["セイ"],
        kunyomi: ["さと.る"],
        examples: [],
    },
    "愼": {
        onyomi: ["シン"],
        kunyomi: ["つつし.む", "つつし.み"],
        examples: [],
    },
    "慧": {
        onyomi: ["ケイ", "エ"],
        kunyomi: ["さとい"],
        examples: [
        { word: "慧眼", reading: "えげん", meaning: "the wisdom eye" },
        { word: "慧敏", reading: "けいびん", meaning: "clever, of quick intellect" },
        { word: "慧日", reading: "えにち", meaning: "sun of wisdom, Buddha's or Bodhisattva's limitless light of wisdom" }
    ],
    },
    "憐": {
        onyomi: ["レン"],
        kunyomi: ["あわ.れむ", "あわ.れ"],
        examples: [
        { word: "同病相憐れむ", reading: "どうびょうあいあわれむ", meaning: "fellow sufferers pity each other" },
        { word: "純情可憐", reading: "じゅんじょうかれん", meaning: "pure of heart and pretty" },
        { word: "自己憐憫", reading: "じこれんびん", meaning: "self-pity" }
    ],
    },
    "應": {
        onyomi: ["オウ", "ヨウ"],
        kunyomi: ["あた.る", "まさに", "こた.える"],
        examples: [
        { word: "慶應義塾", reading: "けいおうぎじゅく", meaning: "Keio (Private University)" },
        { word: "慶應義塾大学", reading: "けいおうぎじゅくだいがく", meaning: "Keio University" },
        { word: "慶應大学", reading: "けいおうだいがく", meaning: "Keio University" }
    ],
    },
    "懷": {
        onyomi: ["カイ", "エ"],
        kunyomi: ["ふところ", "なつ.かしい", "なつ.���しむ", "なつ.く", "なつ.ける", "いだ.く", "おも.う"],
        examples: [
        { word: "懷", reading: "ふところ", meaning: "inside the breast of one's clothing (esp. kimono), bosom, (breast) pocket" }
    ],
    },
    "戊": {
        onyomi: ["ボ", "ボウ"],
        kunyomi: ["つちのえ"],
        examples: [
        { word: "戊辰戦争", reading: "ぼしんせんそう", meaning: "Boshin War (Japanese civil war between Imperial and shogunate forces; 1868-1869)" },
        { word: "戊戌", reading: "ぼじゅつ", meaning: "Earth Dog (35th term of the sexagenary cycle, e.g. 1958, 2018, 2078)" },
        { word: "戊辰", reading: "つちのえたつ", meaning: "Earth Dragon (5th term of the sexagenary cycle, e.g. 1928, 1988, 2048)" }
    ],
    },
    "或": {
        onyomi: ["ワク", "コク", "イキ"],
        kunyomi: ["あ.る", "あるい", "あるいは"],
        examples: [
        { word: "と或る", reading: "とある", meaning: "a certain ..." },
        { word: "或る", reading: "ある", meaning: "a certain ..., some ..." },
        { word: "或る日", reading: "あるひ", meaning: "one day, (on) a certain day" }
    ],
    },
    "戟": {
        onyomi: ["ゲキ"],
        kunyomi: ["ほこ"],
        examples: [
        { word: "戟", reading: "げき", meaning: "ji (ancient Chinese halberd)" },
        { word: "矮鶏大戟", reading: "ちゃぼたいげき", meaning: "petty spurge (Euphorbia peplus)" },
        { word: "三叉戟", reading: "さんさげき", meaning: "trident" }
    ],
    },
    "戰": {
        onyomi: ["セン"],
        kunyomi: ["いくさ", "たたか.う", "おのの.く", "そよぐ"],
        examples: [
        { word: "戰隊", reading: "せんたい", meaning: "squadron" },
        { word: "戰鬪", reading: "せんとう", meaning: "battle, fight, combat" },
        { word: "戰い", reading: "たたかい", meaning: "battle, war, fight" }
    ],
    },
    "戲": {
        onyomi: ["ギ", "ゲ"],
        kunyomi: ["たわむ.れる", "たわむ.れ"],
        examples: [
        { word: "戲言", reading: "ぎげん", meaning: "joke, jest" },
        { word: "戲け者", reading: "おどけもの", meaning: "idiot, dummy, joker" },
        { word: "戲ける", reading: "おどける", meaning: "to jest, to joke, to play the fool" }
    ],
    },
    "托": {
        onyomi: ["タク"],
        kunyomi: ["たく.する", "たの.む"],
        examples: [
        { word: "托卵", reading: "たくらん", meaning: "brood parasitism (planting one's eggs in another bird's nest, as demonstrated by the cuckoo, etc.)" },
        { word: "種間托卵", reading: "しゅかんたくらん", meaning: "interspecific brood parasitism" },
        { word: "種内托卵", reading: "しゅないたくらん", meaning: "intraspecific brood parasitism" }
    ],
    },
    "拂": {
        onyomi: ["ヒツ", "フツ", "ホツ"],
        kunyomi: ["はら.う"],
        examples: [],
    },
    "拔": {
        onyomi: ["バツ", "ハイ"],
        kunyomi: ["ぬ.く", "ぬ.ける", "ぬ.かす", "ぬ.かる"],
        examples: [],
    },
    "拜": {
        onyomi: ["ハイ"],
        kunyomi: ["おが.む", "おろが.む"],
        examples: [
        { word: "拜見", reading: "はいけん", meaning: "seeing, looking at" }
    ],
    },
    "按": {
        onyomi: ["アン"],
        kunyomi: ["おさ.える", "しら.べる"],
        examples: [
        { word: "按司", reading: "あじ", meaning: "chieftain (of the Ryukyu Kingdom)" },
        { word: "按摩機", reading: "あんまき", meaning: "massage machine" },
        { word: "按摩膏", reading: "あんまこう", meaning: "massaging plaster" }
    ],
    },
    "挺": {
        onyomi: ["チョウ", "テイ"],
        kunyomi: ["ぬ.く"],
        examples: [
        { word: "挺進隊", reading: "ていしんたい", meaning: "advance unit sent ahead of the main force on a special mission" },
        { word: "空挺", reading: "くうてい", meaning: "airborne (troops, operation, etc.)" },
        { word: "空挺師団", reading: "くうていしだん", meaning: "airborne division" }
    ],
    },
    "挽": {
        onyomi: ["バン"],
        kunyomi: ["ひ.く"],
        examples: [
        { word: "合い挽き", reading: "あいびき", meaning: "(mixture of) ground beef and pork" },
        { word: "合い挽き肉", reading: "あいびきにく", meaning: "(mixture of) ground beef and pork" },
        { word: "挽きたて", reading: "ひきたて", meaning: "freshly ground (coffee, pepper, etc.)" }
    ],
    },
    "捧": {
        onyomi: ["ホウ"],
        kunyomi: ["ささ.げる"],
        examples: [
        { word: "捧腹", reading: "ほうふく", meaning: "convulsions of laughter" },
        { word: "捧げ銃", reading: "ささげつつ", meaning: "present arms! (military salute command)" },
        { word: "捧げ持つ", reading: "ささげもつ", meaning: "to hold (something) reverently with both hands" }
    ],
    },
    "捲": {
        onyomi: ["ケン"],
        kunyomi: ["ま.く", "ま.くる", "まく.る", "めく.る", "まく.れる"],
        examples: [
        { word: "高捲き", reading: "たかまき", meaning: "detour (around a waterfall, etc. when gorge-climbing)" },
        { word: "葉捲虫", reading: "はまきむし", meaning: "leaf folder (caterpillar)" },
        { word: "譜捲り", reading: "ふめくり", meaning: "page-turner" }
    ],
    },
    "捷": {
        onyomi: ["ショウ", "ソウ"],
        kunyomi: ["はや.い"],
        examples: [
        { word: "必捷", reading: "ひっしょう", meaning: "certain victory" },
        { word: "敏捷力", reading: "びんしょうりょく", meaning: "dexterity (esp. as an attribute in RPGs)" },
        { word: "簡捷", reading: "かんしょう", meaning: "fast and easy" }
    ],
    },
    "捺": {
        onyomi: ["ナツ", "ダツ"],
        kunyomi: ["さ.す", "お.す"],
        examples: [
        { word: "捺染", reading: "なっせん", meaning: "(textile) printing" },
        { word: "指紋押捺", reading: "しもんおうなつ", meaning: "fingerprinting" },
        { word: "判を捺す", reading: "はんをおす", meaning: "to affix a seal" }
    ],
    },
    "掠": {
        onyomi: ["リャク", "リョウ"],
        kunyomi: ["かす.める", "かす.る", "かす.れる"],
        examples: [
        { word: "掠り筆", reading: "かすりふで", meaning: "faint or blurry way of writing with a brush" },
        { word: "私掠免許", reading: "しりゃくめんきょ", meaning: "letter of marque" },
        { word: "私掠免許状", reading: "しりゃくめんきょじょう", meaning: "letter of marque" }
    ],
    },
    "掬": {
        onyomi: ["キク", "コク"],
        kunyomi: ["きく.す", "むす.ぶ", "すく.う", "たなごころ"],
        examples: [
        { word: "スーパーボール掬い", reading: "スーパーボールすくい", meaning: "festival game in which players scoop up bouncy balls floating in water" },
        { word: "小股掬い", reading: "こまたすくい", meaning: "over-thigh scooping body drop" },
        { word: "掬い", reading: "すくい", meaning: "scooping" }
    ],
    },
    "揃": {
        onyomi: ["セン"],
        kunyomi: ["そろ.える", "そろ.う", "そろ.い", "き.る"],
        examples: [
        { word: "耳を揃えて", reading: "みみをそろえて", meaning: "(to pay off) in full" },
        { word: "食器一揃い", reading: "しょっきひとそろい", meaning: "a table service" },
        { word: "供揃い", reading: "ともぞろい", meaning: "accompaniment by a full retinue of attendants (e.g. in a daimyo's procession)" }
    ],
    },
    "揭": {
        onyomi: ["ケイ", "ケツ"],
        kunyomi: ["かかげる"],
        examples: [],
    },
    "搖": {
        onyomi: ["ヨウ"],
        kunyomi: ["ゆ.れる", "ゆ.らぐ", "ゆ.るぐ", "ゆ.する", "ゆ.さぶる", "ゆ.すぶる", "うご.く"],
        examples: [],
    },
    "搜": {
        onyomi: ["ソウ", "シュ", "シュウ"],
        kunyomi: ["さが.す"],
        examples: [],
    },
    "摑": {
        onyomi: ["カク"],
        kunyomi: ["つか.む", "つか.まえる", "つか.まる"],
        examples: [
        { word: "摑まり立ち", reading: "つかまりだち", meaning: "standing while holding onto something (of an infant or toddler)" },
        { word: "雲を摑む", reading: "くもをつかむ", meaning: "to not have a clear picture of the situation" },
        { word: "摑み取る", reading: "つかみとる", meaning: "to grasp, to get" }
    ],
    },
    "摺": {
        onyomi: ["ショウ", "シュウ", "ロウ"],
        kunyomi: ["す.る", "ひだ"],
        examples: [
        { word: "摺り鉢", reading: "すりばち", meaning: "(earthenware) mortar (for grinding)" },
        { word: "千摺り", reading: "センズリ", meaning: "(male) masturbation" },
        { word: "捩摺", reading: "もじずり", meaning: "Chinese spiranthis (Spiranthes sinensis var. amoena)" }
    ],
    },
    "撒": {
        onyomi: ["サン", "サツ"],
        kunyomi: ["ま.く"],
        examples: [
        { word: "弥撒", reading: "ミサ", meaning: "(Catholic) Mass" },
        { word: "耶路撒冷", reading: "エルサレム", meaning: "Jerusalem" },
        { word: "撒哈拉", reading: "サハラ", meaning: "Sahara" }
    ],
    },
    "撞": {
        onyomi: ["ドウ", "トウ", "シュ"],
        kunyomi: ["つ.く"],
        examples: [
        { word: "撞木", reading: "しゅもく", meaning: "T-shaped wooden bell hammer" },
        { word: "撞球", reading: "どうきゅう", meaning: "billiards" },
        { word: "ボンネット撞木鮫", reading: "ボンネットシュモクザメ", meaning: "bonnethead (Sphyrna tiburo)" }
    ],
    },
    "撫": {
        onyomi: ["ブ", "フ"],
        kunyomi: ["な.でる"],
        examples: [
        { word: "一撫で", reading: "ひとなで", meaning: "(one) stroke" },
        { word: "唐撫子", reading: "からなでしこ", meaning: "China pink (species of flower, Dianthus chinensis)" },
        { word: "浜撫子", reading: "はまなでしこ", meaning: "Dianthus japonicus (species of pink)" }
    ],
    },
    "播": {
        onyomi: ["ハ", "バン", "ハン"],
        kunyomi: ["ま.く"],
        examples: [
        { word: "播但線", reading: "ばんたんせん", meaning: "Bantan Line (Hyogo Prefecture)" },
        { word: "播磨", reading: "はりま", meaning: "Harima (former province located in the southwestern part of present-day Hyōgo Prefecture)" },
        { word: "播磨国風土記", reading: "はりまのくにふどき", meaning: "Harima Fudoki (description of the culture, climate, etc. of Harima province; 715 CE)" }
    ],
    },
    "撰": {
        onyomi: ["サン", "セン"],
        kunyomi: ["せん.する", "えら.む", "えら.ぶ"],
        examples: [
        { word: "新撰姓氏録", reading: "しんせんしょうじろく", meaning: "Shinsen Shouji Roku (Newly Compiled Record of Clan Names; 815 CE)" },
        { word: "杜撰脱漏", reading: "ずさんだつろう", meaning: "careless (slipshod) and with many omissions" },
        { word: "撰進", reading: "せんしん", meaning: "compiling and presenting poems, texts, etc. to the emperor" }
    ],
    },
    "擊": {
        onyomi: ["ゲキ"],
        kunyomi: ["う.つ"],
        examples: [],
    },
    "擢": {
        onyomi: ["テキ", "タク"],
        kunyomi: ["ぬ.く", "ぬき.んでる"],
        examples: [
        { word: "擢用", reading: "てきよう", meaning: "selection" },
        { word: "抜擢", reading: "ばってき", meaning: "selection (from many people for an important position), exceptional promotion" },
        { word: "大抜擢", reading: "だいばってき", meaning: "very surprising choice (for a role, promotion, etc.), unexpected appointment" }
    ],
    },
    "攝": {
        onyomi: ["セツ", "ショウ"],
        kunyomi: ["おさ.める", "かね.る", "と.る"],
        examples: [],
    },
    "收": {
        onyomi: ["シュウ"],
        kunyomi: ["おさ.める", "おさ.まる"],
        examples: [
        { word: "收錄", reading: "しゅうろく", meaning: "recording (in a book, the minutes, etc.), printing, including" }
    ],
    },
    "敍": {
        onyomi: ["ジョ"],
        kunyomi: ["つい.ず", "ついで"],
        examples: [],
    },
    "敦": {
        onyomi: ["トン", "タイ", "ダン", "チョウ"],
        kunyomi: ["あつ.い"],
        examples: [
        { word: "倫敦", reading: "ロンドン", meaning: "London (UK)" },
        { word: "敦賀市立看護大学", reading: "つるがしりつかんごだいがく", meaning: "Tsuruga Nursing University" },
        { word: "敦賀女子短期大学", reading: "つるがじょしたんきだいがく", meaning: "Tsuruga Women's Junior College" }
    ],
    },
    "斐": {
        onyomi: ["ヒ", "イ"],
        kunyomi: [],
        examples: [
        { word: "甲斐", reading: "かい", meaning: "Kai (former province located in present-day Yamanashi Prefecture)" },
        { word: "甲斐犬", reading: "かいけん", meaning: "Kai Ken (Japanese dog breed)" },
        { word: "恋の骨折り甲斐", reading: "こいのほねおりがい", meaning: "Love's Labour's Won (Shakespeare)" }
    ],
    },
    "斡": {
        onyomi: ["アツ", "カン", "ワツ"],
        kunyomi: ["めぐ.る", "めぐ.らす"],
        examples: [
        { word: "斡旋料", reading: "あっせんりょう", meaning: "agent's charge" },
        { word: "斡旋収賄", reading: "あっせんしゅうわい", meaning: "influence peddling" },
        { word: "斡旋業者", reading: "あっせんぎょうしゃ", meaning: "mediator" }
    ],
    },
    "斧": {
        onyomi: ["フ"],
        kunyomi: ["おの"],
        examples: [
        { word: "握斧", reading: "あくふ", meaning: "(Paleolithic) hand axe" },
        { word: "斧鉞", reading: "ふえつ", meaning: "axe" },
        { word: "斧斤", reading: "ふきん", meaning: "axe" }
    ],
    },
    "斯": {
        onyomi: ["シ"],
        kunyomi: ["か", "こう", "か.く", "この", "これ", "ここに"],
        examples: [
        { word: "亜富汗斯坦", reading: "アフガニスタン", meaning: "Afghanistan" },
        { word: "愛斯蘭", reading: "アイスランド", meaning: "Iceland" },
        { word: "馬達加斯加", reading: "マダガスカル", meaning: "Madagascar" }
    ],
    },
    "於": {
        onyomi: ["オ", "ヨ"],
        kunyomi: ["おい.て", "お.ける", "ああ", "より"],
        examples: [
        { word: "正義の名に於て", reading: "せいぎのなにおいて", meaning: "in the name of justice" },
        { word: "於転婆", reading: "おてんば", meaning: "tomboy" },
        { word: "信頼の於ける", reading: "しんらいのおける", meaning: "reliable, authentic" }
    ],
    },
    "旭": {
        onyomi: ["キョク"],
        kunyomi: ["あさひ"],
        examples: [
        { word: "旭電化工業", reading: "あさひでんかこうぎょう", meaning: "ADEKA Corporation (formerly known as Asahi Denka Corporation)" },
        { word: "旭硝子", reading: "あさひがらす", meaning: "Asahi Glass" },
        { word: "旭化成", reading: "あさひかせい", meaning: "Asahi Kasei" }
    ],
    },
    "昂": {
        onyomi: ["コウ", "ゴウ"],
        kunyomi: ["あ.がる", "たか.い", "たか.ぶる"],
        examples: [
        { word: "昂揚感", reading: "こうようかん", meaning: "exaltation, emotional uplift" },
        { word: "軒昂", reading: "けんこう", meaning: "high-spirited, in high spirits" },
        { word: "意気軒昂", reading: "いきけんこう", meaning: "in high spirits, elated" }
    ],
    },
    "昊": {
        onyomi: ["コウ"],
        kunyomi: ["そら"],
        examples: [],
    },
    "昌": {
        onyomi: ["ショウ"],
        kunyomi: ["さかん"],
        examples: [
        { word: "南昌", reading: "なんしょう", meaning: "Nanchang (China)" },
        { word: "平昌五輪", reading: "ピョンチャンごりん", meaning: "Pyeongchang 2018 Olympic Winter Games" },
        { word: "昌泰", reading: "しょうたい", meaning: "Shōtai era (898.4.26-901.7.15)" }
    ],
    },
    "昏": {
        onyomi: ["コン"],
        kunyomi: ["くら.い", "くれ"],
        examples: [
        { word: "黄昏泣き", reading: "たそがれなき", meaning: "baby colic (esp. in the evening)" },
        { word: "昏睡状態", reading: "こんすいじょうたい", meaning: "comatose state" },
        { word: "黄昏鳥", reading: "たそがれどり", meaning: "lesser cuckoo (Cuculus poliocephalus)" }
    ],
    },
    "昴": {
        onyomi: ["コウ", "ボウ"],
        kunyomi: ["すばる"],
        examples: [
        { word: "寒昴", reading: "かんすばる", meaning: "Pleiades (esp. in winter)" },
        { word: "昴宿", reading: "ぼうしゅく", meaning: "Chinese \"Hairy Head\" constellation (one of the 28 mansions), Pleiades, Seven Sisters" },
        { word: "昴星", reading: "ぼうせい", meaning: "Chinese \"Hairy Head\" constellation (one of the 28 mansions), Pleiades, Seven Sisters" }
    ],
    },
    "晃": {
        onyomi: ["コウ"],
        kunyomi: ["あきらか"],
        examples: [
        { word: "晃朗", reading: "こうろう", meaning: "bright and brilliant" },
        { word: "晃曜", reading: "こうよう", meaning: "dazzling brightness" },
        { word: "晃々", reading: "こうこう", meaning: "brilliant, bright, dazzling" }
    ],
    },
    "晄": {
        onyomi: ["コウ"],
        kunyomi: ["あきらか"],
        examples: [],
    },
    "晋": {
        onyomi: ["シン"],
        kunyomi: ["すす.む"],
        examples: [
        { word: "晋書", reading: "しんじょ", meaning: "History of the Jin Dynasty" },
        { word: "晋語", reading: "しんご", meaning: "Jin Chinese (language)" },
        { word: "魏晋南北朝時代", reading: "ぎしんなんぼくちょうじだい", meaning: "Wei, Jin, and Southern and Northern Dynasties period (China, 220-589 CE)" }
    ],
    },
    "晏": {
        onyomi: ["アン"],
        kunyomi: ["おそ.い"],
        examples: [
        { word: "晏如", reading: "あんじょ", meaning: "calm, tranquil" },
        { word: "晏然", reading: "あんぜん", meaning: "calm, tranquil" }
    ],
    },
    "晒": {
        onyomi: ["サイ", "シ"],
        kunyomi: ["さら.す", "さらし"],
        examples: [
        { word: "晒し木綿", reading: "さらしもめん", meaning: "bleached cotton cloth" },
        { word: "晒し粉", reading: "さらしこ", meaning: "bleaching powder" },
        { word: "晒菜升麻", reading: "さらしなしょうま", meaning: "bugbane (Cimicifuga simplex)" }
    ],
    },
    "晚": {
        onyomi: ["バン"],
        kunyomi: ["くれ", "おそい"],
        examples: [],
    },
    "晝": {
        onyomi: ["チュウ"],
        kunyomi: ["ひる"],
        examples: [
        { word: "晝", reading: "ひる", meaning: "noon, midday, daytime" }
    ],
    },
    "晟": {
        onyomi: ["セイ", "ジョウ"],
        kunyomi: ["あきらか"],
        examples: [],
    },
    "晦": {
        onyomi: ["カイ"],
        kunyomi: ["つごもり", "くら.い", "みそか", "くら.む"],
        examples: [
        { word: "大晦日", reading: "おおみそか", meaning: "New Year's Eve" },
        { word: "自己韜晦", reading: "じことうかい", meaning: "concealing one's talents, position, status, intentions, etc." },
        { word: "晦冥", reading: "かいめい", meaning: "darkness" }
    ],
    },
    "晨": {
        onyomi: ["シン"],
        kunyomi: ["あした", "とき", "あさ"],
        examples: [
        { word: "晨鴨", reading: "しのりがも", meaning: "harlequin duck (Clangula hyemalis or Histrionicus histrionicus)" },
        { word: "晨朝", reading: "じんじょう", meaning: "around six o'clock AM, dawn service" }
    ],
    },
    "智": {
        onyomi: ["チ"],
        kunyomi: [],
        examples: [
        { word: "智利", reading: "チリ", meaning: "Chile" },
        { word: "智日", reading: "ちにち", meaning: "Chile and Japan" },
        { word: "開智国際大学", reading: "かいちこくさいだいがく", meaning: "Kaichi International University" }
    ],
    },
    "暉": {
        onyomi: ["キ"],
        kunyomi: ["かが.やく"],
        examples: [
        { word: "旭暉", reading: "きょっき", meaning: "rays of the rising sun" },
        { word: "夕暉", reading: "せっき", meaning: "rays of the setting sun" },
        { word: "暉麗", reading: "きれい", meaning: "pretty, lovely, beautiful" }
    ],
    },
    "暢": {
        onyomi: ["チョウ"],
        kunyomi: ["のび.る"],
        examples: [
        { word: "暢達", reading: "ちょうたつ", meaning: "fluency, facileness" },
        { word: "流暢", reading: "りゅうちょう", meaning: "fluent (in a language), flowing" },
        { word: "伸暢", reading: "しんちょう", meaning: "expansion, extension, elongation" }
    ],
    },
    "曆": {
        onyomi: ["レキ", "リャク"],
        kunyomi: ["こよみ"],
        examples: [],
    },
    "曉": {
        onyomi: ["キョウ", "ギョウ"],
        kunyomi: ["あかつき", "さと.る"],
        examples: [
        { word: "曉", reading: "あかつき", meaning: "dawn, daybreak, event (e.g. \"in the event of ...\")" }
    ],
    },
    "曙": {
        onyomi: ["ショ"],
        kunyomi: ["あけぼの"],
        examples: [
        { word: "曙象", reading: "あけぼのぞう", meaning: "Akebono elephant (Stegodon aurorae)" },
        { word: "曙草", reading: "アケボノソウ", meaning: "Swertia bimaculata (species of felwort)" },
        { word: "曙蝶々魚", reading: "アケボノチョウチョウウオ", meaning: "blackback butterflyfish (Chaetodon melannotus)" }
    ],
    },
    "曝": {
        onyomi: ["バク", "ホク", "ボク"],
        kunyomi: ["さら.す"],
        examples: [
        { word: "曝気", reading: "ばっき", meaning: "aeration" },
        { word: "曝書", reading: "ばくしょ", meaning: "airing of books" },
        { word: "曝涼", reading: "ばくりょう", meaning: "airing of clothes, hanging scrolls, etc. (to prevent damage from insects and mould)" }
    ],
    },
    "曳": {
        onyomi: ["エイ"],
        kunyomi: ["ひ.く"],
        examples: [
        { word: "船曳き網", reading: "ふなびきあみ", meaning: "boat seine" },
        { word: "曳山", reading: "ひきやま", meaning: "festival float" },
        { word: "曳子", reading: "ひきこ", meaning: "jinrikisha puller" }
    ],
    },
    "曾": {
        onyomi: ["ソウ", "ソ", "ゾウ"],
        kunyomi: ["かつ.て", "か.って", "すなわち"],
        examples: [
        { word: "伊曾保物語", reading: "いそほものがたり", meaning: "Aesop's Fables (published initially by the Jesuits in 1593)" },
        { word: "木曾路", reading: "きそじ", meaning: "Kiso valley section of the Nakasendo" },
        { word: "大白檜曾", reading: "おおしらびそ", meaning: "Maries' fir (Abies mariesii)" }
    ],
    },
    "朋": {
        onyomi: ["ホウ"],
        kunyomi: ["とも"],
        examples: [
        { word: "同朋大学", reading: "どうほうだいがく", meaning: "Doho University" },
        { word: "桐朋学園大学院大学", reading: "とうほうがくえんだいがくいんだいがく", meaning: "Toho Gakuen Graduate School" },
        { word: "桐朋学園大学", reading: "とうほうがくえんだいがく", meaning: "Toho Gakuen School of Music" }
    ],
    },
    "朔": {
        onyomi: ["サク"],
        kunyomi: ["ついたち"],
        examples: [
        { word: "綿抜の朔日", reading: "わたぬきのついたち", meaning: "1st day of the 4th month of the lunisolar calendar" },
        { word: "視告朔", reading: "こうさく", meaning: "ceremony where the Emperor would inspect the records of attendance and absence of officials" },
        { word: "朔日", reading: "さくじつ", meaning: "first day of the month (in the lunar calendar)" }
    ],
    },
    "李": {
        onyomi: ["リ"],
        kunyomi: ["すもも"],
        examples: [
        { word: "鼠李", reading: "くろうめもどき", meaning: "Japanese buckthorn (Rhamnus japonica var. decipiens)" },
        { word: "李部", reading: "りぶ", meaning: "Ministry of Personnel (Tang dynasty China)" },
        { word: "行李柳", reading: "こりやなぎ", meaning: "Salix koriyanagi (species of willow)" }
    ],
    },
    "杏": {
        onyomi: ["キョウ", "アン", "コウ"],
        kunyomi: ["あんず"],
        examples: [
        { word: "銀杏蟹", reading: "いちょうがに", meaning: "Cancer japonicus (species of crab)" },
        { word: "アメリカ銀杏蟹", reading: "アメリカいちょうがに", meaning: "Dungeness crab (Metacarcinus magister)" },
        { word: "杏林大学", reading: "きょうりんだいがく", meaning: "Kyorin University" }
    ],
    },
    "杖": {
        onyomi: ["ジョウ"],
        kunyomi: ["つえ"],
        examples: [
        { word: "雛の錫杖", reading: "ひなのしゃくじょう", meaning: "Burmannia championii (species of flowering plant)" },
        { word: "宝玉と勺杖", reading: "ほうぎょくとしゃくじょう", meaning: "Orb and Sceptre (march by Sir William Walton)" },
        { word: "毬杖", reading: "ぎっちょう", meaning: "ball-and-mallet game played during New Year's celebrations" }
    ],
    },
    "杜": {
        onyomi: ["ト", "トウ", "ズ"],
        kunyomi: ["もり", "ふさ.ぐ", "やまなし"],
        examples: [
        { word: "杜衡", reading: "かんあおい", meaning: "Asarum nipponicum (species of wild ginger)" },
        { word: "杜の都", reading: "もりのみやこ", meaning: "Capital of Trees (nickname for Sendai city)" },
        { word: "杜仲科", reading: "とちゅうか", meaning: "Eucommiaceae (monotypic plant family containing only the hardy rubber tree)" }
    ],
    },
    "杭": {
        onyomi: ["コウ"],
        kunyomi: ["くい"],
        examples: [
        { word: "杭州", reading: "こうしゅう", meaning: "Hangzhou (China)" },
        { word: "支持杭", reading: "しじぐい", meaning: "bearing pile" },
        { word: "橋杭", reading: "はしぐい", meaning: "bridge pillar" }
    ],
    },
    "杵": {
        onyomi: ["ショ", "ソ"],
        kunyomi: ["きね"],
        examples: [
        { word: "瓊瓊杵尊", reading: "ににぎのみこと", meaning: "Ninigi no Mikoto (Japanese deity; grandson of Amaterasu, great grandfather of Emperor Jimmu)" },
        { word: "杵柄", reading: "きねづか", meaning: "mallet handle" },
        { word: "金剛杵", reading: "こんごうしょ", meaning: "vajra (mystical weapon in Hinduism and Buddhism)" }
    ],
    },
    "杷": {
        onyomi: ["ハ"],
        kunyomi: ["つか"],
        examples: [
        { word: "犬枇杷", reading: "いぬびわ", meaning: "Ficus erecta (species of ficus)" },
        { word: "山枇杷", reading: "やまびわ", meaning: "Meliosma rigida (species of flowering plant)" },
        { word: "竹杷", reading: "さらい", meaning: "farmer's rake" }
    ],
    },
    "枇": {
        onyomi: ["ビ", "ヒ"],
        kunyomi: [],
        examples: [
        { word: "犬枇杷", reading: "いぬびわ", meaning: "Ficus erecta (species of ficus)" },
        { word: "山枇杷", reading: "やまびわ", meaning: "Meliosma rigida (species of flowering plant)" },
        { word: "枇杷葉", reading: "びわよう", meaning: "loquat leaf (used in traditional Chinese medicine)" }
    ],
    },
    "柊": {
        onyomi: ["シュ", "シュウ"],
        kunyomi: ["ひいらぎ"],
        examples: [
        { word: "西洋柊", reading: "せいようひいらぎ", meaning: "English holly (Ilex aquifolium)" },
        { word: "柊菜", reading: "ひいらぎな", meaning: "mizuna (Brassica rapa var. nipposinica)" },
        { word: "柊南天", reading: "ひいらぎなんてん", meaning: "Mahonia japonica, Japanese mahonia" }
    ],
    },
    "柏": {
        onyomi: ["ハク", "ヒャク", "ビャク"],
        kunyomi: ["かしわ"],
        examples: [
        { word: "黄柏", reading: "きはだ", meaning: "Amur cork tree (Phellodendron amurense)" },
        { word: "伊吹柏槙", reading: "いぶきびゃくしん", meaning: "Chinese juniper (Juniperus chinensis)" },
        { word: "柏槙", reading: "びゃくしん", meaning: "Chinese juniper (Juniperus chinensis)" }
    ],
    },
    "柑": {
        onyomi: ["コン", "カン"],
        kunyomi: [],
        examples: [
        { word: "四季柑", reading: "しきかん", meaning: "Calamansi (Citrus x microcarpa)" },
        { word: "紀州蜜柑", reading: "きしゅうみかん", meaning: "Citrus kinokuni (species of mandarin orange)" },
        { word: "蜜柑小実蠅", reading: "みかんこみばえ", meaning: "Oriental fruit fly (Bactrocera dorsalis)" }
    ],
    },
    "柘": {
        onyomi: ["シャ", "ジャク"],
        kunyomi: ["そ", "つげ", "やまぐわ"],
        examples: [
        { word: "柘", reading: "つみ", meaning: "Chinese mulberry (Morus bombycis)" },
        { word: "貴柘榴石", reading: "きざくろいし", meaning: "almandine" },
        { word: "鉄礬柘榴石", reading: "てつばんざくろいし", meaning: "almandine" }
    ],
    },
    "柚": {
        onyomi: ["ユ", "ユウ", "ジク"],
        kunyomi: ["ゆず"],
        examples: [
        { word: "柚香焼", reading: "ゆうがやき", meaning: "citrus-grilled" },
        { word: "柚子胡椒", reading: "ゆずこしょう", meaning: "condiment paste made from yuzu zest and chili peppers (chile)" },
        { word: "晩白柚", reading: "ばんぺいゆ", meaning: "cultivar of pomelo (Citrus maxima, Citrus grandis)" }
    ],
    },
    "柴": {
        onyomi: ["サイ", "シ"],
        kunyomi: ["しば"],
        examples: [
        { word: "三島柴胡", reading: "ミシマサイコ", meaning: "Bupleurum stenophyllum (species of medicinal herb)" },
        { word: "柴漬け", reading: "しばづけ", meaning: "Kyoto-style chopped vegetables pickled in salt with red shiso leaves" },
        { word: "柴田学園大学", reading: "しばたがくえんだいがく", meaning: "Shibata Gakuen University" }
    ],
    },
    "柾": {
        onyomi: [],
        kunyomi: ["まさ", "まさめ", "まさき"],
        examples: [
        { word: "柾の葛", reading: "まさきのかずら", meaning: "Asiatic jasmine (Trachelospermum asiaticum), Asian jasmine" },
        { word: "柾", reading: "マサキ", meaning: "evergreen spindle (Euonymus japonicus), Japanese spindle tree" },
        { word: "柾目", reading: "まさめ", meaning: "straight grain, quartersawn grain" }
    ],
    },
    "栖": {
        onyomi: ["セイ"],
        kunyomi: ["す.む"],
        examples: [
        { word: "鷹栖養護学校", reading: "たかすようごがっこう", meaning: "Takasu Special Needs School (older name style)" },
        { word: "羊栖菜", reading: "ひじき", meaning: "hijiki (dark edible seaweed usu. sold in dried black strips; Hizikia fusiformis)" },
        { word: "幽栖", reading: "ゆうせい", meaning: "living a quiet life in seclusion away from the masses" }
    ],
    },
    "栗": {
        onyomi: ["リツ", "リ"],
        kunyomi: ["くり", "おののく"],
        examples: [
        { word: "天津甘栗", reading: "てんしんあまぐり", meaning: "(Tianjin-style) sweet chestnuts" },
        { word: "アメリカ栗", reading: "アメリカぐり", meaning: "American chestnut (Castanea dentata)" },
        { word: "背赤栗鼠猿", reading: "せあかりすざる", meaning: "Central American squirrel monkey (Saimiri oerstedii)" }
    ],
    },
    "栞": {
        onyomi: ["カン"],
        kunyomi: ["しおり"],
        examples: [
        { word: "栞", reading: "しおり", meaning: "bookmark, guidebook" }
    ],
    },
    "桂": {
        onyomi: ["ケイ"],
        kunyomi: ["かつら"],
        examples: [
        { word: "桂科", reading: "かつらか", meaning: "Cercidiphyllaceae (monotypic plant family containing the katsura trees)" },
        { word: "広葉桂", reading: "ひろはかつら", meaning: "Cercidiphyllum magnificum (species of katsura)" },
        { word: "月桂冠", reading: "げっけいかん", meaning: "Gekkeikan (sake manufacturer)" }
    ],
    },
    "桐": {
        onyomi: ["トウ", "ドウ"],
        kunyomi: ["きり"],
        examples: [
        { word: "桐花章", reading: "とうかしょう", meaning: "Grand Cordon of the Order of the Paulownia Flowers" },
        { word: "桐花大綬章", reading: "とうかだいじゅしょう", meaning: "Grand Cordon of the Order of the Paulownia Flowers" },
        { word: "海桐", reading: "トベラ", meaning: "Japanese cheesewood (Pittosporum tobira)" }
    ],
    },
    "桔": {
        onyomi: ["キツ", "ケツ"],
        kunyomi: [],
        examples: [
        { word: "桔梗", reading: "ききょう", meaning: "Chinese bellflower (Platycodon grandiflorus)" },
        { word: "沢桔梗", reading: "さわぎきょう", meaning: "Lobelia sessilifolia (species of lobelia)" },
        { word: "千島桔梗", reading: "ちしまぎきょう", meaning: "hairyflower bellflower (Campanula chamissonis)" }
    ],
    },
    "桧": {
        onyomi: ["カイ"],
        kunyomi: ["ひのき", "ひ"],
        examples: [
        { word: "桧葉叉", reading: "ひばまた", meaning: "Arctic wrack (Fucus evanescens)" },
        { word: "黒桧", reading: "くろべ", meaning: "Japanese arborvitae (Thuja standishii)" },
        { word: "桧笠", reading: "ひのきがさ", meaning: "conical hat" }
    ],
    },
    "桶": {
        onyomi: ["ヨウ", "トウ"],
        kunyomi: ["おけ"],
        examples: [
        { word: "担い桶", reading: "にないおけ", meaning: "bucket carried on either end of a pole" },
        { word: "糞桶", reading: "くそおけ", meaning: "bucket for carrying night soil" },
        { word: "湯桶", reading: "ゆおけ", meaning: "bucket used for bathing" }
    ],
    },
    "梁": {
        onyomi: ["リョウ"],
        kunyomi: ["はり", "うつばり", "うちばり", "やな", "はし"],
        examples: [
        { word: "梁", reading: "うつばり", meaning: "(roof) beam" },
        { word: "梁歯目", reading: "りょうしもく", meaning: "Docodonta" },
        { word: "後梁", reading: "こうりょう", meaning: "Later Liang dynasty (of China; 907-923)" }
    ],
    },
    "梓": {
        onyomi: ["シ"],
        kunyomi: ["あずさ"],
        examples: [
        { word: "梓宮", reading: "しきゅう", meaning: "Emperor's coffin (made of catalpa wood)" },
        { word: "梓巫女", reading: "あずさみこ", meaning: "female medium who summons spirits by sounding the string of a catalpa bow" },
        { word: "玉梓", reading: "たまずさ", meaning: "(precious) letter, love letter" }
    ],
    },
    "梛": {
        onyomi: ["ダ", "ナ"],
        kunyomi: ["なぎ"],
        examples: [
        { word: "梛筏", reading: "なぎいかだ", meaning: "butcher's broom (Ruscus aculeatus)" },
        { word: "梛", reading: "なぎ", meaning: "nagi (species of conifer, Nageia nagi), Asian bayberry" },
        { word: "梛木擬", reading: "なぎもどき", meaning: "agathis (genus of evergreen trees), kauri, dammar" }
    ],
    },
    "條": {
        onyomi: ["ジョウ", "チョウ", "デキ"],
        kunyomi: ["えだ", "すじ"],
        examples: [
        { word: "四條畷学園大学", reading: "しじょうなわてがくえんだいがく", meaning: "Shijonawate Gakuen University" },
        { word: "四條笛鯛", reading: "よすじふえだい", meaning: "bluestripe snapper (Lutjanus kasmira), bluestripe seaperch" }
    ],
    },
    "梢": {
        onyomi: ["ショウ"],
        kunyomi: ["こずえ", "くすのき"],
        examples: [
        { word: "梢子", reading: "しょうし", meaning: "boatman" },
        { word: "末梢性", reading: "まっしょうせい", meaning: "peripheral" },
        { word: "末梢血管", reading: "まっしょうけっかん", meaning: "peripheral blood vessel" }
    ],
    },
    "梧": {
        onyomi: ["ゴ"],
        kunyomi: ["あおぎり"],
        examples: [
        { word: "梯梧", reading: "でいご", meaning: "Indian coral tree (Erythrina variegata)" },
        { word: "蒼梧", reading: "そうご", meaning: "Chinese parasol-tree (Firmiana simplex), Chinese bottletree, Japanese varnishtree" },
        { word: "梧桐", reading: "あおぎり", meaning: "Chinese parasol-tree (Firmiana simplex), Chinese-bottletree, Japanese varnishtree" }
    ],
    },
    "梯": {
        onyomi: ["テイ", "タイ"],
        kunyomi: ["はしご"],
        examples: [
        { word: "アニマル梯団", reading: "アニマルていだん", meaning: "Animal Teidan (comedy duo)" },
        { word: "梯梧", reading: "でいご", meaning: "Indian coral tree (Erythrina variegata)" },
        { word: "アメリカ梯沽", reading: "アメリカでいご", meaning: "cockspur coral tree (Erythrina crista-galli)" }
    ],
    },
    "梶": {
        onyomi: ["ビ"],
        kunyomi: ["かじ", "こずえ"],
        examples: [
        { word: "黒梶木", reading: "くろかじき", meaning: "Indo-Pacific blue marlin (Makaira mazara)" },
        { word: "芭蕉梶木", reading: "ばしょうかじき", meaning: "Indo-Pacific sailfish (Istiophorus platypterus)" },
        { word: "梶苺", reading: "かじいちご", meaning: "Rubus trifidus (species of raspberry)" }
    ],
    },
    "棲": {
        onyomi: ["セイ"],
        kunyomi: ["す.む"],
        examples: [
        { word: "両棲動物", reading: "りょうせいどうぶつ", meaning: "amphibious animal" },
        { word: "爬虫両棲類学", reading: "はちゅうりょうせいるいがく", meaning: "herpetology" },
        { word: "幽棲", reading: "ゆうせい", meaning: "living a quiet life in seclusion away from the masses" }
    ],
    },
    "椀": {
        onyomi: ["ワン"],
        kunyomi: ["はち"],
        examples: [
        { word: "お椀", reading: "おわん", meaning: "bowl (wooden)" },
        { word: "飯椀", reading: "めしわん", meaning: "bowl used for serving rice" },
        { word: "椀盛り", reading: "わんもり", meaning: "food cooked by boiling or stewing" }
    ],
    },
    "椋": {
        onyomi: ["リョウ"],
        kunyomi: ["むく"],
        examples: [
        { word: "大黒椋鳥擬", reading: "おおくろむくどりもどき", meaning: "common grackle (Quiscalus quiscula)" },
        { word: "椋木", reading: "むくのき", meaning: "Aphananthe oriental elm (Aphananthe aspera), mukutree" },
        { word: "星椋鳥", reading: "ほしむくどり", meaning: "common starling, European starling (Sturnus vulgaris)" }
    ],
    },
    "椛": {
        onyomi: [],
        kunyomi: ["かば", "もみじ"],
        examples: [
        { word: "椛", reading: "なぎ", meaning: "nagi (species of conifer, Nageia nagi), Asian bayberry" }
    ],
    },
    "椰": {
        onyomi: ["ヤ"],
        kunyomi: ["やし"],
        examples: [
        { word: "アレカ椰子", reading: "アレカやし", meaning: "areca palm" },
        { word: "とっくり椰子", reading: "とっくりやし", meaning: "bottle palm (Hyophorbe lagenicaulis)" },
        { word: "花椰菜", reading: "はなやさい", meaning: "cauliflower" }
    ],
    },
    "椿": {
        onyomi: ["チン", "チュン"],
        kunyomi: ["つばき"],
        examples: [
        { word: "佗助椿", reading: "わびすけつばき", meaning: "Camellia japonica 'Wabisuke' (cultivar of common camellia)" },
        { word: "香椿", reading: "ちゃんちん", meaning: "Chinese mahogany (Toona sinensis)" },
        { word: "夏椿", reading: "なつつばき", meaning: "Japanese stewartia (Stewartia pseudocamellia)" }
    ],
    },
    "楊": {
        onyomi: ["ヨウ"],
        kunyomi: ["やなぎ"],
        examples: [
        { word: "白楊", reading: "はこやなぎ", meaning: "Japanese aspen (Populus tremula var. sieboldii)" },
        { word: "朝熊黄楊", reading: "あさまつげ", meaning: "Japanese box tree (Buxus microphylla var. japonica)" },
        { word: "犬黄楊", reading: "いぬつげ", meaning: "Japanese holly (Ilex crenata)" }
    ],
    },
    "楓": {
        onyomi: ["フウ"],
        kunyomi: ["かえで"],
        examples: [
        { word: "楓", reading: "ふう", meaning: "Formosan sweetgum (Liquidambar formosana)" },
        { word: "羽団扇楓", reading: "はうちわかえで", meaning: "Japanese maple (Acer japonicum)" },
        { word: "いろは楓", reading: "いろはかえで", meaning: "Japanese maple (Acer palmatum)" }
    ],
    },
    "楕": {
        onyomi: ["ダ", "タ"],
        kunyomi: [],
        examples: [
        { word: "楕円面", reading: "だえんめん", meaning: "ellipsoid" },
        { word: "楕円体", reading: "だえんたい", meaning: "ellipsoid body" },
        { word: "楕円曲線", reading: "だえんきょくせん", meaning: "elliptic curve" }
    ],
    },
    "楚": {
        onyomi: ["ソ", "ショ"],
        kunyomi: ["いばら", "しもと", "すわえ"],
        examples: [
        { word: "清楚系ビッチ", reading: "せいそけいビッチ", meaning: "neat and tidy woman who is (unexpectedly) promiscuous" },
        { word: "四面楚歌", reading: "しめんそか", meaning: "being surrounded by enemies on all sides, being betrayed (forsaken) by everybody" },
        { word: "金楚糕", reading: "ちんすこう", meaning: "chinsuko, traditional Okinawan biscuit made with wheat flour, lard and sugar" }
    ],
    },
    "楠": {
        onyomi: ["ナン", "ダン", "ゼン", "ネン"],
        kunyomi: ["くす", "くすのき"],
        examples: [
        { word: "東石楠花", reading: "あずましゃくなげ", meaning: "Azuma rhododendron (Rhododendron metternichii var.)" },
        { word: "白山石楠花", reading: "はくさんしゃくなげ", meaning: "Hakusan rhododendron (Rhododendron metternichii var.)" },
        { word: "黄花石楠花", reading: "きばなしゃくなげ", meaning: "Kibana rhododendron (Rhododendron metternichii var.)" }
    ],
    },
    "楢": {
        onyomi: ["シュウ", "ユウ"],
        kunyomi: ["なら"],
        examples: [
        { word: "水楢", reading: "みずなら", meaning: "Mongolian oak (Quercus mongolica)" },
        { word: "楢山節考", reading: "ならやまぶしこう", meaning: "Narayama Bushikō - The Ballad of Narayama (1954 novel by Fukazawa Shichirō, 1983 film by Imamura Shōhei)" },
        { word: "楢", reading: "なら", meaning: "oak (esp. Quercus serrata)" }
    ],
    },
    "楯": {
        onyomi: ["ジュン"],
        kunyomi: ["たて"],
        examples: [
        { word: "防楯", reading: "ぼうじゅん", meaning: "gun shield (esp. artillery)" },
        { word: "楯鱗", reading: "じゅんりん", meaning: "placoid scale" },
        { word: "楯状地", reading: "たてじょうち", meaning: "shield" }
    ],
    },
    "榊": {
        onyomi: [],
        kunyomi: ["さかき"],
        examples: [
        { word: "真榊", reading: "まさかき", meaning: "evergreen (esp. one planted or used at a shrine)" },
        { word: "榊", reading: "さかき", meaning: "sakaki (species of evergreen sacred to Shinto, Cleyera japonica), evergreen (esp. one planted or used at a shrine)" }
    ],
    },
    "榎": {
        onyomi: ["カ"],
        kunyomi: ["えのき"],
        examples: [
        { word: "榎葉", reading: "えのは", meaning: "landlocked masu salmon" },
        { word: "榎の実", reading: "えのみ", meaning: "nettle-tree nut" },
        { word: "蝦夷榎", reading: "えぞえのき", meaning: "Japanese hackberry (Celtis jessoensis), Jesso hackberry" }
    ],
    },
    "榛": {
        onyomi: ["シン", "ハン"],
        kunyomi: ["はしばみ", "はり"],
        examples: [
        { word: "西洋榛", reading: "せいようはしばみ", meaning: "Eurasian hazel (Corylus avellana)" },
        { word: "榛名養護学校", reading: "はるなようごがっこう", meaning: "Haruna Special Needs School (older name style)" },
        { word: "榛", reading: "はり", meaning: "Japanese alder (Alnus japonica)" }
    ],
    },
    "榮": {
        onyomi: ["エイ", "ヨウ"],
        kunyomi: ["さか.える", "は.える", "え"],
        examples: [
        { word: "日榮", reading: "にちえい", meaning: "Nichiei" },
        { word: "天皇彌榮", reading: "すめらぎいやさか", meaning: "prosperity to the emperor" },
        { word: "榮耀榮華", reading: "えいようえいが", meaning: "wealth, prosperity, and arrogant splendor (splendour), (living sumptuously) intoxicated by wealth and power, luxury" }
    ],
    },
    "槇": {
        onyomi: ["テン", "シン"],
        kunyomi: ["まき", "こずえ"],
        examples: [
        { word: "阿部槇", reading: "あべまき", meaning: "Chinese cork oak (Quercus variabilis)" },
        { word: "槇柏", reading: "しんぱく", meaning: "Chinese juniper (Juniperus chinensis)" },
        { word: "コロラド柏槇", reading: "コロラドびゃくしん", meaning: "Rocky Mountain juniper (Juniperus scopulorum)" }
    ],
    },
    "槌": {
        onyomi: ["ツイ"],
        kunyomi: ["つち"],
        examples: [
        { word: "南槌鯨", reading: "みなみつちくじら", meaning: "Arnoux's beaked whale (Berardius arnuxii)" },
        { word: "槌鯨", reading: "つちくじら", meaning: "Baird's beaked whale (Berardius bairdii)" },
        { word: "破城槌", reading: "はじょうつい", meaning: "battering ram" }
    ],
    },
    "槍": {
        onyomi: ["ソウ", "ショウ"],
        kunyomi: ["やり"],
        examples: [
        { word: "千本槍", reading: "せんぼんやり", meaning: "Leibnitz daisy (Leibnitzia anandria)" },
        { word: "三又槍魚", reading: "みつまたやりうお", meaning: "Pacific blackdragon (Idiacanthus antrostomus)" },
        { word: "槍鱮", reading: "やりたなご", meaning: "Tanakia lanceolata (species of cyprinid)" }
    ],
    },
    "槙": {
        onyomi: ["テン", "シン"],
        kunyomi: ["まき", "こずえ"],
        examples: [
        { word: "阿部槙", reading: "あべまき", meaning: "Chinese cork oak (Quercus variabilis)" },
        { word: "伊吹柏槙", reading: "いぶきびゃくしん", meaning: "Chinese juniper (Juniperus chinensis)" },
        { word: "柏槙", reading: "びゃくしん", meaning: "Chinese juniper (Juniperus chinensis)" }
    ],
    },
    "槻": {
        onyomi: ["キ"],
        kunyomi: ["つき"],
        examples: [
        { word: "槻の木", reading: "つきのき", meaning: "Japanese zelkova" },
        { word: "槻欅", reading: "つきげやき", meaning: "Japanese zelkova (Zelkova serrata)" },
        { word: "槻", reading: "けやき", meaning: "Japanese zelkova (Zelkova serrata)" }
    ],
    },
    "樂": {
        onyomi: ["ガク", "ラク", "ゴウ"],
        kunyomi: ["たの.しい", "たの.しむ", "この.む"],
        examples: [
        { word: "樂員", reading: "がくいん", meaning: "bandsman" },
        { word: "音樂", reading: "おんがく", meaning: "music" },
        { word: "音樂會", reading: "おんがくかい", meaning: "concert, recital" }
    ],
    },
    "樋": {
        onyomi: ["トウ"],
        kunyomi: ["ひ", "とい"],
        examples: [
        { word: "樋川", reading: "ひがわ", meaning: "(water) spring" },
        { word: "伏せ樋", reading: "ふせどい", meaning: "covered drain" },
        { word: "樋嘴", reading: "ひはし", meaning: "gargoyle" }
    ],
    },
    "樟": {
        onyomi: ["ショウ"],
        kunyomi: ["くす"],
        examples: [
        { word: "樟科", reading: "くすのきか", meaning: "Lauraceae (laurel family of plants)" },
        { word: "犬樟", reading: "いぬぐす", meaning: "Machilus thunbergii (species of laurel)" },
        { word: "玉樟", reading: "たまぐす", meaning: "Machilus thunbergii (species of laurel)" }
    ],
    },
    "樣": {
        onyomi: ["ヨウ", "ショウ"],
        kunyomi: ["さま"],
        examples: [
        { word: "此樣", reading: "こなさま", meaning: "you" },
        { word: "仕樣", reading: "しよう", meaning: "way, method, means" }
    ],
    },
    "樫": {
        onyomi: [],
        kunyomi: ["かし"],
        examples: [
        { word: "尻深樫", reading: "シリブカガシ", meaning: "Japanese blue oak (Lithocarpus glaber)" },
        { word: "赤樫", reading: "あかがし", meaning: "Japanese evergreen oak (Quercus acuta)" },
        { word: "いちい樫", reading: "いちいがし", meaning: "Quercus gilva (species of oak)" }
    ],
    },
    "樺": {
        onyomi: ["カ"],
        kunyomi: ["かば", "かんば"],
        examples: [
        { word: "樺木科", reading: "かばのきか", meaning: "Betulaceae (birch family)" },
        { word: "樺黄小町蜘蛛", reading: "かばきこまちぐも", meaning: "Japanese foliage spider (Chiracanthium japonicum)" },
        { word: "白樺", reading: "しらかば", meaning: "Japanese white birch (Betula platyphylla var. japonica)" }
    ],
    },
    "樽": {
        onyomi: ["ソン"],
        kunyomi: ["たる"],
        examples: [
        { word: "樽俎", reading: "そんそ", meaning: "(eating or drinking) party" },
        { word: "市立小樽美術館", reading: "しりつおたるびじゅつかん", meaning: "Otaru City Museum of Art" },
        { word: "小樽商科大学", reading: "おたるしょうかだいがく", meaning: "Otaru University of Commerce" }
    ],
    },
    "橘": {
        onyomi: ["キツ"],
        kunyomi: ["たちばな"],
        examples: [
        { word: "四季橘", reading: "しききつ", meaning: "Calamansi (Citrus x microcarpa)" },
        { word: "京都橘大学", reading: "きょうとたちばなだいがく", meaning: "Kyoto Tachibana University" },
        { word: "京都橘女子大学", reading: "きょうとたちばなじょしだいがく", meaning: "Kyoto Tachibana Women's University" }
    ],
    },
    "橙": {
        onyomi: ["トウ"],
        kunyomi: ["だいだい"],
        examples: [
        { word: "橙酢", reading: "だいだいず", meaning: "bitter orange juice (used as a food acid)" },
        { word: "臭橙", reading: "かぼす", meaning: "kabosu (type of citrus fruit) (Citrus sphaerocarpa)" },
        { word: "橙花油", reading: "とうかゆ", meaning: "neroli oil (essential oil made from bitter orange flowers)" }
    ],
    },
    "橫": {
        onyomi: ["オウ", "コウ"],
        kunyomi: ["よこ", "よこたわる", "よこたえる"],
        examples: [],
    },
    "檀": {
        onyomi: ["ダン", "タン"],
        kunyomi: ["まゆみ"],
        examples: [
        { word: "仏檀", reading: "ぶつだん", meaning: "Buddhist (household) altar" },
        { word: "檀林派", reading: "だんりんは", meaning: "Danrin school (of haikai poetry)" },
        { word: "檀香", reading: "だんこう", meaning: "Indian sandalwood (Santalum album)" }
    ],
    },
    "檎": {
        onyomi: ["キン", "ゴン", "ゴ"],
        kunyomi: [],
        examples: [
        { word: "和林檎", reading: "わりんご", meaning: "Chinese apple (Malus asiatica)" },
        { word: "姫林檎", reading: "ひめりんご", meaning: "Chinese crab apple (Malus prunifolia)" },
        { word: "林檎", reading: "りゅうごう", meaning: "apple" }
    ],
    },
    "檜": {
        onyomi: ["カイ"],
        kunyomi: ["ひのき", "ひ"],
        examples: [
        { word: "檜扇菖蒲", reading: "ひおうぎあやめ", meaning: "Arctic iris (Iris setosa)" },
        { word: "矮鶏檜葉", reading: "チャボひば", meaning: "Chamaecyparis obtusa var. breviramea (ornamental variety of hinoki cypress)" },
        { word: "黒檜", reading: "くろべ", meaning: "Japanese arborvitae (Thuja standishii)" }
    ],
    },
    "檢": {
        onyomi: ["ケン"],
        kunyomi: ["しら.べる"],
        examples: [
        { word: "檢事", reading: "けんじ", meaning: "public prosecutor" },
        { word: "檢察", reading: "けんさつ", meaning: "criminal investigation, prosecution, examination" }
    ],
    },
    "櫂": {
        onyomi: ["トウ", "タク"],
        kunyomi: ["かい", "かじ"],
        examples: [
        { word: "櫓櫂", reading: "ろかい", meaning: "sculls and paddles" },
        { word: "打ち櫂", reading: "うちがい", meaning: "type of oar" },
        { word: "櫂", reading: "かい", meaning: "paddle, oar, scull" }
    ],
    },
    "櫓": {
        onyomi: ["ロ"],
        kunyomi: ["やぐら", "おおだて"],
        examples: [
        { word: "櫓", reading: "ろ", meaning: "Japanese scull (oar attached to the rear of the boat by a traditional peg-in-hole oarlock)" },
        { word: "櫓杭", reading: "ろぐい", meaning: "fulcrum peg (fitted into the cavity in an oar as part of a traditional oarlock)" },
        { word: "櫓臍", reading: "ろべそ", meaning: "fulcrum peg (fitted into the cavity in an oar as part of a traditional oarlock)" }
    ],
    },
    "櫛": {
        onyomi: ["シツ"],
        kunyomi: ["くし", "くしけず.る"],
        examples: [
        { word: "有���動物門", reading: "ゆうしつどうぶつもん", meaning: "Ctenophora (phylum comprising the comb jellies)" },
        { word: "櫛", reading: "くし", meaning: "comb" },
        { word: "櫛型", reading: "くしがた", meaning: "comb formation" }
    ],
    },
    "櫻": {
        onyomi: ["オウ", "ヨウ"],
        kunyomi: ["さくら"],
        examples: [
        { word: "櫻花", reading: "おうか", meaning: "cherry blossom" },
        { word: "初櫻", reading: "はつざくら", meaning: "first cherry blossom of the year" },
        { word: "櫻井鉱", reading: "さくらいこう", meaning: "sakuraiite" }
    ],
    },
    "欣": {
        onyomi: ["キン", "ゴン", "コン"],
        kunyomi: ["よろこ.ぶ", "よろこ.び"],
        examples: [
        { word: "欣求", reading: "ごんぐ", meaning: "earnest aspiration (to go to paradise)" },
        { word: "欣喜雀躍", reading: "きんきじゃくやく", meaning: "jump up for joy" },
        { word: "欣喜", reading: "きんき", meaning: "pleasure" }
    ],
    },
    "欽": {
        onyomi: ["キン", "コン"],
        kunyomi: ["つつし.む"],
        examples: [
        { word: "欽定憲法", reading: "きんていけんぽう", meaning: "constitution granted by the Emperor" },
        { word: "欽定英訳聖書", reading: "きんていえいやくせいしょ", meaning: "Authorized Version (of the Bible), AV" },
        { word: "欽定訳聖書", reading: "きんていやくせいしょ", meaning: "King James Bible, King James Version, Authorized Version" }
    ],
    },
    "歎": {
        onyomi: ["タン"],
        kunyomi: ["なげ.く", "なげ.��"],
        examples: [
        { word: "一読三歎", reading: "いちどくさんたん", meaning: "a reading leaves one with ceaseless sighs of admiration" },
        { word: "傷歎", reading: "しょうたん", meaning: "crying in pain" },
        { word: "長歎", reading: "ちょうたん", meaning: "deep sigh" }
    ],
    },
    "此": {
        onyomi: ["シ"],
        kunyomi: ["これ", "この", "ここ"],
        examples: [
        { word: "此の君", reading: "このきみ", meaning: "bamboo" },
        { word: "此れ者", reading: "これしゃ", meaning: "gambler" },
        { word: "此方こそ", reading: "こちらこそ", meaning: "it is I who should say so" }
    ],
    },
    "步": {
        onyomi: ["ホ", "ブ", "フ"],
        kunyomi: ["あるく", "あゆむ", "あゆみ"],
        examples: [
        { word: "步く", reading: "あるく", meaning: "to walk" },
        { word: "散步", reading: "さんぽ", meaning: "walk, stroll" }
    ],
    },
    "歷": {
        onyomi: [],
        kunyomi: [],
        examples: [
        { word: "歷史", reading: "れきし", meaning: "history" }
    ],
    },
    "殆": {
        onyomi: ["タイ", "サイ"],
        kunyomi: ["ほとほと", "ほとん.ど", "あやうい"],
        examples: [
        { word: "殆どの人", reading: "ほとんどのひと", meaning: "almost everyone" },
        { word: "彼を知り己を知れば、百戦殆からず", reading: "かれをしりおのれをしれば、ひゃくせんあやうからず", meaning: "if you know your enemy and know yourself, in a hundred battles you will never be defeated, know your enemy" },
        { word: "危殆に瀕する", reading: "きたいにひんする", meaning: "to face danger, to fall into crisis" }
    ],
    },
    "毅": {
        onyomi: ["キ", "ギ"],
        kunyomi: ["つよ.い"],
        examples: [
        { word: "聡明剛毅", reading: "そうめいごうき", meaning: "be reasonable, strong and do not give in" },
        { word: "毅然として", reading: "きぜんとして", meaning: "with resolution" },
        { word: "剛毅果断", reading: "ごうきかだん", meaning: "dauntless and decisive, with fortitude and resolution" }
    ],
    },
    "每": {
        onyomi: ["マイ", "バイ"],
        kunyomi: ["つね"],
        examples: [],
    },
    "毘": {
        onyomi: ["ヒ", "ビ"],
        kunyomi: ["たす.ける"],
        examples: [
        { word: "阿毘達磨倶舍論", reading: "あびだつまくしゃろん", meaning: "Abhidharma Storehouse Treatise" },
        { word: "亜拉毘亜", reading: "アラビア", meaning: "Arabia" },
        { word: "摩訶毘盧遮那", reading: "まかびるしゃな", meaning: "Mahavairocana (Buddha who symbolizes the entirety of the phenomenological world)" }
    ],
    },
    "毬": {
        onyomi: ["キュウ"],
        kunyomi: ["いが", "まり"],
        examples: [
        { word: "松毬魚", reading: "まつかさうお", meaning: "Japanese pinecone fish (Monocentris japonica)" },
        { word: "松毬貝", reading: "まつかさがい", meaning: "Pronodularia japanensis (species of freshwater mussel)" },
        { word: "金葉手毬", reading: "きんばでまり", meaning: "Viburnum plicatum var. plicatum" }
    ],
    },
    "氣": {
        onyomi: ["キ", "ケ"],
        kunyomi: ["いき"],
        examples: [
        { word: "合氣道", reading: "あいきどう", meaning: "aikido" },
        { word: "意氣", reading: "いき", meaning: "spirit, heart, disposition" },
        { word: "氣功", reading: "きこう", meaning: "breathing exercise, breath control, spirit cultivation" }
    ],
    },
    "汀": {
        onyomi: ["テイ"],
        kunyomi: ["みぎわ", "なぎさ"],
        examples: [
        { word: "長汀", reading: "ちょうてい", meaning: "long shore" },
        { word: "長汀曲浦", reading: "ちょうていきょくほ", meaning: "long stretch of winding beach" },
        { word: "汀渚", reading: "ていしょ", meaning: "sand bar, waters edge" }
    ],
    },
    "汐": {
        onyomi: ["セキ"],
        kunyomi: ["しお", "うしお", "せい"],
        examples: [
        { word: "引き汐", reading: "ひきしお", meaning: "ebb tide" },
        { word: "夕汐", reading: "ゆうしお", meaning: "evening tide" },
        { word: "潮汐摩擦", reading: "ちょうせきまさつ", meaning: "tidal friction" }
    ],
    },
    "汝": {
        onyomi: ["ジョ"],
        kunyomi: ["なんじ", "なれ", "い", "うぬ", "いまし", "し", "しゃ", "な", "なむち", "まし", "みまし"],
        examples: [
        { word: "汝自身を知れ", reading: "なんじじしんをしれ", meaning: "Know thyself" },
        { word: "汝自らを知れ", reading: "なんじみずからをしれ", meaning: "Know thyself" },
        { word: "弱き者汝の名は女なり", reading: "よわきものなんじのなはおんななり", meaning: "frailty, thy name is woman" }
    ],
    },
    "汲": {
        onyomi: ["キュウ"],
        kunyomi: ["く.む"],
        examples: [
        { word: "汲み置き", reading: "くみおき", meaning: "drawn water" },
        { word: "汲み取り口", reading: "くみとりぐち", meaning: "hole for pumping out a cesspool" },
        { word: "汲み取り屋", reading: "くみとりや", meaning: "person who gathers night soil" }
    ],
    },
    "沌": {
        onyomi: ["トン"],
        kunyomi: ["くら.い"],
        examples: [
        { word: "混沌", reading: "こんとん", meaning: "chaos, confusion, disorder" }
    ],
    },
    "沓": {
        onyomi: ["トウ"],
        kunyomi: ["くつ"],
        examples: [
        { word: "靴の沓", reading: "かのくつ", meaning: "black-lacquered cowhide boots with curved toes, metal buckles, and brocade tops (worn with ceremonial dress)" },
        { word: "深沓", reading: "ふかぐつ", meaning: "deep boots" },
        { word: "鉄沓", reading: "かなぐつ", meaning: "horseshoe" }
    ],
    },
    "沫": {
        onyomi: ["マツ", "バツ"],
        kunyomi: ["あわ", "しぶき", "つばき"],
        examples: [
        { word: "飛沫感染", reading: "ひまつかんせん", meaning: "droplet infection" },
        { word: "飛沫核感染", reading: "ひまつかくかんせん", meaning: "droplet nuclei infection" },
        { word: "飛沫核", reading: "ひまつかく", meaning: "droplet nucleus" }
    ],
    },
    "洛": {
        onyomi: ["ラク"],
        kunyomi: [],
        examples: [
        { word: "洛学", reading: "らくがく", meaning: "Luo Xue school (neo-Confucianist school)" },
        { word: "摩洛哥", reading: "モロッコ", meaning: "Morocco" },
        { word: "京洛", reading: "きょうらく", meaning: "capital (esp. Kyoto)" }
    ],
    },
    "洲": {
        onyomi: ["シュウ", "ス"],
        kunyomi: ["しま"],
        examples: [
        { word: "三角洲", reading: "さんかくす", meaning: "(river) delta" },
        { word: "濠洲", reading: "ごうしゅう", meaning: "Australia" },
        { word: "欧洲", reading: "おうしゅう", meaning: "Europe" }
    ],
    },
    "洵": {
        onyomi: ["ジュン", "シュン"],
        kunyomi: ["の.ぶ", "まこと.に"],
        examples: [
        { word: "洵美", reading: "じゅんび", meaning: "exquisite, truly beautiful" },
        { word: "洵に", reading: "まことに", meaning: "really, truly, very" }
    ],
    },
    "洸": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "洸洋", reading: "こうよう", meaning: "unfathomable, great expanse of water, incoherent" },
        { word: "洸洸", reading: "こうこう", meaning: "valiant, brave, surge (of water)" }
    ],
    },
    "浩": {
        onyomi: ["コウ"],
        kunyomi: ["おおき.い", "ひろ.い"],
        examples: [
        { word: "呼和浩特", reading: "フフホト", meaning: "Hohhot (China)" },
        { word: "浩瀚", reading: "こうかん", meaning: "bulky, voluminous" },
        { word: "浩然の気を養う", reading: "こうぜんのきをやしなう", meaning: "to enliven one's spirit, to refresh oneself, to cheer oneself up" }
    ],
    },
    "浬": {
        onyomi: ["リ"],
        kunyomi: ["かいり", "のっと"],
        examples: [
        { word: "浬", reading: "ノット", meaning: "knot (nautical mile per hour)" }
    ],
    },
    "涉": {
        onyomi: ["ショウ"],
        kunyomi: ["わたる", "かかわる"],
        examples: [],
    },
    "淀": {
        onyomi: ["テン", "デン"],
        kunyomi: ["よど.む"],
        examples: [
        { word: "淀", reading: "よど", meaning: "pool (in river)" },
        { word: "淀木瓜", reading: "よどぼけ", meaning: "Choenomeles lagenaria, yodoboke flowering quince" },
        { word: "淀みない", reading: "よどみない", meaning: "fluent, smooth, flowing" }
    ],
    },
    "淋": {
        onyomi: ["リン"],
        kunyomi: ["さび.しい", "さみ.しい"],
        examples: [
        { word: "油淋鶏", reading: "ユーリンチー", meaning: "Chinese-style fried chicken topped with chopped scallions and sweet vinegar and soy sauce" },
        { word: "鮮血淋漓", reading: "せんけつりんり", meaning: "dripping with fresh blood" },
        { word: "淋菌", reading: "りんきん", meaning: "gonococcus (Neisseria gonorrhoeae)" }
    ],
    },
    "淚": {
        onyomi: ["ルイ", "レイ"],
        kunyomi: ["なみだ"],
        examples: [],
    },
    "淨": {
        onyomi: ["ジョウ", "セイ"],
        kunyomi: ["きよ.める", "きよ.い"],
        examples: [],
    },
    "淳": {
        onyomi: ["ジュン", "シュン"],
        kunyomi: ["あつ.い"],
        examples: [
        { word: "淳久堂", reading: "じゅんくどう", meaning: "Junkudo (Japanese bookstore chain)" },
        { word: "淳良", reading: "じゅんりょう", meaning: "simple and kind, innocent" },
        { word: "淳風美俗", reading: "じゅんぷうびぞく", meaning: "good morals and manners, genial manners and laudable customs, pristine way of life" }
    ],
    },
    "淵": {
        onyomi: ["エン", "カク", "コウ"],
        kunyomi: ["ふち", "かた.い", "はなわ"],
        examples: [
        { word: "淵源", reading: "えんげん", meaning: "origin" },
        { word: "海淵", reading: "かいえん", meaning: "(ocean) deep, deepest part of a trench" },
        { word: "深淵", reading: "しんえん", meaning: "abyss, ravine" }
    ],
    },
    "渚": {
        onyomi: ["ショ"],
        kunyomi: ["なぎさ"],
        examples: [
        { word: "汀渚", reading: "ていしょ", meaning: "sand bar, waters edge" },
        { word: "渚畔", reading: "しょはん", meaning: "shore, waterside" },
        { word: "渚", reading: "なぎさ", meaning: "water's edge, beach, shore" }
    ],
    },
    "渥": {
        onyomi: ["アク"],
        kunyomi: ["あつ.い", "うるお.う"],
        examples: [
        { word: "渥然", reading: "あくぜん", meaning: "glossy" },
        { word: "優渥", reading: "ゆうあく", meaning: "gracious" },
        { word: "渥地", reading: "あくち", meaning: "marshland" }
    ],
    },
    "渴": {
        onyomi: ["カツ"],
        kunyomi: ["かわ.く", "かわき"],
        examples: [],
    },
    "渾": {
        onyomi: ["コン"],
        kunyomi: ["すべ.て", "にご.る"],
        examples: [
        { word: "渾々", reading: "こんこん", meaning: "(flowing) copiously" },
        { word: "渾天儀", reading: "こんてんぎ", meaning: "armillary sphere" },
        { word: "渾然一体", reading: "こんぜんいったい", meaning: "in complete harmony" }
    ],
    },
    "湊": {
        onyomi: ["ソウ"],
        kunyomi: ["みなと", "あつ.まる"],
        examples: [
        { word: "春の湊", reading: "はるのみなと", meaning: "end of spring" },
        { word: "湊", reading: "みなと", meaning: "harbour, harbor, port" },
        { word: "輻湊", reading: "ふくそう", meaning: "congestion, overcrowding, pile-up" }
    ],
    },
    "湘": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "湘南ゴールド", reading: "しょうなんゴールド", meaning: "Shonan Gold (hybrid Japanese citrus)" },
        { word: "湘南工科大学", reading: "しょうなんこうかだいがく", meaning: "Shonan Institute of Technology" },
        { word: "湘南鎌倉医療大学", reading: "しょうなんかまくらいりょうだいがく", meaning: "Shonan Kamakura University of Medical Sciences" }
    ],
    },
    "湛": {
        onyomi: ["タン", "チン", "ジン", "セン"],
        kunyomi: ["しず.む", "たた.える"],
        examples: [
        { word: "笑みを湛える", reading: "えみをたたえる", meaning: "to be all smiles" },
        { word: "湛然", reading: "たんぜん", meaning: "still and full of water, quiet and unmoving" },
        { word: "湛水", reading: "たんすい", meaning: "flooding, filling, inundation" }
    ],
    },
    "溜": {
        onyomi: ["リュウ"],
        kunyomi: ["た.まる", "たま.る", "た.める", "したた.る", "たまり", "ため"],
        examples: [
        { word: "掃き溜めに鶴", reading: "はきだめにつる", meaning: "a jewel in a dunghill" },
        { word: "分解蒸溜法", reading: "ぶんかいじょうりゅうほう", meaning: "cracking" },
        { word: "溜出", reading: "りゅうしゅつ", meaning: "distillation" }
    ],
    },
    "溢": {
        onyomi: ["イツ"],
        kunyomi: ["こぼ.れる", "あふ.れる", "み.ち���"],
        examples: [
        { word: "脳溢血", reading: "のういっけつ", meaning: "cerebral hemorrhage" },
        { word: "溢れ", reading: "あぶれ", meaning: "failing to get a job" },
        { word: "溢れ検査", reading: "あふれけんさ", meaning: "overflow check" }
    ],
    },
    "溫": {
        onyomi: ["オン", "ウン"],
        kunyomi: ["あたたか", "あたためる"],
        examples: [],
    },
    "滉": {
        onyomi: ["コウ"],
        kunyomi: ["ひろ.い"],
        examples: [
        { word: "滉瀁", reading: "こうよう", meaning: "wide and deep (of a body of water)" }
    ],
    },
    "滯": {
        onyomi: ["タイ", "テイ"],
        kunyomi: ["とどこお.る"],
        examples: [],
    },
    "漕": {
        onyomi: ["ソウ"],
        kunyomi: ["こ.ぐ", "はこ.ぶ"],
        examples: [
        { word: "手漕ぎボート", reading: "てこぎボート", meaning: "rowboat" },
        { word: "力漕", reading: "りきそう", meaning: "rowing hard" },
        { word: "サバニ帆漕", reading: "サバニはんそう", meaning: "sabani sailing and paddling regatta (Okinawa)" }
    ],
    },
    "漣": {
        onyomi: ["レン", "ラン"],
        kunyomi: ["さざなみ"],
        examples: [
        { word: "漣音", reading: "れんおん", meaning: "mordent" },
        { word: "漣痕", reading: "れんこん", meaning: "ripple mark" },
        { word: "漣々", reading: "れんれん", meaning: "flowing endlessly (of tears), rippling (of water)" }
    ],
    },
    "漱": {
        onyomi: ["ソウ", "シュウ", "ス"],
        kunyomi: ["くちすす.ぐ", "くちそそ.ぐ", "うがい", "すす.ぐ"],
        examples: [
        { word: "漱石��流", reading: "そうせきちんりゅう", meaning: "sore loser who stubbornly refuses to admit being wrong" },
        { word: "枕流漱石", reading: "ちんりゅうそうせき", meaning: "sore loser who stubbornly refuses to admit being wrong" },
        { word: "盥漱", reading: "かんそう", meaning: "washing one's hands and rinsing one's mouth" }
    ],
    },
    "澁": {
        onyomi: ["ジュウ", "シュウ"],
        kunyomi: ["しぶ", "しぶ.い", "しぶ.る"],
        examples: [
        { word: "澁谷", reading: "しぶや", meaning: "Shibuya City (special ward of Tokyo), Shibuya" },
        { word: "澁い", reading: "しぶい", meaning: "astringent, bitter, puckery" }
    ],
    },
    "澪": {
        onyomi: ["レイ"],
        kunyomi: ["みお"],
        examples: [
        { word: "澪標", reading: "みおつくし", meaning: "marks in a water channel, channel buoys" },
        { word: "澪", reading: "みお", meaning: "waterway, channel, wake (of a ship)" }
    ],
    },
    "濕": {
        onyomi: ["シツ", "シュウ"],
        kunyomi: ["しめ.る", "しめ.す", "うるお.う", "うるお.す"],
        examples: [],
    },
    "濡": {
        onyomi: ["ジュ", "ニュ"],
        kunyomi: ["ぬれ.る", "ぬら.す", "ぬ.れる", "ぬ.らす", "うるお.い", "うるお.う", "うるお.す"],
        examples: [
        { word: "濡れ仏", reading: "ぬれぼとけ", meaning: "Buddhist image in the open" },
        { word: "濡れ手に粟", reading: "ぬれてにあわ", meaning: "easy profit" },
        { word: "濡れ手で粟", reading: "ぬれてであわ", meaning: "easy profit" }
    ],
    },
    "瀕": {
        onyomi: ["ヒン"],
        kunyomi: ["ほとり"],
        examples: [
        { word: "瀕死", reading: "ひんし", meaning: "(on the) verge of death" },
        { word: "危殆に瀕する", reading: "きたいにひんする", meaning: "to face danger, to fall into crisis" },
        { word: "瀕死状態", reading: "ひんしじょうたい", meaning: "moribund state, near-death, barely alive condition" }
    ],
    },
    "瀧": {
        onyomi: ["ロウ", "ソウ"],
        kunyomi: ["たき"],
        examples: [
        { word: "瀧", reading: "たき", meaning: "waterfall, rapids" }
    ],
    },
    "瀨": {
        onyomi: ["ライ"],
        kunyomi: ["せ"],
        examples: [],
    },
    "灘": {
        onyomi: ["タン", "ダン"],
        kunyomi: ["なだ", "せ"],
        examples: [
        { word: "灘", reading: "なだ", meaning: "open sea" }
    ],
    },
    "灸": {
        onyomi: ["キュウ", "ク"],
        kunyomi: ["やいと"],
        examples: [
        { word: "明治鍼灸大学", reading: "めいじしんきゅうだいがく", meaning: "Meiji College of Oriental Medicine" },
        { word: "鍼灸", reading: "しんきゅう", meaning: "acupuncture and moxibustion" },
        { word: "鍼灸院", reading: "しんきゅういん", meaning: "acupuncture and moxibustion clinic" }
    ],
    },
    "灼": {
        onyomi: ["シャク"],
        kunyomi: ["あらた", "やく"],
        examples: [
        { word: "焼灼", reading: "しょうしゃく", meaning: "cautery, cauterization" },
        { word: "胸灼け", reading: "むねやけ", meaning: "heartburn, sour stomach" },
        { word: "灼く", reading: "やく", meaning: "to tan (i.e. suntan), to burn" }
    ],
    },
    "烏": {
        onyomi: ["ウ", "オ"],
        kunyomi: ["からす", "いずくんぞ", "なんぞ"],
        examples: [
        { word: "烏揚羽", reading: "からすあげは", meaning: "Chinese peacock (species of swallowtail butterfly, Papilio bianor)" },
        { word: "烏河豚", reading: "からす", meaning: "Chinese puffer (Takifugu chinensis)" },
        { word: "烏臼", reading: "うきゅう", meaning: "Chinese tallow (as an ingredient in Chinese medicine)" }
    ],
    },
    "焚": {
        onyomi: ["フン", "ホン", "ハン"],
        kunyomi: ["た.く", "や.く", "やきがり"],
        examples: [
        { word: "火焚き", reading: "ほたき", meaning: "Kyoto area festival held on the 11th lunar month (wherein bonfires are burned at shrines)" },
        { word: "お火焚", reading: "おひたき", meaning: "Kyoto area festival held on the 11th lunar month (wherein bonfires are burned at shrines)" },
        { word: "焚書", reading: "ふんしょ", meaning: "book burning" }
    ],
    },
    "焰": {
        onyomi: ["エン"],
        kunyomi: ["ほのお"],
        examples: [
        { word: "火焰太鼓", reading: "かえんだいこ", meaning: "dadaiko drum (decorated with flames)" },
        { word: "気焰", reading: "きえん", meaning: "high spirits, boastful talk" },
        { word: "焰色", reading: "えんしょく", meaning: "flame (color, colour), flame scarlet, bright reddish" }
    ],
    },
    "煉": {
        onyomi: ["レン"],
        kunyomi: ["ね.る"],
        examples: [
        { word: "煉り製品", reading: "ねりせいひん", meaning: "boiled fish-paste products" },
        { word: "薬煉", reading: "くすね", meaning: "boiled pine pitch and oil (traditionally used as a glue in archery, etc.)" },
        { word: "煉瓦", reading: "れんが", meaning: "brick" }
    ],
    },
    "煌": {
        onyomi: ["コウ"],
        kunyomi: ["きらめ.く", "きら.めく", "かがや.く"],
        examples: [
        { word: "煌星", reading: "きらぼし", meaning: "glittering stars" },
        { word: "輝煌帝", reading: "きこうてい", meaning: "poetic word for the sun" },
        { word: "敦煌", reading: "とんこう", meaning: "sincerity and kindheartedness, honesty and simplicity" }
    ],
    },
    "煤": {
        onyomi: ["バイ", "マイ"],
        kunyomi: ["すす"],
        examples: [
        { word: "煤色", reading: "すすいろ", meaning: "color of soot (colour)" },
        { word: "煤", reading: "すす", meaning: "soot" },
        { word: "松煤", reading: "しょうばい", meaning: "soot of burnt pine" }
    ],
    },
    "熙": {
        onyomi: ["キ"],
        kunyomi: ["たのし.む", "ひか.る", "ひろ.い", "よろこ.ぶ", "かわ.く", "あきらか", "ひろ.める", "ひろ.まる"],
        examples: [
        { word: "康熙", reading: "こうき", meaning: "Kangxi era (of emperor Shengzu of Qing; 1661-1722)" },
        { word: "熙春茶", reading: "ひちゅんちゃ", meaning: "hyson (Chinese green tea)" },
        { word: "康熙字典", reading: "こうきじてん", meaning: "Kangxi dictionary, Chinese dictionary of 1716, which popularized the system of 214 radicals" }
    ],
    },
    "燈": {
        onyomi: ["トウ"],
        kunyomi: ["ひ", "ほ-", "ともしび", "とも.す", "あかり"],
        examples: [
        { word: "照空燈", reading: "しょうくうとう", meaning: "(anti-aircraft) searchlight" },
        { word: "燈心", reading: "とうしん", meaning: "(lamp) wick" },
        { word: "秋田竿燈まつり", reading: "あきたかんとうまつり", meaning: "Akita Kantō Festival (3-6 August)" }
    ],
    },
    "燎": {
        onyomi: ["リョウ"],
        kunyomi: ["かがりび"],
        examples: [
        { word: "庭燎", reading: "にわび", meaning: "garden bonfire (esp. one held on the imperial grounds)" },
        { word: "燎原の火", reading: "りょうげんのひ", meaning: "wildfire" },
        { word: "燎原", reading: "りょうげん", meaning: "agricultural burning, setting a field ablaze" }
    ],
    },
    "燒": {
        onyomi: ["ショウ"],
        kunyomi: ["や.く", "や.ける"],
        examples: [
        { word: "燒賣", reading: "しゅうまい", meaning: "shumai, shaomai, steamed meat dumpling (Chinese-style)" }
    ],
    },
    "燕": {
        onyomi: ["エン"],
        kunyomi: ["つばめ", "つばくら", "つばくろ"],
        examples: [
        { word: "燕楽", reading: "えんがく", meaning: "Ancient Chinese banquet music" },
        { word: "岩燕", reading: "いわつばめ", meaning: "Asian house martin (Delichon dasypus)" },
        { word: "姫海燕", reading: "ひめうみつばめ", meaning: "European storm petrel (Hydrobates pelagicus)" }
    ],
    },
    "燦": {
        onyomi: ["サン"],
        kunyomi: ["さん.たる", "あき.らか", "きらめ.く", "きら.めく"],
        examples: [
        { word: "燦々", reading: "さんさん", meaning: "brilliant, bright" },
        { word: "燦", reading: "さん", meaning: "brilliant, resplendent" },
        { word: "燦然と輝く", reading: "さんぜんとかがやく", meaning: "to shine brilliantly, to shine radiantly" }
    ],
    },
    "燭": {
        onyomi: ["ソク", "ショク"],
        kunyomi: ["ともしび"],
        examples: [
        { word: "蝋燭", reading: "ろうそく", meaning: "candle" },
        { word: "絵蝋燭", reading: "えろうそく", meaning: "candle decorated with coloured pictures (esp. of flowers or birds)" },
        { word: "蝋燭立て", reading: "ろうそくたて", meaning: "candle holder" }
    ],
    },
    "燿": {
        onyomi: ["ヨウ"],
        kunyomi: ["かがや.く", "ひかり"],
        examples: [
        { word: "黒燿石", reading: "こくようせき", meaning: "obsidian" }
    ],
    },
    "爭": {
        onyomi: ["ソウ"],
        kunyomi: ["あらそ.う", "いか.でか"],
        examples: [
        { word: "鬪爭", reading: "とうそう", meaning: "fight, battle, combat" }
    ],
    },
    "爲": {
        onyomi: ["イ"],
        kunyomi: ["ため", "な.る", "な.す", "す.る", "たり", "つく.る", "なり"],
        examples: [
        { word: "爲さる", reading: "なさる", meaning: "to do" },
        { word: "爲政", reading: "いせい", meaning: "governing, administering" },
        { word: "爲す", reading: "なす", meaning: "to do, to commit, to carry out" }
    ],
    },
    "爾": {
        onyomi: ["ジ", "ニ"],
        kunyomi: ["なんじ", "しかり", "その", "のみ", "おれ", "しか"],
        examples: [
        { word: "阿爾及", reading: "アルジェリア", meaning: "Algeria" },
        { word: "亜爾然丁", reading: "アルゼンチン", meaning: "Argentina" },
        { word: "亜爾然丁蟻", reading: "アルゼンチンアリ", meaning: "Argentine ant (Linepithema humile)" }
    ],
    },
    "牒": {
        onyomi: ["チョウ", "ジョウ"],
        kunyomi: ["ふだ"],
        examples: [
        { word: "移牒", reading: "いちょう", meaning: "notification to authorities" },
        { word: "最後通牒", reading: "さいごつうちょう", meaning: "ultimatum" },
        { word: "来牒", reading: "らいちょう", meaning: "correspondence, received letter or note" }
    ],
    },
    "牟": {
        onyomi: ["ボウ", "ム"],
        kunyomi: [],
        examples: [
        { word: "牟子", reading: "むし", meaning: "conical hat with a veil" },
        { word: "大穴牟遅命", reading: "おおあなむちのみこと", meaning: "Okuninushi, deity of magic and medicine later viewed as equivalent to Daikokuten and celebrated at Izumo Grand Shrine" },
        { word: "大穴牟遅神", reading: "おおなむちのかみ", meaning: "Okuninushi, deity of magic and medicine later viewed as equivalent to Daikokuten and celebrated at Izumo Grand Shrine" }
    ],
    },
    "牡": {
        onyomi: ["ボ", "ボウ"],
        kunyomi: ["おす", "お-", "おん-"],
        examples: [
        { word: "野牡丹", reading: "のぼたん", meaning: "Asian melastome (Melastoma candidum)" },
        { word: "草牡丹", reading: "クサボタン", meaning: "Clematis stans (buttercup species)" },
        { word: "岩牡蠣", reading: "いわがき", meaning: "Iwagaki oyster (Crassostrea nippona)" }
    ],
    },
    "牽": {
        onyomi: ["ケン"],
        kunyomi: ["ひ.く"],
        examples: [
        { word: "牽強", reading: "けんきょう", meaning: "distortion of facts" },
        { word: "牽制作戦", reading: "けんせいさくせん", meaning: "diversionary operations" },
        { word: "牽牛子", reading: "けんごし", meaning: "morning glory seeds (medicinal use)" }
    ],
    },
    "犀": {
        onyomi: ["サイ", "セイ"],
        kunyomi: [],
        examples: [
        { word: "犀皮塗��", reading: "さいひぬり", meaning: "Chinese lacquerware technique resulting in a mottled finish" },
        { word: "ジャワ犀", reading: "ジャワさい", meaning: "Javan rhinoceros (Rhinoceros sondaicus)" },
        { word: "スマトラ犀", reading: "スマトラさい", meaning: "Sumatran rhinoceros (Dicerorhinus sumatrensis)" }
    ],
    },
    "狀": {
        onyomi: ["ジョウ"],
        kunyomi: [],
        examples: [],
    },
    "狹": {
        onyomi: ["キョウ", "コウ"],
        kunyomi: ["せま.い", "せば.める", "せば.まる", "さ"],
        examples: [],
    },
    "狼": {
        onyomi: ["ロウ"],
        kunyomi: ["おおかみ"],
        examples: [
        { word: "狼男", reading: "おおかみおとこ", meaning: "(male) werewolf" },
        { word: "北極狼", reading: "ほっきょくおおかみ", meaning: "Arctic wolf (Canis lupus arctos)" },
        { word: "狼魚", reading: "おおかみうお", meaning: "Bering wolffish (Anarhichas orientalis)" }
    ],
    },
    "猪": {
        onyomi: ["チョ"],
        kunyomi: ["い", "いのしし"],
        examples: [
        { word: "鹿猪", reading: "しかいのしし", meaning: "babirusa (Babyrousa babyrussa)" },
        { word: "猪口", reading: "いぐち", meaning: "bolete" },
        { word: "猪首", reading: "いくび", meaning: "bull neck" }
    ],
    },
    "獅": {
        onyomi: ["シ"],
        kunyomi: ["しし"],
        examples: [
        { word: "金獅子賞", reading: "きんじししょう", meaning: "Golden Lion (highest prize at the Venice Film Festival)" },
        { word: "獅子蘭", reading: "ししらん", meaning: "Haplopteris flexuosa (species of shoestring fern)" },
        { word: "鏡獅子", reading: "かがみじし", meaning: "Kagamijishi" }
    ],
    },
    "獸": {
        onyomi: ["ジュウ"],
        kunyomi: ["けもの", "けだもの"],
        examples: [
        { word: "双蹄獸", reading: "そうていじゅう", meaning: "cloven-hoofed animal" },
        { word: "獸耳", reading: "けものみみ", meaning: "kemonomimi, character with animal ears" }
    ],
    },
    "玖": {
        onyomi: ["キュウ", "ク"],
        kunyomi: [],
        examples: [
        { word: "玖馬", reading: "キューバ", meaning: "Cuba" },
        { word: "玖", reading: "きゅう", meaning: "nine, 9" }
    ],
    },
    "玲": {
        onyomi: ["レイ"],
        kunyomi: [],
        examples: [
        { word: "白玲", reading: "はくれい", meaning: "Hakurei (one of the eight major professional female titles of shogi)" },
        { word: "玲々", reading: "れいれい", meaning: "tinkling (jewels, metal, etc.)" },
        { word: "八面玲瓏", reading: "はちめんれいろう", meaning: "beautiful from all sides, perfect serenity, affability" }
    ],
    },
    "珀": {
        onyomi: ["ハク"],
        kunyomi: [],
        examples: [
        { word: "琥珀", reading: "こはく", meaning: "amber" },
        { word: "琥珀色", reading: "こはくいろ", meaning: "amber (colour, color)" },
        { word: "琥珀酸", reading: "こはくさん", meaning: "succinic acid" }
    ],
    },
    "珂": {
        onyomi: ["カ"],
        kunyomi: [],
        examples: [
        { word: "馬珂貝", reading: "バカガイ", meaning: "Mactra chinensis (species of trough shell)" }
    ],
    },
    "珈": {
        onyomi: ["カ"],
        kunyomi: ["かみかざり"],
        examples: [
        { word: "珈琲館", reading: "コーヒーかん", meaning: "Kohikan (Japanese coffee shop chain)" },
        { word: "珈琲苑", reading: "コーヒーえん", meaning: "Kōhiien (coffee shop)" },
        { word: "ウインナー珈琲", reading: "ウインナーコーヒー", meaning: "Vienna coffee" }
    ],
    },
    "珊": {
        onyomi: ["サン"],
        kunyomi: ["センチ", "さんち"],
        examples: [
        { word: "珊瑚海", reading: "さんごかい", meaning: "Coral Sea" },
        { word: "珊瑚水木", reading: "さんごみずき", meaning: "Cornus alba" },
        { word: "脳珊瑚", reading: "のうさんご", meaning: "brain coral" }
    ],
    },
    "琉": {
        onyomi: ["リュウ", "ル"],
        kunyomi: [],
        examples: [
        { word: "琉球藍", reading: "りゅうきゅうあい", meaning: "Assam indigo (Strobilanthes cusia)" },
        { word: "琉球銀行", reading: "りゅうきゅうぎんこう", meaning: "Bank of The Ryukyus" },
        { word: "琉銀", reading: "りゅうぎん", meaning: "Bank of The Ryukyus (abbr)" }
    ],
    },
    "琢": {
        onyomi: ["タク"],
        kunyomi: ["みが.く"],
        examples: [
        { word: "彫琢", reading: "ちょうたく", meaning: "carving and polishing" },
        { word: "琢磨", reading: "たくま", meaning: "polish (jewels), cultivation" },
        { word: "切磋琢磨", reading: "せっさたくま", meaning: "diligent application (to work or study), cultivating one's character by studying hard, mutual encouragement (to improve)" }
    ],
    },
    "琥": {
        onyomi: ["コ"],
        kunyomi: [],
        examples: [
        { word: "琥珀", reading: "こはく", meaning: "amber" },
        { word: "琥珀色", reading: "こはくいろ", meaning: "amber (colour, color)" },
        { word: "琥珀酸", reading: "こはくさん", meaning: "succinic acid" }
    ],
    },
    "琳": {
        onyomi: ["リン"],
        kunyomi: [],
        examples: [
        { word: "琳派", reading: "りんぱ", meaning: "Rimpa school (of painting, 17th-early 20th century)" },
        { word: "光琳派", reading: "こうりんは", meaning: "Korin school, Rimpa school (of painting, 17th-early 20th century)" }
    ],
    },
    "琵": {
        onyomi: ["ビ", "ヒ"],
        kunyomi: [],
        examples: [
        { word: "琵琶鰉", reading: "びわひがい", meaning: "Biwa oily gudgeon (Sarcocheilichthys variegatus microoculus)" },
        { word: "琵琶笛", reading: "びやぼん", meaning: "Edo-period mouth harp (with a hairpin-like frame and a long straight tongue)" },
        { word: "琵琶湖大鯰", reading: "びわこおおなまず", meaning: "Lake Biwa catfish (Silurus biwaensis)" }
    ],
    },
    "琶": {
        onyomi: ["ハ", "ベ", "ワ"],
        kunyomi: [],
        examples: [
        { word: "琵琶鰉", reading: "びわひがい", meaning: "Biwa oily gudgeon (Sarcocheilichthys variegatus microoculus)" },
        { word: "琵琶笛", reading: "びやぼん", meaning: "Edo-period mouth harp (with a hairpin-like frame and a long straight tongue)" },
        { word: "琵琶湖大鯰", reading: "びわこおおなまず", meaning: "Lake Biwa catfish (Silurus biwaensis)" }
    ],
    },
    "瑚": {
        onyomi: ["コ", "ゴ"],
        kunyomi: [],
        examples: [
        { word: "珊瑚海", reading: "さんごかい", meaning: "Coral Sea" },
        { word: "珊瑚水木", reading: "さんごみずき", meaning: "Cornus alba" },
        { word: "脳珊瑚", reading: "のうさんご", meaning: "brain coral" }
    ],
    },
    "瑛": {
        onyomi: ["エイ"],
        kunyomi: [],
        examples: [
        { word: "玉瑛", reading: "ぎょくえい", meaning: "crystal, transparent gem" }
    ],
    },
    "瑞": {
        onyomi: ["ズイ", "スイ"],
        kunyomi: ["みず-", "しるし"],
        examples: [
        { word: "瑞風", reading: "みずかぜ", meaning: "Mizukaze (luxury train line)" },
        { word: "瑞宝双光章", reading: "ずいほうそうこうしょう", meaning: "Order of the Sacred Treasure, Gold and Silver Rays" },
        { word: "瑞宝単光章", reading: "ずいほうたんこうしょう", meaning: "Order of the Sacred Treasure, Silver Rays" }
    ],
    },
    "瑳": {
        onyomi: ["サ"],
        kunyomi: ["みが.く"],
        examples: [
        { word: "切瑳琢磨", reading: "せっさたくま", meaning: "diligent application (to work or study), cultivating one's character by studying hard, mutual encouragement (to improve)" },
        { word: "切瑳", reading: "せっさ", meaning: "working hard, applying oneself, cultivating one's character (through hard work or study)" }
    ],
    },
    "瑶": {
        onyomi: ["ヨウ"],
        kunyomi: ["たま"],
        examples: [
        { word: "瑶緘", reading: "ようかん", meaning: "your letter" },
        { word: "瑶顔", reading: "ようがん", meaning: "beautiful face, exquisite countenance" },
        { word: "瑶池", reading: "ようち", meaning: "beautiful pond, place where immortals live" }
    ],
    },
    "瓜": {
        onyomi: ["カ", "ケ"],
        kunyomi: ["うり"],
        examples: [
        { word: "破瓜期", reading: "はかき", meaning: "(girl's arrival at) puberty" },
        { word: "瓜の木", reading: "うりのき", meaning: "Alangium platanifolium var. trilobum" },
        { word: "おもちゃ南瓜", reading: "おもちゃかぼちゃ", meaning: "Cucurbita pepo (species that includes many varieties of pumpkin, squash and zucchini)" }
    ],
    },
    "瓢": {
        onyomi: ["ヒョウ"],
        kunyomi: ["ひさご", "ふくべ"],
        examples: [
        { word: "瓢箪鯰", reading: "ひょうたんなまず", meaning: "(person) slippery as an eel" },
        { word: "二十八星瓢虫", reading: "にじゅうやほしてんとう", meaning: "28-spotted ladybird (Epilachna vigintioctopunctata)" },
        { word: "瓢鮎図", reading: "ひょうねんず", meaning: "Hyonenzu (painting by Josetsu, 1415)" }
    ],
    },
    "甥": {
        onyomi: ["セイ", "ソウ", "ショウ"],
        kunyomi: ["おい", "むこ"],
        examples: [
        { word: "甥御", reading: "おいご", meaning: "(another person's) nephew" },
        { word: "又甥", reading: "またおい", meaning: "grandnephew" },
        { word: "甥", reading: "おい", meaning: "nephew" }
    ],
    },
    "甫": {
        onyomi: ["ホ", "フ"],
        kunyomi: ["はじ.めて"],
        examples: [
        { word: "年甫", reading: "ねんぽ", meaning: "beginning of the year" },
        { word: "新甫", reading: "しんぽ", meaning: "new futures on the first trading session of the month" },
        { word: "台甫", reading: "たいほ", meaning: "your personal name" }
    ],
    },
    "畠": {
        onyomi: [],
        kunyomi: ["はたけ", "はた"],
        examples: [
        { word: "田畠", reading: "たはた", meaning: "fields (of rice and other crops)" },
        { word: "桑畠", reading: "くわばたけ", meaning: "mulberry field, mulberry plantation" },
        { word: "段々畠", reading: "だんだんばたけ", meaning: "terraced fields, terraced farm" }
    ],
    },
    "畢": {
        onyomi: ["ヒツ"],
        kunyomi: ["おわ.る", "あみ", "おわ.り", "ことごとく"],
        examples: [
        { word: "畢", reading: "ひつ", meaning: "Chinese \"Net\" constellation (one of the 28 mansions)" },
        { word: "畢宿", reading: "あめふりぼし", meaning: "Chinese \"Net\" constellation (one of the 28 mansions)" },
        { word: "畢撥擬", reading: "ひはつもどき", meaning: "Javanese long pepper (Piper retrofractum)" }
    ],
    },
    "疊": {
        onyomi: ["ジョウ", "チョウ"],
        kunyomi: ["たた.む", "たたみ", "かさ.なる", "かさ.ねる"],
        examples: [
        { word: "疊", reading: "たたみ", meaning: "tatami mat, Japanese straw floor coverings" }
    ],
    },
    "疋": {
        onyomi: ["ヒキ", "ショ", "ソ", "ヒツ"],
        kunyomi: ["あし"],
        examples: [
        { word: "一疋", reading: "いっぴき", meaning: "one (small animal), two-tan bolt of cloth" },
        { word: "疋", reading: "ひき", meaning: "counter for small animals, counter for rolls of cloth (two han in size), counter for horses" }
    ],
    },
    "疏": {
        onyomi: ["ソ", "ショ"],
        kunyomi: ["あら.い", "うと.い", "うと.む", "とお.る", "とお.す", "まばら"],
        examples: [
        { word: "上疏", reading: "じょうそ", meaning: "reporting to the emperor" },
        { word: "意思の疏通", reading: "いしのそつう", meaning: "(reciprocal) communication, (coming to a) mutual understanding" },
        { word: "疏雨", reading: "そう", meaning: "drizzle, scattered rain" }
    ],
    },
    "瘦": {
        onyomi: ["ソウ", "チュウ", "シュウ", "チュ"],
        kunyomi: ["やせ.る"],
        examples: [
        { word: "瘦身", reading: "そうしん", meaning: "slim figure, slender body, slimming" },
        { word: "瘦せる", reading: "やせる", meaning: "to become thin, to lose weight, to slim" }
    ],
    },
    "皐": {
        onyomi: ["コウ"],
        kunyomi: ["さつき"],
        examples: [
        { word: "皐月晴れ", reading: "さつきばれ", meaning: "fine weather during the rainy season" },
        { word: "皐月鱒", reading: "さつきます", meaning: "sea-run variety of red-spotted masu trout (subspecies of cherry salmon, Oncorhynchus masou ishikawae), red-spotted masu salmon" },
        { word: "九皐", reading: "きゅうこう", meaning: "deep, winding ravine, distant, innermost place" }
    ],
    },
    "皓": {
        onyomi: ["コウ"],
        kunyomi: ["しろ.い", "ひか.る"],
        examples: [
        { word: "皓月", reading: "こうげつ", meaning: "bright white moon" },
        { word: "皓歯", reading: "こうし", meaning: "pearly white teeth" },
        { word: "皓白", reading: "こうはく", meaning: "pure white" }
    ],
    },
    "盃": {
        onyomi: ["ハイ"],
        kunyomi: ["さかずき"],
        examples: [
        { word: "組み盃", reading: "くみさかずき", meaning: "a nest of sake cups" },
        { word: "罰盃", reading: "ばっぱい", meaning: "alcohol drunk as a punishment (for arriving late, losing a game, etc.)" },
        { word: "天盃", reading: "てんぱい", meaning: "emperor's gift cup" }
    ],
    },
    "盜": {
        onyomi: ["トウ"],
        kunyomi: ["ぬす.む"],
        examples: [
        { word: "窃盜癖", reading: "せっとうへき", meaning: "kleptomania" }
    ],
    },
    "盡": {
        onyomi: ["ジン", "サン"],
        kunyomi: ["つ.くす", "つ.きる", "つ.かす", "さかづき", "ことごと.く"],
        examples: [
        { word: "盡す", reading: "つくす", meaning: "to use up, to exhaust, to run out of" }
    ],
    },
    "眞": {
        onyomi: ["シン"],
        kunyomi: ["ま", "まこと"],
        examples: [
        { word: "眞言宗", reading: "しんごんしゅう", meaning: "Shingon sect" },
        { word: "眞言", reading: "しんごん", meaning: "mantra, Shingon sect" },
        { word: "寫眞", reading: "しゃしん", meaning: "photograph, photo, picture" }
    ],
    },
    "眸": {
        onyomi: ["ボウ", "ム"],
        kunyomi: ["ひとみ"],
        examples: [
        { word: "明眸", reading: "めいぼう", meaning: "bright or beautiful eyes" },
        { word: "眸子", reading: "ぼうし", meaning: "pupil (of the eye)" },
        { word: "明眸皓歯", reading: "めいぼうこうし", meaning: "starry eyes and beautiful white teeth (said of beautiful women)" }
    ],
    },
    "瞥": {
        onyomi: ["ベツ", "ヘツ"],
        kunyomi: [],
        examples: [
        { word: "一瞥", reading: "いちべつ", meaning: "a glance, a look, a glimpse" },
        { word: "瞥見", reading: "べっけん", meaning: "glance, glimpse, cursory view" }
    ],
    },
    "矩": {
        onyomi: ["ク"],
        kunyomi: ["かね", "かねざし", "さしがね"],
        examples: [
        { word: "矩差", reading: "かねざし", meaning: "carpenter's square" },
        { word: "心の欲する所に従えども矩を踰えず", reading: "こころのほっするところにしたがえどものりをこえず", meaning: "following the desires of one's own heart without transgressing what is right" },
        { word: "矩象", reading: "くしょう", meaning: "quadrature" }
    ],
    },
    "砥": {
        onyomi: ["シ", "テイ", "キイ", "チ"],
        kunyomi: ["と", "といし", "と.ぐ", "みが.く"],
        examples: [
        { word: "青砥稿花紅彩画", reading: "あおとぞうしはなのにしきえ", meaning: "Aoto Zōshi Hana no Nishiki-e (kabuki play by Kawatake Mokuami)" },
        { word: "合わせ砥", reading: "あわせど", meaning: "double whetstone" },
        { word: "丸砥石", reading: "まるといし", meaning: "grindstone" }
    ],
    },
    "砦": {
        onyomi: ["サイ"],
        kunyomi: ["とりで"],
        examples: [
        { word: "タイコンデロガ砦包囲戦", reading: "タイコンデロガとりでほういせん", meaning: "Siege of Fort Ticonderoga (1777)" },
        { word: "鹿砦", reading: "ろくさい", meaning: "abatis" },
        { word: "砦を落とす", reading: "とりでをおとす", meaning: "to capture a fort" }
    ],
    },
    "砧": {
        onyomi: ["チン"],
        kunyomi: ["きぬた"],
        examples: [
        { word: "鉄砧", reading: "かなとこ", meaning: "anvil" },
        { word: "砧声", reading: "ちんせい", meaning: "sound of fulling blocks pounding cloth" },
        { word: "砧", reading: "きぬた", meaning: "fulling block, wooden or stone block for beating cloth" }
    ],
    },
    "硯": {
        onyomi: ["ケン", "ゲン"],
        kunyomi: ["すずり"],
        examples: [
        { word: "硯洗い", reading: "すずりあらい", meaning: "event where schoolchildren wash their inkstones, brushes and desks the night before Tanabata to pray for success in their studies" },
        { word: "硯", reading: "すずり", meaning: "inkstone" },
        { word: "硯箱", reading: "すずりばこ", meaning: "inkstone case" }
    ],
    },
    "碎": {
        onyomi: ["サイ"],
        kunyomi: ["くだ.く", "くだ.ける"],
        examples: [
        { word: "破碎", reading: "はさい", meaning: "crushing (into pieces), smashing, cracking" }
    ],
    },
    "碓": {
        onyomi: ["カク", "タイ"],
        kunyomi: ["たし.か", "かく.たる"],
        examples: [
        { word: "碓氷峠", reading: "うすいとうげ", meaning: "Usui Pass" },
        { word: "水碓", reading: "みずうす", meaning: "water-powered millstone" },
        { word: "碓", reading: "うす", meaning: "millstone, mortar" }
    ],
    },
    "碗": {
        onyomi: ["ワン"],
        kunyomi: ["こばち"],
        examples: [
        { word: "高麗茶碗", reading: "こうらいぢゃわん", meaning: "Koryo dynasty tea bowl" },
        { word: "お碗", reading: "おわん", meaning: "bowl (ceramic, porcelain)" },
        { word: "飯碗", reading: "めしわん", meaning: "bowl used for serving rice" }
    ],
    },
    "碧": {
        onyomi: ["ヘキ", "ヒャク"],
        kunyomi: [],
        examples: [
        { word: "碧螺春", reading: "へきらしゅん", meaning: "biluochun (green tea var. grown in Jiangsu, China)" },
        { word: "金髪碧眼", reading: "きんぱつへきがん", meaning: "blonde hair and blue eyes" },
        { word: "碧眼", reading: "へきがん", meaning: "blue eyes" }
    ],
    },
    "碩": {
        onyomi: ["セキ"],
        kunyomi: ["おお.きい"],
        examples: [
        { word: "碩儒", reading: "せきじゅ", meaning: "(Confucian) scholar" },
        { word: "碩老", reading: "せきろう", meaning: "wise and learned elder" },
        { word: "碩学", reading: "せきがく", meaning: "great scholar, profound scholar" }
    ],
    },
    "磐": {
        onyomi: ["バン", "ハン"],
        kunyomi: ["いわ"],
        examples: [
        { word: "磐越西線", reading: "ばんえつさいせん", meaning: "Ban'etsu West Line" },
        { word: "天の磐戸", reading: "あまのいわと", meaning: "Gate of the Celestial Rock Cave" },
        { word: "磐城", reading: "いわき", meaning: "Iwaki (former province located in the central and eastern parts of present-day Fukushima and southern Miyagi prefectures)" }
    ],
    },
    "磯": {
        onyomi: ["キ"],
        kunyomi: ["いそ"],
        examples: [
        { word: "磯蟹", reading: "いそがに", meaning: "Asian shore crab (Hemigrapsus sanguineus)" },
        { word: "磯筋蝦", reading: "いそすじえび", meaning: "Indian bait prawn (Palaemon pacificus)" },
        { word: "岩磯蚯蚓", reading: "いわいそめ", meaning: "Marphysa sanguinea (species of eunicid worm)" }
    ],
    },
    "祁": {
        onyomi: ["キ", "ケ"],
        kunyomi: [],
        examples: [
        { word: "祁寒", reading: "きかん", meaning: "bitter cold, extreme cold" }
    ],
    },
    "祇": {
        onyomi: ["ギ", "キ", "シ"],
        kunyomi: ["くにつかみ", "ただ", "まさに"],
        examples: [
        { word: "祇園会", reading: "ぎおんえ", meaning: "Gion Festival (in Kyoto during the month of July, with high point on the 17th)" },
        { word: "祇園祭", reading: "ぎおんまつり", meaning: "Gion Festival (in Kyoto during the month of July, with high point on the 17th)" },
        { word: "神祇院", reading: "じんぎいん", meaning: "Institute of Divinities (1940-1946)" }
    ],
    },
    "祐": {
        onyomi: ["ユウ", "ウ"],
        kunyomi: ["たす.ける"],
        examples: [
        { word: "祐助", reading: "ゆうじょ", meaning: "assistance" },
        { word: "天祐神助", reading: "てんゆうしんじょ", meaning: "divine grace, God's help" },
        { word: "神祐", reading: "しんゆう", meaning: "heavenly protection, divine help" }
    ],
    },
    "祕": {
        onyomi: ["ヒ"],
        kunyomi: ["ひ.める", "かく.す"],
        examples: [],
    },
    "祢": {
        onyomi: ["ネ", "デイ", "ナイ"],
        kunyomi: [],
        examples: [
        { word: "祢宜", reading: "ねぎ", meaning: "senior priest (serving under the chief priest and associate chief priest), priest (below chief priest and above junior priest), grasshopper" }
    ],
    },
    "祷": {
        onyomi: ["トウ"],
        kunyomi: ["いの.る", "いの.り", "まつ.る"],
        examples: [
        { word: "時祷書", reading: "じとうしょ", meaning: "book of hours (devotional book popular in the Middle Ages)" },
        { word: "加持祈祷", reading: "かじきとう", meaning: "incantation and prayer" },
        { word: "祈祷者", reading: "きとうしゃ", meaning: "person who prays" }
    ],
    },
    "祿": {
        onyomi: ["ロク"],
        kunyomi: ["さいわ.い", "ふち"],
        examples: [
        { word: "俸祿米", reading: "ほうろくまい", meaning: "rice given as salary" },
        { word: "祿", reading: "ろく", meaning: "stipend, reward" },
        { word: "俸祿", reading: "ほうろく", meaning: "retainer's stipend, official pay, salary" }
    ],
    },
    "禄": {
        onyomi: ["ロク"],
        kunyomi: ["さいわ.い", "ふち"],
        examples: [
        { word: "禄高", reading: "ろくだか", meaning: "(amount of a samurai's) stipend" },
        { word: "小身微禄", reading: "しょうしんびろく", meaning: "(in) a humble position with a small stipend" },
        { word: "文禄", reading: "ぶんろく", meaning: "Bunroku era (1592.12.8-1596.10.27)" }
    ],
    },
    "禎": {
        onyomi: ["テイ"],
        kunyomi: ["さいわ.い"],
        examples: [
        { word: "嘉禎", reading: "かてい", meaning: "Katei era (1235.9.19-1238.11.23)" },
        { word: "禎祥", reading: "ていしょう", meaning: "good omen" }
    ],
    },
    "禪": {
        onyomi: ["ゼン", "セン"],
        kunyomi: ["しずか", "ゆず.る"],
        examples: [
        { word: "五門禪", reading: "ごもんぜん", meaning: "five approaches to meditation, five objects of meditation" },
        { word: "禪", reading: "ぜん", meaning: "dhyana (profound meditation), Zen (Buddhism)" }
    ],
    },
    "禮": {
        onyomi: ["レイ", "ライ"],
        kunyomi: [],
        examples: [
        { word: "祭禮", reading: "さいれい", meaning: "(religious) festival" }
    ],
    },
    "禰": {
        onyomi: ["ネ", "デイ", "ナイ"],
        kunyomi: [],
        examples: [
        { word: "権禰宜", reading: "ごんねぎ", meaning: "junior priest" },
        { word: "島土禰利古", reading: "シマトネリコ", meaning: "Himalayan ash (Fraxinus griffithii), Griffith's ash" },
        { word: "宿禰", reading: "すくね", meaning: "Lord (title of respect for nobility, etc.), Sukune (third highest of the eight hereditary titles)" }
    ],
    },
    "禱": {
        onyomi: ["トウ"],
        kunyomi: ["いの.る", "まつ.る"],
        examples: [
        { word: "祈禱者", reading: "きとうしゃ", meaning: "person who prays" },
        { word: "祈禱書", reading: "きとうしょ", meaning: "prayer book" },
        { word: "祈禱会", reading: "きとうかい", meaning: "prayer meeting" }
    ],
    },
    "禽": {
        onyomi: ["キン"],
        kunyomi: ["とり", "とりこ"],
        examples: [
        { word: "禽鳥", reading: "きんちょう", meaning: "birds" },
        { word: "禽類", reading: "きんるい", meaning: "birds" },
        { word: "生禽", reading: "せいきん", meaning: "capturing something alive" }
    ],
    },
    "禾": {
        onyomi: ["カ"],
        kunyomi: ["いね"],
        examples: [
        { word: "禾予", reading: "じょ", meaning: "10^24" },
        { word: "禾穀類", reading: "かこくるい", meaning: "cereal crops" },
        { word: "禾穂", reading: "かすい", meaning: "ear of a cereal plant" }
    ],
    },
    "秤": {
        onyomi: ["ショウ", "ヒン", "ビン"],
        kunyomi: ["はかり"],
        examples: [
        { word: "木槽天秤しぼり", reading: "きぶねてんびんしぼり", meaning: "(sake) brewed in wooden vats, squeezed out by weight on a pole" },
        { word: "水秤", reading: "みずばかり", meaning: "a water level" },
        { word: "自動秤", reading: "じどうばかり", meaning: "automatic scales" }
    ],
    },
    "秦": {
        onyomi: ["シン"],
        kunyomi: ["はた"],
        examples: [
        { word: "秦皮", reading: "とねりこ", meaning: "Japanese ash (Fraxinus japonica)" },
        { word: "先秦", reading: "せんしん", meaning: "pre-Qin period (of China)" },
        { word: "秦", reading: "しん", meaning: "Qin dynasty (of China; 221-207 BCE), Ch'in dynasty" }
    ],
    },
    "稀": {
        onyomi: ["キ", "ケ"],
        kunyomi: ["まれ", "まばら"],
        examples: [
        { word: "稀酸", reading: "きさん", meaning: "dilute acid" },
        { word: "稀塩酸", reading: "きえんさん", meaning: "dilute hydrochloric acid" },
        { word: "稀釈", reading: "きしゃく", meaning: "dilution" }
    ],
    },
    "稔": {
        onyomi: ["ネン", "ジン", "ニン"],
        kunyomi: ["みの.る", "みのり"],
        examples: [
        { word: "稔りの秋", reading: "みのりのあき", meaning: "autumn, the harvest season" },
        { word: "豊稔", reading: "ほうねん", meaning: "bumper harvest" },
        { word: "稔性", reading: "ねんせい", meaning: "fertility (esp. of plants)" }
    ],
    },
    "稜": {
        onyomi: ["リョウ", "ロウ"],
        kunyomi: ["いつ", "かど"],
        examples: [
        { word: "気骨稜々", reading: "きこつりょうりょう", meaning: "(a person with) strong moral fiber (backbone, determination)" },
        { word: "金沢星稜大学", reading: "かなざわせいりょうだいがく", meaning: "Kanazawa Seiryo University" },
        { word: "稜威言別", reading: "いつのことわき", meaning: "Notes on the Songs of the Kojiki and the Nihonshoki (by Tachibana Moribe, 1850)" }
    ],
    },
    "稟": {
        onyomi: ["リン", "ヒン"],
        kunyomi: ["こめぐら"],
        examples: [
        { word: "稟議書", reading: "りんぎしょ", meaning: "document circulated to staff to obtain approval (for a decision, policy, etc.)" },
        { word: "稟質", reading: "ひんしつ", meaning: "inborn nature" },
        { word: "稟性", reading: "ひんせい", meaning: "inborn nature" }
    ],
    },
    "稻": {
        onyomi: ["トウ", "テ"],
        kunyomi: ["いね", "いな-"],
        examples: [
        { word: "稻", reading: "いね", meaning: "rice plant (Oryza sativa)" }
    ],
    },
    "穗": {
        onyomi: ["スイ"],
        kunyomi: ["ほ"],
        examples: [
        { word: "麥穗", reading: "ばくすい", meaning: "ear of wheat" },
        { word: "初穗", reading: "はつほ", meaning: "first ears of rice of the season, first crops of the season, first harvest of the season" },
        { word: "穗", reading: "ほ", meaning: "ear (of a cereal plant), head, spike" }
    ],
    },
    "穣": {
        onyomi: ["ジョウ"],
        kunyomi: ["わら", "ゆたか"],
        examples: [
        { word: "穣", reading: "じょう", meaning: "10^28, ten octillion" },
        { word: "豊穣", reading: "ほうじょう", meaning: "abundant (grain) crop, good harvest" },
        { word: "豊穣の角", reading: "ほうじょうのつの", meaning: "cornucopia, horn of plenty" }
    ],
    },
    "穰": {
        onyomi: ["ジョウ"],
        kunyomi: ["わら", "ゆたか"],
        examples: [
        { word: "豊穰", reading: "ほうじょう", meaning: "abundant (grain) crop, good harvest" }
    ],
    },
    "穹": {
        onyomi: ["キュウ", "キョウ"],
        kunyomi: ["あめ", "そら"],
        examples: [
        { word: "蒼穹", reading: "そうきゅう", meaning: "blue sky" },
        { word: "穹蒼", reading: "きゅうそう", meaning: "dome of the sky, vault of heaven" },
        { word: "穹窿", reading: "きゅうりゅう", meaning: "vault of heaven, vaulted sky, dome" }
    ],
    },
    "穿": {
        onyomi: ["セン"],
        kunyomi: ["うが.つ", "は.く"],
        examples: [
        { word: "耳穿山甲", reading: "みみせんざんこう", meaning: "Chinese pangolin (Manis pentadactyla)" },
        { word: "羊水穿刺", reading: "ようすいせんし", meaning: "amniocentesis" },
        { word: "カード穿孔機構", reading: "カードせんこうきこう", meaning: "card punch" }
    ],
    },
    "窄": {
        onyomi: ["サク"],
        kunyomi: ["すぼ.める", "つぼ.める", "せま.い"],
        examples: [
        { word: "血管狭窄", reading: "けっかんきょうさく", meaning: "angiostenosis" },
        { word: "異型大動脈縮窄症", reading: "いけいだいどうみゃくしゅくさくしょう", meaning: "atypical coarctation of aorta" },
        { word: "肺動脈弁狭窄症", reading: "はいどうみゃくべんきょうさくしょう", meaning: "pulmonary valve stenosis" }
    ],
    },
    "窪": {
        onyomi: ["ワ", "ア"],
        kunyomi: ["くぼ.む", "くぼ.み", "くぼ.まる", "くぼ"],
        examples: [
        { word: "笑窪", reading: "えくぼ", meaning: "dimple" },
        { word: "片笑窪", reading: "かたえくぼ", meaning: "dimple on one cheek" },
        { word: "曲窪", reading: "きょくわ", meaning: "downwarp" }
    ],
    },
    "窺": {
        onyomi: ["キ"],
        kunyomi: ["うかが.う", "のぞく"],
        examples: [
        { word: "顔色を窺う", reading: "かおいろをうかがう", meaning: "to try and judge a person's feelings (from their expression)" },
        { word: "チャンスを窺う", reading: "チャンスをうかがう", meaning: "to wait for an opportunity" },
        { word: "隙を窺う", reading: "すきをうかがう", meaning: "to watch for an unguarded moment" }
    ],
    },
    "竣": {
        onyomi: ["ドウ", "シュン"],
        kunyomi: ["わらわ", "わらべ", "おわ.る"],
        examples: [
        { word: "竣工式", reading: "しゅんこうしき", meaning: "ceremony to mark completion" },
        { word: "竣成", reading: "しゅんせい", meaning: "completion" },
        { word: "竣工", reading: "しゅんこう", meaning: "completion of construction" }
    ],
    },
    "竪": {
        onyomi: ["ジュ"],
        kunyomi: ["たて", "た.てる", "こども"],
        examples: [
        { word: "竪堀", reading: "たてぼり", meaning: "ascending trench or pathway cut into a naturally-occurring slope" },
        { word: "竪笛", reading: "たてぶえ", meaning: "end-blown flute (esp. the recorder)" },
        { word: "竪琴海豹", reading: "たてごとあざらし", meaning: "harp seal (Phoca groenlandica)" }
    ],
    },
    "竺": {
        onyomi: ["ジク", "チク", "トク"],
        kunyomi: [],
        examples: [
        { word: "パンパス天竺鼠", reading: "パンパスてんじくねずみ", meaning: "Brazilian guinea pig (Cavia aperea)" },
        { word: "天竺編み", reading: "てんじくあみ", meaning: "Jersey stitch (knitware)" },
        { word: "天竺木綿", reading: "てんじくもめん", meaning: "cotton sheeting" }
    ],
    },
    "竿": {
        onyomi: ["カン"],
        kunyomi: ["さお"],
        examples: [
        { word: "秋田竿燈まつり", reading: "あきたかんとうまつり", meaning: "Akita Kantō Festival (3-6 August)" },
        { word: "継ぎ竿", reading: "つぎざお", meaning: "a jointed fishing rod" },
        { word: "竿竹", reading: "さおだけ", meaning: "bamboo pole" }
    ],
    },
    "笈": {
        onyomi: ["キュウ"],
        kunyomi: [],
        examples: [
        { word: "笈多", reading: "グプタ", meaning: "Gupta (dynasty of India; approx. 320-600 CE)" },
        { word: "笈摺", reading: "おいずり", meaning: "thin, sleeveless overgarment worn by pilgrims" },
        { word: "笈", reading: "おい", meaning: "wooden box carried on one's back to store items for a pilgrimage" }
    ],
    },
    "笙": {
        onyomi: ["ショウ", "ソウ"],
        kunyomi: ["ふえ"],
        examples: [
        { word: "鳳笙", reading: "ほうしょう", meaning: "shō (Japanese free reed musical instrument)" },
        { word: "笙の笛", reading: "しょうのふえ", meaning: "shō (Japanese free reed musical instrument)" },
        { word: "笙歌", reading: "しょうか", meaning: "singing and playing the shō" }
    ],
    },
    "笠": {
        onyomi: ["リュウ"],
        kunyomi: ["かさ"],
        examples: [
        { word: "紅葉笠", reading: "もみじがさ", meaning: "Asteraceae flowering plant (Parasenecio delphiniifolius)" },
        { word: "小笠和大蝙蝠", reading: "おがさわおおこうもり", meaning: "Bonin flying fox (Pteropus pselaphon)" },
        { word: "小笠原猿子", reading: "おがさわらましこ", meaning: "Bonin grosbeak (Chaunoproctus ferreorostris, extinct)" }
    ],
    },
    "笹": {
        onyomi: [],
        kunyomi: ["ささ"],
        examples: [
        { word: "笹葉銀蘭", reading: "ささばぎんらん", meaning: "Cephalanthera longibracteata (species of orchid)" },
        { word: "笹百合", reading: "ささゆり", meaning: "Japanese lily (Lilium japonicum)" },
        { word: "尖り笹の葉貝", reading: "とんがりささのはがい", meaning: "Lanceolaria grayana (species of freshwater mussel)" }
    ],
    },
    "筈": {
        onyomi: ["カツ"],
        kunyomi: ["はず", "やはず"],
        examples: [
        { word: "本筈", reading: "もとはず", meaning: "bottom knock (of a bow)" },
        { word: "筈緒", reading: "はずお", meaning: "hemp rope fastened from the bow of a Japanese ship to the tip of the mast" },
        { word: "弓筈", reading: "ゆはず", meaning: "nock (of a bow)" }
    ],
    },
    "筑": {
        onyomi: ["チク"],
        kunyomi: [],
        examples: [
        { word: "筑後", reading: "ちくご", meaning: "Chikugo (former province located in the south of present-day Fukuoka Prefecture)" },
        { word: "筑邦銀行", reading: "ちくほうぎんこう", meaning: "Chikuho Bank" },
        { word: "筑紫女学園大学", reading: "ちくしじょがくえんだいがく", meaning: "Chikushi Jogakuen University" }
    ],
    },
    "箔": {
        onyomi: ["ハク"],
        kunyomi: ["すだれ"],
        examples: [
        { word: "アルミ箔", reading: "アルミはく", meaning: "aluminum foil" },
        { word: "金箔が剥げる", reading: "きんぱくがはげる", meaning: "to reveal one's true colors" },
        { word: "色箔", reading: "いろはく", meaning: "coloured foil, color foil" }
    ],
    },
    "箕": {
        onyomi: ["キ"],
        kunyomi: ["み"],
        examples: [
        { word: "箕", reading: "き", meaning: "Chinese \"winnowing basket\" constellation (one of the 28 mansions)" },
        { word: "箕宿", reading: "みぼし", meaning: "Chinese \"winnowing basket\" constellation (one of the 28 mansions)" },
        { word: "箕作鮫", reading: "みつくりざめ", meaning: "goblin shark (Mitsukurina owstoni)" }
    ],
    },
    "篇": {
        onyomi: ["ヘン"],
        kunyomi: [],
        examples: [
        { word: "倭玉篇", reading: "わごくへん", meaning: "Wagokuhen (c. 1489 Japanese kanji dictionary)" },
        { word: "千篇", reading: "せんぺん", meaning: "many volumes" },
        { word: "雄篇", reading: "ゆうへん", meaning: "masterpiece" }
    ],
    },
    "篠": {
        onyomi: ["ゾウ", "ショウ"],
        kunyomi: ["しの", "ささ", "すず"],
        examples: [
        { word: "アメリカ篠懸の木", reading: "アメリカすずかけのき", meaning: "American sycamore (Platanus occidentalis)" },
        { word: "長篠の戦い", reading: "ながしののたたかい", meaning: "Battle of Nagashino (1575)" },
        { word: "篠笛", reading: "しのぶえ", meaning: "Japanese transverse bamboo flute (high-pitched; usu. with seven holes)" }
    ],
    },
    "簞": {
        onyomi: ["タン"],
        kunyomi: ["はこ"],
        examples: [
        { word: "簞食", reading: "たんし", meaning: "bamboo dish of rice" },
        { word: "一簞", reading: "いったん", meaning: "bamboo utensil (for holding food), bamboo dish" },
        { word: "簞食壺漿", reading: "たんしこしょう", meaning: "receiving with food and drink (e.g. troops), baskets of rice and vessels of congee" }
    ],
    },
    "簾": {
        onyomi: ["レン"],
        kunyomi: ["すだれ", "す"],
        examples: [
        { word: "鋤簾", reading: "じょれん", meaning: "(long-handled) bamboo winnow used to sift earth or sand" },
        { word: "簾貝", reading: "すだれがい", meaning: "Paphia euglypta (species of Venus clam)" },
        { word: "板簾", reading: "いたすだれ", meaning: "Venetian blind" }
    ],
    },
    "籾": {
        onyomi: [],
        kunyomi: ["もみ"],
        examples: [
        { word: "籾摺り", reading: "もみすり", meaning: "hulling rice" },
        { word: "種籾", reading: "たねもみ", meaning: "seed rice" },
        { word: "籾殻", reading: "もみがら", meaning: "rice husks, chaff" }
    ],
    },
    "粟": {
        onyomi: ["ゾク", "ショク", "ソク"],
        kunyomi: ["あわ", "もみ"],
        examples: [
        { word: "秋の野罌粟", reading: "あきののげし", meaning: "Indian lettuce (Lactuca indica)" },
        { word: "濡れ手に粟", reading: "ぬれてにあわ", meaning: "easy profit" },
        { word: "濡れ手で粟", reading: "ぬれてであわ", meaning: "easy profit" }
    ],
    },
    "粥": {
        onyomi: ["イク", "シュク", "ジュク"],
        kunyomi: ["かゆ", "かい", "ひさ.ぐ"],
        examples: [
        { word: "冬至粥", reading: "とうじがゆ", meaning: "adzuki bean rice gruel eaten on the day of the winter solstice (to chase away demons that spread contagious diseases)" },
        { word: "粥腫", reading: "しゅくしゅ", meaning: "atheroma" },
        { word: "パン粥", reading: "パンがゆ", meaning: "bread porridge" }
    ],
    },
    "粹": {
        onyomi: ["スイ"],
        kunyomi: ["いき"],
        examples: [],
    },
    "糊": {
        onyomi: ["コ", "ゴ", "コツ"],
        kunyomi: ["のり"],
        examples: [
        { word: "糊付き封筒", reading: "のりつきふうとう", meaning: "adhesive envelope" },
        { word: "糊置き", reading: "のりおき", meaning: "application of paste (for resist dyeing)" },
        { word: "糊板", reading: "のりいた", meaning: "board for making rice paste" }
    ],
    },
    "紐": {
        onyomi: ["チュウ", "ジュウ"],
        kunyomi: ["ひも"],
        examples: [
        { word: "紐育", reading: "ニューヨーク", meaning: "New York" },
        { word: "真田紐", reading: "さなだひも", meaning: "braid" },
        { word: "打ち紐", reading: "うちひも", meaning: "braided cord" }
    ],
    },
    "紗": {
        onyomi: ["サ", "シャ"],
        kunyomi: ["うすぎぬ"],
        examples: [
        { word: "紗", reading: "しゃ", meaning: "(silk) gauze" },
        { word: "更紗馬蹄螺", reading: "サラサばていら", meaning: "Tectus maximus (species of top shell)" },
        { word: "寒冷紗", reading: "かんれいしゃ", meaning: "cheesecloth" }
    ],
    },
    "紘": {
        onyomi: ["コウ"],
        kunyomi: ["おおづな", "つな", "つなぐ"],
        examples: [
        { word: "八紘一宇", reading: "はっこういちう", meaning: "universal brotherhood, all eight corners of the world under one roof" },
        { word: "八紘", reading: "はっこう", meaning: "the eight directions, the whole land, the whole world" }
    ],
    },
    "紬": {
        onyomi: ["チュウ"],
        kunyomi: ["つむぎ", "つむ.ぐ"],
        examples: [
        { word: "大島紬", reading: "おおしまつむぎ", meaning: "Oshima tsumugi weave (type of pongee made in the Amami islands)" },
        { word: "絹紬", reading: "けんちゅう", meaning: "pongee (unbleached silk)" },
        { word: "白紬", reading: "しろつむぎ", meaning: "white pongee" }
    ],
    },
    "絃": {
        onyomi: ["ゲン"],
        kunyomi: ["いと"],
        examples: [
        { word: "絃線", reading: "げんせん", meaning: "catgut" },
        { word: "管絃楽", reading: "かんげんがく", meaning: "orchestral music" },
        { word: "絃歌", reading: "げんか", meaning: "singing and (string) music" }
    ],
    },
    "絆": {
        onyomi: ["ハン"],
        kunyomi: ["きずな", "ほだ.す", "つな.ぐ"],
        examples: [
        { word: "巻き脚絆", reading: "まききゃはん", meaning: "puttee" },
        { word: "絆創膏", reading: "ばんそうこう", meaning: "adhesive bandage, sticking plaster, band-aid" },
        { word: "情に絆される", reading: "じょうにほだされる", meaning: "to feel compassion towards, to be swayed by emotion, to be moved by" }
    ],
    },
    "絢": {
        onyomi: ["ケン"],
        kunyomi: [],
        examples: [
        { word: "絢緞子", reading: "あやどんす", meaning: "damask" },
        { word: "絢文", reading: "けんぶん", meaning: "colorful pattern, colourful pattern" },
        { word: "豪華絢爛", reading: "ごうかけんらん", meaning: "luxurious and gorgeous, magnificent" }
    ],
    },
    "綜": {
        onyomi: ["ソウ"],
        kunyomi: ["おさ.める", "す.べる"],
        examples: [
        { word: "綜芸種智院", reading: "しゅげいしゅちいん", meaning: "Shugei Shuchiin School (ca 829CE)" },
        { word: "綜芸", reading: "そうげい", meaning: "synthesis of varied arts" },
        { word: "綜", reading: "あぜ", meaning: "warp controller (on a loom)" }
    ],
    },
    "綠": {
        onyomi: ["リョク", "ロク"],
        kunyomi: ["みどり"],
        examples: [
        { word: "綠色", reading: "みどりいろ", meaning: "green, green color" },
        { word: "綠茶", reading: "りょくちゃ", meaning: "green tea, Japanese tea" },
        { word: "黃綠", reading: "きみどり", meaning: "pea green, yellow-green" }
    ],
    },
    "綴": {
        onyomi: ["テイ", "テツ", "テチ", "ゲツ"],
        kunyomi: ["と.じる", "つづ.る", "つづり", "すみ.やか"],
        examples: [
        { word: "綴れ錦", reading: "つづれにしき", meaning: "(hand-woven) brocade" },
        { word: "綴れ織り", reading: "つづれおり", meaning: "(hand-woven) tapestry" },
        { word: "日本補綴歯科学会", reading: "にっぽんほていしかがっかい", meaning: "Japan Prosthodontic Society" }
    ],
    },
    "綸": {
        onyomi: ["リン", "カン"],
        kunyomi: ["いと"],
        examples: [
        { word: "綸子", reading: "りんず", meaning: "figured satin" },
        { word: "綸言", reading: "りんげん", meaning: "imperial words" },
        { word: "綸言汗の如し", reading: "りんげんあせのごとし", meaning: "like sweat cannot return inside the body, the word of an emperor cannot be unsaid" }
    ],
    },
    "綺": {
        onyomi: ["キ"],
        kunyomi: ["あや"],
        examples: [
        { word: "綺譚", reading: "きたん", meaning: "beautiful story" },
        { word: "綺羅", reading: "きら", meaning: "fine clothes" },
        { word: "綺羅星", reading: "きらぼし", meaning: "glittering stars" }
    ],
    },
    "綾": {
        onyomi: ["リン"],
        kunyomi: ["あや"],
        examples: [
        { word: "綾取り", reading: "あやとり", meaning: "cat's cradle" },
        { word: "言葉の綾", reading: "ことばのあや", meaning: "figure of speech" },
        { word: "綾子", reading: "りんず", meaning: "figured satin" }
    ],
    },
    "緋": {
        onyomi: ["ヒ"],
        kunyomi: ["あけ", "あか"],
        examples: [
        { word: "アメリカ緋鳥", reading: "アメリカひどり", meaning: "American wigeon (Anas americana)" },
        { word: "緋鳥鴨", reading: "ひどりがも", meaning: "Eurasian wigeon (Anas penelope)" },
        { word: "緋梅", reading: "ひばい", meaning: "Hibai Japanese apricot" }
    ],
    },
    "緖": {
        onyomi: ["ショ", "チョ"],
        kunyomi: ["お", "いとぐち"],
        examples: [],
    },
    "緣": {
        onyomi: ["エン"],
        kunyomi: ["ふち", "へり", "よる"],
        examples: [],
    },
    "縞": {
        onyomi: ["コウ"],
        kunyomi: ["しま", "しろぎぬ"],
        examples: [
        { word: "一筋縞蚊", reading: "ひとすじしまか", meaning: "Asian tiger mosquito (Aedes albopictus)" },
        { word: "バーチェルサバンナ縞馬", reading: "バーチェルサバンナしまうま", meaning: "Burchell's zebra (Equus quagga burchellii)" },
        { word: "グレビー縞馬", reading: "グレビーしまうま", meaning: "Grevy's zebra (Equus grevyi)" }
    ],
    },
    "縣": {
        onyomi: ["ケン"],
        kunyomi: ["か.ける"],
        examples: [
        { word: "愛知縣", reading: "あいちけん", meaning: "Aichi prefecture (Chūbu area)" },
        { word: "秋田縣", reading: "あきたけん", meaning: "Akita Prefecture (Tōhoku area)" },
        { word: "青森縣", reading: "あおもりけん", meaning: "Aomori Prefecture (Tōhoku area)" }
    ],
    },
    "縱": {
        onyomi: ["ジュウ"],
        kunyomi: ["たて"],
        examples: [],
    },
    "繡": {
        onyomi: ["シュウ"],
        kunyomi: ["ぬいとり"],
        examples: [
        { word: "繡衣", reading: "しゅうい", meaning: "embroidered clothing" },
        { word: "繡帳", reading: "しゅうちょう", meaning: "embroidered curtain" },
        { word: "繡匠", reading: "しゅうしょう", meaning: "embroiderer" }
    ],
    },
    "繫": {
        onyomi: ["ケイ"],
        kunyomi: ["つな.ぐ", "かか.る", "か.ける"],
        examples: [
        { word: "手を繫ぐ", reading: "てをつなぐ", meaning: "to join hands (with)" },
        { word: "繫ぎとめる", reading: "つなぎとめる", meaning: "to tie, to fasten, to hitch" },
        { word: "繫げる", reading: "つなげる", meaning: "to connect, to tie, to fasten" }
    ],
    },
    "纂": {
        onyomi: ["サン"],
        kunyomi: ["あつ.める"],
        examples: [
        { word: "史料編纂所", reading: "しりょうへんさんじょ", meaning: "Historiographical Institute (University of Tokyo)" },
        { word: "編纂所", reading: "へんさんじょ", meaning: "editorial office" },
        { word: "纂述", reading: "さんじゅつ", meaning: "gathering and writing up material" }
    ],
    },
    "纏": {
        onyomi: ["テン", "デン"],
        kunyomi: ["まつ.わる", "まと.う", "まと.める", "まと.まる", "まと.い"],
        examples: [
        { word: "纏頭", reading: "てんとう", meaning: "a tip" },
        { word: "纏足", reading: "てんそく", meaning: "foot-binding" },
        { word: "印半纏", reading: "しるしばんてん", meaning: "livery coat" }
    ],
    },
    "纖": {
        onyomi: ["セン"],
        kunyomi: [],
        examples: [],
    },
    "羚": {
        onyomi: ["レイ", "リョウ"],
        kunyomi: ["かもしか"],
        examples: [
        { word: "日本羚羊", reading: "にほんかもしか", meaning: "Japanese serow (Capricornis crispus)" },
        { word: "羚羊", reading: "れいよう", meaning: "antelope" },
        { word: "チベット羚羊", reading: "チベットかもしか", meaning: "Tibetan antelope (Pantholops hodgsonii), chiru" }
    ],
    },
    "翔": {
        onyomi: ["ショウ"],
        kunyomi: ["かけ.る", "と.ぶ"],
        examples: [
        { word: "北翔大学", reading: "ほくしょうだいがく", meaning: "Hokusho University" },
        { word: "翔破", reading: "しょうは", meaning: "completing a flight" },
        { word: "競翔", reading: "きょうしょう", meaning: "flying race (between pigeons)" }
    ],
    },
    "翠": {
        onyomi: ["スイ"],
        kunyomi: ["かわせみ", "みどり"],
        examples: [
        { word: "翠屋", reading: "みどりや", meaning: "Midoriya" },
        { word: "翠明荘", reading: "すいめいそう", meaning: "Suimeiso (hotel and restaurant chain - suimeiso.co.jp)" },
        { word: "南洋翡翠", reading: "ナンヨウショウビン", meaning: "collared kingfisher (Todiramphus chloris)" }
    ],
    },
    "耀": {
        onyomi: ["ヨウ"],
        kunyomi: ["かがや.く", "ひかり"],
        examples: [
        { word: "衒耀", reading: "げんよう", meaning: "false glitter" },
        { word: "宣耀殿", reading: "せんようでん", meaning: "ladies' pavilion (of the inner Heian Palace)" },
        { word: "黒耀石", reading: "こくようせき", meaning: "obsidian" }
    ],
    },
    "而": {
        onyomi: ["ジ", "ニ"],
        kunyomi: ["しこ.うして", "しか.して", "しか.も", "しか.れども", "すなわち", "なんじ", "しかるに"],
        examples: [
        { word: "而立", reading: "じりつ", meaning: "age 30" },
        { word: "反形而上学", reading: "はんけいじじょうがく", meaning: "anti-metaphysics" },
        { word: "形而上", reading: "けいじじょう", meaning: "metaphysical" }
    ],
    },
    "耶": {
        onyomi: ["ヤ", "ジャ"],
        kunyomi: ["か"],
        examples: [
        { word: "耶蘇教", reading: "やそきょう", meaning: "Christianity" },
        { word: "摩耶蘭", reading: "まやらん", meaning: "Cymbidium macrorhizon (species of orchid)" },
        { word: "耶路撒冷", reading: "エルサレム", meaning: "Jerusalem" }
    ],
    },
    "耽": {
        onyomi: ["タン"],
        kunyomi: ["ふけ.る"],
        examples: [
        { word: "耽読", reading: "たんどく", meaning: "absorption in reading" },
        { word: "耽美派", reading: "たんびは", meaning: "aesthetic school" },
        { word: "耽美主義", reading: "たんびしゅぎ", meaning: "aestheticism" }
    ],
    },
    "聡": {
        onyomi: ["ソウ"],
        kunyomi: ["さと.い", "みみざと.い"],
        examples: [
        { word: "聡明剛毅", reading: "そうめいごうき", meaning: "be reasonable, strong and do not give in" },
        { word: "利に聡い", reading: "りにさとい", meaning: "wide-awake to one's interests" },
        { word: "聡敏", reading: "そうびん", meaning: "sagacity, cleverness" }
    ],
    },
    "聽": {
        onyomi: ["チョウ"],
        kunyomi: ["き.く", "ゆる.す"],
        examples: [
        { word: "傾聽", reading: "けいちょう", meaning: "listening closely" }
    ],
    },
    "肇": {
        onyomi: ["チョウ", "ジョウ", "トウ"],
        kunyomi: ["はじ.める", "はじめ"],
        examples: [
        { word: "肇歳", reading: "ちょうさい", meaning: "beginning of the year" },
        { word: "御肇国天皇", reading: "はつくにしらすすめらみこと", meaning: "first emperor to rule the land (title of Emperor Sujin)" },
        { word: "肇国", reading: "ちょうこく", meaning: "founding of a state" }
    ],
    },
    "肋": {
        onyomi: ["ロク"],
        kunyomi: ["あばら"],
        examples: [
        { word: "肋軟骨", reading: "ろくなんこつ", meaning: "costal cartilage" },
        { word: "肋凹", reading: "ろくおう", meaning: "costal fovea" },
        { word: "肋軟骨炎", reading: "ろくなんこつえん", meaning: "costochondritis" }
    ],
    },
    "肴": {
        onyomi: ["コウ"],
        kunyomi: ["さかな"],
        examples: [
        { word: "祝い肴", reading: "いわいざかな", meaning: "accompaniment to a drink served at celebrations (such as New Year)" },
        { word: "粗酒粗肴", reading: "そしゅそこう", meaning: "cheap wines and unpalatable dishes (a modest (self-deprecating) way of offering a meal to a guest)" },
        { word: "美酒佳肴", reading: "びしゅかこう", meaning: "fine wines and prized delicacies" }
    ],
    },
    "胡": {
        onyomi: ["ウ", "コ", "ゴ"],
        kunyomi: ["なんぞ"],
        examples: [
        { word: "胡鬼の子", reading: "こぎのこ", meaning: "Buckleya lanceolata (species of parasitic deciduous shrub)" },
        { word: "三島柴胡", reading: "ミシマサイコ", meaning: "Bupleurum stenophyllum (species of medicinal herb)" },
        { word: "唐胡頽子", reading: "とうぐみ", meaning: "Elaeagnus multiflora var. hortensis (variety of goumi)" }
    ],
    },
    "胤": {
        onyomi: ["イン"],
        kunyomi: ["たね"],
        examples: [
        { word: "皇胤", reading: "こういん", meaning: "Imperial descendant (posterity)" },
        { word: "落とし胤", reading: "おとしだね", meaning: "illegitimate child (usu. of a nobleman)" },
        { word: "落胤", reading: "らくいん", meaning: "nobleman's illegitimate child" }
    ],
    },
    "脩": {
        onyomi: ["シュウ"],
        kunyomi: ["おさ.める", "なが.い", "ほじし"],
        examples: [
        { word: "脩竹", reading: "しゅうちく", meaning: "tall bamboo" },
        { word: "束脩", reading: "そくしゅう", meaning: "entrance fee, initiation fee, registration fee" }
    ],
    },
    "脹": {
        onyomi: ["チョウ"],
        kunyomi: ["は.れる", "ふく.らむ", "ふく.れる"],
        examples: [
        { word: "脹らし粉", reading: "ふくらしこ", meaning: "baking powder" },
        { word: "水脹れ", reading: "みずぶくれ", meaning: "blister" },
        { word: "火脹れ", reading: "ひぶくれ", meaning: "blister (due to a burn)" }
    ],
    },
    "腔": {
        onyomi: ["コウ"],
        kunyomi: [],
        examples: [
        { word: "紙腔琴", reading: "しこうきん", meaning: "Japanese variety of music box (invented in 1892 by Toda Kindo)" },
        { word: "腹腔", reading: "ふくくう", meaning: "abdominal cavity" },
        { word: "腹腔内圧", reading: "ふくくうないあつ", meaning: "abdominal pressure" }
    ],
    },
    "膏": {
        onyomi: ["コウ"],
        kunyomi: ["あぶら"],
        examples: [
        { word: "膏血", reading: "こうけつ", meaning: "(hard-earned rewards of) sweat and blood" },
        { word: "オロナイン軟膏", reading: "オロナインなんこう", meaning: "Oronine H Ointment" },
        { word: "雪花石膏", reading: "せっかせっこう", meaning: "alabaster" }
    ],
    },
    "臟": {
        onyomi: ["ゾウ"],
        kunyomi: ["はらわた"],
        examples: [
        { word: "脾臟", reading: "ひぞう", meaning: "spleen" }
    ],
    },
    "臥": {
        onyomi: ["ガ"],
        kunyomi: ["ふせ.る", "ふ.せる", "ふ.す"],
        examples: [
        { word: "臥児狼徳", reading: "グリーンランド", meaning: "Greenland" },
        { word: "病臥", reading: "びょうが", meaning: "being ill in bed" },
        { word: "骨折り損の草臥れ儲け", reading: "ほねおりぞんのくたびれもうけ", meaning: "going through great pains in vain" }
    ],
    },
    "與": {
        onyomi: ["ヨ"],
        kunyomi: ["あた.える", "あずか.る", "くみ.する", "ともに"],
        examples: [
        { word: "與太者", reading: "よたもの", meaning: "hooligan, layabout, good-for-nothing" }
    ],
    },
    "舜": {
        onyomi: ["シュン"],
        kunyomi: [],
        examples: [],
    },
    "舵": {
        onyomi: ["ダ", "タ"],
        kunyomi: ["かじ"],
        examples: [
        { word: "白舵木", reading: "しろかじき", meaning: "black marlin (Makaira indica)" },
        { word: "舵面", reading: "だめん", meaning: "control surface" },
        { word: "舵付きフォア", reading: "かじつきフォア", meaning: "coxed four (rowing)" }
    ],
    },
    "芙": {
        onyomi: ["フ"],
        kunyomi: [],
        examples: [
        { word: "芙蓉峰", reading: "ふようほう", meaning: "Mount Fuji" },
        { word: "唐芙蓉", reading: "とうふよう", meaning: "Okinawan-style fermented tofu" },
        { word: "阿芙蓉", reading: "あふよう", meaning: "poppy" }
    ],
    },
    "芥": {
        onyomi: ["カイ", "ケ"],
        kunyomi: ["からし", "ごみ", "あくた"],
        examples: [
        { word: "芥川賞", reading: "あくたがわしょう", meaning: "Akutagawa Prize (literary award)" },
        { word: "秋の野芥子", reading: "あきののげし", meaning: "Indian lettuce (Lactuca indica)" },
        { word: "和芥子", reading: "わがらし", meaning: "Japanese-style mustard" }
    ],
    },
    "芦": {
        onyomi: ["ロ"],
        kunyomi: ["あし", "よし"],
        examples: [
        { word: "芦屋大学", reading: "あしやだいがく", meaning: "Ashiya University" },
        { word: "芦薈", reading: "ろかい", meaning: "aloe" },
        { word: "芦", reading: "あし", meaning: "common reed (Phragmites australis)" }
    ],
    },
    "芭": {
        onyomi: ["バ", "ハ"],
        kunyomi: [],
        examples: [
        { word: "水芭蕉", reading: "みずばしょう", meaning: "Asian skunk cabbage (Lysichiton camtschatcense)" },
        { word: "芭蕉梶木", reading: "ばしょうかじき", meaning: "Indo-Pacific sailfish (Istiophorus platypterus)" },
        { word: "芭蕉", reading: "ばしょう", meaning: "Japanese fiber banana (Musa basjoo)" }
    ],
    },
    "芹": {
        onyomi: ["キン"],
        kunyomi: ["せり"],
        examples: [
        { word: "芹科", reading: "��りか", meaning: "Apiaceae (parsley family of plants)" },
        { word: "浜芹", reading: "はまぜり", meaning: "Cnidium japonicum (species of umbellifer)" },
        { word: "毒芹", reading: "どくぜり", meaning: "Mackenzie's water hemlock (Cicuta virosa)" }
    ],
    },
    "苑": {
        onyomi: ["エン", "オン"],
        kunyomi: ["その", "う.つ"],
        examples: [
        { word: "公苑", reading: "��うえん", meaning: "(public) park" },
        { word: "辞苑", reading: "じえん", meaning: "Jien (forerunner of the Kojien dictionary)" },
        { word: "珈琲苑", reading: "コーヒーえん", meaning: "Kōhiien (coffee shop)" }
    ],
    },
    "苔": {
        onyomi: ["タイ"],
        kunyomi: ["こけ", "こけら"],
        examples: [
        { word: "丹波海苔", reading: "たんばのり", meaning: "Grateloupia elliptica (species of red alga)" },
        { word: "百足海苔", reading: "むかでのり", meaning: "Grateloupia filicina (species of red alga)" },
        { word: "鶏冠海苔", reading: "とさかのり", meaning: "Meristotheca papulosa (species of edible red alga)" }
    ],
    },
    "苺": {
        onyomi: ["バイ", "マイ"],
        kunyomi: ["いちご"],
        examples: [
        { word: "熊苺", reading: "クマイチゴ", meaning: "Korean raspberry (Rubus crataegifolius)" },
        { word: "冬苺", reading: "ふゆいちご", meaning: "Rubus buergeri (species of raspberry)" },
        { word: "大薔薇苺", reading: "おおばらいちご", meaning: "Rubus croceacanthus (species of raspberry)" }
    ],
    },
    "茄": {
        onyomi: ["カ"],
        kunyomi: [],
        examples: [
        { word: "悪茄子", reading: "わるなすび", meaning: "Carolina horsenettle (Solanum carolinense)" },
        { word: "賀茂茄子", reading: "かもなす", meaning: "Kamo eggplant (Solanum melongena; round variety originally grown in Kyoto)" },
        { word: "茄子科", reading: "なすか", meaning: "Solanaceae (nightshade family of plants)" }
    ],
    },
    "茅": {
        onyomi: ["ボウ", "ミョウ"],
        kunyomi: ["かや", "ちがや"],
        examples: [
        { word: "茅潜", reading: "かやくぐり", meaning: "Japanese accentor (Prunella rubida)" },
        { word: "瀬戸茅", reading: "せとがや", meaning: "Japanese foxtail (Alopecurus japonicus)" },
        { word: "油茅", reading: "あぶらがや", meaning: "abura-gaya (Scirpus wichurai)" }
    ],
    },
    "茉": {
        onyomi: ["マツ", "バツ", "マ"],
        kunyomi: [],
        examples: [
        { word: "茉莉花", reading: "まつりか", meaning: "Arabian jasmine (Jasminum sambac)" },
        { word: "茉莉", reading: "まつり", meaning: "Arabian jasmine (Jasminum sambac)" },
        { word: "野茉莉", reading: "エゴノキ", meaning: "Japanese snowbell (Styrax japonicus)" }
    ],
    },
    "茜": {
        onyomi: ["セン"],
        kunyomi: ["あかね"],
        examples: [
        { word: "秋茜", reading: "アキアカネ", meaning: "autumn darter (Sympetrum frequens)" },
        { word: "西洋茜", reading: "せいようあかね", meaning: "common madder (Rubia tinctorum)" },
        { word: "茜さす", reading: "あかねさす", meaning: "glowing dark red" }
    ],
    },
    "茸": {
        onyomi: ["ジョウ", "ニュ"],
        kunyomi: ["きのこ", "たけ", "しげ.る"],
        examples: [
        { word: "卵茸", reading: "タマゴタケ", meaning: "Amanita caesareoides (edible mushroom species)" },
        { word: "乳茸刺", reading: "ちだけさし", meaning: "Astilbe microphylla (species of astilbe)" },
        { word: "海茸", reading: "うみたけ", meaning: "Barnea dilatata (species of piddock)" }
    ],
    },
    "荻": {
        onyomi: ["テキ"],
        kunyomi: ["おぎ"],
        examples: [
        { word: "荻", reading: "おぎ", meaning: "Amur silvergrass (Miscanthus sacchariflorus)" },
        { word: "荻野学説", reading: "おぎのがくせつ", meaning: "Ogino theory (basis of the rhythm method)" },
        { word: "荻花", reading: "てきか", meaning: "flowers of the Amur silvergrass" }
    ],
    },
    "莉": {
        onyomi: ["リ", "ライ", "レイ"],
        kunyomi: [],
        examples: [
        { word: "茉莉花", reading: "まつりか", meaning: "Arabian jasmine (Jasminum sambac)" },
        { word: "茉莉", reading: "まつり", meaning: "Arabian jasmine (Jasminum sambac)" },
        { word: "野茉莉", reading: "エゴノキ", meaning: "Japanese snowbell (Styrax japonicus)" }
    ],
    },
    "莊": {
        onyomi: ["ソウ", "ショウ", "チャン"],
        kunyomi: ["ほうき", "おごそ.か"],
        examples: [],
    },
    "莞": {
        onyomi: ["カン"],
        kunyomi: ["い"],
        examples: [
        { word: "莞爾", reading: "かんじ", meaning: "smiling" },
        { word: "莞", reading: "ふとい", meaning: "softstem bulrush (Scirpus tabernaemontani)" },
        { word: "莞然", reading: "かんぜん", meaning: "sweetly smiling" }
    ],
    },
    "莫": {
        onyomi: ["バク", "ボ", "マク", "モ", "ナイ"],
        kunyomi: ["くれ", "なか.れ", "なし"],
        examples: [
        { word: "莫斯科", reading: "モスクワ", meaning: "Moscow (Russia)" },
        { word: "莫告藻", reading: "なのりそ", meaning: "Sargassum fulvellum (species of edible brown alga)" },
        { word: "莫逆", reading: "ばくぎゃく", meaning: "cordial relations" }
    ],
    },
    "菅": {
        onyomi: ["カン", "ケン"],
        kunyomi: ["すげ"],
        examples: [
        { word: "白菅", reading: "しらすげ", meaning: "Carex alopecuroides var. chlorostachya (species of sedge)" },
        { word: "寒菅", reading: "かんすげ", meaning: "Carex morrowii" },
        { word: "菅藻", reading: "すがも", meaning: "Phyllospadix iwatensis (species of seagrass)" }
    ],
    },
    "菖": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "檜扇菖蒲", reading: "ひおうぎあやめ", meaning: "Arctic iris (Iris setosa)" },
        { word: "ドイツ菖蒲", reading: "ドイツアヤメ", meaning: "German iris (Iris germanica)" },
        { word: "菖蒲科", reading: "あやめか", meaning: "Iridaceae (iris family)" }
    ],
    },
    "菩": {
        onyomi: ["ボ"],
        kunyomi: [],
        examples: [
        { word: "虚空蔵菩薩", reading: "こくうぞうぼさつ", meaning: "Akasagarbha (bodhisattva)" },
        { word: "薬王菩薩", reading: "やくおうぼさつ", meaning: "Bhaisajyaraja (bodhisattva)" },
        { word: "菩提道場", reading: "ぼだいどうじょう", meaning: "Bodhi-manda (place of Buddhist practice or meditation, esp. the place under the bodhi tree where Buddha attained enlightenment)" }
    ],
    },
    "菫": {
        onyomi: ["キン"],
        kunyomi: ["すみれ"],
        examples: [
        { word: "アフリカ菫", reading: "アフリカすみれ", meaning: "African violet" },
        { word: "菫草", reading: "すみれぐさ", meaning: "Fuji dawn (species of violet, Viola mandshurica)" },
        { word: "叡山菫", reading: "えいざんすみれ", meaning: "Viola eizanensis (flower in the violet family)" }
    ],
    },
    "菱": {
        onyomi: ["リョウ"],
        kunyomi: ["ひし"],
        examples: [
        { word: "東京三菱銀行", reading: "とうきょうみつびしぎんこう", meaning: "Bank of Tokyo-Mitsubishi (now Bank of Tokyo-Mitsubishi UFJ)" },
        { word: "三菱", reading: "みつびし", meaning: "Mitsubishi" },
        { word: "三菱化学", reading: "みつびしかがく", meaning: "Mitsubishi Chemical Corporation" }
    ],
    },
    "萄": {
        onyomi: ["ドウ", "トウ"],
        kunyomi: [],
        examples: [
        { word: "葡萄酒", reading: "ぶどうしゅ", meaning: "(grape) wine" },
        { word: "羅萄日辞典", reading: "らぽにちじてん", meaning: "Dictionarium Latino Lusitanicum, ac Iaponicum, (Latin-Portuguese-Japanese dictionary, published in 1595)" },
        { word: "甲州葡萄", reading: "こうしゅうぶどう", meaning: "Kōshū (grape variety)" }
    ],
    },
    "萊": {
        onyomi: ["ライ", "リ"],
        kunyomi: ["あかざ", "あれわ", "こうがい"],
        examples: [],
    },
    "萌": {
        onyomi: ["ホウ"],
        kunyomi: ["も.える", "きざ.す", "めばえ", "きざ.し"],
        examples: [
        { word: "留萌測候所", reading: "るもいそっこうじょ", meaning: "Rumoi Weather Station" },
        { word: "萌やし", reading: "もやし", meaning: "bean sprouts" },
        { word: "萌車", reading: "もえしゃ", meaning: "car decorated with (female) anime characters" }
    ],
    },
    "萠": {
        onyomi: ["ホウ"],
        kunyomi: ["も.える", "きざ.す", "めばえ", "きざ.し"],
        examples: [
        { word: "萠黄", reading: "もえぎ", meaning: "light yellowish green" },
        { word: "下萠", reading: "したもえ", meaning: "sprout of a plant shooting from under the soil" },
        { word: "萠黄色", reading: "もえぎいろ", meaning: "light green, yellowish-green" }
    ],
    },
    "萩": {
        onyomi: ["シュウ"],
        kunyomi: ["はぎ"],
        examples: [
        { word: "秋萩帖", reading: "あきはぎじょ���", meaning: "Akihagijō (10C poem by Ono Michikaze, regarded as the first hiragana text)" },
        { word: "萩猿子", reading: "はぎましこ", meaning: "Asian rosy finch (Leucosticte arctoa)" },
        { word: "萩の乱", reading: "はぎのらん", meaning: "Hagi Rebellion (1876)" }
    ],
    },
    "萬": {
        onyomi: ["マン", "バン"],
        kunyomi: ["よろず"],
        examples: [
        { word: "萬葉集", reading: "まんようしゅう", meaning: "Man'yōshū (8th century anthology of Japanese poetry)" },
        { word: "萬里蟹", reading: "バンリガニ", meaning: "Wanli Crab (brand name for crab caught in the Wanli district of Taiwan)" },
        { word: "萬子", reading: "ワンズ", meaning: "character tiles" }
    ],
    },
    "萱": {
        onyomi: ["ケン"],
        kunyomi: ["かや", "かんぞう"],
        examples: [
        { word: "雄刈萱", reading: "おがるかや", meaning: "Cymbopogon tortilis var. goeringii (variety of grass closely related to lemongrass)" },
        { word: "雌刈萱", reading: "めがるかや", meaning: "Themeda triandra var. japonica (variety of kangaroo grass)" },
        { word: "油萱", reading: "あぶらがや", meaning: "abura-gaya (Scirpus wichurai)" }
    ],
    },
    "葡": {
        onyomi: ["ブ", "ホ"],
        kunyomi: [],
        examples: [
        { word: "葡萄酒", reading: "ぶどうしゅ", meaning: "(grape) wine" },
        { word: "拉葡日対訳辞書", reading: "ラポにちたいやくじしょ", meaning: "Dictionarium Latino Lusitanicum ac Iaponicum (1595 Latin-Portuguese-Japanese dictionary)" },
        { word: "羅葡日対訳辞書", reading: "らぽにちたいやくじしょ", meaning: "Dictionarium Latino Lusitanicum, Ac Iaponicum (1595 trilingual Latin-Portuguese-Japanese dictionary)" }
    ],
    },
    "董": {
        onyomi: ["トウ"],
        kunyomi: ["ただ.す"],
        examples: [
        { word: "骨董趣味", reading: "こっとうしゅみ", meaning: "antiquarianism" },
        { word: "骨董店", reading: "こっとうてん", meaning: "antique shop" },
        { word: "骨董品屋", reading: "こっとうひんや", meaning: "antique shop" }
    ],
    },
    "葦": {
        onyomi: ["イ"],
        kunyomi: ["あし", "よし", "しお.れる", "しな.びる", "しぼ.む", "な.える"],
        examples: [
        { word: "ヨーロッパ葦切", reading: "ヨーロッパよしきり", meaning: "Eurasian reed warbler (Acrocephalus scirpaceus)" },
        { word: "葦原中国", reading: "あしはらのなかつくに", meaning: "Japan" },
        { word: "間葦", reading: "あいあし", meaning: "Phacelurus latifolius (species of perennial grass)" }
    ],
    },
    "葵": {
        onyomi: ["キ"],
        kunyomi: ["あおい"],
        examples: [
        { word: "二葉葵", reading: "ふたばあおい", meaning: "Asarum caulescens (species of wild ginger)" },
        { word: "寒葵", reading: "かんあおい", meaning: "Asarum nipponicum (species of wild ginger)" },
        { word: "蒲葵", reading: "びろう", meaning: "Chinese fan palm (Livistona chinensis)" }
    ],
    },
    "葺": {
        onyomi: ["シュウ"],
        kunyomi: ["あし", "ふ.く", "ふき"],
        examples: [
        { word: "下葺き", reading: "したぶき", meaning: "built-up roofing" },
        { word: "葺石", reading: "ふきいし", meaning: "round boulders covering the slopes of a burial mound (Kofun period)" },
        { word: "板葺き", reading: "いたぶき", meaning: "shingle roofing" }
    ],
    },
    "蒐": {
        onyomi: ["シュウ"],
        kunyomi: ["あかね", "あつ.まる", "あつ.める"],
        examples: [
        { word: "蒐集家", reading: "しゅうしゅうか", meaning: "collector" },
        { word: "蒐集狂", reading: "しゅうしゅうきょう", meaning: "fanatic collector" },
        { word: "蒐荷", reading: "しゅうか", meaning: "collection of cargo (esp. produce, etc.), cargo booking" }
    ],
    },
    "蒔": {
        onyomi: ["シ", "ジ"],
        kunyomi: ["う.える", "ま.く"],
        examples: [
        { word: "蒔き灰", reading: "まきばい", meaning: "ash for spreading (tea ceremony)" },
        { word: "早蒔き", reading: "はやまき", meaning: "early sowing" },
        { word: "金蒔絵", reading: "きんまきえ", meaning: "gold lacquer" }
    ],
    },
    "蒙": {
        onyomi: ["モウ", "ボウ"],
        kunyomi: ["こうむ.る", "おお.う", "くら.い"],
        examples: [
        { word: "鴻蒙", reading: "ホンモン", meaning: "HarmonyOS (Huawei)" },
        { word: "内蒙", reading: "ないもう", meaning: "Inner Mongolia" },
        { word: "内蒙古", reading: "うちもうこ", meaning: "Inner Mongolia (China)" }
    ],
    },
    "蒲": {
        onyomi: ["ホ", "ボ", "フ", "ブ"],
        kunyomi: ["がま", "かば", "かま"],
        examples: [
        { word: "檜扇菖蒲", reading: "ひおうぎあやめ", meaning: "Arctic iris (Iris setosa)" },
        { word: "肉蒲団", reading: "にくぶとん", meaning: "Carnal Prayer Mat (Qing dynasty era erotic novel by Li Yu)" },
        { word: "蒲葵", reading: "びろう", meaning: "Chinese fan palm (Livistona chinensis)" }
    ],
    },
    "蒼": {
        onyomi: ["ソウ"],
        kunyomi: ["あお.い"],
        examples: [
        { word: "蒼鉛", reading: "そうえん", meaning: "bismuth" },
        { word: "輝蒼鉛鉱", reading: "きそうえんこう", meaning: "bismuthinite" },
        { word: "蒼穹", reading: "そうきゅう", meaning: "blue sky" }
    ],
    },
    "蓉": {
        onyomi: ["ヨウ"],
        kunyomi: [],
        examples: [
        { word: "芙蓉峰", reading: "ふようほう", meaning: "Mount Fuji" },
        { word: "唐芙蓉", reading: "とうふよう", meaning: "Okinawan-style fermented tofu" },
        { word: "阿芙蓉", reading: "あふよう", meaning: "poppy" }
    ],
    },
    "蓑": {
        onyomi: ["サ", "サイ"],
        kunyomi: ["みの"],
        examples: [
        { word: "蓑鳩", reading: "みのばと", meaning: "Nicobar pigeon (Caloenas nicobarica)" },
        { word: "蓑笠子", reading: "みのかさご", meaning: "luna lionfish (Pterois lunulata)" },
        { word: "蓑曳鶏", reading: "みのひきどり", meaning: "minohiki chicken (Japanese long-tailed breed)" }
    ],
    },
    "蓬": {
        onyomi: ["ホウ", "ブ"],
        kunyomi: ["よもぎ"],
        examples: [
        { word: "蓬属", reading: "よもぎぞく", meaning: "Artemisia (genus of plants containing mugworts, wormwoods, etc.)" },
        { word: "大蓬", reading: "おおよもぎ", meaning: "Artemisia montana" },
        { word: "背高蓬", reading: "せいたかよもぎ", meaning: "Artemisia selengensis" }
    ],
    },
    "蓮": {
        onyomi: ["レン"],
        kunyomi: ["はす", "はちす"],
        examples: [
        { word: "紅妙蓮寺", reading: "べにみょうれんじ", meaning: "Camellia japonica 'Benimyorenji' (cultivar of common camellia)" },
        { word: "岩蓮華", reading: "いわれんげ", meaning: "Chinese dunce cap (species of succulent plant, Orostachys iwarenge)" },
        { word: "蓮華草", reading: "れんげそう", meaning: "Chinese milk vetch (Astragalus sinicus)" }
    ],
    },
    "蔓": {
        onyomi: ["マン", "バン"],
        kunyomi: ["はびこ.る", "つる"],
        examples: [
        { word: "芋蔓式", reading: "いもづるしき", meaning: "(appearing, occurring) one after another" },
        { word: "合器蔓", reading: "ごきづる", meaning: "Actinostemma lobatum (plant of the family Cucurbitaceae)" },
        { word: "蔓梅擬", reading: "つるうめもどき", meaning: "Celastrus orbiculatus" }
    ],
    },
    "蔣": {
        onyomi: ["ショウ", "ソウ"],
        kunyomi: ["まこも", "はげ.ます"],
        examples: [],
    },
    "蔦": {
        onyomi: ["チョウ"],
        kunyomi: ["つた"],
        examples: [
        { word: "蔦漆", reading: "つたうるし", meaning: "Asian poison ivy (Rhus ambigua)" },
        { word: "豆蔦蘭", reading: "まめづたらん", meaning: "Bulbophyllum drymoglossum (species of orchid)" },
        { word: "黒木蔦", reading: "くろきづた", meaning: "Caulerpa scalpelliformis (species of green alga)" }
    ],
    },
    "蔭": {
        onyomi: ["イン", "オン"],
        kunyomi: ["かげ"],
        examples: [
        { word: "神戸松蔭女子学院大学", reading: "こうべしょういんじょしがくいんだいがく", meaning: "Kobe Shoin Women's University" },
        { word: "大阪樟蔭女子大学", reading: "おおさかしょういんじょしだいがく", meaning: "Osaka Shoin Women's University" },
        { word: "大阪桐蔭", reading: "おおさかとういん", meaning: "Osaka Tōin Junior and Senior High School (abbr)" }
    ],
    },
    "蕃": {
        onyomi: ["バン", "ハン"],
        kunyomi: [],
        examples: [
        { word: "玄蕃寮", reading: "げんばりょう", meaning: "The Agency for Buddhists and Foreigners (ritsuryō system)" },
        { word: "吐蕃", reading: "とばん", meaning: "Tibetan Empire (618-842 CE)" },
        { word: "蕃書", reading: "ばんしょ", meaning: "Western books (esp. Dutch; in the Edo period)" }
    ],
    },
    "蕉": {
        onyomi: ["ショウ"],
        kunyomi: [],
        examples: [
        { word: "水芭蕉", reading: "みずばしょう", meaning: "Asian skunk cabbage (Lysichiton camtschatcense)" },
        { word: "芭蕉梶木", reading: "ばしょうかじき", meaning: "Indo-Pacific sailfish (Istiophorus platypterus)" },
        { word: "芭蕉", reading: "ばしょう", meaning: "Japanese fiber banana (Musa basjoo)" }
    ],
    },
    "蕎": {
        onyomi: ["キョウ"],
        kunyomi: ["そば"],
        examples: [
        { word: "中華蕎麦", reading: "ちゅうかそば", meaning: "Chinese noodles (esp. ramen)" },
        { word: "沖縄蕎麦", reading: "おきなわそば", meaning: "Okinawa soba (thick noodles served in a pork soup)" },
        { word: "夜鷹蕎麦", reading: "よたかそば", meaning: "ambulatory evening vendor of noodles (or the noodles themselves)" }
    ],
    },
    "蕗": {
        onyomi: ["ロ", "ル"],
        kunyomi: ["ふき"],
        examples: [
        { word: "野蕗", reading: "のぶき", meaning: "Adenocaulon himalaicum (species of flowering plant)" },
        { word: "秋田蕗", reading: "あきたぶき", meaning: "Japanese butterbur (Petasites japonicus subsp. giganteus)" },
        { word: "玉蕗", reading: "たまぶき", meaning: "Parasenecio farfarifolius var. bulbifer (variety of Indian plantain)" }
    ],
    },
    "蕨": {
        onyomi: ["ケツ"],
        kunyomi: ["わらび"],
        examples: [
        { word: "熊蕨", reading: "くまわらび", meaning: "Dryopteris lacera (species of wood fern)" },
        { word: "蕨", reading: "わらび", meaning: "bracken" },
        { word: "蕨粉", reading: "わらびこ", meaning: "bracken starch (starch produced from the rhizomes of bracken)" }
    ],
    },
    "蕪": {
        onyomi: ["ブ", "ム"],
        kunyomi: ["かぶ", "かぶら", "あれる"],
        examples: [
        { word: "蕪鮨", reading: "かぶらずし", meaning: "narezushi of amberjack and turnip (Kanazawa speciality)" },
        { word: "和布蕪", reading: "めかぶら", meaning: "thick wakame leaves from near the stem" },
        { word: "蕪菜", reading: "かぶな", meaning: "turnip (Brassica rapa)" }
    ],
    },
    "蕾": {
        onyomi: ["ライ"],
        kunyomi: ["つぼみ"],
        examples: [
        { word: "蕾状期", reading: "らいじょうき", meaning: "bud stage (tooth)" },
        { word: "花蕾", reading: "からい", meaning: "flower bud" },
        { word: "バラの蕾", reading: "バラのつぼみ", meaning: "rosebud" }
    ],
    },
    "薗": {
        onyomi: ["エン", "オン"],
        kunyomi: ["その"],
        examples: [
        { word: "薗", reading: "その", meaning: "garden, orchard, park" }
    ],
    },
    "薙": {
        onyomi: ["テイ", "チ"],
        kunyomi: ["な.ぐ", "なぎ", "か.る"],
        examples: [
        { word: "薙刀術", reading: "なぎなたじゅつ", meaning: "art of using a naginata" },
        { word: "水薙鳥", reading: "みずなぎどり", meaning: "petrel (esp. petrels of family Procellariidae)" },
        { word: "大水薙鳥", reading: "おおみずなぎどり", meaning: "streaked shearwater (species of seabird, Calonectris leucomelas)" }
    ],
    },
    "薩": {
        onyomi: ["サツ", "サチ"],
        kunyomi: [],
        examples: [
        { word: "虚空蔵菩薩", reading: "こくうぞうぼさつ", meaning: "Akasagarbha (bodhisattva)" },
        { word: "薬王菩薩", reading: "やくおうぼさつ", meaning: "Bhaisajyaraja (bodhisattva)" },
        { word: "月光菩薩", reading: "がっこうぼさつ", meaning: "Candraprabha (bodhisattva)" }
    ],
    },
    "薰": {
        onyomi: ["クン"],
        kunyomi: ["かおる", "かおりぐさ", "かおり"],
        examples: [],
    },
    "藁": {
        onyomi: ["コウ"],
        kunyomi: ["わら"],
        examples: [
        { word: "寝藁", reading: "ねわら", meaning: "(stable) litter" },
        { word: "藁苞", reading: "わらすぼ", meaning: "Odontamblyopus lacepedii (species of eel goby)" },
        { word: "藁稭長者", reading: "わらしべちょうじゃ", meaning: "Straw Millionaire (Japanese Buddhist folk tale)" }
    ],
    },
    "藏": {
        onyomi: ["ゾウ", "ソウ"],
        kunyomi: ["くら", "おさ.める", "かく.れる"],
        examples: [
        { word: "西藏", reading: "せいぞう", meaning: "Tibet" },
        { word: "藏人", reading: "くろうど", meaning: "keeper of imperial archives, worker skilled in the brewing of sake or soy sauce" }
    ],
    },
    "藝": {
        onyomi: ["ゲイ", "ウン"],
        kunyomi: ["う.える", "のり", "わざ"],
        examples: [
        { word: "學藝書林", reading: "がくげいしょりん", meaning: "Gakugei Shorin (publisher)" },
        { word: "藝大", reading: "げいだい", meaning: "Tokyo University of Arts (abbr)" },
        { word: "東京藝術大学", reading: "とうきょうげいじゅつだいがく", meaning: "Tokyo University of the Arts" }
    ],
    },
    "藥": {
        onyomi: ["ヤク"],
        kunyomi: ["くすり"],
        examples: [],
    },
    "蘇": {
        onyomi: ["ソ", "ス"],
        kunyomi: ["よみがえ.る"],
        examples: [
        { word: "花蘇芳", reading: "はなずおう", meaning: "Chinese redbud (Cercis chinensis)" },
        { word: "耶蘇教", reading: "やそきょう", meaning: "Christianity" },
        { word: "梅紫蘇", reading: "うめしそ", meaning: "Japanese apricot and shiso" }
    ],
    },
    "蘭": {
        onyomi: ["ラン", "ラ"],
        kunyomi: [],
        examples: [
        { word: "紫君子蘭", reading: "むらさきくんしらん", meaning: "African lily (Agapanthus africanus)" },
        { word: "英蘭戦争", reading: "えいらんせんそう", meaning: "Anglo-Dutch Wars (1652-1654, 1665-1667, 1672-1674)" },
        { word: "紫蘭", reading: "しらん", meaning: "Bletilla striata (purple variety of orchid)" }
    ],
    },
    "虛": {
        onyomi: ["キョ", "コ"],
        kunyomi: ["むなしい"],
        examples: [],
    },
    "蝦": {
        onyomi: ["カ", "ゲ"],
        kunyomi: ["えび"],
        examples: [
        { word: "蝦蟇口", reading: "がまぐち", meaning: "(coin) purse with a metal clasp" },
        { word: "蝦夷にゅう", reading: "えぞにゅう", meaning: "Angelica ursina (species of perennial herb)" },
        { word: "豊年蝦", reading: "ほうねんえび", meaning: "Branchinella kugenumaensis (species of fairy shrimp)" }
    ],
    },
    "蝶": {
        onyomi: ["チョウ"],
        kunyomi: [],
        examples: [
        { word: "箆蝶鮫", reading: "へらちょうざめ", meaning: "American paddlefish (Polyodon spathula)" },
        { word: "黄蛺蝶", reading: "きたては", meaning: "Asian comma butterfly (Polygonia c-aureum)" },
        { word: "墨流蝶", reading: "すみながし", meaning: "Asian constable (species of butterfly, Dichorragia nesimachus)" }
    ],
    },
    "螺": {
        onyomi: ["ラ"],
        kunyomi: ["にし", "にな"],
        examples: [
        { word: "アルキメデスの螺線", reading: "アルキメデスのらせん", meaning: "Archimedean spiral" },
        { word: "蝦夷法螺", reading: "えぞぼら", meaning: "Ezo neptune (species of whelk, Neptunea polycostata)" },
        { word: "馬蹄螺", reading: "ばていら", meaning: "Omphalius pfeifferi pfeifferi (subspecies of top shell)" }
    ],
    },
    "蟬": {
        onyomi: ["セン", "ゼン"],
        kunyomi: ["せみ"],
        examples: [
        { word: "蝦夷蟬", reading: "えぞぜみ", meaning: "Lyristes japonicus (species of cicada)" },
        { word: "耳蟬", reading: "みみずく", meaning: "auricled leafhopper (Ledra auditura)" },
        { word: "夕蟬", reading: "ゆうぜみ", meaning: "cicada singing at dusk" }
    ],
    },
    "蟹": {
        onyomi: ["カイ"],
        kunyomi: ["かに"],
        examples: [
        { word: "磯蟹", reading: "いそがに", meaning: "Asian shore crab (Hemigrapsus sanguineus)" },
        { word: "銀杏蟹", reading: "いちょうがに", meaning: "Cancer japonicus (species of crab)" },
        { word: "蟹玉", reading: "かにたま", meaning: "Chinese dish with fried egg and crab" }
    ],
    },
    "蠟": {
        onyomi: ["ロウ"],
        kunyomi: ["みつろう", "ろうそく"],
        examples: [
        { word: "水蠟蠟虫", reading: "いぼたろうむし", meaning: "Chinese wax scale insect (Ericerus pela)" },
        { word: "蠟染め", reading: "ろうぞめ", meaning: "batik" },
        { word: "蜂蠟", reading: "はちろう", meaning: "beeswax" }
    ],
    },
    "衞": {
        onyomi: ["エイ", "エ"],
        kunyomi: ["まも.る"],
        examples: [
        { word: "權兵衞", reading: "ごんべえ", meaning: "John Doe, person of unknown name, country bumpkin" }
    ],
    },
    "衿": {
        onyomi: ["キン", "コン"],
        kunyomi: ["えり"],
        examples: [
        { word: "衿芯", reading: "えりしん", meaning: "collar core (stiff fabric, etc. inside a collar)" },
        { word: "衿裏", reading: "えりうら", meaning: "lining of the collar" },
        { word: "裏衿", reading: "うらえり", meaning: "neckband lining" }
    ],
    },
    "袈": {
        onyomi: ["ケ", "カ"],
        kunyomi: [],
        examples: [
        { word: "輪袈裟", reading: "わげさ", meaning: "loop-shaped monk's stole" },
        { word: "袈裟固め", reading: "けさがため", meaning: "scarf hold (in judo)" },
        { word: "袈裟斬り", reading: "けさぎり", meaning: "slashing (someone) with a sword diagonally from the shoulder" }
    ],
    },
    "袴": {
        onyomi: ["コ", "ク"],
        kunyomi: ["はかま", "ずぼん"],
        examples: [
        { word: "相合袴", reading: "あいあいばかま", meaning: "Aiaibakama (noh farce)" },
        { word: "二人袴", reading: "ふたりばかま", meaning: "Futaribakama (noh farce)" },
        { word: "猩々袴", reading: "しょうじょうばかま", meaning: "Oriental swamp pink (Heloniopsis orientalis)" }
    ],
    },
    "裝": {
        onyomi: ["ソウ", "ショウ"],
        kunyomi: ["よそお.う", "よそお.い"],
        examples: [
        { word: "裝飾男子", reading: "そうしょくだんし", meaning: "man who doesn't adhere to traditional masculinity, esp. with women and careers, herbivore man" }
    ],
    },
    "裟": {
        onyomi: ["サ", "シャ"],
        kunyomi: [],
        examples: [
        { word: "阿毘羅吽欠裟婆呵", reading: "あびらうんけんそわか", meaning: "a-bi-ra-un-ken so-wa-ka (mantra directed to Vairocana)" },
        { word: "輪袈裟", reading: "わげさ", meaning: "loop-shaped monk's stole" },
        { word: "袈裟固め", reading: "けさがため", meaning: "scarf hold (in judo)" }
    ],
    },
    "裡": {
        onyomi: ["リ"],
        kunyomi: ["うち", "うら"],
        examples: [
        { word: "場裡", reading: "じょうり", meaning: "arena (e.g. international arena)" },
        { word: "競争場裡", reading: "きょうそうじょうり", meaning: "arena of competition" },
        { word: "脳裡", reading: "のうり", meaning: "one's mind" }
    ],
    },
    "裳": {
        onyomi: ["ショウ"],
        kunyomi: ["も", "もすそ"],
        examples: [
        { word: "裳着", reading: "もぎ", meaning: "Heian-period coming-of-age ceremony for girls" },
        { word: "借り衣裳", reading: "かりいしょう", meaning: "borrowed clothes" },
        { word: "舞衣裳", reading: "まいいしょう", meaning: "dancing costume" }
    ],
    },
    "襖": {
        onyomi: ["オウ"],
        kunyomi: ["ふすま", "あお"],
        examples: [
        { word: "襖", reading: "あお", meaning: "everyday garment worn by men in ancient Japan" },
        { word: "襖絵", reading: "ふすまえ", meaning: "images drawn or painted on fusuma" },
        { word: "金襖子", reading: "きんおうし", meaning: "kajika frog (Buergeria buergeri)" }
    ],
    },
    "覽": {
        onyomi: ["ラン"],
        kunyomi: ["み.る"],
        examples: [],
    },
    "訊": {
        onyomi: ["ジン", "シュン", "シン"],
        kunyomi: ["き.く", "と.う", "たず.ねる"],
        examples: [
        { word: "中央通訊社", reading: "ちゅうおうつうじんしゃ", meaning: "Central News Agency (Taiwanese news agency)" },
        { word: "騰訊", reading: "テンセント", meaning: "Tencent (Chinese conglomerate)" },
        { word: "反対訊問", reading: "はんたいじんもん", meaning: "cross-examination" }
    ],
    },
    "訣": {
        onyomi: ["ケツ"],
        kunyomi: ["わかれ", "わかれ.る"],
        examples: [
        { word: "訣絶", reading: "けつぜつ", meaning: "breaking off a relationship" },
        { word: "永訣", reading: "えいけつ", meaning: "last farewell" },
        { word: "要訣", reading: "ようけつ", meaning: "main point" }
    ],
    },
    "註": {
        onyomi: ["チュウ"],
        kunyomi: [],
        examples: [
        { word: "古註", reading: "こちゅう", meaning: "commentaries of the ancients" },
        { word: "脚註", reading: "きゃくちゅう", meaning: "footnote" },
        { word: "頭註", reading: "とうちゅう", meaning: "headnote" }
    ],
    },
    "詢": {
        onyomi: ["ジュン", "シュン"],
        kunyomi: ["はか.る", "まこと"],
        examples: [
        { word: "交詢", reading: "こうじゅん", meaning: "promotion of social intercourse" },
        { word: "諮詢機関", reading: "しじゅんきかん", meaning: "consultative body, advisory committee, advisory organ" },
        { word: "諮詢", reading: "しじゅん", meaning: "question, enquiry, inquiry" }
    ],
    },
    "詫": {
        onyomi: ["タ"],
        kunyomi: ["わび", "わび.しい", "かこつ", "わ.びる", "わび.る"],
        examples: [
        { word: "詫び", reading: "わび", meaning: "apology" },
        { word: "お詫び", reading: "おわび", meaning: "apology" },
        { word: "詫び言", reading: "わびごと", meaning: "apology" }
    ],
    },
    "誼": {
        onyomi: ["ギ"],
        kunyomi: ["よしみ", "よい"],
        examples: [
        { word: "友誼国家", reading: "ゆうぎこっか", meaning: "friendly nation" },
        { word: "旧誼", reading: "きゅうぎ", meaning: "old friendship" },
        { word: "好誼", reading: "こうぎ", meaning: "warm friendship" }
    ],
    },
    "諄": {
        onyomi: ["シュン"],
        kunyomi: ["ひちくど.い", "くど.い", "くどくど", "ねんご.ろ"],
        examples: [
        { word: "回り諄い", reading: "まわりくどい", meaning: "circuitous, roundabout, indirect" },
        { word: "諄々", reading: "じゅんじゅん", meaning: "earnestly, repeatedly, patiently" },
        { word: "諄諄しい", reading: "くどくどしい", meaning: "wordy, verbose, prolix" }
    ],
    },
    "諏": {
        onyomi: ["シュ", "ス"],
        kunyomi: ["そう", "はか.る"],
        examples: [
        { word: "公立諏訪東京理科大学", reading: "こうりつすわとうきょうりかだいがく", meaning: "Suwa University of Science" },
        { word: "諏訪大明神", reading: "すわだいみょうじん", meaning: "Suwa deities (esp. Takeminakata and his consort Yasakatome), Suwa Daimyōjin" },
        { word: "諏訪八幡も照覧あれ", reading: "すわはちまんもしょうらんあれ", meaning: "may Takeminakata (Suwa) and Hachiman bear witness, samurai vow of truthfulness" }
    ],
    },
    "諒": {
        onyomi: ["リョウ"],
        kunyomi: ["あきら.か", "まことに"],
        examples: [
        { word: "諒闇", reading: "りょうあん", meaning: "court mourning (for the late emperor or empress), national mourning" },
        { word: "諒解事項", reading: "りょうかいじこう", meaning: "agreed-upon item, item on which agreement has been reached, understanding" },
        { word: "諒察", reading: "りょうさつ", meaning: "consideration, taking into account, sympathy with" }
    ],
    },
    "諺": {
        onyomi: ["ゲン"],
        kunyomi: ["ことわざ"],
        examples: [
        { word: "諺文", reading: "オンモン", meaning: "hangul (Korean script)" },
        { word: "法諺", reading: "ほうげん", meaning: "legal maxim" },
        { word: "西諺", reading: "せいげん", meaning: "Western saying, Western proverb" }
    ],
    },
    "謂": {
        onyomi: ["イ"],
        kunyomi: ["い.う", "いい", "おも.う", "いわゆる"],
        examples: [
        { word: "過ちて改めざる是を過ちと謂う", reading: "あやまちてあらためざるこれをあやまちという", meaning: "a man who has committed a mistake and doesn't correct it is committing another mistake" },
        { word: "謂れ因縁", reading: "いわれいんねん", meaning: "origin, history" },
        { word: "謂えらく", reading: "おもえらく", meaning: "it seems (to me), presumably, I think" }
    ],
    },
    "謠": {
        onyomi: ["ヨウ"],
        kunyomi: ["うた.う", "うた"],
        examples: [],
    },
    "讃": {
        onyomi: ["サン"],
        kunyomi: ["ほ.める", "たた.える"],
        examples: [
        { word: "土讃本線", reading: "どさんほんせん", meaning: "Dosan Main Line (Kochi-Kagawa Railway)" },
        { word: "来迎和讃", reading: "らいごうわさん", meaning: "Japanese hymn praising the coming of the Buddha (thought to be written by Minamoto No Makoto)" },
        { word: "讃岐弁", reading: "さぬきべん", meaning: "Kagawa dialect" }
    ],
    },
    "讓": {
        onyomi: ["ジョウ"],
        kunyomi: ["ゆず.る"],
        examples: [
        { word: "讓位", reading: "じょうい", meaning: "abdication" }
    ],
    },
    "豹": {
        onyomi: ["ヒョウ", "ホウ"],
        kunyomi: [],
        examples: [
        { word: "君子豹変す", reading: "くんしひょうへんす", meaning: "A wise man changes his mind, a fool never" },
        { word: "アムール豹", reading: "アムールひょう", meaning: "Amur leopard (Panthera pardus orientalis)" },
        { word: "バイカル海豹", reading: "バイカルあざらし", meaning: "Baikal seal (Phoca sibirica)" }
    ],
    },
    "貰": {
        onyomi: ["セイ", "シャ"],
        kunyomi: ["もら.う"],
        examples: [
        { word: "貰い娘", reading: "もらいむすめ", meaning: "adopted daughter" },
        { word: "貰い息子", reading: "もらいむすこ", meaning: "adopted son" },
        { word: "貰い火", reading: "もらいび", meaning: "catching fire (from a neighbouring house on fire)" }
    ],
    },
    "賑": {
        onyomi: ["シン"],
        kunyomi: ["にぎ.わい", "にぎ.やか", "にぎ.わす", "にぎ.わう"],
        examples: [
        { word: "殷賑", reading: "いんしん", meaning: "prosperity" },
        { word: "殷賑を極める", reading: "いんしんをきわめる", meaning: "to enjoy prosperity" },
        { word: "賑やかさ", reading: "にぎやかさ", meaning: "business, liveliness" }
    ],
    },
    "賣": {
        onyomi: ["バイ"],
        kunyomi: ["う.る", "う.れる"],
        examples: [
        { word: "淫賣婦", reading: "いんばいふ", meaning: "prostitute" },
        { word: "淫賣", reading: "いんばい", meaning: "prostitution, prostitute" },
        { word: "商賣繁盛", reading: "しょうばいはんじょう", meaning: "thriving (prosperous) business, rush of business" }
    ],
    },
    "賴": {
        onyomi: ["ライ"],
        kunyomi: ["たのむ", "たよる", "たより"],
        examples: [],
    },
    "赳": {
        onyomi: ["キュウ"],
        kunyomi: [],
        examples: [],
    },
    "跨": {
        onyomi: ["コ", "カ"],
        kunyomi: ["また.がる", "またが.る", "また.ぐ"],
        examples: [
        { word: "年跨", reading: "としまたぎ", meaning: "continuance into the New Year" },
        { word: "跨道橋", reading: "こどうきょう", meaning: "overpass" },
        { word: "跨ぎ", reading: "またぎ", meaning: "step or stride (over something)" }
    ],
    },
    "蹄": {
        onyomi: ["テイ"],
        kunyomi: ["ひづめ"],
        examples: [
        { word: "羊蹄", reading: "ぎしぎし", meaning: "Japanese dock (Rumex japonicus)" },
        { word: "馬蹄螺", reading: "ばていら", meaning: "Omphalius pfeifferi pfeifferi (subspecies of top shell)" },
        { word: "奇蹄目", reading: "きていもく", meaning: "Perissodactyla (order of odd-toed ungulates, incl. horses, tapirs, etc.)" }
    ],
    },
    "蹟": {
        onyomi: ["セキ", "シャク"],
        kunyomi: ["あと"],
        examples: [
        { word: "終油の秘蹟", reading: "しゅうゆのひせき", meaning: "extreme unction" },
        { word: "聖蹟", reading: "せいせき", meaning: "holy site" },
        { word: "奇蹟的", reading: "きせきてき", meaning: "miraculous" }
    ],
    },
    "輔": {
        onyomi: ["ホ", "フ"],
        kunyomi: ["たす.ける"],
        examples: [
        { word: "少輔", reading: "しょう", meaning: "assistant vice-minister (ritsuryō system, early Meiji period)" },
        { word: "唇歯輔車", reading: "しんしほしゃ", meaning: "mutual dependence" },
        { word: "輔車唇歯", reading: "ほしゃしんし", meaning: "mutual dependence" }
    ],
    },
    "輯": {
        onyomi: ["シュウ"],
        kunyomi: ["あつ.める", "やわ.らぐ"],
        examples: [
        { word: "第一輯", reading: "だいいっ���ゅう", meaning: "first series" },
        { word: "集輯", reading: "しゅうしゅう", meaning: "gathered together and compiled" },
        { word: "編輯", reading: "へんしゅう", meaning: "editing, compilation" }
    ],
    },
    "輿": {
        onyomi: ["ヨ"],
        kunyomi: ["かご", "こし"],
        examples: [
        { word: "女氏無くして玉の輿に乗る", reading: "おんなうじなくしてたまのこしにのる", meaning: "even a woman of low birth can gain status by marrying rich (if she has the looks)" },
        { word: "前輿", reading: "さきごし", meaning: "front palanquin carrier" },
        { word: "神輿ダコ", reading: "みこしだこ", meaning: "ganglion cyst caused by carrying a mikoshi on one's shoulders" }
    ],
    },
    "轉": {
        onyomi: ["テン"],
        kunyomi: ["ころ.がる", "ころ.げる", "ころ.がす", "ころ.ぶ", "まろ.ぶ", "うたた", "うつ.る"],
        examples: [
        { word: "轉任", reading: "てんにん", meaning: "change of post" },
        { word: "轉送", reading: "てんそう", meaning: "transfer (of a call, patient, etc.), forwarding (a letter, email, etc.), redirection" }
    ],
    },
    "轟": {
        onyomi: ["ゴウ", "コウ"],
        kunyomi: ["とどろ.かす", "とどろ.く"],
        examples: [
        { word: "爆轟", reading: "ばくごう", meaning: "detonation" },
        { word: "轟", reading: "とどろ", meaning: "roaring" },
        { word: "轟沈", reading: "ごうちん", meaning: "sinking instantly (of a ship due to a torpedo attack, bombing, etc.)" }
    ],
    },
    "辰": {
        onyomi: ["シン", "ジン"],
        kunyomi: ["たつ"],
        examples: [
        { word: "戊辰戦争", reading: "ぼしんせんそう", meaning: "Boshin War (Japanese civil war between Imperial and shogunate forces; 1868-1869)" },
        { word: "戊辰", reading: "つちのえたつ", meaning: "Earth Dragon (5th term of the sexagenary cycle, e.g. 1928, 1988, 2048)" },
        { word: "丙辰", reading: "ひのえたつ", meaning: "Fire Dragon (53rd term of the sexagenary cycle, e.g. 1916, 1976, 2036)" }
    ],
    },
    "辻": {
        onyomi: [],
        kunyomi: ["つじ"],
        examples: [
        { word: "辻占煎餅", reading: "つじうらせんべい", meaning: "Japanese fortune cookie" },
        { word: "辻風呂", reading: "つじぶろ", meaning: "bathtub placed on the roadside and rented to customers" },
        { word: "辻が花", reading: "つじがはな", meaning: "cloth-dyeing technique incorporating flower patterns" }
    ],
    },
    "辿": {
        onyomi: ["テン"],
        kunyomi: ["たど.る", "たどり"],
        examples: [
        { word: "元を辿る", reading: "もとをたどる", meaning: "to trace back to (the origins of something)" },
        { word: "夢路を辿る", reading: "ゆめじをたどる", meaning: "to have a dream, to walk along the road of dreams" },
        { word: "一途を辿る", reading: "いっとをたどる", meaning: "to continue, to keep going, to go along (e.g. with some trend)" }
    ],
    },
    "迂": {
        onyomi: ["ウ"],
        kunyomi: [],
        examples: [
        { word: "迂回ルーティング", reading: "うかいルーティング", meaning: "alternate, detour routing" },
        { word: "婉曲迂遠", reading: "えんきょくうえん", meaning: "being euphemistic and circumlocutory" },
        { word: "迂言法", reading: "うげんほう", meaning: "periphrasis" }
    ],
    },
    "迄": {
        onyomi: ["キツ"],
        kunyomi: ["まで", "およ.ぶ"],
        examples: [
        { word: "年末迄", reading: "ねんまつまで", meaning: "before the end of this year" },
        { word: "暑さ寒さも彼岸迄", reading: "あつささむさもひがんまで", meaning: "no heat or cold lasts over the equinox" },
        { word: "然迄", reading: "さまで", meaning: "so much" }
    ],
    },
    "迦": {
        onyomi: ["カ", "ケ"],
        kunyomi: [],
        examples: [
        { word: "釈迦十", reading: "しゃかじゅう", meaning: "10 of batons (in mekuri karuta)" },
        { word: "阿迦奢", reading: "アカシャ", meaning: "Akasha (ether in traditional Hindu cosmology)" },
        { word: "波波迦", reading: "ははか", meaning: "Japanese bird cherry (Prunus grayana)" }
    ],
    },
    "迪": {
        onyomi: ["テキ"],
        kunyomi: ["みち", "みちび.く", "すす.む", "いた.る"],
        examples: [
        { word: "啓迪", reading: "けいてき", meaning: "edification, enlightenment, guide" },
        { word: "訓迪", reading: "くんてき", meaning: "guide, master, teacher" }
    ],
    },
    "逗": {
        onyomi: ["トウ", "ズ"],
        kunyomi: ["とど.まる"],
        examples: [
        { word: "逗留客", reading: "とうりゅうきゃく", meaning: "sojourner, visitor" },
        { word: "逗留", reading: "とうりゅう", meaning: "stay, sojourn" }
    ],
    },
    "這": {
        onyomi: ["シャ", "ゲン"],
        kunyomi: ["は.う", "は.い", "むか.える", "この"],
        examples: [
        { word: "褄黒大横這い", reading: "つまぐろおおよこばい", meaning: "Bothrogonia ferruginea (species of leafhopper)" },
        { word: "這い這い", reading: "はいはい", meaning: "crawling (of a baby)" },
        { word: "高這い", reading: "たかばい", meaning: "crawling on all fours (usu. with the buttocks raised)" }
    ],
    },
    "逞": {
        onyomi: ["テイ"],
        kunyomi: ["たくま.しい"],
        examples: [
        { word: "逞しくする", reading: "たくましくする", meaning: "to give rein to (imagination)" },
        { word: "商魂逞しい", reading: "しょうこんたくましい", meaning: "aggressively business-minded, shrewd (of a merchant, salesman, etc.)" },
        { word: "不逞の輩", reading: "ふていのやから", meaning: "lawless people, gang, malcontents" }
    ],
    },
    "逢": {
        onyomi: ["ホウ"],
        kunyomi: ["あ.う", "むか.える"],
        examples: [
        { word: "めぐり逢い", reading: "めぐりあい", meaning: "An Affair To Remember (film)" },
        { word: "碁に凝ると親の死に目に逢わぬ", reading: "ごにこるとおやのしにめにあわぬ", meaning: "if you get too absorbed when playing go, you will miss your parent's deathbed" },
        { word: "愛逢月", reading: "めであいづき", meaning: "seventh lunar month" }
    ],
    },
    "遁": {
        onyomi: ["トン", "シュン"],
        kunyomi: ["のが.れる"],
        examples: [
        { word: "火遁", reading: "かとん", meaning: "(ninja art of) escaping using fire or smoke" },
        { word: "隠遁術", reading: "いんとんじゅつ", meaning: "Ninja art of escape" },
        { word: "遁術", reading: "とんじゅつ", meaning: "Ninja art of escape" }
    ],
    },
    "遙": {
        onyomi: ["ヨウ"],
        kunyomi: ["はる.か"],
        examples: [
        { word: "加味逍遙散", reading: "かみしょうようさん", meaning: "kamishōyōsan, traditional Chinese medicine prescribed for gynecological and blood circulation disorders" },
        { word: "遙々", reading: "はるばる", meaning: "from afar, over a great distance, all the way" },
        { word: "逍遙", reading: "しょうよう", meaning: "ramble, saunter, walk" }
    ],
    },
    "遥": {
        onyomi: ["ヨウ"],
        kunyomi: ["はる.か"],
        examples: [
        { word: "逍遥学派", reading: "しょうようがくは", meaning: "Peripatetic school" },
        { word: "遥任", reading: "ようにん", meaning: "absentee appointment to a distant administrative post (Nara and Heian periods)" },
        { word: "遥か昔", reading: "はるかむかし", meaning: "long ago" }
    ],
    },
    "遼": {
        onyomi: ["リョウ"],
        kunyomi: [],
        examples: [
        { word: "遼寧省", reading: "りょうねいしょう", meaning: "Liaoning Province (China)" },
        { word: "遼寧大学", reading: "りょうねいだいがく", meaning: "Liaoning University" },
        { word: "西遼", reading: "せいりょう", meaning: "Western Liao (Central Asian Khitan empire; 1132-1211)" }
    ],
    },
    "邑": {
        onyomi: ["ユウ"],
        kunyomi: ["むら"],
        examples: [
        { word: "林邑楽", reading: "りんゆうがく", meaning: "Indian song and dance (introduced to Japan by the Chams in approx. 736 CE)" },
        { word: "邑落", reading: "ゆうらく", meaning: "hamlet" },
        { word: "幟邑", reading: "のぼりざと", meaning: "kanji \"large village\" radical" }
    ],
    },
    "郁": {
        onyomi: ["イク"],
        kunyomi: [],
        examples: [
        { word: "郁子", reading: "むべ", meaning: "Japanese staunton-vine (Stauntonia hexaphylla)" },
        { word: "馥郁", reading: "ふくいく", meaning: "fragrant, sweet-smelling" },
        { word: "郁郁", reading: "いくいく", meaning: "flourishing, teeming with culture, aromatic" }
    ],
    },
    "郞": {
        onyomi: ["ロウ"],
        kunyomi: ["おとこ"],
        examples: [],
    },
    "鄭": {
        onyomi: ["テイ", "ジョウ"],
        kunyomi: [],
        examples: [
        { word: "鄭声", reading: "ていせい", meaning: "(decadent) music of the state of Zheng" },
        { word: "鄭州", reading: "ていしゅう", meaning: "Zhengzhou (China)" },
        { word: "鄭箋", reading: "ていせん", meaning: "commentary on the Book of Odes by Zheng Xuan" }
    ],
    },
    "酉": {
        onyomi: ["ユウ"],
        kunyomi: ["とり"],
        examples: [
        { word: "己酉", reading: "つちのととり", meaning: "Earth Rooster (46th term of the sexagenary cycle, e.g. 1909, 1969, 2029)" },
        { word: "丁酉", reading: "ひのととり", meaning: "Fire Rooster (34th term of the sexagenary cycle, e.g. 1957, 2017, 2077)" },
        { word: "辛酉", reading: "かのととり", meaning: "Metal Rooster (58th term of the sexagenary cycle, e.g. 1921, 1981, 2041)" }
    ],
    },
    "醇": {
        onyomi: ["ジュン", "シュン"],
        kunyomi: ["もっぱら", "こい", "あつい"],
        examples: [
        { word: "至醇", reading: "しじゅん", meaning: "absolute purity" },
        { word: "醇美", reading: "じゅんび", meaning: "absolute beauty, classical beauty" },
        { word: "醇乎", reading: "じゅんこ", meaning: "pure, sheer" }
    ],
    },
    "醉": {
        onyomi: ["スイ"],
        kunyomi: ["よ.う", "よ.い"],
        examples: [],
    },
    "醍": {
        onyomi: ["ダイ", "タイ", "テイ"],
        kunyomi: [],
        examples: [
        { word: "醍醐", reading: "だいご", meaning: "ghee (held to be the greatest of all flavours), the ultimate truth of Buddhism, nirvana" },
        { word: "醍醐味", reading: "だいごみ", meaning: "the real pleasure (of something), the real thrill, the true charm" }
    ],
    },
    "醐": {
        onyomi: ["ゴ", "コ"],
        kunyomi: [],
        examples: [
        { word: "醍醐", reading: "だいご", meaning: "ghee (held to be the greatest of all flavours), the ultimate truth of Buddhism, nirvana" },
        { word: "醍醐味", reading: "だいごみ", meaning: "the real pleasure (of something), the real thrill, the true charm" }
    ],
    },
    "醬": {
        onyomi: ["ショウ"],
        kunyomi: ["ひしお"],
        examples: [
        { word: "低塩醬油", reading: "ていえんしょうゆ", meaning: "low-salt soy sauce (containing around 13% salt)" },
        { word: "減塩醬油", reading: "げんえんしょうゆ", meaning: "low-salt soy sauce (containing less than 9% salt)" },
        { word: "醬油", reading: "しょうゆ", meaning: "soy sauce, soya sauce, shoyu" }
    ],
    },
    "釀": {
        onyomi: ["ジョウ"],
        kunyomi: ["かも.す"],
        examples: [],
    },
    "釉": {
        onyomi: ["ユウ"],
        kunyomi: ["うわぐすり"],
        examples: [
        { word: "灰釉", reading: "はいぐすり", meaning: "ash glaze (type of fundamental glaze used in ancient times made from the ashes of raw materials such as unhulled rice, straw, oak and pine)" },
        { word: "銅釉", reading: "どうゆう", meaning: "copper glaze (pottery)" },
        { word: "施釉", reading: "せゆう", meaning: "glazing (ceramics)" }
    ],
    },
    "釘": {
        onyomi: ["テイ", "チョウ"],
        kunyomi: ["くぎ"],
        examples: [
        { word: "竹釘", reading: "たけくぎ", meaning: "bamboo nail (spike, peg, etc.)" },
        { word: "隠し釘", reading: "かくしくぎ", meaning: "concealed nail" },
        { word: "蟹目釘", reading: "かにめくぎ", meaning: "large half-dome-shaped nail" }
    ],
    },
    "釧": {
        onyomi: ["セン"],
        kunyomi: ["くしろ", "うでわ"],
        examples: [
        { word: "釧路地方気象台", reading: "くしろちほうきしょうだい", meaning: "Kushiro Local Meteorological Observatory" },
        { word: "釧路公立大学", reading: "くしろこうりつだいがく", meaning: "Kushiro Public University of Economics" },
        { word: "釧", reading: "くしろ", meaning: "bracelet (usu. dating from the Kofun period)" }
    ],
    },
    "銑": {
        onyomi: ["セン"],
        kunyomi: [],
        examples: [
        { word: "溶銑", reading: "ようせん", meaning: "molten iron" },
        { word: "銑", reading: "ずく", meaning: "pig iron" },
        { word: "銑鉄", reading: "せんてつ", meaning: "pig iron" }
    ],
    },
    "鋒": {
        onyomi: ["ホウ"],
        kunyomi: ["きっさき", "とかり", "ほこ��き"],
        examples: [
        { word: "機鋒", reading: "きほう", meaning: "brunt" },
        { word: "鋭鋒", reading: "えいほう", meaning: "brunt of attack or argument" },
        { word: "筆鋒", reading: "ひっぽう", meaning: "power of the pen" }
    ],
    },
    "鋸": {
        onyomi: ["キョ", "コ"],
        kunyomi: ["のこ", "のこぎり"],
        examples: [
        { word: "鎖鋸", reading: "くさりのこ", meaning: "chainsaw" },
        { word: "両刃鋸", reading: "りょうばのこぎり", meaning: "double-edged saw" },
        { word: "電気鋸", reading: "でんきのこぎり", meaning: "electric saw" }
    ],
    },
    "錄": {
        onyomi: ["ロク", "リョ"],
        kunyomi: ["しるす"],
        examples: [
        { word: "錄音", reading: "ろくおん", meaning: "(audio) recording" },
        { word: "錄", reading: "ろく", meaning: "record, transcript" },
        { word: "登錄", reading: "とうろく", meaning: "registration, accession, register" }
    ],
    },
    "錆": {
        onyomi: ["ショウ", "セイ"],
        kunyomi: ["さび", "くわ.しい"],
        examples: [
        { word: "赤錆", reading: "あかさび", meaning: "red rust" },
        { word: "金錆", reading: "かなさび", meaning: "rust" },
        { word: "錆", reading: "さび", meaning: "rust" }
    ],
    },
    "錐": {
        onyomi: ["スイ"],
        kunyomi: ["きり"],
        examples: [
        { word: "円錐面", reading: "えんすいめん", meaning: "(circular) conical surface" },
        { word: "突き錐", reading: "つきぎり", meaning: "(shoemaker's) awl" },
        { word: "弓錐", reading: "ゆみぎり", meaning: "bow drill" }
    ],
    },
    "錘": {
        onyomi: ["スイ"],
        kunyomi: ["つむ", "おもり"],
        examples: [
        { word: "休錘", reading: "きゅうすい", meaning: "idle spindles" },
        { word: "筋紡錘", reading: "きんぼうすい", meaning: "muscle spindle" },
        { word: "鉛錘", reading: "えんすい", meaning: "plumb bob" }
    ],
    },
    "錫": {
        onyomi: ["セキ", "シャク"],
        kunyomi: ["すず", "たま.う"],
        examples: [
        { word: "雛の錫杖", reading: "ひなのしゃくじょう", meaning: "Burmannia championii (species of flowering plant)" },
        { word: "錫蘭", reading: "セイロン", meaning: "Ceylon (former name of Sri Lanka)" },
        { word: "錫石", reading: "すずいし", meaning: "cassiterite" }
    ],
    },
    "鍊": {
        onyomi: ["レン"],
        kunyomi: ["ねる"],
        examples: [],
    },
    "鍬": {
        onyomi: ["ショウ", "シュウ"],
        kunyomi: ["くわ", "すき"],
        examples: [
        { word: "小鍬形", reading: "こくわがた", meaning: "Dorcus rectus (species of stag beetle)" },
        { word: "深山鍬形", reading: "みやまくわがた", meaning: "Miyama stag beetle (Lucanus maculifemoratus)" },
        { word: "鍬初め", reading: "くわはじめ", meaning: "New Year's ceremony in which a hoe is used to break ground in a field lying in a lucky direction" }
    ],
    },
    "鎧": {
        onyomi: ["カイ", "ガイ"],
        kunyomi: ["よろ.う", "よろい"],
        examples: [
        { word: "鎧球", reading: "がいきゅう", meaning: "American football" },
        { word: "鎧草", reading: "よろいぐさ", meaning: "Angelica dahurica (species of angelica)" },
        { word: "鎧竜", reading: "がいりゅう", meaning: "ankylosaur (any dinosaur of infraorder Ankylosauria)" }
    ],
    },
    "鎭": {
        onyomi: ["チン"],
        kunyomi: ["しず.める", "しず.まる", "おさえ"],
        examples: [],
    },
    "鑄": {
        onyomi: ["チュウ", "シュ", "シュウ"],
        kunyomi: ["い.る"],
        examples: [
        { word: "鑄る", reading: "いる", meaning: "to cast, to mint, to coin" }
    ],
    },
    "閃": {
        onyomi: ["セン"],
        kunyomi: ["ひらめ.く", "ひらめ.き", "うかが.う"],
        examples: [
        { word: "緑閃石", reading: "りょくせんせき", meaning: "actinolite" },
        { word: "角閃石", reading: "かくせんせき", meaning: "amphibole" },
        { word: "角閃岩", reading: "かくせんがん", meaning: "amphibolite" }
    ],
    },
    "閏": {
        onyomi: ["ジュン"],
        kunyomi: ["うるう"],
        examples: [
        { word: "閏日", reading: "うるうび", meaning: "leap day" },
        { word: "閏秒", reading: "うるうびょう", meaning: "leap second" },
        { word: "閏年", reading: "うるうどし", meaning: "leap year" }
    ],
    },
    "閤": {
        onyomi: ["コウ"],
        kunyomi: ["くぐりど"],
        examples: [
        { word: "豊太閤", reading: "ほうたいこう", meaning: "Toyotomi Hideyoshi" },
        { word: "太閤検地", reading: "たいこうけんち", meaning: "Toyotomi Hideyoshi's nationwide land survey (1582)" },
        { word: "太閤碁", reading: "たいこうご", meaning: "mirror go (as black), opening strategy of symmetrically copying every move of the opponent, starting with tengen" }
    ],
    },
    "阿": {
        onyomi: ["ア", "オ"],
        kunyomi: ["おもね.る", "くま"],
        examples: [
        { word: "南阿戦争", reading: "なんあせんそう", meaning: "(second) Boer War (1899-1902)" },
        { word: "阿毘達磨倶舍論", reading: "あびだつまくしゃろん", meaning: "Abhidharma Storehouse Treatise" },
        { word: "阿富汗斯坦", reading: "アフガニスタン", meaning: "Afghanistan" }
    ],
    },
    "陀": {
        onyomi: ["タ", "ダ", "イ", "チ", "ジ"],
        kunyomi: ["けわ.しい", "ななめ"],
        examples: [
        { word: "阿弥陀仏", reading: "あみだぶつ", meaning: "Amitabha" },
        { word: "弥陀", reading: "みだ", meaning: "Amitabha" },
        { word: "仏陀", reading: "ブッダ", meaning: "Buddha" }
    ],
    },
    "陷": {
        onyomi: ["カン"],
        kunyomi: ["おちい.る", "おとしい.れる"],
        examples: [],
    },
    "隈": {
        onyomi: ["ワイ", "エ"],
        kunyomi: ["くま", "すみ"],
        examples: [
        { word: "藍隈", reading: "あいぐま", meaning: "indigo blue make-up used in kabuki" },
        { word: "風呂キャンセル界隈", reading: "ふろキャンセルかいわい", meaning: "people who are too lazy to bathe or shower" },
        { word: "隈取りコイル", reading: "くまとりコイル", meaning: "shading coil" }
    ],
    },
    "險": {
        onyomi: ["ケン"],
        kunyomi: ["けわ.しい"],
        examples: [],
    },
    "隼": {
        onyomi: ["シュン", "ジュン"],
        kunyomi: ["はやぶさ"],
        examples: [
        { word: "隼科", reading: "はやぶさか", meaning: "Falconidae (family of birds of prey)" },
        { word: "隼", reading: "はやぶさ", meaning: "falcon (esp. the peregrine falcon, Falco peregrinus)" },
        { word: "白隼", reading: "しろはやぶさ", meaning: "gyrfalcon (Falco rusticolus)" }
    ],
    },
    "雀": {
        onyomi: ["ジャク", "ジャン", "サク", "シャク"],
        kunyomi: ["すずめ"],
        examples: [
        { word: "乙女孔雀", reading: "おとめくじゃく", meaning: "Adiantum edgeworthii (species of maidenhair fern)" },
        { word: "四十雀雁", reading: "しじゅうからがん", meaning: "Aleutian Canada goose (Branta canadensis leucopareia)" },
        { word: "銀葉金雀枝", reading: "ぎんようえにしだ", meaning: "Atlas broom (Argyrocytisus battandieri)" }
    ],
    },
    "雁": {
        onyomi: ["ガン"],
        kunyomi: ["かり", "かりがね"],
        examples: [
        { word: "雁の便り", reading: "かりのたより", meaning: "(a) letter" },
        { word: "雁の文", reading: "かりのふみ", meaning: "(a) letter" },
        { word: "雁字搦みに", reading: "がんじがらみに", meaning: "(bind) firmly" }
    ],
    },
    "雛": {
        onyomi: ["スウ", "ス", "ジュ"],
        kunyomi: ["ひな", "ひよこ"],
        examples: [
        { word: "東洋雛蝙蝠", reading: "とうようひなこうもり", meaning: "Asian particolored bat (Vespertilio sinensis)" },
        { word: "雛の錫杖", reading: "ひなのしゃくじょう", meaning: "Burmannia championii (species of flowering plant)" },
        { word: "雛諸子", reading: "ひなもろこ", meaning: "Chinese bleak (Aphyocypris chinensis)" }
    ],
    },
    "雜": {
        onyomi: ["ザツ", "ゾウ"],
        kunyomi: ["まじ.える", "まじ.る"],
        examples: [],
    },
    "雫": {
        onyomi: ["ダ"],
        kunyomi: ["しずく"],
        examples: [
        { word: "花の雫", reading: "はなのしずく", meaning: "dew that trickles down from a flower" },
        { word: "一雫", reading: "ひとしずく", meaning: "one drop (of fluid)" },
        { word: "雫", reading: "しずく", meaning: "drop (e.g. of water), drip" }
    ],
    },
    "霞": {
        onyomi: ["カ", "ゲ"],
        kunyomi: ["かすみ", "かす.む"],
        examples: [
        { word: "霞桜", reading: "かすみざくら", meaning: "Korean hill cherry (Prunus verecunda)" },
        { word: "霞山椒魚", reading: "かすみさんしょううお", meaning: "clouded salamander (Hynobius nebulosus)" },
        { word: "霞網", reading: "かすみあみ", meaning: "mist net (fine mesh for capturing small birds)" }
    ],
    },
    "靖": {
        onyomi: ["セイ", "ジョウ"],
        kunyomi: ["やす.んじる"],
        examples: [
        { word: "靖国", reading: "やすくに", meaning: "Yasukuni (Shrine)" },
        { word: "靖国神社", reading: "やすくにじんじゃ", meaning: "Yasukuni Shrine" },
        { word: "靖寧", reading: "せいねい", meaning: "peace, calm, tranquility" }
    ],
    },
    "靜": {
        onyomi: ["セイ", "ジョウ"],
        kunyomi: ["しず-", "しず.か", "しず.まる", "しず.める"],
        examples: [
        { word: "靜岡", reading: "しずおか", meaning: "Shizuoka (city, prefecture)" },
        { word: "靜岡縣", reading: "しずおかけん", meaning: "Shizuoka Prefecture (Chūbu area)" },
        { word: "寂靜", reading: "じゃくじょう", meaning: "quiet, stillness, tranquility" }
    ],
    },
    "鞄": {
        onyomi: ["ハク", "ホウ", "ビョウ"],
        kunyomi: ["かばん"],
        examples: [
        { word: "鞄語", reading: "かばんご", meaning: "portmanteau word" },
        { word: "肩掛け鞄", reading: "かたかけかばん", meaning: "shoulder bag" },
        { word: "書類鞄", reading: "しょるいかばん", meaning: "briefcase, attaché case" }
    ],
    },
    "鞍": {
        onyomi: ["アン"],
        kunyomi: ["くら"],
        examples: [
        { word: "唐鞍", reading: "からくら", meaning: "Chinese-style ritual saddle" },
        { word: "大和鞍", reading: "やまとぐら", meaning: "Japanese-style ritual saddle" },
        { word: "鞍掛紋殻", reading: "くらかけもんがら", meaning: "blackbelly triggerfish (Rhinecanthus verrucosus)" }
    ],
    },
    "鞘": {
        onyomi: ["ショウ", "ソウ"],
        kunyomi: ["さや"],
        examples: [
        { word: "翅鞘", reading: "ししょう", meaning: "elytron" },
        { word: "金利鞘", reading: "きんりしょう", meaning: "interest margin" },
        { word: "髄鞘", reading: "ずいしょう", meaning: "myelin sheath (around the axon of a neuron)" }
    ],
    },
    "鞠": {
        onyomi: ["キク", "キュウ"],
        kunyomi: ["まり"],
        examples: [
        { word: "推鞠", reading: "すいきく", meaning: "investigating (e.g. a criminal)" },
        { word: "ゴム鞠", reading: "ゴムまり", meaning: "rubber ball" },
        { word: "手鞠", reading: "てまり", meaning: "traditional Japanese handball (game)" }
    ],
    },
    "鞭": {
        onyomi: ["ベン", "ヘン"],
        kunyomi: ["むち", "むちうつ"],
        examples: [
        { word: "愛の鞭", reading: "あいのむち", meaning: "(lesson in) tough love" },
        { word: "襟鞭毛虫綱", reading: "えりべんもうちゅうこう", meaning: "Choanoflagellatea (class of flagellate eukaryotes closely related to animals)" },
        { word: "襟鞭毛虫門", reading: "えりべんもうちゅうもん", meaning: "Choanozoa (phylum of protists closer to animals than to fungi)" }
    ],
    },
    "頁": {
        onyomi: ["ケツ"],
        kunyomi: ["ぺえじ", "おおがい", "かしら"],
        examples: [
        { word: "余白頁", reading: "よはくページ", meaning: "blank page" },
        { word: "彦頁", reading: "ひこページ", meaning: "face" },
        { word: "頁", reading: "おおがい", meaning: "kanji \"big shell\" radical" }
    ],
    },
    "頌": {
        onyomi: ["ショウ", "ジュ", "ヨウ"],
        kunyomi: ["かたち", "たた.える", "ほめ.る"],
        examples: [
        { word: "頌春", reading: "しょうしゅん", meaning: "Happy New Year" },
        { word: "頌詩", reading: "しょうし", meaning: "admired poem" },
        { word: "頌寿", reading: "しょうじゅ", meaning: "celebration of longevity" }
    ],
    },
    "頗": {
        onyomi: ["ハ"],
        kunyomi: ["すこぶ.る", "かたよ.る"],
        examples: [
        { word: "頗る", reading: "すこぶる", meaning: "extremely, very much" },
        { word: "偏頗", reading: "へんぱ", meaning: "favoritism, favouritism, discrimination" },
        { word: "頗る付き", reading: "すこぶるつき", meaning: "extreme, extraordinary, rare" }
    ],
    },
    "顚": {
        onyomi: ["テン"],
        kunyomi: ["いただ.き", "たお.れる"],
        examples: [
        { word: "大不列顚", reading: "だいブリテン", meaning: "Great Britain (island)" },
        { word: "顚末記", reading: "てんまつき", meaning: "full account" },
        { word: "山顚", reading: "さんてん", meaning: "summit (of a mountain)" }
    ],
    },
    "顯": {
        onyomi: ["ケン"],
        kunyomi: ["あきらか", "あらわ.れる"],
        examples: [
        { word: "顯現", reading: "けんげん", meaning: "manifestation" },
        { word: "顯著", reading: "けんちょ", meaning: "remarkable, striking, obvious" }
    ],
    },
    "颯": {
        onyomi: ["サツ", "ソウ"],
        kunyomi: ["さっ.と"],
        examples: [
        { word: "英姿颯爽", reading: "えいしさっそう", meaning: "cutting a fine (dashing, gallant, noble) figure" },
        { word: "颯爽", reading: "さっそう", meaning: "gallant, dashing, jaunty" },
        { word: "颯々", reading: "さっさつ", meaning: "rustling (of wind), murmuring, whistling" }
    ],
    },
    "飜": {
        onyomi: ["ハン", "ホン"],
        kunyomi: ["ひるがえ.す", "ひるがえ.る"],
        examples: [
        { word: "飜刻", reading: "ほんこく", meaning: "reprinting (of a book)" },
        { word: "飜って", reading: "ひるがえって", meaning: "conversely, from another angle" },
        { word: "飜", reading: "ハン", meaning: "han, fan, unit that doubles the score of a hand" }
    ],
    },
    "饗": {
        onyomi: ["キョウ"],
        kunyomi: ["う.ける", "もてな.す"],
        examples: [
        { word: "饗宴", reading: "きょうえん", meaning: "Symposium (book by Plato)" },
        { word: "饗設け", reading: "あるじもうけ", meaning: "entertaining someone as one's guest" },
        { word: "早苗饗", reading: "さなぶり", meaning: "celebration for the end of rice planting, festival held when all rice has been planted" }
    ],
    },
    "馨": {
        onyomi: ["ケイ", "キョウ"],
        kunyomi: ["かお.る", "かおり"],
        examples: [
        { word: "素馨", reading: "そけい", meaning: "Spanish jasmine (Jasminum grandiflorum)" },
        { word: "黄素馨", reading: "きそけい", meaning: "Italian jasmine (Jasminum humile var. revolutum), yellow jasmine" },
        { word: "馨り立つ", reading: "かおりたつ", meaning: "to be fragrant, to have a pleasant aroma" }
    ],
    },
    "馳": {
        onyomi: ["チ", "ジ"],
        kunyomi: ["は.せる"],
        examples: [
        { word: "ご馳走攻め", reading: "ごちそうぜめ", meaning: "treating someone to one delicious meal after the other" },
        { word: "遅れ馳せ", reading: "おくればせ", meaning: "belated, eleventh-hour" },
        { word: "遅れ馳せながら", reading: "おくればせながら", meaning: "belatedly, though a little too late" }
    ],
    },
    "馴": {
        onyomi: ["ジュン", "シュン", "クン"],
        kunyomi: ["な.れる", "な.らす", "したが.う"],
        examples: [
        { word: "耳馴染み", reading: "みみなじみ", meaning: "familiarity (of a sound, etc.)" },
        { word: "古馴染み", reading: "ふるなじみ", meaning: "old friend" },
        { word: "雅馴", reading: "がじゅん", meaning: "refined (prose, etc.)" }
    ],
    },
    "駈": {
        onyomi: ["ク"],
        kunyomi: ["か.ける", "か.る"],
        examples: [
        { word: "駈歩", reading: "くほ", meaning: "canter (horse gait)" },
        { word: "朝駈け", reading: "あさがけ", meaning: "early-morning attack" },
        { word: "駈け競", reading: "かけくら", meaning: "footrace" }
    ],
    },
    "駕": {
        onyomi: ["カ", "ガ"],
        kunyomi: ["かご", "が.する", "しのぐ", "のる"],
        examples: [
        { word: "出駕", reading: "しゅつが", meaning: "departure (of a noble)" },
        { word: "繋駕競走", reading: "けいがきょうそう", meaning: "harness racing" },
        { word: "繋駕速歩競走", reading: "けいがそくほきょうそう", meaning: "harness racing" }
    ],
    },
    "駿": {
        onyomi: ["シュン", "スン"],
        kunyomi: ["すぐ.れる"],
        examples: [
        { word: "駿台電子情報専門学校", reading: "すんだいでんしじょうほうせんもんがっこう", meaning: "Sundai Computer College" },
        { word: "駿台法律経済専門学校", reading: "すんだいほうりつけいざいせんもんがっこう", meaning: "Sundai Law & Economic College" },
        { word: "駿河", reading: "するが", meaning: "Suruga (former province located in the central and northern parts of present-day Shizuoka Prefecture)" }
    ],
    },
    "騷": {
        onyomi: ["ソウ"],
        kunyomi: ["さわ.ぐ", "うれい", "さわが.しい"],
        examples: [
        { word: "騷ぐ", reading: "さわぐ", meaning: "to make noise, to make racket, to be noisy" }
    ],
    },
    "驍": {
        onyomi: ["ギョウ", "キョウ"],
        kunyomi: ["たけし", "つよ.い"],
        examples: [
        { word: "驍将", reading: "ぎょうしょう", meaning: "veteran general, leader" },
        { word: "驍勇", reading: "ぎょうゆう", meaning: "bravery, valor, prowess" }
    ],
    },
    "驗": {
        onyomi: ["ケン", "ゲン"],
        kunyomi: ["あかし", "しるし", "ため.す", "ためし"],
        examples: [],
    },
    "髮": {
        onyomi: ["ハツ"],
        kunyomi: ["かみ"],
        examples: [
        { word: "髮", reading: "かみ", meaning: "hair (on the head)" },
        { word: "結び髮", reading: "むすびがみ", meaning: "tied-up hairstyle" },
        { word: "髮を切る", reading: "かみをきる", meaning: "to get a haircut, to give a haircut, to cut hair" }
    ],
    },
    "魁": {
        onyomi: ["カイ"],
        kunyomi: ["さきがけ", "かしら"],
        examples: [
        { word: "容貌魁偉", reading: "ようぼうかいい", meaning: "(a man) having a commanding face and a powerful physique" },
        { word: "花魁道中", reading: "おいらんどうちゅう", meaning: "procession of oiran through a red-light district (e.g. to meet a regular client; during the Edo period)" },
        { word: "巨魁", reading: "きょかい", meaning: "ringleader, chief" }
    ],
    },
    "魯": {
        onyomi: ["ロ"],
        kunyomi: ["おろか"],
        examples: [
        { word: "魯", reading: "ろ", meaning: "Lu (Chinese vassal state existing during the Spring and Autumn period)" },
        { word: "普魯西", reading: "プロシア", meaning: "Prussia" },
        { word: "魯国", reading: "ろこく", meaning: "Russia" }
    ],
    },
    "鮎": {
        onyomi: ["デン", "ネン"],
        kunyomi: ["あゆ", "なまず"],
        examples: [
        { word: "瓢鮎図", reading: "ひょうねんず", meaning: "Hyonenzu (painting by Josetsu, 1415)" },
        { word: "琉球鮎", reading: "りゅうきゅうあゆ", meaning: "Ryukyu sweetfish (Plecoglossus altivelis ryukyuensis)" },
        { word: "鮎釣り", reading: "あゆつり", meaning: "ayu fishing" }
    ],
    },
    "鯉": {
        onyomi: ["リ"],
        kunyomi: ["こい"],
        examples: [
        { word: "似鯉", reading: "にごい", meaning: "Hemibarbus barbus (species of cyprinid)" },
        { word: "養鯉", reading: "ようり", meaning: "carp breeding" },
        { word: "鯉こく", reading: "こいこく", meaning: "carp cooked in miso soup" }
    ],
    },
    "鯛": {
        onyomi: ["チョウ"],
        kunyomi: ["たい"],
        examples: [
        { word: "瘤鯛", reading: "こぶだい", meaning: "(adult male) Asian sheepshead wrasse (Semicossyphus reticulatus)" },
        { word: "笛吹鯛", reading: "ふえふきだい", meaning: "Chinese emperor (species of emperor bream, Lethrinus haematopterus)" },
        { word: "壺鯛", reading: "ツボダイ", meaning: "Japanese armorhead (Pentaceros japonicus)" }
    ],
    },
    "鰯": {
        onyomi: [],
        kunyomi: ["いわし"],
        examples: [
        { word: "唐鰯", reading: "からいわし", meaning: "Hawaiian ladyfish (Elops hawaiensis)" },
        { word: "片口鰯", reading: "かたくちいわし", meaning: "Japanese anchovy (Engraulis japonica)" },
        { word: "鯷鰯", reading: "しこいわし", meaning: "Japanese anchovy (Engraulis japonica)" }
    ],
    },
    "鱒": {
        onyomi: ["ソン", "セン", "ザン"],
        kunyomi: ["ます"],
        examples: [
        { word: "北川姫鱒", reading: "きたかわひめます", meaning: "Arctic grayling (Thymallus arcticus)" },
        { word: "国鱒", reading: "くにます", meaning: "Oncorhynchus nerka kawamurae (rare Japanese subspecies of sockeye salmon)" },
        { word: "河鱒", reading: "かわます", meaning: "brook trout (Salvelinus fontinalis)" }
    ],
    },
    "鱗": {
        onyomi: ["リン"],
        kunyomi: ["うろこ", "こけ", "こけら"],
        examples: [
        { word: "鱗片", reading: "りんぺん", meaning: "(animal or plant) scale" },
        { word: "鱗翅目", reading: "りんしもく", meaning: "Lepidoptera" },
        { word: "骨鱗", reading: "こつりん", meaning: "bony scale (of a fish)" }
    ],
    },
    "鳩": {
        onyomi: ["キュウ", "ク"],
        kunyomi: ["はと", "あつ.める"],
        examples: [
        { word: "斑鳩", reading: "いかるが", meaning: "Japanese grosbeak" },
        { word: "蓑鳩", reading: "みのばと", meaning: "Nicobar pigeon (Caloenas nicobarica)" },
        { word: "鳩羽色", reading: "はとばいろ", meaning: "blue-black (color, colour)" }
    ],
    },
    "鳳": {
        onyomi: ["ホウ", "フウ"],
        kunyomi: [],
        examples: [
        { word: "鳳凰竹", reading: "ほうおうちく", meaning: "Bambusa multiplex var. elegans (variety of hedge bamboo)" },
        { word: "鳳凰文", reading: "ほうおうもん", meaning: "Chinese phoenix pattern" },
        { word: "麝香鳳蝶", reading: "じゃこうあげは", meaning: "Chinese windmill (species of red-bodied swallowtail butterfly, Atrophaneura alcinous)" }
    ],
    },
    "鳶": {
        onyomi: ["エン"],
        kunyomi: ["とび", "とんび"],
        examples: [
        { word: "鳶合羽", reading: "とんびがっぱ", meaning: "Inverness cape" },
        { word: "鳶鱝", reading: "とびえい", meaning: "Japanese eagle ray (Myliobatis tobijei)" },
        { word: "ミシシッピー鳶", reading: "ミシシッピーとび", meaning: "Mississippi kite (Ictinia mississippiensis)" }
    ],
    },
    "鴨": {
        onyomi: ["オウ"],
        kunyomi: ["かも", "あひる"],
        examples: [
        { word: "鴨科", reading: "かもか", meaning: "Anatidae (duck family of birds)" },
        { word: "雁鴨科", reading: "がんかもか", meaning: "Anatidae (family of birds including ducks, geese and swans)" },
        { word: "鴨目", reading: "かももく", meaning: "Anseriformes (order of swimming birds)" }
    ],
    },
    "鴻": {
        onyomi: ["コウ", "ゴウ"],
        kunyomi: ["おおとり", "ひしくい", "おおがり"],
        examples: [
        { word: "鴻蒙", reading: "ホンモン", meaning: "HarmonyOS (Huawei)" },
        { word: "鴻", reading: "ひしくい", meaning: "bean goose (Anser fabalis)" },
        { word: "鴻業", reading: "こうぎょう", meaning: "glorious achievement" }
    ],
    },
    "鵜": {
        onyomi: ["テイ", "ダイ"],
        kunyomi: ["う"],
        examples: [
        { word: "鵜", reading: "う", meaning: "cormorant (Phalacrocoracidae spp.)" },
        { word: "鵜匠", reading: "うしょう", meaning: "cormorant fisherman" },
        { word: "耳姫鵜", reading: "みみひめう", meaning: "double-crested cormorant (Phalacrocorax auritus)" }
    ],
    },
    "鵬": {
        onyomi: ["ホウ"],
        kunyomi: ["おおとり"],
        examples: [
        { word: "育鵬社", reading: "いくほうしゃ", meaning: "Ikuhosha Publishing" },
        { word: "大鵬", reading: "たいほう", meaning: "dapeng (giant bird in Chinese mythology, similar to the roc or Garuda)" },
        { word: "柏鵬", reading: "はくほう", meaning: "era during 1960s dominated by grand champions Taiho and Kashiwado" }
    ],
    },
    "鷄": {
        onyomi: ["ケイ"],
        kunyomi: ["にわとり", "とり"],
        examples: [
        { word: "牝鷄", reading: "ひんけい", meaning: "hen" },
        { word: "鷄卵", reading: "けいらん", meaning: "hen's egg" },
        { word: "鷄", reading: "にわとり", meaning: "chicken (Gallus gallus domesticus), domestic chicken, chicken meat" }
    ],
    },
    "鷗": {
        onyomi: ["オウ"],
        kunyomi: ["かもめ"],
        examples: [
        { word: "白鷗大学", reading: "はくおうだいがく", meaning: "Hakuoh University" },
        { word: "白鷗", reading: "しろかもめ", meaning: "glaucous gull (Larus hyperboreus), burgomaster" },
        { word: "水鷗流", reading: "すいおうりゅう", meaning: "old sword fighting, sword drawing style or school from Shizuoka prefecture" }
    ],
    },
    "鷲": {
        onyomi: ["シュウ", "ジュ"],
        kunyomi: ["わし"],
        examples: [
        { word: "鷲木菟", reading: "わしみみずく", meaning: "Eurasian eagle owl (Bubo bubo)" },
        { word: "禿鷲", reading: "はげわし", meaning: "Old World vulture" },
        { word: "大鷲", reading: "おおわし", meaning: "Steller's sea eagle (Haliaeetus pelagicus)" }
    ],
    },
    "鷹": {
        onyomi: ["ヨウ", "オウ"],
        kunyomi: ["たか"],
        examples: [
        { word: "雀鷹", reading: "つみ", meaning: "Japanese sparrowhawk (Accipiter gularis)" },
        { word: "鷹栖養護学校", reading: "たかすようごがっこう", meaning: "Takasu Special Needs School (older name style)" },
        { word: "夜鷹そば", reading: "よたかそば", meaning: "ambulatory evening vendor of noodles (or the noodles themselves)" }
    ],
    },
    "鷺": {
        onyomi: ["ロ"],
        kunyomi: ["さぎ"],
        examples: [
        { word: "アフリカ黒朱鷺", reading: "アフリカクロトキ", meaning: "African sacred ibis (Threskiornis aethiopicus)" },
        { word: "オーストラリア黒朱鷺", reading: "オーストラリアクロトキ", meaning: "Australian white ibis (Threskiornis molucca)" },
        { word: "大鷺草", reading: "だいさぎそう", meaning: "Habenaria dentata (species of bog orchid)" }
    ],
    },
    "麒": {
        onyomi: ["キ"],
        kunyomi: [],
        examples: [
        { word: "麒麟菜", reading: "きりんさい", meaning: "Eucheuma muricatum (species of red algae)" },
        { word: "麒麟草", reading: "きりんそう", meaning: "Kamchatka stonecrop (Sedum kamtschaticum)" },
        { word: "麒麟も老いぬれば駑馬に劣る", reading: "きりんもおいぬればどばにおとる", meaning: "even an outstanding person becomes inferior when getting old" }
    ],
    },
    "麟": {
        onyomi: ["リン"],
        kunyomi: [],
        examples: [
        { word: "麒麟菜", reading: "きりんさい", meaning: "Eucheuma muricatum (species of red algae)" },
        { word: "麒麟草", reading: "きりんそう", meaning: "Kamchatka stonecrop (Sedum kamtschaticum)" },
        { word: "麒麟も老いぬれば駑馬に劣る", reading: "きりんもおいぬればどばにおとる", meaning: "even an outstanding person becomes inferior when getting old" }
    ],
    },
    "麿": {
        onyomi: [],
        kunyomi: ["まろ"],
        examples: [
        { word: "麿", reading: "まろ", meaning: "I, me, (person having) thin or shaved eyebrows" }
    ],
    },
    "黃": {
        onyomi: ["コウ", "オウ"],
        kunyomi: ["き"],
        examples: [
        { word: "黃綠", reading: "きみどり", meaning: "pea green, yellow-green" }
    ],
    },
    "黎": {
        onyomi: ["レイ", "リ"],
        kunyomi: ["くろ.い"],
        examples: [
        { word: "黎巴嫩", reading: "レバノン", meaning: "Lebanon" },
        { word: "黎族", reading: "リーぞく", meaning: "Li (people)" },
        { word: "黎明会", reading: "れいめいかい", meaning: "Reimeikai, progressive political society at various universities in Japan (1918-1920)" }
    ],
    },
    "黑": {
        onyomi: ["コク"],
        kunyomi: ["くろい", "くろ"],
        examples: [],
    },
    "默": {
        onyomi: ["ボク", "モク"],
        kunyomi: ["だ.まる", "もだ.す"],
        examples: [
        { word: "默す", reading: "もだす", meaning: "to be silent, to hold one's tongue, to contain oneself" }
    ],
    },
    "黛": {
        onyomi: ["タイ"],
        kunyomi: ["まゆずみ"],
        examples: [
        { word: "黛青", reading: "たいせい", meaning: "blackish blue" },
        { word: "青黛", reading: "せいたい", meaning: "blue eyebrow pencil, blue eyebrows, deep blue" },
        { word: "翠黛", reading: "すいたい", meaning: "green eyebrow pencil, green-shaded eyebrows, hazy green (distant mountains)" }
    ],
    },
    "鼎": {
        onyomi: ["テイ"],
        kunyomi: ["かなえ"],
        examples: [
        { word: "鐘鼎文", reading: "しょうていぶん", meaning: "bronze-vessel and bell inscriptions" },
        { word: "鼎革", reading: "ていかく", meaning: "change of dynasty" },
        { word: "火風鼎", reading: "かふうてい", meaning: "ding (hexagram 50 of the I Ching: the caldron)" }
    ],
    },
    "齊": {
        onyomi: ["セイ", "サイ"],
        kunyomi: ["そろ.う", "ひと.しい", "ひと.しく", "あたる", "はやい"],
        examples: [
        { word: "齊", reading: "せい", meaning: "Qi (kingdom in China during the Spring and Autumn Period and the Period of the Warring States), Ch'i" }
    ],
    },
    "龍": {
        onyomi: ["リュウ", "リョウ", "ロウ"],
        kunyomi: ["たつ"],
        examples: [
        { word: "産近甲龍", reading: "さんきんこうりゅう", meaning: "Kyoto Sangyo University, Kindai University, Konan University and Ryukoku University (group of similarly ranked private universities in the Kansai region)" },
        { word: "満龍", reading: "まんりゅう", meaning: "Man'ryū (chain of ramen shops)" },
        { word: "爬龍", reading: "はありい", meaning: "Okinawan dragon boat race" }
    ],
    },
    "欄": {
        onyomi: [],
        kunyomi: [],
        examples: [],
    },
    "廊": {
        onyomi: [],
        kunyomi: [],
        examples: [],
    },
    "朗": {
        onyomi: ["ロウ"],
        kunyomi: ["ほが.らか"],
        examples: [],
    },
    "虜": {
        onyomi: ["リョ"],
        kunyomi: ["とりこ"],
        examples: [],
    },
    "類": {
        onyomi: [],
        kunyomi: [],
        examples: [],
    },
    "猪": {
        onyomi: ["チョ"],
        kunyomi: ["いのしし", "い"],
        examples: [],
    },
    "神": {
        onyomi: ["シン", "ジン"],
        kunyomi: ["かみ", "こう", "たましい"],
        examples: [],
    },
    "祥": {
        onyomi: ["ショウ"],
        kunyomi: ["さいわい"],
        examples: [],
    },
    "福": {
        onyomi: ["フク"],
        kunyomi: ["さいわい", "ひもろぎ"],
        examples: [],
    },
    "諸": {
        onyomi: ["ショ"],
        kunyomi: ["もろ", "これ"],
        examples: [],
    },
    "都": {
        onyomi: ["ト", "ツ"],
        kunyomi: ["みやこ"],
        examples: [],
    },
    "侮": {
        onyomi: ["ブ"],
        kunyomi: ["あなど.る"],
        examples: [],
    },
    "勤": {
        onyomi: ["キン", "ゴン"],
        kunyomi: ["つと.まる", "つと.める"],
        examples: [],
    },
    "卑": {
        onyomi: ["ヒ"],
        kunyomi: ["いや.しむ", "いや.しい", "いや.しめる"],
        examples: [],
    },
    "墨": {
        onyomi: ["ボク"],
        kunyomi: ["すみ"],
        examples: [],
    },
    "層": {
        onyomi: ["ソウ"],
        kunyomi: [],
        examples: [],
    },
    "悔": {
        onyomi: ["カイ"],
        kunyomi: ["く.いる", "くや.しい", "く.やむ"],
        examples: [],
    },
    "梅": {
        onyomi: ["バイ"],
        kunyomi: ["うめ"],
        examples: [],
    },
    "煮": {
        onyomi: ["シャ"],
        kunyomi: ["に.る", "に.える", "に.やす"],
        examples: [],
    },
    "琢": {
        onyomi: ["タク"],
        kunyomi: ["みがく"],
        examples: [],
    },
    "碑": {
        onyomi: ["ヒ"],
        kunyomi: ["いしぶみ"],
        examples: [],
    },
    "祐": {
        onyomi: ["ユウ"],
        kunyomi: ["たすけ", "たすける"],
        examples: [],
    },
    "祖": {
        onyomi: ["ソ"],
        kunyomi: [],
        examples: [],
    },
    "禍": {
        onyomi: ["カ"],
        kunyomi: ["まが", "わざわい"],
        examples: [],
    },
    "穀": {
        onyomi: ["コク"],
        kunyomi: [],
        examples: [],
    },
    "練": {
        onyomi: ["コウ", "レン"],
        kunyomi: ["ね.る"],
        examples: [],
    },
    "署": {
        onyomi: ["ショ"],
        kunyomi: [],
        examples: [],
    },
    "者": {
        onyomi: ["シャ"],
        kunyomi: ["もの"],
        examples: [],
    },
    "臭": {
        onyomi: ["シュウ"],
        kunyomi: ["くさ.い", "にお.い"],
        examples: [],
    },
    "賓": {
        onyomi: ["ヒン"],
        kunyomi: [],
        examples: [],
    },
    "贈": {
        onyomi: ["ソウ", "ゾウ"],
        kunyomi: ["おく.る"],
        examples: [],
    },
    "響": {
        onyomi: ["キョウ"],
        kunyomi: ["ひび.く"],
        examples: [],
    },
};
